webpackJsonp([0],{

/***/ "+9MD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = AsyncDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async_style_sass__ = __webpack_require__("/S/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__async_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__async_tpl_pug__ = __webpack_require__("IJ/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__async_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__async_tpl_pug__);
AsyncDirective.$inject = ['$q'];



var selector = 'dbAAsync';

var CLASS_ASYNC = 'async';
var CLASS_LOADING = CLASS_ASYNC + '-loading';
var CLASS_DISABLED = 'disabled';

/* @ngInject */
function AsyncDirective($q) {
    return {
        restrict: 'A',
        template: __WEBPACK_IMPORTED_MODULE_1__async_tpl_pug___default()(),
        transclude: {
            initial: 'initial',
            loading: 'loading'
        },
        scope: {
            loading: '=',
            disabled: '=ngDisabled',
            onClick: '&'
        },

        link: function link(scope, element) {
            var promise = null;

            toggleClass(CLASS_ASYNC, true);

            scope.$watch(getLoadingStatus, updateState);
            scope.$watch(getDisabledStatus, updateState);

            element.on('click', clickHandler);
            scope.$on('$destroy', function () {
                return element.off('click', clickHandler);
            });

            function clickHandler(event) {
                if (promise) {
                    event.preventDefault();
                } else {
                    scope.$applyAsync(function () {
                        return promise = $q.when(scope.onClick()).finally(function () {
                            return promise = null;
                        });
                    });
                }
            }

            function getLoadingStatus() {
                return !!(scope.loading || promise);
            }

            function getDisabledStatus() {
                return !!scope.disabled;
            }

            function updateState() {
                var loading = getLoadingStatus();

                toggleClass(CLASS_DISABLED, getDisabledStatus() || loading);
                toggleClass(CLASS_LOADING, loading);
            }

            function toggleClass(name, state) {
                if (state) {
                    element.addClass(name);
                } else {
                    element.removeClass(name);
                }
            }
        }
    };
}

/***/ }),

/***/ "+ItH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");

defaults._set('global', {
	responsive: true,
	responsiveAnimationDuration: 0,
	maintainAspectRatio: true,
	events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	showLines: true,

	// Element defaults defined in element extensions
	elements: {},

	// Layout options such as padding
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

module.exports = function() {

	// Occupy the global variable of Chart, and create a simple base class
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};

	Chart.Chart = Chart;

	return Chart;
};


/***/ }),

/***/ "+QZ5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"option-select":"option-select","button-icon":"button-icon","icon":"icon","disabled":"disabled","button-select-previous":"button-select-previous","button-select-next":"button-select-next","options":"options","option":"option","active":"active"};

/***/ }),

/***/ "+Z97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__email_verification_confirm_tpl_pug__ = __webpack_require__("T8fi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__email_verification_confirm_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__email_verification_confirm_tpl_pug__);


/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEmailVerificationConfirm',
    template: __WEBPACK_IMPORTED_MODULE_0__email_verification_confirm_tpl_pug___default()()
});

/***/ }),

/***/ "+sfM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Scrissors-e4c1f15a1a5172bf.svg";

/***/ }),

/***/ "+skt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrollIntoViewDirective;
ScrollIntoViewDirective.$inject = ['$parse', '$timeout'];
var selector = 'dbAScrollIntoView';

/* @ngInject */
function ScrollIntoViewDirective($parse, $timeout) {
    return {
        restrict: 'A',
        require: '^dbAScrollContainer',

        link: function link(scope, element, attrs, container) {
            var getter = $parse(attrs[selector]);
            var shouldScroll = getter(scope);

            if (shouldScroll) {
                $timeout(function () {
                    return container.scrollToElement(element[0]);
                });
            }
        }
    };
}

/***/ }),

/***/ "+t/z":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"block-component\" id=\"subscribe-page\"\u003E\u003Cdiv class=\"subscribe-header\"\u003E\u003Cdiv class=\"page-title\"\u003EGo Premium\u003C\u002Fdiv\u003E\u003Ca class=\"button button-icon button-close-page\" ng-click=\"$ctrl.goBack()\"\u003E\u003Ci class=\"icon icon-dollarbird-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscribe-content block-component\"\u003E\u003Cdiv class=\"subscribe-title\"\u003EFind the right plan for you\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscribe-description\"\u003EUpgrade your plan to have more calendars. Explore our monthly and yearly plans and pick the one that best suits your needs.\u003C\u002Fdiv\u003E\u003Cdb-plans plans=\"$ctrl.plans\" upgrade=\"true\" on-select=\"$ctrl.select(plan, subscription)\"\u003E\u003C\u002Fdb-plans\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "+w2c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card-with-year-picker":"card-with-year-picker","card-year-picker":"card-year-picker","button-select-previous-year":"button-select-previous-year","button-select-next-year":"button-select-next-year","year-selected":"year-selected"};

/***/ }),

/***/ "+wd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_slice__ = __webpack_require__("bpPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_application_util_balance_highlight_util__ = __webpack_require__("Ium9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_list_style_sass__ = __webpack_require__("qnXT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_list_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__calendar_list_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar_list_tpl_pug__ = __webpack_require__("y7YE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar_list_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__calendar_list_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var CalendarListController = function () {
    CalendarListController.$inject = ['$q'];

    /* @ngInject */
    function CalendarListController($q) {
        _classCallCheck(this, CalendarListController);

        this.$q = $q;
    }

    _createClass(CalendarListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortableOptions = {
                animation: 100,
                onStart: this.startSort.bind(this),
                onEnd: this.endSort.bind(this)
            };
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.calendars) {
                this.calendars = __WEBPACK_IMPORTED_MODULE_0_lodash_slice___default()(this.calendars || []);
            }

            if (changeObject.multipleSelection || changeObject.canSelectMultiple) {
                this.multiple = this.multipleSelection && this.canSelectMultiple;
            }
        }
    }, {
        key: 'isActive',
        value: function isActive(calendar) {
            return this.selectedCalendarIds && this.selectedCalendarIds.length > 0 && calendar && this.selectedCalendarIds.indexOf(calendar.id) >= 0;
        }
    }, {
        key: 'add',
        value: function add() {
            return this.onCalendarAdd();
        }
    }, {
        key: 'delete',
        value: function _delete(calendar) {
            return this.onCalendarDelete({
                calendar: calendar
            });
        }
    }, {
        key: 'edit',
        value: function edit(calendar) {
            return this.onCalendarEdit({
                calendar: calendar
            });
        }
    }, {
        key: 'select',
        value: function select(calendar) {
            return this.onCalendarSelect({
                calendar: calendar
            });
        }
    }, {
        key: 'editTeam',
        value: function editTeam() {
            return this.onTeamEdit();
        }
    }, {
        key: 'toggleMultiple',
        value: function toggleMultiple(multiple) {
            return this.onMultipleChange({
                multiple: multiple
            });
        }
    }, {
        key: 'startSort',
        value: function startSort() {
            this.sorting = true;
        }
    }, {
        key: 'endSort',
        value: function endSort() {
            var _this = this;

            return this.$q.when(this.onCalendarReorder({
                order: __WEBPACK_IMPORTED_MODULE_0_lodash_slice___default()(this.calendars)
            })).finally(function () {
                _this.sorting = false;
            });
        }
    }, {
        key: 'getBalanceOverrideColor',
        value: function getBalanceOverrideColor(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_application_util_balance_highlight_util__["a" /* getBalanceOverrideColor */])(value, this.balanceWarningThreshold);
        }
    }, {
        key: 'selectedCount',
        get: function get() {
            return this.selectedCalendarIds && this.selectedCalendarIds.length > 0 ? this.selectedCalendarIds.length : 0;
        }
    }]);

    return CalendarListController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarList',
    template: __WEBPACK_IMPORTED_MODULE_3__calendar_list_tpl_pug___default()(),
    controller: CalendarListController,
    bindings: {
        loading: '<',
        calendars: '<',
        selectedCalendarIds: '<',
        multipleSelection: '<multiple',
        canSelectMultiple: '<',
        balanceWarningThreshold: '<',

        owner: '<',
        plan: '<',
        canAdd: '<',

        onCalendarSelect: '&',
        onCalendarEdit: '&',
        onCalendarDelete: '&',
        onCalendarAdd: '&',
        onCalendarReorder: '&',
        onTeamEdit: '&',
        onMultipleChange: '&'
    }
});

/***/ }),

/***/ "/KNH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Laptop-8c7762aeb2c771ce.svg";

/***/ }),

/***/ "/MEv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-chart":"category-chart","chart-container":"chart-container","chart-content":"chart-content","visible":"visible","chart-error":"chart-error","chart-selected-period":"chart-selected-period"};

/***/ }),

/***/ "/NDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_ingest_token_service__ = __webpack_require__("Z/ov");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.service.email-ingest-token', []).service('emailIngestTokenService', __WEBPACK_IMPORTED_MODULE_1__email_ingest_token_service__["a" /* default */]));

/***/ }),

/***/ "/O72":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"sign-in-page\"\u003E\u003Cdiv class=\"form-validation\" ng-bind=\"$ctrl.error\" ng-show=\"$ctrl.error\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-box\"\u003E\u003Cdiv class=\"identity-title\"\u003ELog in to Dollarbird\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-form\"\u003E\u003Cform role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.signIn($ctrl.email, $ctrl.password)\"\u003E\u003Cdiv class=\"control-group\"\u003E\u003Clabel class=\"control-icon\" for=\"email-control\"\u003E\u003Ci class=\"icon-dollarbird-email\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"email\" id=\"email-control\" name=\"email\" placeholder=\"email\" ng-model=\"$ctrl.email\" required\u003E\u003Clabel class=\"control-label\" for=\"email-control\"\u003EEmail\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"email-control\"\u003E\u003Cdb-a-validation-message key=\"email\"\u003EPlease provide a valid email address.\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your email address.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"control-group\"\u003E\u003Clabel class=\"control-icon\" for=\"password-control\"\u003E\u003Ci class=\"icon-dollarbird-password\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"password\" id=\"password-control\" name=\"password\" placeholder=\"password\" ng-model=\"$ctrl.password\" focus-state required\u003E\u003Clabel class=\"control-label\" for=\"password-control\"\u003EPassword\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"password-control\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your password.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"forgot-password\"\u003E\u003Ca class=\"link link-forgot-password\" href=\"javascript:void(0);\" ui-sref=\"identity.forgot-password.request({ email: $ctrl.email })\"\u003EForgot password?\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cbutton class=\"button button-block button-fill button-primary button-sign-in\" type=\"submit\" db-a-async loading=\"form.$submitting\"\u003E\u003Cinitial\u003ELog in\u003C\u002Finitial\u003E\u003Cloading\u003ELogging in...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-comment\"\u003E\u003Cspan\u003EDon't have an account? \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"identity.sign-up\"\u003ESign up\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-comment sign-in-diagnostics\" ng-if=\"$ctrl.canSendDiagnostics\"\u003E\u003Cspan\u003EEncountering issues? \u003C\u002Fspan\u003E\u003Ca class=\"link link-send-diagnostics\" href=\"javascript:void(0);\" ng-click=\"$ctrl.sendDiagnostics()\" ng-class=\"{ disabled: $ctrl.sendingDiagnostics }\"\u003ESend diagnostics\u003C\u002Fa\u003E\u003Cdiv class=\"sign-in-diagnostics-loader\" ng-class=\"{ visible: $ctrl.sendingDiagnostics }\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "/Rav":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_range_picker_cmpt__ = __webpack_require__("bsoP");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.date-range-picker', []).component(__WEBPACK_IMPORTED_MODULE_1__date_range_picker_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__date_range_picker_cmpt__["a" /* default */]));

/***/ }),

/***/ "/S/B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"async":"async","async-text-loading":"async-text-loading","async-text-initial":"async-text-initial","async-loading":"async-loading"};

/***/ }),

/***/ "/dO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiDrag", function() { return MultiDragPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sortable", function() { return Sortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swap", function() { return SwapPlugin; });
/**!
 * Sortable 1.15.7
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var version = "1.15.7";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !! /*@__PURE__*/navigator.userAgent.match(pattern);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};
function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches( /**HTMLElement*/el, /**String*/selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType && el.host !== el ? el.host : el.parentNode;
}
function closest( /**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}
function css(el, prop, val) {
  var style = el && el.style;
  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }
      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = '';
  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');
      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */
  return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
      i = 0,
      n = list.length;
    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }
    return list;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}

/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;
  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode;

    // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11
    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect();

          // Set relative to edges of padding box of container
          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */
      } while (container = container.parentNode);
    }
  }
  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
      scaleX = elMatrix && elMatrix.a,
      scaleY = elMatrix && elMatrix.d;
    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }
  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}

/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */
function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
    elSideVal = getRect(el)[elSide];

  /* jshint boss:true */
  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
      visible = void 0;
    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }
    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }
  return false;
}

/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */
function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0,
    i = 0,
    children = el.children;
  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }
      currentChild++;
    }
    i++;
  }
  return null;
}

/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */
function lastChild(el, selector) {
  var last = el.lastElementChild;
  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }
  return last || null;
}

/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */
function index(el, selector) {
  var index = 0;
  if (!el || !el.parentNode) {
    return -1;
  }

  /* jshint boss:true */
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }
  return index;
}

/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */
function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
    offsetTop = 0,
    winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el),
        scaleX = elMatrix.a,
        scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}

/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */
function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
        _this = this;
      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }
      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}
function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}
function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}
function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}
function getChildContainingRectFromElement(container, options, ghostEl) {
  var rect = {};
  Array.from(container.children).forEach(function (child) {
    var _rect$left, _rect$top, _rect$right, _rect$bottom;
    if (!closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
    var childRect = getRect(child);
    rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
    rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
    rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
    rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
  });
  rect.width = rect.right - rect.left;
  rect.height = rect.bottom - rect.top;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
    animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);

        // If animating: compensate for current animation
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }
      var animating = false,
        animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
          target = state.target,
          fromRect = target.fromRect,
          toRect = getRect(target),
          prevFromRect = target.prevFromRect,
          prevToRect = target.prevToRect,
          animatingRect = state.rect,
          targetMatrix = matrix(target, true);
        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target.toRect = toRect;
        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) &&
          // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        }

        // if fromRect != toRect: animate
        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;
          if (!time) {
            time = _this.options.animation;
          }
          _this.animate(target, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
          scaleX = elMatrix && elMatrix.a,
          scaleY = elMatrix && elMatrix.d,
          translateX = (currentRect.left - toRect.left) / (scaleX || 1),
          translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        this.forRepaintDummy = repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target) {
  return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }
    plugins.forEach(function (p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;
    this.eventCanceled = false;
    evt.cancel = function () {
      _this.eventCanceled = true;
    };
    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return;
      // Fire global events if it exists in this sortable
      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable: sortable
        }, evt));
      }

      // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined
      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;

      // Add default options from plugin
      _extends(defaults, initialized.defaults);
    });
    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);
      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;
      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return;

      // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
    rootEl = _ref.rootEl,
    name = _ref.name,
    targetEl = _ref.targetEl,
    cloneEl = _ref.cloneEl,
    toEl = _ref.toEl,
    fromEl = _ref.fromEl,
    oldIndex = _ref.oldIndex,
    newIndex = _ref.newIndex,
    oldDraggableIndex = _ref.oldDraggableIndex,
    newDraggableIndex = _ref.newDraggableIndex,
    originalEvent = _ref.originalEvent,
    putSortable = _ref.putSortable,
    extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
    options = sortable.options,
    onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
  // Support for new CustomEvent feature
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }
  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }
  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var _excluded = ["evt"];
var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    originalEvent = _ref.evt,
    data = _objectWithoutProperties(_ref, _excluded);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};
function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}
var dragEl,
  parentEl,
  ghostEl,
  rootEl,
  nextEl,
  lastDownEl,
  cloneEl,
  cloneHidden,
  oldIndex,
  newIndex,
  oldDraggableIndex,
  newDraggableIndex,
  activeGroup,
  putSortable,
  awaitingDragStarted = false,
  ignoreNextClick = false,
  sortables = [],
  tapEvt,
  touchEvt,
  lastDx,
  lastDy,
  tapDistanceLeft,
  tapDistanceTop,
  moved,
  lastTarget,
  lastDirection,
  pastFirstInvertThresh = false,
  isCircumstantialInvert = false,
  targetMoveDistance,
  // For positioning ghost absolutely
  ghostRelativeParent,
  ghostRelativeParentInitialScroll = [],
  // (left, top)

  _silent = false,
  savedInputChecked = [];

/** @const */
var documentExists = typeof document !== 'undefined',
  PositionGhostAbsolutely = IOS,
  CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
  // This will not pass for IE9, because IE9 DnD only works on anchors
  supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
  supportCssPointerEvents = function () {
    if (!documentExists) return;
    // false when <= IE11
    if (IE11OrLess) {
      return false;
    }
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
  }(),
  _detectDirection = function _detectDirection(el, options) {
    var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
    if (elCSS.display === 'flex') {
      return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    }
    if (elCSS.display === 'grid') {
      return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    }
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
      var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
      return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
  },
  _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
  },
  /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */
  _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    sortables.some(function (sortable) {
      var threshold = sortable[expando].options.emptyInsertThreshold;
      if (!threshold || lastChild(sortable)) return;
      var rect = getRect(sortable),
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
      if (insideHorizontally && insideVertically) {
        return ret = sortable;
      }
    });
    return ret;
  },
  _prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
      return function (to, from, dragEl, evt) {
        var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
        if (value == null && (pull || sameGroup)) {
          // Default pull value
          // Default pull and put value if same group
          return true;
        } else if (value == null || value === false) {
          return false;
        } else if (pull && value === 'clone') {
          return value;
        } else if (typeof value === 'function') {
          return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
        } else {
          var otherGroup = (pull ? to : from).options.group.name;
          return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
        }
      };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || _typeof(originalGroup) != 'object') {
      originalGroup = {
        name: originalGroup
      };
    }
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
  },
  _hideGhostForTarget = function _hideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', 'none');
    }
  },
  _unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', '');
    }
  };

// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if (documentExists && !ChromeForAndroid) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      // Create imitation event
      var event = {};
      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};

/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el; // root element
  this.options = options = _extends({}, options);

  // Export instance
  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && (!Safari || IOS),
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults);

  // Set default options
  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }
  _prepareGroup(options);

  // Bind all private methods
  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  }

  // Setup drag mode
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  }

  // Bind events
  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }
  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }
  sortables.push(this.el);

  // Restore sorting
  options.store && options.store.get && this.sort(options.store.get(this) || []);

  // Add animation state manager
  _extends(this, AnimationStateManager());
}
Sortable.prototype = /** @lends Sortable.prototype */{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart( /** Event|TouchEvent */evt) {
    if (!evt.cancelable) return;
    var _this = this,
      el = this.el,
      options = this.options,
      preventOnFilter = options.preventOnFilter,
      type = evt.type,
      touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
      target = (touch || evt).target,
      originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
      filter = options.filter;
    _saveInputCheckedState(el);

    // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    }

    // cancel dnd if original target is content editable
    if (originalTarget.isContentEditable) {
      return;
    }

    // Safari ignores further event handling after mousedown
    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
      return;
    }
    target = closest(target, options.draggable, el, false);
    if (target && target.animated) {
      return;
    }
    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    }

    // Get the index of the dragged element within its parent
    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable);

    // Check filter
    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });
        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });
          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });
      if (filter) {
        preventOnFilter && evt.preventDefault();
        return; // cancel dnd
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }

    // Prepare `dragstart`
    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart( /** Event */evt, /** Touch */touch, /** HTMLElement */target) {
    var _this = this,
      el = _this.el,
      options = _this.options,
      ownerDocument = el.ownerDocument,
      dragStartFn;
    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';
      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });
        if (Sortable.eventCanceled) {
          _this._onDrop();
          return;
        }
        // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove
        _this._disableDelayedDragEvents();
        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        }

        // Bind the events: dragstart/dragend
        _this._triggerDragStart(evt, touch);

        // Drag start event
        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        });

        // Chosen item
        toggleClass(dragEl, options.chosenClass, true);
      };

      // Disable "draggable"
      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      if (options.supportPointer) {
        on(ownerDocument, 'pointerup', _this._onDrop);
        // Native D&D triggers pointercancel
        !this.nativeDraggable && on(ownerDocument, 'pointercancel', _this._onDrop);
      } else {
        on(ownerDocument, 'mouseup', _this._onDrop);
        on(ownerDocument, 'touchend', _this._onDrop);
        on(ownerDocument, 'touchcancel', _this._onDrop);
      }

      // Make dragEl draggable (must be before delay for FireFox)
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent('delayStart', this, {
        evt: evt
      });

      // Delay is impossible for native DnD in Edge or IE
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag
        if (options.supportPointer) {
          on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
          on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
        } else {
          on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
          on(ownerDocument, 'touchend', _this._disableDelayedDrag);
          on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        }
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler( /** TouchEvent|PointerEvent **/e) {
    var touch = e.touches ? e.touches[0] : e;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'pointerup', this._disableDelayedDrag);
    off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart( /** Event */evt, /** Touch */touch) {
    touch = touch || evt.pointerType == 'touch' && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });
      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }
      var options = this.options;

      // Apply effect
      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost();

      // Drag start event
      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;
      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target);
      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });
            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }
          target = parent; // store last element
        }
        /* jshint boss:true */ while (parent = getParentOrHost(parent));
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove( /**TouchEvent*/evt) {
    if (tapEvt) {
      var options = this.options,
        fallbackTolerance = options.fallbackTolerance,
        fallbackOffset = options.fallbackOffset,
        touch = evt.touches ? evt.touches[0] : evt,
        ghostMatrix = ghostEl && matrix(ghostEl, true),
        scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
        scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
        relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
        dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
        dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);

      // only set the status to dragging, when we are actually dragging
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
        rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
        options = this.options;

      // Position absolutely
      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;
        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl);

      // Set transform-origin
      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart( /**Event*/evt, /**boolean*/fallback) {
    var _this = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent('setupClone', this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.removeAttribute("id");
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';
      this._hideClone();
      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }

    // #1143: IFrame support workaround
    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;
      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this._hideClone();
      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true);

    // Set proper drop events
    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }
      on(document, 'drop', _this);

      // #1276 fix:
      css(dragEl, 'transform', 'translateZ(0)');
    }
    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;
    window.getSelection().removeAllRanges();
    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver( /**Event*/evt) {
    var el = this.el,
      target = evt.target,
      dragRect,
      targetRect,
      revert,
      options = this.options,
      group = options.group,
      activeSortable = Sortable.active,
      isOwner = activeGroup === group,
      canSort = options.sort,
      fromSortable = putSortable || activeSortable,
      vertical,
      _this = this,
      completedFired = false;
    if (_silent) return;
    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread2({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    }

    // Capture animation state
    function capture() {
      dragOverEvent('dragOverAnimationCapture');
      _this.captureAnimationState();
      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }

    // Return invocation when dragEl is inserted (or completed)
    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });
      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }
        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        }

        // Animation
        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }
        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });
        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }

      // Null lastTarget if it is not inside a previously swapped element
      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      }

      // no bubbling and not fallback
      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);

        // Do not detect for empty insert if already inserted
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }

    // Call when dragEl has been inserted
    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;
    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;
      if (revert) {
        parentEl = rootEl; // actualization
        capture();
        this._hideClone();
        dragOverEvent('revert');
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // Insert to end of list

        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        }

        // if there is a last element, it is the target
        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }
        if (target) {
          targetRect = getRect(target);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          if (elLastChild && elLastChild.nextSibling) {
            // the last draggable element is not the last node
            el.insertBefore(dragEl, elLastChild.nextSibling);
          } else {
            el.appendChild(dragEl);
          }
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        // Insert to start of list
        var firstChild = getChild(el, 0, options, true);
        if (firstChild === dragEl) {
          return completed(false);
        }
        target = firstChild;
        targetRect = getRect(target);
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
          targetBeforeFirstSwap,
          differentLevel = dragEl.parentNode !== el,
          differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
          side1 = vertical ? 'top' : 'left',
          scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
          scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;
        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);
          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        }
        // If dragEl is already beside target: Do not insert
        if (direction === 0 || sibling === target) {
          return completed(false);
        }
        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
          after = false;
        after = direction === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          }

          // Undo chrome's scroll adjustment (has no effect on other browsers)
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode; // actualization

          // must be done before animation
          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'pointercancel', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop( /**Event*/evt) {
    var el = this.el,
      options = this.options;

    // Get the index of the dragged element within its parent
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode;

    // Get again after plugin event
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);

    // Unbind events
    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, 'user-select', '');
    }
    css(dragEl, 'transform', '');
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }
        _disableDraggable(dragEl);
        dragEl.style['will-change'] = '';

        // Remove classes
        // ghostClass is added in dragStarted
        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass(dragEl, this.options.chosenClass, false);

        // Drag stop event
        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            // Remove event
            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            });

            // drag from one list and drop into another
            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          });

          // Save sorting
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    var el = this.el;
    savedInputChecked.forEach(function (checkEl) {
      if (el.contains(checkEl)) {
        checkEl.checked = true;
      }
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent( /**Event*/evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);
        break;
      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
      el,
      children = this.el.children,
      i = 0,
      n = children.length,
      options = this.options;
    for (; i < n; i++) {
      el = children[i];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order, useAnimation) {
    var items = {},
      rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];
      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;
    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);
      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }
      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },
  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);
    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    }
    // Remove draggable attributes
    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return;

      // show clone at dragEl or original position
      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};
function _globalDragOver( /**Event*/evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
    sortable = fromEl[expando],
    onMoveFn = sortable.options.onMove,
    retVal;
  // Support for new CustomEvent feature
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
  var firstElRect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
  var spacer = 10;
  return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
  var lastElRect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
  var spacer = 10;
  return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
    targetLength = vertical ? targetRect.height : targetRect.width,
    targetS1 = vertical ? targetRect.top : targetRect.left,
    targetS2 = vertical ? targetRect.bottom : targetRect.right,
    invert = false;
  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}

/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */
function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}

/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
    i = str.length,
    sum = 0;
  while (i--) {
    sum += str.charCodeAt(i);
  }
  return sum.toString(36);
}
function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn) {
  return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}

// Fixed #973:
if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}

// Export utils
Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild,
  expando: expando
};

/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */
Sortable.get = function (element) {
  return element[expando];
};

/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */
Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }
  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }
    if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};

/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */
Sortable.create = function (el, options) {
  return new Sortable(el, options);
};

// Export
Sortable.version = version;

var autoScrolls = [],
  scrollEl,
  scrollRootEl,
  scrolling = false,
  lastAutoScrollX,
  lastAutoScrollY,
  touchEvt$1,
  pointerElemChangedInterval;
function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };

    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }
  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;
      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;
      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }
      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;
      var x = (evt.touches ? evt.touches[0] : evt).clientX,
        y = (evt.touches ? evt.touches[0] : evt).clientY,
        elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt;

      // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good
      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback);

        // Listener for pointer element change
        var ogElemScroller = getParentAutoScrollElement(elem, true);
        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval();
          // Detect for pointer elem change, emulating native DnD behaviour
          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }
            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
    y = (evt.touches ? evt.touches[0] : evt).clientY,
    sens = options.scrollSensitivity,
    speed = options.scrollSpeed,
    winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
    scrollCustomFn;

  // New scroll root, set scrollEl
  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;
    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }
  var layersOut = 0;
  var currentParent = scrollEl;
  do {
    var el = currentParent,
      rect = getRect(el),
      top = rect.top,
      bottom = rect.bottom,
      left = rect.left,
      right = rect.right,
      width = rect.width,
      height = rect.height,
      canScrollX = void 0,
      canScrollY = void 0,
      scrollWidth = el.scrollWidth,
      scrollHeight = el.scrollHeight,
      elCSS = css(el),
      scrollPosX = el.scrollLeft,
      scrollPosY = el.scrollTop;
    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }
    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }
    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);
      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */
        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely
          }
          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }
          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }
    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
    putSortable = _ref.putSortable,
    dragEl = _ref.dragEl,
    activeSortable = _ref.activeSortable,
    dispatchSortableEvent = _ref.dispatchSortableEvent,
    hideGhostForTarget = _ref.hideGhostForTarget,
    unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};
function Revert() {}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
      putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable) {
      putSortable.captureAnimationState();
    }
    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }
    this.sortable.animateAll();
    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};
_extends(Revert, {
  pluginName: 'revertOnSpill'
});
function Remove() {}
Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
      putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};
_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;
function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }
  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
        target = _ref2.target,
        onMove = _ref2.onMove,
        activeSortable = _ref2.activeSortable,
        changed = _ref2.changed,
        cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
        options = this.options;
      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;
        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }
        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }
      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
        putSortable = _ref3.putSortable,
        dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);
      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}
function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
    p2 = n2.parentNode,
    i1,
    i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);
  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }
  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
  multiDragClones = [],
  lastMultiDragSelect,
  // for selection with modifier key down (SHIFT)
  multiDragSortable,
  initialFolding = false,
  // Initial multi-drag fold when drag started
  folding = false,
  // Folding any other time
  dragStarted = false,
  dragEl$1,
  clonesFromRect,
  clonesHidden;
function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
    if (!sortable.options.avoidImplicitDeselect) {
      if (sortable.options.supportPointer) {
        on(document, 'pointerup', this._deselectMultiDrag);
      } else {
        on(document, 'mouseup', this._deselectMultiDrag);
        on(document, 'touchend', this._deselectMultiDrag);
      }
    }
    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      avoidImplicitDeselect: false,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';
        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }
        dataTransfer.setData('Text', data);
      }
    };
  }
  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
        cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;
      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }
      sortable._hideClone();
      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
        rootEl = _ref3.rootEl,
        dispatchSortableEvent = _ref3.dispatchSortableEvent,
        cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;
      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
        rootEl = _ref4.rootEl,
        cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;
      var sortable = _ref5.sortable,
        cloneNowHidden = _ref5.cloneNowHidden,
        cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');
        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;
      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      });

      // Sort multi-drag elements
      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;
      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;
      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM

        sortable.captureAnimationState();
        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }
      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;
        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        }

        // Remove all auxiliary multidrag items from el, if sorting enabled
        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
        completed = _ref8.completed,
        cancel = _ref8.cancel;
      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
        rootEl = _ref9.rootEl,
        sortable = _ref9.sortable,
        dragRect = _ref9.dragRect;
      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
        isOwner = _ref10.isOwner,
        insertion = _ref10.insertion,
        activeSortable = _ref10.activeSortable,
        parentEl = _ref10.parentEl,
        putSortable = _ref10.putSortable;
      var options = this.options;
      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }
        initialFolding = false;
        // If leaving sort:false root, or already folding - Fold to new location
        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute);

            // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        }

        // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }
          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;
            activeSortable._showClone(sortable);

            // Unfold animation for clones if showing from hidden
            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
        isOwner = _ref11.isOwner,
        activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });
      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
        rootEl = _ref12.rootEl,
        parentEl = _ref12.parentEl,
        sortable = _ref12.sortable,
        dispatchSortableEvent = _ref12.dispatchSortableEvent,
        oldIndex = _ref12.oldIndex,
        putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
        children = parentEl.children;

      // Multi-drag selection
      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }
        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));
        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvent: evt
          });

          // Modifier activated, select from last to dragEl
          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
              currentIndex = index(dragEl$1);
            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              (function () {
                // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                // (but previous selection existed)
                var n, i;
                if (currentIndex > lastIndex) {
                  i = lastIndex;
                  n = currentIndex;
                } else {
                  i = currentIndex;
                  n = lastIndex + 1;
                }
                var filter = options.filter;
                for (; i < n; i++) {
                  if (~multiDragElements.indexOf(children[i])) continue;
                  // Check if element is draggable
                  if (!closest(children[i], options.draggable, parentEl, false)) continue;
                  // Check if element is filtered
                  var filtered = filter && (typeof filter === 'function' ? filter.call(sortable, evt, children[i], sortable) : filter.split(',').some(function (criteria) {
                    return closest(children[i], criteria.trim(), parentEl, false);
                  }));
                  if (filtered) continue;
                  toggleClass(children[i], options.selectedClass, true);
                  multiDragElements.push(children[i]);
                  dispatchEvent({
                    sortable: sortable,
                    rootEl: rootEl,
                    name: 'select',
                    targetEl: children[i],
                    originalEvent: evt
                  });
                }
              })();
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }
          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvent: evt
          });
        }
      }

      // Multi-drag drop
      if (dragStarted && this.isMultiDrag) {
        folding = false;
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
            multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();
          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect;

                  // Prepare unfold animation
                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            }

            // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed
            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }
              multiDragIndex++;
            });

            // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.
            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });
              if (update) {
                dispatchSortableEvent('update');
                dispatchSortableEvent('sort');
              }
            }
          }

          // Must be done after capturing individual rects (scroll bar)
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }
        multiDragSortable = toSortable;
      }

      // Remove clones if necessary
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();
      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return;

      // Only deselect if selection is in this sortable
      if (multiDragSortable !== this.sortable) return;

      // Only deselect if target is not item in this sortable
      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return;

      // Only deselect if left click
      if (evt && evt.button !== 0) return;
      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvent: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;
        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();
          multiDragSortable = sortable;
        }
        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },
      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
          index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;
      var oldIndicies = [],
        newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        });

        // multiDragElements will already be sorted if folding
        var newIndex;
        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }
        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();
        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }
        return key;
      }
    }
  });
}
function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}

/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */
function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}
function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),

/***/ "/hAw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryEntertainment-e748a83e6d38cae3.svg";

/***/ }),

/***/ "/hOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sign_in__ = __webpack_require__("LUro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sign_up__ = __webpack_require__("N6I6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forgot_password__ = __webpack_require__("n2mO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__email_verification__ = __webpack_require__("NqOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__change_email__ = __webpack_require__("Rx8b");








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene', [__WEBPACK_IMPORTED_MODULE_1__sign_in__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__sign_up__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__forgot_password__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__email_verification__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__change_email__["a" /* default */].name]));

/***/ }),

/***/ "/hmp":
/***/ (function(module, exports) {


var Int = function(num) {
    // can be called as a function
    if (!(this instanceof Int)) {
        return new Int(num);
    }

    var self = this;

    // copy existing Int object
    if (num instanceof Int){
        self._s = num._s;
        self._d = num._d.slice();
        return;
    }

    // default value 0
    num = num || 0;

    // sign
    self._s = ((num += '').charAt(0) === '-') ? 1 : 0;

    // digits
    self._d = [];

    num = num.replace(/^[+-]/, '');
    var orig = num;

    // remove any leading - or + as well as other invalid characters
    num = num.replace(/[^\d]/g, '');

    // detect if value is not a number
    if (orig !== num) {
        self._nan = true;
        return;
    }

    // _d is the array of single digits making up the number
    var ln = num.length;
    for (var i=0 ; i<ln ; ++i) {
        self._d.push(+num[i]);
    }

    trim_zeros(self);

    // zeros are normalized to positive
    // TODO (shtylman) consider not doing this and only checking in toString?
    if (self._d.length === 0) {
        self._s = 0;
    }
};

/// add num and return new integer
Int.prototype.add = function(num) {
    var self = this;
    var num = ensure_int(num);

    if(self._s != num._s) {
        num._s ^= 1;
        var res = self.sub(num);
        num._s ^= 1;
        return res;
    }

    // a will be the smaller number
    if (self._d.length < num._d.length) {
        var a = self._d;
        var b = num._d;
        var out = Int(num);
    }
    else {
        var a = num._d;
        var b = self._d;
        var out = Int(self);
    }

    var la = a.length;
    var lb = b.length;

    // clone the larger number
    var res = out._d;

    var carry = 0;
    for (var i = lb - 1, j = la - 1; i >= 0, j >= 0 ; --i, --j) {
        res[i] += carry + a[j];
        carry = 0;

        if (res[i] >= 10) {
            res[i] -= 10;
            carry = 1;
        }
    }

    // carry the rest of the way
    for (; i >= 0 ; --i) {
        res[i] += carry;
        carry = 0;
        if (res[i] >= 10) {
            res[i] -= 10;
            carry = 1;
        }

        // no carry, rest of the number will be unchanged
        if (carry === 0) {
            break;
        }
    }

    // remaining carry?
    if (carry > 0) {
        res.unshift(1);
    }

    return out;
}

Int.prototype.sub = function(num) {
    var self = this;

    // some operations are destructive
    var num = Int(num);

    if(self._s != num._s) {
        num._s ^= 1;
        var res = this.add(num);
        num._s ^= 1;
        return res;
    }

    var s1 = self._s;
    var s2 = num._s;

    // make numbers positive for determining the greater one
    // in absolute terms
    self._s = num._s = 0;

    // make a the smaller number (abs value)
    var c = self.lt(num);
    var a = c ? self._d : num._d;
    var b = c ? num._d : self._d;

    // restore original signs
    self._s = s1;
    num._s = s2;

    var la = a.length;
    var lb = b.length;

    var out = Int((c) ? num : self);
    out._s = num._s & self._s; // ??
    var res = out._d;

    // basic subtraction for common size
    var borrow = 0;
    for (var i = lb - 1, j = la - 1; i >= 0, j >= 0 ; --i, --j) {
        res[i] -= a[j] + borrow;
        borrow = 0;

        if (res[i] < 0) {
            res[i] += 10;
            borrow = 1;
        }
    }

    // carry the rest of the way
    for (; i >= 0 ; --i) {
        res[i] -= borrow;
        borrow = 0;
        if (res[i] < 0) {
            res[i] += 10;
            borrow = 1;
        }

        // no carry, rest of the number will be unchanged
        if (borrow === 0) {
            break;
        }
    }

    // flip the sign if sub num was larger
    c && (out._s ^= 1);

    trim_zeros(out);

    // TODO the subtraction should just be smarter
    if (out._d.length === 0) {
        out._s = 0;
    }

    return out;
};

Int.prototype.mul = function(num) {
    var self = this;

    var r = self._d.length >= (num = Int(num))._d.length;
    var a = (r ? self : num)._d;
    var b = (r ? num : self)._d;

    var la = a.length;
    var lb = b.length;

    var sum = Int();
    var zeros = [];

    // loop for smaller number
    for (var i = lb - 1 ; i >= 0 ; --i) {
        var out = Int();

        // insert proper number of trailing 0s
        var val = out._d = out._d.concat(zeros);

        // reset carry
        var carry = 0;

        // top number
        for (var j = la - 1; j >= 0; --j) {
            // multiplication result
            var mul = b[i] * a[j] + carry;

            // this is the single digit we keep
            var res = mul % 10;

            // carry amount
            carry = Math.floor(mul / 10);

            // insert the number into our new integer
            val.unshift(res);
        }

        // apply any remaining carry
        if (carry) {
            val.unshift(carry);
        }

        sum = sum.add(out);
        zeros.push(0);
    }

    sum._s = self._s ^ num._s;
    return sum;
};

Int.prototype.div = function(num) {
    var self = this;

    // copy since we change sign of num
    var num = Int(num);

    if(num == '0') {
        throw new Error('Division by 0');
    }
    else if(self == '0') {
        return Int();
    }

    // copy since we do destructive things
    var numerator = self._d.slice();

    var quo = Int();
    quo._s = self._s ^ num._s;

    // normalize num to positive number
    var orig_s = num._s;
    num._s = 0;

    // remainder from previous calculation
    var rem = Int();

    while (numerator.length) {
        // long division
        // shift numbers off the numerator until we have achieved size
        // every number after the first causes a 0 to be inserted
        // numbers shifted in from the remainder should not cause 0 insertion

        var c = 0;
        while (numerator.length && rem.lt(num)) {
            if (c++ > 0) {
                quo._d.push(0);
            }

            // shift a number from numerator to our running num
            rem._d.push(numerator.shift());

            // important to trim here since 009 - N won't be done right otherwise
            trim_zeros(rem);
        }

        var count = 0;
        while(rem.gte(num) && ++count) {
            rem = rem.sub(num);
        }

        if (count === 0) {
            quo._d.push(0);
            break;
        }

        quo._d.push(count);
    }

    var rlen = rem._d.length;

    if (rlen > 1 || (quo._s && rlen > 0)) {
        rem = rem.add(5);
    }

    if (quo._s && (rlen !== rem._d.length || rem._d[0] >= 5)) {
        quo = quo.sub(1);
    }

    // put back the sign of num
    num._s = orig_s;

    return trim_zeros(quo);
};

Int.prototype.mod = function(num) {
    return this.sub(this.div(num).mul(num));
};

Int.prototype.pow = function(num) {
    var out = Int(this);
    if((num = (Int(num))) == 0) {
        return out.set(1);
    }

    for(var i = Math.abs(num); --i; out.set(out.mul(this)));
    return num < 0 ? out.set((Int(1)).div(out)) : out;
};

/// set this number to the value of num
Int.prototype.set = function(num) {
    this.constructor(num);
    return this;
};

/// -1 if self < n, 0 if self == n, 1 if self > n
Int.prototype.cmp = function(num) {
    var self = this;
    var num = ensure_int(num);

    if (self._s != num._s) {
        return self._s ? -1 : 1;
    }

    var a = self._d;
    var b = num._d;

    var la = a.length;
    var lb = b.length;

    if (la != lb) {
        return ((la > lb) ^ self._s) ? 1 : -1;
    }

    for (var i = 0; i < la; ++i) {
        if (a[i] != b[i]) {
            return ((a[i] > b[i]) ^ self._s) ? 1 : -1;
        }
    }

    // no differences
    return 0;
};

Int.prototype.neg = function() {
    var out = Int(this);
    out._s ^= 1;
    return out;
};

Int.prototype.abs = function() {
    var out = Int(this);
    out._s = 0;
    return out;
};

// alphabet for converting to a specific base
var alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';

Int.prototype.valueOf = Int.prototype.toString = function(radix){
    var self = this;

    if (self._nan) {
        return NaN;
    }

    if (!radix || radix === 10) {
        return (self._s && self._d.length ? '-' : '') + ((self._d.length) ? self._d.join('') : '0');
    }

    if (radix < 2 || radix > 36) {
        throw RangeError('radix out of range: ' + radix);
    }

    var radix_pow = Math.pow(radix, 6);

    var rem = self;
    var result = '';
    while (true) {
        var div = rem.div(radix_pow);
        var int = rem.sub(div.mul(radix_pow));
        var digits = (+int.toString()).toString(radix);
        rem = div;

        if (rem.eq(0)) {
            return digits + result;
        }
        else {
            while (digits.length < 6) {
                digits = '0' + digits;
            }
            result = '' + digits + result;
        }
    }
};

Int.prototype.gt = function (num) {
    return this.cmp(num) > 0;
};

Int.prototype.gte = function (num) {
    return this.cmp(num) >= 0;
};

Int.prototype.eq = function (num) {
    return this.cmp(num) === 0;
};

Int.prototype.ne = function (num) {
    return this.cmp(num) !== 0;
};

Int.prototype.lt = function (num) {
    return this.cmp(num) < 0;
};

Int.prototype.lte = function (num) {
    return this.cmp(num) <= 0;
};

/// private api

function ensure_int(val) {
    if (val instanceof Int) {
        return val;
    }

    return Int(val);
}

/// remove leading 0's from the int
function trim_zeros(int) {
    while (int._d.length && int._d[0] === 0) {
        int._d.shift();
    }

    return int;
}

module.exports = Int;



/***/ }),

/***/ "/iHN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_color_chart__ = __webpack_require__("cEDq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_group__ = __webpack_require__("M/MC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_group__ = __webpack_require__("nsAZ");






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-dashboard.component', [__WEBPACK_IMPORTED_MODULE_1__category_color_chart__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__category_group__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__event_group__["a" /* default */].name]));

/***/ }),

/***/ "/jKm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");
var helpers = __webpack_require__("iO9N");

defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers.noop,
			title: function(tooltipItems, data) {
				// Pick first xLabel for now
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];

					if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				label += tooltipItem.yLabel;
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers.noop,
			footer: helpers.noop,
			afterFooter: helpers.noop
		}
	}
});

module.exports = function(Chart) {

	/**
 	 * Helper method to merge the opacity into a color
 	 */
	function mergeOpacity(colorString, opacity) {
		var color = helpers.color(colorString);
		return color.alpha(opacity * color.alpha()).rgbaString();
	}

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	// Private helper to create a tooltip item model
	// @param element : the chart element (point, arc, bar) to create the tooltip item for
	// @return : new tooltip item
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {Object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers.each(body, function(bodyItem) {
			helpers.each(bodyItem.before, maxLineWidth);
			helpers.each(bodyItem.lines, maxLineWidth);
			helpers.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}

		olf = function(x) {
			return x + size.width > chart.width;
		};
		orf = function(x) {
			return x - size.width < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
	 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	Chart.Tooltip = Element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeTitle);
			lines = pushOrConcat(lines, title);
			lines = pushOrConcat(lines, afterTitle);

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			var lines = this._options.callbacks.beforeBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			var lines = this._options.callbacks.afterBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeFooter);
			lines = pushOrConcat(lines, footer);
			lines = pushOrConcat(lines, afterFooter);

			return lines;
		},

		update: function(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = Chart.Tooltip.positioners[opts.position](active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});


				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = Math.round(tooltipPosition.x);
				model.y = Math.round(tooltipPosition.y);
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + (height / 2);

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = ptX + (width / 2);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
		drawTitle: function(pt, vm, ctx, opacity) {
			var title = vm.title;

			if (title.length) {
				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';

				var titleFontSize = vm.titleFontSize;
				var titleSpacing = vm.titleSpacing;

				ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
		drawBody: function(pt, vm, ctx, opacity) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var body = vm.body;

			ctx.textAlign = vm._bodyAlign;
			ctx.textBaseline = 'top';
			ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			// Before Body
			var xLinePadding = 0;
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};

			// Before body lines
			helpers.each(vm.beforeBody, fillLineOfText);

			var drawColorBoxes = vm.displayColors;
			xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

			// Draw body lines now
			helpers.each(body, function(bodyItem, i) {
				helpers.each(bodyItem.before, fillLineOfText);

				helpers.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
						ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
						ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
						ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
						ctx.fillStyle = textColor;
					}

					fillLineOfText(line);
				});

				helpers.each(bodyItem.after, fillLineOfText);
			});

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
		drawFooter: function(pt, vm, ctx, opacity) {
			var footer = vm.footer;

			if (footer.length) {
				pt.y += vm.footerMarginTop;

				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';

				ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
				ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				helpers.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},
		drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
			ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
			ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

				// Draw Title, Body, and Footer
				pt.x += vm.xPadding;
				pt.y += vm.yPadding;

				// Titles
				this.drawTitle(pt, vm, ctx, opacity);

				// Body
				this.drawBody(pt, vm, ctx, opacity);

				// Footer
				this.drawFooter(pt, vm, ctx, opacity);
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {Boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}

			// Remember Last Actives
			changed = !helpers.arrayEquals(me._active, me._lastActive);

			// If tooltip didn't change, do not handle the target event
			if (!changed) {
				return false;
			}

			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				var model = me._model;
				me.update(true);
				me.pivot();

				// See if our tooltip position changed
				changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
			}

			return changed;
		}
	});

	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	Chart.Tooltip.positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {Point} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: Math.round(x / count),
				y: Math.round(y / count)
			};
		},

		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {Point} the position of the event in canvas coordinates
		 * @returns {Point} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};
};


/***/ }),

/***/ "/sYY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_16-33ce554a1b48ff6f.svg";

/***/ }),

/***/ "/yyt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__already_subscribed_notification_tpl_pug__ = __webpack_require__("mUT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__already_subscribed_notification_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__already_subscribed_notification_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var AlreadySubscribedController = function () {
    function AlreadySubscribedController() {
        _classCallCheck(this, AlreadySubscribedController);
    }

    _createClass(AlreadySubscribedController, [{
        key: 'close',
        value: function close() {
            return this.onClose();
        }
    }]);

    return AlreadySubscribedController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAAlreadySubscribedNotification',
    template: __WEBPACK_IMPORTED_MODULE_0__already_subscribed_notification_tpl_pug___default()(),
    controller: AlreadySubscribedController,
    bindings: {
        onClose: '&'
    }
});

/***/ }),

/***/ "0C1O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ "0CCe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_date_modal_style_sass__ = __webpack_require__("cR/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_date_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__event_date_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_date_modal_tpl_pug__ = __webpack_require__("4yT8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_date_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__event_date_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var REPEAT_END_TOO_FAR_MESSAGE = 'This repeat schedule ends too far in the future. Choose an earlier date or fewer occurrences.';
var MAX_REPEAT_YEAR = 9999;
var MAX_BACKEND_INTEGER = 2147483647;
var MAX_SAFE_INTEGER = 9007199254740991;

function isSafeInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value && Math.abs(value) <= MAX_SAFE_INTEGER;
}

var EventDateController = function () {
    EventDateController.$inject = ['arrayUtil', 'stringUtil', 'eventUtil', 'modalService'];

    /* @ngInject */
    function EventDateController(arrayUtil, stringUtil, eventUtil, modalService) {
        _classCallCheck(this, EventDateController);

        this.arrayUtil = arrayUtil;
        this.stringUtil = stringUtil;
        this.eventUtil = eventUtil;
        this.modalService = modalService;
    }

    _createClass(EventDateController, [{
        key: '$onInit',
        value: function $onInit() {
            this.canRepeat = this.canRepeat !== false;

            this.unitOptions = [{ id: this.eventUtil.EventRepeatUnit.Daily, value: 'Day' }, { id: this.eventUtil.EventRepeatUnit.Weekly, value: 'Week' }, { id: this.eventUtil.EventRepeatUnit.Monthly, value: 'Month' }, { id: this.eventUtil.EventRepeatUnit.Yearly, value: 'Year' }];

            this.endOptions = [{ id: this.eventUtil.EventRepeatEndType.Never, value: 'Never' }, { id: this.eventUtil.EventRepeatEndType.AfterOccurrence, value: 'After' }, { id: this.eventUtil.EventRepeatEndType.OnDate, value: 'On' }];

            this.timestamp = this.event.timestamp;
            this.repeating = !!this.event.repeat;
            this.previousRepeating = this.repeating;
            this.frequency = this.repeating ? this.event.repeat.frequency : 1;
            this.unit = this.repeating ? this.event.repeat.unit : this.eventUtil.EventRepeatUnit.Monthly;
            this.autoConfirm = this.repeating ? !!this.event.repeat.autoConfirm : false;
            this.endType = this.repeating ? this.event.repeat.end ? this.event.repeat.end.date ? this.eventUtil.EventRepeatEndType.OnDate : this.eventUtil.EventRepeatEndType.AfterOccurrence : this.eventUtil.EventRepeatEndType.Never : this.eventUtil.EventRepeatEndType.Never;
            this.endOccurrence = this.willEndAfterOccurrence ? this.event.repeat.end.occurrence : 4;
            this.endDate = this.willEndOnDate ? this.event.repeat.end.date : this.getEndDate(this.timestamp, this.frequency, this.unit, this.endOccurrence);
            this.repeatEndError = this.initialRepeatEndError || null;
            this.repeatStateWhenInvalid = this.getRepeatState();
        }
    }, {
        key: '$doCheck',
        value: function $doCheck() {
            if (this.previousRepeating && !this.repeating) {
                this.autoConfirm = false;
            }

            this.previousRepeating = this.repeating;

            if (this.repeatEndError && this.repeatStateWhenInvalid !== this.getRepeatState()) {
                this.repeatEndError = null;
                this.repeatStateWhenInvalid = this.getRepeatState();
            }
        }
    }, {
        key: 'getRepeatingUnitDetail',
        value: function getRepeatingUnitDetail(event) {
            var repeat = event.repeat || {};
            var timestamp = event.transactionDate || event.timestamp;

            switch (repeat.unit) {
                case this.eventUtil.EventRepeatUnit.Weekly:
                    return ' (on ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).format('dddd') + ')';
                case this.eventUtil.EventRepeatUnit.Monthly:
                    return ' (on the ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).format('Do') + ')';
                case this.eventUtil.EventRepeatUnit.Yearly:
                    return ' (on ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).format('MMMM') + ' the ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).format('Do') + ')';
            }

            return '';
        }
    }, {
        key: 'getDefaultEndOccurrence',
        value: function getDefaultEndOccurrence() {
            return 4;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate(timestamp, frequency, unit, endOccurrence) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).add(frequency * (endOccurrence - 1), unit).valueOf();
        }
    }, {
        key: 'getRepeatState',
        value: function getRepeatState() {
            return [this.repeating, this.frequency, this.unit, this.endType, this.endOccurrence, this.endDate].join('|');
        }
    }, {
        key: 'getRepeatEnd',
        value: function getRepeatEnd() {
            if (!this.willEnd) {
                return null;
            }

            return this.willEndOnDate ? { date: this.endDate } : { occurrence: this.endOccurrence };
        }
    }, {
        key: 'validateRepeat',
        value: function validateRepeat() {
            var frequency = Number(this.frequency);
            var isValid = !this.repeating || isSafeInteger(frequency) && frequency >= 1 && frequency <= MAX_BACKEND_INTEGER;

            if (isValid && this.willEndOnDate) {
                var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.endDate);
                isValid = endDate.isValid() && endDate.year() >= 1 && endDate.year() <= MAX_REPEAT_YEAR;
            }

            if (isValid && this.willEndAfterOccurrence) {
                var occurrence = Number(this.endOccurrence);
                var intervals = frequency * (occurrence - 1);
                var finalOccurrence = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.timestamp).add(intervals, this.unit);

                isValid = isSafeInteger(occurrence) && occurrence >= 1 && occurrence <= MAX_BACKEND_INTEGER && isSafeInteger(intervals) && intervals <= MAX_BACKEND_INTEGER && finalOccurrence.isValid() && finalOccurrence.year() >= 1 && finalOccurrence.year() <= MAX_REPEAT_YEAR;
            }

            if (!isValid) {
                this.repeatEndError = REPEAT_END_TOO_FAR_MESSAGE;
                this.repeatStateWhenInvalid = this.getRepeatState();
            }

            return isValid;
        }
    }, {
        key: 'updateEvent',
        value: function updateEvent(event) {
            var updatedEvent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.merge({}, event, {
                timestamp: this.timestamp,
                transactionDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.timestamp).format('YYYY-MM-DD'),
                repeat: this.repeating ? {
                    frequency: this.frequency,
                    unit: this.unit,
                    autoConfirm: !!this.autoConfirm,
                    end: this.getRepeatEnd()
                } : null
            });

            if (updatedEvent.repeat) {
                updatedEvent.repeat.end = this.getRepeatEnd();
            }

            return updatedEvent;
        }
    }, {
        key: 'selectDate',
        value: function selectDate() {
            var _this = this;

            var endDate = this.willEndOnDate ? this.event.repeat.end.date : this.getEndDate(this.timestamp, this.frequency, this.unit, this.endOccurrence);

            return this.modalService.open({
                component: 'dbADateModal',
                bindings: {
                    title: 'Date',
                    startOfWeek: this.startOfWeek,
                    timestamp: this.timestamp,
                    onDayCheckDisabled: function onDayCheckDisabled(timestamp) {
                        return timestamp > endDate;
                    }
                }
            }).then(function (timestamp) {
                _this.timestamp = timestamp;
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'selectEndDate',
        value: function selectEndDate() {
            var _this2 = this;

            return this.modalService.open({
                component: 'dbADateModal',
                bindings: {
                    title: 'Repeat ends on',
                    startOfWeek: this.startOfWeek,
                    timestamp: this.endDate,
                    onDayCheckDisabled: function onDayCheckDisabled(timestamp) {
                        return timestamp < _this2.timestamp || __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).year() > MAX_REPEAT_YEAR;
                    }
                }
            }).then(function (timestamp) {
                _this2.endDate = timestamp;
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            return this.onDismiss();
        }
    }, {
        key: 'close',
        value: function close() {
            if (!this.validateRepeat()) {
                return null;
            }

            return this.onClose({
                data: this.updateEvent(this.event)
            });
        }
    }, {
        key: 'occurrencePluralized',
        get: function get() {
            return this.stringUtil.pluralize(this.endOccurrence, 'occurrence');
        }
    }, {
        key: 'willEnd',
        get: function get() {
            return this.repeating && this.endType !== this.eventUtil.EventRepeatEndType.Never;
        }
    }, {
        key: 'willEndAfterOccurrence',
        get: function get() {
            return this.repeating && this.endType === this.eventUtil.EventRepeatEndType.AfterOccurrence;
        }
    }, {
        key: 'willEndOnDate',
        get: function get() {
            return this.repeating && this.endType === this.eventUtil.EventRepeatEndType.OnDate;
        }
    }, {
        key: 'summary',
        get: function get() {
            var event = this.updateEvent(this.event);

            return ['' + this.eventUtil.getRepeatingFrequencySummary(event.repeat) + this.getRepeatingUnitDetail(event), this.eventUtil.getRepeatingEndSummary(event.repeat)].filter(function (summary) {
                return summary && summary.length > 0;
            }).join(', ');
        }
    }]);

    return EventDateController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEventDateModal',
    template: __WEBPACK_IMPORTED_MODULE_3__event_date_modal_tpl_pug___default()(),
    controller: EventDateController,
    bindings: {
        event: '<',
        startOfWeek: '<',
        canRepeat: '<',
        initialRepeatEndError: '<',

        canEdit: '<',

        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "0LRl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"event-receipt-modal":"event-receipt-modal","modal-fixed-height":"modal-fixed-height","modal-body":"modal-body","event-receipt-image-container":"event-receipt-image-container","event-receipt-image":"event-receipt-image"};

/***/ }),

/***/ "0O7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collaborator_invite_modal_cmpt__ = __webpack_require__("XDLl");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.collaborator-invite-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__collaborator_invite_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__collaborator_invite_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "0QVQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_25-0d439105b2ca3fa5.svg";

/***/ }),

/***/ "0Urw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_directive__ = __webpack_require__("mhet");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.match', []).directive(__WEBPACK_IMPORTED_MODULE_1__match_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__match_directive__["a" /* default */]));

/***/ }),

/***/ "0gJx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ "0jNc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"general-settings-page":"general-settings-page","form-group":"form-group","control-switch":"control-switch","control-switch-content":"control-switch-content","settings-disclosure-row":"settings-disclosure-row","settings-disclosure-copy":"settings-disclosure-copy","settings-disclosure-title":"settings-disclosure-title","settings-disclosure-subtitle":"settings-disclosure-subtitle"};

/***/ }),

/***/ "0nUR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"date-modal":"date-modal","modal-fixed-height":"modal-fixed-height","modal-body":"modal-body","date-container":"date-container"};

/***/ }),

/***/ "19SQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var elements = __webpack_require__("L5rj");
var helpers = __webpack_require__("iO9N");

defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});


module.exports = function(Chart) {

	Chart.controllers.bubble = Chart.DatasetController.extend({

		dataElementType: elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);

			var custom = point.custom || {};
			var dataset = me.getDataset();
			var data = dataset.data[index];
			var pointElementOptions = me.chart.options.elements.point;
			var dsIndex = me.index;

			helpers.extend(point, {
				// Utility
				_xScale: xScale,
				_yScale: yScale,
				_datasetIndex: dsIndex,
				_index: index,

				// Desired view properties
				_model: {
					x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex),
					y: reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex),
					// Appearance
					radius: reset ? 0 : custom.radius ? custom.radius : me.getRadius(data),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
				}
			});

			// Trick to reset the styles of the point
			Chart.DatasetController.prototype.removeHoverStyle.call(me, point, pointElementOptions);

			var model = point._model;
			model.skip = custom.skip ? custom.skip : (isNaN(model.x) || isNaN(model.y));

			point.pivot();
		},

		getRadius: function(value) {
			return value.r || this.chart.options.elements.point.radius;
		},

		setHoverStyle: function(point) {
			var me = this;
			Chart.DatasetController.prototype.setHoverStyle.call(me, point);

			// Radius
			var dataset = me.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;
			model.radius = custom.hoverRadius ? custom.hoverRadius : (helpers.valueAtIndexOrDefault(dataset.hoverRadius, index, me.chart.options.elements.point.hoverRadius)) + me.getRadius(dataset.data[index]);
		},

		removeHoverStyle: function(point) {
			var me = this;
			Chart.DatasetController.prototype.removeHoverStyle.call(me, point, me.chart.options.elements.point);

			var dataVal = me.chart.data.datasets[point._datasetIndex].data[point._index];
			var custom = point.custom || {};
			var model = point._model;

			model.radius = custom.radius ? custom.radius : me.getRadius(dataVal);
		}
	});
};


/***/ }),

/***/ "1BKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__team_service__ = __webpack_require__("nwX1");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.service.team', []).service('teamService', __WEBPACK_IMPORTED_MODULE_1__team_service__["a" /* default */]));

/***/ }),

/***/ "1CE5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"email-ingest-token-modal":"email-ingest-token-modal","modal-body":"modal-body","email-ingest-intro":"email-ingest-intro","email-ingest-intro-secondary":"email-ingest-intro-secondary","email-ingest-label":"email-ingest-label","email-ingest-content":"email-ingest-content","email-ingest-enable":"email-ingest-enable","email-ingest-token":"email-ingest-token","email-ingest-address":"email-ingest-address"};

/***/ }),

/***/ "1MfR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-header":"calendar-header","calendar-header-content":"calendar-header-content","button-open-team-management":"button-open-team-management","disabled":"disabled","calendar-header-context":"calendar-header-context","calendar-header-tool-container":"calendar-header-tool-container","calendar-header-navigation-container":"calendar-header-navigation-container","calendar-header-update-container":"calendar-header-update-container","calendar-name":"calendar-name","team-name":"team-name","change-log-container":"change-log-container","calendar-header-tool-items":"calendar-header-tool-items","calendar-header-navigation-items":"calendar-header-navigation-items","calendar-header-tool-item":"calendar-header-tool-item","calendar-header-navigation-item":"calendar-header-navigation-item","transaction-search-container":"transaction-search-container","transaction-search":"transaction-search","visible":"visible","button-open-dashboard":"button-open-dashboard","button-open-search":"button-open-search","current-date-picker":"current-date-picker","current-date":"current-date","button-select-previous-month":"button-select-previous-month","button-select-next-month":"button-select-next-month","button-select-today":"button-select-today","calendar-period-container":"calendar-period-container","calendar-period-content":"calendar-period-content","months-visible":"months-visible"};

/***/ }),

/***/ "1Nt4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("iO9N");
var Ticks = __webpack_require__("IbXy");

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',

		// label settings
		ticks: {
			callback: Ticks.formatters.logarithmic
		}
	};

	var LogarithmicScale = Chart.Scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var valueOrDefault = helpers.valueOrDefault;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						helpers.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							values[index] = values[index] || 0;

							if (opts.relativePoints) {
								values[index] = 100;
							} else {
								// Don't need to split positive and negative since the log scale can't handle a 0 crossing
								values[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var minVal = helpers.min(valuesForType);
					var maxVal = helpers.max(valuesForType);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}

							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}

			me.min = valueOrDefault(tickOpts.min, me.min);
			me.max = valueOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
				} else {
					me.min = 1;
					me.max = 10;
				}
			}
		},
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			var generationOptions = {
				min: tickOpts.min,
				max: tickOpts.max
			};
			var ticks = me.ticks = Ticks.generators.logarithmic(generationOptions, me);

			if (!me.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				ticks.reverse();
			}

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();

			Chart.Scale.prototype.convertTicksToLabels.call(this);
		},
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},
		getPixelForValue: function(value) {
			var me = this;
			var start = me.start;
			var newVal = +me.getRightValue(value);
			var opts = me.options;
			var tickOpts = opts.ticks;
			var innerDimension, pixel, range;

			if (me.isHorizontal()) {
				range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
				if (newVal === 0) {
					pixel = me.left;
				} else {
					innerDimension = me.width;
					pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
				}
			} else {
				// Bottom - top since pixels increase downward on a screen
				innerDimension = me.height;
				if (start === 0 && !tickOpts.reverse) {
					range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
					if (newVal === start) {
						pixel = me.bottom;
					} else if (newVal === me.minNotZero) {
						pixel = me.bottom - innerDimension * 0.02;
					} else {
						pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
					}
				} else if (me.end === 0 && tickOpts.reverse) {
					range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
					if (newVal === me.end) {
						pixel = me.top;
					} else if (newVal === me.minNotZero) {
						pixel = me.top + innerDimension * 0.02;
					} else {
						pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
					}
				} else if (newVal === 0) {
					pixel = tickOpts.reverse ? me.top : me.bottom;
				} else {
					range = helpers.log10(me.end) - helpers.log10(start);
					innerDimension = me.height;
					pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
				}
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var range = helpers.log10(me.end) - helpers.log10(me.start);
			var value, innerDimension;

			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
			} else { // todo: if start === 0
				innerDimension = me.height;
				value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
			}
			return value;
		}
	});
	Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);

};


/***/ }),

/***/ "1bfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_repeat_delete_modal_style_sass__ = __webpack_require__("xARd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_repeat_delete_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__event_repeat_delete_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_repeat_delete_modal_tpl_pug__ = __webpack_require__("MZx8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_repeat_delete_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__event_repeat_delete_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var EventRepeatDeleteModalController = function () {
    EventRepeatDeleteModalController.$inject = ['eventUtil'];

    /* @ngInject */
    function EventRepeatDeleteModalController(eventUtil) {
        _classCallCheck(this, EventRepeatDeleteModalController);

        this.eventUtil = eventUtil;

        this.onlyThisValue = this.eventUtil.EventRepeatSelector.OnlyThis;
        this.thisAndAllFollowingValue = this.eventUtil.EventRepeatSelector.ThisAndAllFollowing;

        this.selectOnlyThis();
    }

    _createClass(EventRepeatDeleteModalController, [{
        key: 'selectOnlyThis',
        value: function selectOnlyThis() {
            this.selector = this.onlyThisValue;
        }
    }, {
        key: 'selectThisAndAllFollowing',
        value: function selectThisAndAllFollowing() {
            this.selector = this.thisAndAllFollowingValue;
        }
    }, {
        key: 'confirm',
        value: function confirm() {
            return this.onClose({
                data: this.selector
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            return this.onDismiss();
        }
    }, {
        key: 'isOnlyThisSelected',
        get: function get() {
            return this.selector === this.onlyThisValue;
        }
    }]);

    return EventRepeatDeleteModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEventRepeatDeleteModal',
    template: __WEBPACK_IMPORTED_MODULE_1__event_repeat_delete_modal_tpl_pug___default()(),
    controller: EventRepeatDeleteModalController,
    bindings: {
        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "1p0f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Books-e19c19b233b61088.svg";

/***/ }),

/***/ "21GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = OnFocusDirective;
var selector = 'dbAOnFocus';

/* @ngInject */
function OnFocusDirective() {
    return {
        restrict: 'A',

        link: function link(scope, element, attrs) {
            element.on('focusin', focusHandler);
            scope.$on('$destroy', function () {
                return element.off('focusin', focusHandler);
            });

            function focusHandler() {
                scope.$applyAsync(function () {
                    return scope.$eval(attrs[selector]);
                });
            }
        }
    };
}

/***/ }),

/***/ "22Zj":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"income-expense-chart\"\u003E\u003Cdiv class=\"chart-container\"\u003E\u003Cdiv class=\"chart-error\" ng-bind=\"$ctrl.error\"\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-chart class=\"chart-content\" type=\"bar\" options=\"$ctrl.options\" data=\"$ctrl.data\" ng-class=\"{ visible: !$ctrl.loading }\" ng-if=\"!$ctrl.error\"\u003E\u003C\u002Fdb-a-chart\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "23tK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryUncategorized-56ff29275132b8e4.svg";

/***/ }),

/***/ "2C65":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-mailbox-7f9c957df6d7e0e4.svg";

/***/ }),

/***/ "2CaH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category":"category","category-color":"category-color","category-icon":"category-icon","category-name":"category-name","unknown":"unknown","disabled":"disabled","filled":"filled"};

/***/ }),

/***/ "2JtO":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cspan ng-bind=\"$ctrl.normalizedValue\" ng-attr-title=\"{{ $ctrl.formattedValue }}\"\u003E\u003C\u002Fspan\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "2Lxh":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"team-edit-modal modal-fixed-height\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.save()\"\u003E\u003Cdiv class=\"modal-header modal-section modal-delimiter\"\u003E\u003Cdiv class=\"modal-title\"\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ENew calendar group\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ECalendar group details\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter modal-body-scrollable\"\u003E\u003Cdiv class=\"calendar-name modal-section\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"text\" id=\"team-name\" name=\"name\" placeholder=\"e.g. My family\" ng-model=\"$ctrl.team.name\" ng-change=\"$ctrl.updateName()\" db-a-autofocus=\"!$ctrl.existing\" ng-readonly=\"!$ctrl.canEdit\" required\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"team-name\"\u003EName\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"team-name\"\u003E\u003Cdb-a-validation-message key=\"error\" ng-bind=\"$ctrl.error\"\u003E\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in the calendar group name.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"link link-manage-categories modal-section modal-delimiter\" type=\"button\" ng-show=\"$ctrl.existing &amp;&amp; $ctrl.canManageCategories\" ng-click=\"$ctrl.manageCategories()\"\u003EManage categories\u003C\u002Fbutton\u003E\u003Cdiv class=\"transactions-by-email modal-section modal-delimiter\" ng-show=\"$ctrl.existing &amp;&amp; $ctrl.canEdit\"\u003E\u003Cdiv class=\"transactions-by-email-title\"\u003ETRANSACTIONS BY EMAIL\u003C\u002Fdiv\u003E\u003Cbutton class=\"link link-transactions-by-email\" type=\"button\" ng-click=\"$ctrl.manageTransactionsByEmail()\"\u003E\u003Cspan\u003EManage private email address\u003C\u002Fspan\u003E\u003Ci class=\"icon icon-dollarbird-chevron-right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collaborators\"\u003E\u003Cdiv class=\"collaborators-heading modal-section\" ng-if=\"!$ctrl.canManageCollaboratorsIfUpgrade\"\u003E\u003Cdiv class=\"collaborators-title\"\u003EShared with\u003C\u002Fdiv\u003E\u003Cbutton class=\"button-link link-manage-members\" type=\"button\" ng-click=\"$ctrl.manageCollaborators()\" ng-if=\"$ctrl.canManageCollaborators\"\u003EManage collaborators\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collaborators-content modal-section\" ng-if=\"!$ctrl.canManageCollaboratorsIfUpgrade\"\u003E\u003Cdiv class=\"collaborator-item\" ng-repeat=\"member in $ctrl.members track by $index\" ng-class=\"{ invited: member.invited, disabled: !member.canEdit }\" ng-click=\"$ctrl.toggleShare(member)\"\u003E\u003Cdb-a-user-image class=\"collaborator-image\" name=\"member.name\" email=\"member.email\" color=\"member.profileImage.color\" url=\"member.profileImage.url\"\u003E\u003C\u002Fdb-a-user-image\u003E\u003Cdiv class=\"collaborator-info\"\u003E\u003Cdiv class=\"collaborator-name\" ng-bind=\"member.name\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collaborator-email\" ng-bind=\"member.email\" ng-class=\"{ highlighted: !member.name }\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collaborator-role\"\u003E\u003Cdiv class=\"collaborator-owner\" ng-if=\"member.owner\"\u003EOwner\u003C\u002Fdiv\u003E\u003Cdiv class=\"collaborator-me\" ng-if=\"$ctrl.isCurrentUser(member)\"\u003EMe\u003C\u002Fdiv\u003E\u003Cdb-a-checkmark class=\"collaborator-share\" ng-if=\"!member.owner\" ng-model=\"member.shared\"\u003E\u003C\u002Fdb-a-checkmark\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state\" ng-if=\"$ctrl.canManageCollaboratorsIfUpgrade\"\u003E\u003Cdiv class=\"empty-state-content\"\u003E\u003Cimg" + (" class=\"empty-state-image\""+pug.attr("src", __webpack_require__("WdxZ"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003Cdiv class=\"empty-state-title\"\u003ECollaborate on your expenses\u003C\u002Fdiv\u003E\u003Ca class=\"link link-subscribe\" href=\"javascript:void(0);\" ui-sref=\"authorized.subscribe\"\u003E\u003Cspan ng-if=\"!$ctrl.plan.paid\"\u003EGo Premium\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.plan.paid\"\u003EUpgrade your account\u003C\u002Fspan\u003E\u003Cspan\u003E to invite people\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-danger button-remove button-modal-left button-remove-team\" type=\"button\" ng-if=\"$ctrl.existing &amp;&amp; $ctrl.canDelete\" ng-click=\"$ctrl.remove()\"\u003E\u003Ci class=\"icon-delete icon-dollarbird-delete\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-link button-danger button-modal-left button-leave-team\" type=\"button\" ng-if=\"$ctrl.existing &amp;&amp; !$ctrl.canDelete\" ng-click=\"$ctrl.leave()\"\u003ELeave calendar group\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-save-calendar\" type=\"submit\" db-a-async loading=\"form.$submitting\" ng-if=\"$ctrl.canEdit\"\u003E\u003Cinitial\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ECreate\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ESave\u003C\u002Fspan\u003E\u003C\u002Finitial\u003E\u003Cloading\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ECreating...\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ESaving...\u003C\u002Fspan\u003E\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "2Pgy":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"modals\" ng-class=\"{ visible: $ctrl.modals.length &gt; 0 }\"\u003E\u003Cdiv class=\"modal-backdrop\" ng-click=\"$ctrl.dismissOnBackdrop()\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-item-container\" ng-repeat=\"modal in $ctrl.modals track by $index\" ng-show=\"$index === $ctrl.modals.length - 1\"\u003E\u003Cdiv class=\"modal-item\" db-a-compile-component=\"modal.component\" bindings=\"modal.bindings\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "2V0L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_radio_cmpt__ = __webpack_require__("FtNY");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.calendar-radio', []).component(__WEBPACK_IMPORTED_MODULE_1__calendar_radio_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__calendar_radio_cmpt__["a" /* default */]));

/***/ }),

/***/ "2YoO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_style_sass__ = __webpack_require__("O5d7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__identity_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_tpl_pug__ = __webpack_require__("C67W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__identity_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAIdentity',
    template: __WEBPACK_IMPORTED_MODULE_1__identity_tpl_pug___default()()
});

/***/ }),

/***/ "2Z8G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ddL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var elements = __webpack_require__("L5rj");
var helpers = __webpack_require__("iO9N");

defaults._set('radar', {
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			tension: 0 // no bezier in radar
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.radar = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data;
			var custom = line.custom || {};
			var dataset = me.getDataset();
			var lineElementOptions = me.chart.options.elements.line;
			var scale = me.chart.scale;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			helpers.extend(meta.dataset, {
				// Utility
				_datasetIndex: me.index,
				_scale: scale,
				// Data
				_children: points,
				_loop: true,
				// Model
				_model: {
					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
				}
			});

			meta.dataset.pivot();

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			}, me);

			// Update bezier control points
			me.updateBezierControlPoints();
		},
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointElementOptions = me.chart.options.elements.point;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			helpers.extend(point, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
					y: reset ? scale.yCenter : pointPosition.y,

					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
					radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
					pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
				}
			});

			point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
		},
		updateBezierControlPoints: function() {
			var chartArea = this.chart.chartArea;
			var meta = this.getMeta();

			helpers.each(meta.data, function(point, index) {
				var model = point._model;
				var controlPoints = helpers.splineCurve(
					helpers.previousItem(meta.data, index, true)._model,
					model,
					helpers.nextItem(meta.data, index, true)._model,
					model.tension
				);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
				model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

				model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
				model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

				// Now pivot the point for animation
				point.pivot();
			});
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;

			model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;
			var pointElementOptions = this.chart.options.elements.point;

			model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
		}
	});
};


/***/ }),

/***/ "2xI1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("iO9N");

// By default, select the browser (DOM) platform.
// @TODO Make possible to select another platform at build time.
var implementation = __webpack_require__("DN1M");

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
module.exports = helpers.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {Object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {Boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {String} type - The ({@link IEvent}) type to listen for
	 * @param {Function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart -Chart from which to remove the listener
	 * @param {String} type - The ({@link IEvent}) type to remove
	 * @param {Function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

/**
 * @interface IPlatform
 * Allows abstracting platform dependencies away from the chart
 * @borrows Chart.platform.acquireContext as acquireContext
 * @borrows Chart.platform.releaseContext as releaseContext
 * @borrows Chart.platform.addEventListener as addEventListener
 * @borrows Chart.platform.removeEventListener as removeEventListener
 */

/**
 * @interface IEvent
 * @prop {String} type - The event type name, possible values are:
 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
 */


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("PEX0");


/***/ }),

/***/ "313L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_palette_cmpt__ = __webpack_require__("CwXX");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.category-edit-modal.component.color-palette', []).component(__WEBPACK_IMPORTED_MODULE_1__color_palette_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__color_palette_cmpt__["a" /* default */]));

/***/ }),

/***/ "31Zn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sortBy__ = __webpack_require__("KBYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SuggestionService = function () {
    /* @ngInject */
    function SuggestionService() {
        _classCallCheck(this, SuggestionService);

        this.reset();
    }

    _createClass(SuggestionService, [{
        key: 'reset',
        value: function reset() {
            this.terms = {};
        }
    }, {
        key: 'initialize',
        value: function initialize(teamId, terms) {
            this.terms[teamId] = this.filterTerms(terms || []);
        }
    }, {
        key: 'add',
        value: function add(teamId, term) {
            this.terms[teamId] = this.filterTerms(__WEBPACK_IMPORTED_MODULE_0_lodash_concat___default()(this.terms[teamId] || [], [term]));
        }
    }, {
        key: 'filterTerms',
        value: function filterTerms(terms) {
            return __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_sortBy___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(terms || [], function (term) {
                return term && term.length > 0;
            }), function (term) {
                return term.trim();
            }), function (term) {
                return term.toLowerCase();
            }));
        }
    }, {
        key: 'get',
        value: function get(teamId, term) {
            return term && term.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.terms[teamId] || [], function (note) {
                return note && note.toLowerCase().indexOf(term.toLowerCase()) === 0;
            }) : null;
        }
    }, {
        key: 'getMissingPart',
        value: function getMissingPart(teamId, term) {
            var note = this.get(teamId, term);
            return note ? note.substr(term.length, note.length - term.length) : null;
        }
    }]);

    return SuggestionService;
}();

/* harmony default export */ __webpack_exports__["a"] = (SuggestionService);

/***/ }),

/***/ "37nS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__option_select_cmpt__ = __webpack_require__("AuYI");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.option-select', []).component(__WEBPACK_IMPORTED_MODULE_1__option_select_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__option_select_cmpt__["a" /* default */]));

/***/ }),

/***/ "38wx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Abr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PreferencesService = function () {
    PreferencesService.$inject = ["apiService"];

    /* @ngInject */
    function PreferencesService(apiService) {
        _classCallCheck(this, PreferencesService);

        this.apiService = apiService;
    }

    _createClass(PreferencesService, [{
        key: "get",
        value: function get() {
            return this.apiService.get("/users/me/preferences").then(function (result) {
                return result.data;
            });
        }
    }, {
        key: "save",
        value: function save(preferences) {
            return this.apiService.put("/users/me/preferences", preferences).then(function (result) {
                return result.data;
            });
        }
    }]);

    return PreferencesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PreferencesService);

/***/ }),

/***/ "3GN1":
/***/ (function(module, exports) {

(function(angular) {
    'use strict';

    function isDnDsSupported() {
        return 'ondrag' in document.createElement('a');
    }

    function determineEffectAllowed(e) {
        if(e.originalEvent) {
          e.dataTransfer = e.originalEvent.dataTransfer;
        }

        // Chrome doesn't set dropEffect, so we have to work it out ourselves
        if (typeof e.dataTransfer !== 'undefined' && e.dataTransfer.dropEffect === 'none') {
            if (e.dataTransfer.effectAllowed === 'copy' ||
                e.dataTransfer.effectAllowed === 'move') {
                e.dataTransfer.dropEffect = e.dataTransfer.effectAllowed;
            } else if (e.dataTransfer.effectAllowed === 'copyMove' || e.dataTransfer.effectAllowed === 'copymove') {
                e.dataTransfer.dropEffect = e.ctrlKey ? 'copy' : 'move';
            }
        }
    }

    if (!isDnDsSupported()) {
        angular.module('ang-drag-drop', []);
        return;
    }

    var module = angular.module('ang-drag-drop', []);

    module.directive('uiDraggable', ['$parse', '$rootScope', '$dragImage', function($parse, $rootScope, $dragImage) {
        return function(scope, element, attrs) {
            var isDragHandleUsed = false,
                dragHandleClass,
                draggingClass = attrs.draggingClass || 'on-dragging',
                dragTarget;

            element.attr('draggable', false);

            scope.$watch(attrs.uiDraggable, function(newValue) {
                if (newValue) {
                    element.attr('draggable', newValue);
                    element.bind('dragend', dragendHandler);
                    element.bind('dragstart', dragstartHandler);
                }
                else {
                    element.removeAttr('draggable');
                    element.unbind('dragend', dragendHandler);
                    element.unbind('dragstart', dragstartHandler);
                }

            });

            if (angular.isString(attrs.dragHandleClass)) {
                isDragHandleUsed = true;
                dragHandleClass = attrs.dragHandleClass.trim() || 'drag-handle';

                element.bind('mousedown', function(e) {
                    dragTarget = e.target;
                });
            }

            function dragendHandler(e) {
                if(e.originalEvent) {
                  e.dataTransfer = e.originalEvent.dataTransfer;
                }

                setTimeout(function() {
                    element.unbind('$destroy', dragendHandler);
                }, 0);
                var sendChannel = attrs.dragChannel || 'defaultchannel';
                $rootScope.$broadcast('ANGULAR_DRAG_END', e, sendChannel);

                determineEffectAllowed(e);

                if (e.dataTransfer && e.dataTransfer.dropEffect !== 'none') {
                    if (attrs.onDropSuccess) {
                        var onDropSuccessFn = $parse(attrs.onDropSuccess);
                        scope.$evalAsync(function() {
                            onDropSuccessFn(scope, {$event: e});
                        });
                    }
                }else if (e.dataTransfer && e.dataTransfer.dropEffect === 'none'){
                    if (attrs.onDropFailure) {
                        var onDropFailureFn = $parse(attrs.onDropFailure);
                        scope.$evalAsync(function() {
                            onDropFailureFn(scope, {$event: e});
                        });
                    }
                }
                element.removeClass(draggingClass);
            }

            function setDragElement(e, dragImageElementId) {
                var dragImageElementFn;

                if(e.originalEvent) {
                  e.dataTransfer = e.originalEvent.dataTransfer;
                }

                dragImageElementFn = $parse(dragImageElementId);

                scope.$apply(function() {
                    var elementId = dragImageElementFn(scope, {$event: e}),
                        dragElement;

                    if (!(elementId && angular.isString(elementId))) {
                        return;
                    }

                    dragElement = document.getElementById(elementId);

                    if (!dragElement) {
                        return;
                    }

                    e.dataTransfer.setDragImage(dragElement, 0, 0);
                });
            }

            function dragstartHandler(e) {
                if(e.originalEvent) {
                  e.dataTransfer = e.originalEvent.dataTransfer;
                }

                var isDragAllowed = !isDragHandleUsed || dragTarget.classList.contains(dragHandleClass);

                if (isDragAllowed) {
                    var sendChannel = attrs.dragChannel || 'defaultchannel';
                    var dragData = '';
                    if (attrs.drag) {
                        dragData = scope.$eval(attrs.drag);
                    }

                    var dragImage = attrs.dragImage || null;

                    element.addClass(draggingClass);
                    element.bind('$destroy', dragendHandler);

                    //Code to make sure that the setDragImage is available. IE 10, 11, and Opera do not support setDragImage.
                    var hasNativeDraggable = !(document.uniqueID || window.opera);

                    //If there is a draggable image passed in, then set the image to be dragged.
                    if (dragImage && hasNativeDraggable) {
                        var dragImageFn = $parse(attrs.dragImage);
                        scope.$apply(function() {
                            var dragImageParameters = dragImageFn(scope, {$event: e});
                            if (dragImageParameters) {
                                if (angular.isString(dragImageParameters)) {
                                    dragImageParameters = $dragImage.generate(dragImageParameters);
                                }
                                if (dragImageParameters.image) {
                                    var xOffset = dragImageParameters.xOffset || 0,
                                        yOffset = dragImageParameters.yOffset || 0;
                                    e.dataTransfer.setDragImage(dragImageParameters.image, xOffset, yOffset);
                                }
                            }
                        });
                    } else if (attrs.dragImageElementId) {
                        setDragElement(e, attrs.dragImageElementId);
                    }

                    var offset = {x: e.offsetX, y: e.offsetY};
                    var transferDataObject = {data: dragData, channel: sendChannel, offset: offset};
                    var transferDataText = angular.toJson(transferDataObject);

                    e.dataTransfer.setData('text', transferDataText);
                    e.dataTransfer.effectAllowed = 'copyMove';

                    $rootScope.$broadcast('ANGULAR_DRAG_START', e, sendChannel, transferDataObject);
                }
                else {
                    e.preventDefault();
                }
            }
        };
    }
    ]);

    module.directive('uiOnDrop', ['$parse', '$rootScope', function($parse, $rootScope) {
        return function(scope, element, attr) {
            var dragging = 0; //Ref. http://stackoverflow.com/a/10906204
            var dropChannel = attr.dropChannel || 'defaultchannel';
            var dragChannel = '';
            var dragEnterClass = attr.dragEnterClass || 'on-drag-enter';
            var dragHoverClass = attr.dragHoverClass || 'on-drag-hover';
            var customDragEnterEvent = $parse(attr.onDragEnter);
            var customDragLeaveEvent = $parse(attr.onDragLeave);

            function calculateDropOffset(e) {
                var offset = {
                    x: e.offsetX,
                    y: e.offsetY
                };
                var target = e.target;

                while (target !== element[0]) {
                    offset.x = offset.x + target.offsetLeft;
                    offset.y = offset.y + target.offsetTop;

                    target = target.offsetParent;
                    if (!target) {
                        return null;
                    }
                }

                return offset;
            }

            function onDragOver(e) {
                if (e.preventDefault) {
                    e.preventDefault(); // Necessary. Allows us to drop.
                }

                if (e.stopPropagation) {
                    e.stopPropagation();
                }

                var uiOnDragOverFn = $parse(attr.uiOnDragOver);
                scope.$evalAsync(function() {
                    uiOnDragOverFn(scope, {$event: e, $channel: dropChannel});
                });

                return false;
            }

            function onDragLeave(e) {
                if (e.preventDefault) {
                    e.preventDefault();
                }

                if (e.stopPropagation) {
                    e.stopPropagation();
                }
                dragging--;

                if (dragging === 0) {
                    scope.$evalAsync(function() {
                        customDragLeaveEvent(scope, {$event: e, $channel: dropChannel});
                    });
                    element.addClass(dragEnterClass);
                    element.removeClass(dragHoverClass);
                }

                var uiOnDragLeaveFn = $parse(attr.uiOnDragLeave);
                scope.$evalAsync(function() {
                    uiOnDragLeaveFn(scope, {$event: e, $channel: dropChannel});
                });
            }

            function onDragEnter(e) {
                if (e.preventDefault) {
                    e.preventDefault();
                }

                if (e.stopPropagation) {
                    e.stopPropagation();
                }

                if (dragging === 0) {
                    scope.$evalAsync(function() {
                        customDragEnterEvent(scope, {$event: e, $channel: dropChannel});
                    });
                    element.removeClass(dragEnterClass);
                    element.addClass(dragHoverClass);
                }
                dragging++;

                var uiOnDragEnterFn = $parse(attr.uiOnDragEnter);
                scope.$evalAsync(function() {
                    uiOnDragEnterFn(scope, {$event: e, $channel: dropChannel});
                });

                $rootScope.$broadcast('ANGULAR_HOVER', dragChannel);
            }

            function onDrop(e) {
                if(e.originalEvent) {
                  e.dataTransfer = e.originalEvent.dataTransfer;
                }

                if (e.preventDefault) {
                    e.preventDefault(); // Necessary. Allows us to drop.
                }
                if (e.stopPropagation) {
                    e.stopPropagation(); // Necessary. Allows us to drop.
                }

                var sendData = e.dataTransfer.getData('text');
                sendData = angular.fromJson(sendData);

                var dropOffset = calculateDropOffset(e);
                
                var position = dropOffset ? {
                    x: dropOffset.x - sendData.offset.x,
                    y: dropOffset.y - sendData.offset.y
                } : null;
                
                determineEffectAllowed(e);

                var uiOnDropFn = $parse(attr.uiOnDrop);
                scope.$evalAsync(function() {
                    uiOnDropFn(scope, {$data: sendData.data, $event: e, $channel: sendData.channel, $position: position});
                });
                element.removeClass(dragEnterClass);
                dragging = 0;
            }
            
            function isDragChannelAccepted(dragChannel, dropChannel) {
                if (dropChannel === '*') {
                    return true;
                }

                var channelMatchPattern = new RegExp('(\\s|[,])+(' + dragChannel + ')(\\s|[,])+', 'i');

                return channelMatchPattern.test(',' + dropChannel + ',');
            }

            function preventNativeDnD(e) {
                if(e.originalEvent) {
                  e.dataTransfer = e.originalEvent.dataTransfer;
                }

                if (e.preventDefault) {
                    e.preventDefault();
                }
                if (e.stopPropagation) {
                    e.stopPropagation();
                }
                e.dataTransfer.dropEffect = 'none';
                return false;
            }

            var deregisterDragStart = $rootScope.$on('ANGULAR_DRAG_START', function(_, e, channel, transferDataObject) {
                dragChannel = channel;

                var valid = true;

                if (!isDragChannelAccepted(channel, dropChannel)) {
                    valid = false;
                }

                if (valid && attr.dropValidate) {
                    var validateFn = $parse(attr.dropValidate);
                    valid = validateFn(scope, {
                        $drop: {scope: scope, element: element},
                        $event: e,
                        $data: transferDataObject.data,
                        $channel: transferDataObject.channel
                    });
                }

                if (valid) {
                    element.bind('dragover', onDragOver);
                    element.bind('dragenter', onDragEnter);
                    element.bind('dragleave', onDragLeave);
                    element.bind('drop', onDrop);

                    element.addClass(dragEnterClass);
                } else {
                    element.bind('dragover', preventNativeDnD);
                    element.bind('dragenter', preventNativeDnD);
                    element.bind('dragleave', preventNativeDnD);
                    element.bind('drop', preventNativeDnD);

                    element.removeClass(dragEnterClass);
                }

            });


            var deregisterDragEnd = $rootScope.$on('ANGULAR_DRAG_END', function() {
                element.unbind('dragover', onDragOver);
                element.unbind('dragenter', onDragEnter);
                element.unbind('dragleave', onDragLeave);

                element.unbind('drop', onDrop);
                element.removeClass(dragHoverClass);
                element.removeClass(dragEnterClass);

                element.unbind('dragover', preventNativeDnD);
                element.unbind('dragenter', preventNativeDnD);
                element.unbind('dragleave', preventNativeDnD);
                element.unbind('drop', preventNativeDnD);
            });

            scope.$on('$destroy', function() {
                deregisterDragStart();
                deregisterDragEnd();
            });


            attr.$observe('dropChannel', function(value) {
                if (value) {
                    dropChannel = value;
                }
            });


        };
    }
    ]);

    module.constant('$dragImageConfig', {
        height: 20,
        width: 200,
        padding: 10,
        font: 'bold 11px Arial',
        fontColor: '#eee8d5',
        backgroundColor: '#93a1a1',
        xOffset: 0,
        yOffset: 0
    });

    module.service('$dragImage', ['$dragImageConfig', function(defaultConfig) {
        var ELLIPSIS = '…';

        function fitString(canvas, text, config) {
            var width = canvas.measureText(text).width;
            if (width < config.width) {
                return text;
            }
            while (width + config.padding > config.width) {
                text = text.substring(0, text.length - 1);
                width = canvas.measureText(text + ELLIPSIS).width;
            }
            return text + ELLIPSIS;
        }

        this.generate = function(text, options) {
            var config = angular.extend({}, defaultConfig, options || {});
            var el = document.createElement('canvas');

            el.height = config.height;
            el.width = config.width;

            var canvas = el.getContext('2d');

            canvas.fillStyle = config.backgroundColor;
            canvas.fillRect(0, 0, config.width, config.height);
            canvas.font = config.font;
            canvas.fillStyle = config.fontColor;

            var title = fitString(canvas, text, config);
            canvas.fillText(title, 4, config.padding + 4);

            var image = new Image();
            image.src = el.toDataURL();

            return {
                image: image,
                xOffset: config.xOffset,
                yOffset: config.yOffset
            };
        };
    }
    ]);

}(angular));


/***/ }),

/***/ "3Mt+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-no-team-eac2cb6788041a58.svg";

/***/ }),

/***/ "3PSo":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"icon-palette\"\u003E\u003Cbutton class=\"palette-page-control palette-page-control-up\" type=\"button\" ng-click=\"$ctrl.goPreviousPage()\" ng-disabled=\"$ctrl.page &lt;= 0\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-up\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"palette-grid\"\u003E\u003Cdiv class=\"grid-item-container\" ng-repeat=\"icon in $ctrl.visibleIcons track by icon.iconIndex\"\u003E\u003Cdiv class=\"grid-item\"\u003E\u003Cbutton class=\"palette-item\" type=\"button\" ng-class=\"{ selected: icon.selected, disabled: $ctrl.disabled }\" ng-style=\"{ backgroundColor: $ctrl.iconColor || '#394852' }\" ng-click=\"$ctrl.select(icon)\"\u003E\u003Cdb-a-category-icon class=\"palette-item-icon\" icon-name=\"icon.iconName\" icon-index=\"icon.iconIndex\" color=\"$ctrl.iconForegroundColor\" size=\"20\"\u003E\u003C\u002Fdb-a-category-icon\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"palette-page-control palette-page-control-down\" type=\"button\" ng-click=\"$ctrl.goNextPage()\" ng-disabled=\"$ctrl.page &gt;= $ctrl.pageCount - 1\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-down\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "3jOQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Property-1-Piggy-Bank-d30fcf57f1c08915.svg";

/***/ }),

/***/ "3n1n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {Number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @function
	 */
	isArray: Array.isArray ? Array.isArray : function(value) {
		return Object.prototype.toString.call(value) === '[object Array]';
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {Number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {Function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {Object|Array} loopable - The object or array to be iterated.
	 * @param {Function} fn - The function to call for each item.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see http://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {Boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @param {Object} [options] - Merging options:
	 * @param {Function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {Object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @returns {Object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	}
};

module.exports = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ }),

/***/ "3p9A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sign-in-page":"sign-in-page","forgot-password":"forgot-password","sign-in-diagnostics":"sign-in-diagnostics","sign-in-diagnostics-loader":"sign-in-diagnostics-loader","visible":"visible","pulse-indicator":"pulse-indicator"};

/***/ }),

/***/ "3yLT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_token_expired_cmpt__ = __webpack_require__("4xhO");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.forgot-password-token-expired', []).component(__WEBPACK_IMPORTED_MODULE_1__forgot_password_token_expired_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__forgot_password_token_expired_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.forgot-password.token-expired', {
        url: '/reset',
        template: '<db-a-forgot-password-token-expired class="block-component"></db-a-forgot-password-token-expired>'
    });
}

/***/ }),

/***/ "3yzE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-period":"calendar-period","loading":"loading","months-container":"months-container","period-content":"period-content","month-items":"month-items","month-item":"month-item","month-selection-container":"month-selection-container","month-selection":"month-selection"};

/***/ }),

/***/ "40fB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	// Default config for a category scale
	var defaultConfig = {
		position: 'bottom'
	};

	var DatasetScale = Chart.Scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},

		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;

			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}

			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}

			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},

		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var isHorizontal = me.isHorizontal();

			if (data.yLabels && !isHorizontal) {
				return me.getRightValue(data.datasets[datasetIndex].data[index]);
			}
			return me.ticks[index - me.minIndex];
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index) {
			var me = this;
			var offset = me.options.offset;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}

			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));

				if (offset) {
					widthOffset += (valueWidth / 2);
				}

				return me.left + Math.round(widthOffset);
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));

			if (offset) {
				heightOffset += (valueHeight / 2);
			}

			return me.top + Math.round(heightOffset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var value;
			var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;

			pixel -= horz ? me.left : me.top;

			if (offset) {
				pixel -= (valueDimension / 2);
			}

			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}

			return value + me.minIndex;
		},
		getBasePixel: function() {
			return this.bottom;
		}
	});

	Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);

};


/***/ }),

/***/ "4ONb":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"cash-flow-chart\"\u003E\u003Cdiv class=\"chart-flow-content\"\u003E\u003Cdb-a-selected-date-range class=\"chart-selected-period\" start=\"$ctrl.start\" end=\"$ctrl.end\"\u003E\u003C\u002Fdb-a-selected-date-range\u003E\u003Ctable class=\"chart-meta\"\u003E\u003Ctr\u003E\u003Cth class=\"meta-heading\"\u003EEarned\u003C\u002Fth\u003E\u003Cth class=\"meta-heading\"\u003ESpent\u003C\u002Fth\u003E\u003Cth class=\"meta-heading\"\u003EChange\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd class=\"meta-value\"\u003E\u003Cdb-a-pretty-number value=\"$ctrl.income\" prevent-shrink=\"true\" pretty=\"true\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"meta-value\"\u003E\u003Cdb-a-pretty-number value=\"$ctrl.expense\" prevent-shrink=\"true\" pretty=\"true\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"meta-value\"\u003E\u003Cdb-a-pretty-number value=\"$ctrl.change\" prevent-shrink=\"true\" pretty=\"true\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003Cdiv class=\"chart-container\"\u003E\u003Cdiv class=\"chart-error\" ng-bind=\"$ctrl.error\"\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-chart class=\"chart-content\" type=\"line\" options=\"$ctrl.options\" data=\"$ctrl.data\" ng-class=\"{ visible: !$ctrl.loading }\" ng-if=\"!$ctrl.error\"\u003E\u003C\u002Fdb-a-chart\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "4Uxm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");
var helpers = __webpack_require__("iO9N");

defaults._set('global', {
	plugins: {}
});

module.exports = function(Chart) {

	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	Chart.plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],

		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,

		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});

			this._cacheId++;
		},

		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});

			this._cacheId++;
		},

		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},

		/**
		 * Returns the number of registered plugins?
		 * @returns {Number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},

		/**
		 * Returns all registered plugin instances.
		 * @returns {Array} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},

		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Object} chart - The chart instance for which plugins should be called.
		 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {Boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;

			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}

			return true;
		},

		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {Array} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart._plugins || (chart._plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}

			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};

			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}

				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}

				if (opts === true) {
					opts = helpers.clone(defaults.global.plugins[id]);
				}

				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});

			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		}
	};

	/**
	 * Plugin extension hooks.
	 * @interface IPlugin
	 * @since 2.1.0
	 */
	/**
	 * @method IPlugin#beforeInit
	 * @desc Called before initializing `chart`.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterInit
	 * @desc Called after `chart` has been initialized and before the first update.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeUpdate
	 * @desc Called before updating `chart`. If any plugin returns `false`, the update
	 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart update.
	 */
	/**
	 * @method IPlugin#afterUpdate
	 * @desc Called after `chart` has been updated and before rendering. Note that this
	 * hook will not be called if the chart update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsUpdate
 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
	 * the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} false to cancel the datasets update.
	 * @since version 2.1.5
	 */
	/**
	 * @method IPlugin#afterDatasetsUpdate
	 * @desc Called after the `chart` datasets have been updated. Note that this hook
	 * will not be called if the datasets update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @since version 2.1.5
	 */
	/**
	 * @method IPlugin#beforeDatasetUpdate
 	 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
	 * returns `false`, the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetUpdate
 	 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
	 * that this hook will not be called if the datasets update has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeLayout
	 * @desc Called before laying out `chart`. If any plugin returns `false`,
	 * the layout update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart layout.
	 */
	/**
	 * @method IPlugin#afterLayout
	 * @desc Called after the `chart` has been layed out. Note that this hook will not
	 * be called if the layout update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeRender
	 * @desc Called before rendering `chart`. If any plugin returns `false`,
	 * the rendering is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart rendering.
	 */
	/**
	 * @method IPlugin#afterRender
	 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
	 * that this hook will not be called if the rendering has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDraw
	 * @desc Called before drawing `chart` at every animation frame specified by the given
	 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
	 * another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart drawing.
	 */
	/**
	 * @method IPlugin#afterDraw
	 * @desc Called after the `chart` has been drawn for the specific easing value. Note
	 * that this hook will not be called if the drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsDraw
 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
	 * the datasets drawing is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetsDraw
	 * @desc Called after the `chart` datasets have been drawn. Note that this hook
	 * will not be called if the datasets drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetDraw
 	 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
	 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
	 * is cancelled until another `render` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetDraw
 	 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
	 * (datasets are drawn in the reverse order). Note that this hook will not be called
	 * if the datasets drawing has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeEvent
 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
	 * the event will be discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterEvent
	 * @desc Called after the `event` has been consumed. Note that this hook
	 * will not be called if the `event` has been previously discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#resize
	 * @desc Called after the chart as been resized.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#destroy
	 * @desc Called after the chart as been destroyed.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */

	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.pluginService = Chart.plugins;

	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.PluginBase = Element.extend({});
};


/***/ }),

/***/ "4ZJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_join__ = __webpack_require__("ZZNS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_application_util_event_report_util__ = __webpack_require__("NLyG");



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var BalanceService = function () {
    BalanceService.$inject = ['$q', 'apiService'];

    /* @ngInject */
    function BalanceService($q, apiService) {
        _classCallCheck(this, BalanceService);

        this.$q = $q;
        this.apiService = apiService;
    }

    _createClass(BalanceService, [{
        key: 'getMonthlyBalances',
        value: function getMonthlyBalances(calendarIds, from, to) {
            return this.apiService.get('/calendars/overview', {
                params: {
                    from: from,
                    to: to,
                    calendars: __WEBPACK_IMPORTED_MODULE_1_lodash_join___default()(calendarIds, ',')
                }
            }).then(function (result) {
                return result.data || [];
            });
        }
    }, {
        key: 'getDailyBalances',
        value: function getDailyBalances(calendarIds, from, to) {
            return this.apiService.get('/calendars/days', {
                params: {
                    from: from,
                    to: to,
                    calendars: __WEBPACK_IMPORTED_MODULE_1_lodash_join___default()(calendarIds, ',')
                }
            }).then(function (result) {
                var data = result.data || {};
                return Object.assign({}, data, {
                    transactions: __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(data.transactions || [], function (event) {
                        return Object(__WEBPACK_IMPORTED_MODULE_2_application_util_event_report_util__["b" /* normalizeIncludeInReports */])(event);
                    })
                });
            });
        }
    }]);

    return BalanceService;
}();

/* harmony default export */ __webpack_exports__["a"] = (BalanceService);

/***/ }),

/***/ "4aOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_group_style_sass__ = __webpack_require__("bugh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_group_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__event_group_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_group_tpl_pug__ = __webpack_require__("M/VY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_group_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__event_group_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEventGroup',
    template: __WEBPACK_IMPORTED_MODULE_1__event_group_tpl_pug___default()(),
    bindings: {
        count: '<',
        note: '<',
        value: '<'
    }
});

/***/ }),

/***/ "4bMO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("842T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications_cmpt__ = __webpack_require__("IpXu");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.notifications', [__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_2__notifications_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__notifications_cmpt__["a" /* default */]));

/***/ }),

/***/ "4jcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_util_plan_util__ = __webpack_require__("vOfg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__team_edit_modal_style_sass__ = __webpack_require__("cJ7d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__team_edit_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__team_edit_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__team_edit_modal_tpl_pug__ = __webpack_require__("2Lxh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__team_edit_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__team_edit_modal_tpl_pug__);





var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










var TeamEditModalController = function () {
    TeamEditModalController.$inject = ['$q', 'sessionService', 'modalService', 'teamService', 'collaboratorService', 'notificationService'];

    /* @ngInject */
    function TeamEditModalController($q, sessionService, modalService, teamService, collaboratorService, notificationService) {
        _classCallCheck(this, TeamEditModalController);

        this.$q = $q;
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.teamService = teamService;
        this.collaboratorService = collaboratorService;
        this.notificationService = notificationService;
    }

    _createClass(TeamEditModalController, [{
        key: '$onInit',
        value: function $onInit() {
            this.existing = this.team && this.team.id;
            this.canDelete = this.existing && this.canDelete;

            this.load();
        }
    }, {
        key: 'load',
        value: function load() {
            var _this = this;

            this.loading = true;

            return this.$q.all([this.sessionService.initialize(), this.collaboratorService.getAll()]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    session = _ref2[0],
                    collaborators = _ref2[1];

                _this.plan = session.plan;

                var user = session.user;
                _this.currentUser = user;
                var maxMemberCount = Object(__WEBPACK_IMPORTED_MODULE_6_common_util_plan_util__["a" /* getMaxNumberOfCollaborators */])(_this.plan);
                var isOwner = !_this.team || !_this.team.owner || _this.team.owner.id === user.id;

                _this.canManageCollaboratorsIfUpgrade = isOwner && maxMemberCount === 0;

                if (_this.existing) {
                    return _this.loadMembers(user);
                }

                return _this.loadCollaborators(collaborators, user);
            }).catch(function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to retrieve your account collaborators.'));
            }).finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'isCurrentUser',
        value: function isCurrentUser(member) {
            if (!member || !this.currentUser) {
                return false;
            }

            if (this.currentUser.id && member.id) {
                return this.currentUser.id === member.id;
            }

            if (this.currentUser.email && member.email) {
                return this.currentUser.email === member.email;
            }

            return false;
        }
    }, {
        key: 'loadMembers',
        value: function loadMembers(user) {
            var _this2 = this;

            return this.teamService.getMembers(this.team.id).then(function (members) {
                _this2.updateMembers(__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(members, function (member) {
                    return __WEBPACK_IMPORTED_MODULE_4_angular___default.a.merge({}, member, {
                        canEdit: user.email !== member.email && !member.owner
                    });
                }));
            }).catch(function (result) {
                _this2.updateMembers([]);
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to retrieve the team members.'));
            });
        }
    }, {
        key: 'loadCollaborators',
        value: function loadCollaborators(collaborators, user) {
            collaborators = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(collaborators, function (collaborator) {
                return __WEBPACK_IMPORTED_MODULE_4_angular___default.a.merge({}, collaborator, {
                    shared: false,
                    owner: false,
                    canEdit: true
                });
            });

            var members = __WEBPACK_IMPORTED_MODULE_0_lodash_concat___default()([__WEBPACK_IMPORTED_MODULE_4_angular___default.a.merge({}, user, {
                shared: true,
                owner: true,
                canEdit: false
            })], collaborators);

            this.updateMembers(members);
        }
    }, {
        key: 'toggleShare',
        value: function toggleShare(member) {
            if (member.canEdit) {
                member.shared = !member.shared;
            }
        }
    }, {
        key: 'updateMembers',
        value: function updateMembers(members) {
            this.members = members;
            this.initialMembers = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(members, function (member) {
                return __WEBPACK_IMPORTED_MODULE_4_angular___default.a.merge({}, member);
            });
        }
    }, {
        key: 'manageCategories',
        value: function manageCategories() {
            return this.modalService.open({
                component: 'dbACategoryManageModal',
                bindings: {
                    teamId: this.team.id
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'manageTransactionsByEmail',
        value: function manageTransactionsByEmail() {
            return this.modalService.open({
                component: 'dbAEmailIngestTokenModal',
                bindings: {
                    teamId: this.team.id,
                    teamName: this.team.name
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this3 = this;

            var promise = this.existing ? this.teamService.update(this.team) : this.teamService.create(this.team);

            return promise.then(function (team) {
                var addedMembers = _this3.getAddedMembers();
                var removedMembers = _this3.getRemovedMembers();

                if (addedMembers.length > 0 || removedMembers.length > 0) {
                    return _this3.teamService.updateMembers(team.id, addedMembers, removedMembers).then(_this3.close.bind(_this3, team)).catch(function (result) {
                        return _this3.$q.reject(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["e" /* updateErrorMessage */])(result, 'We were not able to update the collaborators.'));
                    });
                }

                return _this3.close(team);
            }).catch(function (result) {
                _this3.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to save the team.'));
            });
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this4 = this;

            return this.modalService.open({
                component: 'dbAConfirmModal',
                bindings: {
                    title: 'Delete team',
                    message: ['Deleting a team cannot be undone. All the calendars and categories associated with this team will be erased.', 'Are you still sure about it?'],
                    onClose: function onClose() {
                        return _this4.teamService.remove(_this4.team).then(_this4.close.bind(_this4, _this4.team)).catch(function (result) {
                            _this4.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to delete the team.'));
                            return _this4.$q.reject(result);
                        });
                    }
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'leave',
        value: function leave() {
            var _this5 = this;

            return this.modalService.open({
                component: 'dbAConfirmModal',
                bindings: {
                    title: 'Leave team',
                    message: ['You are about to leave this team. If you change your mind later on, you have to contact the team owner (' + this.team.owner.name + ') to add you back to this team.', 'By leaving the team you lose access to all the calendars and categories associated with this team.', 'Are you still sure about it?'],
                    primaryButton: ['Leave', 'Leaving...'],
                    onClose: function onClose() {
                        return _this5.teamService.leave(_this5.team).then(_this5.close.bind(_this5, _this5.team)).catch(function (result) {
                            _this5.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to remove you from the team.'));
                            return _this5.$q.reject(result);
                        });
                    }
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'manageCollaborators',
        value: function manageCollaborators() {
            var _this6 = this;

            return this.modalService.open({
                component: 'dbACollaboratorManageModal'
            }).then(function (emails) {
                return _this6.load().then(function () {
                    __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(_this6.members, function (member) {
                        member.shared = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(emails, function (email) {
                            return email === member.email;
                        }) || member.shared;
                    });
                });
            });
        }
    }, {
        key: 'getAddedMembers',
        value: function getAddedMembers() {
            var _this7 = this;

            return this.members.filter(function (member) {
                var initial = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(_this7.initialMembers, function (initial) {
                    return _this7.userComparator(member, initial);
                });
                return !initial || initial.shared !== member.shared && member.shared;
            });
        }
    }, {
        key: 'getRemovedMembers',
        value: function getRemovedMembers() {
            var _this8 = this;

            return this.initialMembers.filter(function (initial) {
                var member = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(_this8.members, function (member) {
                    return _this8.userComparator(member, initial);
                });
                return member && member.shared !== initial.shared && !member.shared;
            });
        }
    }, {
        key: 'userComparator',
        value: function userComparator(user1, user2) {
            return user1.email === user2.email;
        }
    }, {
        key: 'close',
        value: function close(team) {
            return this.onClose({
                data: team
            });
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            return this.onDismiss();
        }
    }]);

    return TeamEditModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbATeamEditModal',
    template: __WEBPACK_IMPORTED_MODULE_8__team_edit_modal_tpl_pug___default()(),
    controller: TeamEditModalController,
    bindings: {
        team: '<',

        canEdit: '<',
        canDelete: '<',
        canManageCollaborators: '<',
        canManageCategories: '<',

        onDismiss: '&',
        onClose: '&'
    }
});

/***/ }),

/***/ "4xhO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forgot_password_token_expired_style_sass__ = __webpack_require__("sMAA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forgot_password_token_expired_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__forgot_password_token_expired_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_token_expired_tpl_pug__ = __webpack_require__("CTIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_token_expired_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__forgot_password_token_expired_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAForgotPasswordTokenExpired',
    template: __WEBPACK_IMPORTED_MODULE_1__forgot_password_token_expired_tpl_pug___default()()
});

/***/ }),

/***/ "4yT8":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"event-date-modal modal-fixed-height\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\"\u003EDate\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter\"\u003E\u003Ctable class=\"date-settings\"\u003E\u003Ctr class=\"date-control\"\u003E\u003Ctd class=\"date-control-label\"\u003EDate\u003C\u002Ftd\u003E\u003Ctd class=\"date-control-value\"\u003E\u003Cdb-a-date class=\"date-control-item\" ng-model=\"$ctrl.timestamp\" disabled=\"!$ctrl.canEdit\" on-click=\"$ctrl.selectDate()\"\u003E\u003C\u002Fdb-a-date\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"date-control\" ng-if=\"$ctrl.canRepeat\"\u003E\u003Ctd class=\"date-control-label\"\u003ERepeat\u003C\u002Ftd\u003E\u003Ctd class=\"date-control-value\"\u003E\u003Clabel class=\"date-control-item\"\u003E\u003Cdb-a-switch ng-model=\"$ctrl.repeating\" disabled=\"!$ctrl.canEdit\"\u003E\u003C\u002Fdb-a-switch\u003E\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"date-control date-repeating-settings\" ng-if=\"$ctrl.repeating\"\u003E\u003Ctd class=\"date-control-label\"\u003EEvery\u003C\u002Ftd\u003E\u003Ctd class=\"date-control-value\"\u003E\u003Cdiv class=\"date-control-group\"\u003E\u003Cdiv class=\"control frequency-control\"\u003E\u003Cinput class=\"control-input\" type=\"text\" id=\"repeating-frequency\" name=\"frequency\" placeholder=\"1\" ng-model=\"$ctrl.frequency\" ng-min=\"1\" ng-max=\"99\" db-a-number-only integer-only ng-readonly=\"!$ctrl.canEdit\"\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-option-select class=\"unit-select\" ng-model=\"$ctrl.unit\" disabled=\"!$ctrl.canEdit\" options=\"$ctrl.unitOptions\"\u003E\u003C\u002Fdb-a-option-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"date-control\" ng-if=\"$ctrl.repeating\" ng-class=\"{ 'repeat-ending-invalid': $ctrl.repeatEndError }\"\u003E\u003Ctd class=\"date-control-label\"\u003EEnds\u003C\u002Ftd\u003E\u003Ctd class=\"date-control-value\"\u003E\u003Cdb-a-option-select class=\"end-select\" ng-model=\"$ctrl.endType\" disabled=\"!$ctrl.canEdit\" options=\"$ctrl.endOptions\"\u003E\u003C\u002Fdb-a-option-select\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"date-control\" ng-if=\"$ctrl.repeating\"\u003E\u003Ctd class=\"date-control-label date-control-label-auto-confirm\"\u003EAuto-confirm\u003C\u002Ftd\u003E\u003Ctd class=\"date-control-value\"\u003E\u003Clabel class=\"date-control-item\"\u003E\u003Cdb-a-switch ng-model=\"$ctrl.autoConfirm\" disabled=\"!$ctrl.canEdit\"\u003E\u003C\u002Fdb-a-switch\u003E\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"date-control\" ng-if=\"$ctrl.willEndAfterOccurrence\"\u003E\u003Ctd class=\"date-control-label\"\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"date-control-value\"\u003E\u003Cdiv class=\"control occurrence-control\"\u003E\u003Cinput class=\"control-input\" type=\"text\" id=\"repeating-end-occurence\" name=\"occurence\" placeholder=\"1\" ng-model=\"$ctrl.endOccurrence\" ng-min=\"1\" ng-max=\"99\" db-a-number-only integer-only ng-readonly=\"!$ctrl.canEdit\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"occurrence-text\" ng-bind=\"$ctrl.occurrencePluralized\"\u003E\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"date-control\" ng-if=\"$ctrl.willEndOnDate\"\u003E\u003Ctd class=\"date-control-label\"\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"date-control-value\"\u003E\u003Cdb-a-date class=\"date-control-item\" ng-model=\"$ctrl.endDate\" disabled=\"!$ctrl.canEdit\" on-click=\"$ctrl.selectEndDate()\"\u003E\u003C\u002Fdb-a-date\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"repeat-ending-error\" ng-if=\"$ctrl.repeatEndError\"\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd ng-bind=\"$ctrl.repeatEndError\"\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003Cdiv class=\"date-repeat-summary modal-section\" ng-if=\"$ctrl.repeating\"\u003E\u003Cdiv class=\"date-control-label\"\u003ESummary\u003C\u002Fdiv\u003E\u003Cdiv class=\"date-control-value\" ng-bind=\"$ctrl.summary\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-modal-left button-close-modal\" ng-click=\"$ctrl.dismiss()\" ng-if=\"!$ctrl.canEdit\"\u003EClose\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-save-date\" ng-click=\"$ctrl.close()\" ng-if=\"$ctrl.canEdit\"\u003EOK\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "5/ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProfileService = function () {
    ProfileService.$inject = ['apiService'];

    /* @ngInject */
    function ProfileService(apiService) {
        _classCallCheck(this, ProfileService);

        this.apiService = apiService;
    }

    _createClass(ProfileService, [{
        key: 'get',
        value: function get() {
            return this.apiService.get('/users/me/profile').then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'save',
        value: function save(profile) {
            return this.apiService.put('/users/me/profile', profile).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'generateBackup',
        value: function generateBackup() {
            return this.apiService.post('/backup/export').then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'importBackup',
        value: function importBackup(file) {
            var dryRun = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var formData = new FormData();
            formData.append('file', file);
            var endpoint = dryRun ? '/backup/import?dryRun=true' : '/backup/import';

            return this.apiService.post(endpoint, formData, {
                transformRequest: function transformRequest(data) {
                    return data;
                },
                headers: {
                    // eslint-disable-next-line no-undefined
                    'Content-Type': undefined
                }
            }).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'export',
        value: function _export() {
            return this.apiService.post('/export/simple-csv').then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'exportCsv',
        value: function exportCsv() {
            return this.apiService.get('/export/download').then(function (result) {
                window.open(result.data.url, '_blank');
            });
        }
    }, {
        key: 'changeEmailWithToken',
        value: function changeEmailWithToken(token) {
            return this.apiService.post('/users/change-email', {
                token: token
            }).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'updatePassword',
        value: function updatePassword(oldPassword, newPassword) {
            return this.apiService.put('/users/me/change-password', {
                oldPassword: oldPassword,
                newPassword: newPassword
            }).then(function (result) {
                return result.data;
            });
        }
    }]);

    return ProfileService;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProfileService);

/***/ }),

/***/ "5/c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_verification_confirm_cmpt__ = __webpack_require__("+Z97");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.email-verification-confirm', []).component(__WEBPACK_IMPORTED_MODULE_1__email_verification_confirm_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__email_verification_confirm_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.email-verification.confirm', {
        url: '/re-send',
        template: '<db-a-email-verification-confirm class="block-component"></db-a-email-verification-confirm>'
    });
}

/***/ }),

/***/ "52Yl":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-period\" ng-class=\"{ loading: $ctrl.loading }\"\u003E\u003Cdiv class=\"loader-line\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"period-content\"\u003E\u003Cdiv class=\"months-container\"\u003E\u003Cdiv class=\"month-items\"\u003E\u003Cdb-a-period-month-item class=\"month-item\" ng-repeat=\"month in $ctrl.months track by month.timestamp\" name=\"month.name\" change=\"month.change\" balance=\"month.balance\" selected=\"$ctrl.selectedIndex === $index\" ng-click=\"$ctrl.select(month)\"\u003E\u003C\u002Fdb-a-period-month-item\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"month-selection-container\"\u003E\u003Cdiv class=\"month-selection\" ng-attr-data-index=\"{{ $ctrl.selectedIndex }}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "5BGd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_select_modal_cmpt__ = __webpack_require__("fVhu");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.category-select-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__category_select_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__category_select_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "5BVa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"period-month-item":"period-month-item","selected":"selected","month-name":"month-name","month-item-content":"month-item-content","month-change":"month-change","month-balance":"month-balance"};

/***/ }),

/***/ "5ImO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");
var helpers = __webpack_require__("iO9N");

defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		}
	}
});

module.exports = Element.extend({
	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var	angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += 2.0 * Math.PI;
			}
			while (angle > endAngle) {
				angle -= 2.0 * Math.PI;
			}
			while (angle < startAngle) {
				angle += 2.0 * Math.PI;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var sA = vm.startAngle;
		var eA = vm.endAngle;

		ctx.beginPath();

		ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
		ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

		ctx.closePath();
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;

		ctx.fillStyle = vm.backgroundColor;

		ctx.fill();
		ctx.lineJoin = 'bevel';

		if (vm.borderWidth) {
			ctx.stroke();
		}
	}
});


/***/ }),

/***/ "5MVB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"team-radio":"team-radio","selected":"selected","team-state":"team-state","team-name":"team-name"};

/***/ }),

/***/ "5pZ+":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"block-component\" id=\"settings-page\"\u003E\u003Cdiv class=\"settings-modal\"\u003E\u003Cdiv class=\"settings-modal-backdrop\" ng-click=\"$ctrl.goBack()\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"settings-modal-container\" db-stop-propagation=\"click\"\u003E\u003Cdiv class=\"settings-header\"\u003E\u003Cbutton class=\"button button-icon button-open-navigation\" ng-click=\"$ctrl.openNavigation()\"\u003E\u003Ci class=\"icon icon-dollarbird-menu\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"page-title\"\u003ESettings\u003C\u002Fdiv\u003E\u003Ca class=\"button button-icon button-close-page\" ng-click=\"$ctrl.goBack()\"\u003E\u003Ci class=\"icon icon-dollarbird-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"settings-container\"\u003E\u003Cdiv class=\"settings-content\"\u003E\u003Cdiv class=\"settings-navigation\" ng-class=\"{ visible: $ctrl.isNavigationVisible }\"\u003E\u003Cdiv class=\"settings-navigation-items\"\u003E\u003Ca class=\"settings-navigation-item\" ui-sref=\"authorized.calendar.settings.general\" ui-sref-active=\"active\" ng-click=\"$ctrl.closeNavigation()\"\u003EGeneral\u003C\u002Fa\u003E\u003Ca class=\"settings-navigation-item\" ui-sref=\"authorized.calendar.settings.userInterface\" ui-sref-active=\"active\" ng-click=\"$ctrl.closeNavigation()\"\u003EUser Interface\u003C\u002Fa\u003E\u003Ca class=\"settings-navigation-item\" ui-sref=\"authorized.calendar.settings.account\" ui-sref-active=\"active\" ng-click=\"$ctrl.closeNavigation()\"\u003EAccount\u003C\u002Fa\u003E\u003Ca class=\"settings-navigation-item\" ui-sref=\"authorized.calendar.settings.data\" ui-sref-active=\"active\" ng-click=\"$ctrl.closeNavigation()\"\u003EData\u003C\u002Fa\u003E\u003Ca class=\"settings-navigation-item\" ui-sref=\"authorized.calendar.settings.subscription\" ui-sref-active=\"active\" ng-click=\"$ctrl.closeNavigation()\" ng-hide=\"$ctrl.plan.free\"\u003ESubscription\u003C\u002Fa\u003E\u003Ca class=\"settings-navigation-item\" ui-sref=\"authorized.calendar.settings.about\" ui-sref-active=\"active\" ng-click=\"$ctrl.closeNavigation()\"\u003EAbout\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"settings-navigation-sign-out\"\u003E\u003Cbutton class=\"settings-navigation-item button-sign-out\" ng-click=\"$ctrl.signOut()\" ng-disabled=\"$ctrl.signingOut\" db-stop-propagation=\"click\"\u003ELog out\u003Cdiv class=\"button-sign-out-loader\" ng-if=\"$ctrl.signingOut\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdiv\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cui-view class=\"settings-view\" ng-click=\"$ctrl.closeNavigation()\"\u003E\u003C\u002Fui-view\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "5vIW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryHousehold-3e35230a42657525.svg";

/***/ }),

/***/ "5x40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_picker_cmpt__ = __webpack_require__("nJpA");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.date-picker', []).component(__WEBPACK_IMPORTED_MODULE_1__date_picker_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__date_picker_cmpt__["a" /* default */]));

/***/ }),

/***/ "6b2N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_request_style_sass__ = __webpack_require__("ClCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_request_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__forgot_password_request_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forgot_password_request_tpl_pug__ = __webpack_require__("CROK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forgot_password_request_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__forgot_password_request_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var ForgotPasswordRequestController = function () {
    ForgotPasswordRequestController.$inject = ['$state', '$stateParams', 'resetPasswordService'];

    /* @ngInject */
    function ForgotPasswordRequestController($state, $stateParams, resetPasswordService) {
        _classCallCheck(this, ForgotPasswordRequestController);

        this.$state = $state;
        this.resetPasswordService = resetPasswordService;

        this.email = $stateParams.email || null;
    }

    _createClass(ForgotPasswordRequestController, [{
        key: 'send',
        value: function send(email) {
            var _this = this;

            return this.resetPasswordService.send(email).then(function () {
                _this.$state.go('identity.forgot-password.confirm');
            }, function (result) {
                _this.error = Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to send you the email.');
            });
        }
    }]);

    return ForgotPasswordRequestController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAForgotPasswordRequest',
    template: __WEBPACK_IMPORTED_MODULE_2__forgot_password_request_tpl_pug___default()(),
    controller: ForgotPasswordRequestController
});

/***/ }),

/***/ "6fjO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_select_default_modal_style_sass__ = __webpack_require__("xBRd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_select_default_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__calendar_select_default_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_select_default_modal_tpl_pug__ = __webpack_require__("XHSq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_select_default_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_select_default_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CalendarSelectDefaultModalController = function () {
    function CalendarSelectDefaultModalController() {
        _classCallCheck(this, CalendarSelectDefaultModalController);
    }

    _createClass(CalendarSelectDefaultModalController, [{
        key: '$onInit',
        value: function $onInit() {
            this.selected = null;
        }
    }, {
        key: 'select',
        value: function select(calendar) {
            this.selected = calendar;
        }
    }, {
        key: 'markAsDone',
        value: function markAsDone() {
            if (this.selected) {
                this.onClose({
                    data: this.selected
                });
            }
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            this.onDismiss();
        }
    }]);

    return CalendarSelectDefaultModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarSelectDefaultModal',
    template: __WEBPACK_IMPORTED_MODULE_1__calendar_select_default_modal_tpl_pug___default()(),
    controller: CalendarSelectDefaultModalController,
    bindings: {
        teams: '<',

        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "6rMk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");
var helpers = __webpack_require__("iO9N");

defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers.noop,
		onComplete: helpers.noop
	}
});

module.exports = function(Chart) {

	Chart.Animation = Element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});

	Chart.animationService = {
		frameDuration: 17,
		animations: [],
		dropFrames: 0,
		request: null,

		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {Number} duration - The animation duration in ms.
		 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;

			if (!lazy) {
				chart.animating = true;
			}

			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function(chart) {
			var index = helpers.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
			var startTime = Date.now();
			var framesToDrop = 0;

			if (me.dropFrames > 1) {
				framesToDrop = Math.floor(me.dropFrames);
				me.dropFrames = me.dropFrames % 1;
			}

			me.advance(1 + framesToDrop);

			var endTime = Date.now();

			me.dropFrames += (endTime - startTime) / me.frameDuration;

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
		 * @private
		 */
		advance: function(count) {
			var animations = this.animations;
			var animation, chart;
			var i = 0;

			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;

				animation.currentStep = (animation.currentStep || 0) + count;
				animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

				helpers.callback(animation.render, [chart, animation], chart);
				helpers.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= animation.numSteps) {
					helpers.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};

	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});

};


/***/ }),

/***/ "712i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_time_util__ = __webpack_require__("S2sh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verify_email_notification_tpl_pug__ = __webpack_require__("nMZG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verify_email_notification_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__verify_email_notification_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var VerifyEmailController = function () {
    VerifyEmailController.$inject = ['$timeout', 'emailVerificationService'];

    /* @ngInject */
    function VerifyEmailController($timeout, emailVerificationService) {
        _classCallCheck(this, VerifyEmailController);

        this.$timeout = $timeout;
        this.emailVerificationService = emailVerificationService;
    }

    _createClass(VerifyEmailController, [{
        key: '$onInit',
        value: function $onInit() {
            this.expired = Object(__WEBPACK_IMPORTED_MODULE_0_application_util_time_util__["c" /* getNow */])() > this.expire;
        }
    }, {
        key: 'resend',
        value: function resend() {
            var _this = this;

            return this.emailVerificationService.send(this.email).then(function () {
                _this.message = 'The email has been sent to your inbox.';
                _this.$timeout(_this.close.bind(_this), 3000);
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'close',
        value: function close() {
            return this.onClose();
        }
    }]);

    return VerifyEmailController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAVerifyEmailNotification',
    template: __WEBPACK_IMPORTED_MODULE_1__verify_email_notification_tpl_pug___default()(),
    controller: VerifyEmailController,
    bindings: {
        expire: '<',
        email: '<',
        onClose: '&'
    }
});

/***/ }),

/***/ "72Lu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ "76EN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_event_report_util__ = __webpack_require__("NLyG");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var BalanceUpdateService = function () {
    BalanceUpdateService.$inject = ['apiService'];

    /* @ngInject */
    function BalanceUpdateService(apiService) {
        _classCallCheck(this, BalanceUpdateService);

        this.apiService = apiService;
    }

    _createClass(BalanceUpdateService, [{
        key: 'create',
        value: function create(calendarId, event) {
            return this.apiService.post('/calendars/' + calendarId + '/transactions/balance-updates', Object(__WEBPACK_IMPORTED_MODULE_0_application_util_event_report_util__["c" /* toEventPayload */])(event, false)).then(function (result) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_application_util_event_report_util__["b" /* normalizeIncludeInReports */])(result.data);
            });
        }
    }]);

    return BalanceUpdateService;
}();

/* harmony default export */ __webpack_exports__["a"] = (BalanceUpdateService);

/***/ }),

/***/ "78R8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_little_loader__ = __webpack_require__("lchF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_little_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_little_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__("0Qa9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CHANGE_LOG_CLASS = 'change-log';

var ChangeLogController = function () {
    /* @ngInject */
    function ChangeLogController() {
        _classCallCheck(this, ChangeLogController);

        this.accountId = {"version":"6.3.3","googleAnalyticsTrackingId":"G-VPTZ3M0ZDZ","googleAdsTrackingId":"AW-16909656843","monitoringApi":"https://monitoring.dollarbird.co/v1","monitoringApiDev":"http://localhost:8100/v1","monitoringPlatform":"Web","supportDiagnosticsEndpoint":null,"sentryDsn":"https://de1a474472ce1315cfce1a5014bcc445@o1153676.ingest.us.sentry.io/4510906059063296","sentryEnvironment":"production","sentryRelease":"7a657325bc30c1a183a610118146bc8e9797eab0","api":"https://api.dollarbird.co/v1","quoraPixelTrackingId":"dummy","headwayAccountId":"yEkdD7","appDownloadUrl":"https://get.dollarbird.co","androidDownloadUrl":"https://get.dollarbird.co/android","iosDownloadUrl":"https://get.dollarbird.co/ios","pressKitUrl":"https://press.dollarbird.co/download-press-kit","helpCenterUrl":"https://help.dollarbird.co","cancelSubscriptionHelpCenterUrl":"https://help.dollarbird.co/cancel-subscription","canonicalUrl":"https://dollarbird.co","socialFacebookUrl":"https://www.facebook.com/dollarbirdapp","socialTwitterUrl":"https://twitter.com/dollarbirdapp","supportEmail":"support@dollarbird.co","salesEmail":"hello@dollarbird.co"}.headwayAccountId;
    }

    _createClass(ChangeLogController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            return this.initialize().then(function () {
                _this.interval = setInterval(_this.update.bind(_this), _this.updateInterval);
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: '$onDestory',
        value: function $onDestory() {
            if (this.interval) {
                clearInterval(this.interval);
            }

            return this.getInstance().then(function (instance) {
                instance.destroy();
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'initialize',
        value: function initialize() {
            var _this2 = this;

            return this.getInstance().then(function (instance) {
                instance.init({
                    selector: '.' + CHANGE_LOG_CLASS,
                    account: _this2.accountId
                });

                return instance;
            });
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            return this.getInstance().then(function (instance) {
                if (!instance.visible) {
                    return _this3.initialize();
                }

                return instance;
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'getInstance',
        value: function getInstance() {
            var _this4 = this;

            if (!this.instance) {
                this.instance = new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function (resolve, reject) {
                    if (_this4.accountId) {
                        return __WEBPACK_IMPORTED_MODULE_0_little_loader___default()('https://cdn.headwayapp.co/widget.js', function (error) {
                            if (error) {
                                return reject(error);
                            }

                            return resolve(window.Headway);
                        });
                    }

                    return reject(new Error('The change log is disabled.'));
                });
            }

            return this.instance;
        }
    }]);

    return ChangeLogController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAChangeLog',
    template: '<div class="' + CHANGE_LOG_CLASS + '"></div>',
    controller: ChangeLogController,
    bindings: {
        updateInterval: '<'
    }
});

/***/ }),

/***/ "78Tj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_notification_cmpt__ = __webpack_require__("SFEB");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.notifications.component.error-notification', []).component(__WEBPACK_IMPORTED_MODULE_1__error_notification_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__error_notification_cmpt__["a" /* default */]));

/***/ }),

/***/ "7F/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_analytics__ = __webpack_require__("3pWh");



// Create and register the Angular module
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.service.analytics', []).factory('analyticsService', function () {
    return __WEBPACK_IMPORTED_MODULE_1_common_analytics__["c" /* default */];
}));

/***/ }),

/***/ "7Mjc":
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),

/***/ "7OSm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-icon-image-aff2af5657ab6cfd.svg";

/***/ }),

/***/ "7ck3":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category-color\" ng-class=\"{ filled: $ctrl.fill }\" ng-style=\"{ borderColor: $ctrl.borderColor, backgroundColor: $ctrl.backgroundColor }\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "7nA+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_number_util__ = __webpack_require__("Cybx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pretty_number_style_sass__ = __webpack_require__("38wx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pretty_number_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pretty_number_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pretty_number_tpl_pug__ = __webpack_require__("2JtO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pretty_number_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pretty_number_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var PrettyNumberController = function () {
    function PrettyNumberController() {
        _classCallCheck(this, PrettyNumberController);
    }

    _createClass(PrettyNumberController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.value) {
                this.refreshValues(this.value);
            }
        }
    }, {
        key: 'refreshValues',
        value: function refreshValues(value) {
            value = Object(__WEBPACK_IMPORTED_MODULE_0_application_util_number_util__["b" /* isNumeric */])(value) ? Number(value) : 0;

            this.normalizedValue = Object(__WEBPACK_IMPORTED_MODULE_0_application_util_number_util__["c" /* prettifyNumber */])(value, {
                addPositiveSign: this.addPositiveSign,
                omitNegativeSign: this.omitNegativeSign,
                limit: this.limit,
                preventShrink: this.preventShrink,
                decimals: this.decimals,
                pretty: this.pretty
            });

            this.formattedValue = Object(__WEBPACK_IMPORTED_MODULE_0_application_util_number_util__["c" /* prettifyNumber */])(value, {
                preventShrink: true,
                decimals: this.decimals,
                pretty: true
            });
        }
    }]);

    return PrettyNumberController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAPrettyNumber',
    template: __WEBPACK_IMPORTED_MODULE_2__pretty_number_tpl_pug___default()(),
    controller: PrettyNumberController,
    bindings: {
        value: '<',
        addPositiveSign: '<',
        omitNegativeSign: '<',
        limit: '<',
        preventShrink: '<',
        decimals: '<',
        pretty: '<'
    }
});

/***/ }),

/***/ "7s0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_style_sass__ = __webpack_require__("T3/K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modals_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_tpl_pug__ = __webpack_require__("2Pgy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modals_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var ModalsController = function () {
    ModalsController.$inject = ['$document', '$scope', 'modalService'];

    /* @ngInject */
    function ModalsController($document, $scope, modalService) {
        var _this = this;

        _classCallCheck(this, ModalsController);

        this.$document = $document;
        this.$body = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(this.$document[0].body);

        this.modalService = modalService;

        $scope.$watchCollection(function () {
            return _this.modalService.modals;
        }, function (modals) {
            _this.toggleDocumentScroll(!modals || modals.length === 0);
        });
    }

    _createClass(ModalsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.$body.on('keydown', this.handleEscape.bind(this));
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.$body.off('keydown', this.handleEscape.bind(this));
        }
    }, {
        key: 'toggleDocumentScroll',
        value: function toggleDocumentScroll(scrollable) {
            var name = 'modal-open';

            if (scrollable) {
                this.$body.removeClass(name);
            } else if (!this.$body.hasClass(name)) {
                this.$body.addClass(name);
            }
        }
    }, {
        key: 'handleEscape',
        value: function handleEscape(event) {
            switch (event.which) {
                case 27:
                    __WEBPACK_IMPORTED_MODULE_1_common_analytics__["c" /* default */].trackModalDismissByShortcut();

                    this.dismiss();
                    break;
            }
        }
    }, {
        key: 'dismissOnBackdrop',
        value: function dismissOnBackdrop() {
            __WEBPACK_IMPORTED_MODULE_1_common_analytics__["c" /* default */].trackModalDismissByBackdrop();

            return this.dismiss.apply(this, arguments);
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            var _modalService;

            return (_modalService = this.modalService).dismiss.apply(_modalService, arguments);
        }
    }, {
        key: 'modals',
        get: function get() {
            return this.modalService.modals;
        }
    }]);

    return ModalsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAModals',
    template: __WEBPACK_IMPORTED_MODULE_3__modals_tpl_pug___default()(),
    controller: ModalsController
});

/***/ }),

/***/ "7yQ9":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category-icon\" ng-class=\"{ empty: !$ctrl.iconUrl }\" ng-style=\"$ctrl.style\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "8++/":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "842T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification__ = __webpack_require__("BgnQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__text_notification__ = __webpack_require__("O9b3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_notification__ = __webpack_require__("78Tj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__verify_email_notification__ = __webpack_require__("A04l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__renew_subscription_notification__ = __webpack_require__("GTP8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__already_subscribed_notification__ = __webpack_require__("YARn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event_limit_notification__ = __webpack_require__("IR8+");










/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.notifications.component', [__WEBPACK_IMPORTED_MODULE_1__notification__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__text_notification__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__error_notification__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__verify_email_notification__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__renew_subscription_notification__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__already_subscribed_notification__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__event_limit_notification__["a" /* default */].name]));

/***/ }),

/***/ "8BbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_reset_cmpt__ = __webpack_require__("X69l");
stateConfiguration.$inject = ['$stateProvider', '$transitionsProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.forgot-password-reset', []).component(__WEBPACK_IMPORTED_MODULE_1__forgot_password_reset_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__forgot_password_reset_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('identity.forgot-password.reset', {
        url: '/reset?token',
        template: '<db-a-forgot-password-reset class="block-component"></db-a-forgot-password-reset>'
    });

    // TODO: prevent triggering on start twice
    $transitionsProvider.onStart({
        to: 'identity.forgot-password.reset'
    }, function (transition) {
        var $state = transition.injector().get('$state');
        var resetPasswordService = transition.injector().get('resetPasswordService');

        var params = transition.params() || {};

        if (params.token) {
            return resetPasswordService.validate(params.token).then(function () {
                return true;
            }, redirect);
        }

        return redirect();

        function redirect() {
            return $state.target('identity.forgot-password.token-expired');
        }
    });
}

/***/ }),

/***/ "8HTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__outside_click_directive__ = __webpack_require__("C0LB");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.outside-click', []).directive(__WEBPACK_IMPORTED_MODULE_1__outside_click_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__outside_click_directive__["a" /* default */]));

/***/ }),

/***/ "8Jal":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"color-palette\"\u003E\u003Cbutton class=\"palette-page-control palette-page-control-up\" type=\"button\" ng-click=\"$ctrl.goPreviousPage()\" ng-disabled=\"$ctrl.page &lt;= 0\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-up\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"palette-grid\"\u003E\u003Cdiv class=\"grid-item-container\" ng-repeat=\"color in $ctrl.visibleColors track by $index\"\u003E\u003Cdiv class=\"grid-item\"\u003E\u003Cdiv class=\"palette-item\" ng-class=\"{ used: color.used, selected: color.selected, disabled: $ctrl.disabled }\" ng-style=\"{ backgroundColor: color.hex }\" ng-click=\"$ctrl.select(color)\"\u003E\u003Ci class=\"icon-selected icon-dollarbird-checkmark\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"palette-page-control palette-page-control-down\" type=\"button\" ng-click=\"$ctrl.goNextPage()\" ng-disabled=\"$ctrl.page &gt;= $ctrl.pageCount - 1\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-down\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "8qhh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_20-6fc2442c0dc440b8.svg";

/***/ }),

/***/ "8rSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blacklist_directive__ = __webpack_require__("yXCI");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.blacklist', []).directive(__WEBPACK_IMPORTED_MODULE_1__blacklist_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__blacklist_directive__["a" /* default */]));

/***/ }),

/***/ "8uqi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var elements = __webpack_require__("L5rj");
var helpers = __webpack_require__("iO9N");

defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

module.exports = function(Chart) {

	function lineEnabled(dataset, options) {
		return helpers.valueOrDefault(dataset.showLine, options.showLines);
	}

	Chart.controllers.line = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var lineElementOptions = options.elements.line;
			var scale = me.getScaleForId(meta.yAxisID);
			var i, ilen, custom;
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, options);

			// Update Line
			if (showLine) {
				custom = line.custom || {};

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = {
					// Appearance
					// The default behavior of lines is to break at null values, according
					// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
					// This option gives lines the ability to span gaps
					spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
					cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
				};

				line.pivot();
			}

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		getPointBackgroundColor: function(point, index) {
			var backgroundColor = this.chart.options.elements.point.backgroundColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.backgroundColor) {
				backgroundColor = custom.backgroundColor;
			} else if (dataset.pointBackgroundColor) {
				backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
			} else if (dataset.backgroundColor) {
				backgroundColor = dataset.backgroundColor;
			}

			return backgroundColor;
		},

		getPointBorderColor: function(point, index) {
			var borderColor = this.chart.options.elements.point.borderColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.borderColor) {
				borderColor = custom.borderColor;
			} else if (dataset.pointBorderColor) {
				borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
			} else if (dataset.borderColor) {
				borderColor = dataset.borderColor;
			}

			return borderColor;
		},

		getPointBorderWidth: function(point, index) {
			var borderWidth = this.chart.options.elements.point.borderWidth;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (!isNaN(custom.borderWidth)) {
				borderWidth = custom.borderWidth;
			} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
				borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
			} else if (!isNaN(dataset.borderWidth)) {
				borderWidth = dataset.borderWidth;
			}

			return borderWidth;
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var pointOptions = me.chart.options.elements.point;
			var x, y;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
				pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
				backgroundColor: me.getPointBackgroundColor(point, index),
				borderColor: me.getPointBorderColor(point, index),
				borderWidth: me.getPointBorderWidth(point, index),
				tension: meta.dataset._model ? meta.dataset._model.tension : 0,
				steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
				// Tooltip
				hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
			};
		},

		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;

			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}

			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = (meta.data || []);
			var i, ilen, point, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
				helpers.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					point = points[i];
					model = point._model;
					controlPoints = helpers.splineCurve(
						helpers.previousItem(points, i)._model,
						model,
						helpers.nextItem(points, i)._model,
						meta.dataset._model.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (me.chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
					model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
					model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
				}
			}
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, area);

			if (lineEnabled(me.getDataset(), chart.options)) {
				meta.dataset.draw();
			}

			helpers.canvas.unclipArea(chart.ctx);

			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var me = this;
			var dataset = me.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}

			model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
			model.backgroundColor = me.getPointBackgroundColor(point, index);
			model.borderColor = me.getPointBorderColor(point, index);
			model.borderWidth = me.getPointBorderWidth(point, index);
		}
	});
};


/***/ }),

/***/ "8wd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("xhhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_header_cmpt__ = __webpack_require__("9gEI");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-header', [__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_2__calendar_header_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__calendar_header_cmpt__["a" /* default */]));

/***/ }),

/***/ "8xVG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-color-chart":"category-color-chart","color-chart-item":"color-chart-item"};

/***/ }),

/***/ "9TJD":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-day\" ng-class=\"{ today: $ctrl.today, another: $ctrl.another, readonly: !$ctrl.canManageEvents }\" ui-on-drop=\"$ctrl.eventDrop($data)\" drop-channel=\"event\" drop-validate=\"$ctrl.validateEventDrop($data)\"\u003E\u003Cdiv class=\"day-heading\" ng-click=\"$ctrl.clickHeading()\"\u003E\u003Cdiv class=\"day-date\" ng-bind=\"$ctrl.date\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"day-values\"\u003E\u003Cdb-a-pretty-number class=\"day-change\" value=\"$ctrl.change\" add-positive-sign=\"true\" limit=\"10000\" ng-if=\"$ctrl.events.length &gt; 0\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003Cdb-a-pretty-number class=\"day-balance\" value=\"$ctrl.balance\" limit=\"10000\" ng-style=\"{ color: $ctrl.getBalanceOverrideColor($ctrl.balance) }\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"button-add-container\"\u003E\u003Cbutton class=\"button button-fill button-primary button-icon button-add button-add-event\" ng-click=\"$ctrl.clickAddEvent()\" db-stop-propagation=\"click\" ng-if=\"$ctrl.canManageEvents\"\u003E\u003Ci class=\"icon icon-dollarbird-plus\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"day-content\"\u003E\u003Cdb-a-calendar-day-event class=\"day-event\" ng-repeat=\"event in $ctrl.displayedEvents track by $index\" type=\"event.type\" confirmed=\"event.confirmed\" category=\"event.category\" note=\"event.note\" details=\"event.details\" value=\"event.value\" repeat=\"!!event.repeat\" receipt-url=\"event.receiptUrl\" use-category-icons=\"$ctrl.useCategoryIcons\" ng-click=\"$ctrl.selectEvent(event)\" ui-draggable=\"true\" drag=\"event\" drag-channel=\"event\"\u003E\u003C\u002Fdb-a-calendar-day-event\u003E\u003Cbutton class=\"link day-event button-show-more-events\" ng-show=\"$ctrl.more &gt; 0\" ng-click=\"$ctrl.clickMore()\"\u003E\u003Cspan class=\"icon-plus\"\u003E+\u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.more\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E other\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "9W0y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dashboard-page":"dashboard-page","dashboard-header":"dashboard-header","button-close-page":"button-close-page","page-title":"page-title","dashboard-container":"dashboard-container","dashboard-content":"dashboard-content","navigation-content":"navigation-content","navigation-section":"navigation-section","navigation-section-title":"navigation-section-title","navigation-item":"navigation-item","dashboard-cards":"dashboard-cards","dashboard-form":"dashboard-form","dashboard-form-control":"dashboard-form-control","control-input":"control-input","dashboard-card-container":"dashboard-card-container","dashboard-card-loader":"dashboard-card-loader","dashboard-navigation":"dashboard-navigation"};

/***/ }),

/***/ "9gEI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_application_util_balance_highlight_util__ = __webpack_require__("Ium9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__calendar_header_style_sass__ = __webpack_require__("1MfR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__calendar_header_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__calendar_header_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__calendar_header_tpl_pug__ = __webpack_require__("M3d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__calendar_header_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__calendar_header_tpl_pug__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var CalendarHeaderController = function () {
    function CalendarHeaderController() {
        _classCallCheck(this, CalendarHeaderController);
    }

    _createClass(CalendarHeaderController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.timestamp) {
                this.date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(changeObject.timestamp.currentValue).format('MMMM YYYY');
            }

            if (changeObject.team || changeObject.calendarIds) {
                this.calendars = this.getSelectedCalendarsByIds(this.team || {}, this.calendarIds || []);
                this.selectedName = this.getSelectedCalendarsName(this.calendars);
            }
        }
    }, {
        key: 'getSelectedCalendarsByIds',
        value: function getSelectedCalendarsByIds(team, calendarIds) {
            var calendars = team.calendars || [];

            return __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(calendarIds || [], function (calendarId) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(calendars, function (calendar) {
                    return calendar.id === calendarId;
                });
            }));
        }
    }, {
        key: 'getBalanceOverrideColor',
        value: function getBalanceOverrideColor(value) {
            if (this.loading) {
                return null;
            }

            return Object(__WEBPACK_IMPORTED_MODULE_5_application_util_balance_highlight_util__["a" /* getBalanceOverrideColor */])(value, this.balanceWarningThreshold);
        }
    }, {
        key: 'getSelectedCalendarsName',
        value: function getSelectedCalendarsName(calendars) {
            if (!calendars || calendars.length === 0) {
                return null;
            }

            if (calendars.length === 1) {
                return calendars[0].name;
            }

            return calendars.length + ' calendars selected';
        }
    }, {
        key: 'openTeamManagement',
        value: function openTeamManagement() {
            this.blur();

            return this.onTeamManagementClick();
        }
    }, {
        key: 'selectPreviousMonth',
        value: function selectPreviousMonth() {
            return this.onPreviousMonthClick();
        }
    }, {
        key: 'selectNextMonth',
        value: function selectNextMonth() {
            return this.onNextMonthClick();
        }
    }, {
        key: 'selectToday',
        value: function selectToday() {
            this.blur();

            return this.onTodayClick();
        }
    }, {
        key: 'selectMonth',
        value: function selectMonth(timestamp) {
            return this.onMonthClick({
                timestamp: timestamp
            });
        }
    }, {
        key: 'hover',
        value: function hover() {
            this.areMonthsVisible = true;
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.areMonthsVisible = false;
        }
    }, {
        key: 'searchTermChanged',
        value: function searchTermChanged(terms) {
            this.terms = terms;

            return this.onSearchTermsChanged({
                terms: terms
            });
        }
    }, {
        key: 'toggleSearchVisibility',
        value: function toggleSearchVisibility(focused) {
            if (focused || !this.terms || this.terms.length === 0) {
                this.searchVisible = focused;
            }
        }
    }, {
        key: 'balance',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()(this.calendars || [], function (total, calendar) {
                return total + calendar.balance;
            }, 0);
        }
    }]);

    return CalendarHeaderController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarHeader',
    template: __WEBPACK_IMPORTED_MODULE_7__calendar_header_tpl_pug___default()(),
    controller: CalendarHeaderController,
    bindings: {
        loading: '<',
        team: '<',
        calendarIds: '<',
        timestamp: '<',
        months: '<',
        canCaptureSearch: '<',
        balanceWarningThreshold: '<',
        onTeamManagementClick: '&',
        onPreviousMonthClick: '&',
        onNextMonthClick: '&',
        onTodayClick: '&',
        onMonthClick: '&',
        onSearchTermsChanged: '&'
    }
});

/***/ }),

/***/ "A04l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verify_email_notification_cmpt__ = __webpack_require__("712i");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.notifications.component.verify-email-notification', []).component(__WEBPACK_IMPORTED_MODULE_1__verify_email_notification_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__verify_email_notification_cmpt__["a" /* default */]));

/***/ }),

/***/ "A2Xd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookie_notification_cmpt__ = __webpack_require__("F82N");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.cookie-notification', []).component(__WEBPACK_IMPORTED_MODULE_1__cookie_notification_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__cookie_notification_cmpt__["a" /* default */]));

/***/ }),

/***/ "A5K1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Plugin based on discussion from the following Chart.js issues:
 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
 */



var defaults = __webpack_require__("k7DW");
var elements = __webpack_require__("L5rj");
var helpers = __webpack_require__("iO9N");

defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

module.exports = function() {

	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;

			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},

		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;

			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};

	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;

		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}

		if (fill === false || fill === null) {
			return false;
		}

		if (fill === true) {
			return 'origin';
		}

		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}

			if (target === index || target < 0 || target >= count) {
				return false;
			}

			return target;
		}

		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}

	function computeBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;

		if (isFinite(fill)) {
			return null;
		}

		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).

		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePosition) {
			target = scale.getBasePosition();
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}

		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}

			if (typeof target === 'number' && isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}

		return null;
	}

	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;

		if (!propagate) {
			return fill;
		}

		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}

			target = sources[fill];
			if (!target) {
				return false;
			}

			if (target.visible) {
				return fill;
			}

			visited.push(fill);
			fill = target.fill;
		}

		return false;
	}

	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';

		if (fill === false) {
			return null;
		}

		if (!isFinite(fill)) {
			type = 'boundary';
		}

		return mappers[type](source);
	}

	function isDrawable(point) {
		return point && !point.skip;
	}

	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i;

		if (!len0 || !len1) {
			return;
		}

		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}

		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}

	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1;

		ctx.beginPath();

		for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);

			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}

		drawArea(ctx, curve0, curve1, len0, len1);

		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}

	return {
		id: 'filler',

		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;

			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;

				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}

				meta.$filler = source;
				sources.push(source);
			}

			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}

				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},

		beforeDatasetDraw: function(chart, args) {
			var meta = args.meta.$filler;
			if (!meta) {
				return;
			}

			var ctx = chart.ctx;
			var el = meta.el;
			var view = el._view;
			var points = el._children || [];
			var mapper = meta.mapper;
			var color = view.backgroundColor || defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers.canvas.unclipArea(ctx);
			}
		}
	};
};


/***/ }),

/***/ "A8eB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_value_key_filter__ = __webpack_require__("k1UB");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.event-edit-modal.directive', [__WEBPACK_IMPORTED_MODULE_1__event_value_key_filter__["a" /* default */].name]));

/***/ }),

/***/ "ACBE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryBalanceUpdate-f7fd9b0f71882e3f.svg";

/***/ }),

/***/ "AFDx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");

defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: defaults.global.defaultColor,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(bar) {
	return bar._view.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(bar) {
	var vm = bar._view;
	var x1, x2, y1, y2;

	if (isVertical(bar)) {
		// vertical
		var halfWidth = vm.width / 2;
		x1 = vm.x - halfWidth;
		x2 = vm.x + halfWidth;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		// horizontal bar
		var halfHeight = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - halfHeight;
		y2 = vm.y + halfHeight;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

module.exports = Element.extend({
	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var left, right, top, bottom, signX, signY, borderSkipped;
		var borderWidth = vm.borderWidth;

		if (!vm.horizontal) {
			// bar
			left = vm.x - vm.width / 2;
			right = vm.x + vm.width / 2;
			top = vm.y;
			bottom = vm.base;
			signX = 1;
			signY = bottom > top ? 1 : -1;
			borderSkipped = vm.borderSkipped || 'bottom';
		} else {
			// horizontal bar
			left = vm.base;
			right = vm.x;
			top = vm.y - vm.height / 2;
			bottom = vm.y + vm.height / 2;
			signX = right > left ? 1 : -1;
			signY = 1;
			borderSkipped = vm.borderSkipped || 'left';
		}

		// Canvas doesn't allow us to stroke inside the width so we can
		// adjust the sizes to fit if we're setting a stroke on the line
		if (borderWidth) {
			// borderWidth shold be less than bar width and bar height.
			var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
			borderWidth = borderWidth > barSize ? barSize : borderWidth;
			var halfStroke = borderWidth / 2;
			// Adjust borderWidth when bar top position is near vm.base(zero).
			var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
			var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
			var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
			var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
			// not become a vertical line?
			if (borderLeft !== borderRight) {
				top = borderTop;
				bottom = borderBottom;
			}
			// not become a horizontal line?
			if (borderTop !== borderBottom) {
				left = borderLeft;
				right = borderRight;
			}
		}

		ctx.beginPath();
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = borderWidth;

		// Corner points, from bottom-left to bottom-right clockwise
		// | 1 2 |
		// | 0 3 |
		var corners = [
			[left, bottom],
			[left, top],
			[right, top],
			[right, bottom]
		];

		// Find first (starting) corner with fallback to 'bottom'
		var borders = ['bottom', 'left', 'top', 'right'];
		var startCorner = borders.indexOf(borderSkipped, 0);
		if (startCorner === -1) {
			startCorner = 0;
		}

		function cornerAt(index) {
			return corners[(startCorner + index) % 4];
		}

		// Draw rectangle from 'startCorner'
		var corner = cornerAt(0);
		ctx.moveTo(corner[0], corner[1]);

		for (var i = 1; i < 4; i++) {
			corner = cornerAt(i);
			ctx.lineTo(corner[0], corner[1]);
		}

		ctx.fill();
		if (borderWidth) {
			ctx.stroke();
		}
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		var inRange = false;

		if (this._view) {
			var bounds = getBarBounds(this);
			inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inLabelRange: function(mouseX, mouseY) {
		var me = this;
		if (!me._view) {
			return false;
		}

		var inRange = false;
		var bounds = getBarBounds(me);

		if (isVertical(me)) {
			inRange = mouseX >= bounds.left && mouseX <= bounds.right;
		} else {
			inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inXRange: function(mouseX) {
		var bounds = getBarBounds(this);
		return mouseX >= bounds.left && mouseX <= bounds.right;
	},

	inYRange: function(mouseY) {
		var bounds = getBarBounds(this);
		return mouseY >= bounds.top && mouseY <= bounds.bottom;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(this)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;
		return vm.width * Math.abs(vm.y - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});


/***/ }),

/***/ "AL3o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_repeat_change_modal_cmpt__ = __webpack_require__("Gz8l");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.event-repeat-change-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__event_repeat_change_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__event_repeat_change_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "AZn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pretty_number_cmpt__ = __webpack_require__("7nA+");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.pretty-number', []).component(__WEBPACK_IMPORTED_MODULE_1__pretty_number_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__pretty_number_cmpt__["a" /* default */]));

/***/ }),

/***/ "Ak92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_service__ = __webpack_require__("MbXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transfer_service__ = __webpack_require__("FoJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__balance_update_service__ = __webpack_require__("76EN");






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.service.calendar.transaction', []).service('eventService', __WEBPACK_IMPORTED_MODULE_1__event_service__["a" /* default */]).service('transferService', __WEBPACK_IMPORTED_MODULE_2__transfer_service__["a" /* default */]).service('balanceUpdateService', __WEBPACK_IMPORTED_MODULE_3__balance_update_service__["a" /* default */]));

/***/ }),

/***/ "At72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__check_event_count_directive__ = __webpack_require__("P7a5");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.directive.check-event-count', []).directive(__WEBPACK_IMPORTED_MODULE_1__check_event_count_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__check_event_count_directive__["a" /* default */]));

/***/ }),

/***/ "AuYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__option_select_style_sass__ = __webpack_require__("+QZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__option_select_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__option_select_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__option_select_tpl_pug__ = __webpack_require__("MfiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__option_select_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__option_select_tpl_pug__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var OptionSelectController = function () {
    OptionSelectController.$inject = ['arrayUtil'];

    /* @ngInject */
    function OptionSelectController(arrayUtil) {
        _classCallCheck(this, OptionSelectController);

        this.arrayUtil = arrayUtil;
    }

    _createClass(OptionSelectController, [{
        key: '$onInit',
        value: function $onInit() {
            this.$ctrl.$formatters.push(this.formatter.bind(this));
            this.$ctrl.$parsers.push(this.parser.bind(this));
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.options) {
                this.options = this.createOptions(changeObject.options.currentValue);
            }
            if (changeObject.id) {
                this.id = changeObject.id.currentValue;
            }
        }
    }, {
        key: 'formatter',
        value: function formatter(id) {
            var option = this.arrayUtil.find(this.options, function (option) {
                return option.empty || option.id === id;
            });
            return option.value;
        }
    }, {
        key: 'parser',
        value: function parser(value) {
            var option = this.arrayUtil.find(this.options, function (option) {
                return option.empty || option.value === value;
            });
            return option.id;
        }
    }, {
        key: 'getIndexById',
        value: function getIndexById(id) {
            return this.arrayUtil.find(this.options, function (option) {
                return option.empty || option.id === id;
            }, -1, function (option, index) {
                return index;
            });
        }
    }, {
        key: 'createOptions',
        value: function createOptions(options) {
            options = options || [];

            if (options.length > 0) {
                return options.map(function (option) {
                    if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) !== 'object') {
                        option = {
                            id: option,
                            value: option
                        };
                    }

                    return __WEBPACK_IMPORTED_MODULE_0_angular___default.a.merge({}, option);
                });
            }

            return [{ empty: true, value: '-' }];
        }
    }, {
        key: 'selectPreviousOption',
        value: function selectPreviousOption() {
            var index = this.getIndexById(this.$ctrl.$modelValue);
            this.update(this.options[index > 0 ? index - 1 : this.options.length - 1]);
        }
    }, {
        key: 'selectNextOption',
        value: function selectNextOption() {
            var index = this.getIndexById(this.$ctrl.$modelValue);
            this.update(this.options[(index + 1) % this.options.length]);
        }
    }, {
        key: 'update',
        value: function update(option) {
            this.$ctrl.$setViewValue(option.value);
            this.$ctrl.$render();
        }
    }]);

    return OptionSelectController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAOptionSelect',
    template: __WEBPACK_IMPORTED_MODULE_2__option_select_tpl_pug___default()(),
    controller: OptionSelectController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        id: '<ngModel',
        options: '<',
        disabled: '<'
    }
});

/***/ }),

/***/ "B2J5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Wifi-b229ab6183f1df53.svg";

/***/ }),

/***/ "BYmK":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdb-a-text-notification image-url=\"$ctrl.imageUrl\" data-title=\"$ctrl.title\" message=\"$ctrl.message\"\u003E\u003C\u002Fdb-a-text-notification\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "BgnQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_cmpt__ = __webpack_require__("ZGK3");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.notifications.component.notification', []).component(__WEBPACK_IMPORTED_MODULE_1__notification_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__notification_cmpt__["a" /* default */]));

/***/ }),

/***/ "BhGz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_color_cmpt__ = __webpack_require__("g2IO");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.category-color', []).component(__WEBPACK_IMPORTED_MODULE_1__category_color_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__category_color_cmpt__["a" /* default */]));

/***/ }),

/***/ "BjW1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_header__ = __webpack_require__("8wd7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_side_bar__ = __webpack_require__("kui2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar_day__ = __webpack_require__("Gvex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar_dashboard__ = __webpack_require__("t145");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__calendar_navigation__ = __webpack_require__("fpgH");








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component', [__WEBPACK_IMPORTED_MODULE_1__calendar_header__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__calendar_side_bar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__calendar_day__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__calendar_dashboard__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__calendar_navigation__["a" /* default */].name]));

/***/ }),

/***/ "BsFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_application_util_transaction_util__ = __webpack_require__("vu3g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_application_util_category_util__ = __webpack_require__("XzH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__image_icon_image_svg__ = __webpack_require__("7OSm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__image_icon_image_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__image_icon_image_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_list_modal_style_sass__ = __webpack_require__("o7lu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_list_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__event_list_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__event_list_modal_tpl_pug__ = __webpack_require__("x/nr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__event_list_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__event_list_modal_tpl_pug__);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












var EventListModalController = function () {
    EventListModalController.$inject = ['$q', 'eventUtil', 'storageService'];

    /* @ngInject */
    function EventListModalController($q, eventUtil, storageService) {
        _classCallCheck(this, EventListModalController);

        this.$q = $q;
        this.eventUtil = eventUtil;
        this.storageService = storageService;
        this.receiptIconUrl = 'url(' + __WEBPACK_IMPORTED_MODULE_7__image_icon_image_svg___default.a + ')';

        this.groups = [];
    }

    _createClass(EventListModalController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.timestamp || changeObject.events) {
                var categoryIconStyle = this.storageService.getUserItem('category-icon-style') || 'icons';
                this.useCategoryIcons = categoryIconStyle === 'icons';
            }

            if (changeObject.timestamp) {
                this.date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.timestamp ? this.timestamp : null).format('MMMM D');
            }

            if (changeObject.events) {
                var events = changeObject.events.currentValue || [];

                var confirmedEvents = this.getEventsByConfirmation(events, true);
                var unconfirmedEvents = this.getEventsByConfirmation(events, false);

                this.groups = __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()([{
                    name: 'Unconfirmed transactions',
                    value: this.getTotalValueOfEvents(unconfirmedEvents),
                    events: unconfirmedEvents
                }, {
                    name: 'Confirmed transactions',
                    value: this.getTotalValueOfEvents(confirmedEvents),
                    events: confirmedEvents
                }], function (group) {
                    return group.events.length > 0;
                });
            }
        }
    }, {
        key: 'isBalanceUpdate',
        value: function isBalanceUpdate(event) {
            return event && Object(__WEBPACK_IMPORTED_MODULE_6_application_util_category_util__["b" /* isCategoryBalanceUpdate */])(event.category);
        }
    }, {
        key: 'getTotalValueOfEvents',
        value: function getTotalValueOfEvents(events) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(events, function (value, event) {
                return value + _this.eventUtil.getValue(event.type, event.value);
            }, 0);
        }
    }, {
        key: 'getEventsByConfirmation',
        value: function getEventsByConfirmation(events, confirmed) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(events, function (event) {
                return event.confirmed === confirmed;
            }), function (event) {
                return __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, event, {
                    actualNote: Object(__WEBPACK_IMPORTED_MODULE_5_application_util_transaction_util__["f" /* getTransactionNote */])(event.note, event.type, event.category),
                    actualValue: _this2.eventUtil.getValue(event.type, event.value)
                });
            });
        }
    }, {
        key: 'addEvent',
        value: function addEvent() {
            return this.onTransactionCreate({
                data: this.timestamp
            });
        }
    }, {
        key: 'openEvent',
        value: function openEvent(transaction) {
            return this.onTransactionEdit({
                data: transaction
            });
        }
    }, {
        key: 'toggleConfirmation',
        value: function toggleConfirmation(transaction) {
            transaction = __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, transaction, {
                confirmed: !transaction.confirmed
            });

            var promise = this.onTransactionConfirmChange({
                data: transaction
            });

            return this.$q.when(promise).catch(function () {
                return null;
            });
        }
    }]);

    return EventListModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEventListModal',
    template: __WEBPACK_IMPORTED_MODULE_9__event_list_modal_tpl_pug___default()(),
    controller: EventListModalController,
    bindings: {
        timestamp: '<',
        change: '<',
        balance: '<',
        events: '<',

        canAddEvent: '<',

        onTransactionCreate: '&',
        onTransactionEdit: '&',
        onTransactionConfirmChange: '&'
    }
});

/***/ }),

/***/ "BtV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_application_util_time_util__ = __webpack_require__("S2sh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_style_sass__ = __webpack_require__("n4aM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__account_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_tpl_pug__ = __webpack_require__("RT6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__account_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var AccountSettingsController = function () {
    AccountSettingsController.$inject = ['$q', '$state', 'sessionService', 'emailVerificationService', 'profileService', 'notificationService', 'modalService'];

    /* @ngInject */
    function AccountSettingsController($q, $state, sessionService, emailVerificationService, profileService, notificationService, modalService) {
        _classCallCheck(this, AccountSettingsController);

        this.$q = $q;
        this.$state = $state;
        this.sessionService = sessionService;
        this.emailVerificationService = emailVerificationService;
        this.profileService = profileService;
        this.notificationService = notificationService;
        this.modalService = modalService;

        this.currentPassword = null;
        this.newPassword = null;
    }

    _createClass(AccountSettingsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;

            return this.sessionService.reload().then(function (session) {
                var user = session.user;


                _this.name = user.name;
                _this.email = user.email;
                _this.originalEmail = _this.email;
                _this.expirationDate = user.verified ? null : user.expirationDate;
                _this.expired = _this.expirationDate && Object(__WEBPACK_IMPORTED_MODULE_1_application_util_time_util__["c" /* getNow */])() > _this.expirationDate;

                // Check if restore action is requested via URL parameter
                if (_this.$state.params.action === 'restore') {
                    return _this.$state.go('authorized.calendar.settings.data', {
                        action: 'restore'
                    });
                }
            }).catch(function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_2_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to retrieve your account settings.'));
            }).finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'save',
        value: function save(name, email, form) {
            var _this2 = this;

            if (this.isEmailChanged) {
                return this.modalService.open({
                    component: 'dbAConfirmModal',
                    bindings: {
                        title: 'Change email address',
                        message: ['You are about to change current the email address (' + this.originalEmail + ') associated with this account to ' + email + '.', 'An email will be sent to ' + email + ' to confirm the request.'],
                        primaryButton: ['Update', 'Updating...'],
                        onClose: function onClose() {
                            return _this2.update(name, email, form).then(function () {
                                _this2.email = _this2.originalEmail;
                                _this2.notificationService.showInfo('An email has been sent to ' + email + ' to confirm the email address change.', null, true, 10000);
                            });
                        }
                    }
                }).catch(function () {
                    return null;
                });
            }

            return this.update(name, email, form).then(function () {
                _this2.notificationService.showInfo('Your name has been updated.', null, true, 5000);
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'update',
        value: function update(name, email, form) {
            var _this3 = this;

            return this.profileService.save({
                name: name,
                email: email
            }).then(function () {
                form.$setPristine();
            }).catch(function (result) {
                _this3.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_2_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to update your account information.'));
                return _this3.$q.reject(result);
            });
        }
    }, {
        key: 'updatePassword',
        value: function updatePassword(currentPassword, newPassword, form) {
            var _this4 = this;

            return this.profileService.updatePassword(currentPassword, newPassword).then(function () {
                form.$setPristine();

                _this4.currentPassword = null;
                _this4.newPassword = null;

                _this4.notificationService.showInfo('You password has been updated.');

                __WEBPACK_IMPORTED_MODULE_0_common_analytics__["c" /* default */].trackProfilePasswordChange();
            }, function (result) {
                _this4.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_2_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to update your password.'));
            });
        }
    }, {
        key: 'sendVerificationEmail',
        value: function sendVerificationEmail() {
            var _this5 = this;

            return this.emailVerificationService.send(this.email).then(function () {
                _this5.confirmationEmailSent = true;

                _this5.notificationService.showInfo('The email has been sent to your inbox.', null, true, 3000);
            }).catch(function (result) {
                _this5.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_2_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to send you the account activation email. Please try again later.'));
            });
        }
    }, {
        key: 'deleteAccount',
        value: function deleteAccount() {
            var _this6 = this;

            this.sessionService.deleteAccount().then(function () {
                _this6.$state.go('identity.sign-in');
                _this6.notificationService.showInfo('Your account and data has been deleted.', null, true, 3000);
            }).catch(function () {
                _this6.notificationService.showError('We were not able to delete your account. Please try again later.');
            });
        }
    }, {
        key: 'isEmailChanged',
        get: function get() {
            return this.email !== this.originalEmail;
        }
    }]);

    return AccountSettingsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAAccountSettings',
    template: __WEBPACK_IMPORTED_MODULE_4__account_tpl_pug___default()(),
    controller: AccountSettingsController,
    bindings: {
        plan: '<'
    }
});

/***/ }),

/***/ "C0LB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = OutsideClickDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
OutsideClickDirective.$inject = ['$document', '$parse'];


var selector = 'dbAOutsideClick';

/* @ngInject */
function OutsideClickDirective($document, $parse) {
    return {
        restrict: 'A',

        link: function link(scope, element, attrs) {
            var click = $parse(attrs[selector]);

            $document.on('click', clickHandler);
            element.on('$destroy', function () {
                return $document.off('click', clickHandler);
            });

            function clickHandler(event) {
                if (element[0] !== event.target && !isChild(__WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(event.target))) {
                    scope.$applyAsync(click(scope));
                }
            }

            function isChild($element) {
                if (!$element || $element.length === 0) {
                    return false;
                }

                return $element[0] === element[0] ? true : isChild($element.parent());
            }
        }
    };
}

/***/ }),

/***/ "C67W":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"identity-page\"\u003E\u003Cdiv class=\"identity-content\"\u003E\u003Ca class=\"identity-logo\" href=\"javascript:void(0);\" ui-sref=\"landing\"\u003E\u003Cdb-logo\u003E\u003C\u002Fdb-logo\u003E\u003C\u002Fa\u003E\u003Cui-view class=\"block-component\"\u003E\u003C\u002Fui-view\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "C94H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_application_util_number_util__ = __webpack_require__("Cybx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__income_expense_chart_style_sass__ = __webpack_require__("u60v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__income_expense_chart_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__income_expense_chart_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__income_expense_chart_tpl_pug__ = __webpack_require__("22Zj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__income_expense_chart_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__income_expense_chart_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










var IncomeExpenseChartController = function () {
    IncomeExpenseChartController.$inject = ['dashboardService'];

    /* @ngInject */
    function IncomeExpenseChartController(dashboardService) {
        _classCallCheck(this, IncomeExpenseChartController);

        this.dashboardService = dashboardService;

        this.options = this.getChartOptions();
    }

    _createClass(IncomeExpenseChartController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loading = true;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.calendarIds || changeObject.year) {
                return this.load(this.calendarIds, __WEBPACK_IMPORTED_MODULE_1_moment___default()([this.year]).startOf('year').valueOf(), __WEBPACK_IMPORTED_MODULE_1_moment___default()([this.year]).endOf('year').valueOf());
            }
        }
    }, {
        key: 'getTooltipTitle',
        value: function getTooltipTitle(items, data) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.labels[items[0].index]).format('MMMM');
        }
    }, {
        key: 'getTooltipLabel',
        value: function getTooltipLabel(item, data) {
            var index = item.index;
            var datasetIndex = item.datasetIndex;

            // skip the one of the labels
            if (datasetIndex % 2 === 1) {
                return null;
            }

            var income = Object(__WEBPACK_IMPORTED_MODULE_2_application_util_number_util__["c" /* prettifyNumber */])(data.datasets[0].data[index], {
                preventShrink: true,
                pretty: true
            });

            var expense = Object(__WEBPACK_IMPORTED_MODULE_2_application_util_number_util__["c" /* prettifyNumber */])(data.datasets[1].data[index], {
                preventShrink: true,
                pretty: true
            });

            var change = Object(__WEBPACK_IMPORTED_MODULE_2_application_util_number_util__["c" /* prettifyNumber */])(data.datasets[0].data[index] - data.datasets[1].data[index], {
                preventShrink: true,
                addPositiveSign: true,
                pretty: true
            });

            return ['Income: ' + income, 'Expense: ' + expense, 'Change: ' + change];
        }
    }, {
        key: 'getBalanceTick',
        value: function getBalanceTick(label) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_application_util_number_util__["c" /* prettifyNumber */])(label);
        }
    }, {
        key: 'getMonthTick',
        value: function getMonthTick(label) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(label).format('MMM');
        }
    }, {
        key: 'getChartOptions',
        value: function getChartOptions() {
            return {
                layout: {
                    padding: {
                        left: 20,
                        top: 110
                    }
                },
                tooltips: {
                    yAlign: 'bottom',
                    callbacks: {
                        title: this.getTooltipTitle.bind(this),
                        label: this.getTooltipLabel.bind(this)
                    }
                },
                scales: {
                    yAxes: [{
                        gridLines: {
                            color: '#ebeced',
                            borderDash: [3, 5],
                            zeroLineColor: '#ebeced',
                            zeroLineBorderDash: [3, 5],
                            drawBorder: false,
                            drawTicks: false
                        },
                        ticks: {
                            padding: 30,
                            maxTicksLimit: 5,
                            suggestedMin: 0,
                            suggestedMax: 0,
                            beginAtZero: true,
                            callback: this.getBalanceTick.bind(this)
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false,
                            drawBorder: false,
                            drawTicks: false
                        },
                        ticks: {
                            maxTicksLimit: 12,
                            autoSkipPadding: 20,
                            padding: 15,
                            maxRotation: 0,
                            minRotation: 0,
                            callback: this.getMonthTick.bind(this)
                        },
                        barPercentage: 0.8,
                        categoryPercentage: 0.4
                    }]
                }
            };
        }
    }, {
        key: 'load',
        value: function load(calendarIds, start, end) {
            var _this = this;

            start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start);
            end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(end);

            this.loading = true;

            var labels = [];
            var income = [];
            var expense = [];

            return this.dashboardService.getIncomeExpenseData(calendarIds, start.isValid() ? start.valueOf() : null, end.valueOf()).then(function (dataSet) {
                __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(dataSet, function (month) {
                    labels.push(month.timestamp);
                    income.push(month.income);
                    expense.push(month.expense);
                });

                _this.error = null;
            }).catch(function (result) {
                _this.error = Object(__WEBPACK_IMPORTED_MODULE_3_application_util_error_util__["b" /* getErrorMessage */])(result, 'Unfortunately we couldn\'t load the chart data. Please try again later.');
            }).finally(function () {
                _this.data = {
                    labels: labels,
                    datasets: [_this.getDataSet(income, '#1196ea'), _this.getDataSet(expense, '#e55264')]
                };

                _this.loading = false;
            });
        }
    }, {
        key: 'getDataSet',
        value: function getDataSet(data, color) {
            return {
                data: data,
                fill: true,
                backgroundColor: color,
                hoverBackgroundColor: color
            };
        }
    }]);

    return IncomeExpenseChartController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAIncomeExpenseChart',
    template: __WEBPACK_IMPORTED_MODULE_5__income_expense_chart_tpl_pug___default()(),
    controller: IncomeExpenseChartController,
    bindings: {
        calendarIds: '<',
        year: '<'
    }
});

/***/ }),

/***/ "CBsE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date_modal_style_sass__ = __webpack_require__("0nUR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__date_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_modal_tpl_pug__ = __webpack_require__("Fy27");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__date_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var DateController = function () {
    function DateController() {
        _classCallCheck(this, DateController);
    }

    _createClass(DateController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.timestamp) {
                this.timestamp = changeObject.timestamp.currentValue;
            }
            if (changeObject.title) {
                this.title = changeObject.title.currentValue;
            }
        }
    }, {
        key: 'updateDate',
        value: function updateDate(timestamp) {
            this.timestamp = timestamp;
        }
    }, {
        key: 'checkDayDisabled',
        value: function checkDayDisabled(timestamp) {
            return this.onDayCheckDisabled({
                data: timestamp
            });
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            this.onDismiss();
        }
    }, {
        key: 'close',
        value: function close() {
            return this.onClose({
                data: this.timestamp
            });
        }
    }]);

    return DateController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbADateModal',
    template: __WEBPACK_IMPORTED_MODULE_1__date_modal_tpl_pug___default()(),
    controller: DateController,
    bindings: {
        title: '<',
        timestamp: '<',
        startOfWeek: '<',
        onDayCheckDisabled: '&',
        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "CFwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authorized_cmpt__ = __webpack_require__("xnPS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scene__ = __webpack_require__("wER3");
stateConfiguration.$inject = ['$stateProvider'];





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized', [__WEBPACK_IMPORTED_MODULE_2__scene__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_1__authorized_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__authorized_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized', {
        url: '',
        template: '<db-a-authorized class="block-component"></db-a-authorized>',
        redirectTo: 'authorized.calendar',
        data: {
            requires: {
                authentication: {
                    state: 'identity.sign-in',
                    keep: true
                }
            }
        }
    });
}

/***/ }),

/***/ "CNHz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-no-calendar-537641c56c7d7b4c.svg";

/***/ }),

/***/ "CROK":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"forgot-password-request-page\"\u003E\u003Cdiv class=\"form-validation\" ng-bind=\"$ctrl.error\" ng-show=\"$ctrl.error\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-box\"\u003E\u003Cdiv class=\"identity-title\"\u003EForgot password\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-form\"\u003E\u003Cform role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.send($ctrl.email)\"\u003E\u003Cdiv class=\"form-note\"\u003EA password reset link will be sent to your email address.\u003C\u002Fdiv\u003E\u003Cdiv class=\"control-group\"\u003E\u003Clabel class=\"control-icon\" for=\"email-control\"\u003E\u003Ci class=\"icon-dollarbird-email\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"email\" id=\"email-control\" name=\"email\" placeholder=\"email\" ng-model=\"$ctrl.email\" required\u003E\u003Clabel class=\"control-label\" for=\"email-control\"\u003EEmail\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"email-control\"\u003E\u003Cdb-a-validation-message key=\"email\"\u003EPlease provide a valid email address.\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your email address.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cbutton class=\"button button-block button-fill button-primary button-send-email\" type=\"submit\" db-a-async loading=\"form.$submitting\"\u003E\u003Cinitial\u003ESend\u003C\u002Finitial\u003E\u003Cloading\u003ESending...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-comment\"\u003E\u003Cspan\u003EGo back to \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"identity.sign-in\"\u003Elog in\u003C\u002Fa\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "CTIK":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"forgot-password-token-expired-page\"\u003E\u003Cdiv class=\"identity-box\"\u003E\u003Cdiv class=\"identity-form\"\u003E\u003Cdiv class=\"form-illustration\"\u003E\u003Cimg" + (" class=\"form-image\""+pug.attr("src", __webpack_require__("pv2Y"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-title\"\u003EThis link has expired\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-note\"\u003EPlease enter your email address so we can send you a new one.\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Ca class=\"button button-block button-fill button-primary button-sign-in\" href=\"javascript:void(0);\" ui-sref=\"identity.forgot-password.request\"\u003EEnter email address\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-comment\"\u003E\u003Cspan\u003EGo back to \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"identity.sign-in\"\u003Elog in\u003C\u002Fa\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "CYOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = EventValueKeyFilterDirective;
var selector = 'dbAEventValueKeyFilter';

/* @ngInject */
function EventValueKeyFilterDirective() {
    return {
        restrict: 'A',

        link: function link(scope, element) {
            var codes = [
            // +
            187,
            // -
            189,
            // e
            69];

            element.on('keydown', keyHandler);

            scope.$on('$destroy', function () {
                element.off('keydown', keyHandler);
            });

            function keyHandler(event) {
                var shouldIgnore = codes.indexOf(event.keyCode || event.which) >= 0;

                if (shouldIgnore) {
                    event.preventDefault();
                }

                return !shouldIgnore;
            }
        }
    };
}

/***/ }),

/***/ "CYse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_slice__ = __webpack_require__("bpPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__team_list_style_sass__ = __webpack_require__("nYk1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__team_list_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__team_list_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__team_list_tpl_pug__ = __webpack_require__("YEIi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__team_list_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__team_list_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var TeamListController = function () {
    TeamListController.$inject = ['$q'];

    /* @ngInject */
    function TeamListController($q) {
        _classCallCheck(this, TeamListController);

        this.$q = $q;
    }

    _createClass(TeamListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortableOptions = {
                animation: 100,
                onStart: this.startSort.bind(this),
                onEnd: this.endSort.bind(this)
            };
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.teams) {
                this.teams = __WEBPACK_IMPORTED_MODULE_0_lodash_slice___default()(this.teams || []);
            }
        }
    }, {
        key: 'isActive',
        value: function isActive(team) {
            return this.selected && team && this.selected.id === team.id;
        }
    }, {
        key: 'add',
        value: function add() {
            return this.onAdd();
        }
    }, {
        key: 'select',
        value: function select(team) {
            return this.onSelect({
                team: team
            });
        }
    }, {
        key: 'startSort',
        value: function startSort() {
            this.sorting = true;
        }
    }, {
        key: 'endSort',
        value: function endSort() {
            var _this = this;

            return this.$q.when(this.onReorder({
                order: __WEBPACK_IMPORTED_MODULE_0_lodash_slice___default()(this.teams)
            })).finally(function () {
                _this.sorting = false;
            });
        }
    }]);

    return TeamListController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbATeamList',
    template: __WEBPACK_IMPORTED_MODULE_2__team_list_tpl_pug___default()(),
    controller: TeamListController,
    bindings: {
        teams: '<',
        selected: '<',
        onSelect: '&',
        onAdd: '&',
        onReorder: '&'
    }
});

/***/ }),

/***/ "Cg2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = OnBlurDirective;
var selector = 'dbAOnBlur';

/* @ngInject */
function OnBlurDirective() {
    return {
        restrict: 'A',

        link: function link(scope, element, attrs) {
            element.on('blur', blurHandler);
            scope.$on('$destroy', function () {
                return element.off('blur', blurHandler);
            });

            function blurHandler() {
                scope.$applyAsync(function () {
                    return scope.$eval(attrs[selector]);
                });
            }
        }
    };
}

/***/ }),

/***/ "Cjxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jstimezonedetect__ = __webpack_require__("3Cio");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jstimezonedetect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jstimezonedetect__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var HEADER_AUTHORIZATION = 'Authorization';
var HEADER_PLATFORM = 'X-App-Platform';
var HEADER_VERSION = 'X-App-Version';
var HEADER_TIMEZONE = 'X-Timezone';
var HEADER_CONTENT_TYPE = 'Content-Type';

var CONTENT_TYPE_FORM_URLENCODED = 'application/x-www-form-urlencoded';

var MonitoringCategorizationService = function () {
    MonitoringCategorizationService.$inject = ['$http', '$q', 'apiService', 'configuration'];

    /* @ngInject */
    function MonitoringCategorizationService($http, $q, apiService, configuration) {
        _classCallCheck(this, MonitoringCategorizationService);

        this.$http = $http;
        this.$q = $q;
        this.apiService = apiService;
        this.configuration = configuration;
    }

    _createClass(MonitoringCategorizationService, [{
        key: 'categorizeLabel',
        value: function categorizeLabel(label, teamCategories, labelCategoryMap) {
            var normalizedLabel = this.normalizeLabel(label);

            if (!normalizedLabel) {
                return this.$q.reject();
            }

            if (!this.apiService.token) {
                return this.$q.reject();
            }

            var url = this.getBaseUrl() + '/categorize/label.php';
            var data = this.formEncode({
                label: normalizedLabel,
                teamCategories: JSON.stringify(teamCategories || []),
                labelCategoryMap: JSON.stringify(labelCategoryMap || [])
            });

            return this.$http.post(url, data, {
                headers: this.buildHeaders()
            }).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'buildHeaders',
        value: function buildHeaders() {
            var _ref;

            return _ref = {}, _defineProperty(_ref, HEADER_AUTHORIZATION, this.apiService.token), _defineProperty(_ref, HEADER_PLATFORM, this.configuration.monitoringPlatform || 'Web'), _defineProperty(_ref, HEADER_VERSION, this.configuration.version), _defineProperty(_ref, HEADER_TIMEZONE, __WEBPACK_IMPORTED_MODULE_0_jstimezonedetect___default.a.determine().name()), _defineProperty(_ref, HEADER_CONTENT_TYPE, CONTENT_TYPE_FORM_URLENCODED), _ref;
        }
    }, {
        key: 'getBaseUrl',
        value: function getBaseUrl() {
            if (true) {
                return this.configuration.monitoringApi || 'https://monitoring.dollarbird.co/v1';
            }

            return this.configuration.monitoringApiDev || this.configuration.monitoringApi || 'http://192.168.0.120:8100/v1';
        }
    }, {
        key: 'normalizeLabel',
        value: function normalizeLabel(label) {
            return String(label || '').trim().toLowerCase();
        }
    }, {
        key: 'formEncode',
        value: function formEncode(data) {
            return Object.keys(data).map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
            }).join('&');
        }
    }]);

    return MonitoringCategorizationService;
}();

/* harmony default export */ __webpack_exports__["a"] = (MonitoringCategorizationService);

/***/ }),

/***/ "ClCG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CusM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_ingest_token_modal_cmpt__ = __webpack_require__("TUTj");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.email-ingest-token-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__email_ingest_token_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__email_ingest_token_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "CwCP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__radio__ = __webpack_require__("ZiQG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox__ = __webpack_require__("OY7L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkmark__ = __webpack_require__("ssmE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__time__ = __webpack_require__("f0k0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__date__ = __webpack_require__("MSXc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__date_picker__ = __webpack_require__("5x40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__option_select__ = __webpack_require__("37nS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__switch__ = __webpack_require__("ZxY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validation_message__ = __webpack_require__("YlQy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_image__ = __webpack_require__("Th19");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pretty_number__ = __webpack_require__("AZn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__notifications__ = __webpack_require__("4bMO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modals__ = __webpack_require__("JCwK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cookie_notification__ = __webpack_require__("A2Xd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__search__ = __webpack_require__("ft5x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__team_radio__ = __webpack_require__("jGXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__calendar_checkbox__ = __webpack_require__("PEJn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__calendar_radio__ = __webpack_require__("2V0L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__category_icon__ = __webpack_require__("eWxN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__date_range_picker__ = __webpack_require__("/Rav");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__change_log__ = __webpack_require__("dV23");





















// import SelectModule from './select';
// import MultipleSelectModule from './multiple-select';



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component', [__WEBPACK_IMPORTED_MODULE_1__radio__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__checkbox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__checkmark__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__time__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__date__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__date_picker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__option_select__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__switch__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__validation_message__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__user_image__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__pretty_number__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__notifications__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_13__modals__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__cookie_notification__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_15__search__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_16__team_radio__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_17__calendar_checkbox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_18__calendar_radio__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_19__category_icon__["a" /* default */].name,
// SelectModule.name,
// MultipleSelectModule.name,
__WEBPACK_IMPORTED_MODULE_20__date_range_picker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_21__change_log__["a" /* default */].name]));

/***/ }),

/***/ "CwXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_palette_style_sass__ = __webpack_require__("MkRY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_palette_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__color_palette_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__color_palette_tpl_pug__ = __webpack_require__("8Jal");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__color_palette_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__color_palette_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var ColorPaletteController = function () {
    function ColorPaletteController() {
        _classCallCheck(this, ColorPaletteController);
    }

    _createClass(ColorPaletteController, [{
        key: '$onInit',
        value: function $onInit() {
            this.page = 0;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.colors && changeObject.colors.currentValue) {
                var colors = changeObject.colors.currentValue || [];

                this.colors = colors.map(function (color) {
                    return __WEBPACK_IMPORTED_MODULE_0_angular___default.a.merge({}, color);
                });
            }

            this.updateSelectedColor(this.colors || [], this.hex);
        }
    }, {
        key: 'updateSelectedColor',
        value: function updateSelectedColor(colors, hex) {
            colors.forEach(function (color) {
                color.selected = color.hex === hex;
            });
        }
    }, {
        key: 'goPreviousPage',
        value: function goPreviousPage() {
            if (this.page > 0) {
                this.page -= 1;
            }
        }
    }, {
        key: 'goNextPage',
        value: function goNextPage() {
            if (this.page < this.pageCount - 1) {
                this.page += 1;
            }
        }
    }, {
        key: 'select',
        value: function select(color) {
            if (!this.disabled) {
                this.$ctrl.$setViewValue(color.hex);

                return this.onChange({
                    color: color.hex
                });
            }
        }
    }, {
        key: 'pageSize',
        get: function get() {
            return (this.columns || 7) * (this.rows || 4);
        }
    }, {
        key: 'pageCount',
        get: function get() {
            if (!this.colors || this.colors.length === 0) {
                return 1;
            }

            return Math.ceil(this.colors.length / this.pageSize);
        }
    }, {
        key: 'visibleColors',
        get: function get() {
            var size = this.pageSize;
            var start = this.page * size;
            return (this.colors || []).slice(start, start + size);
        }
    }]);

    return ColorPaletteController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAColorPalette',
    template: __WEBPACK_IMPORTED_MODULE_2__color_palette_tpl_pug___default()(),
    controller: ColorPaletteController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        hex: '<ngModel',
        colors: '<',
        disabled: '<ngDisabled',
        rows: '<',
        columns: '<',
        onChange: '&'
    }
});

/***/ }),

/***/ "Cybx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _isNumeric; });
/* harmony export (immutable) */ __webpack_exports__["c"] = prettifyNumber;
/* unused harmony export localizeNumber */
/* harmony export (immutable) */ __webpack_exports__["d"] = toFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_num__ = __webpack_require__("Xn7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_num___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_num__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var NumberUtil = function () {
    function NumberUtil() {
        _classCallCheck(this, NumberUtil);
    }

    _createClass(NumberUtil, [{
        key: 'isNumeric',
        value: function isNumeric(number) {
            return _isNumeric(number);
        }
    }, {
        key: 'isInteger',
        value: function isInteger(number) {
            return parseInt(number) === number;
        }
    }, {
        key: 'numberify',
        value: function numberify(value) {
            value = value + ' ';
            return parseFloat(value.replace(/[^\d.-]/g, ''));
        }
    }, {
        key: 'convertToPercentage',
        value: function convertToPercentage(percent) {
            return Math.min(Math.max(percent, 0), 100);
        }
    }]);

    return NumberUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (NumberUtil);
function _isNumeric(number) {
    return !isNaN(parseFloat(number)) && isFinite(number);
}

var abbreviations = [{ symbol: 'Q', limit: 1e15 }, { symbol: 'T', limit: 1e12 }, { symbol: 'B', limit: 1e9 }, { symbol: 'M', limit: 1e6 }, { symbol: 'K', limit: 1e3 }];

function prettifyNumber(value, options) {
    value = Number(value);
    options = options || {};
    options.decimals = options.decimals == null ? 2 : options.decimals;

    if (!options.preventShrink && (options.limit == null || isValueOutsideTheLimit(value, options.limit))) {
        for (var index = 0; index < abbreviations.length; ++index) {
            var abbreviation = abbreviations[index];
            if (value <= -abbreviation.limit || abbreviation.limit <= value) {
                // it's a very large number
                return isValueOutsideTheLimit(value / abbreviation.limit, 10000) && index === 0 ? formatValue(toExponential(value / abbreviation.limit, 0), '', options) : formatValue(toFixed(value / abbreviation.limit, options.decimals), abbreviation.symbol, options);
            }
        }
    }

    return formatValue(toFixed(value, options.decimals), '', options);
}

function localizeNumber(value, decimals) {
    return value.toLocaleString([], {
        minimumFractionDigits: decimals || 0
    });
}

function isValueOutsideTheLimit(value, limit) {
    return value < -limit || value > limit;
}

function formatValue(value, symbol) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (value > 0 && options.addPositiveSign) {
        value = '+' + prettify(value, options);
    } else if (value < 0 && options.omitNegativeSign) {
        value = prettify(Math.abs(value, options));
    } else {
        value = prettify(value, options);
    }

    return '' + value + symbol;
}

function prettify(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return options.pretty ? localizeNumber(+value, options.decimals) : value;
}

// use custom toFixed instead of built-in Number.prototype.toFixed:
// - to prevent rounding up/down (e.g. -999.999 -> -1000)
// - to prevent floating point math (e.g. 8.95 * 100 -> 894.9999999999999)
function toFixed(value, decimals) {
    // since negative numbers are still not rounded properly (e.g. -4,076.9700000003 -> -4,076.98 instead of -4,076.97),
    // workaround the sign with this sorcery
    var absolute = Math.abs(value);
    var sign = value < 0 ? '-' : '';

    return sign + __WEBPACK_IMPORTED_MODULE_0_num___default()(absolute).set_precision(decimals || 0).toString();
}

function toExponential(value, decimals) {
    return Number.prototype.toExponential.call(value || 0, decimals);
}

/***/ }),

/***/ "D5dL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_15-f42716a4a6fd4b15.svg";

/***/ }),

/***/ "DChA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Calculator-e6a4a314adc38e43.svg";

/***/ }),

/***/ "DN1M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Chart.Platform implementation for targeting a web browser
 */



var helpers = __webpack_require__("iO9N");

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {Number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addEventListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeEventListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var resizer = document.createElement('div');
	var cls = CSS_PREFIX + 'size-monitor';
	var maxSize = 1000000;
	var style =
		'position:absolute;' +
		'left:0;' +
		'top:0;' +
		'right:0;' +
		'bottom:0;' +
		'overflow:hidden;' +
		'pointer-events:none;' +
		'visibility:hidden;' +
		'z-index:-1;';

	resizer.style.cssText = style;
	resizer.className = cls;
	resizer.innerHTML =
		'<div class="' + cls + '-expand" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:' + maxSize + 'px;' +
				'height:' + maxSize + 'px;' +
				'left:0;' +
				'top:0">' +
			'</div>' +
		'</div>' +
		'<div class="' + cls + '-shrink" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:200%;' +
				'height:200%;' +
				'left:0; ' +
				'top:0">' +
			'</div>' +
		'</div>';

	var expand = resizer.childNodes[0];
	var shrink = resizer.childNodes[1];

	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};
	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers.each(ANIMATION_START_EVENTS, function(type) {
		addEventListener(node, type, proxy);
	});

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			removeEventListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			return listener(createEvent('resize', chart));
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

function injectCSS(platform, css) {
	// http://stackoverflow.com/q/3922139
	var style = platform._style || document.createElement('style');
	if (!platform._style) {
		platform._style = style;
		css = '/* Chart.js */\n' + css;
		style.setAttribute('type', 'text/css');
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	style.appendChild(document.createTextNode(css));
}

module.exports = {
	initialize: function() {
		var keyframes = 'from{opacity:0.99}to{opacity:1}';

		injectCSS(this,
			// DOM rendering detection
			// https://davidwalsh.name/detect-node-insertion
			'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'.' + CSS_RENDER_MONITOR + '{' +
				'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
			'}'
		);
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addEventListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas, listener);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeEventListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.addEvent = addEventListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.removeEvent = removeEventListener;


/***/ }),

/***/ "DRWz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_18-3a9f3cbd3c2ced1c.svg";

/***/ }),

/***/ "Db81":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var moment = __webpack_require__("PJh5");
moment = typeof moment === 'function' ? moment : window.moment;

var defaults = __webpack_require__("k7DW");
var helpers = __webpack_require__("iO9N");

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		major: true,
		size: 1,
		steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
	},
	second: {
		major: true,
		size: 1000,
		steps: [1, 2, 5, 10, 30]
	},
	minute: {
		major: true,
		size: 60000,
		steps: [1, 2, 5, 10, 30]
	},
	hour: {
		major: true,
		size: 3600000,
		steps: [1, 2, 3, 6, 12]
	},
	day: {
		major: true,
		size: 86400000,
		steps: [1, 2, 5]
	},
	week: {
		major: false,
		size: 604800000,
		steps: [1, 2, 3, 4]
	},
	month: {
		major: true,
		size: 2.628e9,
		steps: [1, 2, 3]
	},
	quarter: {
		major: false,
		size: 7.884e9,
		steps: [1, 2, 3, 4]
	},
	year: {
		major: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

/**
 * Convert the given value to a moment object using the given time options.
 * @see http://momentjs.com/docs/#/parsing/
 */
function momentify(value, options) {
	var parser = options.parser;
	var format = options.parser || options.format;

	if (typeof parser === 'function') {
		return parser(value);
	}

	if (typeof value === 'string' && typeof format === 'string') {
		return moment(value, format);
	}

	if (!(value instanceof moment)) {
		value = moment(value);
	}

	if (value.isValid()) {
		return value;
	}

	// Labels are in an incompatible moment format and no `parser` has been provided.
	// The user might still use the deprecated `format` option to convert his inputs.
	if (typeof format === 'function') {
		return format(value);
	}

	return value;
}

function parse(input, scale) {
	if (helpers.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = momentify(scale.getRightValue(input), options);
	if (!value.isValid()) {
		return null;
	}

	if (options.round) {
		value.startOf(options.round);
	}

	return value.valueOf();
}

/**
 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
 */
function determineStepSize(min, max, unit, capacity) {
	var range = max - min;
	var interval = INTERVALS[unit];
	var milliseconds = interval.size;
	var steps = interval.steps;
	var i, ilen, factor;

	if (!steps) {
		return Math.ceil(range / ((capacity || 1) * milliseconds));
	}

	for (i = 0, ilen = steps.length; i < ilen; ++i) {
		factor = steps[i];
		if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
			break;
		}
	}

	return factor;
}

function determineUnit(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

		if (Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].major) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(min, max, minor, major, capacity, options) {
	var stepSize = helpers.valueOrDefault(options.stepSize, options.unitStepSize);
	var weekday = minor === 'week' ? options.isoWeekday : false;
	var interval = INTERVALS[minor];
	var first = moment(min);
	var last = moment(max);
	var ticks = [];
	var time;

	if (!stepSize) {
		stepSize = determineStepSize(min, max, minor, capacity);
	}

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = first.isoWeekday(weekday);
		last = last.isoWeekday(weekday);
	}

	// Align first/last ticks on unit
	first = first.startOf(weekday ? 'day' : minor);
	last = last.startOf(weekday ? 'day' : minor);

	// Make sure that the last tick include max
	if (last < max) {
		last.add(1, minor);
	}

	time = moment(first);

	if (major && !weekday && !options.round) {
		// Align the first tick on the previous `minor` unit aligned on the `major` unit:
		// we first aligned time on the previous `major` unit then add the number of full
		// stepSize there is between first and the previous major time.
		time.startOf(major);
		time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
	}

	for (; time < last; time.add(stepSize, minor)) {
		ticks.push(+time);
	}

	ticks.push(+time);

	return ticks;
}

/**
 * Returns the right and left offsets from edges in the form of {left, right}.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var left = 0;
	var right = 0;
	var upper, lower;

	if (options.offset && ticks.length) {
		if (!options.time.min) {
			upper = ticks.length > 1 ? ticks[1] : max;
			lower = ticks[0];
			left = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
		if (!options.time.max) {
			upper = ticks[ticks.length - 1];
			lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
			right = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
	}

	return {left: left, right: right};
}

function ticksFromTimestamps(values, majorUnit) {
	var ticks = [];
	var i, ilen, value, major;

	for (i = 0, ilen = values.length; i < ilen; ++i) {
		value = values[i];
		major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;

		ticks.push({
			value: value,
			major: major
		});
	}

	return ticks;
}

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'bottom',

		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',

		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',

		time: {
			parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',

			// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
			displayFormats: {
				millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
				second: 'h:mm:ss a', // 11:20:01 AM
				minute: 'h:mm a', // 11:20 AM
				hour: 'hA', // 5PM
				day: 'MMM D', // Sep 4
				week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
				month: 'MMM YYYY', // Sept 2015
				quarter: '[Q]Q - YYYY', // Q3
				year: 'YYYY' // 2015
			},
		},
		ticks: {
			autoSkip: false,

			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto'
		}
	};

	var TimeScale = Chart.Scale.extend({
		initialize: function() {
			if (!moment) {
				throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
			}

			this.mergeTicksOptions();

			Chart.Scale.prototype.initialize.call(this);
		},

		update: function() {
			var me = this;
			var options = me.options;

			// DEPRECATIONS: output a message only one time per update
			if (options.time && options.time.format) {
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			}

			return Chart.Scale.prototype.update.apply(me, arguments);
		},

		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return Chart.Scale.prototype.getRightValue.call(this, rawValue);
		},

		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var timeOpts = me.options.time;
			var min = parse(timeOpts.min, me) || MAX_INTEGER;
			var max = parse(timeOpts.max, me) || MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp;

			// Convert labels to timestamps
			for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
				labels.push(parse(chart.data.labels[i], me));
			}

			// Convert data to timestamps
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;

					// Let's consider that all data have the same format.
					if (helpers.isObject(data[0])) {
						datasets[i] = [];

						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(data[j], me);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						timestamps.push.apply(timestamps, labels);
						datasets[i] = labels.slice(0);
					}
				} else {
					datasets[i] = [];
				}
			}

			if (labels.length) {
				// Sort labels **after** data have been converted
				labels = arrayUnique(labels).sort(sorter);
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}

			if (timestamps.length) {
				timestamps = arrayUnique(timestamps).sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}

			// In case there is no valid min/max, let's use today limits
			min = min === MAX_INTEGER ? +moment().startOf('day') : min;
			max = max === MIN_INTEGER ? +moment().endOf('day') + 1 : max;

			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);

			// PRIVATE
			me._horizontal = me.isHorizontal();
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},

		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var timeOpts = options.time;
			var formats = timeOpts.displayFormats;
			var capacity = me.getLabelCapacity(min);
			var unit = timeOpts.unit || determineUnit(timeOpts.minUnit, min, max, capacity);
			var majorUnit = determineMajorUnit(unit);
			var timestamps = [];
			var ticks = [];
			var i, ilen, timestamp;

			switch (options.ticks.source) {
			case 'data':
				timestamps = me._timestamps.data;
				break;
			case 'labels':
				timestamps = me._timestamps.labels;
				break;
			case 'auto':
			default:
				timestamps = generate(min, max, unit, majorUnit, capacity, timeOpts);
			}

			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}

			// Enforce limits with user min/max options
			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}

			me.min = min;
			me.max = max;

			// PRIVATE
			me._unit = unit;
			me._majorUnit = majorUnit;
			me._minorFormat = formats[unit];
			me._majorFormat = formats[majorUnit];
			me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);

			return ticksFromTimestamps(ticks, majorUnit);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];

			if (helpers.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				label = momentify(label, timeOpts).format(timeOpts.tooltipFormat);
			}

			return label;
		},

		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(tick, index, ticks) {
			var me = this;
			var options = me.options;
			var time = tick.valueOf();
			var majorUnit = me._majorUnit;
			var majorFormat = me._majorFormat;
			var majorTime = tick.clone().startOf(me._majorUnit).valueOf();
			var major = majorUnit && majorFormat && time === majorTime;
			var label = tick.format(major ? majorFormat : me._minorFormat);
			var tickOpts = major ? options.ticks.major : options.ticks.minor;
			var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);

			return formatter ? formatter(label, index, ticks) : label;
		},

		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
			}

			return labels;
		},

		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = interpolate(me._table, 'time', time, 'pos');

			return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
		},

		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;

			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}

			if (time === null) {
				time = parse(value, me);
			}

			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},

		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
			var time = interpolate(me._table, 'pos', pos, 'time');

			return moment(time);
		},

		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers.toRadians(ticksOpts.maxRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);

			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},

		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;

			me._minorFormat = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation

			var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, []);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);
			var innerWidth = me.isHorizontal() ? me.width : me.height;

			return Math.floor(innerWidth / tickLabelWidth);
		}
	});

	Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
};


/***/ }),

/***/ "DgF8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card-with-period":"card-with-period","chart-period":"chart-period","chart-period-items":"chart-period-items","chart-confirmed-filter":"chart-confirmed-filter","chart-period-item":"chart-period-item","chart-custom-range-tooltip":"chart-custom-range-tooltip"};

/***/ }),

/***/ "Dvy5":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Clabel class=\"switch\" ng-class=\"{ toggled: $ctrl.toggled, disabled: $ctrl.disabled }\"\u003E\u003Cspan class=\"switch-label\" ng-transclude\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"switch-control\"\u003E\u003Cinput class=\"input-checkbox\" type=\"checkbox\" ng-model=\"$ctrl.toggled\" ng-change=\"$ctrl.change()\" ng-disabled=\"$ctrl.disabled\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "E61u":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdb-a-notification class=\"event-limit-notification\"\u003E\u003Cnotification-title\u003ESubscribe to continue adding transactions\u003C\u002Fnotification-title\u003E\u003Cnotification-content\u003E\u003Cdiv class=\"subscription-description\" ng-if=\"$ctrl.plan.free\"\u003EDollarbird no longer offers a free plan so please support us and subscribe to one of our paid plans to add more transactions past the daily limit.\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-description\" ng-if=\"!$ctrl.plan.free\"\u003EDollarbird no longer offers a free plan so please support us and subscribe to one of our paid plans to add more transactions past the daily limit.\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-buttons\"\u003E\u003Ca class=\"button button-block button-fill button-primary button-subscription button-event-limit\" href=\"javascript:void(0);\" ui-sref=\"authorized.subscribe\" ng-click=\"$ctrl.renew()\" ng-if=\"$ctrl.plan.free\"\u003EGo premium \u003C\u002Fa\u003E\u003Ca class=\"button button-block button-fill button-primary button-subscription button-event-limit\" href=\"javascript:void(0);\" ui-sref=\"authorized.subscribe\" ng-click=\"$ctrl.renew()\" ng-if=\"!$ctrl.plan.free\"\u003ERenew subscription\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnotification-content\u003E\u003C\u002Fdb-a-notification\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "EBDT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_style_sass__ = __webpack_require__("eL07");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__date_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__date_tpl_pug__ = __webpack_require__("iZDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__date_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__date_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var DateController = function () {
    function DateController() {
        _classCallCheck(this, DateController);
    }

    _createClass(DateController, [{
        key: '$onInit',
        value: function $onInit() {
            this.$ctrl.$formatters.push(this.formatter.bind(this));
            this.$ctrl.$parsers.push(this.parser.bind(this));
            this.$ctrl.$render = this.render.bind(this);
        }
    }, {
        key: 'formatter',
        value: function formatter(value) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('MMMM D YYYY');
        }
    }, {
        key: 'parser',
        value: function parser(value) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, 'MMMM D YYYY').valueOf();
        }
    }, {
        key: 'render',
        value: function render() {
            this.value = this.$ctrl.$viewValue;
        }
    }, {
        key: 'click',
        value: function click() {
            if (!this.disabled) {
                return this.onClick();
            }
        }
    }]);

    return DateController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbADate',
    template: __WEBPACK_IMPORTED_MODULE_2__date_tpl_pug___default()(),
    controller: DateController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        disabled: '<',
        onClick: '&'
    }
});

/***/ }),

/***/ "EC5N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EU2A":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-checkbox\" ng-class=\"{ selected: $ctrl.selected }\"\u003E\u003Cdb-a-checkbox class=\"calendar-checkbox-state\" selected=\"$ctrl.selected\"\u003E\u003C\u002Fdb-a-checkbox\u003E\u003Cdiv class=\"calendar-checkbox-name\" ng-bind=\"$ctrl.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "EWC9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribe_cmpt__ = __webpack_require__("sV5L");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.subscribe', []).component(__WEBPACK_IMPORTED_MODULE_1__subscribe_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__subscribe_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.subscribe', {
        url: '/subscribe',
        component: __WEBPACK_IMPORTED_MODULE_1__subscribe_cmpt__["a" /* default */].selector
    });
}

/***/ }),

/***/ "F1Zx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-color":"category-color","filled":"filled"};

/***/ }),

/***/ "F4U8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("3n1n");

/**
 * @namespace Chart.helpers.canvas
 */
var exports = module.exports = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {Number} width - The rectangle's width.
	 * @param {Number} height - The rectangle's height.
	 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var rx = Math.min(radius, width / 2);
			var ry = Math.min(radius, height / 2);

			ctx.moveTo(x + rx, y);
			ctx.lineTo(x + width - rx, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
			ctx.lineTo(x + width, y + height - ry);
			ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
			ctx.lineTo(x + rx, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
			ctx.lineTo(x, y + ry);
			ctx.quadraticCurveTo(x, y, x + rx, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y) {
		var type, edgeLength, xOffset, yOffset, height, size;

		if (typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		switch (style) {
		// Default includes circle
		default:
			ctx.beginPath();
			ctx.arc(x, y, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'triangle':
			ctx.beginPath();
			edgeLength = 3 * radius / Math.sqrt(3);
			height = edgeLength * Math.sqrt(3) / 2;
			ctx.moveTo(x - edgeLength / 2, y + height / 3);
			ctx.lineTo(x + edgeLength / 2, y + height / 3);
			ctx.lineTo(x, y - 2 * height / 3);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rect':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
			ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
			break;
		case 'rectRounded':
			var offset = radius / Math.SQRT2;
			var leftX = x - offset;
			var topY = y - offset;
			var sideSize = Math.SQRT2 * radius;
			ctx.beginPath();
			this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rectRot':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.moveTo(x - size, y);
			ctx.lineTo(x, y + size);
			ctx.lineTo(x + size, y);
			ctx.lineTo(x, y - size);
			ctx.closePath();
			ctx.fill();
			break;
		case 'cross':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'crossRot':
			ctx.beginPath();
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'star':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'line':
			ctx.beginPath();
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'dash':
			ctx.beginPath();
			ctx.moveTo(x, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		}

		ctx.stroke();
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		if (target.steppedLine) {
			if (target.steppedLine === 'after') {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.clear = exports.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports.roundedRect.apply(exports, arguments);
	ctx.closePath();
};


/***/ }),

/***/ "F82N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie_notification_style_sass__ = __webpack_require__("gZSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie_notification_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__cookie_notification_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookie_notification_tpl_pug__ = __webpack_require__("WDWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookie_notification_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cookie_notification_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CookieNotificationController = function () {
    CookieNotificationController.$inject = ['$timeout', 'storageService'];

    /* @ngInject */
    function CookieNotificationController($timeout, storageService) {
        _classCallCheck(this, CookieNotificationController);

        this.$timeout = $timeout;
        this.storageService = storageService;
    }

    _createClass(CookieNotificationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.exists = true;
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            this.$timeout(function () {
                _this.visible = !_this.storageService.getItem('cp');
                _this.exists = _this.visible;
            }, 0);
        }
    }, {
        key: 'acknowledge',
        value: function acknowledge() {
            this.storageService.setItem('cp', Date.now());
            this.visible = false;
        }
    }]);

    return CookieNotificationController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACookieNotification',
    template: __WEBPACK_IMPORTED_MODULE_1__cookie_notification_tpl_pug___default()(),
    controller: CookieNotificationController
});

/***/ }),

/***/ "FDK5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");
var helpers = __webpack_require__("iO9N");

var globalDefaults = defaults.global;

defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

module.exports = Element.extend({
	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var index, current, previous, currentVM;

		// If we are looping, adding the first point again
		if (me._loop && points.length) {
			points.push(points[0]);
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();
		lastDrawnIndex = -1;

		for (index = 0; index < points.length; ++index) {
			current = points[index];
			previous = helpers.previousItem(points, index);
			currentVM = current._view;

			// First point moves to it's starting position no matter what
			if (index === 0) {
				if (!currentVM.skip) {
					ctx.moveTo(currentVM.x, currentVM.y);
					lastDrawnIndex = index;
				}
			} else {
				previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers.canvas.lineTo(ctx, previous._view, current._view);
					}
					lastDrawnIndex = index;
				}
			}
		}

		ctx.stroke();
		ctx.restore();
	}
});


/***/ }),

/***/ "FLLW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_verification_request_cmpt__ = __webpack_require__("xnjY");
errorResolve.$inject = ['$transition$'];
emailResolve.$inject = ['$transition$'];
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.email-verification.request', []).component(__WEBPACK_IMPORTED_MODULE_1__email_verification_request_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__email_verification_request_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.email-verification.request', {
        url: '/re-send',
        component: __WEBPACK_IMPORTED_MODULE_1__email_verification_request_cmpt__["a" /* default */].selector,
        params: {
            email: null,
            error: null
        },
        resolve: {
            email: emailResolve,
            error: errorResolve
        }
    });
}

/* @ngInject */
function emailResolve($transition$) {
    var params = $transition$.params() || {};
    return params.email || null;
}

/* @ngInject */
function errorResolve($transition$) {
    var params = $transition$.params() || {};
    return params.error || null;
}

/***/ }),

/***/ "FnIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_edit_modal_style_sass__ = __webpack_require__("Ntdr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_edit_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_edit_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_edit_modal_tpl_pug__ = __webpack_require__("l/ov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_edit_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__calendar_edit_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var CalendarEditModalController = function () {
    CalendarEditModalController.$inject = ['$q', 'modalService', 'calendarService', 'categoryService', 'notificationService'];

    /* @ngInject */
    function CalendarEditModalController($q, modalService, calendarService, categoryService, notificationService) {
        _classCallCheck(this, CalendarEditModalController);

        this.$q = $q;
        this.modalService = modalService;
        this.calendarService = calendarService;
        this.categoryService = categoryService;
        this.notificationService = notificationService;
    }

    _createClass(CalendarEditModalController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.existing = this.calendar && this.calendar.id;
            this.loading = true;
            this.accountsInput = this.formatAccounts(this.calendar.accounts);

            if (typeof this.calendar.useAutoForecasting === 'undefined') {
                this.calendar.useAutoForecasting = false;
            }

            return this.categoryService.getPalette().then(function (colors) {
                _this.colors = (colors || []).map(function (color) {
                    return { hex: color };
                });
                if (!_this.calendar.color && _this.colors.length > 0) {
                    _this.calendar.color = _this.colors[0].hex;
                }
            }).catch(function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to load the color palette. Please try again later.'));
            }).finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'formatAccounts',
        value: function formatAccounts(accounts) {
            if (!accounts || accounts.length === 0) {
                return '';
            }

            return accounts.map(function (account) {
                return account && account.name;
            }).filter(function (name) {
                return !!name;
            }).join('\n');
        }
    }, {
        key: 'parseAccounts',
        value: function parseAccounts(accountsInput) {
            if (!accountsInput) {
                return [];
            }

            return accountsInput.split('\n').map(function (account) {
                return account.trim();
            }).filter(function (account) {
                return account.length > 0;
            }).map(function (name) {
                return { name: name };
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.calendar.accounts = this.parseAccounts(this.accountsInput);

            var promise = this.existing ? this.calendarService.update(this.calendar) : this.calendarService.create(this.teamId, this.calendar);

            return promise.then(this.close.bind(this)).catch(function (result) {
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to save the calendar.'));
            });
        }
    }, {
        key: 'close',
        value: function close(calendar) {
            return this.onClose({
                data: calendar
            });
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            return this.onDismiss();
        }
    }]);

    return CalendarEditModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarEditModal',
    template: __WEBPACK_IMPORTED_MODULE_2__calendar_edit_modal_tpl_pug___default()(),
    controller: CalendarEditModalController,
    bindings: {
        teamId: '<',
        calendar: '<',

        onDismiss: '&',
        onClose: '&'
    }
});

/***/ }),

/***/ "FoJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_event_report_util__ = __webpack_require__("NLyG");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var TransferService = function () {
    TransferService.$inject = ['apiService'];

    /* @ngInject */
    function TransferService(apiService) {
        _classCallCheck(this, TransferService);

        this.apiService = apiService;
    }

    _createClass(TransferService, [{
        key: 'create',
        value: function create(calendarId, event) {
            return this.apiService.post('/calendars/' + calendarId + '/transactions/transfers', Object(__WEBPACK_IMPORTED_MODULE_0_application_util_event_report_util__["c" /* toEventPayload */])(event, false)).then(function (result) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_application_util_event_report_util__["b" /* normalizeIncludeInReports */])(result.data);
            });
        }
    }]);

    return TransferService;
}();

/* harmony default export */ __webpack_exports__["a"] = (TransferService);

/***/ }),

/***/ "FtNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_radio_style_sass__ = __webpack_require__("h3dC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_radio_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__calendar_radio_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_radio_tpl_pug__ = __webpack_require__("V164");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_radio_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_radio_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarRadio',
    template: __WEBPACK_IMPORTED_MODULE_1__calendar_radio_tpl_pug___default()(),
    bindings: {
        name: '<',
        selected: '<'
    }
});

/***/ }),

/***/ "Fv8P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var elements = __webpack_require__("L5rj");
var helpers = __webpack_require__("iO9N");

defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.polarArea = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var meta = me.getMeta();
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
			chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;

			meta.count = me.countVisibleElements();

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;

			var circumference = me.calculateCircumference(dataset.data[index]);
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// If there is NaN data before us, we need to calculate the starting angle correctly.
			// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
			var visibleCount = 0;
			var meta = me.getMeta();
			for (var i = 0; i < index; ++i) {
				if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
					++visibleCount;
				}
			}

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = datasetStartAngle + (circumference * visibleCount);
			var endAngle = startAngle + (arc.hidden ? 0 : circumference);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			// Apply border and fill style
			me.removeHoverStyle(arc);

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		calculateCircumference: function(value) {
			var count = this.getMeta().count;
			if (count > 0 && !isNaN(value)) {
				return (2 * Math.PI) / count;
			}
			return 0;
		}
	});
};


/***/ }),

/***/ "Fy27":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"date-modal modal-fixed-height\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\" ng-bind=\"$ctrl.title\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter modal-section\"\u003E\u003Cdb-a-date-picker class=\"date-container\" timestamp=\"$ctrl.timestamp\" start-of-week=\"$ctrl.startOfWeek\" on-day-check-disabled=\"$ctrl.checkDayDisabled(timestamp)\" on-day-select=\"$ctrl.updateDate(timestamp)\"\u003E\u003C\u002Fdb-a-date-picker\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-save-date\" type=\"button\" ng-click=\"$ctrl.close()\"\u003EDone\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "G/3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge__ = __webpack_require__("HN2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chart_style_sass__ = __webpack_require__("U0Im");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chart_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__chart_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_tpl_pug__ = __webpack_require__("MGI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__chart_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







__WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()(__WEBPACK_IMPORTED_MODULE_1_chart_js___default.a.defaults.global, {
    legend: {
        display: false
    },
    hover: {
        mode: 'index',
        intersect: false
    },
    tooltips: {
        position: 'average',
        mode: 'index',
        intersect: false,
        backgroundColor: '#fff',
        borderWidth: 1,
        borderColor: '#ebeced',
        xPadding: 15,
        yPadding: 15,
        titleFontStyle: 'bold',
        titleFontColor: '#394852',
        titleMarginBottom: 13,
        bodyFontStyle: 'normal',
        bodySpacing: 10,
        displayColors: false,
        caretSize: 8,
        caretPadding: 10,
        cornerRadius: 4
    },
    defaultFontFamily: '\'Open Sans\', sans-serif',
    defaultFontSize: 14
});

var ChartController = function () {
    ChartController.$inject = ['$q', '$element'];

    /* @ngInject */
    function ChartController($q, $element) {
        _classCallCheck(this, ChartController);

        this.$q = $q;
        this.$element = $element;

        this.chartPromise = this.$q.defer();
    }

    _createClass(ChartController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            var _this = this;

            if (changeObject.data && this.data) {
                this.getChart().then(function (chart) {
                    return _this.updateData(chart, _this.data);
                });
            }

            if (changeObject.options && this.options) {
                this.getChart().then(function (chart) {
                    return _this.updateOptions(chart, _this.options);
                });
            }
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var context = this.$element.children()[0];

            this.chartPromise.resolve(new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(context, {
                type: this.type,
                options: this.options || {}
            }));
        }
    }, {
        key: 'getChart',
        value: function getChart() {
            return this.chartPromise.promise;
        }
    }, {
        key: 'updateData',
        value: function updateData(chart, data) {
            var labels = data.labels,
                datasets = data.datasets;


            chart.data.labels = labels;
            chart.data.datasets = datasets;
            chart.update();
        }
    }, {
        key: 'updateOptions',
        value: function updateOptions(chart, options) {
            __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()(chart.options, options || {});
            chart.update();
        }
    }]);

    return ChartController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAChart',
    template: __WEBPACK_IMPORTED_MODULE_3__chart_tpl_pug___default()(),
    controller: ChartController,
    bindings: {
        type: '@',
        options: '<',
        data: '<'
    }
});

/***/ }),

/***/ "G7hY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_31-10c682bd2a27a73c.svg";

/***/ }),

/***/ "G8ar":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("cdq7"),
    baseIsNaN = __webpack_require__("8++/"),
    strictIndexOf = __webpack_require__("i6nN");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "GBuA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var elements = __webpack_require__("L5rj");
var helpers = __webpack_require__("iO9N");

defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',

			// Specific to Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			position: 'left',
			type: 'category',

			// Specific to Horizontal Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		callbacks: {
			title: function(item, data) {
				// Pick first xLabel for now
				var title = '';

				if (item.length > 0) {
					if (item[0].yLabel) {
						title = item[0].yLabel;
					} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
						title = data.labels[item[0].index];
					}
				}

				return title;
			},

			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				return datasetLabel + ': ' + item.xLabel;
			}
		},
		mode: 'index',
		axis: 'y'
	}
});

module.exports = function(Chart) {

	Chart.controllers.bar = Chart.DatasetController.extend({

		dataElementType: elements.Rectangle,

		initialize: function() {
			var me = this;
			var meta;

			Chart.DatasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},

		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},

		updateElement: function(rectangle, index, reset) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var custom = rectangle.custom || {};
			var rectangleOptions = chart.options.elements.rectangle;

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;

			rectangle._model = {
				datasetLabel: dataset.label,
				label: chart.data.labels[index],
				borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
				backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
				borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
				borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
			};

			me.updateElementGeometry(rectangle, index, reset);

			rectangle.pivot();
		},

		/**
		 * @private
		 */
		updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me.getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},

		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getValueScale: function() {
			return this.getScaleForId(this.getValueScaleId());
		},

		/**
		 * @private
		 */
		getIndexScale: function() {
			return this.getScaleForId(this.getIndexScaleId());
		},

		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me.getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined ? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}

			return stacks.length;
		},

		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @private
		 */
		getStackIndex: function(datasetIndex) {
			return this.getStackCount(datasetIndex) - 1;
		},

		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me.getIndexScale();
			var stackCount = me.getStackCount();
			var datasetIndex = me.index;
			var pixels = [];
			var isHorizontal = scale.isHorizontal();
			var start = isHorizontal ? scale.left : scale.top;
			var end = start + (isHorizontal ? scale.width : scale.height);
			var i, ilen;

			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, datasetIndex));
			}

			return {
				pixels: pixels,
				start: start,
				end: end,
				stackCount: stackCount,
				scale: scale
			};
		},

		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me.getValueScale();
			var datasets = chart.data.datasets;
			var value = scale.getRightValue(datasets[datasetIndex].data[index]);
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;

			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);

					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller.getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {

						ivalue = scale.getRightValue(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = (head - base) / 2;

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var options = ruler.scale.options;
			var stackIndex = me.getStackIndex(datasetIndex);
			var pixels = ruler.pixels;
			var base = pixels[index];
			var length = pixels.length;
			var start = ruler.start;
			var end = ruler.end;
			var leftSampleSize, rightSampleSize, leftCategorySize, rightCategorySize, fullBarSize, size;

			if (length === 1) {
				leftSampleSize = base > start ? base - start : end - base;
				rightSampleSize = base < end ? end - base : base - start;
			} else {
				if (index > 0) {
					leftSampleSize = (base - pixels[index - 1]) / 2;
					if (index === length - 1) {
						rightSampleSize = leftSampleSize;
					}
				}
				if (index < length - 1) {
					rightSampleSize = (pixels[index + 1] - base) / 2;
					if (index === 0) {
						leftSampleSize = rightSampleSize;
					}
				}
			}

			leftCategorySize = leftSampleSize * options.categoryPercentage;
			rightCategorySize = rightSampleSize * options.categoryPercentage;
			fullBarSize = (leftCategorySize + rightCategorySize) / ruler.stackCount;
			size = fullBarSize * options.barPercentage;

			size = Math.min(
				helpers.valueOrDefault(options.barThickness, size),
				helpers.valueOrDefault(options.maxBarThickness, Infinity));

			base -= leftCategorySize;
			base += fullBarSize * stackIndex;
			base += (fullBarSize - size) / 2;

			return {
				size: size,
				base: base,
				head: base + size,
				center: base + size / 2
			};
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me.getIndexScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i < ilen; ++i) {
				if (!isNaN(scale.getRightValue(dataset.data[i]))) {
					rects[i].draw();
				}
			}

			helpers.canvas.unclipArea(chart.ctx);
		},

		setHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;
			var rectangleElementOptions = this.chart.options.elements.rectangle;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
		}
	});

	Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
};


/***/ }),

/***/ "GMmw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_application_util_transaction_util__ = __webpack_require__("vu3g");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var EventUtil = function () {
    EventUtil.$inject = ['stringUtil'];

    /* @ngInject */
    function EventUtil(stringUtil) {
        _classCallCheck(this, EventUtil);

        this.stringUtil = stringUtil;

        this.EventRepeatUnit = {
            Daily: 'day',
            Weekly: 'week',
            Monthly: 'month',
            Yearly: 'year'
        };

        this.EventRepeatEndType = {
            Never: 'never',
            AfterOccurrence: 'occurrence',
            OnDate: 'date'
        };

        this.EventRepeatSelector = {
            OnlyThis: 'only-this',
            ThisAndAllFollowing: 'this-and-all-following'
        };
    }

    _createClass(EventUtil, [{
        key: 'getValue',
        value: function getValue(type, value) {
            return type === __WEBPACK_IMPORTED_MODULE_1_application_util_transaction_util__["e" /* TRANSACTION_TYPE_INCOME */] ? value : -value;
        }
    }, {
        key: 'isPast',
        value: function isPast(timestamp) {
            return timestamp < __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').valueOf();
        }
    }, {
        key: 'getRepeatingFrequencySummary',
        value: function getRepeatingFrequencySummary(repeat) {
            if (repeat) {
                // TODO normalize unit
                return repeat.frequency > 1 ? 'Every ' + repeat.frequency + ' ' + this.stringUtil.pluralize(repeat.frequency, repeat.unit) : 'Every ' + repeat.unit;
            }

            return null;
        }
    }, {
        key: 'getRepeatingEndSummary',
        value: function getRepeatingEndSummary(repeat) {
            if (repeat && repeat.end) {
                return repeat.end.date ? 'until ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(repeat.end.date).format('MMMM D YYYY') : repeat.end.occurrence + ' ' + this.stringUtil.pluralize(repeat.end.occurrence, 'time');
            }

            return null;
        }
    }, {
        key: 'getRepeatingSummary',
        value: function getRepeatingSummary(timestamp, repeat) {
            var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp);
            var dateFormat = date.year() === __WEBPACK_IMPORTED_MODULE_0_moment___default()().year() ? 'dddd, MMMM D' : 'dddd, MMMM D YYYY';

            return {
                dateSummary: date.format(dateFormat),
                repeatingSummary: [this.getRepeatingFrequencySummary(repeat), this.getRepeatingEndSummary(repeat)].filter(function (summary) {
                    return summary && summary.length > 0;
                }).join(', ')
            };
        }
    }, {
        key: 'happenedOn',
        value: function happenedOn(event, timestamp) {
            if (!event) {
                return false;
            }

            // Deliberately buckets by timestamp, not transactionDate. transactionDate is still
            // experimental and no backend calculation reads it, so the daily change and balances
            // from /calendars/days are bucketed by timestamp. Bucketing the list by transactionDate
            // instead put the two halves of a day out of sync whenever the fields disagree.
            // Switch this over only once the backend buckets by transactionDate too.
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).startOf('day').valueOf() <= event.timestamp && event.timestamp <= __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).endOf('day').valueOf();
        }
    }]);

    return EventUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventUtil);

/***/ }),

/***/ "GTP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renew_subscription_notification_cmpt__ = __webpack_require__("P1Ul");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.notifications.component.renew-subscription-notification', []).component(__WEBPACK_IMPORTED_MODULE_1__renew_subscription_notification_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__renew_subscription_notification_cmpt__["a" /* default */]));

/***/ }),

/***/ "GqGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {
	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};
};


/***/ }),

/***/ "GqWm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_application_util_time_util__ = __webpack_require__("S2sh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__card_with_period_style_sass__ = __webpack_require__("DgF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__card_with_period_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__card_with_period_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__card_with_period_tpl_pug__ = __webpack_require__("nl3g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__card_with_period_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__card_with_period_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var CardWithPeriodController = function () {
    CardWithPeriodController.$inject = ['$timeout'];

    /* @ngInject */
    function CardWithPeriodController($timeout) {
        _classCallCheck(this, CardWithPeriodController);

        this.$timeout = $timeout;

        this.periods = [{
            name: 'This week',
            isActive: this.isThisWeekActive.bind(this),
            select: this.selectThisWeek.bind(this)
        }, {
            name: 'This month',
            isActive: this.isUnitActive.bind(this, 'month'),
            select: this.selectUnit.bind(this, 'month')
        }, {
            name: 'This year',
            isActive: this.isUnitActive.bind(this, 'year'),
            select: this.selectUnit.bind(this, 'year')
        }, {
            name: 'Lifetime',
            isActive: this.isLifetimeActive.bind(this),
            select: this.selectLifetime.bind(this)
        }, {
            name: 'Custom',
            isActive: this.isCustomActive.bind(this),
            select: this.showDateRange.bind(this)
        }];
    }

    _createClass(CardWithPeriodController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            var _this = this;

            if (changeObject.start || changeObject.end || changeObject.startOfWeek) {
                this.period = __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(this.periods, function (period) {
                    return period.isActive(_this.start, _this.end);
                });
            }
        }
    }, {
        key: 'isActive',
        value: function isActive(period) {
            return this.period === period;
        }
    }, {
        key: 'isUnitActive',
        value: function isUnitActive(unit, from, to) {
            var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

            var _getUnit = this.getUnit(unit, offset),
                start = _getUnit.start,
                end = _getUnit.end;

            return start === from && end === to;
        }
    }, {
        key: 'isThisWeekActive',
        value: function isThisWeekActive(from, to) {
            return this.isUnitActive('week', from, to, this.startOfWeek);
        }
    }, {
        key: 'isLifetimeActive',
        value: function isLifetimeActive(from, to) {
            var today = Object(__WEBPACK_IMPORTED_MODULE_2_application_util_time_util__["d" /* getToday */])();

            return from === null && to === __WEBPACK_IMPORTED_MODULE_1_moment___default()(today).endOf('day').valueOf();
        }
    }, {
        key: 'isCustomActive',
        value: function isCustomActive() {
            return true;
        }
    }, {
        key: 'selectThisWeek',
        value: function selectThisWeek() {
            return this.selectUnit('week', this.startOfWeek);
        }
    }, {
        key: 'selectLifetime',
        value: function selectLifetime() {
            var today = Object(__WEBPACK_IMPORTED_MODULE_2_application_util_time_util__["d" /* getToday */])();

            return this.onPeriodChange({
                start: null,
                end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(today).endOf('day').valueOf()
            });
        }
    }, {
        key: 'selectCustom',
        value: function selectCustom(start, end) {
            return this.onPeriodChange({
                start: start,
                end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(end).endOf('day').valueOf()
            });
        }
    }, {
        key: 'selectUnit',
        value: function selectUnit(unit) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            return this.onPeriodChange(this.getUnit(unit, offset));
        }
    }, {
        key: 'select',
        value: function select(period) {
            period.select();
        }
    }, {
        key: 'isConfirmedFilterActive',
        value: function isConfirmedFilterActive(option) {
            return this.confirmedFilter === option.id;
        }
    }, {
        key: 'selectConfirmedFilter',
        value: function selectConfirmedFilter(option) {
            this.confirmedFilter = option.id;
            return this.notifyConfirmedFilterChange();
        }
    }, {
        key: 'showDateRange',
        value: function showDateRange() {
            if (this.isLifetimeActive(this.start, this.end)) {
                this.selectUnit('month');
            }

            return this.$timeout(this.toggleDateRangeVisibility.bind(this, true), 0);
        }
    }, {
        key: 'hideDateRange',
        value: function hideDateRange() {
            return this.toggleDateRangeVisibility(false);
        }
    }, {
        key: 'toggleDateRangeVisibility',
        value: function toggleDateRangeVisibility(visible) {
            this.isCustomVisible = visible;
        }
    }, {
        key: 'blur',
        value: function blur(period) {
            if (typeof period.blur === 'function') {
                period.blur();
            }
        }
    }, {
        key: 'getUnit',
        value: function getUnit(unit) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var today = Object(__WEBPACK_IMPORTED_MODULE_2_application_util_time_util__["d" /* getToday */])();

            return {
                start: __WEBPACK_IMPORTED_MODULE_1_moment___default()(today).startOf(unit).add(offset, 'day').valueOf(),
                end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(today).endOf(unit).add(offset, 'day').valueOf()
            };
        }
    }, {
        key: 'notifyConfirmedFilterChange',
        value: function notifyConfirmedFilterChange() {
            if (typeof this.onConfirmedFilterChange === 'function') {
                return this.onConfirmedFilterChange({
                    confirmed: this.confirmedFilter
                });
            }
        }
    }]);

    return CardWithPeriodController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbADashboardCardWithPeriod',
    template: __WEBPACK_IMPORTED_MODULE_4__card_with_period_tpl_pug___default()(),
    controller: CardWithPeriodController,
    transclude: true,
    bindings: {
        name: '@',
        start: '<',
        end: '<',
        startOfWeek: '<',
        onPeriodChange: '&',
        confirmedFilter: '<?',
        confirmedFilterOptions: '<?',
        onConfirmedFilterChange: '&?'
    }
});

/***/ }),

/***/ "GskU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_24-fd10465c9d013371.svg";

/***/ }),

/***/ "Gvex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_native_dragdrop__ = __webpack_require__("QFyr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_native_dragdrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_native_dragdrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__("M0jB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar_day_cmpt__ = __webpack_require__("NRy+");






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-day', [__WEBPACK_IMPORTED_MODULE_1_angular_native_dragdrop___default.a, __WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_3__calendar_day_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_3__calendar_day_cmpt__["a" /* default */]));

/***/ }),

/***/ "Gvsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export THEME_DEFAULT */
/* unused harmony export THEME_DARK */
/* unused harmony export THEME_SYSTEM */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var THEME_DEFAULT = 'default';
var THEME_DARK = 'dark';
var THEME_SYSTEM = 'system';

var ThemeService = function () {
    ThemeService.$inject = ['$window', '$document'];

    /* @ngInject */
    function ThemeService($window, $document) {
        _classCallCheck(this, ThemeService);

        this.$window = $window;
        this.$document = $document;
        this.theme = THEME_DEFAULT;

        this.mediaQuery = this.$window.matchMedia ? this.$window.matchMedia('(prefers-color-scheme: dark)') : null;

        this.handleSystemChange = this.handleSystemChange.bind(this);

        if (this.mediaQuery) {
            if (this.mediaQuery.addEventListener) {
                this.mediaQuery.addEventListener('change', this.handleSystemChange);
            } else if (this.mediaQuery.addListener) {
                this.mediaQuery.addListener(this.handleSystemChange);
            }
        }

        this.applyTheme(this.getStoredTheme() || THEME_DEFAULT);
    }

    _createClass(ThemeService, [{
        key: 'getStoredTheme',
        value: function getStoredTheme() {
            try {
                return this.$window.localStorage.getItem('theme') || null;
            } catch (error) {
                return null;
            }
        }
    }, {
        key: 'applyTheme',
        value: function applyTheme(theme) {
            this.theme = theme || THEME_DEFAULT;
            var resolved = this.resolveTheme(this.theme);
            this.setThemeAttribute(resolved);
            this.persistTheme(this.theme);
            this.persistResolvedTheme(resolved);
        }
    }, {
        key: 'resolveTheme',
        value: function resolveTheme(theme) {
            if (theme === THEME_SYSTEM) {
                return this.mediaQuery && this.mediaQuery.matches ? THEME_DARK : THEME_DEFAULT;
            }

            return theme === THEME_DARK ? THEME_DARK : THEME_DEFAULT;
        }
    }, {
        key: 'setThemeAttribute',
        value: function setThemeAttribute(theme) {
            var body = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(this.$document[0].body);
            var root = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(this.$document[0].documentElement);
            body.attr('data-theme', theme);
            root.attr('data-theme', theme);

            var inlineStyle = this.$document[0].querySelector('style[data-theme-inline="true"]');
            if (inlineStyle && inlineStyle.parentNode) {
                inlineStyle.parentNode.removeChild(inlineStyle);
            }
        }
    }, {
        key: 'persistTheme',
        value: function persistTheme(theme) {
            try {
                this.$window.localStorage.setItem('theme', theme);
            } catch (error) {
                // ignore storage failures (private mode, disabled storage, etc.)
            }
        }
    }, {
        key: 'handleSystemChange',
        value: function handleSystemChange() {
            if (this.theme === THEME_SYSTEM) {
                this.applyTheme(THEME_SYSTEM);
            }
        }
    }, {
        key: 'persistResolvedTheme',
        value: function persistResolvedTheme(theme) {
            try {
                this.$window.localStorage.setItem('theme_resolved', theme);
            } catch (error) {
                // ignore storage failures
            }
        }
    }]);

    return ThemeService;
}();

/* harmony default export */ __webpack_exports__["a"] = (ThemeService);




/***/ }),

/***/ "Gz8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_repeat_change_modal_style_sass__ = __webpack_require__("fgEq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_repeat_change_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__event_repeat_change_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_repeat_change_modal_tpl_pug__ = __webpack_require__("uqIT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_repeat_change_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__event_repeat_change_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var EventRepeatChangeModalController = function () {
    EventRepeatChangeModalController.$inject = ['eventUtil'];

    /* @ngInject */
    function EventRepeatChangeModalController(eventUtil) {
        _classCallCheck(this, EventRepeatChangeModalController);

        this.eventUtil = eventUtil;

        this.onlyThisValue = this.eventUtil.EventRepeatSelector.OnlyThis;
        this.thisAndAllFollowingValue = this.eventUtil.EventRepeatSelector.ThisAndAllFollowing;

        this.selectOnlyThis();
    }

    _createClass(EventRepeatChangeModalController, [{
        key: 'selectOnlyThis',
        value: function selectOnlyThis() {
            this.selector = this.onlyThisValue;
        }
    }, {
        key: 'selectThisAndAllFollowing',
        value: function selectThisAndAllFollowing() {
            this.selector = this.thisAndAllFollowingValue;
        }
    }, {
        key: 'confirm',
        value: function confirm() {
            return this.onClose({
                data: this.selector
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            return this.onDismiss();
        }
    }, {
        key: 'isOnlyThisSelected',
        get: function get() {
            return this.selector === this.onlyThisValue;
        }
    }]);

    return EventRepeatChangeModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEventRepeatChangeModal',
    template: __WEBPACK_IMPORTED_MODULE_1__event_repeat_change_modal_tpl_pug___default()(),
    controller: EventRepeatChangeModalController,
    bindings: {
        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "H9+b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PERMISSION_TEAM_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PERMISSION_TEAM_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PERMISSION_TEAM_ADD_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PERMISSION_TEAM_ADD_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PERMISSION_TEAM_MANAGE_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PERMISSION_TEAM_MANAGE_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PERMISSION_CALENDAR_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PERMISSION_CALENDAR_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PERMISSION_CALENDAR_MANAGE_EVENTS; });
/* harmony export (immutable) */ __webpack_exports__["j"] = hasPermission;
var PERMISSION_TEAM_EDIT = 1 << 0;
var PERMISSION_TEAM_DELETE = 1 << 1;
var PERMISSION_TEAM_ADD_CALENDAR = 1 << 2;
var PERMISSION_TEAM_ADD_MEMBER = 1 << 3;
var PERMISSION_TEAM_MANAGE_EVENTS = PERMISSION_TEAM_EDIT;
var PERMISSION_TEAM_MANAGE_CATEGORIES = PERMISSION_TEAM_EDIT;

var PERMISSION_CALENDAR_EDIT = 1 << 0;
var PERMISSION_CALENDAR_DELETE = 1 << 1;
var PERMISSION_CALENDAR_MANAGE_EVENTS = PERMISSION_CALENDAR_EDIT;

function hasPermission(permissions, permission) {
    return (permissions & permission) === permission;
}

/***/ }),

/***/ "HGZV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-no-events-469227c729b22aeb.svg";

/***/ }),

/***/ "HLiI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Recurring-arrows-6e907e34cd1a9ca0.svg";

/***/ }),

/***/ "HOha":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_34-6ccb1d0f4b06f473.svg";

/***/ }),

/***/ "HV6+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"link","disabled":"disabled","button":"button","button-block":"button-block","button-icon":"button-icon","icon":"icon","button-link":"button-link","button-danger":"button-danger","button-remove":"button-remove","button-add":"button-add","icon-dollarbird-plus":"icon-dollarbird-plus","button-fill":"button-fill","button-primary":"button-primary","button-secondary":"button-secondary","button-outline":"button-outline","readonly":"readonly","block-component":"block-component","icon-dollarbird-grip":"icon-dollarbird-grip","icon-dollarbird-multiple":"icon-dollarbird-multiple","icon-dollarbird-search":"icon-dollarbird-search","icon-dollarbird-delete":"icon-dollarbird-delete","icon-dollarbird-edit":"icon-dollarbird-edit","icon-dollarbird-users":"icon-dollarbird-users","icon-dollarbird-balance-update":"icon-dollarbird-balance-update","icon-dollarbird-transfer":"icon-dollarbird-transfer","icon-dollarbird-close":"icon-dollarbird-close","icon-dollarbird-settings":"icon-dollarbird-settings","icon-dollarbird-readonly":"icon-dollarbird-readonly","icon-dollarbird-premium":"icon-dollarbird-premium","icon-dollarbird-twitter":"icon-dollarbird-twitter","icon-dollarbird-facebook":"icon-dollarbird-facebook","icon-dollarbird-dashboard":"icon-dollarbird-dashboard","icon-dollarbird-menu":"icon-dollarbird-menu","icon-dollarbird-minus":"icon-dollarbird-minus","icon-dollarbird-name":"icon-dollarbird-name","icon-dollarbird-email":"icon-dollarbird-email","icon-dollarbird-password":"icon-dollarbird-password","icon-dollarbird-chevron-left":"icon-dollarbird-chevron-left","icon-dollarbird-chevron-right":"icon-dollarbird-chevron-right","icon-dollarbird-chevron-up":"icon-dollarbird-chevron-up","icon-dollarbird-chevron-down":"icon-dollarbird-chevron-down","icon-dollarbird-repeat":"icon-dollarbird-repeat","icon-dollarbird-arrow-left":"icon-dollarbird-arrow-left","icon-dollarbird-arrow-right":"icon-dollarbird-arrow-right","icon-dollarbird-checkmark":"icon-dollarbird-checkmark","icon-dollarbird-calendar":"icon-dollarbird-calendar","icon-dollarbird-details":"icon-dollarbird-details","control-group":"control-group","control-icon":"control-icon","control":"control","control-label":"control-label","control-validation":"control-validation","form-validation":"form-validation","control-label-right":"control-label-right","control-input":"control-input","control-label-permanent":"control-label-permanent","ng-dirty":"ng-dirty","ng-invalid":"ng-invalid","ng-valid":"ng-valid","ng-submitted":"ng-submitted","application":"application","empty-state":"empty-state","empty-state-content":"empty-state-content","empty-state-image":"empty-state-image","empty-state-title":"empty-state-title","empty-state-message":"empty-state-message"};

/***/ }),

/***/ "HXAi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Property-1-Coffee-cup-2-cf6053b4527c9a1b.svg";

/***/ }),

/***/ "HXEu":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-day-event\" ng-class=\"{ confirmed: $ctrl.confirmed }\"\u003E\u003Cdiv class=\"day-event-overlay\" ng-style=\"{ backgroundColor: $ctrl.backgroundColor }\"\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-category-icon class=\"day-event-category-icon\" ng-if=\"$ctrl.useCategoryIcons\" icon-name=\"$ctrl.category &amp;&amp; $ctrl.category.iconName\" icon-index=\"$ctrl.category ? $ctrl.category.iconIndex : 11\" color=\"$ctrl.category &amp;&amp; $ctrl.category.color\" size=\"12\"\u003E\u003C\u002Fdb-a-category-icon\u003E\u003Cdiv class=\"day-event-category\" ng-if=\"!$ctrl.useCategoryIcons\" ng-style=\"{ backgroundColor: $ctrl.backgroundColor }\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"day-event-note-container\"\u003E\u003Cdiv class=\"day-event-note\"\u003E\u003Cdiv class=\"day-event-text\"\u003E\u003Cspan class=\"day-event-label\" ng-bind=\"$ctrl.mainLabel\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"day-event-detail\" ng-if=\"$ctrl.detailNote\" ng-bind=\"$ctrl.detailNote\" ng-attr-title=\"{{ $ctrl.detailTooltip }}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"day-event-icons\" ng-if=\"$ctrl.repeat || $ctrl.receiptUrl\"\u003E\u003Cdiv class=\"day-event-repeating\"\u003E\u003Ci class=\"icon-dollarbird-repeat\" ng-if=\"$ctrl.repeat\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"day-event-receipt-wrapper\" ng-if=\"$ctrl.receiptUrl\" ng-mouseenter=\"$ctrl.showReceiptPreview($event)\" ng-mouseleave=\"$ctrl.hideReceiptPreview()\"\u003E\u003Cdiv class=\"day-event-receipt\" ng-style=\"{ '-webkit-mask-image': $ctrl.receiptIconUrl, 'mask-image': $ctrl.receiptIconUrl }\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"day-event-value\" value=\"$ctrl.actualValue\" limit=\"99999\" pretty=\"true\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "Hpa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_application_util_number_util__ = __webpack_require__("Cybx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_application_util_category_util__ = __webpack_require__("XzH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__ = __webpack_require__("vu3g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_application_util_event_report_util__ = __webpack_require__("NLyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__image_icon_image_svg__ = __webpack_require__("hypg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__image_icon_image_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__image_icon_image_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__event_edit_modal_style_sass__ = __webpack_require__("SmC/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__event_edit_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__event_edit_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__event_edit_modal_tpl_pug__ = __webpack_require__("fA2j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__event_edit_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__event_edit_modal_tpl_pug__);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// refactor the whole junk asap















var MIN_NOTE_LENGTH_FOR_AUTOCATEGORIZATION = 2;
var MAX_NOTE_LENGTH_FOR_AUTOCATEGORIZATION = 16;
var RECEIPT_MAX_EDGE = 2048;
var RECEIPT_JPEG_QUALITY = 0.82;

var EventEditController = function () {
    EventEditController.$inject = ['$q', '$element', '$window', 'timeUtil', 'numberUtil', 'eventUtil', 'categoryService', 'eventService', 'transferService', 'balanceUpdateService', 'sessionService', 'suggestionService', 'autoCategoryService', 'modalService', 'notificationService', 'storageService'];

    /* @ngInject */
    function EventEditController($q, $element, $window, timeUtil, numberUtil, eventUtil, categoryService, eventService, transferService, balanceUpdateService, sessionService, suggestionService, autoCategoryService, modalService, notificationService, storageService) {
        _classCallCheck(this, EventEditController);

        this.$q = $q;
        this.$element = $element;
        this.$window = $window;
        this.timeUtil = timeUtil;
        this.numberUtil = numberUtil;
        this.eventUtil = eventUtil;
        this.categoryService = categoryService;
        this.eventService = eventService;
        this.transferService = transferService;
        this.balanceUpdateService = balanceUpdateService;
        this.sessionService = sessionService;
        this.autoCategoryService = autoCategoryService;
        this.suggestionService = suggestionService;
        this.modalService = modalService;
        this.notificationService = notificationService;
        this.storageService = storageService;
        this.receiptIconUrl = 'url(' + __WEBPACK_IMPORTED_MODULE_10__image_icon_image_svg___default.a + ')';
        this.handleReceiptInputChange = this.handleReceiptInputChange.bind(this);
    }

    _createClass(EventEditController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var categoryIconStyle = this.storageService.getUserItem('category-icon-style') || 'icons';
            this.useCategoryIcons = categoryIconStyle === 'icons';
            this.categoryService.onUpdate(this.refreshCategories.bind(this));
            this.types = [__WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["b" /* TRANSACTION_KIND_EVENT */]].concat(this.getEditableCalendars(this.calendars).length > 1 ? [__WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["c" /* TRANSACTION_KIND_TRANSFER */]] : []).concat([__WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["a" /* TRANSACTION_KIND_BALANCE_UPDATE */]]).map(function (type) {
                return {
                    value: type,
                    label: _this.getTypeLabel(type)
                };
            });

            this.event = __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, this.event || {});
            this.event.value = this.numberUtil.isNumeric(this.event.value) ? +Object(__WEBPACK_IMPORTED_MODULE_6_application_util_number_util__["d" /* toFixed */])(Math.abs(this.event.value), 2) : this.event.value;

            this.existing = !!this.event.id || !!this.event.templateId;
            this.canDelete = this.existing && this.canDelete;
            this.repeating = this.event.repeat;

            this.originalEntity = __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, this.event);
            this.entities = {};
            this.selectType(this.getType(this.event));

            this.updateSummaries(this.entity);

            this.autoCategoryPromise = this.$q.resolve();
            this.debouncedGuessCategory = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (resolve, reject) {
                for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                    args[_key - 2] = arguments[_key];
                }

                return _this.$q.when(_this.guessCategory.apply(_this, args)).then(resolve, reject);
            }, 250);
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            this.receiptInput = this.$element[0].querySelector('.input-receipt-file');

            if (this.receiptInput) {
                this.receiptInput.addEventListener('change', this.handleReceiptInputChange);
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            if (this.receiptInput) {
                this.receiptInput.removeEventListener('change', this.handleReceiptInputChange);
            }
        }
    }, {
        key: 'refreshCategories',
        value: function refreshCategories(updatedCategory) {
            var _this2 = this;

            if (!updatedCategory || !updatedCategory.id) {
                return this.categoryService.getAll(this.teamId, true).then(function (categories) {
                    if (!categories || categories.length === 0) {
                        return;
                    }

                    Object.keys(_this2.entities || {}).forEach(function (key) {
                        var currentEntity = _this2.entities[key];
                        if (!currentEntity || !currentEntity.category || !currentEntity.category.id) {
                            return;
                        }

                        var latestCategory = __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(categories, function (category) {
                            return '' + category.id === '' + currentEntity.category.id;
                        });
                        if (latestCategory) {
                            currentEntity.category = latestCategory;
                        }
                    });
                }).catch(function () {
                    return null;
                });
            }

            Object.keys(this.entities || {}).forEach(function (key) {
                var currentEntity = _this2.entities[key];
                if (!currentEntity || !currentEntity.category || !currentEntity.category.id) {
                    return;
                }

                if ('' + currentEntity.category.id === '' + updatedCategory.id) {
                    currentEntity.category = __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, currentEntity.category, updatedCategory);
                }
            });

            return null;
        }
    }, {
        key: 'getEditableCalendars',
        value: function getEditableCalendars(calendars) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(calendars, function (calendar) {
                return calendar && calendar.permissions.manageEvents;
            });
        }
    }, {
        key: 'getTypeLabel',
        value: function getTypeLabel(type) {
            switch (type) {
                case __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["c" /* TRANSACTION_KIND_TRANSFER */]:
                    return 'Transfer';
                case __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["a" /* TRANSACTION_KIND_BALANCE_UPDATE */]:
                    return 'Balance';
            }

            return 'Transaction';
        }
    }, {
        key: 'getType',
        value: function getType(entity) {
            if (entity && entity.category) {
                if (Object(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["e" /* isCategoryTransfer */])(entity.category)) {
                    return __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["c" /* TRANSACTION_KIND_TRANSFER */];
                }

                if (Object(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["b" /* isCategoryBalanceUpdate */])(entity.category)) {
                    return __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["a" /* TRANSACTION_KIND_BALANCE_UPDATE */];
                }
            }

            return __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["b" /* TRANSACTION_KIND_EVENT */];
        }
    }, {
        key: 'clickSelectType',
        value: function clickSelectType(type) {
            __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionTypeChange(type.label);

            this.selectType(type.value);
        }
    }, {
        key: 'selectType',
        value: function selectType(type) {
            this.type = type;

            this.entities[this.type] = this.entities[this.type] || this.makeEntity(this.type, this.originalEntity);

            this.isEvent = this.type === __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["b" /* TRANSACTION_KIND_EVENT */];
            this.isTransfer = this.type === __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["c" /* TRANSACTION_KIND_TRANSFER */];
            this.isBalanceUpdate = this.type === __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["a" /* TRANSACTION_KIND_BALANCE_UPDATE */];

            this.canEditCategory = this.canEdit && this.isEvent;

            this.entity = this.entities[this.type];

            this.updateSummaries(this.entity);
        }

        // eslint-disable-next-line complexity

    }, {
        key: 'makeEntity',
        value: function makeEntity(type, entity) {
            entity = __WEBPACK_IMPORTED_MODULE_3_angular___default.a.copy(entity);

            switch (type) {
                case __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["c" /* TRANSACTION_KIND_TRANSFER */]:
                    if (entity.fromCalendar) {
                        var calendar = this.findCalendarById(entity.fromCalendar);
                        this.updateFromCalendar(entity, entity.fromCalendar, calendar);
                    } else if (!this.existing) {
                        var _calendar = this.findCalendarById(this.calendarIds[0]);
                        this.updateFromCalendar(entity, this.calendarIds[0], _calendar);
                    }

                    if (entity.toCalendar) {
                        var _calendar2 = this.findCalendarById(entity.toCalendar);
                        this.updateToCalendar(entity, entity.toCalendar, _calendar2);
                    } else if (!this.existing) {
                        var _calendar3 = __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(this.calendars, function (calendar) {
                            return calendar.id !== entity.fromCalendar;
                        });
                        this.updateToCalendar(entity, _calendar3 ? _calendar3.id : null, _calendar3);
                    }

                    if (!Object(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["e" /* isCategoryTransfer */])(entity.category)) {
                        this.getCategory(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["e" /* isCategoryTransfer */]).then(function (category) {
                            return entity.category = category;
                        }).catch(function () {
                            return null;
                        });
                    }

                    this.updateCalendar(entity, this.findCalendarById(entity.calendarId) || this.findCalendarById(entity.fromCalendar));

                    entity.type = entity.type || __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["d" /* TRANSACTION_TYPE_EXPENSE */];
                    entity.isIncludedInReports = this.existing ? Object(__WEBPACK_IMPORTED_MODULE_9_application_util_event_report_util__["a" /* getIncludeInReports */])(entity, false) : false;

                    break;
                case __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["a" /* TRANSACTION_KIND_BALANCE_UPDATE */]:
                    if (!Object(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["b" /* isCategoryBalanceUpdate */])(entity.category)) {
                        this.getCategory(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["b" /* isCategoryBalanceUpdate */]).then(function (category) {
                            return entity.category = category;
                        }).catch(function () {
                            return null;
                        });
                    }

                    this.updateCalendar(entity, this.findCalendarById(entity.calendarId) || this.findCalendarById(this.calendarIds[0]));

                    entity.type = entity.type || __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["e" /* TRANSACTION_TYPE_INCOME */];
                    entity.transactionDate = this.timeUtil.toTransactionDate(entity.timestamp);
                    entity.isIncludedInReports = this.existing ? Object(__WEBPACK_IMPORTED_MODULE_9_application_util_event_report_util__["a" /* getIncludeInReports */])(entity, false) : false;

                    break;
                default:
                    if (!entity.category || Object(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["e" /* isCategoryTransfer */])(entity.category) || Object(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["b" /* isCategoryBalanceUpdate */])(entity.category)) {
                        this.getCategory(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["d" /* isCategoryOther */]).then(function (category) {
                            return entity.category = category;
                        }).catch(function () {
                            return null;
                        });
                    }

                    this.updateCalendar(entity, this.findCalendarById(entity.calendarId) || this.findCalendarById(this.calendarIds[0]));

                    entity.type = entity.type || __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["d" /* TRANSACTION_TYPE_EXPENSE */];
                    entity.isIncludedInReports = Object(__WEBPACK_IMPORTED_MODULE_9_application_util_event_report_util__["a" /* getIncludeInReports */])(entity, true);

                    break;
            }

            return entity;
        }
    }, {
        key: 'findCalendarById',
        value: function findCalendarById(calendarId) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(this.calendars, function (calendar) {
                return calendar.id === calendarId;
            });
        }
    }, {
        key: 'updateFromCalendar',
        value: function updateFromCalendar(entity, calendarId, calendar) {
            entity.fromCalendar = calendarId;
            this.fromCalendar = calendar;
        }
    }, {
        key: 'updateToCalendar',
        value: function updateToCalendar(entity, calendarId, calendar) {
            entity.toCalendar = calendarId;
            this.toCalendar = calendar;
        }
    }, {
        key: 'updateCalendar',
        value: function updateCalendar(entity, calendar) {
            entity.calendarId = calendar ? calendar.id : null;
            this.calendar = calendar;
        }
    }, {
        key: 'selectFromCalendar',
        value: function selectFromCalendar(entity) {
            var _this3 = this;

            var calendars = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(this.calendars, function (calendar) {
                return calendar.id !== entity.toCalendar && calendar.permissions.manageEvents;
            });
            return this.openCalendarSelectionModal(calendars, this.fromCalendar, 'Transfer from').then(function (calendar) {
                _this3.updateFromCalendar(entity, calendar.id, calendar);
                return _this3.updateCalendar(entity, calendar);
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'selectToCalendar',
        value: function selectToCalendar(entity) {
            var _this4 = this;

            var calendars = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(this.calendars, function (calendar) {
                return calendar.id !== entity.fromCalendar && calendar.permissions.manageEvents;
            });
            return this.openCalendarSelectionModal(calendars, this.toCalendar, 'Transfer to').then(function (calendar) {
                return _this4.updateToCalendar(entity, calendar.id, calendar);
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'selectCalendar',
        value: function selectCalendar(entity) {
            var _this5 = this;

            var calendars = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(this.calendars, function (calendar) {
                return calendar.permissions.manageEvents;
            });
            return this.openCalendarSelectionModal(calendars, this.calendar, 'Select calendar').then(function (calendar) {
                return _this5.updateCalendar(entity, calendar);
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'openCalendarSelectionModal',
        value: function openCalendarSelectionModal(calendars, selected, title) {
            return this.modalService.open({
                component: 'dbACalendarSelectModal',
                bindings: {
                    calendars: calendars,
                    selected: selected,
                    title: title
                }
            });
        }
    }, {
        key: 'getCategory',
        value: function getCategory(callback) {
            var _this6 = this;

            this.loading = true;

            return this.categoryService.find(this.teamId, callback).finally(function () {
                return _this6.loading = false;
            });
        }
    }, {
        key: 'switchSign',
        value: function switchSign(entity) {
            entity.type = this.income ? __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["d" /* TRANSACTION_TYPE_EXPENSE */] : __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["e" /* TRANSACTION_TYPE_INCOME */];

            __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionSignChange(entity);
        }
    }, {
        key: 'switchTransferCalendars',
        value: function switchTransferCalendars(entity) {
            var fromCalendar = __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, this.fromCalendar);
            var fromCalendarId = entity.fromCalendar;

            this.updateFromCalendar(entity, entity.toCalendar, this.toCalendar);
            this.updateToCalendar(entity, fromCalendarId, fromCalendar);
            this.updateCalendar(entity, this.fromCalendar);

            __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionTransferCalendarSwitch(entity);
        }
    }, {
        key: 'openCategoryModal',
        value: function openCategoryModal(entity) {
            var _this7 = this;

            if (this.canEditCategory) {
                var previousCategory = entity.category || {};

                return this.modalService.open({
                    component: 'dbACategorySelectModal',
                    bindings: {
                        teamId: this.teamId,
                        selectedCategoryId: entity.category ? entity.category.id : null,
                        canAdd: this.canManageCategories
                    }
                }).then(function (category) {
                    _this7.hasChangedCategory = true;

                    entity.category = category;

                    if (!_this7.existing) {
                        if (entity.autocategorized) {
                            __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionAutocategoryOverride(entity, previousCategory);
                        }

                        entity.autocategorized = false;
                    }
                }).catch(function () {
                    return _this7.reloadCategory(entity).catch(function () {
                        return _this7.getCategory(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["d" /* isCategoryOther */]).then(function (category) {
                            entity.category = category;
                        }).catch(function () {
                            return null;
                        });
                    });
                });
            }
        }
    }, {
        key: 'reloadCategory',
        value: function reloadCategory(entity) {
            return this.getCategory(function (category) {
                return category.id === entity.category.id;
            }).then(function (category) {
                entity.category = category;
            });
        }
    }, {
        key: 'save',
        value: function save(entity) {
            var _this8 = this;

            entity.value = +Object(__WEBPACK_IMPORTED_MODULE_6_application_util_number_util__["d" /* toFixed */])(entity.value, 2);

            if (this.type === __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["a" /* TRANSACTION_KIND_BALANCE_UPDATE */]) {
                return this.saveBalanceUpdate(entity);
            }

            if (this.existing && this.repeating) {
                return this.modalService.open({
                    component: 'dbAEventRepeatChangeModal',
                    bindings: {
                        onClose: function onClose(eventSelector) {
                            var promise = entity.templateId ? _this8.eventService.updateRepeating(entity, _this8.repeating.occurrence, eventSelector) : _this8.eventService.update(entity, eventSelector);

                            return promise.then(_this8.close.bind(_this8)).catch(function (result) {
                                var repeatEndError = Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["c" /* getRepeatEndFieldError */])(result);
                                _this8.notificationService.showError(repeatEndError || Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to save your transaction. Please try again later.'));
                                if (repeatEndError) {
                                    return _this8.openDateModal(entity, repeatEndError);
                                }
                                return _this8.$q.reject(result);
                            });
                        }
                    }
                }).catch(function () {
                    return null;
                });
            }

            return this.autoCategoryPromise.then(function () {
                var promise = null;

                if (_this8.existing) {
                    promise = _this8.eventService.update(entity);
                } else if (_this8.type === __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["c" /* TRANSACTION_KIND_TRANSFER */]) {
                    promise = _this8.transferService.create(entity.calendarId, entity).then(function (entity) {
                        __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionTransferCreate(entity, _this8.from);
                        return entity;
                    });
                } else {
                    promise = _this8.eventService.create(entity.calendarId, entity).then(function (entity) {
                        __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionEventCreate(entity, _this8.from);

                        return entity;
                    });
                }

                return promise.then(function () {
                    if (entity.note && entity.note.length > 0) {
                        _this8.addSuggestion(entity.note);

                        if (_this8.isEvent) {
                            _this8.addCategoryMap(entity.category, entity.note);
                        }
                    }

                    return _this8.close();
                }).catch(function (result) {
                    var repeatEndError = Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["c" /* getRepeatEndFieldError */])(result);
                    _this8.notificationService.showError(repeatEndError || Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to save your transaction. Please try again later.'));
                    if (repeatEndError) {
                        return _this8.openDateModal(entity, repeatEndError);
                    }
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'saveBalanceUpdate',
        value: function saveBalanceUpdate(entity) {
            var _this9 = this;

            var promise = this.existing ? this.eventService.update(entity) : this.balanceUpdateService.create(entity.calendarId, entity).then(function (entity) {
                __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionBalanceUpdateCreate(entity, _this9.from);
                return entity;
            });

            return promise.then(this.close.bind(this)).catch(function (result) {
                _this9.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to save your balance update. Please try again later.'));
                return _this9.$q.reject(result);
            });
        }
    }, {
        key: 'addSuggestion',
        value: function addSuggestion(note) {
            this.suggestionService.add(this.teamId, note);
        }
    }, {
        key: 'addCategoryMap',
        value: function addCategoryMap(category, note) {
            this.autoCategoryService.add(this.teamId, category.id, note);
        }
    }, {
        key: 'remove',
        value: function remove(entity) {
            var _this10 = this;

            if (this.repeating) {
                return this.modalService.open({
                    component: 'dbAEventRepeatDeleteModal',
                    bindings: {
                        onClose: function onClose(eventSelector) {
                            var promise = entity.templateId ? _this10.eventService.removeRepeating(entity, _this10.repeating.occurrence, eventSelector) : _this10.eventService.remove(entity, eventSelector);

                            return promise.then(function () {
                                __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionDelete(entity, _this10.from);
                                return _this10.close();
                            }).catch(function (result) {
                                _this10.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to save your transaction. Please try again later.'));
                                return _this10.$q.reject(result);
                            });
                        }
                    }
                }).catch(function () {
                    return null;
                });
            }

            return this.modalService.open({
                component: 'dbAConfirmModal',
                bindings: {
                    title: 'Delete transaction',
                    message: ['Deleting a transaction cannot be undone.', 'Are you still sure about it?'],
                    onClose: function onClose() {
                        return _this10.eventService.remove(entity).then(function () {
                            __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionDelete(entity, _this10.from);
                            return _this10.close();
                        }).catch(function (result) {
                            _this10.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to delete your transaction. Please try again later.'));
                            return _this10.$q.reject(result);
                        });
                    }
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'toggleConfirmation',
        value: function toggleConfirmation(entity) {
            if (this.canEdit) {
                entity.confirmed = !entity.confirmed;
            }
        }
    }, {
        key: 'openDateModal',
        value: function openDateModal(entity, initialRepeatEndError) {
            return this.modalService.open({
                component: 'dbAEventDateModal',
                bindings: {
                    event: __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, entity),
                    startOfWeek: this.startOfWeek,
                    canRepeat: !this.isBalanceUpdate,
                    canEdit: this.canEdit,
                    initialRepeatEndError: initialRepeatEndError
                }
            }).then(this.updateEvent.bind(this)).catch(function () {
                return null;
            });
        }
    }, {
        key: 'openDetailsModal',
        value: function openDetailsModal(entity) {
            return this.modalService.open({
                component: 'dbAEventDetailsModal',
                bindings: {
                    event: __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, entity),
                    canEdit: this.canEdit
                }
            }).then(this.updateEvent.bind(this)).catch(function () {
                return null;
            });
        }
    }, {
        key: 'hasReceipt',
        value: function hasReceipt(entity) {
            return !!this.getReceiptImageUrl(entity);
        }
    }, {
        key: 'getReceiptImageUrl',
        value: function getReceiptImageUrl(entity) {
            if (!entity) {
                return null;
            }

            return entity.receiptUrl || null;
        }
    }, {
        key: 'handleReceiptClick',
        value: function handleReceiptClick(entity) {
            if (this.uploadingReceipt) {
                return null;
            }

            if (this.hasReceipt(entity)) {
                return this.openReceiptModal(entity);
            }

            if (!this.canEdit || !this.receiptInput) {
                return null;
            }

            this.receiptInput.value = '';
            this.receiptInput.click();

            return null;
        }
    }, {
        key: 'handleReceiptInputChange',
        value: function handleReceiptInputChange(event) {
            var _this11 = this;

            return this.$q.resolve().then(function () {
                var file = event && event.target && event.target.files && event.target.files[0];

                if (!file) {
                    return null;
                }

                if (file.type && file.type.indexOf('image/') !== 0) {
                    return null;
                }

                var localUrl = _this11.$window.URL.createObjectURL(file);

                return _this11.modalService.open({
                    component: 'dbAEventReceiptModal',
                    bindings: {
                        imageUrl: localUrl,
                        fileName: file.name,
                        canAttach: true
                    }
                }).then(function () {
                    _this11.uploadingReceipt = true;

                    return _this11.uploadReceipt(file).then(function (receiptUrl) {
                        _this11.attachReceipt(_this11.entity, receiptUrl, file.name);
                    }).catch(function (result) {
                        _this11.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_5_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to upload your image. Please try again later.'));
                    }).finally(function () {
                        _this11.uploadingReceipt = false;
                    });
                }).catch(function () {
                    return null;
                }).finally(function () {
                    _this11.revokeLocalReceiptUrl(localUrl);
                });
            });
        }
    }, {
        key: 'uploadReceipt',
        value: function uploadReceipt(file) {
            var _this12 = this;

            // eslint-disable-next-line no-console
            console.log('[receipt-upload] selected file size (bytes):', file.size, 'name:', file.name, 'type:', file.type);
            return this.compressImageToJpeg(file).then(function (jpegFile) {
                // eslint-disable-next-line no-console
                console.log('[receipt-upload] compressed jpeg size (bytes):', jpegFile.size, 'type:', jpegFile.type);
                return _this12.eventService.uploadReceipt(jpegFile, 'receipt.jpeg');
            }).then(function (url) {
                if (!url) {
                    return _this12.$q.reject();
                }

                return url;
            });
        }
    }, {
        key: 'compressImageToJpeg',
        value: function compressImageToJpeg(file) {
            var _this13 = this;

            return this.createImageElement(file).then(function (image) {
                var dimensions = _this13.getScaledDimensions(image.naturalWidth || image.width, image.naturalHeight || image.height);
                var canvas = _this13.$window.document.createElement('canvas');

                canvas.width = dimensions.width;
                canvas.height = dimensions.height;

                var context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, dimensions.width, dimensions.height);

                return _this13.$q(function (resolve) {
                    canvas.toBlob(function (blob) {
                        return resolve(blob);
                    }, 'image/jpeg', RECEIPT_JPEG_QUALITY);
                }).then(function (blob) {
                    if (blob) {
                        return blob;
                    }

                    var dataUrl = canvas.toDataURL('image/jpeg', RECEIPT_JPEG_QUALITY);
                    return _this13.dataUrlToBlob(dataUrl);
                });
            });
        }
    }, {
        key: 'createImageElement',
        value: function createImageElement(file) {
            var _this14 = this;

            return this.$q(function (resolve, reject) {
                var image = new _this14.$window.Image();
                var objectUrl = _this14.$window.URL.createObjectURL(file);

                image.onload = function () {
                    _this14.revokeLocalReceiptUrl(objectUrl);
                    resolve(image);
                };

                image.onerror = function () {
                    _this14.revokeLocalReceiptUrl(objectUrl);
                    reject();
                };

                image.src = objectUrl;
            });
        }
    }, {
        key: 'getScaledDimensions',
        value: function getScaledDimensions(width, height) {
            var longestEdge = Math.max(width, height);

            if (!longestEdge || longestEdge <= RECEIPT_MAX_EDGE) {
                return {
                    width: width,
                    height: height
                };
            }

            var ratio = RECEIPT_MAX_EDGE / longestEdge;

            return {
                width: Math.round(width * ratio),
                height: Math.round(height * ratio)
            };
        }
    }, {
        key: 'dataUrlToBlob',
        value: function dataUrlToBlob(dataUrl) {
            var parts = (dataUrl || '').split(',');

            if (parts.length < 2) {
                return this.$q.reject();
            }

            var header = parts[0];
            var content = parts[1];
            var mimeMatch = header.match(/data:(.*?);base64/);
            var mimeType = mimeMatch && mimeMatch[1] ? mimeMatch[1] : 'image/jpeg';
            var binary = this.$window.atob(content);
            var bytes = new Uint8Array(binary.length);

            for (var index = 0; index < binary.length; index++) {
                bytes[index] = binary.charCodeAt(index);
            }

            return new Blob([bytes], {
                type: mimeType
            });
        }
    }, {
        key: 'attachReceipt',
        value: function attachReceipt(entity, receiptUrl, fileName) {
            if (!entity) {
                return;
            }

            entity.receiptUrl = receiptUrl;
            entity.receiptName = fileName;
        }
    }, {
        key: 'openReceiptModal',
        value: function openReceiptModal(entity) {
            var imageUrl = this.getReceiptImageUrl(entity);

            if (!imageUrl) {
                return null;
            }

            return this.modalService.open({
                component: 'dbAEventReceiptModal',
                bindings: {
                    imageUrl: imageUrl,
                    fileName: entity.receiptName || this.getReceiptFileName(imageUrl),
                    canAttach: false
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'removeReceipt',
        value: function removeReceipt(entity) {
            if (!entity || !this.canEdit) {
                return;
            }

            entity.receiptName = null;
            entity.receiptUrl = null;
        }
    }, {
        key: 'getReceiptFileName',
        value: function getReceiptFileName(url) {
            if (!url) {
                return 'receipt-image';
            }

            var withoutQuery = ('' + url).split('?')[0];
            var filename = withoutQuery.substring(withoutQuery.lastIndexOf('/') + 1);

            return filename || 'receipt-image';
        }
    }, {
        key: 'revokeLocalReceiptUrl',
        value: function revokeLocalReceiptUrl(url) {
            if (url && ('' + url).indexOf('blob:') === 0 && this.$window.URL && this.$window.URL.revokeObjectURL) {
                this.$window.URL.revokeObjectURL(url);
            }
        }
    }, {
        key: 'updateDateSummaries',
        value: function updateDateSummaries(entity) {
            var timestamp = entity && (entity.transactionDate || entity.timestamp);

            var _eventUtil$getRepeati = this.eventUtil.getRepeatingSummary(timestamp, entity.repeat),
                dateSummary = _eventUtil$getRepeati.dateSummary,
                repeatingSummary = _eventUtil$getRepeati.repeatingSummary;

            this.dateSummary = dateSummary;
            this.repeatingSummary = repeatingSummary;
        }
    }, {
        key: 'updateDetailSummary',
        value: function updateDetailSummary(entity) {
            this.detailSummary = entity.details && entity.details.length > 0 ? entity.details.split(/\r?\n/).join(' ').trim() : null;
        }
    }, {
        key: 'updateSummaries',
        value: function updateSummaries(entity) {
            this.updateDateSummaries(entity);
            this.updateDetailSummary(entity);
        }
    }, {
        key: 'updateEvent',
        value: function updateEvent(entity) {
            if (entity && typeof entity.timestamp === 'number') {
                entity.transactionDate = this.timeUtil.toTransactionDate(entity.timestamp);
            }

            this.entities[this.type] = entity;

            this.updateSummaries(entity);
            this.entity = entity;
        }
    }, {
        key: 'checkKeyForNote',
        value: function checkKeyForNote(entity, code) {
            if (this.noteSuggestion) {
                switch (code) {
                    case 27:
                        this.noteSuggestion = null;
                        return false;
                    case 9:
                    case 13:
                    case 39:
                        this.autofillNote(entity);
                        return false;
                }
            }

            return true;
        }
    }, {
        key: 'updateNote',
        value: function updateNote(entity) {
            var _this15 = this;

            if (this.canEdit) {
                var hasNote = entity.note && entity.note.length > 0;

                this.noteSuggestion = hasNote && entity.note.length < MAX_NOTE_LENGTH_FOR_AUTOCATEGORIZATION ? this.suggestionService.getMissingPart(this.teamId, entity.note) : null;

                if (this.isTransfer || this.isBalanceUpdate) {
                    return null;
                }

                if (!this.existing && !this.hasChangedCategory && this.autoCategorization) {
                    if (hasNote && entity.note.length > MIN_NOTE_LENGTH_FOR_AUTOCATEGORIZATION) {
                        return this.autoCategoryPromise = this.$q(function (resolve) {
                            return _this15.debouncedGuessCategory(resolve, resolve, _this15.teamId, entity, entity.note);
                        });
                    }

                    return this.getCategory(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["d" /* isCategoryOther */]).then(function (category) {
                        return entity.category = category;
                    }).catch(function () {
                        return null;
                    });
                }
            }
        }
    }, {
        key: 'guessCategory',
        value: function guessCategory(teamId, entity, note) {
            var _this16 = this;

            if (note && note.length > 2) {
                return this.autoCategoryService.get(teamId, note).then(function (categoryId) {
                    return _this16.categoryService.getAll(teamId).then(function (categories) {
                        var category = __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(categories, function (category) {
                            return '' + category.id === '' + categoryId;
                        });

                        if (category) {
                            entity.category = category;

                            return category;
                        }

                        return _this16.$q.reject();
                    });
                }).catch(function () {
                    return _this16.autoCategoryService.guess(teamId, note).then(function (category) {
                        entity.category = category;

                        if (!_this16.existing) {
                            entity.autocategorized = true;
                        }
                    }).catch(function () {
                        return _this16.getCategory(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["d" /* isCategoryOther */]).then(function (category) {
                            return entity.category = category;
                        }).catch(function () {
                            return null;
                        });
                    });
                });
            }

            return this.getCategory(__WEBPACK_IMPORTED_MODULE_7_application_util_category_util__["d" /* isCategoryOther */]).then(function (category) {
                return entity.category = category;
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'autofillNote',
        value: function autofillNote(entity) {
            entity.note = this.suggestionService.get(this.teamId, entity.note) || entity.note;
            this.noteSuggestion = null;

            this.updateNote(entity);

            __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackTransactionLabelSuggestionAutocomplete(entity);
        }
    }, {
        key: 'close',
        value: function close() {
            return this.onClose();
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            return this.onDismiss();
        }
    }, {
        key: 'canNavigateBack',
        get: function get() {
            return this.index > 0;
        }
    }, {
        key: 'income',
        get: function get() {
            return this.entity.type && this.entity.type === __WEBPACK_IMPORTED_MODULE_8_application_util_transaction_util__["e" /* TRANSACTION_TYPE_INCOME */];
        }
    }]);

    return EventEditController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEventEditModal',
    template: __WEBPACK_IMPORTED_MODULE_12__event_edit_modal_tpl_pug___default()(),
    controller: EventEditController,
    bindings: {
        teamId: '<',
        calendarIds: '<',
        calendars: '<',
        event: '<',
        startOfWeek: '<',
        autoCategorization: '<',
        from: '<',
        index: '<',

        canEdit: '<',
        canDelete: '<',
        canManageCategories: '<',

        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "Hxm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_service__ = __webpack_require__("NY7f");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.service.payment', []).service('paymentService', __WEBPACK_IMPORTED_MODULE_1__payment_service__["a" /* default */]));

/***/ }),

/***/ "HyjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_day_event_cmpt__ = __webpack_require__("XRqS");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-day.component.calendar-day-event', []).component(__WEBPACK_IMPORTED_MODULE_1__calendar_day_event_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__calendar_day_event_cmpt__["a" /* default */]));

/***/ }),

/***/ "IJ/B":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"async-text-loading\" ng-transclude=\"loading\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"async-text-initial\" ng-transclude=\"initial\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "IR8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_limit_notification_cmpt__ = __webpack_require__("vOuy");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.notifications.component.event-limit-notification', []).component(__WEBPACK_IMPORTED_MODULE_1__event_limit_notification_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__event_limit_notification_cmpt__["a" /* default */]));

/***/ }),

/***/ "IbXy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("iO9N");

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
module.exports = {
	/**
	 * Namespace to hold generators for different types of ticks
	 * @namespace Chart.Ticks.generators
	 */
	generators: {
		/**
		 * Interface for the options provided to the numeric tick generator
		 * @interface INumericTickGenerationOptions
		 */
		/**
		 * The maximum number of ticks to display
		 * @name INumericTickGenerationOptions#maxTicks
		 * @type Number
		 */
		/**
		 * The distance between each tick.
		 * @name INumericTickGenerationOptions#stepSize
		 * @type Number
		 * @optional
		 */
		/**
		 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
		 * @name INumericTickGenerationOptions#min
		 * @type Number
		 * @optional
		 */
		/**
		 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
		 * @name INumericTickGenerationOptions#max
		 * @type Number
		 * @optional
		 */

		/**
		 * Generate a set of linear ticks
		 * @method Chart.Ticks.generators.linear
		 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
		 * @param dataRange {IRange} the range of the data
		 * @returns {Array<Number>} array of tick values
		 */
		linear: function(generationOptions, dataRange) {
			var ticks = [];
			// To get a "nice" value for the tick spacing, we will use the appropriately named
			// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
			// for details.

			var spacing;
			if (generationOptions.stepSize && generationOptions.stepSize > 0) {
				spacing = generationOptions.stepSize;
			} else {
				var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
				spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
			}
			var niceMin = Math.floor(dataRange.min / spacing) * spacing;
			var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

			// If min, max and stepSize is set and they make an evenly spaced scale use it.
			if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
				// If very close to our whole number, use it.
				if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
					niceMin = generationOptions.min;
					niceMax = generationOptions.max;
				}
			}

			var numSpaces = (niceMax - niceMin) / spacing;
			// If very close to our rounded value, use it.
			if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
				numSpaces = Math.round(numSpaces);
			} else {
				numSpaces = Math.ceil(numSpaces);
			}

			// Put the values into the ticks array
			ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
			for (var j = 1; j < numSpaces; ++j) {
				ticks.push(niceMin + (j * spacing));
			}
			ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

			return ticks;
		},

		/**
		 * Generate a set of logarithmic ticks
		 * @method Chart.Ticks.generators.logarithmic
		 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
		 * @param dataRange {IRange} the range of the data
		 * @returns {Array<Number>} array of tick values
		 */
		logarithmic: function(generationOptions, dataRange) {
			var ticks = [];
			var valueOrDefault = helpers.valueOrDefault;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph
			var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));

			var endExp = Math.floor(helpers.log10(dataRange.max));
			var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
			var exp, significand;

			if (tickVal === 0) {
				exp = Math.floor(helpers.log10(dataRange.minNotZero));
				significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

				ticks.push(tickVal);
				tickVal = significand * Math.pow(10, exp);
			} else {
				exp = Math.floor(helpers.log10(tickVal));
				significand = Math.floor(tickVal / Math.pow(10, exp));
			}

			do {
				ticks.push(tickVal);

				++significand;
				if (significand === 10) {
					significand = 1;
					++exp;
				}

				tickVal = significand * Math.pow(10, exp);
			} while (exp < endExp || (exp === endExp && significand < endSignificand));

			var lastTick = valueOrDefault(generationOptions.max, tickVal);
			ticks.push(lastTick);

			return ticks;
		}
	},

	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {String|Array} the label to display
		 */
		values: function(value) {
			return helpers.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {Number} the value to be formatted
		 * @param index {Number} the position of the tickValue parameter in the ticks array
		 * @param ticks {Array<Number>} the list of ticks being converted
		 * @return {String} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var numDecimal = -1 * Math.floor(logDelta);
				numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
				tickString = tickValue.toFixed(numDecimal);
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};


/***/ }),

/***/ "IpXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notifications_style_sass__ = __webpack_require__("empT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notifications_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__notifications_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications_tpl_pug__ = __webpack_require__("ce2Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__notifications_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var NotificationsController = function () {
    NotificationsController.$inject = ['notificationService'];

    /* @ngInject */
    function NotificationsController(notificationService) {
        _classCallCheck(this, NotificationsController);

        this.notificationService = notificationService;
    }

    _createClass(NotificationsController, [{
        key: 'disableClose',
        value: function disableClose() {
            this.notificationService.disableClose();
        }
    }, {
        key: 'enableClose',
        value: function enableClose() {
            this.notificationService.enableClose();
        }
    }, {
        key: 'notifications',
        get: function get() {
            return this.notificationService.notifications;
        }
    }]);

    return NotificationsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbANotifications',
    template: __WEBPACK_IMPORTED_MODULE_1__notifications_tpl_pug___default()(),
    controller: NotificationsController
});

/***/ }),

/***/ "Is6f":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"block-component\" id=\"dashboard-page\"\u003E\u003Cdiv class=\"dashboard-header\"\u003E\u003Cdiv class=\"page-title\"\u003EDashboard\u003C\u002Fdiv\u003E\u003Ca class=\"button button-icon button-close-page\" ui-sref=\"authorized.calendar\"\u003E\u003Ci class=\"icon icon-dollarbird-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dashboard-container\"\u003E\u003Cdiv class=\"dashboard-content\"\u003E\u003Cdiv class=\"dashboard-navigation\"\u003E\u003Cdiv class=\"navigation-content\"\u003E\u003Cdiv class=\"navigation-section\"\u003E\u003Cdiv class=\"navigation-section-title\"\u003ETeams\u003C\u002Fdiv\u003E\u003Cdiv class=\"navigation-section-content\"\u003E\u003Ca class=\"navigation-item\" href=\"javascript:void(0)\" ng-repeat=\"team in $ctrl.teams track by team.id\" ui-sref=\"authorized.dashboard({ teamId: team.id })\" ng-click=\"$ctrl.selectTeam(team)\"\u003E\u003Cdb-a-team-radio name=\"team.name\" selected=\"$ctrl.isTeamActive(team)\"\u003E\u003C\u002Fdb-a-team-radio\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navigation-section\"\u003E\u003Cdiv class=\"navigation-section-title\"\u003ECalendars\u003C\u002Fdiv\u003E\u003Cdiv class=\"navigation-section-content\"\u003E\u003Ca class=\"navigation-item\" href=\"javascript:void(0)\" ng-repeat=\"calendar in $ctrl.selectedTeam.calendars track by $index\" ui-sref=\"authorized.dashboard({ teamId: $ctrl.selectedTeam.id, cid: $ctrl.getCalendarIdsOfCalendar(calendar) })\" ng-click=\"$ctrl.selectCalendar(calendar)\"\u003E\u003Cdb-a-calendar-checkbox name=\"calendar.name\" selected=\"$ctrl.isCalendarActive(calendar)\"\u003E\u003C\u002Fdb-a-calendar-checkbox\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dashboard-cards\"\u003E\u003Cdb-a-dashboard-card-with-period class=\"dashboard-card-container\" name=\"Cash flow\" start=\"$ctrl.cashFlow.start\" end=\"$ctrl.cashFlow.end\" start-of-week=\"$ctrl.startOfWeek\" on-period-change=\"$ctrl.updateCashFlowPeriod(start, end)\"\u003E\u003Cdb-a-cash-flow-chart calendar-ids=\"$ctrl.calendarIds\" start=\"$ctrl.cashFlow.start\" end=\"$ctrl.cashFlow.end\"\u003E\u003C\u002Fdb-a-cash-flow-chart\u003E\u003C\u002Fdb-a-dashboard-card-with-period\u003E\u003Cdb-a-dashboard-card-with-year-picker class=\"dashboard-card-container\" name=\"Income \u002F Expense\" year=\"$ctrl.incomeExpense.year\" on-year-change=\"$ctrl.updateIncomeExpenseYear(year)\"\u003E\u003Cdb-a-income-expense-chart calendar-ids=\"$ctrl.calendarIds\" year=\"$ctrl.incomeExpense.year\"\u003E\u003C\u002Fdb-a-income-expense-chart\u003E\u003C\u002Fdb-a-dashboard-card-with-year-picker\u003E\u003Cdb-a-dashboard-card-with-period class=\"dashboard-card-container\" name=\"Expenses\" start=\"$ctrl.category.start\" end=\"$ctrl.category.end\" start-of-week=\"$ctrl.startOfWeek\" on-period-change=\"$ctrl.updateCategoryPeriod(start, end)\" confirmed-filter=\"$ctrl.category.confirmed\" confirmed-filter-options=\"$ctrl.categoryConfirmedFilterOptions\" on-confirmed-filter-change=\"$ctrl.updateCategoryConfirmed(confirmed)\"\u003E\u003Cdb-a-category-chart calendar-ids=\"$ctrl.calendarIds\" start=\"$ctrl.category.start\" end=\"$ctrl.category.end\" confirmed=\"$ctrl.category.confirmed\"\u003E\u003C\u002Fdb-a-category-chart\u003E\u003C\u002Fdb-a-dashboard-card-with-period\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "Ium9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BALANCE_OVERRIDE_COLOR_DESTRUCTIVE */
/* unused harmony export BALANCE_OVERRIDE_COLOR_WARNING */
/* harmony export (immutable) */ __webpack_exports__["a"] = getBalanceOverrideColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_number_util__ = __webpack_require__("Cybx");


var BALANCE_OVERRIDE_COLOR_DESTRUCTIVE = 'var(--color-danger)';
var BALANCE_OVERRIDE_COLOR_WARNING = 'var(--color-warning, #f2b01e)';

function getBalanceOverrideColor(value, threshold) {
    var normalizedValue = Object(__WEBPACK_IMPORTED_MODULE_0_application_util_number_util__["b" /* isNumeric */])(value) ? Number(value) : 0;
    var normalizedThreshold = Object(__WEBPACK_IMPORTED_MODULE_0_application_util_number_util__["b" /* isNumeric */])(threshold) ? Number(threshold) : null;
    var hasPositiveThreshold = normalizedThreshold != null && normalizedThreshold > 0;

    if (normalizedValue < 0) {
        return BALANCE_OVERRIDE_COLOR_DESTRUCTIVE;
    }

    if (hasPositiveThreshold && normalizedValue < normalizedThreshold) {
        return BALANCE_OVERRIDE_COLOR_WARNING;
    }

    return null;
}

/***/ }),

/***/ "JBwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_container_directive__ = __webpack_require__("msgi");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.scroll-container', []).directive(__WEBPACK_IMPORTED_MODULE_1__scroll_container_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__scroll_container_directive__["a" /* default */]));

/***/ }),

/***/ "JCwK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_cmpt__ = __webpack_require__("7s0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__("oLRq");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals', [__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_1__modals_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__modals_cmpt__["a" /* default */]));

/***/ }),

/***/ "JFb5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dashboard_style_sass__ = __webpack_require__("9W0y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dashboard_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dashboard_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard_tpl_pug__ = __webpack_require__("Is6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__dashboard_tpl_pug__);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var DashboardController = function () {
    DashboardController.$inject = ['$state'];

    /* @ngInject */
    function DashboardController($state) {
        _classCallCheck(this, DashboardController);

        this.$state = $state;
    }

    _createClass(DashboardController, [{
        key: '$onInit',
        value: function $onInit() {
            var time = this.time ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.time) : __WEBPACK_IMPORTED_MODULE_3_moment___default()();

            this.cashFlow = {
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()(time).startOf('month').valueOf(),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()(time).endOf('month').valueOf()
            };

            this.incomeExpense = {
                year: __WEBPACK_IMPORTED_MODULE_3_moment___default()(time).year()
            };

            this.category = {
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()(time).startOf('month').valueOf(),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()(time).endOf('month').valueOf(),
                confirmed: 'true'
            };

            this.categoryConfirmedFilterOptions = [{ id: 'true', value: 'Confirmed' }, { id: 'false', value: 'Unconfirmed' }, { id: 'any', value: 'All' }];
        }
    }, {
        key: 'updateCashFlowPeriod',
        value: function updateCashFlowPeriod(start, end) {
            this.cashFlow.start = start;
            this.cashFlow.end = end;
        }
    }, {
        key: 'updateIncomeExpenseYear',
        value: function updateIncomeExpenseYear(year) {
            this.incomeExpense.year = year;
        }
    }, {
        key: 'updateCategoryPeriod',
        value: function updateCategoryPeriod(start, end) {
            this.category.start = start;
            this.category.end = end;
        }
    }, {
        key: 'updateCategoryConfirmed',
        value: function updateCategoryConfirmed(confirmed) {
            this.category.confirmed = confirmed;
        }
    }, {
        key: 'isTeamActive',
        value: function isTeamActive(team) {
            return this.selectedTeam === team;
        }
    }, {
        key: 'isCalendarActive',
        value: function isCalendarActive(calendar) {
            return this.getCalendarIndex(calendar) >= 0;
        }
    }, {
        key: 'selectTeam',
        value: function selectTeam(team) {
            this.selectedTeam = team;
            this.calendarIds = [this.selectedTeam.calendars[0].id];
        }
    }, {
        key: 'getCalendarIndex',
        value: function getCalendarIndex(calendar) {
            return this.calendarIds.indexOf(calendar.id);
        }
    }, {
        key: 'getCalendarIdsOfCalendar',
        value: function getCalendarIdsOfCalendar(calendar) {
            var team = findTeamCalendarBelongsTo(this.teams, calendar);

            var index = this.getCalendarIndex(calendar);
            var calendarIds = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(this.calendarIds, function (id) {
                return teamHasCalendarId(team, id);
            });

            if (index < 0) {
                calendarIds.push(calendar.id);
            } else if (calendarIds.length > 1) {
                calendarIds.splice(index, 1);
            }

            return calendarIds;
        }
    }, {
        key: 'selectCalendar',
        value: function selectCalendar(calendar) {
            this.calendarIds = this.getCalendarIdsOfCalendar(calendar);
        }
    }, {
        key: 'getTeamName',
        value: function getTeamName(team) {
            return team ? team.name : null;
        }
    }, {
        key: 'getCalendarName',
        value: function getCalendarName(calendar) {
            return calendar ? calendar.name : null;
        }
    }, {
        key: 'getCalendarId',
        value: function getCalendarId(calendar) {
            return calendar.id;
        }
    }, {
        key: 'getCalendarPlaceholder',
        value: function getCalendarPlaceholder() {
            return this.calendars && this.calendars.length > 1 ? this.calendars[0].name + ' and ' + (this.calendars.length - 1) + ' more' : null;
        }
    }]);

    return DashboardController;
}();

function teamHasCalendar(team, calendar) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(team.calendars, function (item) {
        return compareCalendar(calendar, item);
    });
}

function teamHasCalendarId(team, calendarId) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(team.calendars, function (calendar) {
        return calendar.id === calendarId;
    });
}

function findTeamCalendarBelongsTo(teams, calendar) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(teams, function (team) {
        return teamHasCalendar(team, calendar);
    });
}

function compareCalendar(calendar, anotherCalendar) {
    return calendar.id === anotherCalendar.id;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbADashboard',
    template: __WEBPACK_IMPORTED_MODULE_5__dashboard_tpl_pug___default()(),
    controller: DashboardController,
    bindings: {
        teams: '<',
        selectedTeam: '<',
        calendarIds: '<',
        startOfWeek: '<',
        time: '<'
    }
});

/***/ }),

/***/ "JM0q":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"notification\" ng-class=\"{ 'has-image': $ctrl.imageUrl }\"\u003E\u003Cimg class=\"notification-image\" ng-src=\"{{ $ctrl.imageUrl }}\" alt=\"\" role=\"presentation\"\u003E\u003Cdiv class=\"notification-title\" ng-transclude=\"title\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"notification-content\" ng-transclude=\"content\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "JUs9":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("G8ar");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "JiEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_cmpt__ = __webpack_require__("xFT5");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.category', []).component(__WEBPACK_IMPORTED_MODULE_1__category_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__category_cmpt__["a" /* default */]));

/***/ }),

/***/ "JpD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export appStartCacheRegistration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transaction__ = __webpack_require__("Ak92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__balance_service__ = __webpack_require__("4ZJt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__category_service__ = __webpack_require__("TnF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar_service__ = __webpack_require__("Vncn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__suggestion_service__ = __webpack_require__("31Zn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auto_category_service__ = __webpack_require__("ZVbr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__monitoring_categorization_service__ = __webpack_require__("Cjxq");
appStartCacheRegistration.$inject = ['appStartCacheService', 'storageService', 'categoryService'];











/* @ngInject */
function appStartCacheRegistration(appStartCacheService, storageService, categoryService) {
    appStartCacheService.register('categories', {
        warm: function warm() {
            var teamId = storageService.getUserItem('selected-team');
            if (!teamId) {
                return null;
            }

            return categoryService.refresh(teamId);
        },
        clear: function clear() {
            appStartCacheService.clearUserKeyPrefix('categories');
        }
    });
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.service.calendar', [__WEBPACK_IMPORTED_MODULE_1__transaction__["a" /* default */].name]).service('balanceService', __WEBPACK_IMPORTED_MODULE_2__balance_service__["a" /* default */]).service('categoryService', __WEBPACK_IMPORTED_MODULE_3__category_service__["a" /* default */]).service('calendarService', __WEBPACK_IMPORTED_MODULE_4__calendar_service__["a" /* default */]).service('suggestionService', __WEBPACK_IMPORTED_MODULE_5__suggestion_service__["a" /* default */]).service('monitoringCategorizationService', __WEBPACK_IMPORTED_MODULE_7__monitoring_categorization_service__["a" /* default */]).service('autoCategoryService', __WEBPACK_IMPORTED_MODULE_6__auto_category_service__["a" /* default */]).run(appStartCacheRegistration));

/***/ }),

/***/ "Jww3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__on_blur_directive__ = __webpack_require__("Cg2K");


// TODO find a better name


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.on-blur', []).directive(__WEBPACK_IMPORTED_MODULE_1__on_blur_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__on_blur_directive__["a" /* default */]));

/***/ }),

/***/ "KC8c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("iO9N");

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {Point} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param chart {chart} the chart
 * @param handler {Function} the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var datasets = chart.data.datasets;
	var meta, i, j, ilen, jlen;

	for (i = 0, ilen = datasets.length; i < ilen; ++i) {
		if (!chart.isDatasetVisible(i)) {
			continue;
		}

		meta = chart.getDatasetMeta(i);
		for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
			var element = meta.data[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param items {ChartElement[]} elements to filter
 * @param position {Point} the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param chart {Chart} the chart to look at elements from
 * @param position {Point} the point to be nearest to
 * @param intersect {Boolean} if true, only consider items that intersect the position
 * @param distanceMetric {Function} function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);

		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {String} axis the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart.data.datasets.forEach(function(dataset, datasetIndex) {
		if (chart.isDatasetVisible(datasetIndex)) {
			var meta = chart.getDatasetMeta(datasetIndex);
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
module.exports = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: true});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);

			// We have multiple items at the same distance from the event. Now sort by smallest
			if (nearestItems.length > 1) {
				nearestItems.sort(function(a, b) {
					var sizeA = a.getArea();
					var sizeB = b.getArea();
					var ret = sizeA - sizeB;

					if (ret === 0) {
						// if equal sort by dataset index
						ret = a._datasetIndex - b._datasetIndex;
					}

					return ret;
				});
			}

			// Return only 1 item
			return nearestItems.slice(0, 1);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};


/***/ }),

/***/ "KH+1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_cmpt__ = __webpack_require__("vksQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scene__ = __webpack_require__("KeNN");
defaultRouteHandler.$inject = ['$injector'];
stateConfiguration.$inject = ['$urlRouterProvider', '$stateProvider', '$transitionsProvider'];





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.settings', [__WEBPACK_IMPORTED_MODULE_2__scene__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_1__settings_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__settings_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($urlRouterProvider, $stateProvider, $transitionsProvider) {
    $urlRouterProvider.when('/settings', defaultRouteHandler);

    $stateProvider.state('authorized.calendar.settings', {
        url: '^/settings',
        component: __WEBPACK_IMPORTED_MODULE_1__settings_cmpt__["a" /* default */].selector,
        redirectTo: 'authorized.calendar.settings.general'
    });

    $transitionsProvider.onStart({
        to: 'authorized.calendar.settings.**'
    }, function () {
        return true;
    });
}

/* @ngInject */
function defaultRouteHandler($injector) {
    var $state = $injector.get('$state');
    return $state.go('authorized.calendar.settings.general');
}

/***/ }),

/***/ "KeNN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__account__ = __webpack_require__("fN8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__("RH3r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general__ = __webpack_require__("po3/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_interface__ = __webpack_require__("fWtn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscription__ = __webpack_require__("u2yG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__about__ = __webpack_require__("S7yp");









/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.settings.scene', [__WEBPACK_IMPORTED_MODULE_1__account__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__general__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__user_interface__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__subscription__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__about__["a" /* default */].name]));

/***/ }),

/***/ "KilB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subscription_style_sass__ = __webpack_require__("N5cQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subscription_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__subscription_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscription_tpl_pug__ = __webpack_require__("OEeb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscription_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__subscription_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _STORE_NAME, _DEVICE_NAME;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var SUBSCRIPTION_TYPE_ANDROID = 'android';
var SUBSCRIPTION_TYPE_IOS = 'ios';
var SUBSCRIPTION_TYPE_AVANGATE = 'avangate';

var STORE_NAME = (_STORE_NAME = {}, _defineProperty(_STORE_NAME, SUBSCRIPTION_TYPE_ANDROID, 'Google Play Store'), _defineProperty(_STORE_NAME, SUBSCRIPTION_TYPE_IOS, 'Apple App Store'), _defineProperty(_STORE_NAME, SUBSCRIPTION_TYPE_AVANGATE, 'Avangate'), _STORE_NAME);

var DEVICE_NAME = (_DEVICE_NAME = {}, _defineProperty(_DEVICE_NAME, SUBSCRIPTION_TYPE_ANDROID, 'Android device'), _defineProperty(_DEVICE_NAME, SUBSCRIPTION_TYPE_IOS, 'iOS device'), _defineProperty(_DEVICE_NAME, SUBSCRIPTION_TYPE_AVANGATE, 'browser'), _DEVICE_NAME);

var SubscriptionSettingsController = function () {
    SubscriptionSettingsController.$inject = ['$q', 'planService', 'configuration', 'notificationService'];

    /* @ngInject */
    function SubscriptionSettingsController($q, planService, configuration, notificationService) {
        _classCallCheck(this, SubscriptionSettingsController);

        this.$q = $q;
        this.planService = planService;
        this.configuration = configuration;
        this.notificationService = notificationService;
    }

    _createClass(SubscriptionSettingsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.cancelSubscriptionHelpCenterUrl = this.configuration.cancelSubscriptionHelpCenterUrl;
            this.plan = this.plan || {};
            this.loading = true;

            this.loadSubscriptionInfo().finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'loadSubscriptionInfo',
        value: function loadSubscriptionInfo() {
            var _this2 = this;

            return this.planService.getSubscriptionInfo().then(function (data) {
                _this2.plan = _this2.buildPlanFromSubscriptionInfo(data);
                _this2.applyPlan(_this2.plan);
            }).catch(function (error) {
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_2_application_util_error_util__["b" /* getErrorMessage */])(error, 'We were not able to retrieve your subscription information.'));
                _this2.processing = true;
                return _this2.$q.reject(error);
            });
        }
    }, {
        key: 'buildPlanFromSubscriptionInfo',
        value: function buildPlanFromSubscriptionInfo(data) {
            var billing = data && data.billingInfo ? data.billingInfo : {};

            return __WEBPACK_IMPORTED_MODULE_0_angular___default.a.merge({}, data ? data.plan || {} : {}, {
                subscription: __WEBPACK_IMPORTED_MODULE_0_angular___default.a.merge({}, data && data.plan ? data.plan.subscription || {} : {}, {
                    price: billing.price || null,
                    currency: billing.currency || null
                })
            });
        }
    }, {
        key: 'applyPlan',
        value: function applyPlan(plan) {
            var subscription = plan && plan.subscription || {};
            var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(subscription.endDate);

            this.endTimestamp = subscription.endDate;
            this.endDate = this.canExpire(date) ? date.format('dddd, Do MMMM YYYY') : null;
            this.recurring = subscription.recurring;
            this.store = this.getStoreName(subscription.type);
            this.device = this.getDeviceName(subscription.type);
            this.price = this.formatPrice(subscription.currency, subscription.price);
            this.features = plan && plan.features ? plan.features : [];
            this.expired = !!(plan && plan.expired);
            this.processing = !subscription.type;
        }
    }, {
        key: 'formatPrice',
        value: function formatPrice(currency, price) {
            return currency && price ? currency + ' ' + Number.prototype.toFixed.call(price, 2) : null;
        }
    }, {
        key: 'canExpire',
        value: function canExpire(date) {
            date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date);
            return date.isValid() && date.year() < 2100;
        }
    }, {
        key: 'getStoreName',
        value: function getStoreName(type) {
            return STORE_NAME[type] || 'Unknown';
        }
    }, {
        key: 'getDeviceName',
        value: function getDeviceName(type) {
            return DEVICE_NAME[type] || 'unknown device';
        }
    }]);

    return SubscriptionSettingsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbASubscriptionSettings',
    template: __WEBPACK_IMPORTED_MODULE_4__subscription_tpl_pug___default()(),
    controller: SubscriptionSettingsController,
    bindings: {
        plan: '<'
    }
});

/***/ }),

/***/ "KodT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppStartCacheService = function () {
    AppStartCacheService.$inject = ['$q', 'storageService'];

    /* @ngInject */
    function AppStartCacheService($q, storageService) {
        _classCallCheck(this, AppStartCacheService);

        this.$q = $q;
        this.storageService = storageService;
        this.entries = [];
        this.inflight = null;
        this.completed = false;
    }

    _createClass(AppStartCacheService, [{
        key: 'register',
        value: function register(key, handler) {
            var normalized = this.normalizeHandler(handler);

            if (!key || !normalized) {
                return null;
            }

            this.entries.push({
                key: key,
                handler: normalized
            });

            return null;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.inflight = null;
            this.completed = false;
        }
    }, {
        key: 'warm',
        value: function warm() {
            var _this = this;

            if (this.inflight) {
                return this.inflight;
            }

            if (this.completed) {
                return this.$q.resolve([]);
            }

            var tasks = this.entries.map(function (entry) {
                return _this.$q.when().then(function () {
                    return entry.handler.warm();
                }).catch(function () {
                    return null;
                });
            });
            this.inflight = this.$q.all(tasks).finally(function () {
                _this.completed = true;
                _this.inflight = null;
            });

            return this.inflight;
        }
    }, {
        key: 'clearAll',
        value: function clearAll() {
            this.entries.forEach(function (entry) {
                if (entry.handler && entry.handler.clear) {
                    entry.handler.clear();
                }
            });
        }
    }, {
        key: 'clearUserKeyPrefix',
        value: function clearUserKeyPrefix(prefix) {
            if (!this.storageService.userPrefix || !prefix) {
                return null;
            }

            var storage = this.storageService.getStorage();
            var base = this.storageService.getPrefixedKey(this.storageService.prefix, this.storageService.userPrefix);
            var normalizedPrefix = this.storageService.normalizeKey(prefix);
            var fullPrefix = base + '-' + normalizedPrefix;

            for (var index = storage.length - 1; index >= 0; index -= 1) {
                var key = storage.key(index);
                if (key && key.startsWith(fullPrefix)) {
                    storage.removeItem(key);
                }
            }

            return null;
        }
    }, {
        key: 'normalizeHandler',
        value: function normalizeHandler(handler) {
            if (typeof handler === 'function') {
                return {
                    warm: handler,
                    clear: null
                };
            }

            if (handler && typeof handler.warm === 'function') {
                return {
                    warm: handler.warm,
                    clear: typeof handler.clear === 'function' ? handler.clear : null
                };
            }

            return null;
        }
    }]);

    return AppStartCacheService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AppStartCacheService);

/***/ }),

/***/ "KsWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_style_sass__ = __webpack_require__("SKa4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_tpl_pug__ = __webpack_require__("YUSk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__card_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbADashboardCard',
    template: __WEBPACK_IMPORTED_MODULE_1__card_tpl_pug___default()(),
    transclude: {
        date: 'cardDate',
        content: 'cardContent'
    },
    bindings: {
        name: '@'
    }
});

/***/ }),

/***/ "KyKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = BlurDirective;
BlurDirective.$inject = ['$parse'];
var selector = 'dbABlur';

/* @ngInject */
function BlurDirective($parse) {
    return {
        restrict: 'A',

        link: function link(scope, element, attrs) {
            var setter = $parse(attrs[selector]);

            setter(scope, {
                callback: blurHandler
            });

            function blurHandler() {
                setTimeout(function () {
                    return element[0].blur();
                }, 0);
            }
        }
    };
}

/***/ }),

/***/ "L5rj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.Arc = __webpack_require__("5ImO");
module.exports.Line = __webpack_require__("FDK5");
module.exports.Point = __webpack_require__("Qor1");
module.exports.Rectangle = __webpack_require__("AFDx");


/***/ }),

/***/ "LAWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_receipt_modal_style_sass__ = __webpack_require__("0LRl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_receipt_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__event_receipt_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_receipt_modal_tpl_pug__ = __webpack_require__("OASY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_receipt_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__event_receipt_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var EventReceiptModalController = function () {
    EventReceiptModalController.$inject = ['$window'];

    /* @ngInject */
    function EventReceiptModalController($window) {
        _classCallCheck(this, EventReceiptModalController);

        this.$window = $window;
    }

    _createClass(EventReceiptModalController, [{
        key: 'dismiss',
        value: function dismiss() {
            return this.onDismiss();
        }
    }, {
        key: 'attach',
        value: function attach() {
            return this.onClose({
                data: true
            });
        }
    }, {
        key: 'download',
        value: function download() {
            if (!this.imageUrl) {
                return null;
            }

            var anchor = this.$window.document.createElement('a');
            anchor.href = this.imageUrl;
            anchor.download = this.fileName || 'receipt-image';
            anchor.target = '_blank';
            anchor.rel = 'noopener';
            anchor.click();

            return null;
        }
    }]);

    return EventReceiptModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEventReceiptModal',
    template: __WEBPACK_IMPORTED_MODULE_1__event_receipt_modal_tpl_pug___default()(),
    controller: EventReceiptModalController,
    bindings: {
        imageUrl: '<',
        fileName: '<',
        canAttach: '<',

        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "LBBT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-navigation":"calendar-navigation","calendar-list-content":"calendar-list-content","calendar-list-section":"calendar-list-section","calendar-list-section-fill":"calendar-list-section-fill","calendar-list-section-content":"calendar-list-section-content","calendar-list-heading":"calendar-list-heading","calendar-list-heading-actions":"calendar-list-heading-actions","button-subscribe":"button-subscribe","disabled":"disabled","icon":"icon","plan-name":"plan-name","button-open-settings":"button-open-settings","calendar-user-profile":"calendar-user-profile","calendar-user-plan":"calendar-user-plan","current-user-image":"current-user-image","user-image":"user-image","image-default":"image-default","user-initials":"user-initials","user-info":"user-info","user-name":"user-name","user-email":"user-email","calendar-navigation-heading":"calendar-navigation-heading","team-name":"team-name","team-selection-main":"team-selection-main","team-shared":"team-shared","icon-dollarbird-users":"icon-dollarbird-users","team-balance":"team-balance","team-selection":"team-selection","calendar-navigation-content":"calendar-navigation-content","calendar-navigation-item":"calendar-navigation-item"};

/***/ }),

/***/ "LPE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selected_date_range_style_sass__ = __webpack_require__("WGcY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selected_date_range_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__selected_date_range_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selected_date_range_tpl_pug__ = __webpack_require__("hGsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selected_date_range_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__selected_date_range_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var SelectedDateRangeController = function () {
    function SelectedDateRangeController() {
        _classCallCheck(this, SelectedDateRangeController);
    }

    _createClass(SelectedDateRangeController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.start) {
                this.startDate = this.formatPeriodDate(this.start, 'Beginning of time');
            }

            if (changeObject.start) {
                this.endDate = this.formatPeriodDate(this.end, 'End of time');
            }
        }
    }, {
        key: 'formatPeriodDate',
        value: function formatPeriodDate(date, placeholder) {
            date = date ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(date) : null;

            return date && date.isValid() ? date.format('MMMM D, YYYY') : placeholder;
        }
    }]);

    return SelectedDateRangeController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbASelectedDateRange',
    template: __WEBPACK_IMPORTED_MODULE_2__selected_date_range_tpl_pug___default()(),
    controller: SelectedDateRangeController,
    bindings: {
        start: '<',
        end: '<'
    }
});

/***/ }),

/***/ "LTak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_legacy_sortablejs_maintained__ = __webpack_require__("SGnE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_legacy_sortablejs_maintained___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_legacy_sortablejs_maintained__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_manage_modal_cmpt__ = __webpack_require__("opx7");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.category-manage-modal', ['ng-sortable']).component(__WEBPACK_IMPORTED_MODULE_2__category_manage_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__category_manage_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "LUro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common__ = __webpack_require__("1lyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sign_in_cmpt__ = __webpack_require__("ZdTG");
stateConfiguration.$inject = ['$stateProvider'];





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.sign-in', []).component(__WEBPACK_IMPORTED_MODULE_2__sign_in_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__sign_in_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.sign-in', {
        url: __WEBPACK_IMPORTED_MODULE_1_common__["c" /* URL_SIGN_IN */],
        template: '<db-a-sign-in class="block-component"></db-a-sign-in>',
        params: {
            error: null
        },
        data: {
            requires: {
                anonymous: 'authorized.calendar'
            }
        }
    });
}

/***/ }),

/***/ "LVGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_repeat_delete_modal_cmpt__ = __webpack_require__("1bfa");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.event-repeat-delete-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__event_repeat_delete_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__event_repeat_delete_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "Lbh9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_21-abdf6c3505a598d1.svg";

/***/ }),

/***/ "LcjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_edit_modal_cmpt__ = __webpack_require__("FnIM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_edit_modal_component__ = __webpack_require__("tJW2");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.calendar-edit-modal', [__WEBPACK_IMPORTED_MODULE_2__category_edit_modal_component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_1__calendar_edit_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__calendar_edit_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "Lh+N":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Baby.svg": "VID3",
	"./Balance-scale.svg": "Qyae",
	"./Banknote.svg": "r1UY",
	"./Bed-1.svg": "xb/H",
	"./Bed.svg": "wC4o",
	"./Books.svg": "1p0f",
	"./Broom.svg": "pz8W",
	"./Calculator.svg": "DChA",
	"./Charts.svg": "zvwG",
	"./Cross.svg": "bLl/",
	"./Heart-Hands.svg": "Ojfb",
	"./Key.svg": "w47J",
	"./Laptop.svg": "/KNH",
	"./More-dots.svg": "mVCC",
	"./Paw.svg": "ZieB",
	"./Percent.svg": "mYgp",
	"./Pill.svg": "ysNX",
	"./Property-1-Coffee-cup-1.svg": "Zn4b",
	"./Property-1-Coffee-cup-2.svg": "HXAi",
	"./Property-1-Piggy-Bank.svg": "3jOQ",
	"./Property-1-Receipt.svg": "uJqd",
	"./Property-1-Shield.svg": "lhZF",
	"./Recurring-arrows.svg": "HLiI",
	"./Running.svg": "Wl94",
	"./Scrissors.svg": "+sfM",
	"./Wifi.svg": "B2J5",
	"./Wrench.svg": "YwHZ",
	"./Wuestion-Mark.svg": "l9ut",
	"./ic_category_15.svg": "D5dL",
	"./ic_category_16.svg": "/sYY",
	"./ic_category_17.svg": "Nxgv",
	"./ic_category_18.svg": "DRWz",
	"./ic_category_19.svg": "apxD",
	"./ic_category_20.svg": "8qhh",
	"./ic_category_21.svg": "Lbh9",
	"./ic_category_22.svg": "Ub4b",
	"./ic_category_23.svg": "it8l",
	"./ic_category_24.svg": "GskU",
	"./ic_category_25.svg": "0QVQ",
	"./ic_category_26.svg": "Nfcd",
	"./ic_category_27.svg": "lnWs",
	"./ic_category_28.svg": "waoX",
	"./ic_category_29.svg": "lAgd",
	"./ic_category_30.svg": "WWu0",
	"./ic_category_31.svg": "G7hY",
	"./ic_category_32.svg": "OiI6",
	"./ic_category_33.svg": "zsci",
	"./ic_category_34.svg": "HOha",
	"./ic_category_35.svg": "WITs",
	"./iconCategoryBalanceUpdate.svg": "ACBE",
	"./iconCategoryCar.svg": "pdTe",
	"./iconCategoryClothes.svg": "yn4m",
	"./iconCategoryEatingOut.svg": "x3r6",
	"./iconCategoryEntertainment.svg": "/hAw",
	"./iconCategoryFitness.svg": "gGI1",
	"./iconCategoryGroceries.svg": "mTmz",
	"./iconCategoryHealth.svg": "YB0b",
	"./iconCategoryHousehold.svg": "5vIW",
	"./iconCategoryIncome.svg": "QmoE",
	"./iconCategoryPersonalCare.svg": "nrl3",
	"./iconCategorySubscription.svg": "hNRh",
	"./iconCategoryTransfer.svg": "RTjd",
	"./iconCategoryUncategorized.svg": "23tK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Lh+N";

/***/ }),

/***/ "LkuQ":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("v9aJ");

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ "Lxud":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"about-settings-page\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003ELegal\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv\u003E\u003Ca class=\"link link-privacy-policy\" href=\"javascript:void(0);\" ui-sref=\"privacy-policy\" target=\"_blank\"\u003EPrivacy Policy\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ca class=\"link link-terms-of-service\" href=\"javascript:void(0);\" ui-sref=\"terms-of-service\" target=\"_blank\"\u003ETerms of Service\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EContact us\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv\u003E\u003Ca class=\"link link-facebook\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.facebookUrl }}\" target=\"_blank\" rel=\"noopener\"\u003EFacebook\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ca class=\"link link-twitter\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.twitterUrl }}\" target=\"_blank\" rel=\"noopener\"\u003ETwitter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EHelp & Support\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv\u003E\u003Ca class=\"link link-help-center\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.helpCenterUrl }}\" target=\"_blank\"\u003EHelp Center\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ca class=\"link link-feedback\" href=\"javascript:void(0);\" db-mail-to=\"$ctrl.supportEmail\" db-mail-subject=\"$ctrl.supportMailSubject\" db-mail-body=\"$ctrl.supportMailBody\" target=\"_blank\" rel=\"noopener\"\u003E{{ $ctrl.supportEmail }}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.canSendDiagnostics\"\u003E\u003Cbutton class=\"button button-fill button-secondary button-send-diagnostics\" type=\"button\" db-a-async on-click=\"$ctrl.sendDiagnostics()\"\u003E\u003Cinitial\u003ESend diagnostics\u003C\u002Finitial\u003E\u003Cloading\u003ESending diagnostics...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EVersion\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv ng-bind=\"'v.' + $ctrl.version\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "M/MC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_group_cmpt__ = __webpack_require__("jDkL");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-dashboard.component.category-group', []).component(__WEBPACK_IMPORTED_MODULE_1__category_group_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__category_group_cmpt__["a" /* default */]));

/***/ }),

/***/ "M/VY":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"event-group\"\u003E\u003Cdiv class=\"event-count\" ng-bind=\"$ctrl.count\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-name\" ng-bind=\"$ctrl.note\"\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"event-value\" value=\"$ctrl.value\" limit=\"100000\" pretty=\"true\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "M0jB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_day_event__ = __webpack_require__("HyjE");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-day.component', [__WEBPACK_IMPORTED_MODULE_1__calendar_day_event__["a" /* default */].name]));

/***/ }),

/***/ "M1c9":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ "M3d/":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-header\" ng-mouseleave=\"$ctrl.blur()\"\u003E\u003Cdiv class=\"calendar-header-content\" ng-class=\"{ 'months-visible': $ctrl.areMonthsVisible }\"\u003E\u003Cbutton class=\"button button-icon button-fill button-primary button-open-team-management\" type=\"button\" ng-click=\"$ctrl.openTeamManagement()\"\u003E\u003Ci class=\"icon icon-dollarbird-menu\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"calendar-header-context\"\u003E\u003Cdiv class=\"calendar-name\"\u003E\u003Cspan ng-show=\"$ctrl.selectedName\"\u003E\u003Cspan ng-bind=\"$ctrl.selectedName\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003Cspan\u003E (\u003C\u002Fspan\u003E\u003Cdb-a-pretty-number value=\"$ctrl.balance\" limit=\"999999999.99\" pretty=\"true\" ng-style=\"{ color: $ctrl.getBalanceOverrideColor($ctrl.balance) }\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003Cspan\u003E)\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan ng-hide=\"$ctrl.selectedName\"\u003ELoading...\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team-name\" ng-bind=\"$ctrl.team.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-header-tool-container\" ng-show=\"$ctrl.calendarIds.length &gt; 0\"\u003E\u003Cdiv class=\"calendar-header-tool-item\"\u003E\u003Cdiv class=\"transaction-search-container\"\u003E\u003Cdb-a-search class=\"transaction-search\" data-id=\"transaction-search\" data-placeholder=\"'e.g. salary or 4.99'\" can-capture=\"$ctrl.canCaptureSearch\" on-focus-change=\"$ctrl.toggleSearchVisibility(focused)\" on-term-change=\"$ctrl.searchTermChanged(terms)\" on-submit=\"$ctrl.searchTermChanged(terms)\" ng-class=\"{ visible: $ctrl.searchVisible }\"\u003E\u003C\u002Fdb-a-search\u003E\u003Clabel class=\"button button-icon button-open-search\" for=\"transaction-search\" tabindex=\"0\"\u003E\u003Ci class=\"icon icon-dollarbird-search\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-header-tool-item\"\u003E\u003Ca class=\"button button-icon button-open-dashboard\" ui-sref=\"authorized.dashboard({ teamId: $ctrl.team.id, cid: $ctrl.calendarIds, time: $ctrl.timestamp })\"\u003E\u003Ci class=\"icon icon-dollarbird-dashboard\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-header-navigation-container\" ng-show=\"$ctrl.calendarIds.length &gt; 0\" ng-mouseenter=\"$ctrl.hover()\"\u003E\u003Cdiv class=\"calendar-header-navigation-items\"\u003E\u003Cdiv class=\"calendar-header-navigation-item\"\u003E\u003Cdiv class=\"current-date-picker\"\u003E\u003Cbutton class=\"button button-icon button-select-previous-month\" type=\"button\" ng-click=\"$ctrl.selectPreviousMonth()\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"current-date\" ng-bind=\"$ctrl.date\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-icon button-select-next-month\" type=\"button\" ng-click=\"$ctrl.selectNextMonth()\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-header-navigation-item\"\u003E\u003Cbutton class=\"button button-outline button-secondary button-select-today\" type=\"button\" ng-click=\"$ctrl.selectToday()\"\u003EToday\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-header-update-container\"\u003E\u003Cdb-a-change-log class=\"change-log-container\" update-interval=\"3600000\"\u003E\u003C\u002Fdb-a-change-log\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-period-container\"\u003E\u003Cdb-a-calendar-period class=\"calendar-period-content\" loading=\"$ctrl.loading\" timestamp=\"$ctrl.timestamp\" months=\"$ctrl.months\" on-select=\"$ctrl.selectMonth(timestamp)\" ng-show=\"$ctrl.calendarIds.length &gt; 0\"\u003E\u003C\u002Fdb-a-calendar-period\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "M5hB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__period_month_item_cmpt__ = __webpack_require__("owzX");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-header.component.calendar-period.component.period-month-item', []).component(__WEBPACK_IMPORTED_MODULE_1__period_month_item_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__period_month_item_cmpt__["a" /* default */]));

/***/ }),

/***/ "MGI3":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ccanvas class=\"chart\"\u003E\u003C\u002Fcanvas\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "MHsw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon-palette":"icon-palette","palette-page-control":"palette-page-control","disabled":"disabled","palette-page-control-up":"palette-page-control-up","palette-page-control-down":"palette-page-control-down","palette-grid":"palette-grid","grid-item-container":"grid-item-container","grid-item":"grid-item","palette-item":"palette-item","selected":"selected","palette-item-icon":"palette-item-icon"};

/***/ }),

/***/ "MSXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_cmpt__ = __webpack_require__("EBDT");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.date', []).component(__WEBPACK_IMPORTED_MODULE_1__date_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__date_cmpt__["a" /* default */]));

/***/ }),

/***/ "MVjj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_cmpt__ = __webpack_require__("G/3b");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.dashboard.component.chart', []).component(__WEBPACK_IMPORTED_MODULE_1__chart_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__chart_cmpt__["a" /* default */]));

/***/ }),

/***/ "MZx8":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"event-repeat-delete-modal modal-fixed-height\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.confirm()\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cdiv class=\"modal-title\"\u003EDelete transaction\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter modal-section\"\u003E\u003Cdiv class=\"prompt-question\"\u003EWould you like to delete this particular transaction or all the following transactions too?\u003C\u002Fdiv\u003E\u003Cdiv class=\"prompt-answers\"\u003E\u003Clabel class=\"prompt-answer\" ng-click=\"$ctrl.selectOnlyThis()\"\u003E\u003Cdb-a-radio class=\"prompt-answer-state\" selected=\"$ctrl.isOnlyThisSelected\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"prompt-answer-title\"\u003EOnly this transaction\u003C\u002Fdiv\u003E\u003Cdiv class=\"prompt-answer-description\"\u003EAll other transactions in the series will be kept.\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003Clabel class=\"prompt-answer\" ng-click=\"$ctrl.selectThisAndAllFollowing()\"\u003E\u003Cdb-a-radio class=\"prompt-answer-state\" selected=\"!$ctrl.isOnlyThisSelected\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"promot-answer-title\"\u003EThis and all following transactions\u003C\u002Fdiv\u003E\u003Cdiv class=\"prompt-answer-description\"\u003EThis and all the following transactions in the series will be deleted.\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-outline button-secondary button-modal-left button-modal-done button-cancel\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-class=\"{ disabled: form.$submitting }\"\u003ECancel\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-danger button-modal-right button-modal-done button-confirm\" type=\"submit\" db-a-async loading=\"form.$submitting\"\u003E\u003Cinitial\u003EYes, delete\u003C\u002Finitial\u003E\u003Cloading\u003EDeleting...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "MbXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_application_util_event_report_util__ = __webpack_require__("NLyG");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var UNSET_HEADER = function () {}();

var EventService = function () {
    EventService.$inject = ['$q', 'eventUtil', 'timeUtil', 'apiService', 'sessionService'];

    /* @ngInject */
    function EventService($q, eventUtil, timeUtil, apiService, sessionService) {
        _classCallCheck(this, EventService);

        this.$q = $q;
        this.eventUtil = eventUtil;
        this.timeUtil = timeUtil;
        this.apiService = apiService;
        this.sessionService = sessionService;
    }

    _createClass(EventService, [{
        key: 'getInitial',
        value: function getInitial(timestamp) {
            var _this = this;

            return this.$q(function (resolve) {
                var event = {
                    timestamp: timestamp,
                    transactionDate: _this.timeUtil.toTransactionDate(timestamp),
                    confirmed: _this.eventUtil.isPast(timestamp),
                    isIncludedInReports: true,
                    owner: __WEBPACK_IMPORTED_MODULE_0_angular___default.a.merge({}, _this.sessionService.user)
                };

                resolve(event);
            });
        }
    }, {
        key: 'create',
        value: function create(calendarId, event) {
            return this.apiService.post('/calendars/' + calendarId + '/transactions', Object(__WEBPACK_IMPORTED_MODULE_1_application_util_event_report_util__["c" /* toEventPayload */])(event)).then(function (result) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_application_util_event_report_util__["b" /* normalizeIncludeInReports */])(result.data);
            });
        }
    }, {
        key: 'uploadReceipt',
        value: function uploadReceipt(file) {
            var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'receipt.jpeg';

            var formData = new FormData();
            formData.append('receipt', file, filename);

            return this.apiService.post('/upload/receipt', formData, {
                transformRequest: function transformRequest(data) {
                    return data;
                },
                headers: {
                    'Content-Type': UNSET_HEADER
                }
            }).then(function (result) {
                var data = result && result.data ? result.data : {};
                return data.url || null;
            });
        }
    }, {
        key: 'update',
        value: function update(event, eventSelector) {
            return this.apiService.put('/transactions/' + event.id, Object(__WEBPACK_IMPORTED_MODULE_1_application_util_event_report_util__["c" /* toEventPayload */])(event), {
                params: {
                    which: eventSelector || this.eventUtil.EventRepeatSelector.OnlyThis
                }
            }).then(function (result) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_application_util_event_report_util__["b" /* normalizeIncludeInReports */])(result.data);
            });
        }
    }, {
        key: 'updateRepeating',
        value: function updateRepeating(event, occurrence, eventSelector) {
            return this.apiService.post('/transactions/' + event.templateId + '/' + occurrence, Object(__WEBPACK_IMPORTED_MODULE_1_application_util_event_report_util__["c" /* toEventPayload */])(event), {
                params: {
                    which: eventSelector || this.eventUtil.EventRepeatSelector.OnlyThis
                }
            }).then(function (result) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_application_util_event_report_util__["b" /* normalizeIncludeInReports */])(result.data);
            });
        }
    }, {
        key: 'remove',
        value: function remove(event, eventSelector) {
            return this.apiService.delete('/transactions/' + event.id, {
                params: {
                    which: eventSelector || this.eventUtil.EventRepeatSelector.OnlyThis
                }
            });
        }
    }, {
        key: 'removeRepeating',
        value: function removeRepeating(event, occurrence, eventSelector) {
            return this.apiService.delete('/transactions/' + event.templateId + '/' + occurrence, {
                params: {
                    which: eventSelector || this.eventUtil.EventRepeatSelector.OnlyThis
                }
            });
        }
    }]);

    return EventService;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventService);

/***/ }),

/***/ "MfiQ":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"option-select\" ng-class=\"{ disabled: $ctrl.disabled }\"\u003E\u003Cbutton class=\"button button-icon button-select-previous\" type=\"button\" ng-click=\"$ctrl.selectPreviousOption()\" ng-disabled=\"$ctrl.disabled\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"options\"\u003E\u003Cdiv class=\"option\" ng-repeat=\"option in $ctrl.options track by $index\" ng-bind=\"option.value\" ng-class=\"{ active: option.id === $ctrl.id }\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-icon button-select-next\" type=\"button\" ng-click=\"$ctrl.selectNextOption()\" ng-disabled=\"$ctrl.disabled\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "MkRY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"color-palette":"color-palette","palette-page-control":"palette-page-control","disabled":"disabled","palette-page-control-up":"palette-page-control-up","palette-page-control-down":"palette-page-control-down","palette-grid":"palette-grid","grid-item-container":"grid-item-container","grid-item":"grid-item","palette-item":"palette-item","selected":"selected","used":"used","icon-selected":"icon-selected"};

/***/ }),

/***/ "N141":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category\" ng-class=\"{ unknown: $ctrl.unknown, filled: $ctrl.fill, disabled: $ctrl.disabled }\"\u003E\u003Cdb-a-category-icon ng-if=\"$ctrl.showIcon\" icon-name=\"$ctrl.iconNameResolved\" icon-index=\"$ctrl.iconIndex\" color=\"$ctrl.iconColor\"\u003E\u003C\u002Fdb-a-category-icon\u003E\u003Cdb-a-category-color ng-if=\"!$ctrl.showIcon\" color=\"$ctrl.color\" fill=\"$ctrl.fill\"\u003E\u003C\u002Fdb-a-category-color\u003E\u003Cdiv class=\"category-name\" ng-bind=\"$ctrl.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "N5cQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"subscription-settings-page":"subscription-settings-page","page-title":"page-title","form-group":"form-group","subscription-content":"subscription-content","subscription-expiration-date":"subscription-expiration-date","subscription-info":"subscription-info","subscription-feature":"subscription-feature"};

/***/ }),

/***/ "N6I6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common__ = __webpack_require__("1lyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sign_up_cmpt__ = __webpack_require__("whya");
stateConfiguration.$inject = ['$stateProvider'];





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.sign-up', []).component(__WEBPACK_IMPORTED_MODULE_2__sign_up_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__sign_up_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.sign-up', {
        url: __WEBPACK_IMPORTED_MODULE_1_common__["d" /* URL_SIGN_UP */],
        template: '<db-a-sign-up class="block-component"></db-a-sign-up>',
        data: {
            requires: {
                anonymous: 'authorized.calendar'
            }
        }
    });
}

/***/ }),

/***/ "NLQ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_provider_subscribable_provider__ = __webpack_require__("OymO");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SessionService = function (_Subscribable) {
    SessionService.$inject = ['$q', 'apiService', 'storageService', 'appStartCacheService', 'diagnosticsService'];

    _inherits(SessionService, _Subscribable);

    /* @ngInject */
    function SessionService($q, apiService, storageService, appStartCacheService, diagnosticsService) {
        _classCallCheck(this, SessionService);

        var _this = _possibleConstructorReturn(this, (SessionService.__proto__ || Object.getPrototypeOf(SessionService)).call(this));

        _this.$q = $q;
        _this.apiService = apiService;
        _this.storageService = storageService;
        _this.appStartCacheService = appStartCacheService;
        _this.diagnosticsService = diagnosticsService;

        _this.promise = null;
        return _this;
    }

    _createClass(SessionService, [{
        key: 'reload',
        value: function reload() {
            var _this2 = this;

            return this.initialize(true).catch(function (error) {
                return _this2.$q.reject(error);
            });
        }
    }, {
        key: 'initialize',
        value: function initialize(reload) {
            var _this3 = this;

            if (!reload && this.promise) {
                return this.promise;
            }

            this.promise = this.apiService.onlyAuthorized().then(function () {
                return _this3.apiService.get('/context').then(function (result) {
                    return _this3.updateUser(result);
                }).catch(function (error) {
                    _this3.clearUser();
                    return _this3.$q.reject(error);
                });
            }).catch(function (error) {
                _this3.clearUser();
                return _this3.$q.reject(error);
            });

            return this.promise;
        }
    }, {
        key: 'updateUser',
        value: function updateUser(result) {
            if (result.data && result.data.user) {
                this.user = result.data.user;
                return result.data;
            }

            this.clearUser();
            return this.$q.reject('We were unable to read and process your initial request. Please try again later.');
        }
    }, {
        key: 'deleteAccount',
        value: function deleteAccount() {
            var _this4 = this;

            return this.apiService.delete('/users/me').finally(function () {
                _this4.changeTokenAndReload();
            });
        }
    }, {
        key: 'clearUser',
        value: function clearUser() {
            this.user = null;
        }
    }, {
        key: 'signIn',
        value: function signIn(identity, password) {
            var _this5 = this;

            this.diagnosticsService.info('sign_in_attempt', {
                identityProvided: !!identity
            });

            return this.apiService.post('/sign-in', {
                identity: identity,
                password: password
            }, {
                anonymous: true
            }).then(function (result) {
                return _this5.changeTokenAndReload(result).then(function (data) {
                    if (!data || !data.user) {
                        _this5.diagnosticsService.error('sign_in_missing_user_after_reload');
                        return _this5.$q.reject(new Error('No user data after reload'));
                    }
                    _this5.diagnosticsService.info('sign_in_success', {
                        userId: data.user && data.user.id
                    });
                    return _this5.fire('sign-in', data.user);
                });
            }).catch(function (error) {
                _this5.diagnosticsService.warn('sign_in_failed', _this5.diagnosticsService.describeHttpError(error));
                return _this5.$q.reject(error || new Error('Sign in failed'));
            });
        }
    }, {
        key: 'signUp',
        value: function signUp(name, identity, password) {
            var _this6 = this;

            return this.apiService.post('/sign-up', {
                name: name,
                identity: identity,
                password: password,
                email: identity
            }, {
                anonymous: true
            }).then(function () {
                return _this6.signIn(identity, password);
            }).catch(function (error) {
                return _this6.$q.reject(error);
            });
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            var _this7 = this;

            this.diagnosticsService.info('sign_out_requested');
            return this.apiService.post('/sign-out').then(function (result) {
                _this7.finalizeSignOut();
                _this7.diagnosticsService.info('sign_out_completed');
                return result;
            }).catch(function (error) {
                _this7.diagnosticsService.warn('sign_out_failed', _this7.diagnosticsService.describeHttpError(error));
                return _this7.$q.reject(error);
            });
        }
    }, {
        key: 'finalizeSignOut',
        value: function finalizeSignOut() {
            // Clear the token and user data after a successful sign-out.
            this.appStartCacheService.clearAll();
            this.apiService.token = null;
            this.promise = null;
            this.storageService.setUserPrefix(null);
            this.clearUser();
            this.fire('change', null);
        }
    }, {
        key: 'refreshToken',
        value: function refreshToken() {
            var _this8 = this;

            this.diagnosticsService.info('refresh_token_attempt');
            return this.apiService.post('/refresh-token', null, {
                anonymous: true
            }).then(function (result) {
                _this8.diagnosticsService.info('refresh_token_success');
                return _this8.changeToken(result);
            }).catch(function (error) {
                _this8.diagnosticsService.warn('refresh_token_failed', _this8.diagnosticsService.describeHttpError(error));
                return _this8.$q.reject(error);
            });
        }
    }, {
        key: 'changeToken',
        value: function changeToken(result) {
            var token = result && result.data && result.data.token ? result.data.token : null;

            if (!token) {
                this.diagnosticsService.error('change_token_missing_token');
                return this.$q.reject(new Error('No token received'));
            }

            this.apiService.token = token;
            this.fire('change', token);

            return this.$q.resolve(token);
        }
    }, {
        key: 'changeTokenAndReload',
        value: function changeTokenAndReload(result) {
            var _this9 = this;

            return this.changeToken(result).then(function () {
                return _this9.apiService.onlyAuthorized().then(function () {
                    return _this9.reload();
                });
            }).catch(function (error) {
                return _this9.reload().then(function () {
                    return _this9.$q.reject(error);
                });
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(callback) {
            return this.on('change', callback);
        }
    }, {
        key: 'onSignIn',
        value: function onSignIn(callback) {
            return this.on('sign-in', callback);
        }
    }]);

    return SessionService;
}(Object(__WEBPACK_IMPORTED_MODULE_0_common_provider_subscribable_provider__["a" /* default */])());

/* harmony default export */ __webpack_exports__["a"] = (SessionService);

/***/ }),

/***/ "NLyG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIncludeInReports;
/* unused harmony export getReceiptUrl */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeIncludeInReports;
/* harmony export (immutable) */ __webpack_exports__["c"] = toEventPayload;
function getIncludeInReports(event) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (event && typeof event.isIncludedInReports === 'boolean') {
        return event.isIncludedInReports;
    }

    if (event && typeof event.includeInReports === 'boolean') {
        return event.includeInReports;
    }

    return fallback;
}

function getReceiptUrl(event) {
    if (!event) {
        return null;
    }

    if (typeof event.receiptUrl === 'string' && event.receiptUrl.length > 0) {
        return event.receiptUrl;
    }

    if (typeof event.receiptURL === 'string' && event.receiptURL.length > 0) {
        return event.receiptURL;
    }

    if (typeof event.receipt_url === 'string' && event.receipt_url.length > 0) {
        return event.receipt_url;
    }

    if (event.receipt && typeof event.receipt.url === 'string' && event.receipt.url.length > 0) {
        return event.receipt.url;
    }

    return null;
}

function normalizeIncludeInReports(event) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!event) {
        return event;
    }

    var includeInReports = getIncludeInReports(event, fallback);
    var normalizedEvent = Object.assign({}, event, {
        includeInReports: includeInReports,
        isIncludedInReports: includeInReports
    });

    var receiptUrl = getReceiptUrl(event);

    if (receiptUrl) {
        normalizedEvent.receiptUrl = receiptUrl;
    }

    return normalizedEvent;
}

function toEventPayload(event) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!event) {
        return event;
    }

    var includeInReports = getIncludeInReports(event, fallback);
    var payload = Object.assign({}, event, {
        includeInReports: includeInReports
    });

    delete payload.receiptLocalUrl;
    delete payload.receiptFile;
    delete payload.receiptName;

    if (typeof payload.transactionDate !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(payload.transactionDate)) {
        delete payload.transactionDate;
    }

    return payload;
}

/***/ }),

/***/ "NRy+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__("KBYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_slice__ = __webpack_require__("bpPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_take__ = __webpack_require__("m4tL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_application_util_balance_highlight_util__ = __webpack_require__("Ium9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar_day_style_sass__ = __webpack_require__("mRXS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar_day_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__calendar_day_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__calendar_day_tpl_pug__ = __webpack_require__("9TJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__calendar_day_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__calendar_day_tpl_pug__);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var CalendarDayController = function () {
    CalendarDayController.$inject = ['eventUtil'];

    /* @ngInject */
    function CalendarDayController(eventUtil) {
        _classCallCheck(this, CalendarDayController);

        this.eventUtil = eventUtil;
    }

    _createClass(CalendarDayController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.limit) {
                this.limit = changeObject.limit.currentValue;
            }

            var limit = this.limit == null ? 4 : Math.max(this.limit, 0);

            if (changeObject.events) {
                this.events = this.sort(changeObject.events.currentValue || []);
            }

            if (changeObject.events || changeObject.limit) {
                this.more = this.events.length > limit ? this.events.length - limit + 1 : 0;

                this.displayedEvents = this.more > 1 ? __WEBPACK_IMPORTED_MODULE_2_lodash_take___default()(this.events, this.events.length - this.more) : this.events.slice();
            }
        }
    }, {
        key: 'sort',
        value: function sort(events) {
            events = events || [];

            return __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_slice___default()(events), function (event) {
                return event.confirmed;
            }, function (event) {
                return event.timestamp;
            });
        }
    }, {
        key: 'clickHeading',
        value: function clickHeading() {
            return this.onListClick();
        }
    }, {
        key: 'clickMore',
        value: function clickMore() {
            return this.onListClick();
        }
    }, {
        key: 'clickAddEvent',
        value: function clickAddEvent() {
            return this.onAddClick();
        }
    }, {
        key: 'selectEvent',
        value: function selectEvent(event) {
            return this.onEventClick({
                event: event
            });
        }
    }, {
        key: 'eventDrop',
        value: function eventDrop(event) {
            return this.onEventDrop({
                event: event
            });
        }
    }, {
        key: 'validateEventDrop',
        value: function validateEventDrop(event) {
            return this.events && this.events.indexOf(event) < 0;
        }
    }, {
        key: 'getBalanceOverrideColor',
        value: function getBalanceOverrideColor(value) {
            if (this.loadingBalances) {
                return null;
            }

            return Object(__WEBPACK_IMPORTED_MODULE_3_application_util_balance_highlight_util__["a" /* getBalanceOverrideColor */])(value, this.balanceWarningThreshold);
        }
    }]);

    return CalendarDayController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarDay',
    template: __WEBPACK_IMPORTED_MODULE_5__calendar_day_tpl_pug___default()(),
    controller: CalendarDayController,
    bindings: {
        date: '<',
        change: '<',
        balance: '<',
        events: '<',
        today: '<',
        another: '<',
        loadingBalances: '<',
        balanceWarningThreshold: '<',
        limit: '<',
        useCategoryIcons: '<',

        canManageEvents: '<',

        onListClick: '&',
        onAddClick: '&',
        onEventClick: '&',
        onEventDrop: '&'
    }
});

/***/ }),

/***/ "NY7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentService = function () {
    PaymentService.$inject = ['$q', 'apiService'];

    /* @ngInject */
    function PaymentService($q, apiService) {
        _classCallCheck(this, PaymentService);

        this.$q = $q;
        this.apiService = apiService;
    }

    _createClass(PaymentService, [{
        key: 'getBuyUrl',
        value: function getBuyUrl(subscriptionId) {
            var _this = this;

            return this.apiService.post('/subscriptions/avangate/buy-link', null, {
                params: {
                    subscriptionId: subscriptionId
                }
            }).then(function (result) {
                if (result.data && result.data.link) {
                    return result.data.link;
                }
                return _this.$q.reject(new Error('No payment link received'));
            }).catch(function (error) {
                return _this.$q.reject(error);
            });
        }
    }, {
        key: 'confirm',
        value: function confirm(avangateCtrl, token) {
            return this.apiService.post('/subscriptions/avangate/payments', {
                avangateCtrl: avangateCtrl,
                token: token
            });
        }
    }]);

    return PaymentService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PaymentService);

/***/ }),

/***/ "Nfcd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_26-2d1ea1b2d887c81d.svg";

/***/ }),

/***/ "Nkrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__period_month_item__ = __webpack_require__("M5hB");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-header.component.calendar-period.component', [__WEBPACK_IMPORTED_MODULE_1__period_month_item__["a" /* default */].name]));

/***/ }),

/***/ "NmuC":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"event-details-modal modal-fixed-height\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\"\u003EDescription\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter\"\u003E\u003Ctextarea class=\"modal-section event-details\" placeholder=\"Add details about this transaction\" ng-model=\"$ctrl.event.details\" maxlength=\"255\" db-a-autofocus=\"true\" ng-readonly=\"!$ctrl.canEdit\"\u003E\u003C\u002Ftextarea\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-modal-left button-close-modal\" ng-click=\"$ctrl.dismiss()\" ng-if=\"!$ctrl.canEdit\"\u003EClose\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-save-details\" ng-click=\"$ctrl.close()\" ng-if=\"$ctrl.canEdit\"\u003EOK\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "Nnmi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"switch":"switch","switch-label":"switch-label","switch-control":"switch-control","input-checkbox":"input-checkbox","toggled":"toggled","disabled":"disabled"};

/***/ }),

/***/ "NpVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__category_icon_style_sass__ = __webpack_require__("SQDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__category_icon_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__category_icon_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_icon_tpl_pug__ = __webpack_require__("7yQ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_icon_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__category_icon_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/* global require */
var iconContext = __webpack_require__("Lh+N");
var iconMap = __webpack_require__("nyB0");

var iconIndexMap = iconMap.reduce(function (map, entry) {
    if (!entry || !entry.iconIndex) {
        return map;
    }

    if (entry.svgFilename) {
        map[entry.iconIndex] = entry.svgFilename;
        return map;
    }

    if (entry.pdfFilename) {
        map[entry.iconIndex] = entry.pdfFilename.replace(/\.pdf$/i, '.svg');
    }

    return map;
}, {});

function resolveIconPath(name, iconIndex) {
    var mappedName = iconIndexMap[iconIndex];
    var resolvedName = name || mappedName;

    if (!resolvedName) {
        return null;
    }

    var normalized = String(resolvedName).trim();
    if (!normalized) {
        return null;
    }

    var fileName = normalized.endsWith('.svg') ? normalized : normalized + '.svg';

    try {
        return iconContext('./' + fileName);
    } catch (error) {
        return null;
    }
}

function normalizeSize(size) {
    if (size == null || size === '') {
        return null;
    }

    if (typeof size === 'number') {
        return size + 'px';
    }

    var value = ('' + size).trim();
    if (!value.length) {
        return null;
    }

    return (/^\d+$/.test(value) ? value + 'px' : value
    );
}

var CategoryIconController = function () {
    function CategoryIconController() {
        _classCallCheck(this, CategoryIconController);
    }

    _createClass(CategoryIconController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.iconName || changeObject.iconIndex) {
                this.iconUrl = resolveIconPath(this.iconName, this.iconIndex);
            }

            if (changeObject.color || changeObject.iconName || changeObject.size) {
                var safeUrl = this.iconUrl ? encodeURI(this.iconUrl).replace(/"/g, '\\"') : null;
                var iconUrl = safeUrl ? 'url("' + safeUrl + '")' : null;
                var size = normalizeSize(this.size);

                this.style = {
                    color: this.color || 'currentColor',
                    backgroundColor: this.color || 'currentColor',
                    maskImage: iconUrl,
                    WebkitMaskImage: iconUrl,
                    width: size,
                    height: size
                };
            }
        }
    }]);

    return CategoryIconController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategoryIcon',
    template: __WEBPACK_IMPORTED_MODULE_1__category_icon_tpl_pug___default()(),
    controller: CategoryIconController,
    bindings: {
        iconName: '<',
        iconIndex: '<',
        color: '<',
        size: '<'
    }
});

/***/ }),

/***/ "NqOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scene__ = __webpack_require__("Tsmr");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.email-verification', [__WEBPACK_IMPORTED_MODULE_1__scene__["a" /* default */].name]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.email-verification', {
        url: '/verify-email',
        abstract: true,
        template: '<ui-view class="block-component"></ui-view>'
    });
}

/***/ }),

/***/ "NrPr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"about-settings-page":"about-settings-page","form-group":"form-group","link-privacy-policy":"link-privacy-policy","link-terms-of-service":"link-terms-of-service","link-help-center":"link-help-center","link-facebook":"link-facebook","link-twitter":"link-twitter","link-feedback":"link-feedback","button-send-diagnostics":"button-send-diagnostics"};

/***/ }),

/***/ "NtIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collaborator_manage_modal_cmpt__ = __webpack_require__("yVny");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.collaborator-manage-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__collaborator_manage_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__collaborator_manage_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "Ntdr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-edit-modal":"calendar-edit-modal","calendar-name":"calendar-name","calendar-color":"calendar-color","calendar-note":"calendar-note","calendar-accounts":"calendar-accounts","control-input":"control-input","calendar-auto-forecast":"calendar-auto-forecast","control-switch":"control-switch","control-switch-content":"control-switch-content"};

/***/ }),

/***/ "NxPG":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("uIr7"),
    baseFlatten = __webpack_require__("1C79"),
    copyArray = __webpack_require__("hrPF"),
    isArray = __webpack_require__("NGEn");

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

module.exports = concat;


/***/ }),

/***/ "Nxgv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_17-399a8d94e24b7d04.svg";

/***/ }),

/***/ "O4Lo":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("yCNF"),
    now = __webpack_require__("RVHk"),
    toNumber = __webpack_require__("kxzG");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "O5d7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"identity-page":"identity-page","identity-content":"identity-content","identity-logo":"identity-logo","logo":"logo","logo-text":"logo-text","identity-box":"identity-box","identity-title":"identity-title","identity-comment":"identity-comment","identity-note":"identity-note","control-group":"control-group","form-note":"form-note","form-submit":"form-submit","form-illustration":"form-illustration","form-image":"form-image","form-title":"form-title","form-validation":"form-validation"};

/***/ }),

/***/ "O9b3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text_notification_cmpt__ = __webpack_require__("SAAm");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.notifications.component.text-notification', []).component(__WEBPACK_IMPORTED_MODULE_1__text_notification_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__text_notification_cmpt__["a" /* default */]));

/***/ }),

/***/ "O9jO":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"collaborator-manage-modal modal-fixed-height\" ng-class=\"{ empty: $ctrl.isEmpty }\"\u003E\u003Cdiv class=\"modal-header modal-section modal-delimiter\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.close()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\"\u003EManage collaborators\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-section modal-body-scrollable\"\u003E\u003Cdiv class=\"collaborators\"\u003E\u003Cbutton class=\"invite-collaborator\" type=\"button\" ng-click=\"$ctrl.openInviteMembersModal()\" ng-show=\"$ctrl.canInvite\"\u003E\u003Cdiv class=\"button button-fill button-primary button-add\"\u003E\u003Ci class=\"icon icon-dollarbird-plus\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"invite-collaborator-text\"\u003EInvite people\u003C\u002Fdiv\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"collaborator-item\" ng-repeat=\"collaborator in $ctrl.collaborators track by $index\" ng-class=\"{ invited: collaborator.invited }\"\u003E\u003Cdb-a-user-image class=\"collaborator-image\" name=\"collaborator.name\" email=\"collaborator.email\" color=\"collaborator.profileImage.color\" url=\"collaborator.profileImage.url\"\u003E\u003C\u002Fdb-a-user-image\u003E\u003Cdiv class=\"collaborator-info\"\u003E\u003Cdiv class=\"collaborator-name\" ng-bind=\"collaborator.name\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collaborator-email\" ng-bind=\"collaborator.email\" ng-class=\"{ highlighted: !collaborator.name }\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-icon button-delete-collaborator\" type=\"button\" ng-click=\"$ctrl.promptToDelete(collaborator)\"\u003E\u003Ci class=\"icon icon-dollarbird-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collaborators-full-message\" ng-if=\"$ctrl.isAtMaxCollaborators\"\u003E\u003Cspan\u003EYou've reached the member limit of your plan. To continue inviting new people \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"authorized.subscribe\"\u003Eupgrade your account\u003C\u002Fa\u003E\u003Cspan\u003E or remove members.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state\"\u003E\u003Cdiv class=\"empty-state-content\"\u003E\u003Cimg" + (" class=\"empty-state-image\""+pug.attr("src", __webpack_require__("pxa1"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003Cdiv class=\"empty-state-title\"\u003ECollaborate on your expenses\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state-message\"\u003EAdd people to your teams so you can track and manage your finances together.\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-fill button-primary button-add-team\" ng-click=\"$ctrl.openInviteMembersModal()\"\u003EInvite people\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "OASY":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"event-receipt-modal modal-fixed-height\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\" ng-bind=\"$ctrl.canAttach ? 'Preview image' : 'Receipt image'\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter\"\u003E\u003Cdiv class=\"event-receipt-image-container\"\u003E\u003Cimg class=\"event-receipt-image\" ng-src=\"{{ $ctrl.imageUrl }}\" alt=\"Receipt image\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-attach-receipt\" type=\"button\" ng-if=\"$ctrl.canAttach\" ng-click=\"$ctrl.attach()\"\u003EAttach\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-download-receipt\" type=\"button\" ng-if=\"!$ctrl.canAttach\" ng-click=\"$ctrl.download()\"\u003EDownload\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "OEeb":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"subscription-settings-page\"\u003E\u003Cdiv class=\"page-title\" ng-if=\"!$ctrl.expired\"\u003E\u003Cspan\u003EYou have a \u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.plan.name\" ng-style=\"{ color: $ctrl.plan.color }\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E subscription!\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"page-title\" ng-if=\"$ctrl.expired\"\u003E\u003Cspan\u003EYour \u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.plan.name\" ng-style=\"{ color: $ctrl.plan.color }\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E subscription has expired!\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-content\"\u003E\u003Ca class=\"button button-fill button-primary\" href=\"javascript:void(0);\" ui-sref=\"authorized.subscribe\" ng-if=\"$ctrl.expired\"\u003ERenew your subscription\u003C\u002Fa\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EGeneral\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cspan\u003EYour subscription \u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.endDate\"\u003E\u003Cspan ng-if=\"!$ctrl.expired\"\u003Ewill expire on \u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.expired\"\u003Eexpired on \u003C\u002Fspan\u003E\u003Cspan class=\"subscription-expiration-date\"\u003E\u003Cspan ng-bind=\"$ctrl.endDate\"\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!$ctrl.expired\"\u003E\u003Cspan\u003E (in \u003C\u002Fspan\u003E\u003Cdb-a-time timestamp=\"$ctrl.endTimestamp\" max-unit=\"day\"\u003E\u003C\u002Fdb-a-time\u003E\u003Cspan\u003E)\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.expired\"\u003E\u003Cspan\u003E (\u003C\u002Fspan\u003E\u003Cdb-a-time timestamp=\"$ctrl.endTimestamp\" max-unit=\"day\"\u003E\u003C\u002Fdb-a-time\u003E\u003Cspan\u003E ago)\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!$ctrl.processing\"\u003E\u003Cspan ng-if=\"$ctrl.recurring &amp;&amp; $ctrl.price\"\u003E \u003Cspan\u003E and it will be renewed automatically for \u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.price\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!$ctrl.recurring || !$ctrl.price\"\u003E and you will have to renew it manually\u003C\u002Fspan\u003E\u003Cspan\u003E . You have purchased this plan from your \u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.device\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!$ctrl.endDate\"\u003Ewon't ever expire\u003C\u002Fspan\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EInformation\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Ctable class=\"subscription-information\"\u003E\u003Ctr\u003E\u003Ctd\u003E\u003Cspan ng-if=\"!$ctrl.expired\"\u003EExpires on\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.expired\"\u003EExpired on\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"subscription-info\"\u003E\u003Cspan ng-bind=\"$ctrl.endDate\"\u003E\u003C\u002Fspan\u003E\u003Cspan ng-hide=\"$ctrl.endDate\"\u003ENever\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"$ctrl.endDate &amp;&amp; $ctrl.price &amp;&amp; !$ctrl.processing\"\u003E\u003Ctd\u003EPrice\u003C\u002Ftd\u003E\u003Ctd class=\"subscription-info\" ng-bind=\"$ctrl.price\"\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"$ctrl.endDate &amp;&amp; !$ctrl.processing\"\u003E\u003Ctd\u003ERenew automatically\u003C\u002Ftd\u003E\u003Ctd class=\"subscription-info\"\u003E\u003Cspan ng-if=\"$ctrl.recurring\"\u003EYes\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!$ctrl.recurring\"\u003ENo\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"$ctrl.endDate &amp;&amp; !$ctrl.processing\"\u003E\u003Ctd\u003EBought from\u003C\u002Ftd\u003E\u003Ctd class=\"subscription-info\"\u003E\u003Cspan ng-bind=\"$ctrl.store\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E (\u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.device\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E)\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr ng-if=\"$ctrl.features.length &gt; 0\"\u003E\u003Ctd\u003E\u003Cspan ng-if=\"!$ctrl.expired\"\u003EIncludes\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.expired\"\u003EIncluded\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"subscription-info\"\u003E\u003Cdiv class=\"subscription-feature\" ng-repeat=\"feature in $ctrl.features\" ng-bind=\"feature\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\" ng-show=\"$ctrl.endDate &amp;&amp; !$ctrl.expired\"\u003E\u003Cdiv class=\"form-group-name\"\u003ECancel\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cspan\u003EPlease see \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.cancelSubscriptionHelpCenterUrl }}\" target=\"_blank\" rel=\"noopener\"\u003Ethis Help Center article\u003C\u002Fa\u003E\u003Cspan\u003E to learn about how to cancel your subscription.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "OHlg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_confirm_cmpt__ = __webpack_require__("gDNm");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.forgot-password-confirm', []).component(__WEBPACK_IMPORTED_MODULE_1__forgot_password_confirm_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__forgot_password_confirm_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.forgot-password.confirm', {
        url: '',
        template: '<db-a-forgot-password-confirm class="block-component"></db-a-forgot-password-confirm>'
    });
}

/***/ }),

/***/ "OY7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkbox_cmpt__ = __webpack_require__("Y2h6");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.checkbox', []).component(__WEBPACK_IMPORTED_MODULE_1__checkbox_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__checkbox_cmpt__["a" /* default */]));

/***/ }),

/***/ "OfXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_merge_modal_cmpt__ = __webpack_require__("Si9C");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.category-merge-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__category_merge_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__category_merge_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "OiI6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_32-280800fac031d512.svg";

/***/ }),

/***/ "Ojfb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Heart-Hands-73fc3ff61d22d1db.svg";

/***/ }),

/***/ "OmoP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-group":"category-group","category-heading":"category-heading","category-toggle":"category-toggle","category-name":"category-name","category-progress-container":"category-progress-container","category-progress":"category-progress","category-progress-bar":"category-progress-bar","outer":"outer","category-value-types":"category-value-types","category-value-type":"category-value-type","category-value-type-heading":"category-value-type-heading","category-value-type-color":"category-value-type-color","opaque":"opaque","category-value-type-name":"category-value-type-name","category-value-type-value":"category-value-type-value","event-groups":"event-groups","event-group-item":"event-group-item"};

/***/ }),

/***/ "P1Ul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renew_subscription_notification_style_sass__ = __webpack_require__("hqfj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renew_subscription_notification_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__renew_subscription_notification_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__renew_subscription_notification_tpl_pug__ = __webpack_require__("UlYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__renew_subscription_notification_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__renew_subscription_notification_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var RenewSubscriptionNotificationController = function () {
    function RenewSubscriptionNotificationController() {
        _classCallCheck(this, RenewSubscriptionNotificationController);
    }

    _createClass(RenewSubscriptionNotificationController, [{
        key: 'renew',
        value: function renew() {
            __WEBPACK_IMPORTED_MODULE_0_common_analytics__["c" /* default */].trackRenewNotificationRenew();

            return this.onClose();
        }
    }, {
        key: 'select',
        value: function select() {
            this.onClose();
            this.onSelect();

            __WEBPACK_IMPORTED_MODULE_0_common_analytics__["c" /* default */].trackRenewNotificationSelectDefaultCalendar();
        }
    }]);

    return RenewSubscriptionNotificationController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbARenewSubscriptionNotification',
    template: __WEBPACK_IMPORTED_MODULE_2__renew_subscription_notification_tpl_pug___default()(),
    controller: RenewSubscriptionNotificationController,
    bindings: {
        plan: '<',
        onSelect: '&',
        onClose: '&'
    }
});

/***/ }),

/***/ "P29P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_service__ = __webpack_require__("ty5p");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.service.dashboard', []).service('dashboardService', __WEBPACK_IMPORTED_MODULE_1__dashboard_service__["a" /* default */]));

/***/ }),

/***/ "P7a5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = CheckEventCountDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);

CheckEventCountDirective.$inject = ['$parse', '$document', '$window'];



var selector = 'dbACheckEventCount';

/* @ngInject */
function CheckEventCountDirective($parse, $document, $window) {
    return {
        restrict: 'A',

        link: {
            post: function post(scope, element, attrs) {
                var eventHeight = 18;
                var eventSpacing = 4;

                if ($parse(attrs[selector])(scope)) {
                    var onLimitChange = $parse(attrs.onLimitChange)(scope);
                    var resizeHandler = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
                        scope.$applyAsync(function () {
                            return onLimitChange(getEventCountFit());
                        });
                    }, 100);

                    onLimitChange(getEventCountFit());
                    __WEBPACK_IMPORTED_MODULE_1_angular___default.a.element($window).on('resize', resizeHandler);
                }

                function getEventCountFit() {
                    var container = findElementByClass('day-content');

                    if (container) {
                        var containerHeight = getElementHeight(container);

                        if (containerHeight) {
                            return Math.floor((containerHeight + eventSpacing) / (eventHeight + eventSpacing));
                        }
                    }

                    return null;
                }

                function findElementByClass(className) {
                    var elements = $document[0].getElementsByClassName(className);

                    if (elements.length > 0) {
                        return elements[0];
                    }

                    return null;
                }

                function getElementHeight(element) {
                    if (element && typeof element.getBoundingClientRect === 'function') {
                        var rectangle = element.getBoundingClientRect();

                        if (rectangle && rectangle.height != null) {
                            return rectangle.height;
                        }
                    }

                    return null;
                }
            }
        }
    };
}

/***/ }),

/***/ "PEJn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_checkbox_cmpt__ = __webpack_require__("chNe");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.calendar-checkbox', []).component(__WEBPACK_IMPORTED_MODULE_1__calendar_checkbox_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__calendar_checkbox_cmpt__["a" /* default */]));

/***/ }),

/***/ "PEX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["stateAuthorizationConfiguration"] = stateAuthorizationConfiguration;
/* harmony export (immutable) */ __webpack_exports__["animationConfiguration"] = animationConfiguration;
/* harmony export (immutable) */ __webpack_exports__["serviceConfiguration"] = serviceConfiguration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__ = __webpack_require__("7Cuf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_animate__ = __webpack_require__("mWUN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angular_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_site_style_sass__ = __webpack_require__("HV6+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_site_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_site_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common__ = __webpack_require__("1lyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__("ykAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directive__ = __webpack_require__("Xnak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("CwCP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scene__ = __webpack_require__("bYpV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service__ = __webpack_require__("qk6T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_config__ = __webpack_require__("vQ4Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_error_util__ = __webpack_require__("xQkc");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

serviceConfiguration.$inject = ['$state', 'apiService', 'sessionService', 'notificationService', 'storageService', 'navigationService', 'appStartCacheService', 'diagnosticsService'];
animationConfiguration.$inject = ['$animateProvider'];
stateAuthorizationConfiguration.$inject = ['$q', '$state', '$transitions'];
















/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application', [__WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__["default"], __WEBPACK_IMPORTED_MODULE_2_angular_animate___default.a, __WEBPACK_IMPORTED_MODULE_4_common__["f" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__util__["j" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__directive__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__service__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__scene__["a" /* default */].name]).run(serviceConfiguration).config(__WEBPACK_IMPORTED_MODULE_10__index_config__["b" /* routerConfiguration */]).run(__WEBPACK_IMPORTED_MODULE_10__index_config__["a" /* bootstrapApplication */]).config(animationConfiguration).run(stateAuthorizationConfiguration));

/* @ngInject */
function stateAuthorizationConfiguration($q, $state, $transitions) {
    $transitions.onStart({
        to: function to(state) {
            return state.data && state.data.requires;
        }
    }, function (transition) {
        var sessionService = transition.injector().get('sessionService');
        var navigationService = transition.injector().get('navigationService');
        var diagnosticsService = transition.injector().get('diagnosticsService');

        var state = transition.to();
        var requires = state.data.requires || {};
        var stateName = state && state.name ? state.name : null;

        diagnosticsService.info('route_guard_start', {
            toState: stateName,
            hasUserInMemory: !!sessionService.user,
            hasAnonymousRequirement: !!requires.anonymous,
            hasAuthenticationRequirement: !!requires.authentication
        });

        if (sessionService.user) {
            diagnosticsService.info('route_guard_memory_user_fast_path', {
                toState: stateName
            });
            sessionService.initialize().catch(function () {
                return null;
            });
            return checkFlagAndRedirect(requires.anonymous);
        }

        return sessionService.initialize().then(function (result) {
            diagnosticsService.info('route_guard_session_initialize_success', {
                toState: stateName,
                hasUser: !!(result && result.user)
            });

            return checkFlagAndRedirect(requires.anonymous);
        }, function (error) {
            diagnosticsService.warn('route_guard_session_initialize_failed', diagnosticsService.describeHttpError(error, {
                toState: stateName
            }));

            return checkFlagAndRedirect(requires.authentication);
        });

        function checkFlagAndRedirect(options) {
            options = (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object' ? options : {
                state: options
            };

            if (options.state) {
                diagnosticsService.warn('route_guard_redirect_decision', {
                    fromState: stateName,
                    toState: options.state,
                    keepRedirect: !!options.keep
                });
                return redirect(options.state, options.keep);
            }

            diagnosticsService.info('route_guard_allow', {
                toState: stateName
            });
            return true;
        }

        function redirect(name, keep) {
            if ($state.href(name)) {
                diagnosticsService.warn('route_guard_redirect_execute', {
                    fromState: stateName,
                    toState: name,
                    keepRedirect: !!keep
                });
                return $state.target(name, {
                    redirect: keep ? navigationService.getRedirectUrl(state.name, transition.params()) : null
                });
            }

            diagnosticsService.warn('route_guard_redirect_fallback_sign_in', {
                fromState: stateName,
                targetState: name
            });
            return $state.target('identity.sign-in');
        }
    }, {
        priority: 10
    });
}

/* @ngInject */
function animationConfiguration($animateProvider) {
    $animateProvider.classNameFilter(/animated/);
}

/* @ngInject */
function serviceConfiguration($state, apiService, sessionService, notificationService, storageService, navigationService, appStartCacheService, diagnosticsService) {
    diagnosticsService.start();

    apiService.token = storageService.getItem('token');
    diagnosticsService.info('app_service_init', {
        hasStoredToken: !!apiService.token
    });

    apiService.onTokenExpired(function (defer) {
        diagnosticsService.warn('app_token_expired_handler_start', {
            hasToken: !!apiService.token
        });
        sessionService.refreshToken().then(function (token) {
            updateToken(token);
            diagnosticsService.info('app_token_refresh_recovered', {
                hasToken: !!token
            });
            return defer.resolve();
        }).catch(function (result) {
            defer.reject(result);
            diagnosticsService.error('app_token_refresh_failed', diagnosticsService.describeHttpError(result, {
                hasTokenBeforeClear: !!apiService.token
            }));

            updateToken();

            var requiresAuthentication = isAuthenticationRequiredState();

            return sessionService.reload().catch(function () {
                if (requiresAuthentication) {
                    diagnosticsService.warn('app_forced_signout_notification', {
                        reason: 'refresh_failed'
                    });
                    handleSessionError(__WEBPACK_IMPORTED_MODULE_11__util_error_util__["a" /* MESSAGE_SESSION_END */]);
                }
            }).finally(function () {
                if (requiresAuthentication) {
                    diagnosticsService.warn('app_forced_signout_redirect', {
                        target: 'identity'
                    });
                    $state.go('identity', null, {
                        reload: true
                    });
                }
            });
        });
    });

    apiService.onStatusCode(401, function () {
        if (apiService.token) {
            diagnosticsService.warn('app_401_status_handler', {
                hasToken: !!apiService.token,
                authorizedState: isAuthenticationRequiredState()
            });
            updateToken();

            if (isAuthenticationRequiredState()) {
                $state.go('identity.sign-in', {
                    error: __WEBPACK_IMPORTED_MODULE_11__util_error_util__["a" /* MESSAGE_SESSION_END */]
                });
            }
        }
    });

    apiService.onError(__WEBPACK_IMPORTED_MODULE_11__util_error_util__["d" /* trackError */]);

    sessionService.initialize().then(function (data) {
        diagnosticsService.info('session_initialize_success', {
            hasUser: !!(data && data.user)
        });
        storageService.setUserPrefix(data && data.user && data.user.id ? data.user.id : null);
        appStartCacheService.warm().catch(function () {
            return null;
        });
    }).catch(function (result) {
        diagnosticsService.warn('session_initialize_failed', diagnosticsService.describeHttpError(result));
        if (isAuthenticationRequiredState()) {
            handleSessionError(result);
        }
    });

    sessionService.onChange(function (token) {
        updateToken(token);
    });

    sessionService.onSignIn(function (user) {
        storageService.setUserPrefix(user && user.id ? user.id : null);
        appStartCacheService.reset();
        appStartCacheService.warm().catch(function () {
            return null;
        });

        if (user && !user.verified && user.expirationDate) {
            navigationService.onSuccess(function () {
                notificationService.show({
                    component: 'dbAVerifyEmailNotification',
                    id: 'user-email-unverified',
                    bindings: {
                        expire: user.expirationDate,
                        email: user.email
                    }
                });
            }, true);
        }
    });

    function updateToken(token) {
        apiService.token = token;
        storageService.setItem('token', apiService.token);
        diagnosticsService.info('app_token_updated', {
            hasToken: !!token
        });
    }

    function isAuthenticationRequiredState() {
        if ($state.includes('authorized')) {
            return true;
        }

        return !!($state.current && $state.current.data && $state.current.data.requires && $state.current.data.requires.authentication);
    }

    function handleSessionError(result) {
        if (result) {
            notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11__util_error_util__["b" /* getErrorMessage */])(result), null, false, 10000);
        }
    }
}

/***/ }),

/***/ "PJh5":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "PZT5":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"date-picker\"\u003E\u003Cdiv class=\"dp-view-title\"\u003E\u003Cbutton class=\"button button-icon dp-button-select-previous\" ng-click=\"$ctrl.selectPreviousMonth()\" ng-if=\"!$ctrl.preventNavigationToPreviousMonth\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"dp-month\" ng-bind=\"$ctrl.monthName\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-icon dp-button-select-next\" ng-click=\"$ctrl.selectNextMonth()\" ng-if=\"!$ctrl.preventNavigationToNextMonth\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dp-view-content\"\u003E\u003Ctable class=\"dp-days\"\u003E\u003Ctr class=\"dp-weekday-list\"\u003E\u003Ctd class=\"dp-weekday-item\" ng-repeat=\"day in $ctrl.weekdays track by $index\" ng-bind=\"day.name\" ng-class=\"{ weekend: day.weekend }\"\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"dp-week\" ng-repeat=\"week in $ctrl.weeks track by $index\"\u003E\u003Ctd class=\"dp-day\" ng-repeat=\"day in week track by $index\"\u003E\u003Cdiv class=\"dp-day-content\" ng-class=\"day.style\"\u003E\u003Cbutton class=\"dp-day-item\" type=\"button\" ng-click=\"$ctrl.selectDay(day.timestamp)\" ng-disabled=\"day.style.disabled\"\u003E\u003Cdiv class=\"dp-day-date\" ng-bind=\"day.date\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "PdLe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__income_expense_chart_cmpt__ = __webpack_require__("C94H");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.dashboard.component.income-expense-chart', []).component(__WEBPACK_IMPORTED_MODULE_1__income_expense_chart_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__income_expense_chart_cmpt__["a" /* default */]));

/***/ }),

/***/ "Q+mV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_key_directive__ = __webpack_require__("Xp6K");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.process-key', []).directive(__WEBPACK_IMPORTED_MODULE_1__process_key_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__process_key_directive__["a" /* default */]));

/***/ }),

/***/ "Q+vZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"settings-page":"settings-page","settings-modal":"settings-modal","settings-modal-backdrop":"settings-modal-backdrop","settings-modal-container":"settings-modal-container","settings-header":"settings-header","page-title":"page-title","button-open-navigation":"button-open-navigation","button-close-page":"button-close-page","settings-navigation":"settings-navigation","visible":"visible","settings-view":"settings-view","settings-navigation-items":"settings-navigation-items","settings-navigation-item":"settings-navigation-item","active":"active","settings-navigation-sign-out":"settings-navigation-sign-out","button-sign-out":"button-sign-out","button-sign-out-loader":"button-sign-out-loader","form-group-name":"form-group-name","form-group-content":"form-group-content","form-submit":"form-submit","control":"control","settings-container":"settings-container","settings-content":"settings-content"};

/***/ }),

/***/ "Q1n8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__profile_service__ = __webpack_require__("5/ab");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preference_service__ = __webpack_require__("3Abr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__email_verification_service__ = __webpack_require__("wNkg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__collaborator_service__ = __webpack_require__("RE4E");







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.service.user', []).service('profileService', __WEBPACK_IMPORTED_MODULE_1__profile_service__["a" /* default */]).service('preferenceService', __WEBPACK_IMPORTED_MODULE_2__preference_service__["a" /* default */]).service('emailVerificationService', __WEBPACK_IMPORTED_MODULE_3__email_verification_service__["a" /* default */]).service('collaboratorService', __WEBPACK_IMPORTED_MODULE_4__collaborator_service__["a" /* default */]));

/***/ }),

/***/ "QE2y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"date-range-picker":"date-range-picker","date-range-item":"date-range-item"};

/***/ }),

/***/ "QFyr":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("3GN1");
module.exports = 'ang-drag-drop';


/***/ }),

/***/ "QV34":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("iO9N");
var Ticks = __webpack_require__("IbXy");

module.exports = function(Chart) {

	var noop = helpers.noop;

	Chart.LinearScaleBase = Chart.Scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return Chart.Scale.prototype.getRightValue.call(this, value);
		},

		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers.sign(me.min);
				var maxSign = helpers.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
		getTickLimit: noop,
		handleDirectionalChanges: noop,

		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = Ticks.generators.linear(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			Chart.Scale.prototype.convertTicksToLabels.call(me);
		}
	});
};


/***/ }),

/***/ "QmoE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryIncome-36f492813a2f448f.svg";

/***/ }),

/***/ "Qor1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");
var helpers = __webpack_require__("iO9N");

var defaultColor = defaults.global.defaultColor;

defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderColor: defaultColor,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
}

module.exports = Element.extend({
	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var model = this._model;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var color = helpers.color;
		var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
		var ratio = 0;

		if (vm.skip) {
			return;
		}

		ctx.strokeStyle = vm.borderColor || defaultColor;
		ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
		ctx.fillStyle = vm.backgroundColor || defaultColor;

		// Cliping for Points.
		// going out from inner charArea?
		if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
			// Point fade out
			if (model.x < chartArea.left) {
				ratio = (x - model.x) / (chartArea.left - model.x);
			} else if (chartArea.right * errMargin < model.x) {
				ratio = (model.x - x) / (model.x - chartArea.right);
			} else if (model.y < chartArea.top) {
				ratio = (y - model.y) / (chartArea.top - model.y);
			} else if (chartArea.bottom * errMargin < model.y) {
				ratio = (model.y - y) / (model.y - chartArea.bottom);
			}
			ratio = Math.round(ratio * 100) / 100;
			ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
			ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
		}

		helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
	}
});


/***/ }),

/***/ "Qyae":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Balance-scale-92413b9769acaa69.svg";

/***/ }),

/***/ "R04K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number_only_directive__ = __webpack_require__("ggwY");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.number-only', []).directive(__WEBPACK_IMPORTED_MODULE_1__number_only_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__number_only_directive__["a" /* default */]));

/***/ }),

/***/ "RE4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CollaboratorService = function () {
    CollaboratorService.$inject = ['apiService'];

    /* @ngInject */
    function CollaboratorService(apiService) {
        _classCallCheck(this, CollaboratorService);

        this.apiService = apiService;
    }

    _createClass(CollaboratorService, [{
        key: 'getAll',
        value: function getAll() {
            return this.apiService.get('/users/me/team-members').then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'create',
        value: function create(collaborator) {
            return this.updateAll([collaborator], []);
        }
    }, {
        key: 'delete',
        value: function _delete(collaborator) {
            return this.updateAll([], [collaborator]);
        }
    }, {
        key: 'updateAll',
        value: function updateAll(addedCollaborators, removedCollaborators) {
            var operations = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(addedCollaborators, function (collaborator) {
                return {
                    operation: 'create',
                    email: collaborator.email
                };
            });

            operations = __WEBPACK_IMPORTED_MODULE_0_lodash_concat___default()(operations, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(removedCollaborators, function (collaborator) {
                return {
                    operation: 'delete',
                    email: collaborator.email
                };
            }));

            return this.apiService.patch('/users/me/team-members', operations).then(function (result) {
                return result.data;
            });
        }
    }]);

    return CollaboratorService;
}();

/* harmony default export */ __webpack_exports__["a"] = (CollaboratorService);

/***/ }),

/***/ "RH3r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_cmpt__ = __webpack_require__("rw/q");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.settings.scene.data', []).component(__WEBPACK_IMPORTED_MODULE_1__data_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__data_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.data', {
        url: '/data?action',
        component: __WEBPACK_IMPORTED_MODULE_1__data_cmpt__["a" /* default */].selector
    });
}

/***/ }),

/***/ "RIi+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = FormSubmitDirective;
FormSubmitDirective.$inject = ['$q'];
var selector = 'dbAFormSubmit';

/* @ngInject */
function FormSubmitDirective($q) {
    return {
        require: '^form',
        restrict: 'A',

        link: function link(scope, element, attrs, ctrl) {
            var watcher = null;
            ctrl.$submitting = false;

            scope.$watch(serialize, changeHandler);

            element.on('submit', submitHandler);
            scope.$on('$destroy', function () {
                return element.off('submit', submitHandler);
            });

            function submitHandler() {
                if (ctrl.$valid) {
                    updateState(true);

                    $q.when(scope.callback()).finally(function () {
                        return updateState(false);
                    });
                } else {
                    validate();
                }
            }

            function validate() {
                scope.$applyAsync(makeControlsDirty);

                if (watcher) {
                    watcher();
                }

                watcher = scope.$watch(serialize, function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        watcher();
                        ctrl.$setPristine();
                        ctrl.$setUntouched();
                        makeControlsDirty();
                    }
                });
            }

            function makeControlsDirty() {
                ctrl.$$controls.forEach(function (control) {
                    return control.$setDirty();
                });
            }

            function updateState(submitting) {
                scope.$applyAsync(function () {
                    return ctrl.$submitting = submitting;
                });
            }

            function serialize() {
                return JSON.stringify(ctrl.$$controls.map(function (control) {
                    return control.$viewValue;
                }));
            }

            function changeHandler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    scope.onChange();
                }
            }
        },


        scope: {
            callback: '&' + selector,
            onChange: '&'
        }
    };
}

/***/ }),

/***/ "RKPS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__ = __webpack_require__("KgVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_period_style_sass__ = __webpack_require__("3yzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_period_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_period_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_period_tpl_pug__ = __webpack_require__("52Yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_period_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__calendar_period_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CalendarPeriodController = function () {
    function CalendarPeriodController() {
        _classCallCheck(this, CalendarPeriodController);
    }

    _createClass(CalendarPeriodController, [{
        key: '$onInit',
        value: function $onInit() {
            this.selectedIndex = this.selectedIndex || 0;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            var _this = this;

            if (changeObject.timestamp || changeObject.months) {
                this.selectedIndex = Math.max(__WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(this.months || [], function (month) {
                    return month.timestamp === _this.timestamp;
                }), 0);
                this.selectedPosition = Number.prototype.toFixed.call(this.selectedIndex * 100 / 12, 2) + '%';
            }
        }
    }, {
        key: 'select',
        value: function select(month) {
            if (this.timestamp !== month.timestamp) {
                return this.onSelect({
                    timestamp: month.timestamp
                });
            }
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            return this.onDismiss();
        }
    }]);

    return CalendarPeriodController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarPeriod',
    template: __WEBPACK_IMPORTED_MODULE_2__calendar_period_tpl_pug___default()(),
    controller: CalendarPeriodController,
    bindings: {
        loading: '<',
        timestamp: '<',
        months: '<',
        onSelect: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "RQHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
stateConfiguration.$inject = ['$stateProvider', '$transitionsProvider'];


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.email-verification.redirect', []).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('identity.email-verification.redirect', {
        url: '?token'
    });

    $transitionsProvider.onStart({
        to: 'identity.email-verification.redirect'
    }, function (transition) {
        var $state = transition.injector().get('$state');
        var emailVerificationService = transition.injector().get('emailVerificationService');
        var navigationService = transition.injector().get('navigationService');
        var notificationService = transition.injector().get('notificationService');

        var params = transition.params() || {};

        if (params.token) {
            return emailVerificationService.verify(params.token).then(function () {
                showNotification('Congratulations!', 'Your email address has been verified.');
                return redirect();
            }, function () {
                showNotification('Verification Failed', 'We were unable to verify your email address. The link might be expired.');
                return redirect();
            });
        }

        return redirect();

        function showNotification(title, message) {
            navigationService.onSuccess(function () {
                notificationService.showError(message, title, true, 0);
            }, true);
        }

        function redirect() {
            return $state.target('identity.sign-in');
        }
    });
}

/***/ }),

/***/ "RS2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_chart_cmpt__ = __webpack_require__("VYl1");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.dashboard.component.category-chart', []).component(__WEBPACK_IMPORTED_MODULE_1__category_chart_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__category_chart_cmpt__["a" /* default */]));

/***/ }),

/***/ "RT6d":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"account-settings-page\"\u003E\u003Cdiv class=\"form-group\" ng-show=\"$ctrl.expirationDate\"\u003E\u003Cdiv class=\"form-group-name\"\u003EActivate account\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cform role=\"form\" name=\"expire\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.sendVerificationEmail()\"\u003E\u003Cspan\u003EYour account \u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.expired\"\u003Ehas expired\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!$ctrl.expired\"\u003E\u003Cspan\u003Ewill expire in \u003C\u002Fspan\u003E\u003Cdb-a-time class=\"account-expiration\" timestamp=\"$ctrl.expirationDate\" max-unit=\"day\"\u003E\u003C\u002Fdb-a-time\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E. To activate it, please check your inbox and click on the activation link.\u003C\u002Fspan\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cbutton class=\"button button-fill button-primary button-send-confirmation-email\" type=\"submit\" db-a-async loading=\"expire.$submitting\" ng-disabled=\"$ctrl.confirmationEmailSent\"\u003E\u003Cinitial ng-hide=\"$ctrl.confirmationEmailSent\"\u003EResend activation email\u003C\u002Finitial\u003E\u003Cinitial ng-show=\"$ctrl.confirmationEmailSent\"\u003EActivation email sent\u003C\u002Finitial\u003E\u003Cloading\u003ESending...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EAccount info\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cform role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.save($ctrl.name, $ctrl.email, form)\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"text\" id=\"name-control\" name=\"name\" placeholder=\"name\" ng-model=\"$ctrl.name\" required\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"name-control\"\u003EName\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"name-control\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your name.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"email\" id=\"email-control\" name=\"email\" placeholder=\"email\" ng-model=\"$ctrl.email\" required\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"email-control\"\u003EEmail\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"email-control\"\u003E\u003Cdb-a-validation-message key=\"email\"\u003EPlease provide a valid email address.\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your email address.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cbutton class=\"button button-fill button-update-settings\" type=\"submit\" db-a-async loading=\"form.$submitting\" ng-class=\"{ 'button-danger': $ctrl.isEmailChanged, 'button-primary': !$ctrl.isEmailChanged }\" ng-disabled=\"!form.$dirty || !form.$valid\"\u003E\u003Cinitial\u003EUpdate\u003C\u002Finitial\u003E\u003Cloading\u003EUpdating...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EChange password\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cform role=\"form\" name=\"passwordForm\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.updatePassword($ctrl.currentPassword, $ctrl.newPassword, passwordForm)\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"password\" id=\"current-password-control\" name=\"current-password\" ng-model=\"$ctrl.currentPassword\" required\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"current-password-control\"\u003ECurrent password\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"current-password-control\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your current password.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"password\" id=\"new-password-control\" name=\"new-password\" ng-model=\"$ctrl.newPassword\" required\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"new-password-control\"\u003ENew password\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"new-password-control\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your new password.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cbutton class=\"button button-fill button-primary button-change-password\" type=\"submit\" db-a-async loading=\"passwordForm.$submitting\" ng-disabled=\"!passwordForm.$dirty\"\u003E\u003Cinitial\u003EChange\u003C\u002Finitial\u003E\u003Cloading\u003EUpdating...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\" ng-show=\"$ctrl.plan.free\"\u003E\u003Cdiv class=\"form-group-name\"\u003EUpgrade account\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv class=\"plan-note\"\u003EUpgrade your individiual plan to have more calendars or see our collaborative plan for small teams or families.\u003C\u002Fdiv\u003E\u003Ca class=\"button button-fill button-primary button-pricing-get-started\" ui-sref=\"authorized.subscribe\"\u003EGo premium\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EDelete account\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Ca class=\"button button-fill button-danger button-delete-account\" ng-click=\"$ctrl.deleteAccount()\"\u003EDelete account and all my data\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "RTFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_legacy_sortablejs_maintained__ = __webpack_require__("SGnE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_legacy_sortablejs_maintained___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_legacy_sortablejs_maintained__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__team_list_cmpt__ = __webpack_require__("CYse");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-navigation.component.team-list', ['ng-sortable']).component(__WEBPACK_IMPORTED_MODULE_2__team_list_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__team_list_cmpt__["a" /* default */]));

/***/ }),

/***/ "RTjd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryTransfer-b37679c5db5ee344.svg";

/***/ }),

/***/ "RVHk":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "RhrS":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdb-a-notification image-url=\"$ctrl.imageUrl\"\u003E\u003Cnotification-title ng-bind=\"$ctrl.title\" ng-if=\"$ctrl.title\"\u003E\u003C\u002Fnotification-title\u003E\u003Cnotification-content ng-bind=\"$ctrl.message\"\u003E\u003C\u002Fnotification-content\u003E\u003C\u002Fdb-a-notification\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "RrLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_palette_cmpt__ = __webpack_require__("bdb6");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.category-edit-modal.component.icon-palette', []).component(__WEBPACK_IMPORTED_MODULE_1__icon_palette_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__icon_palette_cmpt__["a" /* default */]));

/***/ }),

/***/ "Rx8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
stateConfiguration.$inject = ['$stateProvider', '$transitionsProvider'];


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.change-email', []).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('identity.change-email', {
        url: '/change-email?token'
    });

    $transitionsProvider.onStart({
        to: 'identity.change-email'
    }, function (transition) {
        var $state = transition.injector().get('$state');
        var profileService = transition.injector().get('profileService');
        var sessionService = transition.injector().get('sessionService');
        var navigationService = transition.injector().get('navigationService');
        var notificationService = transition.injector().get('notificationService');

        var _ref = transition.params() || {},
            token = _ref.token;

        if (token) {
            return profileService.changeEmailWithToken(token).then(function () {
                showNotification('Congratulations!', 'Your email address has been updated. For security reasons we invalidated your existing session. Please sign in again.', false);
                return sessionService.reload().then(redirect).catch(redirect);
            }, function () {
                showNotification('Update Failed', 'We were unable to update your email address. The link might be expired.', true);
                return redirect();
            });
        }

        return redirect();

        function showNotification(title, message, hide) {
            navigationService.onSuccess(function () {
                notificationService.showError(message, title, hide, 0);
            }, true);
        }

        function redirect() {
            return $state.target('identity.sign-in');
        }
    });
}

/***/ }),

/***/ "S+Kx":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category-manage-modal modal-fixed-height\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\"\u003EManage categories\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter\"\u003E\u003Cdb-a-search class=\"category-search modal-section\" data-id=\"category-search\" data-placeholder=\"$ctrl.searchPlaceholder\" can-capture=\"true\" on-focus-change=\"$ctrl.toggleSearch(focused)\" on-term-change=\"$ctrl.search(terms)\" on-submit=\"$ctrl.searchBySubmit(terms)\" ng-show=\"$ctrl.categories.length &gt; 0\"\u003E\u003C\u002Fdb-a-search\u003E\u003Cdiv class=\"categories-container\" ng-hide=\"$ctrl.loading\"\u003E\u003Cdiv class=\"categories\" ng-show=\"$ctrl.categories.length &gt; 0\" ng-sortable=\"$ctrl.sortableOptions\"\u003E\u003Cdiv class=\"category-select-item modal-section\" ng-repeat=\"category in $ctrl.filteredCategories track by category.id\" ng-click=\"$ctrl.select(category)\"\u003E\u003Cdb-a-category class=\"category-item\" name=\"category.name\" color=\"category.color\" icon-name=\"category.iconName\" icon-index=\"category.iconIndex\" use-icons=\"$ctrl.useCategoryIcons\" fallback-icon-name=\"null\"\u003E\u003C\u002Fdb-a-category\u003E\u003Ci class=\"drag-handle icon-dollarbird-grip\" ng-if=\"$ctrl.categories.length &gt; 1\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"categories-message modal-section\" ng-if=\"$ctrl.filteredCategories.length &lt; 1\"\u003E\u003Cspan\u003ENone of the \u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.categories.length\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E categories matched your search criteria.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"categories-message modal-section\" ng-show=\"$ctrl.categories.length &lt; 1\"\u003EIt looks like you have no categories created yet. You can add one by clicking the button below.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-modal-left button-add-category\" ng-click=\"$ctrl.create()\"\u003EAdd new category\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "S19y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_legacy_sortablejs_maintained__ = __webpack_require__("SGnE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_legacy_sortablejs_maintained___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_legacy_sortablejs_maintained__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_list_cmpt__ = __webpack_require__("+wd5");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-navigation.component.calendar-list', ['ng-sortable']).component(__WEBPACK_IMPORTED_MODULE_2__calendar_list_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__calendar_list_cmpt__["a" /* default */]));

/***/ }),

/***/ "S2sh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = every;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNow;
/* harmony export (immutable) */ __webpack_exports__["d"] = getToday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idle_js__ = __webpack_require__("v9a+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idle_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idle_js__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var TimeUtil = function () {
    TimeUtil.$inject = ['$timeout', 'numberUtil'];

    /* @ngInject */
    function TimeUtil($timeout, numberUtil) {
        _classCallCheck(this, TimeUtil);

        this.$timeout = $timeout;
        this.numberUtil = numberUtil;

        this.units = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second'];
    }

    _createClass(TimeUtil, [{
        key: 'now',
        value: function now() {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()().valueOf();
        }
    }, {
        key: 'toTransactionDate',
        value: function toTransactionDate(timestamp) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).format('YYYY-MM-DD');
        }
    }, {
        key: 'isWeekend',
        value: function isWeekend(timestamp) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).isoWeekday() > 5;
        }
    }, {
        key: 'getWeekdays',
        value: function getWeekdays(startOfWeek) {
            var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('isoWeek').add(fixStartOfWeek(startOfWeek) - 1, 'day');

            var days = [];
            for (var index = 0; index < 7; ++index) {
                var timestamp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start).add(index, 'day').valueOf();

                days.push({
                    timestamp: timestamp,
                    weekend: this.isWeekend(timestamp)
                });
            }

            return days;
        }
    }, {
        key: 'getDaysForMonth',
        value: function getDaysForMonth(date, startOfWeek, count) {
            var daysFromPreviousMonth = this.getDaysCountFromPreviousMonth(date, startOfWeek);

            date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).startOf('month');
            var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).subtract(daysFromPreviousMonth, 'day');
            var daysInCurrentMonth = date.daysInMonth();

            count = this.numberUtil.isInteger(count) ? count : 7 * Math.ceil((daysFromPreviousMonth + daysInCurrentMonth) / 7);

            var today = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.now()).startOf('day').valueOf();

            var days = [];

            for (var index = 0; index < count; ++index) {
                date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start).add(index, 'day').startOf('day');
                var timestamp = date.valueOf();

                days.push({
                    timestamp: timestamp,
                    previous: index < daysFromPreviousMonth,
                    next: index >= daysInCurrentMonth + daysFromPreviousMonth,
                    today: today === __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).startOf('day').valueOf(),
                    weekend: this.isWeekend(timestamp)
                });
            }

            return days;
        }
    }, {
        key: 'getDaysCountFromPreviousMonth',
        value: function getDaysCountFromPreviousMonth(date, startOfWeek) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).startOf('month').isoWeekday() - fixStartOfWeek(startOfWeek) % 7;
        }
    }]);

    return TimeUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (TimeUtil);


function fixStartOfWeek(startOfWeek) {
    return startOfWeek === 0 || startOfWeek === 1 ? startOfWeek : 0;
}

var isIdle = false;
var callbacks = {};

var idler = new __WEBPACK_IMPORTED_MODULE_2_idle_js___default.a({
    idle: 1000 * 30,
    onIdle: idleCallback,
    onActive: activeCallback,
    onHide: idleCallback,
    onShow: activeCallback
});
idler.start();

function every(unit, callback) {
    var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()().valueOf();
    var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(getNextTimestampByUnit(now, unit));

    var id = setTimeout(function () {
        if (isIdle) {
            return onActive(id, next);
        }

        return next();
    }, __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).diff(now));

    var clear = function clear() {
        removeJob(id);
        clearTimeout(id);
    };
    var next = function next() {
        clear = every(unit, callback);
        callback();
    };

    return function () {
        return clear();
    };
}

function getNextTimestampByUnit(start, unit) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(start).add(1, unit).startOf(unit).valueOf();
}

function idleCallback() {
    isIdle = true;
}

function activeCallback() {
    isIdle = false;

    __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(callbacks, function (callback) {
        return callback();
    });

    callbacks = {};
}

function onActive(id, callback) {
    callbacks[id] = callback;
}

function removeJob(id) {
    delete callbacks[id];
}

function getNow() {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()().valueOf();
}

function getToday() {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(getNow()).startOf('day').valueOf();
}

/***/ }),

/***/ "S46d":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"sign-up-page\"\u003E\u003Cdiv class=\"form-validation\" ng-bind=\"$ctrl.error\" ng-show=\"$ctrl.error\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-box\"\u003E\u003Cdiv class=\"identity-title\"\u003ESign up\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-form\"\u003E\u003Cform role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.signUp($ctrl.name, $ctrl.email, $ctrl.password)\"\u003E\u003Cdiv class=\"control-group\"\u003E\u003Clabel class=\"control-icon\" for=\"name-control\"\u003E\u003Ci class=\"icon-dollarbird-name\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"text\" id=\"name-control\" name=\"name\" placeholder=\"name\" ng-model=\"$ctrl.name\" required\u003E\u003Clabel class=\"control-label\" for=\"name-control\"\u003EName\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"name-control\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your name.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"control-group\"\u003E\u003Clabel class=\"control-icon\" for=\"email-control\"\u003E\u003Ci class=\"icon-dollarbird-email\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"email\" id=\"email-control\" name=\"email\" placeholder=\"email\" ng-model=\"$ctrl.email\" required\u003E\u003Clabel class=\"control-label\" for=\"email-control\"\u003EEmail\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"email-control\"\u003E\u003Cdb-a-validation-message key=\"email\"\u003EPlease provide a valid email address.\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your email address.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"control-group\"\u003E\u003Clabel class=\"control-icon\" for=\"password-control\"\u003E\u003Ci class=\"icon-dollarbird-password\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"password\" id=\"password-control\" name=\"password\" placeholder=\"password\" ng-model=\"$ctrl.password\" ng-minlength=\"6\" required\u003E\u003Clabel class=\"control-label\" for=\"password-control\"\u003EPassword\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"password-control\"\u003E\u003Cdb-a-validation-message key=\"required,minlength\"\u003EShould be at least 6 characters long.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cbutton class=\"button button-block button-fill button-primary button-sign-up\" type=\"submit\" db-a-async loading=\"form.$submitting\"\u003E\u003Cinitial\u003ESign up\u003C\u002Finitial\u003E\u003Cloading\u003ESigning up...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-comment\"\u003E\u003Cspan\u003EAlready have an account? \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"identity.sign-in\"\u003ELog in\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-note\"\u003E\u003Cspan\u003EBy signing up you agree with our \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"terms-of-service\"\u003ETerms of Service\u003C\u002Fa\u003E\u003Cspan\u003E and \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"privacy-policy\"\u003EPrivacy Policy\u003C\u002Fa\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "S4DG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_navigation_style_sass__ = __webpack_require__("LBBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_navigation_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__calendar_navigation_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar_navigation_tpl_pug__ = __webpack_require__("w7kL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar_navigation_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__calendar_navigation_tpl_pug__);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var CalendarNavigationController = function () {
    CalendarNavigationController.$inject = ['$q'];

    /* @ngInject */
    function CalendarNavigationController($q) {
        _classCallCheck(this, CalendarNavigationController);

        this.$q = $q;
    }

    _createClass(CalendarNavigationController, [{
        key: 'canSelectCalendars',
        value: function canSelectCalendars() {
            return this.teams && this.teams.length > 0;
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.isSelectingCalendar = this.canSelectCalendars();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.teams) {
                this.isSelectingCalendar = !this.previousTeams || !this.teams || this.previousTeams.length !== this.teams.length ? this.canSelectCalendars() : this.isSelectingCalendar;

                this.previousTeams = this.teams;
            }

            if (changeObject.user) {
                this.user = this.user || {};
                this.user = changeObject.user.currentValue || this.user;
            }

            if (changeObject.selectedTeam) {
                this.balance = this.getTeamBalance(this.selectedTeam);
                this.sharedWithLabel = this.getSharedWithLabel(this.selectedTeam);
            }

            if (changeObject.plan) {
                this.planBadgeStyle = this.getPlanBadgeStyle(this.plan);
            }
        }
    }, {
        key: 'getTeamBalance',
        value: function getTeamBalance(team) {
            return team && team.calendars && team.calendars.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()(team.calendars, function (balance, calendar) {
                return balance + calendar.balance;
            }, 0) : 0;
        }
    }, {
        key: 'getSharedWithLabel',
        value: function getSharedWithLabel(team) {
            var members = this.getTeamMembers(team);
            var filteredMembers = this.removeCurrentUserFromMembers(members);

            if (!filteredMembers || filteredMembers.length === 0) {
                return null;
            }

            var displayNames = filteredMembers.map(function (member) {
                return member && (member.name || member.email);
            }).filter(function (name) {
                return !!name;
            });

            var firstTwo = displayNames.slice(0, 2);

            if (filteredMembers.length === 1) {
                return 'Shared with: ' + firstTwo[0];
            }

            if (filteredMembers.length === 2) {
                return 'Shared with: ' + firstTwo.join(', ');
            }

            var remaining = Math.max(filteredMembers.length - 2, 0);
            return 'Shared with: ' + firstTwo.join(', ') + ' and ' + remaining + ' more';
        }
    }, {
        key: 'getTeamMembers',
        value: function getTeamMembers(team) {
            if (!team) {
                return [];
            }

            if (Array.isArray(team.members)) {
                return team.members;
            }

            if (Array.isArray(team.collaborators)) {
                return team.collaborators;
            }

            return [];
        }
    }, {
        key: 'getPlanBadgeStyle',
        value: function getPlanBadgeStyle(plan) {
            var color = plan && plan.color ? plan.color : null;
            if (!color) {
                return null;
            }

            var textColor = this.getReadableTextColor(color);
            return {
                backgroundColor: color,
                color: textColor
            };
        }
    }, {
        key: 'getReadableTextColor',
        value: function getReadableTextColor(backgroundColor) {
            var rgb = this.parseColorToRgb(backgroundColor);
            if (!rgb) {
                return '#fff';
            }

            var _rgb$map = rgb.map(function (value) {
                var channel = value / 255;
                return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
            }),
                _rgb$map2 = _slicedToArray(_rgb$map, 3),
                r = _rgb$map2[0],
                g = _rgb$map2[1],
                b = _rgb$map2[2];

            var luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
            return luminance > 0.5 ? '#394852' : '#fff';
        }
    }, {
        key: 'parseColorToRgb',
        value: function parseColorToRgb(color) {
            if (!color || typeof color !== 'string') {
                return null;
            }

            var value = color.trim();
            if (value[0] === '#') {
                value = value.slice(1);
            }

            if (value.length === 3) {
                var red = parseInt(value[0] + value[0], 16);
                var green = parseInt(value[1] + value[1], 16);
                var blue = parseInt(value[2] + value[2], 16);
                return [red, green, blue];
            }

            if (value.length === 6) {
                var _red = parseInt(value.slice(0, 2), 16);
                var _green = parseInt(value.slice(2, 4), 16);
                var _blue = parseInt(value.slice(4, 6), 16);
                return [_red, _green, _blue];
            }

            return null;
        }
    }, {
        key: 'removeCurrentUserFromMembers',
        value: function removeCurrentUserFromMembers(members) {
            if (!members || members.length === 0) {
                return [];
            }

            var user = this.user;
            if (!user) {
                return members;
            }

            return members.filter(function (member) {
                if (!member) {
                    return false;
                }

                if (user.id && member.id) {
                    return member.id !== user.id;
                }

                if (user.email && member.email) {
                    return member.email !== user.email;
                }

                return true;
            });
        }
    }, {
        key: 'subscribe',
        value: function subscribe(renew) {
            if (renew) {
                return __WEBPACK_IMPORTED_MODULE_1_common_analytics__["c" /* default */].trackPlanRenewFromSidebar();
            }

            return __WEBPACK_IMPORTED_MODULE_1_common_analytics__["c" /* default */].trackPlanSubscribeFromSidebar();
        }
    }, {
        key: 'toggleView',
        value: function toggleView() {
            if (this.canSelectCalendars()) {
                this.isSelectingCalendar = !this.isSelectingCalendar;
            }
        }
    }, {
        key: 'editCalendar',
        value: function editCalendar(team, calendar) {
            return this.onCalendarEdit({
                team: team,
                calendar: calendar
            });
        }
    }, {
        key: 'deleteCalendar',
        value: function deleteCalendar(team, calendar) {
            return this.onCalendarDelete({
                team: team,
                calendar: calendar
            });
        }
    }, {
        key: 'addCalendar',
        value: function addCalendar(team) {
            return this.onCalendarAdd({
                team: team
            });
        }
    }, {
        key: 'selectCalendar',
        value: function selectCalendar(team, calendar) {
            return this.onCalendarSelect({
                team: team,
                calendar: calendar
            });
        }
    }, {
        key: 'reorderCalendars',
        value: function reorderCalendars(team, order) {
            return this.onCalendarReorder({
                team: team,
                order: order
            });
        }
    }, {
        key: 'selectTeam',
        value: function selectTeam(team) {
            var _this = this;

            return this.$q.when(this.onTeamSelect({
                team: team
            })).finally(function () {
                return _this.isSelectingCalendar = true;
            });
        }
    }, {
        key: 'editTeam',
        value: function editTeam(team) {
            return this.onTeamEdit({
                team: team
            });
        }
    }, {
        key: 'addTeam',
        value: function addTeam() {
            return this.onTeamAdd();
        }
    }, {
        key: 'toggleMultiple',
        value: function toggleMultiple(multiple) {
            return this.onMultipleChange({
                multiple: multiple
            });
        }
    }, {
        key: 'reorderTeams',
        value: function reorderTeams(order) {
            return this.onTeamReorder({
                order: order
            });
        }
    }]);

    return CalendarNavigationController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarNavigation',
    template: __WEBPACK_IMPORTED_MODULE_3__calendar_navigation_tpl_pug___default()(),
    controller: CalendarNavigationController,
    bindings: {
        loading: '<',
        plan: '<',
        user: '<',
        selectedCalendarIds: '<',
        selectedTeam: '<',
        teams: '<',
        multiple: '<',
        canSelectMultiple: '<',
        balanceWarningThreshold: '<',
        onCalendarEdit: '&',
        onCalendarAdd: '&',
        onCalendarDelete: '&',
        onCalendarSelect: '&',
        onCalendarReorder: '&',
        onTeamSelect: '&',
        onTeamEdit: '&',
        onTeamAdd: '&',
        onTeamReorder: '&',
        onMultipleChange: '&',
        onSettingsOpen: '&'
    }
});

/***/ }),

/***/ "S7yp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__about_cmpt__ = __webpack_require__("W3eN");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.settings.scene.about', []).component(__WEBPACK_IMPORTED_MODULE_1__about_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__about_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.about', {
        url: '/about',
        component: __WEBPACK_IMPORTED_MODULE_1__about_cmpt__["a" /* default */].selector
    });
}

/***/ }),

/***/ "SAAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text_notification_tpl_pug__ = __webpack_require__("RhrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text_notification_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__text_notification_tpl_pug__);


/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbATextNotification',
    template: __WEBPACK_IMPORTED_MODULE_0__text_notification_tpl_pug___default()(),
    bindings: {
        title: '<',
        message: '<',
        imageUrl: '<'
    }
});

/***/ }),

/***/ "SFEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_notification_tpl_pug__ = __webpack_require__("BYmK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_notification_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__error_notification_tpl_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_error_icon_svg__ = __webpack_require__("pDM8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_error_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__image_error_icon_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ErrorNotificationController = function () {
    function ErrorNotificationController() {
        _classCallCheck(this, ErrorNotificationController);
    }

    _createClass(ErrorNotificationController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.imageUrl) {
                this.imageUrl = changeObject.imageUrl.currentValue || __WEBPACK_IMPORTED_MODULE_1__image_error_icon_svg___default.a;
            }
        }
    }]);

    return ErrorNotificationController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAErrorNotification',
    template: __WEBPACK_IMPORTED_MODULE_0__error_notification_tpl_pug___default()(),
    controller: ErrorNotificationController,
    bindings: {
        title: '<',
        message: '<',
        imageUrl: '<'
    }
});

/***/ }),

/***/ "SGnE":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
/**
 * @author RubaXa <trash@rubaxa.org>
 * @licence MIT
 */
(function (factory) {
	'use strict';

	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/jXN"), __webpack_require__("/dO2")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof require === 'function' && typeof exports === 'object' && typeof module === 'object') {
		require('angular');
		factory(angular, require('sortablejs'));
		module.exports = 'ng-sortable';
	}
	else if (window.angular && window.Sortable) {
		factory(angular, Sortable);
	}
})(function (angular, Sortable) {
	'use strict';

	// Use default import if available
	Sortable = Sortable.default || Sortable;

	/**
	 * @typedef   {Object}        ngSortEvent
	 * @property  {*}             model      List item
	 * @property  {Object|Array}  models     List of items
	 * @property  {number}        oldIndex   before sort
	 * @property  {number}        newIndex   after sort
	 */

	var expando = 'Sortable:ng-sortable';

	angular.module('ng-sortable', [])
		.constant('ngSortableVersion', '0.4.1')
		.constant('ngSortableConfig', {})
		.directive('ngSortable', ['$parse', 'ngSortableConfig', function ($parse, ngSortableConfig) {
			var removed,
				nextSibling;

			function getNgRepeatExpression(node) {
				return node.getAttribute('ng-repeat') || node.getAttribute('data-ng-repeat') || node.getAttribute('x-ng-repeat') || node.getAttribute('dir-paginate');
			}

			// Export
			return {
				restrict: 'AC',
				scope: { ngSortable: "=?" },
				priority: 1001,
				compile: function ($element, $attr) {

					var ngRepeat = [].filter.call($element[0].childNodes, function (node) {
						return node.nodeType === Node.ELEMENT_NODE && getNgRepeatExpression(node);
					})[0];

					if (!ngRepeat) {
						return;
					}

					var match = getNgRepeatExpression(ngRepeat)
						.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

					if (!match) {
						return;
					}

					var rhs = match[2];

					return function postLink(scope, $el) {
						var itemsExpr = $parse(rhs);
						var getSource = function getSource() {
							return itemsExpr(scope.$parent) || [];
						};


						var el = $el[0],
							options = angular.extend(scope.ngSortable || {}, ngSortableConfig),
							watchers = [],
							offDestroy,
							sortable
						;

						el[expando] = getSource;

						function _emitEvent(/**Event*/evt, /*Mixed*/item) {
							var name = 'on' + evt.type.charAt(0).toUpperCase() + evt.type.substr(1);
							var source = getSource();

							/* jshint expr:true */
							options[name] && options[name]({
								model: item || source[evt.newIndex],
								models: source,
								oldIndex: evt.oldIndex,
								newIndex: evt.newIndex,
								originalEvent: evt
							});
						}


						function _sync(/**Event*/evt) {
							var items = getSource();

							if (!items) {
								// Without ng-repeat
								return;
							}

							var oldIndex = evt.oldIndex,
								newIndex = evt.newIndex;

							if (el !== evt.from) {
								var prevItems = evt.from[expando]();

								removed = prevItems[oldIndex];

								if (Sortable.active && Sortable.active.lastPullMode === 'clone') {
									removed = angular.copy(removed);
									prevItems.splice(Sortable.utils.index(evt.clone, sortable.options.draggable), 0, prevItems.splice(oldIndex, 1)[0]);

									if (evt.from.contains(evt.clone)) {
										evt.from.removeChild(evt.clone);
									}
								}
								else {
									prevItems.splice(oldIndex, 1);
								}

								items.splice(newIndex, 0, removed);

								evt.from.insertBefore(evt.item, nextSibling); // revert element
							}
							else {
								items.splice(newIndex, 0, items.splice(oldIndex, 1)[0]);

								// move ng-repeat comment node to right position
								if (nextSibling.nodeType === Node.COMMENT_NODE) {
									evt.from.insertBefore(nextSibling, evt.item.nextSibling);
								}
							}

							scope.$apply();
						}

						function _destroy() {
							offDestroy();

							angular.forEach(watchers, function (/** Function */unwatch) {
								unwatch();
							});

							sortable.destroy();

							el[expando] = null;
							el = null;
							watchers = null;
							sortable = null;
							nextSibling = null;
						}


						// Initialization
						sortable = Sortable.create(el, Object.keys(options).reduce(function (opts, name) {
							opts[name] = opts[name] || options[name];
							return opts;
						}, {
							onStart: function (/**Event*/evt) {
								nextSibling = evt.from === evt.item.parentNode ? evt.item.nextSibling : evt.clone.nextSibling;
								_emitEvent(evt);
								scope.$apply();
							},
							onEnd: function (/**Event*/evt) {
								_emitEvent(evt, removed);
								scope.$apply();
							},
							onAdd: function (/**Event*/evt) {
								_sync(evt);
								_emitEvent(evt, removed);
								scope.$apply();
							},
							onUpdate: function (/**Event*/evt) {
								_sync(evt);
								_emitEvent(evt);
							},
							onRemove: function (/**Event*/evt) {
								_emitEvent(evt, removed);
							},
							onSort: function (/**Event*/evt) {
								_emitEvent(evt);
							}
						}));

						// Create watchers for `options`
						angular.forEach([
							'sort', 'disabled', 'draggable', 'handle', 'animation', 'group', 'ghostClass', 'filter',
							'onStart', 'onEnd', 'onAdd', 'onUpdate', 'onRemove', 'onSort', 'onMove', 'onClone', 'setData',
							'delay', 'animation', 'forceFallback'
						], function (name) {
							watchers.push(scope.$watch('ngSortable.' + name, function (value) {
								if (value !== void 0) {
									options[name] = value;

									if (!/^on[A-Z]/.test(name)) {
										sortable.option(name, value);
									}
								}
							}));
						});

						offDestroy = scope.$on('$destroy', _destroy);

					}
				}
			};
		}]);
});


/***/ }),

/***/ "SGuk":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"date-range-picker\"\u003E\u003Cdb-a-date-picker class=\"date-range-item\" timestamp=\"$ctrl.start\" view-timestamp=\"$ctrl.startView\" start-of-week=\"$ctrl.startOfWeek\" prevent-navigation-to-next-month=\"$ctrl.viewDifference &lt; 2\" hide-days-from-other-month=\"true\" on-day-check-hidden=\"$ctrl.isAnotherMonth(timestamp, current)\" on-day-check-active=\"$ctrl.checkDayActive(timestamp)\" on-day-check-highlighted=\"$ctrl.isBetweenInterval(timestamp)\" on-day-select=\"$ctrl.update(timestamp)\" on-view-change=\"$ctrl.startViewChanged(timestamp)\"\u003E\u003C\u002Fdb-a-date-picker\u003E\u003Cdb-a-date-picker class=\"date-range-item\" timestamp=\"$ctrl.end\" view-timestamp=\"$ctrl.endView\" start-of-week=\"$ctrl.startOfWeek\" prevent-navigation-to-previous-month=\"$ctrl.viewDifference &lt; 2\" hide-days-from-other-month=\"true\" on-day-check-hidden=\"$ctrl.isAnotherMonth(timestamp, current)\" on-day-check-active=\"$ctrl.checkDayActive(timestamp)\" on-day-check-highlighted=\"$ctrl.isBetweenInterval(timestamp)\" on-day-select=\"$ctrl.update(timestamp)\" on-view-change=\"$ctrl.endViewChanged(timestamp)\"\u003E\u003C\u002Fdb-a-date-picker\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "SKa4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card":"card","card-heading":"card-heading","card-title":"card-title","card-content":"card-content"};

/***/ }),

/***/ "SQDF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-icon":"category-icon","empty":"empty"};

/***/ }),

/***/ "Si9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_application_util_category_util__ = __webpack_require__("XzH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__category_merge_modal_style_sass__ = __webpack_require__("dpaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__category_merge_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__category_merge_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category_merge_modal_tpl_pug__ = __webpack_require__("UNd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category_merge_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__category_merge_modal_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var CategoryMergeModalController = function () {
    CategoryMergeModalController.$inject = ['$q', 'categoryService', 'modalService', 'notificationService'];

    /* @ngInject */
    function CategoryMergeModalController($q, categoryService, modalService, notificationService) {
        _classCallCheck(this, CategoryMergeModalController);

        this.$q = $q;
        this.categoryService = categoryService;
        this.modalService = modalService;
        this.notificationService = notificationService;
    }

    _createClass(CategoryMergeModalController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.fallbackCategory = null;

            return this.categoryService.getAll(this.teamId).then(function (categories) {
                _this.categories = __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(categories || [], function (category) {
                    return Object(__WEBPACK_IMPORTED_MODULE_2_application_util_category_util__["c" /* isCategoryListable */])(category) && '' + category.id !== '' + _this.category.id;
                });
            }).catch(function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_1_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to load categories. Please try again later.'));
                _this.categories = [];
            });
        }
    }, {
        key: 'pickFallbackCategory',
        value: function pickFallbackCategory() {
            var _this2 = this;

            return this.modalService.open({
                component: 'dbACategorySelectModal',
                bindings: {
                    teamId: this.teamId,
                    selectedCategoryId: this.fallbackCategory && this.fallbackCategory.id,
                    canAdd: false
                }
            }).then(function (selectedCategory) {
                if (!selectedCategory || !selectedCategory.id) {
                    return _this2.$q.reject();
                }

                if ('' + selectedCategory.id === '' + _this2.category.id) {
                    _this2.notificationService.showError('Select a different fallback category.');
                    return _this2.$q.reject();
                }

                _this2.fallbackCategory = selectedCategory;
                return selectedCategory;
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'merge',
        value: function merge() {
            if (!this.fallbackCategory || !this.fallbackCategory.id) {
                return this.$q.reject();
            }

            return this.onClose({
                data: this.fallbackCategory
            });
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            this.onDismiss();
        }
    }]);

    return CategoryMergeModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategoryMergeModal',
    template: __WEBPACK_IMPORTED_MODULE_4__category_merge_modal_tpl_pug___default()(),
    controller: CategoryMergeModalController,
    bindings: {
        teamId: '<',
        category: '<',
        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "SkZH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SmC/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"event-edit-modal":"event-edit-modal","input-receipt-file":"input-receipt-file","modal-fixed-height":"modal-fixed-height","modal-header":"modal-header","entity-body":"entity-body","entity-types":"entity-types","button-select-type":"button-select-type","active":"active","entity-type-label":"entity-type-label","entity-core":"entity-core","entity-content":"entity-content","entity-body-container":"entity-body-container","entity-information":"entity-information","button-modal-back":"button-modal-back","entity-sign":"entity-sign","control":"control","control-label":"control-label","control-validation":"control-validation","control-input":"control-input","control-input-suggestion":"control-input-suggestion","control-input-label":"control-input-label","modal-delimiter":"modal-delimiter","confirmed":"confirmed","button-toggle-sign":"button-toggle-sign","entity-property":"entity-property","category-name":"category-name","has-back":"has-back","ng-dirty":"ng-dirty","ng-invalid":"ng-invalid","entity-details":"entity-details","entity-value":"entity-value","entity-label":"entity-label","label-current":"label-current","label-suggestion":"label-suggestion","entity-category-loader":"entity-category-loader","entity-transfer-container":"entity-transfer-container","transfer-calendar-switcher":"transfer-calendar-switcher","transfer-calendar-cell":"transfer-calendar-cell","transfer-calendar-icon-cell":"transfer-calendar-icon-cell","button-switch-calendar":"button-switch-calendar","transfer-calendar-heading":"transfer-calendar-heading","transfer-calendar-name":"transfer-calendar-name","disabled":"disabled","entity-properties":"entity-properties","entity-property-icon":"entity-property-icon","entity-property-content":"entity-property-content","icon":"icon","entity-property-secondary-text":"entity-property-secondary-text","entity-property-primary-text":"entity-property-primary-text","entity-property-placeholder-text":"entity-property-placeholder-text","entity-property-confirm":"entity-property-confirm","entity-property-details":"entity-property-details","entity-property-reports":"entity-property-reports","switch":"switch","entity-property-receipt":"entity-property-receipt","with-thumbnail":"with-thumbnail","entity-property-actions":"entity-property-actions","button-remove-receipt":"button-remove-receipt","entity-property-receipt-icon":"entity-property-receipt-icon","entity-property-receipt-thumbnail":"entity-property-receipt-thumbnail","entity-property-receipt-image":"entity-property-receipt-image"};

/***/ }),

/***/ "Sww0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_interface_style_sass__ = __webpack_require__("f+QK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_interface_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__user_interface_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_interface_tpl_pug__ = __webpack_require__("TYlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_interface_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__user_interface_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var UserInterfaceSettingsController = function () {
    UserInterfaceSettingsController.$inject = ['$rootScope', 'preferenceService', 'notificationService', 'themeService', 'storageService'];

    _createClass(UserInterfaceSettingsController, [{
        key: 'getBalanceWarningThresholdStorageValue',
        value: function getBalanceWarningThresholdStorageValue() {
            return this.storageService.getUserItem('balance-warning-threshold');
        }
    }, {
        key: 'getBalanceWarningThresholdEnabledStorageValue',
        value: function getBalanceWarningThresholdEnabledStorageValue() {
            return this.storageService.getUserItem('balance-warning-threshold-enabled');
        }
    }, {
        key: 'persistBalanceWarningThresholdSettings',
        value: function persistBalanceWarningThresholdSettings() {
            this.storageService.setUserItem('balance-warning-threshold-enabled', !!this.preferences.balanceWarningThresholdEnabled);
            this.storageService.setUserItem('balance-warning-threshold', this.preferences.balanceWarningThreshold);
        }
    }, {
        key: 'broadcastBalanceWarningThresholdUpdated',
        value: function broadcastBalanceWarningThresholdUpdated() {
            this.$rootScope.$broadcast('balanceWarningThresholdUpdated', {
                enabled: !!this.preferences.balanceWarningThresholdEnabled,
                threshold: this.preferences.balanceWarningThreshold
            });
        }

        /* @ngInject */

    }]);

    function UserInterfaceSettingsController($rootScope, preferenceService, notificationService, themeService, storageService) {
        _classCallCheck(this, UserInterfaceSettingsController);

        this.$rootScope = $rootScope;
        this.preferenceService = preferenceService;
        this.notificationService = notificationService;
        this.themeService = themeService;
        this.storageService = storageService;
    }

    _createClass(UserInterfaceSettingsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;
            this.preferences = {};

            return this.preferenceService.get().then(function (preferences) {
                var storedThreshold = _this.getBalanceWarningThresholdStorageValue();
                var storedEnabled = _this.getBalanceWarningThresholdEnabledStorageValue();
                _this.preferences = preferences || {};
                _this.preferences.calendarHighlightColor = _this.preferences.calendarHighlightColor || 'selected';
                _this.preferences.theme = _this.preferences.theme || _this.themeService.getStoredTheme() || 'system';
                _this.preferences.categoryIconStyle = _this.preferences.categoryIconStyle || _this.storageService.getUserItem('category-icon-style') || 'icons';
                var balanceWarningThreshold = _this.preferences.balanceWarningThreshold;

                if (storedThreshold == null) {
                    balanceWarningThreshold = _this.preferences.balanceWarningThreshold;
                } else {
                    balanceWarningThreshold = storedThreshold;
                }

                _this.preferences.balanceWarningThreshold = _this.normalizeBalanceWarningThreshold(balanceWarningThreshold);

                var balanceWarningThresholdEnabled = void 0;

                if (storedEnabled == null) {
                    if (_this.preferences.balanceWarningThresholdEnabled == null) {
                        balanceWarningThresholdEnabled = _this.preferences.balanceWarningThreshold > 0;
                    } else {
                        balanceWarningThresholdEnabled = _this.preferences.balanceWarningThresholdEnabled === true;
                    }
                } else {
                    balanceWarningThresholdEnabled = storedEnabled === true || storedEnabled === 'true';
                }

                _this.preferences.balanceWarningThresholdEnabled = balanceWarningThresholdEnabled;
            }, function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to retrieve your user interface settings.'));
            }).finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'selectCalendarHighlightColor',
        value: function selectCalendarHighlightColor(value) {
            if (!this.preferences) {
                return;
            }

            this.preferences.calendarHighlightColor = value;
            return this.updatePreferences();
        }
    }, {
        key: 'updatePreferences',
        value: function updatePreferences() {
            var _this2 = this;

            return this.preferenceService.save(this.preferences).catch(function (result) {
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to update your user interface settings.'));
            });
        }
    }, {
        key: 'selectTheme',
        value: function selectTheme(theme) {
            if (!this.preferences) {
                return;
            }

            this.preferences.theme = theme;
            this.themeService.applyTheme(theme);
            return this.updatePreferences();
        }
    }, {
        key: 'selectCategoryIconStyle',
        value: function selectCategoryIconStyle(style) {
            if (!this.preferences) {
                return;
            }

            this.preferences.categoryIconStyle = style;
            this.storageService.setUserItem('category-icon-style', style);
            this.$rootScope.$broadcast('categoryIconStyleUpdated', style);
            return this.updatePreferences();
        }
    }, {
        key: 'toggleBalanceWarningThreshold',
        value: function toggleBalanceWarningThreshold(enabled) {
            if (!this.preferences) {
                return;
            }

            this.preferences.balanceWarningThresholdEnabled = !!enabled;

            if (this.preferences.balanceWarningThresholdEnabled && this.preferences.balanceWarningThreshold == null) {
                this.preferences.balanceWarningThreshold = 0;
            }

            this.persistBalanceWarningThresholdSettings();
            this.broadcastBalanceWarningThresholdUpdated();
            return this.updatePreferences();
        }
    }, {
        key: 'updateBalanceWarningThreshold',
        value: function updateBalanceWarningThreshold() {
            if (!this.preferences) {
                return;
            }

            this.preferences.balanceWarningThreshold = this.normalizeBalanceWarningThreshold(this.preferences.balanceWarningThreshold);
            this.persistBalanceWarningThresholdSettings();
            this.broadcastBalanceWarningThresholdUpdated();
            return this.updatePreferences();
        }
    }, {
        key: 'normalizeBalanceWarningThreshold',
        value: function normalizeBalanceWarningThreshold(value) {
            if (value === '' || value == null) {
                return null;
            }

            var normalized = Number(value);
            if (!Number.isFinite(normalized)) {
                return null;
            }

            return normalized >= 0 ? normalized : 0;
        }
    }]);

    return UserInterfaceSettingsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAUserInterfaceSettings',
    template: __WEBPACK_IMPORTED_MODULE_2__user_interface_tpl_pug___default()(),
    controller: UserInterfaceSettingsController
});

/***/ }),

/***/ "SyVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = CompileComponentDirective;
CompileComponentDirective.$inject = ['$compile', 'stringUtil'];

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var selector = 'dbACompileComponent';

/* @ngInject */
function CompileComponentDirective($compile, stringUtil) {
    var _scope;

    return {
        restrict: 'A',
        scope: (_scope = {}, _defineProperty(_scope, selector, '<'), _defineProperty(_scope, 'bindings', '='), _scope),

        link: function link(scope, element) {
            compile(scope[selector], scope.bindings);

            function compile(component, bindings) {
                component = stringUtil.toSnakeCase(component || '');

                var link = $compile('<' + component + ' ' + createBindings(bindings) + '></' + component + '>');

                element.html('');
                element.append(link(scope));
            }

            function createBindings(bindings) {
                return Object.keys(bindings).map(function (key) {
                    return createBindingValue(key, key, bindings[key]);
                }).join(' ');
            }

            function createBindingValue(attribute, value, bindedValue) {
                if (typeof bindedValue === 'function') {
                    value = value + '(data)';
                }

                return bindAttributeOnModalInstance(stringUtil.toSnakeCase(attribute), value);
            }

            function bindAttributeOnModalInstance(attribute, value) {
                return 'data-' + attribute + '="bindings.' + value + '"';
            }
        }
    };
}

/***/ }),

/***/ "T1eG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_with_year_picker_cmpt__ = __webpack_require__("bY2B");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.dashboard.component.card-with-year-picker', []).component(__WEBPACK_IMPORTED_MODULE_1__card_with_year_picker_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__card_with_year_picker_cmpt__["a" /* default */]));

/***/ }),

/***/ "T3/K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-open":"modal-open","modals":"modals","visible":"visible","modal-backdrop":"modal-backdrop","modal-item-container":"modal-item-container","slide-up":"slide-up","modal-item":"modal-item","modal-header":"modal-header","modal-title":"modal-title","modal-fixed-height":"modal-fixed-height","modal-body":"modal-body","modal-footer":"modal-footer","modal-body-scrollable":"modal-body-scrollable","modal-delimiter":"modal-delimiter","modal-section":"modal-section","section-label":"section-label","button-back":"button-back","button-modal-done":"button-modal-done","button-modal-back":"button-modal-back","button-modal-left":"button-modal-left","button-link":"button-link","button-modal-right":"button-modal-right","event-edit-modal":"event-edit-modal","calendar-select-modal":"calendar-select-modal","calendar-edit-modal":"calendar-edit-modal","category-select-modal":"category-select-modal","category-edit-modal":"category-edit-modal","category-merge-modal":"category-merge-modal","category-manage-modal":"category-manage-modal","collaborator-manage-modal":"collaborator-manage-modal","collaborator-invite-modal":"collaborator-invite-modal","team-edit-modal":"team-edit-modal","event-details-modal":"event-details-modal","event-receipt-modal":"event-receipt-modal","event-date-modal":"event-date-modal","event-repeat-delete-modal":"event-repeat-delete-modal","event-list-modal":"event-list-modal","email-ingest-token-modal":"email-ingest-token-modal"};

/***/ }),

/***/ "T8fi":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"email-verification-confirm-page\"\u003E\u003Cdiv class=\"identity-box\"\u003E\u003Cdiv class=\"identity-form\"\u003E\u003Cdiv class=\"form-illustration\"\u003E\u003Cimg" + (" class=\"form-image\""+pug.attr("src", __webpack_require__("ybOs"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-title\"\u003EYou've got mail\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-note\"\u003EWe've sent you an email with a link to verify your email address.\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Ca class=\"button button-block button-fill button-primary button-sign-in\" href=\"javascript:void(0);\" ui-sref=\"identity.sign-in\"\u003EOK\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-comment\"\u003E\u003Cspan\u003EHaven't you receive the email? Try to \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"identity.email-verification.request\"\u003Erequest it again\u003C\u002Fa\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "TN7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_details_modal_style_sass__ = __webpack_require__("vGwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_details_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__event_details_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_details_modal_tpl_pug__ = __webpack_require__("NmuC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_details_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__event_details_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var EventDetailsController = function () {
    function EventDetailsController() {
        _classCallCheck(this, EventDetailsController);
    }

    _createClass(EventDetailsController, [{
        key: 'dismiss',
        value: function dismiss() {
            return this.onDismiss();
        }
    }, {
        key: 'close',
        value: function close() {
            return this.onClose({
                data: this.event
            });
        }
    }]);

    return EventDetailsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEventDetailsModal',
    template: __WEBPACK_IMPORTED_MODULE_1__event_details_modal_tpl_pug___default()(),
    controller: EventDetailsController,
    bindings: {
        event: '<',

        canEdit: '<',

        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "TUTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_ingest_token_modal_style_sass__ = __webpack_require__("1CE5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_ingest_token_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__email_ingest_token_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__email_ingest_token_modal_tpl_pug__ = __webpack_require__("ZRrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__email_ingest_token_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__email_ingest_token_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var INBOUND_EMAIL_DOMAIN = 'inbox.dollarbird.co';

var EmailIngestTokenModalController = function () {
    EmailIngestTokenModalController.$inject = ['$q', '$window', 'emailIngestTokenService', 'modalService', 'notificationService'];

    /* @ngInject */
    function EmailIngestTokenModalController($q, $window, emailIngestTokenService, modalService, notificationService) {
        _classCallCheck(this, EmailIngestTokenModalController);

        this.$q = $q;
        this.$window = $window;
        this.emailIngestTokenService = emailIngestTokenService;
        this.modalService = modalService;
        this.notificationService = notificationService;
    }

    _createClass(EmailIngestTokenModalController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;

            return this.reload().finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'reload',
        value: function reload() {
            var _this2 = this;

            return this.emailIngestTokenService.getActiveByTeamId(this.teamId).then(function (token) {
                _this2.token = token;
            }).catch(function (result) {
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to load the inbound email address. Please try again later.'));
                return _this2.$q.reject(result);
            });
        }
    }, {
        key: 'enable',
        value: function enable() {
            var _this3 = this;

            this.loading = true;

            return this.emailIngestTokenService.create(this.teamId).then(function (token) {
                _this3.token = token || null;

                if (!_this3.token) {
                    return _this3.reload();
                }

                return null;
            }).catch(function (result) {
                if (result && result.data && result.data.error === 'EMAIL_INGEST_TOKEN_CONFLICT') {
                    return _this3.reload();
                }

                _this3.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to enable your inbound email address. Please try again later.'));
                return null;
            }).finally(function () {
                _this3.loading = false;
            });
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this4 = this;

            if (!this.token || !this.token.id) {
                return null;
            }

            return this.modalService.open({
                component: 'dbAConfirmModal',
                bindings: {
                    title: 'Delete email address',
                    message: ['Deleting this address cannot be undone.', 'Are you still sure about it?'],
                    primaryButton: ['Delete', 'Deleting...'],
                    onClose: function onClose() {
                        _this4.loading = true;

                        return _this4.emailIngestTokenService.remove(_this4.token.id).then(function () {
                            _this4.token = null;
                        }).catch(function (result) {
                            _this4.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to delete your inbound email address. Please try again later.'));
                            return _this4.$q.reject(result);
                        }).finally(function () {
                            _this4.loading = false;
                        });
                    }
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'getAddress',
        value: function getAddress() {
            if (!this.token || !this.token.token) {
                return null;
            }

            return this.token.token + '@' + INBOUND_EMAIL_DOMAIN;
        }
    }, {
        key: 'copyAddress',
        value: function copyAddress() {
            var _this5 = this;

            var address = this.getAddress();
            if (!address) {
                return this.$q.resolve();
            }

            return this.$q.when(this.writeTextToClipboard(address)).then(function () {
                _this5.notificationService.showInfo('Email address copied.');
            }).catch(function (result) {
                _this5.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to copy the email address. Please try again.'));
            });
        }
    }, {
        key: 'writeTextToClipboard',
        value: function writeTextToClipboard(text) {
            var _this6 = this;

            var clipboard = this.$window.navigator && this.$window.navigator.clipboard;
            if (clipboard && this.$window.isSecureContext) {
                return clipboard.writeText(text);
            }

            return this.$q(function (resolve, reject) {
                var node = _this6.$window.document.createElement('textarea');
                node.value = text;
                node.setAttribute('readonly', '');
                node.style.position = 'fixed';
                node.style.top = '-9999px';

                _this6.$window.document.body.appendChild(node);
                node.focus();
                node.select();

                var copied = _this6.$window.document.execCommand('copy');
                _this6.$window.document.body.removeChild(node);

                return copied ? resolve() : reject('Clipboard copy failed.');
            });
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            return this.onDismiss();
        }
    }]);

    return EmailIngestTokenModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEmailIngestTokenModal',
    template: __WEBPACK_IMPORTED_MODULE_2__email_ingest_token_modal_tpl_pug___default()(),
    controller: EmailIngestTokenModalController,
    bindings: {
        teamId: '<',
        teamName: '<',
        title: '@?',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "TYlE":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"user-interface-settings-page\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EUser Interface\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv class=\"setting-name\"\u003ECalendar highlight color\u003C\u002Fdiv\u003E\u003Cdiv class=\"setting-description\"\u003EChoose which color is used for calendar highlights.\u003C\u002Fdiv\u003E\u003Cdiv class=\"setting-options\"\u003E\u003Clabel class=\"setting-option\" ng-click=\"$ctrl.selectCalendarHighlightColor('selected')\"\u003E\u003Cdb-a-radio class=\"setting-option-state\" selected=\"$ctrl.preferences.calendarHighlightColor === 'selected'\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"setting-option-title\"\u003ESelected calendar color (default)\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003Clabel class=\"setting-option\" ng-click=\"$ctrl.selectCalendarHighlightColor('blue')\"\u003E\u003Cdb-a-radio class=\"setting-option-state\" selected=\"$ctrl.preferences.calendarHighlightColor === 'blue'\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"setting-option-title\"\u003EDollarbird blue\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003ETheme\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv class=\"setting-name\"\u003EColor theme\u003C\u002Fdiv\u003E\u003Cdiv class=\"setting-description\"\u003EChoose how the app looks.\u003C\u002Fdiv\u003E\u003Cdiv class=\"setting-options\"\u003E\u003Clabel class=\"setting-option\" ng-click=\"$ctrl.selectTheme('system')\"\u003E\u003Cdb-a-radio class=\"setting-option-state\" selected=\"$ctrl.preferences.theme === 'system'\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"setting-option-title\"\u003EAuto\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003Clabel class=\"setting-option\" ng-click=\"$ctrl.selectTheme('default')\"\u003E\u003Cdb-a-radio class=\"setting-option-state\" selected=\"$ctrl.preferences.theme === 'default'\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"setting-option-title\"\u003ELight\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003Clabel class=\"setting-option\" ng-click=\"$ctrl.selectTheme('dark')\"\u003E\u003Cdb-a-radio class=\"setting-option-state\" selected=\"$ctrl.preferences.theme === 'dark'\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"setting-option-title\"\u003EDark\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003ECategories\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv class=\"setting-name\"\u003ECategory markers\u003C\u002Fdiv\u003E\u003Cdiv class=\"setting-description\"\u003EChoose how categories are displayed across the app.\u003C\u002Fdiv\u003E\u003Cdiv class=\"setting-options\"\u003E\u003Clabel class=\"setting-option\" ng-click=\"$ctrl.selectCategoryIconStyle('classic')\"\u003E\u003Cdb-a-radio class=\"setting-option-state\" selected=\"$ctrl.preferences.categoryIconStyle === 'classic'\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"setting-option-title\"\u003EClassic circles\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003Clabel class=\"setting-option\" ng-click=\"$ctrl.selectCategoryIconStyle('icons')\"\u003E\u003Cdb-a-radio class=\"setting-option-state\" selected=\"$ctrl.preferences.categoryIconStyle === 'icons'\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"setting-option-title\"\u003ECategory icons\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003ECalendar Balances\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv class=\"setting-name\"\u003ECalendar balance warning highlight\u003C\u002Fdiv\u003E\u003Cdiv class=\"setting-description\"\u003EHighlight balances in yellow when they fall below your warning threshold (but stay above 0).\u003C\u002Fdiv\u003E\u003Clabel class=\"control-switch\"\u003EEnable warning threshold\u003Cdb-a-switch class=\"control-switch-content\" ng-model=\"$ctrl.preferences.balanceWarningThresholdEnabled\" ng-change=\"$ctrl.toggleBalanceWarningThreshold($ctrl.preferences.balanceWarningThresholdEnabled)\"\u003E\u003C\u002Fdb-a-switch\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"control setting-threshold-control\" ng-class=\"{ disabled: !$ctrl.preferences.balanceWarningThresholdEnabled }\"\u003E\u003Cinput class=\"control-input\" type=\"number\" min=\"0\" step=\"0.01\" id=\"balance-warning-threshold-control\" name=\"balance-warning-threshold\" placeholder=\"0\" ng-model=\"$ctrl.preferences.balanceWarningThreshold\" ng-change=\"$ctrl.updateBalanceWarningThreshold()\" ng-disabled=\"!$ctrl.preferences.balanceWarningThresholdEnabled\"\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"balance-warning-threshold-control\"\u003EWarning threshold\u003C\u002Flabel\u003E\u003Cdiv class=\"setting-threshold-hint\"\u003EUse a positive value. Balances below 0 are always shown in red.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "TgK+":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"team-radio\" ng-class=\"{ selected: $ctrl.selected }\"\u003E\u003Cdb-a-radio class=\"team-state\" selected=\"$ctrl.selected\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"team-name\" ng-bind=\"$ctrl.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "Tgva":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blur_directive__ = __webpack_require__("KyKc");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.blur', []).directive(__WEBPACK_IMPORTED_MODULE_1__blur_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__blur_directive__["a" /* default */]));

/***/ }),

/***/ "Th19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_image_cmpt__ = __webpack_require__("wZ8A");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.user-image', []).component(__WEBPACK_IMPORTED_MODULE_1__user_image_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__user_image_cmpt__["a" /* default */]));

/***/ }),

/***/ "TnF8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_provider_subscribable_provider__ = __webpack_require__("OymO");


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var CategoryService = function (_Subscribable) {
    CategoryService.$inject = ['$q', 'apiService', 'storageService'];

    _inherits(CategoryService, _Subscribable);

    /* @ngInject */
    function CategoryService($q, apiService, storageService) {
        _classCallCheck(this, CategoryService);

        var _this = _possibleConstructorReturn(this, (CategoryService.__proto__ || Object.getPrototypeOf(CategoryService)).call(this));

        _this.$q = $q;
        _this.apiService = apiService;
        _this.storageService = storageService;

        _this.promises = {};
        _this.refreshPromises = {};
        return _this;
    }

    _createClass(CategoryService, [{
        key: 'reload',
        value: function reload(teamId) {
            var _this2 = this;

            var object = {};

            object.promise = this.fetchCategories(teamId).then(function (categories) {
                object.categories = categories;
                return object.categories;
            }, function (result) {
                object.categories = [];
                return _this2.$q.reject(result);
            });

            this.promises[teamId] = object;

            return object.promise;
        }
    }, {
        key: 'onUpdate',
        value: function onUpdate(callback) {
            return this.on('change', callback);
        }
    }, {
        key: 'getAll',
        value: function getAll(teamId, reload) {
            if (reload) {
                return this.reload(teamId);
            }

            if (this.promises[teamId]) {
                return this.promises[teamId].promise;
            }

            var cached = this.getCachedCategories(teamId);
            if (cached) {
                this.promises[teamId] = {
                    categories: cached,
                    promise: this.$q.resolve(cached)
                };

                this.refresh(teamId).catch(function () {
                    return null;
                });
                return this.promises[teamId].promise;
            }

            return this.reload(teamId);
        }
    }, {
        key: 'getPalette',
        value: function getPalette() {
            return this.apiService.get('/palette').then(function (result) {
                return result.data || [];
            });
        }
    }, {
        key: 'find',
        value: function find(teamId, callback) {
            var _this3 = this;

            return this.getAll(teamId).then(function (categories) {
                return __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(categories || [], callback) || _this3.$q.reject('Category not found.');
            });
        }
    }, {
        key: 'create',
        value: function create(teamId, category) {
            var _this4 = this;

            return this.apiService.post('/teams/' + teamId + '/categories', category).then(this.successHandler.bind(this, teamId)).then(function (createdCategory) {
                var nextCategory = Object.assign({}, createdCategory || {}, category || {});

                if (createdCategory && createdCategory.id) {
                    nextCategory.id = createdCategory.id;
                }

                _this4.fire('change', nextCategory);
                return createdCategory;
            });
        }
    }, {
        key: 'update',
        value: function update(teamId, category) {
            var _this5 = this;

            return this.apiService.put('/categories/' + category.id, category).then(this.successHandler.bind(this, teamId)).then(function (updatedCategory) {
                var nextCategory = Object.assign({}, updatedCategory || {}, category || {});

                if (updatedCategory && updatedCategory.id) {
                    nextCategory.id = updatedCategory.id;
                }

                _this5.fire('change', nextCategory);
                return updatedCategory;
            });
        }
    }, {
        key: 'remove',
        value: function remove(teamId, category) {
            var _this6 = this;

            var fallbackCategoryId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var config = fallbackCategoryId ? {
                params: {
                    fallback: fallbackCategoryId
                }
            } : null;

            return this.apiService.delete('/categories/' + category.id, config).then(this.successHandler.bind(this, teamId)).then(function (category) {
                _this6.fire('change', category);
                return category;
            });
        }
    }, {
        key: 'reorder',
        value: function reorder(teamId, ids) {
            var _this7 = this;

            return this.apiService.post('/teams/' + teamId + '/categories/order', ids).then(function (result) {
                return _this7.reload(teamId).then(function () {
                    return result.data;
                });
            });
        }
    }, {
        key: 'successHandler',
        value: function successHandler(teamId, result) {
            result = result || {};
            return this.reload(teamId).then(function () {
                return result.data;
            });
        }
    }, {
        key: 'refresh',
        value: function refresh(teamId) {
            var _this8 = this;

            if (this.refreshPromises[teamId]) {
                return this.refreshPromises[teamId];
            }

            var refreshPromise = this.fetchCategories(teamId).then(function (categories) {
                _this8.promises[teamId] = {
                    categories: categories,
                    promise: _this8.$q.resolve(categories)
                };

                return categories;
            }).finally(function () {
                delete _this8.refreshPromises[teamId];
            });

            this.refreshPromises[teamId] = refreshPromise;
            return refreshPromise;
        }
    }, {
        key: 'fetchCategories',
        value: function fetchCategories(teamId) {
            var _this9 = this;

            return this.apiService.get('/teams/' + teamId + '/categories').then(function (result) {
                result = result || {};
                var categories = result.data || [];
                _this9.setCachedCategories(teamId, categories);
                return categories;
            });
        }
    }, {
        key: 'getCachedCategories',
        value: function getCachedCategories(teamId) {
            var key = this.getCategoriesCacheKey(teamId);
            var cached = this.storageService.getUserItem(key);

            if (!cached) {
                return null;
            }

            if (Array.isArray(cached)) {
                return cached;
            }

            return Array.isArray(cached.categories) ? cached.categories : null;
        }
    }, {
        key: 'setCachedCategories',
        value: function setCachedCategories(teamId, categories) {
            try {
                var key = this.getCategoriesCacheKey(teamId);
                this.storageService.setUserItem(key, {
                    version: 1,
                    updatedAt: Date.now(),
                    categories: categories || []
                });
            } catch (error) {
                return null;
            }

            return null;
        }
    }, {
        key: 'getCategoriesCacheKey',
        value: function getCategoriesCacheKey(teamId) {
            return 'categories-' + teamId;
        }
    }]);

    return CategoryService;
}(Object(__WEBPACK_IMPORTED_MODULE_1_common_provider_subscribable_provider__["a" /* default */])());

/* harmony default export */ __webpack_exports__["a"] = (CategoryService);

/***/ }),

/***/ "Tsmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_verification_request__ = __webpack_require__("FLLW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__email_verification_confirm__ = __webpack_require__("5/c5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__email_verification_redirect__ = __webpack_require__("RQHK");






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.email-verification.scene', [__WEBPACK_IMPORTED_MODULE_1__email_verification_request__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__email_verification_confirm__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__email_verification_redirect__["a" /* default */].name]));

/***/ }),

/***/ "Tvex":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("7YkW"),
    arrayIncludes = __webpack_require__("JUs9"),
    arrayIncludesWith = __webpack_require__("s96k"),
    cacheHas = __webpack_require__("dmQx"),
    createSet = __webpack_require__("V3Yo"),
    setToArray = __webpack_require__("octw");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "U0Im":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart"};

/***/ }),

/***/ "U4kA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = CaptureKeysDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
CaptureKeysDirective.$inject = ['$parse', '$document'];


var selector = 'dbACaptureKeys';

/* @ngInject */
function CaptureKeysDirective($parse, $document) {
    return {
        restrict: 'A',
        require: 'ngModel',

        link: function link(scope, element, attrs) {
            var enabled = $parse(attrs[selector]);
            var $body = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element($document[0].body);

            $body.on('keypress', handleCapture);
            element.on('keydown', handleEscape);
            scope.$on('$destroy', function () {
                $body.off('keypress', handleCapture);
                element.off('keydown', handleEscape);
            });

            function handleCapture(event) {
                if (enabled(scope) && event.which !== 13 && element[0] !== $document[0].activeElement) {
                    element[0].focus();
                }
            }

            function handleEscape(event) {
                switch (event.which) {
                    case 27:
                        element[0].blur();
                        break;
                }
            }
        }
    };
}

/***/ }),

/***/ "U7WT":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"user-image\"\u003E\u003Cdb-image class=\"user-image\" url=\"$ctrl.url\" color=\"$ctrl.color\" alt=\"$ctrl.name\" on-change=\"$ctrl.update(url)\"\u003E\u003C\u002Fdb-image\u003E\u003Cdiv class=\"user-initials\" ng-show=\"!$ctrl.missing\" ng-bind=\"$ctrl.initials\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "UISt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__radio_style_sass__ = __webpack_require__("f+rN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__radio_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__radio_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__radio_tpl_pug__ = __webpack_require__("l/u7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__radio_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__radio_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbARadio',
    template: __WEBPACK_IMPORTED_MODULE_1__radio_tpl_pug___default()(),
    bindings: {
        name: '@',
        selected: '<'
    }
});

/***/ }),

/***/ "UNd/":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category-merge-modal modal-fixed-height\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.merge()\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cdiv class=\"modal-title\"\u003EMerge category\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter modal-section\"\u003E\u003Cdiv class=\"merge-description\"\u003E\u003Cspan ng-bind=\"'You are about to delete &quot;' + $ctrl.category.name + '&quot;, so choose a destination category where all transactions and repeating transactions will be moved before deletion.'\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"fallback-section\"\u003E\u003Cbutton class=\"button button-outline button-secondary button-select-fallback\" type=\"button\" ng-click=\"$ctrl.pickFallbackCategory()\"\u003ESelect destination category\u003C\u002Fbutton\u003E\u003Cdb-a-category class=\"fallback-category-preview\" ng-if=\"$ctrl.fallbackCategory\" name=\"$ctrl.fallbackCategory.name\" color=\"$ctrl.fallbackCategory.color\" icon-name=\"$ctrl.fallbackCategory.iconName\" icon-index=\"$ctrl.fallbackCategory.iconIndex\" use-icons=\"true\" fallback-icon-name=\"null\"\u003E\u003C\u002Fdb-a-category\u003E\u003Cdiv class=\"fallback-empty\" ng-if=\"!$ctrl.fallbackCategory\"\u003E\u003Cspan\u003ENo destination category selected.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-outline button-secondary button-modal-left\" type=\"button\" ng-click=\"$ctrl.dismiss()\" ng-class=\"{ disabled: form.$submitting }\"\u003ECancel\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-danger button-modal-right\" type=\"submit\" db-a-async loading=\"form.$submitting\" ng-disabled=\"!$ctrl.fallbackCategory || !$ctrl.fallbackCategory.id\"\u003E\u003Cinitial\u003EMerge now\u003C\u002Finitial\u003E\u003Cloading\u003EMerging...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "UY3x":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category-group\"\u003E\u003Cdiv class=\"category-heading\" ng-click=\"$ctrl.toggleGroupVisibility()\"\u003E\u003Cdiv class=\"button-icon category-toggle\" ng-style=\"{ backgroundColor: $ctrl.color }\"\u003E\u003Ci class=\"icon\" ng-class=\"{ 'icon-dollarbird-chevron-up': $ctrl.expanded, 'icon-dollarbird-chevron-down': !$ctrl.expanded }\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-name\" ng-bind=\"$ctrl.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-progress-container\"\u003E\u003Cdiv class=\"category-progress outer\"\u003E\u003Cdiv class=\"category-progress-bar\" ng-style=\"{ backgroundColor: $ctrl.color, width: $ctrl.averagePercent }\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-progress\"\u003E\u003Cdiv class=\"category-progress-bar\" ng-style=\"{ backgroundColor: $ctrl.color, width: $ctrl.valuePercent }\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-value-types\"\u003E\u003Cdiv class=\"category-value-type\"\u003E\u003Cdiv class=\"category-value-type-heading\"\u003E\u003Cdiv class=\"category-value-type-color opaque\" ng-style=\"{ backgroundColor: $ctrl.color }\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-value-type-name\"\u003EPast avg\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"category-value-type-value\" value=\"$ctrl.average\" limit=\"100000\" pretty=\"true\" ng-if=\"$ctrl.average\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003Cdiv class=\"category-value-type-value\" ng-hide=\"$ctrl.average\"\u003E-\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-value-type\"\u003E\u003Cdiv class=\"category-value-type-heading\"\u003E\u003Cdiv class=\"category-value-type-color\" ng-style=\"{ backgroundColor: $ctrl.color }\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-value-type-name\"\u003EThis month\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"category-value-type-value\" value=\"$ctrl.value\" limit=\"100000\" pretty=\"true\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-value-type\"\u003E\u003Cdiv class=\"category-value-type-heading\"\u003E\u003Cdiv class=\"category-value-type-name\" ng-hide=\"$ctrl.exceeded\" ng-bind=\"$ctrl.savedText\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-value-type-name\" ng-show=\"$ctrl.exceeded\" ng-bind=\"$ctrl.exceededText\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"category-value-type-value\" value=\"$ctrl.difference\" limit=\"100000\" pretty=\"true\" ng-if=\"$ctrl.average\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003Cdiv class=\"category-value-type-value\" ng-hide=\"$ctrl.average\"\u003E-\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-groups\" ng-if=\"$ctrl.expanded\"\u003E\u003Cdb-a-event-group class=\"event-group-item\" ng-repeat=\"group in $ctrl.eventGroups track by $index\" count=\"group.count\" note=\"group.note\" value=\"group.value\" ng-click=\"$ctrl.clickEventGroup()\"\u003E\u003C\u002Fdb-a-event-group\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "Ub4b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_22-b0816f74d12a2df5.svg";

/***/ }),

/***/ "UlYi":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdb-a-notification class=\"renew-subscription-notification\"\u003E\u003Cnotification-title\u003EYour subscription has expired.\u003C\u002Fnotification-title\u003E\u003Cnotification-content\u003E\u003Cdiv class=\"subscription-description\"\u003EPlease renew your subscription to have full control over all your calendars or select a calendar as your default. All your other calendars will be kept in view-only mode until subscription renewal.\u003C\u002Fdiv\u003E\u003Cdiv class=\"subscription-buttons\"\u003E\u003Ca class=\"button button-block button-fill button-primary button-subscription button-renew-subscription\" href=\"javascript:void(0);\" ui-sref=\"authorized.subscribe\" ng-click=\"$ctrl.renew()\"\u003ERenew subscription\u003C\u002Fa\u003E\u003Cbutton class=\"button button-block button-outline button-secondary button-subscription button-select-default-calendar\" type=\"button\" ng-click=\"$ctrl.select()\"\u003ESelect default calendar\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnotification-content\u003E\u003C\u002Fdb-a-notification\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "Um0n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-page":"calendar-page","calendar-content":"calendar-content","calendar-modal-host":"calendar-modal-host","calendar-loader":"calendar-loader","transactions-by-email-shortcut":"transactions-by-email-shortcut","button-dismiss-transactions-by-email":"button-dismiss-transactions-by-email","button-open-transactions-by-email":"button-open-transactions-by-email","transactions-by-email-shortcut-title":"transactions-by-email-shortcut-title","transactions-by-email-shortcut-subtitle":"transactions-by-email-shortcut-subtitle","calendar-piece-container":"calendar-piece-container","empty":"empty","calendar-piece":"calendar-piece","calendar-weekday-list":"calendar-weekday-list","calendar-weekday-item-container":"calendar-weekday-item-container","weekend":"weekend","calendar-day-list":"calendar-day-list","calendar-day-item-container":"calendar-day-item-container","empty-state-content":"empty-state-content","empty-state-title":"empty-state-title","empty-state-message":"empty-state-message"};

/***/ }),

/***/ "V+kx":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv ng-transclude ng-show=\"$ctrl.invalid\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "V164":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-radio\" ng-class=\"{ selected: $ctrl.selected }\"\u003E\u003Cdb-a-radio class=\"calendar-radio-state\" selected=\"$ctrl.selected\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"calendar-radio-name\" ng-bind=\"$ctrl.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "V3Yo":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("5N57"),
    noop = __webpack_require__("qrdl"),
    setToArray = __webpack_require__("octw");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "VID3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Baby-dc7d0aeba04a5076.svg";

/***/ }),

/***/ "VIWf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("ySb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboard_cmpt__ = __webpack_require__("JFb5");





var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

stateConfiguration.$inject = ['$stateProvider', '$transitionsProvider'];







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_angular___default.a.module('application.scene.authorized.scene.dashboard', [__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_7__dashboard_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_7__dashboard_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('authorized.dashboard', {
        url: '/dashboard/:teamId?cid&time',
        component: __WEBPACK_IMPORTED_MODULE_7__dashboard_cmpt__["a" /* default */].selector,
        params: {
            teamId: {
                value: null,
                squash: true,
                dynamic: true
            },
            cid: {
                array: true,
                value: [],
                dynamic: true
            },
            time: {
                value: null
            }
        }
    });

    $transitionsProvider.onStart({
        to: 'authorized.dashboard'
    }, function (transition) {
        var _ref = transition.params() || {},
            teamId = _ref.teamId,
            cid = _ref.cid,
            time = _ref.time;

        teamId = +teamId;

        var $state = transition.injector().get('$state');
        var $q = transition.injector().get('$q');
        var sessionService = transition.injector().get('sessionService');
        var preferenceService = transition.injector().get('preferenceService');

        return $q.all([sessionService.initialize(), preferenceService.get()]).then(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                data = _ref3[0],
                preferences = _ref3[1];

            var teams = data.teams;

            var selectedTeam = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(teams, function (team) {
                return team.id === teamId;
            });

            if (!selectedTeam) {
                return $q.reject('No team specified.');
            }

            transition.addResolvable({
                token: 'selectedTeam',
                deps: [],
                resolveFn: function resolveFn() {
                    return selectedTeam;
                }
            });

            transition.addResolvable({
                token: 'calendarIds',
                deps: [],
                resolveFn: function resolveFn() {
                    return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(cid, function (id) {
                        return +id;
                    }), function (id) {
                        return __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(selectedTeam.calendars, function (calendar) {
                            return calendar.id === id;
                        });
                    });
                }
            });

            transition.addResolvable({
                token: 'teams',
                deps: [],
                resolveFn: function resolveFn() {
                    return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(teams, function (team) {
                        return team.calendars.length > 0;
                    });
                }
            });

            transition.addResolvable({
                token: 'startOfWeek',
                deps: [],
                resolveFn: function resolveFn() {
                    return preferences.startWeekOnSunday ? 0 : 1;
                }
            });

            time = __WEBPACK_IMPORTED_MODULE_5_moment___default()(+time);
            transition.addResolvable({
                token: 'time',
                deps: [],
                resolveFn: function resolveFn() {
                    return time.isValid() ? time.valueOf() : null;
                }
            });

            return true;
        }).catch(function () {
            return $state.target('authorized');
        });
    });
}

/***/ }),

/***/ "VL38":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"general-settings-page\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EGeneral\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Clabel class=\"control-switch\"\u003EStart week on Sunday\u003Cdb-a-switch class=\"control-switch-content\" ng-model=\"$ctrl.preferences.startWeekOnSunday\" ng-change=\"$ctrl.updatePreferences()\"\u003E\u003C\u002Fdb-a-switch\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Clabel class=\"control-switch\"\u003EPredict category from transaction label\u003Cdb-a-switch class=\"control-switch-content\" ng-model=\"$ctrl.autoCategorization\" ng-change=\"$ctrl.updatePreferences()\"\u003E\u003C\u002Fdb-a-switch\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Clabel class=\"control-switch\"\u003EReset balance to 0 every month\u003Cdb-a-switch class=\"control-switch-content\" ng-model=\"$ctrl.preferences.resetBalanceMonthly\" ng-change=\"$ctrl.updatePreferences()\"\u003E\u003C\u002Fdb-a-switch\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\" ng-if=\"$ctrl.selectedTeam\"\u003E\u003Cdiv class=\"form-group-name\"\u003EEmail to transaction\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cbutton class=\"settings-disclosure-row\" type=\"button\" ng-click=\"$ctrl.manageTransactionsByEmail()\"\u003E\u003Cdiv class=\"settings-disclosure-copy\"\u003E\u003Cdiv class=\"settings-disclosure-title\"\u003EManage private email address\u003C\u002Fdiv\u003E\u003Cdiv class=\"settings-disclosure-subtitle\"\u003EFor currently selected calendar group\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ci class=\"icon icon-dollarbird-chevron-right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "VRu6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");
var helpers = __webpack_require__("iO9N");
var Ticks = __webpack_require__("IbXy");

defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		lineHeight: 1.2
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: Ticks.formatters.values,
		minor: {},
		major: {}
	}
});

function labelsFromTicks(ticks) {
	var labels = [];
	var i, ilen;

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		labels.push(ticks[i].label);
	}

	return labels;
}

function getLineValue(scale, index, offsetGridLines) {
	var lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

module.exports = function(Chart) {

	function computeTextSize(context, tick, font) {
		return helpers.isArray(tick) ?
			helpers.longestText(context, font, tick) :
			context.measureText(tick).width;
	}

	function parseFontOptions(options) {
		var valueOrDefault = helpers.valueOrDefault;
		var globalDefaults = defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
		var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

		return {
			size: size,
			style: style,
			family: family,
			font: helpers.fontString(size, style, family)
		};
	}

	function parseLineHeight(options) {
		return helpers.options.toLineHeight(
			helpers.valueOrDefault(options.lineHeight, 1.2),
			helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
	}

	Chart.Scale = Element.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		mergeTicksOptions: function() {
			var ticks = this.options.ticks;
			if (ticks.minor === false) {
				ticks.minor = {
					display: false
				};
			}
			if (ticks.major === false) {
				ticks.major = {
					display: false
				};
			}
			for (var key in ticks) {
				if (key !== 'major' && key !== 'minor') {
					if (typeof ticks.minor[key] === 'undefined') {
						ticks.minor[key] = ticks[key];
					}
					if (typeof ticks.major[key] === 'undefined') {
						ticks.major[key] = ticks[key];
					}
				}
			}
		},
		beforeUpdate: function() {
			helpers.callback(this.options.beforeUpdate, [this]);
		},
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var i, ilen, labels, label, ticks, tick;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
			me.longestTextCache = me.longestTextCache || {};

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.

			me.beforeBuildTicks();

			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];

			me.afterBuildTicks();

			me.beforeTickToLabelConversion();

			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;

			me.afterTickToLabelConversion();

			me.ticks = labels;   // BACKWARD COMPATIBILITY

			// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = labels.length; i < ilen; ++i) {
				label = labels[i];
				tick = ticks[i];
				if (!tick) {
					ticks.push(tick = {
						label: label,
						major: false
					});
				} else {
					tick.label = label;
				}
			}

			me._ticks = ticks;

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: function() {
			helpers.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function() {
			helpers.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function() {
			helpers.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers.noop,
		afterDataLimits: function() {
			helpers.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function() {
			helpers.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers.noop,
		afterBuildTicks: function() {
			helpers.callback(this.options.afterBuildTicks, [this]);
		},

		beforeTickToLabelConversion: function() {
			helpers.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function() {
			helpers.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;
			var labels = labelsFromTicks(me._ticks);

			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = parseFontOptions(tickOpts);
			context.font = tickFont.font;

			var labelRotation = tickOpts.minRotation || 0;

			if (labels.length && me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation, sinRotation;

				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);

					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}

					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function() {
			helpers.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var labels = labelsFromTicks(me._ticks);

			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = opts.display;
			var isHorizontal = me.isHorizontal();

			var tickFont = parseFontOptions(tickOpts);
			var tickMarkLength = opts.gridLines.tickMarkLength;
			var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);

			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}

			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}

			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				if (isHorizontal) {
					minSize.height += scaleLabelLineHeight;
				} else {
					minSize.width += scaleLabelLineHeight;
				}
			}

			// Don't bother fitting the ticks if we are not showing them
			if (tickOpts.display && display) {
				var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
				var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
				var lineSpace = tickFont.size * 0.5;
				var tickPadding = me.options.ticks.padding;

				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					me.longestLabelWidth = largestTextWidth;

					var angleRadians = helpers.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.size * tallestLabelHeightInLines)
						+ (lineSpace * tallestLabelHeightInLines);

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
					me.ctx.font = tickFont.font;

					var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
					var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
					// by the font height
					if (me.labelRotation !== 0) {
						me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
						me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
					} else {
						me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = lastLabelWidth / 2 + 3;
					}
				} else {
					// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
					// Account for padding

					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						largestTextWidth += tickPadding;
					}
					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);
					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}

			me.handleMargins();

			me.width = minSize.width;
			me.height = minSize.height;
		},

		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},

		afterFit: function() {
			helpers.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (helpers.isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if (typeof rawValue === 'number' && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}

			// Value is good, return it
			return rawValue;
		},

		// Used to get the value to display in the tooltip for the data at the given index
		// function getLabelForIndex(index, datasetIndex)
		getLabelForIndex: helpers.noop,

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: helpers.noop,

		// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		getValueForPixel: helpers.noop,

		// Used for tick location, should
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;

				if (offset) {
					pixel += tickWidth / 2;
				}

				var finalVal = me.left + Math.round(pixel);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me._ticks.length - 1)));
		},

		// Utility for getting the pixel location of a percentage of scale
		getPixelForDecimal: function(decimal) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;

				var finalVal = me.left + Math.round(valueOffset);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},

		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},

		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var skipRatio;
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
			var tickCount = ticks.length;
			var labelRotationRadians = helpers.toRadians(me.labelRotation);
			var cosRotation = Math.cos(labelRotationRadians);
			var longestRotatedLabel = me.longestLabelWidth * cosRotation;
			var result = [];
			var i, tick, shouldSkip;

			// figure out the maximum number of gridlines to show
			var maxTicks;
			if (optionTicks.maxTicksLimit) {
				maxTicks = optionTicks.maxTicksLimit;
			}

			if (isHorizontal) {
				skipRatio = false;

				if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
					skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
				}

				// if they defined a max number of optionTicks,
				// increase skipRatio until that number is met
				if (maxTicks && tickCount > maxTicks) {
					skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
				}
			}

			for (i = 0; i < tickCount; i++) {
				tick = ticks[i];

				// Since we always show the last tick,we need may need to hide the last shown one before
				shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
				if (shouldSkip && i !== tickCount - 1 || helpers.isNullOrUndef(tick.label)) {
					// leave tick in place but make sure it's not displayed (#4635)
					delete tick.label;
				}
				result.push(tick);
			}
			return result;
		},

		// Actually draw the scale on the canvas
		// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
		draw: function(chartArea) {
			var me = this;
			var options = me.options;
			if (!options.display) {
				return;
			}

			var context = me.ctx;
			var globalDefaults = defaults.global;
			var optionTicks = options.ticks.minor;
			var optionMajorTicks = options.ticks.major || optionTicks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;

			var isRotated = me.labelRotation !== 0;
			var isHorizontal = me.isHorizontal();

			var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
			var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
			var tickFont = parseFontOptions(optionTicks);
			var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
			var majorTickFont = parseFontOptions(optionMajorTicks);

			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

			var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
			var scaleLabelFont = parseFontOptions(scaleLabel);
			var labelRotationRadians = helpers.toRadians(me.labelRotation);

			var itemsToDraw = [];

			var xTickStart = options.position === 'right' ? me.left : me.right - tl;
			var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
			var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
			var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;

			helpers.each(ticks, function(tick, index) {
				// autoskipper skipped this tick (#4635)
				if (tick.label === undefined) {
					return;
				}

				var label = tick.label;
				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === (typeof me.zeroLineIndex !== 'undefined' ? me.zeroLineIndex : 0) && (options.offset === gridLines.offsetGridLines)) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash;
					borderDashOffset = gridLines.zeroLineBorderDashOffset;
				} else {
					lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
					borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
					borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
				}

				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
				var textAlign = 'middle';
				var textBaseline = 'middle';
				var tickPadding = optionTicks.padding;

				if (isHorizontal) {
					var labelYOffset = tl + tickPadding;

					if (options.position === 'bottom') {
						// bottom
						textBaseline = !isRotated ? 'top' : 'middle';
						textAlign = !isRotated ? 'center' : 'right';
						labelY = me.top + labelYOffset;
					} else {
						// top
						textBaseline = !isRotated ? 'bottom' : 'middle';
						textAlign = !isRotated ? 'center' : 'left';
						labelY = me.bottom - labelYOffset;
					}

					var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (xLineValue < me.left) {
						lineColor = 'rgba(0,0,0,0)';
					}
					xLineValue += helpers.aliasPixel(lineWidth);

					labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

					tx1 = tx2 = x1 = x2 = xLineValue;
					ty1 = yTickStart;
					ty2 = yTickEnd;
					y1 = chartArea.top;
					y2 = chartArea.bottom;
				} else {
					var isLeft = options.position === 'left';
					var labelXOffset;

					if (optionTicks.mirror) {
						textAlign = isLeft ? 'left' : 'right';
						labelXOffset = tickPadding;
					} else {
						textAlign = isLeft ? 'right' : 'left';
						labelXOffset = tl + tickPadding;
					}

					labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

					var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (yLineValue < me.top) {
						lineColor = 'rgba(0,0,0,0)';
					}
					yLineValue += helpers.aliasPixel(lineWidth);

					labelY = me.getPixelForTick(index) + optionTicks.labelOffset;

					tx1 = xTickStart;
					tx2 = xTickEnd;
					x1 = chartArea.left;
					x2 = chartArea.right;
					ty1 = ty2 = y1 = y2 = yLineValue;
				}

				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					major: tick.major,
					textBaseline: textBaseline,
					textAlign: textAlign
				});
			});

			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers.each(itemsToDraw, function(itemToDraw) {
				if (gridLines.display) {
					context.save();
					context.lineWidth = itemToDraw.glWidth;
					context.strokeStyle = itemToDraw.glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}

					context.beginPath();

					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}

					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}

					context.stroke();
					context.restore();
				}

				if (optionTicks.display) {
					// Make sure we draw text in the correct color and font
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
					context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
					context.textBaseline = itemToDraw.textBaseline;
					context.textAlign = itemToDraw.textAlign;

					var label = itemToDraw.label;
					if (helpers.isArray(label)) {
						for (var i = 0, y = 0; i < label.length; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							// apply same lineSpacing as calculated @ L#320
							y += (tickFont.size * 1.5);
						}
					} else {
						context.fillText(label, 0, 0);
					}
					context.restore();
				}
			});

			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;
				var halfLineHeight = parseLineHeight(scaleLabel) / 2;

				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = options.position === 'bottom' ? me.bottom - halfLineHeight : me.top + halfLineHeight;
				} else {
					var isLeft = options.position === 'left';
					scaleLabelX = isLeft ? me.left + halfLineHeight : me.right - halfLineHeight;
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}

				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.font;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}

			if (gridLines.drawBorder) {
				// Draw the line at the edge of the axis
				context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
				context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
				var x1 = me.left;
				var x2 = me.right;
				var y1 = me.top;
				var y2 = me.bottom;

				var aliasPixel = helpers.aliasPixel(context.lineWidth);
				if (isHorizontal) {
					y1 = y2 = options.position === 'top' ? me.bottom : me.top;
					y1 += aliasPixel;
					y2 += aliasPixel;
				} else {
					x1 = x2 = options.position === 'left' ? me.right : me.left;
					x1 += aliasPixel;
					x2 += aliasPixel;
				}

				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});
};


/***/ }),

/***/ "VVuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_side_bar_style_sass__ = __webpack_require__("WXo7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_side_bar_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__calendar_side_bar_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_side_bar_tpl_pug__ = __webpack_require__("iphP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_side_bar_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_side_bar_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CalendarSideBarController = function () {
    function CalendarSideBarController() {
        _classCallCheck(this, CalendarSideBarController);
    }

    _createClass(CalendarSideBarController, [{
        key: 'close',
        value: function close() {
            return this.onClose();
        }
    }]);

    return CalendarSideBarController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarSideBar',
    template: __WEBPACK_IMPORTED_MODULE_1__calendar_side_bar_tpl_pug___default()(),
    controller: CalendarSideBarController,
    transclude: true,
    bindings: {
        visible: '<',
        onClose: '&'
    }
});

/***/ }),

/***/ "VXg5":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("JyYQ"),
    baseUniq = __webpack_require__("Tvex");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ "VYl1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_application_util_number_util__ = __webpack_require__("Cybx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category_chart_style_sass__ = __webpack_require__("/MEv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category_chart_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__category_chart_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__category_chart_tpl_pug__ = __webpack_require__("ZNTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__category_chart_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__category_chart_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










var CategoryChartController = function () {
    CategoryChartController.$inject = ['dashboardService'];

    /* @ngInject */
    function CategoryChartController(dashboardService) {
        _classCallCheck(this, CategoryChartController);

        this.dashboardService = dashboardService;

        this.options = this.getChartOptions();
    }

    _createClass(CategoryChartController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loading = true;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.calendarIds || changeObject.start || changeObject.end || changeObject.confirmed) {
                return this.load(this.calendarIds, __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start).startOf('day').valueOf(), __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.end).endOf('day').valueOf(), this.confirmed);
            }
        }
    }, {
        key: 'getTooltipLabel',
        value: function getTooltipLabel(item, data) {
            var index = item.index;
            var datasetIndex = item.datasetIndex;

            return Object(__WEBPACK_IMPORTED_MODULE_2_application_util_number_util__["c" /* prettifyNumber */])(data.datasets[datasetIndex].data[index], {
                preventShrink: true,
                pretty: true
            });
        }
    }, {
        key: 'getBalanceTick',
        value: function getBalanceTick(label) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_application_util_number_util__["c" /* prettifyNumber */])(label);
        }
    }, {
        key: 'getMonthTick',
        value: function getMonthTick(label) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(label).format('MMM');
        }
    }, {
        key: 'getChartOptions',
        value: function getChartOptions() {
            return {
                maintainAspectRatio: false,
                responsive: true,
                layout: {
                    padding: {
                        top: 60
                    }
                },
                tooltips: {
                    yAlign: 'bottom',
                    callbacks: {
                        label: this.getTooltipLabel.bind(this)
                    }
                },
                scales: {
                    xAxes: [{
                        position: 'top',
                        gridLines: {
                            color: '#ebeced',
                            borderDash: [3, 5],
                            drawBorder: false,
                            drawTicks: false
                        },
                        ticks: {
                            padding: 10,
                            suggestedMin: 0,
                            suggestedMax: 0,
                            beginAtZero: true,
                            maxTicksLimit: 5,
                            maxRotation: 0,
                            minRotation: 0,
                            callback: this.getBalanceTick.bind(this)
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            display: false,
                            color: '#ebeced',
                            drawTicks: false
                        },
                        ticks: {
                            padding: 15,
                            maxRotation: 0,
                            minRotation: 0
                        },
                        barPercentage: 0.25,
                        categoryPercentage: 1
                    }]
                }
            };
        }
    }, {
        key: 'load',
        value: function load(calendarIds, start, end, confirmed) {
            var _this = this;

            start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start);
            end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(end);

            this.loading = true;

            var labels = [];
            var values = [];
            var colors = [];

            return this.dashboardService.getExpenseCategoryData(calendarIds, start.isValid() ? start.valueOf() : null, end.valueOf(), confirmed).then(function (dataSet) {
                __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(dataSet, function (item) {
                    labels.push(item.category.name);
                    colors.push(item.category.color);
                    values.push(item.value);
                });

                _this.error = null;
            }).catch(function (result) {
                _this.error = Object(__WEBPACK_IMPORTED_MODULE_3_application_util_error_util__["b" /* getErrorMessage */])(result, 'Unfortunately we couldn\'t load the chart data. Please try again later.');
            }).finally(function () {
                _this.data = {
                    labels: labels,
                    datasets: [_this.getDataSet(values, colors)]
                };

                _this.height = labels.length > 0 ? labels.length * 30 + 10 + 15 + 'px' : null;

                _this.loading = false;
            });
        }
    }, {
        key: 'getDataSet',
        value: function getDataSet(data, colors) {
            return {
                data: data,
                fill: true,
                backgroundColor: colors,
                hoverBackgroundColor: colors
            };
        }
    }]);

    return CategoryChartController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategoryChart',
    template: __WEBPACK_IMPORTED_MODULE_5__category_chart_tpl_pug___default()(),
    controller: CategoryChartController,
    bindings: {
        calendarIds: '<',
        start: '<',
        end: '<',
        confirmed: '<'
    }
});

/***/ }),

/***/ "Vihm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSearchTerms;
/* harmony export (immutable) */ __webpack_exports__["b"] = valueContainsTerm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);



function getSearchTerms(term) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(('' + (term || '')).toLowerCase().split(/\s+/), function (term) {
        return term && term.length > 0;
    });
}

function valueContainsTerm(value, term) {
    return value && value.length > 0 && value.toLowerCase().indexOf(term) >= 0;
}

/***/ }),

/***/ "Vncn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventService = function () {
    EventService.$inject = ['apiService'];

    /* @ngInject */
    function EventService(apiService) {
        _classCallCheck(this, EventService);

        this.apiService = apiService;
    }

    _createClass(EventService, [{
        key: 'create',
        value: function create(teamId, calendar) {
            return this.apiService.post('/teams/' + teamId + '/calendars', calendar).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'update',
        value: function update(calendar) {
            return this.apiService.put('/calendars/' + calendar.id, {
                name: calendar.name,
                useAutoForecasting: !!calendar.useAutoForecasting,
                color: calendar.color || null,
                note: calendar.note || null,
                accounts: (calendar.accounts || []).map(function (account) {
                    return {
                        name: account.name
                    };
                })
            }).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'remove',
        value: function remove(calendar) {
            return this.apiService.delete('/calendars/' + calendar.id).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'reorder',
        value: function reorder(teamId, ids) {
            return this.apiService.post('/teams/' + teamId + '/calendars/order', ids).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'markAsDefault',
        value: function markAsDefault(calendar) {
            return this.apiService.patch('/calendars/' + calendar.id, [{
                path: 'isDefault',
                value: true
            }]).then(function (result) {
                return result.data;
            });
        }
    }]);

    return EventService;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventService);

/***/ }),

/***/ "W3eN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__about_style_sass__ = __webpack_require__("NrPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__about_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__about_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__about_tpl_pug__ = __webpack_require__("Lxud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__about_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__about_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var AboutSettingsController = function () {
    AboutSettingsController.$inject = ['$window', 'configuration', 'diagnosticsService', 'notificationService', 'sessionService'];

    /* @ngInject */
    function AboutSettingsController($window, configuration, diagnosticsService, notificationService, sessionService) {
        _classCallCheck(this, AboutSettingsController);

        this.$window = $window;
        this.configuration = configuration;
        this.diagnosticsService = diagnosticsService;
        this.notificationService = notificationService;
        this.sessionService = sessionService;
    }

    _createClass(AboutSettingsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.facebookUrl = this.configuration.socialFacebookUrl;
            this.twitterUrl = this.configuration.socialTwitterUrl;
            this.helpCenterUrl = this.configuration.helpCenterUrl;
            this.supportEmail = this.configuration.supportEmail;
            this.version = this.configuration.version;
            this.canSendDiagnostics = this.diagnosticsService.canSend();
            this.buildSupportMailDraft();

            this.sessionService.initialize().then(function (data) {
                _this.plan = data && data.plan ? data.plan : _this.plan;
                _this.buildSupportMailDraft();
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'sendDiagnostics',
        value: function sendDiagnostics() {
            var _this2 = this;

            return this.diagnosticsService.send({
                source: 'settings-about',
                userId: this.sessionService && this.sessionService.user && this.sessionService.user.id,
                identity: this.sessionService && this.sessionService.user && this.sessionService.user.email
            }).then(function (result) {
                var diagnosticsId = result && result.data && result.data.id;
                var message = diagnosticsId ? 'Diagnostics sent. ID: ' + diagnosticsId : 'Diagnostics sent. Thank you.';

                _this2.notificationService.showInfo(message, null, true, 6000);
            }).catch(function (result) {
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to send diagnostics. Please try again later.'));
            });
        }
    }, {
        key: 'buildSupportMailDraft',
        value: function buildSupportMailDraft() {
            var user = this.sessionService && this.sessionService.user ? this.sessionService.user : {};
            var planName = this.getPlanTypeName(this.plan);
            var userAgent = this.$window && this.$window.navigator ? this.$window.navigator.userAgent : null;
            var appUrl = this.$window && this.$window.location ? this.$window.location.href : null;

            this.supportMailSubject = 'Customer Support (Web, ' + planName + ')';
            this.supportMailBody = ['Platform: Web, version: ' + (this.version || 'unknown') + ', userID: ' + (user && user.id ? user.id : 'unknown') + ', userEmail: ' + (user && user.email ? user.email : 'unknown'), 'Browser: ' + (userAgent || 'unknown'), 'baseUrl: ' + (this.configuration && this.configuration.api ? this.configuration.api : 'unknown'), 'appUrl: ' + (appUrl || 'unknown')].join('\n');
        }
    }, {
        key: 'getPlanTypeName',
        value: function getPlanTypeName(plan) {
            var value = plan && (plan.planType_name || plan.planTypeName || plan.type_name || plan.typeName || plan.name || plan.subscription && plan.subscription.type);

            return value || 'unknown';
        }
    }]);

    return AboutSettingsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAAbout',
    template: __WEBPACK_IMPORTED_MODULE_2__about_tpl_pug___default()(),
    controller: AboutSettingsController
});

/***/ }),

/***/ "WDWI":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"cookie-notification\" ng-if=\"$ctrl.exists\" ng-class=\"{ visible: $ctrl.visible }\"\u003E\u003Cspan\u003EWe use cookies. \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"privacy-policy\" ng-click=\"$ctrl.acknowledge()\"\u003EWhy?\u003C\u002Fa\u003E\u003Cbutton class=\"button button-fill button-primary button-acknowledge-policy\" type=\"button\" ng-click=\"$ctrl.acknowledge()\"\u003EOk\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "WGcY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"selected-date-range":"selected-date-range","selected-date":"selected-date","selected-date-delimiter":"selected-date-delimiter"};

/***/ }),

/***/ "WITs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_35-48eb02a3fc1e4bd6.svg";

/***/ }),

/***/ "WWu0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_30-19ece56e6d42ac11.svg";

/***/ }),

/***/ "WXo7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-side-bar":"calendar-side-bar","side-bar-overlay":"side-bar-overlay","side-bar-content":"side-bar-content","visible":"visible"};

/***/ }),

/***/ "WaEV":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @namespace Chart
 */
var Chart = __webpack_require__("+ItH")();

Chart.helpers = __webpack_require__("iO9N");

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
__webpack_require__("lG75")(Chart);

Chart.defaults = __webpack_require__("k7DW");
Chart.Element = __webpack_require__("wGD1");
Chart.elements = __webpack_require__("L5rj");
Chart.Interaction = __webpack_require__("KC8c");
Chart.platform = __webpack_require__("2xI1");

__webpack_require__("4Uxm")(Chart);
__webpack_require__("6rMk")(Chart);
__webpack_require__("ghsk")(Chart);
__webpack_require__("oQMP")(Chart);
__webpack_require__("hAmm")(Chart);
__webpack_require__("jJ84")(Chart);
__webpack_require__("VRu6")(Chart);
__webpack_require__("/jKm")(Chart);

__webpack_require__("QV34")(Chart);
__webpack_require__("40fB")(Chart);
__webpack_require__("XhZS")(Chart);
__webpack_require__("1Nt4")(Chart);
__webpack_require__("sFo6")(Chart);
__webpack_require__("Db81")(Chart);

// Controllers must be loaded after elements
// See Chart.core.datasetController.dataElementType
__webpack_require__("GBuA")(Chart);
__webpack_require__("19SQ")(Chart);
__webpack_require__("sFj2")(Chart);
__webpack_require__("8uqi")(Chart);
__webpack_require__("Fv8P")(Chart);
__webpack_require__("2ddL")(Chart);
__webpack_require__("mC8W")(Chart);

__webpack_require__("vvdA")(Chart);
__webpack_require__("wPWQ")(Chart);
__webpack_require__("mg6x")(Chart);
__webpack_require__("0gJx")(Chart);
__webpack_require__("gCP2")(Chart);
__webpack_require__("0C1O")(Chart);
__webpack_require__("GqGk")(Chart);

// Loading built-it plugins
var plugins = [];

plugins.push(
	__webpack_require__("A5K1")(Chart),
	__webpack_require__("ZmvM")(Chart),
	__webpack_require__("lRs/")(Chart)
);

Chart.plugins.register(plugins);

Chart.platform.initialize();

module.exports = Chart;
if (typeof window !== 'undefined') {
	window.Chart = Chart;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
Chart.canvasHelpers = Chart.helpers.canvas;


/***/ }),

/***/ "WdxZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-upgrade-to-collaborate-7515ae14f2865789.svg";

/***/ }),

/***/ "Wl94":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Running-9c45e57eae2e1c19.svg";

/***/ }),

/***/ "WnJf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"user-image":"user-image","image-default":"image-default","user-initials":"user-initials"};

/***/ }),

/***/ "Wp8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__async_directive__ = __webpack_require__("+9MD");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.async', []).directive(__WEBPACK_IMPORTED_MODULE_1__async_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__async_directive__["a" /* default */]));

/***/ }),

/***/ "X5OD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X69l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_reset_style_sass__ = __webpack_require__("2Z8G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_reset_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__forgot_password_reset_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forgot_password_reset_tpl_pug__ = __webpack_require__("qkz2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forgot_password_reset_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__forgot_password_reset_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var ForgotPasswordResetController = function () {
    ForgotPasswordResetController.$inject = ['$state', '$stateParams', 'resetPasswordService'];

    /* @ngInject */
    function ForgotPasswordResetController($state, $stateParams, resetPasswordService) {
        _classCallCheck(this, ForgotPasswordResetController);

        this.$state = $state;
        this.resetPasswordService = resetPasswordService;

        this.token = $stateParams.token || null;
    }

    _createClass(ForgotPasswordResetController, [{
        key: 'resetPassword',
        value: function resetPassword(password) {
            var _this = this;

            return this.resetPasswordService.reset(this.token, password).then(function () {
                _this.$state.go('identity.sign-in');
            }, function (result) {
                _this.error = Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to reset your password.');
            });
        }
    }]);

    return ForgotPasswordResetController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAForgotPasswordReset',
    template: __WEBPACK_IMPORTED_MODULE_2__forgot_password_reset_tpl_pug___default()(),
    controller: ForgotPasswordResetController
});

/***/ }),

/***/ "XDLl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__collaborator_invite_modal_style_sass__ = __webpack_require__("eS9E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__collaborator_invite_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__collaborator_invite_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collaborator_invite_modal_tpl_pug__ = __webpack_require__("go0+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collaborator_invite_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__collaborator_invite_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CollaboratorInviteModalController = function () {
    function CollaboratorInviteModalController() {
        _classCallCheck(this, CollaboratorInviteModalController);
    }

    _createClass(CollaboratorInviteModalController, [{
        key: '$onInit',
        value: function $onInit() {
            this.email = null;
            this.emails = this.emails || [];
        }
    }, {
        key: 'invite',
        value: function invite() {
            return this.onClose({
                data: this.email
            });
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            return this.onDismiss();
        }
    }]);

    return CollaboratorInviteModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACollaboratorInviteModal',
    template: __WEBPACK_IMPORTED_MODULE_1__collaborator_invite_modal_tpl_pug___default()(),
    controller: CollaboratorInviteModalController,
    bindings: {
        emails: '<',
        user: '<',
        onDismiss: '&',
        onClose: '&'
    }
});

/***/ }),

/***/ "XHSq":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-select-default-modal modal-fixed-height\"\u003E\u003Cdiv class=\"modal-header modal-section\"\u003E\u003Cdiv class=\"modal-title\"\u003ESelect default calendar\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter\"\u003E\u003Cdiv class=\"select-default-description modal-section modal-delimiter\"\u003EAll your other calendars will be kept in view-only mode until subscription renewal.\u003C\u002Fdiv\u003E\u003Cdiv class=\"team-items\"\u003E\u003Cdiv class=\"team-item\" ng-repeat=\"team in $ctrl.teams track by $index\"\u003E\u003Cdiv class=\"team-name modal-section\" ng-bind=\"team.name\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-items\"\u003E\u003Cdb-a-calendar-radio class=\"calendar-select-item modal-section\" ng-repeat=\"calendar in team.calendars track by $index\" name=\"calendar.name\" selected=\"$ctrl.selected === calendar\" ng-click=\"$ctrl.select(calendar)\"\u003E\u003C\u002Fdb-a-calendar-radio\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-modal-left button-close-modal\" ng-click=\"$ctrl.dismiss()\"\u003EClose\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-select-calendar\" ng-click=\"$ctrl.markAsDone()\" ng-disabled=\"!$ctrl.selected\"\u003EKeep this\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "XPuf":
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__("7Mjc"),
    isIterateeCall = __webpack_require__("zBOP"),
    toFinite = __webpack_require__("sBat");

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * **Note:** If `lower` is greater than `upper`, the values are swapped.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * // when lower is greater than upper the values are swapped
 * _.random(5, 0);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(-5);
 * // => an integer between -5 and 0
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return baseRandom(lower, upper);
}

module.exports = random;


/***/ }),

/***/ "XRqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_day_event_style_sass__ = __webpack_require__("boTu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_day_event_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__calendar_day_event_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_day_event_tpl_pug__ = __webpack_require__("HXEu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_day_event_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_day_event_tpl_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image_icon_image_svg__ = __webpack_require__("cxal");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image_icon_image_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__image_icon_image_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var CalendarDayEventController = function () {
    CalendarDayEventController.$inject = ['eventUtil', '$element', '$timeout', '$window'];

    /* @ngInject */
    function CalendarDayEventController(eventUtil, $element, $timeout, $window) {
        _classCallCheck(this, CalendarDayEventController);

        this.eventUtil = eventUtil;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$window = $window;
        this.receiptIconUrl = 'url(' + __WEBPACK_IMPORTED_MODULE_2__image_icon_image_svg___default.a + ')';
        this.detailTooltip = null;
        this.tooltipUpdatePromise = null;
        this.receiptPreviewElement = null;
    }

    _createClass(CalendarDayEventController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.confirmed || changeObject.category) {
                this.backgroundColor = this.confirmed && this.category ? this.category.color : null;
            }
            if (changeObject.type || changeObject.value || changeObject.note || changeObject.category || changeObject.details || changeObject.repeat || changeObject.receiptUrl) {
                this.actualValue = this.eventUtil.getValue(this.type, this.value);
                this.mainLabel = this.note || this.category && this.category.name || (this.type === 'income' ? 'income' : 'expense');
                this.detailNote = this.details && this.details.trim() ? this.details : null;
                this.receiptPreviewVisible = false;
                this.scheduleDetailTooltipUpdate();
            }
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            this.scheduleDetailTooltipUpdate();
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            if (this.tooltipUpdatePromise) {
                this.$timeout.cancel(this.tooltipUpdatePromise);
                this.tooltipUpdatePromise = null;
            }

            this.hideReceiptPreview();
        }
    }, {
        key: 'scheduleDetailTooltipUpdate',
        value: function scheduleDetailTooltipUpdate() {
            var _this = this;

            if (this.tooltipUpdatePromise) {
                this.$timeout.cancel(this.tooltipUpdatePromise);
            }
            this.tooltipUpdatePromise = this.$timeout(function () {
                _this.tooltipUpdatePromise = null;
                _this.updateDetailTooltip();
            });
        }
    }, {
        key: 'updateDetailTooltip',
        value: function updateDetailTooltip() {
            if (!this.detailNote) {
                this.detailTooltip = null;
                return;
            }
            var detailElement = this.$element[0].querySelector('.day-event-detail');
            var isTruncated = detailElement && detailElement.scrollWidth > detailElement.clientWidth;
            this.detailTooltip = isTruncated ? this.detailNote : null;
        }
    }, {
        key: 'showReceiptPreview',
        value: function showReceiptPreview(event) {
            if (!this.receiptUrl || !event || !event.currentTarget) {
                return;
            }

            this.hideReceiptPreview();

            var previewElement = this.$window.document.createElement('div');
            previewElement.className = 'calendar-day-event-receipt-hover-preview';

            var imageElement = this.$window.document.createElement('img');
            imageElement.className = 'calendar-day-event-receipt-hover-preview-image';
            imageElement.src = this.receiptUrl;
            imageElement.alt = 'Receipt preview';

            previewElement.appendChild(imageElement);
            this.$window.document.body.appendChild(previewElement);
            this.receiptPreviewElement = previewElement;

            this.positionReceiptPreview(event.currentTarget);
        }
    }, {
        key: 'hideReceiptPreview',
        value: function hideReceiptPreview() {
            if (this.receiptPreviewElement && this.receiptPreviewElement.parentNode) {
                this.receiptPreviewElement.parentNode.removeChild(this.receiptPreviewElement);
            }

            this.receiptPreviewElement = null;
        }
    }, {
        key: 'positionReceiptPreview',
        value: function positionReceiptPreview(target) {
            if (!this.receiptPreviewElement || !target || !target.getBoundingClientRect) {
                return;
            }

            var previewSize = 240;
            var previewPadding = 4;
            var previewWidth = previewSize + previewPadding * 2;
            var previewHeight = previewSize + previewPadding * 2;
            var spacing = 8;
            var viewportMargin = 8;

            var targetRect = target.getBoundingClientRect();
            var viewportWidth = this.$window.innerWidth || 0;
            var viewportHeight = this.$window.innerHeight || 0;

            var left = targetRect.left + targetRect.width / 2 - previewWidth / 2;
            left = Math.max(viewportMargin, Math.min(left, viewportWidth - previewWidth - viewportMargin));

            var top = targetRect.top - previewHeight - spacing;

            if (top < viewportMargin) {
                top = targetRect.bottom + spacing;
            }

            if (top + previewHeight > viewportHeight - viewportMargin) {
                top = Math.max(viewportMargin, viewportHeight - previewHeight - viewportMargin);
            }

            this.receiptPreviewElement.style.left = left + 'px';
            this.receiptPreviewElement.style.top = top + 'px';
        }
    }]);

    return CalendarDayEventController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarDayEvent',
    template: __WEBPACK_IMPORTED_MODULE_1__calendar_day_event_tpl_pug___default()(),
    controller: CalendarDayEventController,
    bindings: {
        type: '<',
        confirmed: '<',
        category: '<',
        note: '<',
        details: '<',
        value: '<',
        repeat: '<',
        receiptUrl: '<',
        useCategoryIcons: '<'
    }
});

/***/ }),

/***/ "XeE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_with_period_cmpt__ = __webpack_require__("GqWm");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.dashboard.component.card-with-period', []).component(__WEBPACK_IMPORTED_MODULE_1__card_with_period_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__card_with_period_cmpt__["a" /* default */]));

/***/ }),

/***/ "XhZS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var helpers = __webpack_require__("iO9N");
var Ticks = __webpack_require__("IbXy");

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',
		ticks: {
			callback: Ticks.formatters.linear
		}
	};

	var LinearScale = Chart.LinearScaleBase.extend({

		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;

			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// First Calculate the range
			me.min = null;
			me.max = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}

					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;

							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers.min(values);
					var maxVal = helpers.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}

			me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var maxTicks;
			var me = this;
			var tickOpts = me.options.ticks;

			if (me.isHorizontal()) {
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
			} else {
				// The factor of 2 used to scale the font size has been experimentally determined.
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
			}

			return maxTicks;
		},
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;

			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;

			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
				return Math.round(pixel);
			}

			pixel = me.bottom - (me.height / range * (rightValue - start));
			return Math.round(pixel);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});
	Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);

};


/***/ }),

/***/ "Xk/h":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdb-a-dashboard-card class=\"card-with-year-picker\" ng-attr-data-name=\"{{ ::$ctrl.name }}\"\u003E\u003Ccard-date\u003E\u003Cdiv class=\"card-year-picker\"\u003E\u003Cbutton class=\"button button-icon button-select-previous-year\" ng-click=\"$ctrl.selectPreviousYear()\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"year-selected\" ng-bind=\"$ctrl.year\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-icon button-select-next-year\" ng-click=\"$ctrl.selectNextYear()\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fcard-date\u003E\u003Ccard-content ng-transclude\u003E\u003C\u002Fcard-content\u003E\u003C\u002Fdb-a-dashboard-card\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "Xn7U":
/***/ (function(module, exports, __webpack_require__) {

var int = __webpack_require__("/hmp");

function Num(num, prec) {
    if (!(this instanceof Num)) {
        return new Num(num, prec);
    }

    var self = this;
    if (num instanceof Num) {
        self._int = int(num._int);
        self._precision = num._precision;
        return self;
    }

    var precision = 0;

    num = num || 0;
    // convert to a string
    num = '' + num;

    var idx_e = num.indexOf('e');
    if (idx_e > 0) {
        var exp = num.slice(idx_e + 1)
        num = num.slice(0, idx_e)
        precision = -exp;
    }

    // find Num point
    var dec = num.indexOf('.');

    if (dec >= 0) {
        // take out the Num point
        num = num.replace('.', '');
        precision = precision + num.length - dec;
    }

    self._int = int(num);
    self._precision = prec || precision;
    self._nan = self._int._nan;
}

// TODO (shtylman) cleanup
Num.prototype.toString = function() {
    var self = this;

    if (self._nan) {
        return NaN;
    }

    var num_str = self._int.toString();

    // 0 precision, just return the int
    if (self._precision <= 0) {
        return num_str;
    }

    // if number is negative, store that and make it positive
    var neg = false;
    if (num_str.charAt(0) === '-') {
        // negative
        neg = true;
        num_str = num_str.slice(1);
    }

    // find index where to add the decimal point
    var idx = num_str.length - self._precision;

    // insert the proper number of 0s after the .
    if(idx < 0) {
        var zeros = new Array(-idx + 1).join('0');
        idx = 0;
    } else {
        var zeros = '';
    }

    // make sure there's always a number before the .
    var before_dot = idx > 0 ? num_str.slice(0, idx) : '0';

    return (neg ? '-' : '') + before_dot + '.' + zeros + num_str.slice(idx);
};

Num.prototype.valueOf = Num.prototype.toString;
Num.prototype.toJSON = Num.prototype.toString;

/// return {int} the precision
Num.prototype.get_precision = function() {
    return this._precision;
};

/// setting precision to < current precision will floor, NOT round
/// modifies this object
Num.prototype.set_precision = function(precision) {
    var self = this;
    var precision_diff = precision - self._precision;

    if (precision_diff > 0) {
        self._int = self._int.mul(int(10).pow(precision_diff));
    }
    else if(precision_diff < 0) {
        self._int = self._int.div(int(10).pow(-precision_diff));
    }

    self._precision += precision_diff;
    return self;
};

/// returns a copy
Num.prototype.round = function(precision) {
    var copy = Num(this);

    if (precision >= copy._precision) {
        return copy;
    }

    var num_str = copy._int.toString();

    // the index to check for rounding
    var idx = num_str.length - copy._precision + precision;

    // the number to check for rounding
    var n = num_str[idx] - 0;

    var neg = num_str[0] === '-';

    copy.set_precision(precision);

    if ((neg && n < 5) || (!neg && n >= 5)) {
        copy._int = copy._int.add(1);
    }

    return copy;
};

/// returns new Num, -this
Num.prototype.neg = function() {
    return new Num(this._int.neg(), this._precision);
};

/// returns new Num, absolute value of this
Num.prototype.abs = function() {
    return new Num(this._int.abs(), this._precision);
};

/// returns a + b
/// a, b can each be either a Num, String, or Number
/// will return a new Num with the greatest precision of the operands
Num.add = function(a, b) {
    a = ensure_num(a);
    b = ensure_num(b);

    var precision = Math.max(a._precision, b._precision);
    var a = Num(a);
    a.set_precision(precision);
    var b = Num(b);
    b.set_precision(precision);

    // the integer result
    var num_res = a._int.add(b._int);

    return new Num(num_res, precision);
};

/// returns a - b
/// a, b can each be either a Num, String, or Number
/// will return a new Num with the greatest precision of the operands
Num.sub = function(a, b) {
    b = Num(b); // convert/copy before modifying
    b._int = b._int.neg(); // negate
    return Num.add(a, b);
};

/// returns a * b
/// a, b can each be either a Num, String, or Number
/// will return a new Num with precision = a.precision + b.precision
Num.mul = function(a, b) {
    a = ensure_num(a);
    b = ensure_num(b);
    return new Num(a._int.mul(b._int), a._precision + b._precision);
};

Num.div = function(a, b) {
    a = ensure_num(a);
    b = ensure_num(b);

    var a_int = a._int;

    var precision = b._precision;
    for (var i=0 ; i<precision ; ++i) {
        a_int = a_int.mul(10);
    }

    return Num(a_int.div(b._int), a._precision);
};

Num.mod = function(a, b) {
    a = ensure_num(a);
    b = ensure_num(b);

    var prec_a = a._precision;
    var prec_b = b._precision;
    var a = a._int;
    var b = b._int;

    while (prec_a < prec_b) {
        a = a.mul(10);
        prec_a += 1;
    }

    while (prec_b < prec_a) {
        b = b.mul(10);
        prec_b += 1;
    }

    return Num(a.mod(b), prec_a);
};

/// returns < 0 if a < b, 0 if a == b, > 0 if a > b
Num.cmp = function(a, b) {

    // make copies cause we modify precision
    var a = Num(a);
    var b = Num(b);

    if (a._int._s != b._int._s) {
        return a._int._s ? -1 : 1;
    }

    // normalize the two numbers
    var precision = Math.max(a._precision, b._precision);
    a.set_precision(precision);
    b.set_precision(precision);

    return a._int.cmp(b._int);
};

Num.eq = function(a, b) {
    return Num.cmp(a, b) === 0;
};

Num.gt = function(a, b) {
    return Num.cmp(a, b) > 0;
};

Num.gte = function(a, b) {
    return Num.cmp(a, b) >= 0;
};

Num.lt = function(a, b) {
    return Num.cmp(a, b) < 0;
};

Num.lte = function(a, b) {
    return Num.cmp(a, b) <= 0;
};

// add all the static methods in Num to Num's prototype
(function() {
    function add_method(name) {
        Num.prototype[name] = function(b) {
            return Num[name](this, b);
        }
    }

    for(var i in Num) {
        add_method(i);
    }
})();

/// box the value into a Num if it isn't
function ensure_num(val) {
    if (val instanceof Num) {
        return val;
    }

    return Num(val);
}

module.exports = Num;


/***/ }),

/***/ "Xnak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_submit__ = __webpack_require__("kX2h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__async__ = __webpack_require__("Wp8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__custom_error__ = __webpack_require__("mE2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compile_component__ = __webpack_require__("qe5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scroll_container__ = __webpack_require__("JBwk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scroll_into_view__ = __webpack_require__("tOBf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__autofocus__ = __webpack_require__("lgK8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blacklist__ = __webpack_require__("8rSt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__number_only__ = __webpack_require__("R04K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__on_focus__ = __webpack_require__("bb60");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__on_blur__ = __webpack_require__("Jww3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__process_key__ = __webpack_require__("Q+mV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__match__ = __webpack_require__("0Urw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__capture_keys__ = __webpack_require__("cx4P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__blur__ = __webpack_require__("Tgva");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__outside_click__ = __webpack_require__("8HTB");



















/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive', [__WEBPACK_IMPORTED_MODULE_1__form_submit__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__async__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__custom_error__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__compile_component__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__scroll_container__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__scroll_into_view__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__autofocus__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__blacklist__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__number_only__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__on_focus__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__on_blur__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__process_key__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_13__match__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__capture_keys__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_15__blur__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_16__outside_click__["a" /* default */].name]));

/***/ }),

/***/ "Xp6K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ProcessKeyDirective;
var selector = 'dbAProcessKey';

/* @ngInject */
function ProcessKeyDirective() {
    return {
        restrict: 'A',
        scope: {
            callback: '&' + selector
        },

        link: function link(scope, element) {
            element.on('keydown', keypressHandler);
            scope.$on('$destroy', function () {
                return element.off('keydown', keypressHandler);
            });

            function keypressHandler(event) {
                var value = scope.callback({
                    code: event.which == null ? event.keyCode : event.which
                });

                scope.$applyAsync();

                if (!value) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                return value;
            }
        }
    };
}

/***/ }),

/***/ "XzH4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = isCategoryTransfer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isCategoryBalanceUpdate;
/* harmony export (immutable) */ __webpack_exports__["d"] = isCategoryOther;
/* harmony export (immutable) */ __webpack_exports__["c"] = isCategoryListable;
/* harmony export (immutable) */ __webpack_exports__["a"] = categoryHasTerms;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search_util_js__ = __webpack_require__("Vihm");





function isCategoryTransfer(category) {
    return category && category.transfer;
}

function isCategoryBalanceUpdate(category) {
    return category && category.balanceUpdate;
}

function isCategoryOther(category) {
    return category && category.other;
}

function isCategoryListable(category) {
    return !isCategoryTransfer(category) && !isCategoryBalanceUpdate(category);
}

function categoryHasTerms(category, terms) {
    return !__WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(terms, function (term) {
        return !Object(__WEBPACK_IMPORTED_MODULE_1__search_util_js__["b" /* valueContainsTerm */])(category.name, term);
    });
}

/***/ }),

/***/ "Y/tY":
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var cssKeywords = __webpack_require__("jhJr");

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),

/***/ "Y2h6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_style_sass__ = __webpack_require__("hTxh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__checkbox_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkbox_tpl_pug__ = __webpack_require__("k5Qk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkbox_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__checkbox_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACheckbox',
    template: __WEBPACK_IMPORTED_MODULE_1__checkbox_tpl_pug___default()(),
    bindings: {
        selected: '<'
    }
});

/***/ }),

/***/ "Y4Fx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_cmpt__ = __webpack_require__("KsWd");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.dashboard.component.card', []).component(__WEBPACK_IMPORTED_MODULE_1__card_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__card_cmpt__["a" /* default */]));

/***/ }),

/***/ "YARn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__already_subscribed_notification_cmpt__ = __webpack_require__("/yyt");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.notifications.component.already-subscribed-notification', []).component(__WEBPACK_IMPORTED_MODULE_1__already_subscribed_notification_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__already_subscribed_notification_cmpt__["a" /* default */]));

/***/ }),

/***/ "YB0b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryHealth-f328892d6d883fb3.svg";

/***/ }),

/***/ "YEIi":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"team-list\"\u003E\u003Cdiv class=\"team-items\" ng-sortable=\"$ctrl.sortableOptions\" ng-class=\"{ sorting: $ctrl.sorting }\"\u003E\u003Cdiv class=\"team-item\" ng-repeat=\"team in $ctrl.teams track by team.id\" ng-class=\"{ active: $ctrl.isActive(team) }\" ng-click=\"$ctrl.select(team)\"\u003E\u003Ci class=\"drag-handle icon-dollarbird-grip\" ng-if=\"$ctrl.teams.length &gt; 1\"\u003E\u003C\u002Fi\u003E\u003Cdb-a-radio class=\"team-state\" selected=\"$ctrl.isActive(team)\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"team-content\"\u003E\u003Cdiv class=\"team-name\" ng-bind=\"team.name\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team-owner\" ng-bind=\"team.owner.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team-add-container\"\u003E\u003Cbutton class=\"link link-add-team\" ng-click=\"$ctrl.add()\"\u003EAdd calendar group\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "YUSk":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"card\"\u003E\u003Cdiv class=\"card-heading\"\u003E\u003Cdiv class=\"card-title\" ng-bind=\"$ctrl.name\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"card-date\" ng-transclude=\"date\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"card-content\" ng-transclude=\"content\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "YlQy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_message_cmpt__ = __webpack_require__("kmJ5");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.validation-message', []).component(__WEBPACK_IMPORTED_MODULE_1__validation_message_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__validation_message_cmpt__["a" /* default */]));

/***/ }),

/***/ "YwHZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Wrench-69bb56c7a8d91d6c.svg";

/***/ }),

/***/ "Z/ov":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EmailIngestTokenService = function () {
    EmailIngestTokenService.$inject = ['apiService'];

    /* @ngInject */
    function EmailIngestTokenService(apiService) {
        _classCallCheck(this, EmailIngestTokenService);

        this.apiService = apiService;
    }

    _createClass(EmailIngestTokenService, [{
        key: 'getAll',
        value: function getAll() {
            var _this = this;

            return this.apiService.get('/email-ingest-tokens').then(function (result) {
                return _this.extractTokens(result.data);
            });
        }
    }, {
        key: 'create',
        value: function create(teamId) {
            return this.apiService.post('/email-ingest-tokens', {
                teamId: teamId
            }).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'remove',
        value: function remove(id) {
            return this.apiService.delete('/email-ingest-tokens/' + id).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'getActiveByTeamId',
        value: function getActiveByTeamId(teamId) {
            var _this2 = this;

            return this.getAll().then(function (tokens) {
                return __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(tokens || [], function (token) {
                    var tokenTeamId = _this2.getTokenTeamId(token);

                    return token && '' + tokenTeamId === '' + teamId && _this2.isTokenActive(token);
                }) || null;
            });
        }
    }, {
        key: 'extractTokens',
        value: function extractTokens(payload) {
            if (Array.isArray(payload)) {
                return payload;
            }

            if (payload && Array.isArray(payload.items)) {
                return payload.items;
            }

            if (payload && Array.isArray(payload.data)) {
                return payload.data;
            }

            return [];
        }
    }, {
        key: 'getTokenTeamId',
        value: function getTokenTeamId(token) {
            if (!token) {
                return null;
            }

            if (token.teamId != null) {
                return token.teamId;
            }

            if (token.team_id != null) {
                return token.team_id;
            }

            if (token.team && token.team.id != null) {
                return token.team.id;
            }

            return null;
        }
    }, {
        key: 'isTokenActive',
        value: function isTokenActive(token) {
            if (!token) {
                return false;
            }

            if (token.isActive != null) {
                return !!token.isActive;
            }

            if (token.is_active != null) {
                return !!token.is_active;
            }

            if (token.active != null) {
                return !!token.active;
            }

            return true;
        }
    }]);

    return EmailIngestTokenService;
}();

/* harmony default export */ __webpack_exports__["a"] = (EmailIngestTokenService);

/***/ }),

/***/ "ZGK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notification_style_sass__ = __webpack_require__("vymh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notification_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__notification_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_tpl_pug__ = __webpack_require__("JM0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__notification_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbANotification',
    template: __WEBPACK_IMPORTED_MODULE_1__notification_tpl_pug___default()(),
    transclude: {
        title: 'notificationTitle',
        content: 'notificationContent'
    },
    bindings: {
        imageUrl: '<'
    }
});

/***/ }),

/***/ "ZNTm":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category-chart\"\u003E\u003Cdiv class=\"chart-container\" ng-style=\"{ height: $ctrl.height }\"\u003E\u003Cdiv class=\"chart-error\" ng-bind=\"$ctrl.error\"\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-selected-date-range class=\"chart-selected-period\" start=\"$ctrl.start\" end=\"$ctrl.end\"\u003E\u003C\u002Fdb-a-selected-date-range\u003E\u003Cdb-a-chart class=\"chart-content\" type=\"horizontalBar\" options=\"$ctrl.options\" data=\"$ctrl.data\" ng-class=\"{ visible: !$ctrl.loading }\" ng-if=\"!$ctrl.error\"\u003E\u003C\u002Fdb-a-chart\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "ZRrD":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"email-ingest-token-modal modal-fixed-height\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\"\u003EEmail to transaction\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter modal-section\"\u003E\u003Cdiv class=\"email-ingest-intro\"\u003EYou can forward receipts, invoices or other transactional emails to your unique Dollarbird address and we automatically create transactions for you from those emails.\u003C\u002Fdiv\u003E\u003Cdiv class=\"email-ingest-intro email-ingest-intro-secondary\"\u003EThis email address will be associated with the current calendar group, \"{{ $ctrl.teamName }}\". You can set up additional email addresses for your other groups.\u003C\u002Fdiv\u003E\u003Cdiv class=\"email-ingest-label\"\u003EYour own inbox email address:\u003C\u002Fdiv\u003E\u003Cdiv class=\"email-ingest-content\" ng-if=\"!$ctrl.loading\"\u003E\u003Cdiv class=\"email-ingest-enable\" ng-if=\"!$ctrl.token\"\u003E\u003Cbutton class=\"button button-fill button-primary\" type=\"button\" ng-click=\"$ctrl.enable()\"\u003EEnable your inbound address\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"email-ingest-token\" ng-if=\"$ctrl.token\"\u003E\u003Cdiv class=\"email-ingest-address\" ng-bind=\"$ctrl.getAddress()\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-fill button-secondary\" type=\"button\" ng-click=\"$ctrl.copyAddress()\"\u003ECopy email address\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-danger button-modal-left\" type=\"button\" ng-if=\"$ctrl.token\" ng-click=\"$ctrl.remove()\"\u003EDelete email address\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "ZVbr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AutoCategoryService = function () {
    AutoCategoryService.$inject = ['$q', 'categoryService', 'monitoringCategorizationService'];

    /* @ngInject */
    function AutoCategoryService($q, categoryService, monitoringCategorizationService) {
        _classCallCheck(this, AutoCategoryService);

        this.$q = $q;
        this.categoryService = categoryService;
        this.monitoringCategorizationService = monitoringCategorizationService;

        this.reset();
    }

    _createClass(AutoCategoryService, [{
        key: 'reset',
        value: function reset() {
            this.map = {};
        }
    }, {
        key: 'initialize',
        value: function initialize(teamId, map) {
            this.map[teamId] = map || {};
        }
    }, {
        key: 'get',
        value: function get(teamId, note) {
            this.map[teamId] = this.map[teamId] || {};
            var categoryId = this.map[teamId][note];

            return categoryId ? this.$q.resolve(categoryId) : this.$q.reject();
        }
    }, {
        key: 'guess',
        value: function guess(teamId, note) {
            var _this = this;

            return this.categoryService.getAll(teamId).then(function (categories) {
                var teamCategories = _this.buildTeamCategories(categories);
                var labelCategoryMap = _this.buildLabelCategoryMap(teamId);

                return _this.monitoringCategorizationService.categorizeLabel(note, teamCategories, labelCategoryMap).then(function (result) {
                    if (!result || typeof result.categoryId !== 'number') {
                        return _this.$q.reject();
                    }

                    if (result.categoryId === -1) {
                        return _this.$q.reject();
                    }

                    var category = __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(categories || [], function (item) {
                        return '' + item.id === '' + result.categoryId;
                    });

                    return category ? category : _this.$q.reject();
                });
            });
        }
    }, {
        key: 'add',
        value: function add(teamId, categoryId, note) {
            this.map[teamId] = this.map[teamId] || {};
            this.map[teamId][note] = categoryId;
        }
    }, {
        key: 'remove',
        value: function remove(note) {
            delete this.map[note];
        }
    }, {
        key: 'buildTeamCategories',
        value: function buildTeamCategories(categories) {
            return (categories || []).map(function (category) {
                return {
                    id: category.id,
                    name: category.name,
                    iconName: category.iconName || null,
                    iconIndex: category.iconIndex || null,
                    type: category.type || 'regular',
                    color: category.color,
                    isOther: !!category.other,
                    weeklyLimit: category.weeklyLimit == null ? null : category.weeklyLimit,
                    monthlyLimit: category.monthlyLimit == null ? null : category.monthlyLimit
                };
            });
        }
    }, {
        key: 'buildLabelCategoryMap',
        value: function buildLabelCategoryMap(teamId) {
            var _this2 = this;

            var map = this.map[teamId] || {};
            var grouped = {};

            Object.keys(map).forEach(function (label) {
                var normalizedLabel = _this2.normalizeLabel(label);
                var categoryId = map[label];

                if (!normalizedLabel) {
                    return;
                }

                if (categoryId == null) {
                    return;
                }

                if (!grouped[categoryId]) {
                    grouped[categoryId] = [];
                }

                if (!grouped[categoryId].includes(normalizedLabel)) {
                    grouped[categoryId].push(normalizedLabel);
                }
            });

            return Object.keys(grouped).map(function (categoryId) {
                return {
                    categoryId: +categoryId,
                    labels: grouped[categoryId]
                };
            });
        }
    }, {
        key: 'normalizeLabel',
        value: function normalizeLabel(label) {
            return String(label || '').trim().toLowerCase();
        }
    }]);

    return AutoCategoryService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AutoCategoryService);

/***/ }),

/***/ "ZZNS":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

module.exports = join;


/***/ }),

/***/ "ZdTG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sign_in_style_sass__ = __webpack_require__("3p9A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sign_in_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sign_in_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sign_in_tpl_pug__ = __webpack_require__("/O72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sign_in_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sign_in_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var SignInController = function () {
    SignInController.$inject = ['$state', '$stateParams', 'sessionService', 'navigationService', 'appStartCacheService', 'storageService', 'notificationService', 'diagnosticsService'];

    /* @ngInject */
    function SignInController($state, $stateParams, sessionService, navigationService, appStartCacheService, storageService, notificationService, diagnosticsService) {
        _classCallCheck(this, SignInController);

        this.$state = $state;
        this.sessionService = sessionService;
        this.navigationService = navigationService;
        this.appStartCacheService = appStartCacheService;
        this.notificationService = notificationService;
        this.diagnosticsService = diagnosticsService;

        this.error = $stateParams.error || null;
        this.redirect = $stateParams.redirect || null;

        this.diagnosticsService.info('sign_in_page_init', {
            hasSessionUser: !!this.sessionService.user,
            stateName: this.$state.current && this.$state.current.name,
            hasErrorParam: !!this.error,
            hasRedirectParam: !!this.redirect
        });

        if (!this.sessionService.user) {
            this.appStartCacheService.clearAll();
            storageService.setUserPrefix(null);
            this.appStartCacheService.reset();
        }

        this.canSendDiagnostics = this.diagnosticsService.canSend();
    }

    _createClass(SignInController, [{
        key: 'signIn',
        value: function signIn(email, password) {
            var _this = this;

            return this.sessionService.signIn(email, password).then(function () {
                var _ref = _this.navigationService.getStateFromRedirectUrl(_this.redirect) || {},
                    state = _ref.state,
                    params = _ref.params;

                _this.$state.go(state || 'authorized.calendar', params || {});
            }, function (result) {
                var error = result.data && result.data.error === 'INVALID_GRANT' ? 'Incorrect email address or password.' : Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'Sorry, but we were not able to sign you in. Please try again later.');

                if (result.data && result.data.error === 'ACCOUNT_EXPIRED') {
                    _this.$state.go('identity.email-verification.request', {
                        error: error,
                        email: email
                    });

                    return;
                }

                _this.error = error;
            });
        }
    }, {
        key: 'sendDiagnostics',
        value: function sendDiagnostics() {
            var _this2 = this;

            if (this.sendingDiagnostics) {
                return;
            }

            this.sendingDiagnostics = true;

            return this.diagnosticsService.send({
                source: 'sign-in',
                identity: this.email || null,
                context: {
                    hasError: !!this.error
                }
            }).then(function (result) {
                var diagnosticsId = result && result.data && result.data.id;
                var message = diagnosticsId ? 'Diagnostics sent. ID: ' + diagnosticsId : 'Diagnostics sent. Thank you.';

                _this2.notificationService.showInfo(message, null, true, 6000);
            }).catch(function (result) {
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to send diagnostics. Please try again later.'));
            }).finally(function () {
                _this2.sendingDiagnostics = false;
            });
        }
    }]);

    return SignInController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbASignIn',
    template: __WEBPACK_IMPORTED_MODULE_2__sign_in_tpl_pug___default()(),
    controller: SignInController
});

/***/ }),

/***/ "ZiQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__radio_cmpt__ = __webpack_require__("UISt");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.radio', []).component(__WEBPACK_IMPORTED_MODULE_1__radio_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__radio_cmpt__["a" /* default */]));

/***/ }),

/***/ "ZieB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Paw-581428c046b6c5c6.svg";

/***/ }),

/***/ "ZmvM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");
var helpers = __webpack_require__("iO9N");

defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	},

	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');
		for (var i = 0; i < chart.data.datasets.length; i++) {
			text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
			if (chart.data.datasets[i].label) {
				text.push(chart.data.datasets[i].label);
			}
			text.push('</li>');
		}
		text.push('</ul>');
		return text.join('');
	}
});

module.exports = function(Chart) {

	var layout = Chart.layoutService;
	var noop = helpers.noop;

	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param labelopts {Object} the label options on the legend
	 * @param fontSize {Number} the label font size
	 * @return {Number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle ?
			fontSize * Math.SQRT2 :
			labelOpts.boxWidth;
	}

	Chart.Legend = Element.extend({

		initialize: function(config) {
			helpers.extend(this, config);

			// Contains hit boxes for each dataset (in dataset order)
			this.legendHitBoxes = [];

			// Are we in doughnut mode which has a different data type
			this.doughnutMode = false;
		},

		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type

		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;
		},
		afterUpdate: noop,

		//

		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,

		//

		beforeBuildLabels: noop,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];

			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}

			if (me.options.reverse) {
				legendItems.reverse();
			}

			me.legendItems = legendItems;
		},
		afterBuildLabels: noop,

		//

		beforeFit: noop,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;

			var ctx = me.ctx;

			var globalDefault = defaults.global;
			var valueOrDefault = helpers.valueOrDefault;
			var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
			var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
			var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
			var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];

			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();

			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}

			// Increase sizes here
			if (display) {
				ctx.font = labelFont;

				if (isHorizontal) {
					// Labels

					// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
					var lineWidths = me.lineWidths = [0];
					var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;

					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';

					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
							totalHeight += fontSize + (labelOpts.padding);
							lineWidths[lineWidths.length] = me.left;
						}

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: width,
							height: fontSize
						};

						lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
					});

					minSize.height += totalHeight;

				} else {
					var vPadding = labelOpts.padding;
					var columnWidths = me.columnWidths = [];
					var totalWidth = labelOpts.padding;
					var currentColWidth = 0;
					var currentColHeight = 0;
					var itemHeight = fontSize + vPadding;

					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						// If too tall, go to new column
						if (currentColHeight + itemHeight > minSize.height) {
							totalWidth += currentColWidth + labelOpts.padding;
							columnWidths.push(currentColWidth); // previous column width

							currentColWidth = 0;
							currentColHeight = 0;
						}

						// Get max width
						currentColWidth = Math.max(currentColWidth, itemWidth);
						currentColHeight += itemHeight;

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: itemWidth,
							height: fontSize
						};
					});

					totalWidth += currentColWidth;
					columnWidths.push(currentColWidth);
					minSize.width += totalWidth;
				}
			}

			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop,

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},

		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefault = defaults.global;
			var lineDefault = globalDefault.elements.line;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;

			if (opts.display) {
				var ctx = me.ctx;
				var valueOrDefault = helpers.valueOrDefault;
				var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
				var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
				var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
				var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
				var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
				var cursor;

				// Canvas setup
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
				ctx.lineWidth = 0.5;
				ctx.strokeStyle = fontColor; // for strikethrough effect
				ctx.fillStyle = fontColor; // render in correct colour
				ctx.font = labelFont;

				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var hitboxes = me.legendHitBoxes;

				// current position
				var drawLegendBox = function(x, y, legendItem) {
					if (isNaN(boxWidth) || boxWidth <= 0) {
						return;
					}

					// Set the ctx for the box
					ctx.save();

					ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
					ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
					ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
					ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
					ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
					ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
					var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);

					if (ctx.setLineDash) {
						// IE 9 and 10 do not support line dash
						ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
					}

					if (opts.labels && opts.labels.usePointStyle) {
						// Recalculate x and y for drawPoint() because its expecting
						// x and y to be center of figure (instead of top left)
						var radius = fontSize * Math.SQRT2 / 2;
						var offSet = radius / Math.SQRT2;
						var centerX = x + offSet;
						var centerY = y + offSet;

						// Draw pointStyle as legend symbol
						helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
					} else {
						// Draw box as legend symbol
						if (!isLineWidthZero) {
							ctx.strokeRect(x, y, boxWidth, fontSize);
						}
						ctx.fillRect(x, y, boxWidth, fontSize);
					}

					ctx.restore();
				};
				var fillText = function(x, y, legendItem, textWidth) {
					var halfFontSize = fontSize / 2;
					var xLeft = boxWidth + halfFontSize + x;
					var yMiddle = y + halfFontSize;

					ctx.fillText(legendItem.text, xLeft, yMiddle);

					if (legendItem.hidden) {
						// Strikethrough the text if hidden
						ctx.beginPath();
						ctx.lineWidth = 2;
						ctx.moveTo(xLeft, yMiddle);
						ctx.lineTo(xLeft + textWidth, yMiddle);
						ctx.stroke();
					}
				};

				// Horizontal
				var isHorizontal = me.isHorizontal();
				if (isHorizontal) {
					cursor = {
						x: me.left + ((legendWidth - lineWidths[0]) / 2),
						y: me.top + labelOpts.padding,
						line: 0
					};
				} else {
					cursor = {
						x: me.left + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				}

				var itemHeight = fontSize + labelOpts.padding;
				helpers.each(me.legendItems, function(legendItem, i) {
					var textWidth = ctx.measureText(legendItem.text).width;
					var width = boxWidth + (fontSize / 2) + textWidth;
					var x = cursor.x;
					var y = cursor.y;

					if (isHorizontal) {
						if (x + width >= legendWidth) {
							y = cursor.y += itemHeight;
							cursor.line++;
							x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
						}
					} else if (y + itemHeight > me.bottom) {
						x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
						y = cursor.y = me.top + labelOpts.padding;
						cursor.line++;
					}

					drawLegendBox(x, y, legendItem);

					hitboxes[i].left = x;
					hitboxes[i].top = y;

					// Fill the actual label
					fillText(x, y, legendItem, textWidth);

					if (isHorizontal) {
						cursor.x += width + (labelOpts.padding);
					} else {
						cursor.y += itemHeight;
					}

				});
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @return {Boolean} true if a change occured
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var changed = false;

			if (type === 'mousemove') {
				if (!opts.onHover) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}

			// Chart event already has relative position in it
			var x = e.x;
			var y = e.y;

			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				var lh = me.legendHitBoxes;
				for (var i = 0; i < lh.length; ++i) {
					var hitBox = lh[i];

					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						if (type === 'click') {
							// use e.native for backwards compatibility
							opts.onClick.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						} else if (type === 'mousemove') {
							// use e.native for backwards compatibility
							opts.onHover.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						}
					}
				}
			}

			return changed;
		}
	});

	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Chart.Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});

		layout.configure(chart, legend, legendOpts);
		layout.addBox(chart, legend);
		chart.legend = legend;
	}

	return {
		id: 'legend',

		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;

			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},

		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;

			if (legendOpts) {
				helpers.mergeIf(legendOpts, defaults.global.legend);

				if (legend) {
					layout.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				layout.removeBox(chart, legend);
				delete chart.legend;
			}
		},

		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
};


/***/ }),

/***/ "Zn4b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Property-1-Coffee-cup-1-959ef838af41833b.svg";

/***/ }),

/***/ "ZpKn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"checkmark":"checkmark","checkmark-content":"checkmark-content","checkmark-icon":"checkmark-icon","selected":"selected"};

/***/ }),

/***/ "ZxY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__switch_cmpt__ = __webpack_require__("rqO+");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.switch', []).component(__WEBPACK_IMPORTED_MODULE_1__switch_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__switch_cmpt__["a" /* default */]));

/***/ }),

/***/ "a6EW":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"checkmark\" ng-class=\"{ selected: $ctrl.selected }\" ng-style=\"{ borderColor: $ctrl.color }\" ng-click=\"$ctrl.toggle()\"\u003E\u003Cdiv class=\"checkmark-content\" ng-style=\"{ backgroundColor: $ctrl.color }\"\u003E\u003C\u002Fdiv\u003E\u003Ci class=\"checkmark-icon icon-dollarbird-checkmark\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "aKzM":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category-color-chart\"\u003E\u003Cdiv class=\"color-chart-item\" ng-repeat=\"entry in $ctrl.entries track by $index\" ng-style=\"{ backgroundColor: entry.color, width: entry.percent + '%' }\" ng-attr-title=\"{{ entry.label }}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "aLVB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"date-picker":"date-picker","dp-view-title":"dp-view-title","dp-month":"dp-month","dp-button-select-previous":"dp-button-select-previous","dp-button-select-next":"dp-button-select-next","dp-days":"dp-days","dp-day":"dp-day","dp-weekday-item":"dp-weekday-item","weekend":"weekend","dp-day-content":"dp-day-content","disabled":"disabled","dp-day-item":"dp-day-item","another":"another","today":"today","active":"active","highlighted":"highlighted","hidden":"hidden","first-highlighted":"first-highlighted","last-highlighted":"last-highlighted","dp-day-date":"dp-day-date"};

/***/ }),

/***/ "aPo/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__confirm_modal_cmpt__ = __webpack_require__("g/wL");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.confirm-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__confirm_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__confirm_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "aQK8":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-dashboard\"\u003E\u003Cdiv class=\"calendar-dashboard-content\"\u003E\u003Cdiv class=\"calendar-dashboard-section\"\u003E\u003Cdiv class=\"calendar-dashboard-section-content\"\u003E\u003Cdiv class=\"month-name\" ng-bind=\"$ctrl.monthName\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dashboard-types\"\u003E\u003Cdiv class=\"dashboard-type\" ng-class=\"{ active: !$ctrl.expenseSelected }\" ng-click=\"$ctrl.selectIncome()\"\u003E\u003Cdiv class=\"dashboard-type-name\"\u003EIncome\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"dashboard-type-value\" value=\"$ctrl.income\" limit=\"1000000\" pretty=\"true\" ng-if=\"$ctrl.isValueValid($ctrl.income)\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003Cdiv class=\"dashboard-type-value\" ng-hide=\"$ctrl.isValueValid($ctrl.income)\"\u003E-\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dashboard-type\" ng-class=\"{ active: $ctrl.expenseSelected }\" ng-click=\"$ctrl.selectExpense()\"\u003E\u003Cdiv class=\"dashboard-type-name\"\u003EExpense\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"dashboard-type-value\" value=\"$ctrl.expense\" limit=\"1000000\" pretty=\"true\" ng-if=\"$ctrl.isValueValid($ctrl.expense)\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003Cdiv class=\"dashboard-type-value\" ng-hide=\"$ctrl.isValueValid($ctrl.expense)\"\u003E-\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-category-color-chart class=\"category-color-chart\" entries=\"$ctrl.colors\"\u003E\u003C\u002Fdb-a-category-color-chart\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-dashboard-section calendar-dashboard-section-fill\"\u003E\u003Cdiv class=\"calendar-dashboard-section-content\"\u003E\u003Cdiv class=\"category-groups\" ng-show=\"$ctrl.groups.length &gt; 0\"\u003E\u003Cdb-a-category-group class=\"category-group-item\" ng-repeat=\"group in $ctrl.groups track by $index\" name=\"group.name\" color=\"group.color\" average=\"group.averagePastValue\" value=\"group.totalCurrentValue\" event-groups=\"group.eventGroups\" exceeded-text=\"$ctrl.exceeded\" saved-text=\"$ctrl.saved\"\u003E\u003C\u002Fdb-a-category-group\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state\" ng-hide=\"$ctrl.groups.length &gt; 0 || $ctrl.loading\"\u003E\u003Cdiv class=\"empty-state-content\"\u003E\u003Cimg" + (" class=\"empty-state-image\""+pug.attr("src", __webpack_require__("vx4v"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003Cdiv class=\"empty-state-title\"\u003ENo statistics yet\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state-message\"\u003EYou have no added transactions in {{ $ctrl.monthName }}. Start adding transactions to see an overview of your finances.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "aUVh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__team_radio_style_sass__ = __webpack_require__("5MVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__team_radio_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__team_radio_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__team_radio_tpl_pug__ = __webpack_require__("TgK+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__team_radio_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__team_radio_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbATeamRadio',
    template: __WEBPACK_IMPORTED_MODULE_1__team_radio_tpl_pug___default()(),
    bindings: {
        name: '<',
        selected: '<'
    }
});

/***/ }),

/***/ "ajDi":
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__("72Lu");

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}


/***/ }),

/***/ "apxD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_19-a59177e26c217a59.svg";

/***/ }),

/***/ "axi+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"confirm-modal":"confirm-modal","modal-body":"modal-body","paragraph":"paragraph","confirm-checkbox":"confirm-checkbox","button-cancel":"button-cancel","button-confirm":"button-confirm","modal-item":"modal-item","confirm-modal-wide":"confirm-modal-wide"};

/***/ }),

/***/ "b+8S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_request_cmpt__ = __webpack_require__("6b2N");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.forgot-password-request', []).component(__WEBPACK_IMPORTED_MODULE_1__forgot_password_request_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__forgot_password_request_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.forgot-password.request', {
        url: '',
        template: '<db-a-forgot-password-request class="block-component"></db-a-forgot-password-request>',
        params: {
            email: null
        }
    });
}

/***/ }),

/***/ "bB1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("Nkrn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_period_cmpt__ = __webpack_require__("RKPS");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-header.component.calendar-period', [__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_2__calendar_period_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__calendar_period_cmpt__["a" /* default */]));

/***/ }),

/***/ "bB9A":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"email-verification-request-page\"\u003E\u003Cdiv class=\"form-validation\" ng-bind=\"$ctrl.error\" ng-show=\"$ctrl.error\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-box\"\u003E\u003Cdiv class=\"identity-title\"\u003EVerify your email address\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-form\"\u003E\u003Cform role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.send($ctrl.email)\"\u003E\u003Cdiv class=\"form-note\"\u003EAn email will be sent to your email address with a link.\u003C\u002Fdiv\u003E\u003Cdiv class=\"control-group\"\u003E\u003Clabel class=\"control-icon\" for=\"email-control\"\u003E\u003Ci class=\"icon-dollarbird-email\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"email\" id=\"email-control\" name=\"email\" placeholder=\"email\" ng-model=\"$ctrl.email\" required\u003E\u003Clabel class=\"control-label\" for=\"email-control\"\u003EEmail\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"email-control\"\u003E\u003Cdb-a-validation-message key=\"email\"\u003EPlease provide a valid email address.\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in your email address.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cbutton class=\"button button-block button-fill button-primary button-send-email\" type=\"submit\" db-a-async loading=\"form.$submitting\"\u003E\u003Cinitial\u003ESend\u003C\u002Finitial\u003E\u003Cloading\u003ESending...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-comment\"\u003E\u003Cspan\u003EGo back to \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"identity.sign-in\"\u003Elog in\u003C\u002Fa\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "bLl/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Cross-6b8124402f5bae9b.svg";

/***/ }),

/***/ "bY2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_with_year_picker_style_sass__ = __webpack_require__("+w2c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_with_year_picker_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card_with_year_picker_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_with_year_picker_tpl_pug__ = __webpack_require__("Xk/h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_with_year_picker_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__card_with_year_picker_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CardWithYearPickerController = function () {
    function CardWithYearPickerController() {
        _classCallCheck(this, CardWithYearPickerController);
    }

    _createClass(CardWithYearPickerController, [{
        key: 'selectPreviousYear',
        value: function selectPreviousYear() {
            return this.onYearChange({
                year: this.year - 1
            });
        }
    }, {
        key: 'selectNextYear',
        value: function selectNextYear() {
            return this.onYearChange({
                year: this.year + 1
            });
        }
    }]);

    return CardWithYearPickerController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbADashboardCardWithYearPicker',
    template: __WEBPACK_IMPORTED_MODULE_1__card_with_year_picker_tpl_pug___default()(),
    controller: CardWithYearPickerController,
    transclude: true,
    bindings: {
        name: '@',
        year: '<',
        onYearChange: '&'
    }
});

/***/ }),

/***/ "bYpV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common__ = __webpack_require__("1lyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__("kIam");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authorized__ = __webpack_require__("CFwW");
stateConfiguration.$inject = ['$stateProvider'];







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene', [__WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__authorized__["a" /* default */].name]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('landing', {
        url: Object(__WEBPACK_IMPORTED_MODULE_1_common__["i" /* getPresentationStateUrl */])(),
        data: {
            external: true
        }
    }).state('privacy-policy', {
        url: Object(__WEBPACK_IMPORTED_MODULE_1_common__["h" /* getLegalStateUrl */])(__WEBPACK_IMPORTED_MODULE_1_common__["b" /* URL_PRIVACY_POLICY */]),
        data: {
            external: {
                blank: true
            }
        }
    }).state('terms-of-service', {
        url: Object(__WEBPACK_IMPORTED_MODULE_1_common__["h" /* getLegalStateUrl */])(__WEBPACK_IMPORTED_MODULE_1_common__["e" /* URL_TERMS_OF_SERVICE */]),
        data: {
            external: {
                blank: true
            }
        }
    });
}

/***/ }),

/***/ "bb60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__on_focus_directive__ = __webpack_require__("21GL");


// TODO find a better name


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.on-focus', []).directive(__WEBPACK_IMPORTED_MODULE_1__on_focus_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__on_focus_directive__["a" /* default */]));

/***/ }),

/***/ "bdb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_palette_style_sass__ = __webpack_require__("MHsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_palette_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_palette_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_palette_tpl_pug__ = __webpack_require__("3PSo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_palette_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icon_palette_tpl_pug__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var IconPaletteController = function () {
    function IconPaletteController() {
        _classCallCheck(this, IconPaletteController);
    }

    _createClass(IconPaletteController, [{
        key: '$onInit',
        value: function $onInit() {
            this.page = 0;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.icons && changeObject.icons.currentValue) {
                var icons = changeObject.icons.currentValue || [];

                this.icons = icons.map(function (icon) {
                    return __WEBPACK_IMPORTED_MODULE_0_angular___default.a.merge({}, icon);
                });
            }

            this.updateSelectedIcon(this.icons || [], this.iconIndex);
            this.iconForegroundColor = this.getReadableTextColor(this.iconColor);

            if (this.page > this.pageCount - 1) {
                this.page = this.pageCount - 1;
            }
        }
    }, {
        key: 'updateSelectedIcon',
        value: function updateSelectedIcon(icons, iconIndex) {
            icons.forEach(function (icon) {
                icon.selected = icon.iconIndex === iconIndex;
            });
        }
    }, {
        key: 'goPreviousPage',
        value: function goPreviousPage() {
            if (this.page > 0) {
                this.page -= 1;
            }
        }
    }, {
        key: 'goNextPage',
        value: function goNextPage() {
            if (this.page < this.pageCount - 1) {
                this.page += 1;
            }
        }
    }, {
        key: 'select',
        value: function select(icon) {
            if (!this.disabled) {
                this.$ctrl.$setViewValue(icon.iconIndex);
                this.updateSelectedIcon(this.icons || [], icon.iconIndex);

                return this.onChange({
                    icon: icon
                });
            }
        }
    }, {
        key: 'getReadableTextColor',
        value: function getReadableTextColor(backgroundColor) {
            var rgb = this.parseColorToRgb(backgroundColor);
            if (!rgb) {
                return '#fff';
            }

            var _rgb$map = rgb.map(function (value) {
                var channel = value / 255;
                return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
            }),
                _rgb$map2 = _slicedToArray(_rgb$map, 3),
                r = _rgb$map2[0],
                g = _rgb$map2[1],
                b = _rgb$map2[2];

            var luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
            return luminance > 0.5 ? '#394852' : '#fff';
        }
    }, {
        key: 'parseColorToRgb',
        value: function parseColorToRgb(color) {
            if (!color || typeof color !== 'string') {
                return null;
            }

            var value = color.trim();
            if (value[0] === '#') {
                value = value.slice(1);
            }

            if (value.length === 3) {
                var red = parseInt(value[0] + value[0], 16);
                var green = parseInt(value[1] + value[1], 16);
                var blue = parseInt(value[2] + value[2], 16);
                return [red, green, blue];
            }

            if (value.length === 6) {
                var _red = parseInt(value.slice(0, 2), 16);
                var _green = parseInt(value.slice(2, 4), 16);
                var _blue = parseInt(value.slice(4, 6), 16);
                return [_red, _green, _blue];
            }

            return null;
        }
    }, {
        key: 'pageSize',
        get: function get() {
            return (this.columns || 7) * (this.rows || 4);
        }
    }, {
        key: 'pageCount',
        get: function get() {
            if (!this.icons || this.icons.length === 0) {
                return 1;
            }

            return Math.ceil(this.icons.length / this.pageSize);
        }
    }, {
        key: 'visibleIcons',
        get: function get() {
            var size = this.pageSize;
            var start = this.page * size;
            return (this.icons || []).slice(start, start + size);
        }
    }]);

    return IconPaletteController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAIconPalette',
    template: __WEBPACK_IMPORTED_MODULE_2__icon_palette_tpl_pug___default()(),
    controller: IconPaletteController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        iconIndex: '<ngModel',
        iconColor: '<',
        icons: '<',
        disabled: '<ngDisabled',
        rows: '<',
        columns: '<',
        onChange: '&'
    }
});

/***/ }),

/***/ "beF3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"data-settings-page":"data-settings-page","data-action-button":"data-action-button","button-generate-backup":"button-generate-backup","button-restore-data":"button-restore-data","button-export-data":"button-export-data","button-download-data":"button-download-data","data-download-label":"data-download-label"};

/***/ }),

/***/ "boTu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-day-event":"calendar-day-event","confirmed":"confirmed","day-event-category":"day-event-category","day-event-overlay":"day-event-overlay","day-event-category-icon":"day-event-category-icon","day-event-note-container":"day-event-note-container","day-event-note":"day-event-note","day-event-text":"day-event-text","day-event-label":"day-event-label","day-event-icons":"day-event-icons","day-event-detail":"day-event-detail","day-event-repeating":"day-event-repeating","day-event-receipt":"day-event-receipt","day-event-receipt-wrapper":"day-event-receipt-wrapper","day-event-value":"day-event-value","calendar-day-event-receipt-hover-preview":"calendar-day-event-receipt-hover-preview","calendar-day-event-receipt-hover-preview-image":"calendar-day-event-receipt-hover-preview-image"};

/***/ }),

/***/ "bpPp":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("M1c9"),
    isIterateeCall = __webpack_require__("zBOP"),
    toInteger = __webpack_require__("5Zxu");

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),

/***/ "bsoP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_range_picker_style_sass__ = __webpack_require__("QE2y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_range_picker_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__date_range_picker_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__date_range_picker_tpl_pug__ = __webpack_require__("SGuk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__date_range_picker_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__date_range_picker_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var DateRangePickerController = function () {
    /* @ngInject */
    function DateRangePickerController() {
        _classCallCheck(this, DateRangePickerController);

        this.isStartDateSelection = true;
    }

    _createClass(DateRangePickerController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.start) {
                var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.start);

                this.start = start.isValid() ? start.startOf('day').valueOf() : __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day').valueOf();

                this.startView = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.start);
            }
            if (changeObject.start || changeObject.end) {
                var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.end);

                this.end = end.isValid() ? end.startOf('day').valueOf() : __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day').valueOf();

                this.endView = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.end).diff(this.startView, 'month', true) < 1 ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.startView).add(1, 'month').valueOf() : this.end.valueOf();

                this.viewDifference = this.getDifferenceInMonths(this.startView, this.endView);
            }
        }
    }, {
        key: 'isAnotherMonth',
        value: function isAnotherMonth(source, timestamp) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(source).month() !== __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).month();
        }
    }, {
        key: 'isBetweenInterval',
        value: function isBetweenInterval(timestamp) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.start).valueOf() <= timestamp && timestamp <= __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.end).valueOf();
        }
    }, {
        key: 'checkDayActive',
        value: function checkDayActive(timestamp) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.start).valueOf() === timestamp || __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.end).valueOf() === timestamp;
        }

        // using moment instance instead of timestamp so the underlying
        // date-picker components get updated every time we change the
        // start or end dates

    }, {
        key: 'update',
        value: function update(timestamp) {
            if (this.isStartDateSelection) {
                this.start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp);
                this.end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.start);
            } else {
                var end = this.start < timestamp ? timestamp : this.start;

                var start = this.start > timestamp ? timestamp : this.start;

                this.start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(start);
                this.end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(end);

                this.onChange({
                    start: this.start.valueOf(),
                    end: this.end.valueOf()
                });
            }

            this.isStartDateSelection = !this.isStartDateSelection;
        }
    }, {
        key: 'startViewChanged',
        value: function startViewChanged(timestamp) {
            this.startView = __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).valueOf();

            if (this.isDifferenceLessThan1Month(this.startView, this.endView)) {
                this.endView = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.startView).add(1, 'month').valueOf();
            }

            this.viewDifference = this.getDifferenceInMonths(this.startView, this.endView);
        }
    }, {
        key: 'endViewChanged',
        value: function endViewChanged(timestamp) {
            this.endView = __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).valueOf();

            if (this.isDifferenceLessThan1Month(this.startView, this.endView)) {
                this.startView = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.endView).subtract(1, 'month').valueOf();
            }

            this.viewDifference = this.getDifferenceInMonths(this.startView, this.endView);
        }
    }, {
        key: 'getDifferenceInMonths',
        value: function getDifferenceInMonths(start, end) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(end).diff(start, 'month', true);
        }
    }, {
        key: 'isDifferenceLessThan1Month',
        value: function isDifferenceLessThan1Month(start, end) {
            return this.getDifferenceInMonths(start, end) < 1;
        }
    }]);

    return DateRangePickerController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbADateRangePicker',
    template: __WEBPACK_IMPORTED_MODULE_2__date_range_picker_tpl_pug___default()(),
    controller: DateRangePickerController,
    bindings: {
        start: '<',
        end: '<',
        startOfWeek: '<',
        onChange: '&'
    }
});

/***/ }),

/***/ "bugh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"event-group":"event-group","event-count":"event-count","event-name":"event-name","event-value":"event-value"};

/***/ }),

/***/ "cEDq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_color_chart_cmpt__ = __webpack_require__("fwUy");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-dashboard.component.category-color-chart', []).component(__WEBPACK_IMPORTED_MODULE_1__category_color_chart_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__category_color_chart_cmpt__["a" /* default */]));

/***/ }),

/***/ "cJ7d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"team-edit-modal":"team-edit-modal","calendar-name":"calendar-name","link-manage-categories":"link-manage-categories","transactions-by-email":"transactions-by-email","transactions-by-email-title":"transactions-by-email-title","link-transactions-by-email":"link-transactions-by-email","collaborators-content":"collaborators-content","collaborators-heading":"collaborators-heading","collaborators-title":"collaborators-title","link-manage-members":"link-manage-members","invite-collaborators":"invite-collaborators","button":"button","invite-collaborators-text":"invite-collaborators-text","collaborator-item":"collaborator-item","disabled":"disabled","collaborator-share":"collaborator-share","collaborator-info":"collaborator-info","collaborator-image":"collaborator-image","collaborator-name":"collaborator-name","collaborator-email":"collaborator-email","collaborator-owner":"collaborator-owner","collaborator-me":"collaborator-me","highlighted":"highlighted","collaborator-role":"collaborator-role","empty-state":"empty-state","empty-state-content":"empty-state-content","empty-state-image":"empty-state-image"};

/***/ }),

/***/ "cR/v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"event-date-modal":"event-date-modal","modal-body":"modal-body","date-settings":"date-settings","date-control-label":"date-control-label","date-control-value":"date-control-value","date-repeating-settings":"date-repeating-settings","date-control-label-auto-confirm":"date-control-label-auto-confirm","date-control-group":"date-control-group","date-control-item":"date-control-item","end-select":"end-select","repeat-ending-invalid":"repeat-ending-invalid","repeat-ending-error":"repeat-ending-error","frequency-control":"frequency-control","unit-select":"unit-select","occurrence-control":"occurrence-control","occurrence-text":"occurrence-text","control-input":"control-input","date-repeat-summary":"date-repeat-summary"};

/***/ }),

/***/ "ce2Z":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"notifications\" ng-mouseenter=\"$ctrl.disableClose()\" ng-mouseleave=\"$ctrl.enableClose()\"\u003E\u003Cdiv class=\"notification-item-container animated\" ng-repeat=\"notification in $ctrl.notifications\"\u003E\u003Cdiv class=\"notification-item\" db-a-compile-component=\"notification.component\" bindings=\"notification.bindings\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-icon button-dismiss-notification\" ng-click=\"notification.close()\"\u003E\u003Ci class=\"icon icon-dollarbird-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "chNe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_checkbox_style_sass__ = __webpack_require__("mrfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_checkbox_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__calendar_checkbox_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_checkbox_tpl_pug__ = __webpack_require__("EU2A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_checkbox_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_checkbox_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarCheckbox',
    template: __WEBPACK_IMPORTED_MODULE_1__calendar_checkbox_tpl_pug___default()(),
    bindings: {
        name: '<',
        selected: '<'
    }
});

/***/ }),

/***/ "cx4P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__capture_keys_directive__ = __webpack_require__("U4kA");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.capture-keys', []).directive(__WEBPACK_IMPORTED_MODULE_1__capture_keys_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__capture_keys_directive__["a" /* default */]));

/***/ }),

/***/ "cxal":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-icon-image-aff2af5657ab6cfd.svg";

/***/ }),

/***/ "d1/4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("3n1n");

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

module.exports = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.easingEffects = effects;


/***/ }),

/***/ "dDla":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_receipt_modal_cmpt__ = __webpack_require__("LAWr");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.event-receipt-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__event_receipt_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__event_receipt_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "dQ6+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_style_sass__ = __webpack_require__("0jNc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__general_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_tpl_pug__ = __webpack_require__("VL38");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__general_tpl_pug__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var GeneralSettingsController = function () {
    GeneralSettingsController.$inject = ['$q', 'profileService', 'preferenceService', 'sessionService', 'modalService', 'storageService', 'notificationService'];

    /* @ngInject */
    function GeneralSettingsController($q, profileService, preferenceService, sessionService, modalService, storageService, notificationService) {
        _classCallCheck(this, GeneralSettingsController);

        this.$q = $q;
        this.profileService = profileService;
        this.preferenceService = preferenceService;
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.storageService = storageService;
        this.notificationService = notificationService;
    }

    _createClass(GeneralSettingsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;
            this.preferences = {};
            this.selectedTeam = null;

            return this.$q.all([this.preferenceService.get(), this.sessionService.initialize()]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    preferences = _ref2[0],
                    session = _ref2[1];

                _this.preferences = preferences;
                _this.selectedTeam = _this.getSelectedTeam(session && session.teams);
            }).catch(function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to retrieve your general settings.'));
            }).finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'getSelectedTeam',
        value: function getSelectedTeam(teams) {
            var selectedTeamId = +this.storageService.getUserItem('selected-team');
            var availableTeams = teams || [];

            return availableTeams.find(function (team) {
                return team && team.id === selectedTeamId;
            }) || availableTeams[0] || null;
        }
    }, {
        key: 'updatePreferences',
        value: function updatePreferences() {
            var _this2 = this;

            return this.preferenceService.save(this.preferences).catch(function (result) {
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to update your general settings.'));
            });
        }
    }, {
        key: 'manageTransactionsByEmail',
        value: function manageTransactionsByEmail() {
            if (!this.selectedTeam || !this.selectedTeam.id) {
                return null;
            }

            return this.modalService.open({
                component: 'dbAEmailIngestTokenModal',
                bindings: {
                    teamId: this.selectedTeam.id,
                    teamName: this.selectedTeam.name
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'autoCategorization',
        get: function get() {
            return this.preferences && !this.preferences.autoCategorizationOff;
        },
        set: function set(value) {
            if (this.preferences) {
                this.preferences.autoCategorizationOff = !value;
            }
        }
    }]);

    return GeneralSettingsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAGeneralSettings',
    template: __WEBPACK_IMPORTED_MODULE_2__general_tpl_pug___default()(),
    controller: GeneralSettingsController
});

/***/ }),

/***/ "dV23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__change_log_cmpt__ = __webpack_require__("78R8");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.change-log', []).component(__WEBPACK_IMPORTED_MODULE_1__change_log_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__change_log_cmpt__["a" /* default */]));

/***/ }),

/***/ "dpaq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-merge-modal":"category-merge-modal","modal-body":"modal-body","merge-description":"merge-description","fallback-section":"fallback-section","button-select-fallback":"button-select-fallback","fallback-category-preview":"fallback-category-preview","category-name":"category-name","fallback-empty":"fallback-empty"};

/***/ }),

/***/ "e1lC":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"confirm-modal\" ng-class=\"{ 'confirm-modal-wide': $ctrl.wide }\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.confirm()\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\" ng-if=\"$ctrl.title\"\u003E\u003Cdiv class=\"modal-title\" ng-bind=\"$ctrl.title\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter modal-section\"\u003E\u003Cdiv class=\"paragraph\" ng-repeat=\"paragraph in $ctrl.paragraphs\" ng-bind=\"paragraph\"\u003E\u003C\u002Fdiv\u003E\u003Clabel class=\"paragraph confirm-checkbox\" ng-if=\"$ctrl.checkboxLabel\"\u003E\u003Cinput type=\"checkbox\" ng-model=\"$ctrl.checkboxChecked\"\u003E\u003Cspan ng-bind=\"$ctrl.checkboxLabel\"\u003E\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-outline button-secondary button-modal-left button-cancel\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-class=\"{ disabled: form.$submitting }\" ng-bind=\"$ctrl.secondaryButtonText\"\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-modal-right button-confirm\" type=\"submit\" db-a-async loading=\"form.$submitting\" ng-class=\"$ctrl.buttonStyleClass\"\u003E\u003Cinitial ng-bind=\"$ctrl.getPrimaryButtonText()\"\u003E\u003C\u002Finitial\u003E\u003Cloading ng-bind=\"$ctrl.getPrimaryButtonLoadingText()\"\u003E\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "eL07":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"date":"date","date-value":"date-value","date-icon":"date-icon","disabled":"disabled"};

/***/ }),

/***/ "eN5m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-select-modal":"category-select-modal","button-manage-categories":"button-manage-categories","categories-container":"categories-container","category-search":"category-search","categories-message":"categories-message","category-select-item":"category-select-item","category":"category","filled":"filled","unknown":"unknown","disabled":"disabled","category-name":"category-name"};

/***/ }),

/***/ "eS9E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"collaborator-invite-modal":"collaborator-invite-modal","modal-body":"modal-body","form-description":"form-description"};

/***/ }),

/***/ "eWxN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_icon_cmpt__ = __webpack_require__("NpVt");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.category-icon', []).component(__WEBPACK_IMPORTED_MODULE_1__category_icon_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__category_icon_cmpt__["a" /* default */]));

/***/ }),

/***/ "empT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notifications":"notifications","notification-item-container":"notification-item-container","ng-enter":"ng-enter","ng-leave":"ng-leave","ng-leave-active":"ng-leave-active","ng-enter-active":"ng-enter-active","notification-item":"notification-item","button-dismiss-notification":"button-dismiss-notification"};

/***/ }),

/***/ "f+QK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"user-interface-settings-page":"user-interface-settings-page","form-group":"form-group","setting-name":"setting-name","setting-description":"setting-description","setting-options":"setting-options","setting-option":"setting-option","setting-option-state":"setting-option-state","setting-option-title":"setting-option-title","setting-threshold-control":"setting-threshold-control","disabled":"disabled","setting-threshold-hint":"setting-threshold-hint"};

/***/ }),

/***/ "f+rN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"radio":"radio","selected":"selected","input-radio":"input-radio"};

/***/ }),

/***/ "f0k0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__time_cmpt__ = __webpack_require__("g4UR");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.time', []).component(__WEBPACK_IMPORTED_MODULE_1__time_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__time_cmpt__["a" /* default */]));

/***/ }),

/***/ "fA2j":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"event-edit-modal modal-fixed-height\" ng-class=\"{ confirmed: $ctrl.entity.confirmed &amp;&amp; $ctrl.entity.category, 'has-back': $ctrl.canNavigateBack }\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.save($ctrl.entity)\"\u003E\u003Cdiv class=\"modal-header modal-section\" ng-style=\"{ backgroundColor: $ctrl.entity.confirmed ? $ctrl.entity.category.color : null }\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-show=\"$ctrl.canNavigateBack\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Ctable class=\"entity-types\" ng-if=\"!$ctrl.existing\"\u003E\u003Ctr\u003E\u003Ctd class=\"entity-type\" ng-repeat=\"type in $ctrl.types\"\u003E\u003Cbutton class=\"button-select-type\" type=\"button\" ng-class=\"{ active: $ctrl.type === type.value }\" ng-click=\"$ctrl.clickSelectType(type)\"\u003E\u003Cspan class=\"entity-type-label\" ng-bind=\"type.label\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter\"\u003E\u003Ctable class=\"entity-content\"\u003E\u003Ctr\u003E\u003Ctd class=\"entity-core\" ng-style=\"{ backgroundColor: $ctrl.entity.confirmed ? $ctrl.entity.category.color : null }\"\u003E\u003Ctable class=\"entity-information\"\u003E\u003Ctr\u003E\u003Ctd class=\"entity-sign\" ng-if=\"$ctrl.isEvent || $ctrl.isBalanceUpdate\"\u003E\u003Cbutton class=\"button-toggle-sign\" type=\"button\" ng-click=\"$ctrl.switchSign($ctrl.entity)\" ng-disabled=\"!$ctrl.canEdit\"\u003E\u003Ci class=\"icon\" ng-class=\"{ 'icon-dollarbird-minus': !$ctrl.income, 'icon-dollarbird-plus': $ctrl.income }\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"entity-value\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"number\" id=\"value-control\" name=\"value\" placeholder=\"0.00\" ng-model=\"$ctrl.entity.value\" ng-min=\"0\" db-a-number-only allow-invalid db-a-autofocus=\"$ctrl.canEdit &amp;&amp; !$ctrl.existing\" ng-readonly=\"!$ctrl.canEdit\" required\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"value-control\"\u003E\u003Cspan ng-hide=\"$ctrl.isBalanceUpdate\"\u003EValue\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.isBalanceUpdate\"\u003ENew balance\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"value-control\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003EFill in the value.\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"number\"\u003EInvalid value.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"entity-label\" ng-if=\"$ctrl.isEvent || $ctrl.isTransfer\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input control-input-label\" type=\"text\" id=\"label-control\" name=\"label\" placeholder=\"e.g. lunch\" ng-model=\"$ctrl.entity.note\" ng-model-options=\"{ allowInvalid: true }\" maxlength=\"255\" ng-readonly=\"!$ctrl.canEdit\" ng-change=\"$ctrl.updateNote($ctrl.entity)\" db-a-process-key=\"$ctrl.checkKeyForNote($ctrl.entity, code)\"\u003E\u003Cdiv class=\"control-input control-input-suggestion\" ng-if=\"$ctrl.noteSuggestion\"\u003E\u003Cspan class=\"label-current\" ng-bind=\"$ctrl.entity.note\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"label-suggestion\" ng-bind=\"$ctrl.noteSuggestion\" ng-click=\"$ctrl.autofillNote($ctrl.entity)\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"label-control\"\u003ELabel\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd class=\"entity-body-container\"\u003E\u003Cdiv class=\"entity-body\"\u003E\u003Ctable class=\"entity-details\"\u003E\u003Ctr ng-if=\"$ctrl.isTransfer\"\u003E\u003Ctd class=\"entity-transfer-container modal-delimiter\"\u003E\u003Ctable class=\"transfer-calendar-switcher\"\u003E\u003Ctr\u003E\u003Ctd class=\"transfer-calendar-cell transfer-calendar-icon-cell\" rowspan=\"2\" ng-if=\"!$ctrl.existing\"\u003E\u003Cbutton class=\"button button-icon button-switch-calendar\" type=\"button\" ng-click=\"$ctrl.switchTransferCalendars($ctrl.entity)\"\u003E\u003Ci class=\"icon icon-dollarbird-transfer\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"transfer-calendar-cell transfer-calendar-heading\"\u003EFrom\u003C\u002Ftd\u003E\u003Ctd class=\"transfer-calendar-cell transfer-calendar-heading\"\u003Eto\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd class=\"transfer-calendar-cell transfer-calendar-name\" ng-class=\"{ disabled: $ctrl.existing || !$ctrl.fromCalendar }\" ng-click=\"$ctrl.selectFromCalendar($ctrl.entity)\"\u003E\u003Cspan ng-bind=\"$ctrl.fromCalendar.name\"\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!$ctrl.fromCalendar\"\u003ERemoved calendar\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"transfer-calendar-cell transfer-calendar-name\" ng-class=\"{ disabled: $ctrl.existing || !$ctrl.toCalendar }\" ng-click=\"$ctrl.selectToCalendar($ctrl.entity)\"\u003E\u003Cspan ng-bind=\"$ctrl.toCalendar.name\"\u003E\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!$ctrl.toCalendar\"\u003ERemoved calendar\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd class=\"entity-properties-container\"\u003E\u003Cdiv class=\"entity-properties\"\u003E\u003Cdiv class=\"entity-property\" ng-if=\"!$ctrl.isTransfer\" ng-click=\"$ctrl.selectCalendar($ctrl.entity)\" ng-class=\"{ disabled: !$ctrl.canEdit || ($ctrl.existing &amp;&amp; $ctrl.isBalanceUpdate) }\"\u003E\u003Cdiv class=\"entity-property-icon\"\u003E\u003Ci class=\"icon icon-dollarbird-calendar\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-content\"\u003E\u003Cdiv class=\"entity-property-primary-text\" ng-bind=\"$ctrl.calendar.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property entity-property-confirm\" ng-if=\"!$ctrl.isBalanceUpdate\" ng-class=\"{ confirmed: $ctrl.entity.confirmed, disabled: !$ctrl.canEdit }\" ng-click=\"$ctrl.toggleConfirmation($ctrl.entity)\"\u003E\u003Cdiv class=\"entity-property-icon\"\u003E\u003Ci class=\"icon icon-dollarbird-checkmark\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-content\"\u003E\u003Cspan class=\"entity-property-primary-text\" ng-show=\"$ctrl.entity.confirmed\"\u003EConfirmed\u003C\u002Fspan\u003E\u003Cspan class=\"entity-property-primary-text\" ng-hide=\"$ctrl.entity.confirmed\"\u003EUnconfirmed\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property\"\u003E\u003Cdb-a-category class=\"entity-category\" name=\"$ctrl.entity.category.name\" color=\"$ctrl.entity.category.color\" icon-name=\"$ctrl.entity.category.iconName\" use-icons=\"$ctrl.useCategoryIcons\" icon-index=\"$ctrl.entity.category.iconIndex\" fallback-icon-name=\"null\" ng-click=\"$ctrl.openCategoryModal($ctrl.entity)\" disabled=\"!$ctrl.canEditCategory\"\u003E\u003C\u002Fdb-a-category\u003E\u003Cdb-loader class=\"entity-category-loader\" visible=\"$ctrl.loading\" fit=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property\" ng-click=\"$ctrl.openDateModal($ctrl.entity)\" ng-class=\"{ disabled: !$ctrl.canEdit }\"\u003E\u003Cdiv class=\"entity-property-icon\"\u003E\u003Ci class=\"icon icon-dollarbird-calendar\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-content\"\u003E\u003Cdiv class=\"entity-property-primary-text\" ng-bind=\"$ctrl.dateSummary\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-secondary-text\" ng-bind=\"$ctrl.repeatingSummary\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property entity-property-details\" ng-if=\"!$ctrl.isBalanceUpdate\" ng-click=\"$ctrl.openDetailsModal($ctrl.entity)\" ng-class=\"{ disabled: !$ctrl.canEdit }\"\u003E\u003Cdiv class=\"entity-property-icon\"\u003E\u003Ci class=\"icon icon-dollarbird-details\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-content\"\u003E\u003Cdiv class=\"entity-property-primary-text\" ng-bind=\"$ctrl.detailSummary\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-placeholder-text\" ng-if=\"!$ctrl.detailSummary\"\u003EAdd description\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property entity-property-reports\" ng-class=\"{ disabled: !$ctrl.canEdit }\"\u003E\u003Cdiv class=\"entity-property-icon\"\u003E\u003Ci class=\"icon icon-dollarbird-dashboard\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-content\"\u003E\u003Cdb-a-switch ng-model=\"$ctrl.entity.isIncludedInReports\" disabled=\"!$ctrl.canEdit\"\u003EShow transaction in reports\u003C\u002Fdb-a-switch\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property entity-property-receipt\" ng-if=\"!$ctrl.isBalanceUpdate\" ng-click=\"$ctrl.handleReceiptClick($ctrl.entity)\" ng-class=\"{ disabled: $ctrl.uploadingReceipt || (!$ctrl.canEdit &amp;&amp; !$ctrl.hasReceipt($ctrl.entity)), 'with-thumbnail': $ctrl.hasReceipt($ctrl.entity) }\"\u003E\u003Cdiv class=\"entity-property-icon\"\u003E\u003Cdiv class=\"entity-property-receipt-icon\" ng-style=\"{ '-webkit-mask-image': $ctrl.receiptIconUrl, 'mask-image': $ctrl.receiptIconUrl }\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-content\"\u003E\u003Cdiv class=\"entity-property-placeholder-text\" ng-if=\"!$ctrl.hasReceipt($ctrl.entity)\"\u003EAdd image\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-receipt-thumbnail\" ng-if=\"$ctrl.hasReceipt($ctrl.entity)\"\u003E\u003Cimg class=\"entity-property-receipt-image\" ng-src=\"{{ $ctrl.getReceiptImageUrl($ctrl.entity) }}\" alt=\"Receipt image\" role=\"presentation\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-actions\" ng-if=\"$ctrl.hasReceipt($ctrl.entity) &amp;&amp; $ctrl.canEdit\"\u003E\u003Cbutton class=\"button button-link button-remove-receipt\" type=\"button\" db-stop-propagation=\"click\" ng-click=\"$ctrl.removeReceipt($ctrl.entity)\"\u003ERemove\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property disabled\"\u003E\u003Cdiv class=\"entity-property-icon\"\u003E\u003Ci class=\"icon icon-dollarbird-name\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"entity-property-content\"\u003E\u003Cdiv class=\"entity-property-primary-text\"\u003E\u003Cspan\u003Eby \u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.entity.owner.name\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003Cinput class=\"input-receipt-file\" type=\"file\" accept=\"image\u002F*\" hidden\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-danger button-remove button-modal-left button-remove-event\" type=\"button\" ng-show=\"$ctrl.canDelete\" ng-click=\"$ctrl.remove($ctrl.entity)\"\u003E\u003Ci class=\"icon-delete icon-dollarbird-delete\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-link button-modal-left button-close-modal\" type=\"button\" ng-show=\"!$ctrl.canEdit\" ng-click=\"$ctrl.dismiss()\"\u003EClose\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-create-event\" type=\"submit\" db-a-async loading=\"form.$submitting\" ng-if=\"$ctrl.canEdit\"\u003E\u003Cinitial\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ESave\u003C\u002Fspan\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ECreate\u003C\u002Fspan\u003E\u003C\u002Finitial\u003E\u003Cloading\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ESaving...\u003C\u002Fspan\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ECreating...\u003C\u002Fspan\u003E\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "fGGw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_application_util_search_util__ = __webpack_require__("Vihm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_style_sass__ = __webpack_require__("sUV3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__search_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search_tpl_pug__ = __webpack_require__("ur4S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__search_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var SearchController = function () {
    SearchController.$inject = ['$scope'];

    /* @ngInject */
    function SearchController($scope) {
        var _this = this;

        _classCallCheck(this, SearchController);

        this.search = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (term) {
            return $scope.$applyAsync(_this.changed.bind(_this, term));
        }, 250);
    }

    _createClass(SearchController, [{
        key: 'changed',
        value: function changed(term) {
            return this.onTermChange({
                terms: Object(__WEBPACK_IMPORTED_MODULE_1_application_util_search_util__["a" /* getSearchTerms */])(term)
            });
        }
    }, {
        key: 'submit',
        value: function submit(term) {
            return this.onSubmit({
                terms: Object(__WEBPACK_IMPORTED_MODULE_1_application_util_search_util__["a" /* getSearchTerms */])(term)
            });
        }
    }, {
        key: 'open',
        value: function open() {
            return this.onFocusChange({
                focused: true
            });
        }
    }, {
        key: 'close',
        value: function close() {
            return this.onFocusChange({
                focused: false
            });
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.term = null;
            this.changed();
        }
    }, {
        key: 'handleClear',
        value: function handleClear(code) {
            switch (code) {
                case 27:
                    this.clear();
                    this.close();
                    return false;
            }

            return true;
        }
    }]);

    return SearchController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbASearch',
    template: __WEBPACK_IMPORTED_MODULE_3__search_tpl_pug___default()(),
    controller: SearchController,
    bindings: {
        id: '@',
        placeholder: '<',
        term: '<',

        canCapture: '<',

        onFocusChange: '&',
        onTermChange: '&',
        onSubmit: '&'
    }
});

/***/ }),

/***/ "fN8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__account_cmpt__ = __webpack_require__("BtV/");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.settings.scene.account', []).component(__WEBPACK_IMPORTED_MODULE_1__account_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__account_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.account', {
        url: '/account?action',
        component: __WEBPACK_IMPORTED_MODULE_1__account_cmpt__["a" /* default */].selector
    });
}

/***/ }),

/***/ "fUuY":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"forgot-password-confirm-page\"\u003E\u003Cdiv class=\"identity-box\"\u003E\u003Cdiv class=\"identity-form\"\u003E\u003Cdiv class=\"form-illustration\"\u003E\u003Cimg" + (" class=\"form-image\""+pug.attr("src", __webpack_require__("2C65"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-title\"\u003EYou've got mail\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-note\"\u003EWe've sent you an email with a link to reset your password\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Ca class=\"button button-block button-fill button-primary button-sign-in\" href=\"javascript:void(0);\" ui-sref=\"identity.sign-in\"\u003EOK\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-comment\"\u003E\u003Cspan\u003EHaven't you received the email? Try to \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"identity.forgot-password.request\"\u003Erequest it again\u003C\u002Fa\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "fVhu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_random__ = __webpack_require__("XPuf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_random__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_application_util_category_util__ = __webpack_require__("XzH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__category_select_modal_style_sass__ = __webpack_require__("eN5m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__category_select_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__category_select_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__category_select_modal_tpl_pug__ = __webpack_require__("r5tb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__category_select_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__category_select_modal_tpl_pug__);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










var CategorySelectModalController = function () {
    CategorySelectModalController.$inject = ['categoryService', 'modalService', 'notificationService', 'storageService'];

    /* @ngInject */
    function CategorySelectModalController(categoryService, modalService, notificationService, storageService) {
        _classCallCheck(this, CategorySelectModalController);

        this.categoryService = categoryService;
        this.modalService = modalService;
        this.notificationService = notificationService;
        this.storageService = storageService;
    }

    _createClass(CategorySelectModalController, [{
        key: '$onInit',
        value: function $onInit() {
            var categoryIconStyle = this.storageService.getUserItem('category-icon-style') || 'icons';
            this.useCategoryIcons = categoryIconStyle === 'icons';
            this.categoryService.onUpdate(this.handleCategoryUpdate.bind(this));
            this.reload();
        }
    }, {
        key: 'reload',
        value: function reload() {
            var _this = this;

            this.loading = true;

            return this.categoryService.getAll(this.teamId, true).then(function (categories) {
                _this.categories = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(categories, __WEBPACK_IMPORTED_MODULE_5_application_util_category_util__["c" /* isCategoryListable */]), function (category) {
                    return __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({
                        selected: category.id === _this.selectedCategoryId
                    }, category);
                });
                _this.searchPlaceholder = _this.categories.length > 0 ? 'search for e.g. ' + _this.categories[__WEBPACK_IMPORTED_MODULE_0_lodash_random___default()(0, _this.categories.length - 1)].name : null;

                _this.search();
            }).catch(function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_4_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to load your categories. Please try again later.'));
            }).finally(function () {
                return _this.loading = false;
            });
        }
    }, {
        key: 'handleCategoryUpdate',
        value: function handleCategoryUpdate(updatedCategory) {
            var _this2 = this;

            if (!updatedCategory || !updatedCategory.id) {
                return this.reload();
            }

            var replaced = false;
            this.categories = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.categories || [], function (category) {
                if ('' + category.id === '' + updatedCategory.id) {
                    replaced = true;
                    return __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, category, updatedCategory, {
                        selected: category.id === _this2.selectedCategoryId
                    });
                }

                return category;
            });

            if (!replaced) {
                return this.reload();
            }

            return this.search();
        }
    }, {
        key: 'select',
        value: function select(category) {
            return this.onClose({
                data: category
            });
        }
    }, {
        key: 'create',
        value: function create() {
            return this.modalService.open({
                component: 'dbACategoryEditModal',
                bindings: {
                    teamId: this.teamId,
                    canEdit: true,
                    from: 'event'
                }
            }).then(this.select.bind(this)).catch(function () {
                return null;
            });
        }
    }, {
        key: 'manage',
        value: function manage() {
            var _this3 = this;

            return this.modalService.open({
                component: 'dbACategoryManageModal',
                bindings: {
                    teamId: this.teamId
                }
            }).finally(function () {
                return _this3.reload();
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'searchBySubmit',
        value: function searchBySubmit(terms) {
            var valid = this.search(terms);

            if (valid && this.filteredCategories.length > 0) {
                this.select(this.filteredCategories[0]);
            }
        }
    }, {
        key: 'search',
        value: function search(terms) {
            var valid = terms && terms.length > 0;

            this.filteredCategories = valid ? __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.categories, function (category) {
                return Object(__WEBPACK_IMPORTED_MODULE_5_application_util_category_util__["a" /* categoryHasTerms */])(category, terms);
            }) : this.categories;

            return valid;
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            this.onDismiss();
        }
    }]);

    return CategorySelectModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategorySelectModal',
    template: __WEBPACK_IMPORTED_MODULE_7__category_select_modal_tpl_pug___default()(),
    controller: CategorySelectModalController,
    bindings: {
        teamId: '<',
        selectedCategoryId: '<',

        canAdd: '<',

        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "fWtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_interface_cmpt__ = __webpack_require__("Sww0");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.settings.scene.user-interface', []).component(__WEBPACK_IMPORTED_MODULE_1__user_interface_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__user_interface_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.userInterface', {
        url: '/user-interface',
        component: __WEBPACK_IMPORTED_MODULE_1__user_interface_cmpt__["a" /* default */].selector
    });
}

/***/ }),

/***/ "feAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_application_util__ = __webpack_require__("ykAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_application_util_time_util__ = __webpack_require__("S2sh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_util_plan_util__ = __webpack_require__("vOfg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_application_util_transaction_util__ = __webpack_require__("vu3g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__calendar_style_sass__ = __webpack_require__("Um0n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__calendar_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__calendar_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__calendar_tpl_pug__ = __webpack_require__("yHpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__calendar_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__calendar_tpl_pug__);








var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }














var TRANSACTIONS_BY_EMAIL_NOTIFICATION_KEY = 'com.halcyonmobile.dollarbird3.userdefkey.showTransactionsByEmailNotification.v3';

var CalendarController = function () {
    CalendarController.$inject = ['$q', '$state', '$scope', '$element', 'eventUtil', 'timeUtil', 'sessionService', 'balanceService', 'eventService', 'preferenceService', 'suggestionService', 'autoCategoryService', 'calendarService', 'categoryService', 'teamService', 'modalService', 'storageService', 'notificationService', 'diagnosticsService'];

    /* @ngInject */
    function CalendarController($q, $state, $scope, $element, eventUtil, timeUtil, sessionService, balanceService, eventService, preferenceService, suggestionService, autoCategoryService, calendarService, categoryService, teamService, modalService, storageService, notificationService, diagnosticsService) {
        _classCallCheck(this, CalendarController);

        this.$q = $q;
        this.$state = $state;
        this.$scope = $scope;
        this.$element = $element;
        this.timeUtil = timeUtil;
        this.eventUtil = eventUtil;
        this.sessionService = sessionService;
        this.balanceService = balanceService;
        this.eventService = eventService;
        this.preferenceService = preferenceService;
        this.suggestionService = suggestionService;
        this.autoCategoryService = autoCategoryService;
        this.calendarService = calendarService;
        this.categoryService = categoryService;
        this.teamService = teamService;
        this.modalService = modalService;
        this.storageService = storageService;
        this.notificationService = notificationService;
        this.diagnosticsService = diagnosticsService;

        this.updateEventLimit = this.updateEventLimit.bind(this);
    }

    _createClass(CalendarController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loadingTeams = 0;
            this.loadingMonthlyBalances = 0;
            this.loadingDailyBalances = 0;

            this.loading = true;
            this.calendarHighlightPreference = 'selected';
            this.calendarHighlightPalette = null;
            this.useCategoryIcons = false;
            this.balanceWarningThreshold = null;

            this.categoryService.onUpdate(this.refreshVisibleCategoryMetadata.bind(this));
            this.initializeTransactionsByEmailNotification();
            this.$scope.$on('categoryIconStyleUpdated', function (event, style) {
                _this.useCategoryIcons = style === 'icons';
            });
            this.$scope.$on('balanceWarningThresholdUpdated', function () {
                _this.balanceWarningThreshold = _this.getBalanceWarningThreshold({});
            });

            this.$q.all([this.preferenceService.get(), this.loadTeams(this.sessionService.initialize())]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    preferences = _ref2[0],
                    teams = _ref2[1];

                _this.startOfWeek = preferences.startWeekOnSunday ? 0 : 1;
                _this.autoCategorization = !preferences.autoCategorizationOff;
                _this.calendarHighlightPreference = preferences.calendarHighlightColor || 'selected';
                _this.balanceWarningThreshold = _this.getBalanceWarningThreshold(preferences);
                var categoryIconStyle = preferences.categoryIconStyle || _this.storageService.getUserItem('category-icon-style') || 'icons';
                _this.useCategoryIcons = categoryIconStyle === 'icons';

                _this.timestamp = __WEBPACK_IMPORTED_MODULE_8_moment___default()().startOf('month').valueOf();

                _this.weekdays = _this.createWeekdays();
                _this.months = _this.createMonths(_this.timestamp);
                _this.days = _this.createDays(_this.timestamp);

                _this.handleDefaultCalendarNotification(_this.plan || {}, teams);

                _this.multiple = _this.storageService.getUserItem('multiple-calendars');

                return _this.selectTeamIdAndCalendarIds(+_this.teamId, __WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(_this.calendarIds, function (calendarId) {
                    return +calendarId;
                }), _this.storageService.getUserItem('selected-team'), _this.storageService.getUserItem('selected-calendars'));
            }).catch(function () {
                return null;
            }).finally(function () {
                _this.dailyRefreshId = Object(__WEBPACK_IMPORTED_MODULE_12_application_util_time_util__["b" /* every */])('day', function () {
                    return _this.refreshMonthlyBalances(_this.timestamp).catch(function () {
                        return null;
                    });
                });
                _this.pollRefreshId = Object(__WEBPACK_IMPORTED_MODULE_12_application_util_time_util__["b" /* every */])('minute', _this.reloadCalendar.bind(_this));

                _this.loading = false;
            });
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            this.calendarRoot = this.$element && this.$element[0] ? this.$element[0].querySelector('#calendar-page') : null;
            this.applyCalendarHighlight();
        }
    }, {
        key: 'reloadCalendar',
        value: function reloadCalendar() {
            var _this2 = this;

            return this.getSelectedTeamAndCalendars().then(function (_ref3) {
                var selectedCalendarIds = _ref3.selectedCalendarIds;
                return _this2.refreshCalendar(selectedCalendarIds);
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'getBalanceWarningThreshold',
        value: function getBalanceWarningThreshold(preferences) {
            var storedEnabled = this.storageService.getUserItem('balance-warning-threshold-enabled');
            var hasStoredEnabled = storedEnabled != null;
            var effectiveEnabled = hasStoredEnabled ? storedEnabled === true || storedEnabled === 'true' : !(preferences && preferences.balanceWarningThresholdEnabled === false);

            if (!effectiveEnabled) {
                return null;
            }

            var storedThreshold = this.storageService.getUserItem('balance-warning-threshold');
            var hasStoredThreshold = storedThreshold != null && storedThreshold !== '';
            var threshold = hasStoredThreshold ? storedThreshold : preferences && (preferences.balanceWarningThreshold || preferences.calendarBalanceWarningThreshold || preferences.balanceThreshold || preferences.calendarBalanceThreshold || preferences.warningBalanceThreshold);

            return Number.isFinite(+threshold) && +threshold > 0 ? +threshold : null;
        }
    }, {
        key: 'refreshVisibleCategoryMetadata',
        value: function refreshVisibleCategoryMetadata(updatedCategory) {
            var _this3 = this;

            if (updatedCategory && updatedCategory.id) {
                __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(this.days || [], function (day) {
                    var transactions = day && day.events ? day.events : [];

                    __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(transactions, function (transaction) {
                        var categoryId = transaction && transaction.category ? transaction.category.id : null;
                        if ('' + categoryId === '' + updatedCategory.id) {
                            transaction.category = __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge({}, transaction.category, updatedCategory);
                        }
                    });

                    if (day) {
                        day.filteredTransactions = _this3.filterDailyTransactions(day.events || []);
                    }
                });

                return null;
            }

            var activeTeamId = this.selectedTeam && this.selectedTeam.id ? this.selectedTeam.id : this.teamId;
            if (!activeTeamId) {
                return this.reloadCalendar();
            }

            return this.categoryService.getAll(activeTeamId, true).then(function (categories) {
                if (!categories || categories.length === 0) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(_this3.days || [], function (day) {
                    var transactions = day && day.events ? day.events : [];

                    __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(transactions, function (transaction) {
                        var categoryId = transaction && transaction.category ? transaction.category.id : null;
                        if (!categoryId) {
                            return;
                        }

                        var updatedCategory = _this3.getCategoryById(categories, categoryId);
                        if (updatedCategory) {
                            transaction.category = __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge({}, transaction.category, updatedCategory);
                        }
                    });

                    if (day) {
                        day.filteredTransactions = _this3.filterDailyTransactions(day.events || []);
                    }
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'getCategoryById',
        value: function getCategoryById(categories, categoryId) {
            return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(categories || [], function (category) {
                return category && category.id === categoryId;
            }) || null;
        }
    }, {
        key: 'selectTeamIdAndCalendarIds',
        value: function selectTeamIdAndCalendarIds(teamId, calendarIds, defaultTeamId, defaultCalendarIds) {
            var _this4 = this;

            var team = this.findTeamById(teamId);

            team = team ? team : defaultTeamId ? this.findTeamById(defaultTeamId) || this.getDefaultTeam() : this.getDefaultTeam();

            if (team) {
                calendarIds = calendarIds && calendarIds.length > 0 ? calendarIds : defaultCalendarIds || [];

                var calendars = __WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(calendarIds, function (calendarId) {
                    return _this4.getCalendarById(team.calendars || [], calendarId);
                });
                return this.selectTeamAndCalendars(team, calendars);
            }

            return this.selectTeamAndCalendars();
        }
    }, {
        key: 'selectTeamAndCalendars',
        value: function selectTeamAndCalendars(team, calendars) {
            var _this5 = this;

            if (!team && this.teams.length > 0) {
                return this.selectTeamAndCalendars(this.teams[0], calendars);
            }

            if (team) {
                calendars = team ? __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(calendars || [], function (calendar) {
                    return calendar && _this5.getCalendarById(team.calendars || [], calendar.id);
                }) : [];

                calendars = calendars.length > 0 ? calendars : team.calendars && team.calendars.length > 0 ? [team.calendars[0]] : [];
            } else {
                calendars = [];
            }

            if (!this.multiple) {
                calendars = calendars.slice(0, 1);
            }

            this.selectedTeam = team;
            this.selectedCalendarIds = calendars && calendars.length > 0 ? __WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(calendars, function (calendar) {
                return calendar.id;
            }) : [];
            this.canManageEvents = this.getEditableCalendars(calendars).length > 0;
            this.updateCalendarHighlight();

            this.storageService.setUserItem('selected-team', this.selectedTeam ? this.selectedTeam.id : null);
            this.storageService.setUserItem('selected-calendars', this.selectedCalendarIds);

            return this.getSelectedTeamAndCalendars().then(function (data) {
                var selectedTeam = data.selectedTeam,
                    selectedCalendarIds = data.selectedCalendarIds;


                return _this5.refreshCalendar(selectedCalendarIds, _this5.months, _this5.days).then(function () {
                    _this5.teamService.getNoteMapping(selectedTeam.id).then(function (mapping) {
                        _this5.suggestionService.initialize(selectedTeam.id, Object.keys(mapping));
                        _this5.autoCategoryService.initialize(selectedTeam.id, mapping);
                    }).catch(function () {
                        return null;
                    });

                    return data;
                });
            });
        }
    }, {
        key: 'updateCalendarHighlight',
        value: function updateCalendarHighlight() {
            var color = this.getCalendarHighlightColor();
            var palette = this.buildHighlightPalette(color);

            this.calendarHighlightPalette = palette;
            this.applyCalendarHighlight();
        }
    }, {
        key: 'applyCalendarHighlight',
        value: function applyCalendarHighlight() {
            if (!this.calendarRoot || !this.calendarHighlightPalette) {
                return;
            }

            this.calendarRoot.style.setProperty('--calendar-highlight-color', this.calendarHighlightPalette.base);
            this.calendarRoot.style.setProperty('--calendar-highlight-color-hover', this.calendarHighlightPalette.hover);
            this.calendarRoot.style.setProperty('--calendar-highlight-color-shadow', this.calendarHighlightPalette.shadow);
            this.calendarRoot.style.setProperty('--calendar-highlight-color-fade', this.calendarHighlightPalette.fade);
            this.calendarRoot.style.setProperty('--calendar-highlight-color-pulse', this.calendarHighlightPalette.pulse);
        }
    }, {
        key: 'getCalendarHighlightColor',
        value: function getCalendarHighlightColor() {
            if (this.calendarHighlightPreference !== 'selected') {
                return '#1196ea';
            }

            var selectedCalendar = this.getPrimarySelectedCalendar();
            if (selectedCalendar && selectedCalendar.color) {
                return selectedCalendar.color;
            }

            return '#1196ea';
        }
    }, {
        key: 'getPrimarySelectedCalendar',
        value: function getPrimarySelectedCalendar() {
            if (!this.selectedTeam || !this.selectedTeam.calendars || !this.selectedCalendarIds || this.selectedCalendarIds.length === 0) {
                return null;
            }

            for (var index = 0; index < this.selectedCalendarIds.length; index += 1) {
                var calendar = this.getCalendarById(this.selectedTeam.calendars, this.selectedCalendarIds[index]);
                if (calendar) {
                    return calendar;
                }
            }

            return null;
        }
    }, {
        key: 'buildHighlightPalette',
        value: function buildHighlightPalette(color) {
            var rgb = this.parseColorToRgb(color);

            if (!rgb) {
                return null;
            }

            var hover = this.adjustColor(rgb, -0.18);

            return {
                base: this.rgbToCss(rgb),
                hover: this.rgbToCss(hover),
                shadow: this.rgbToRgba(rgb, 0.5),
                fade: this.rgbToRgba(rgb, 0.5),
                pulse: this.rgbToRgba(rgb, 0.3)
            };
        }
    }, {
        key: 'parseColorToRgb',
        value: function parseColorToRgb(color) {
            if (!color || typeof color !== 'string') {
                return null;
            }

            var trimmed = color.trim();

            if (trimmed.startsWith('#')) {
                return this.hexToRgb(trimmed);
            }

            return this.rgbStringToRgb(trimmed);
        }
    }, {
        key: 'hexToRgb',
        value: function hexToRgb(hex) {
            var value = hex.replace('#', '');

            if (value.length === 3) {
                value = value.split('').map(function (char) {
                    return char + char;
                }).join('');
            }

            if (value.length !== 6) {
                return null;
            }

            var number = parseInt(value, 16);
            return {
                r: number >> 16 & 255,
                g: number >> 8 & 255,
                b: number & 255
            };
        }
    }, {
        key: 'rgbStringToRgb',
        value: function rgbStringToRgb(value) {
            var match = value.match(/^rgba?\(([^)]+)\)$/i);

            if (!match) {
                return null;
            }

            var parts = match[1].split(',').map(function (part) {
                return part.trim();
            });

            if (parts.length < 3) {
                return null;
            }

            var red = parseFloat(parts[0]);
            var green = parseFloat(parts[1]);
            var blue = parseFloat(parts[2]);

            if ([red, green, blue].some(function (component) {
                return Number.isNaN(component);
            })) {
                return null;
            }

            return {
                r: Math.max(0, Math.min(255, red)),
                g: Math.max(0, Math.min(255, green)),
                b: Math.max(0, Math.min(255, blue))
            };
        }
    }, {
        key: 'adjustColor',
        value: function adjustColor(color, amount) {
            var factor = 1 + amount;

            return {
                r: Math.max(0, Math.min(255, Math.round(color.r * factor))),
                g: Math.max(0, Math.min(255, Math.round(color.g * factor))),
                b: Math.max(0, Math.min(255, Math.round(color.b * factor)))
            };
        }
    }, {
        key: 'rgbToCss',
        value: function rgbToCss(color) {
            return 'rgb(' + color.r + ', ' + color.g + ', ' + color.b + ')';
        }
    }, {
        key: 'rgbToRgba',
        value: function rgbToRgba(color, alpha) {
            return 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + alpha + ')';
        }
    }, {
        key: 'selectCalendar',
        value: function selectCalendar(team, calendar) {
            var _this6 = this;

            return this.getSelectedTeamAndCalendars().then(function (_ref4) {
                var selectedCalendarIds = _ref4.selectedCalendarIds;

                var filteredCalendarIds = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(selectedCalendarIds, function (id) {
                    return id !== calendar.id;
                });

                if (filteredCalendarIds.length === 0 || filteredCalendarIds.length === selectedCalendarIds.length) {
                    filteredCalendarIds.unshift(calendar.id);
                }

                return _this6.selectTeamIdAndCalendarIds(team.id, __WEBPACK_IMPORTED_MODULE_0_lodash_uniqBy___default()(filteredCalendarIds));
            });
        }
    }, {
        key: 'selectTeam',
        value: function selectTeam(team) {
            return this.selectTeamIdAndCalendarIds(team.id, []);
        }
    }, {
        key: 'getSelectedTeamAndCalendars',
        value: function getSelectedTeamAndCalendars() {
            var _this7 = this;

            return this.$q(function (resolve, reject) {
                if (_this7.selectedTeam) {
                    return resolve({
                        selectedTeam: _this7.selectedTeam,
                        selectedCalendarIds: _this7.selectedCalendarIds || []
                    });
                }

                return reject('No team is selected.');
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            if (this.dailyRefreshId) {
                this.dailyRefreshId();
            }

            if (this.pollRefreshId) {
                this.pollRefreshId();
            }

            this.suggestionService.reset();
            this.autoCategoryService.reset();
        }
    }, {
        key: 'handleDefaultCalendarNotification',
        value: function handleDefaultCalendarNotification(plan, teams) {
            var planExpired = plan.expired && !plan.free;
            var hasDefaultCalendar = __WEBPACK_IMPORTED_MODULE_5_lodash_some___default()(teams, function (team) {
                return __WEBPACK_IMPORTED_MODULE_5_lodash_some___default()(team.calendars, function (calendar) {
                    return calendar.default;
                });
            });

            if (planExpired && !hasDefaultCalendar) {
                this.notificationService.show({
                    component: 'dbARenewSubscriptionNotification',
                    id: 'renew-subscription',
                    bindings: {
                        plan: teams[0].plan,
                        onSelect: this.selectDefaultCalendar.bind(this)
                    }
                }, true, 0);
            }
        }
    }, {
        key: 'selectDefaultCalendar',
        value: function selectDefaultCalendar() {
            var _this8 = this;

            return this.loadTeams().then(function (teams) {
                var calendars = __WEBPACK_IMPORTED_MODULE_3_lodash_reduce___default()(teams, function (calendars, team) {
                    return calendars.concat(team.calendars);
                }, []);

                var promise = calendars.length > 1 ? _this8.modalService.open({
                    component: 'dbACalendarSelectDefaultModal',
                    bindings: {
                        teams: __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(teams, function (team) {
                            return team.calendars && team.calendars.length > 0;
                        })
                    }
                }) : _this8.$q.resolve(calendars[0]);

                return promise.then(function (calendar) {
                    return _this8.calendarService.markAsDefault(calendar).then(function () {
                        _this8.notificationService.show({
                            component: 'dbATextNotification',
                            id: 'default-calendar',
                            bindings: {
                                title: 'All good!',
                                message: calendar.name + ' has been marked as your default calendar.'
                            }
                        });

                        return _this8.loadTeams().then(function () {
                            return _this8.getSelectedTeamAndCalendars().then(function (_ref5) {
                                var selectedTeam = _ref5.selectedTeam,
                                    selectedCalendarIds = _ref5.selectedCalendarIds;

                                return _this8.selectTeamIdAndCalendarIds(selectedTeam.id, selectedCalendarIds);
                            });
                        });
                    });
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'createMonths',
        value: function createMonths(timestamp) {
            timestamp = __WEBPACK_IMPORTED_MODULE_8_moment___default()(timestamp).startOf('year').valueOf();

            var months = [];

            for (var index = 0; index < 12; ++index) {
                var date = __WEBPACK_IMPORTED_MODULE_8_moment___default()(timestamp).add(index, 'month');

                months.push({
                    timestamp: date.valueOf(),
                    name: date.format('MMMM'),
                    change: 0,
                    balance: 0
                });
            }

            return months;
        }
    }, {
        key: 'createWeekdays',
        value: function createWeekdays() {
            return this.timeUtil.getWeekdays(this.startOfWeek).map(function (day) {
                return {
                    name: __WEBPACK_IMPORTED_MODULE_8_moment___default()(day.timestamp).format('dddd'),
                    weekend: day.weekend
                };
            });
        }
    }, {
        key: 'createDays',
        value: function createDays(timestamp, days) {
            days = days || [];

            return this.timeUtil.getDaysForMonth(timestamp, this.startOfWeek).map(function (day, index) {
                return __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge(days[index] || {}, {
                    timestamp: day.timestamp,
                    date: __WEBPACK_IMPORTED_MODULE_8_moment___default()(day.timestamp).date(),
                    another: day.previous || day.next,
                    today: day.today
                });
            });
        }
    }, {
        key: 'selectMonth',
        value: function selectMonth(timestamp) {
            var selected = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.timestamp);
            var target = __WEBPACK_IMPORTED_MODULE_8_moment___default()(timestamp);

            if (target.year() !== selected.year()) {
                return this.refreshMonthlyBalances(timestamp);
            }

            return this.refreshDailyBalances(timestamp);
        }
    }, {
        key: 'refreshDailyBalances',
        value: function refreshDailyBalances(timestamp) {
            var _this9 = this;

            return this.getSelectedTeamAndCalendars().then(function (_ref6) {
                var selectedCalendarIds = _ref6.selectedCalendarIds;

                timestamp = __WEBPACK_IMPORTED_MODULE_8_moment___default()(timestamp).startOf('month').valueOf();

                var days = _this9.createDays(timestamp);

                return _this9.loadDailyBalances(selectedCalendarIds, days).catch(function (result) {
                    _this9.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to load your transactions for this year. Please try again later.'));
                }).finally(function () {
                    _this9.days = days;
                    _this9.timestamp = timestamp;
                });
            });
        }
    }, {
        key: 'refreshMonthlyBalances',
        value: function refreshMonthlyBalances(timestamp) {
            var _this10 = this;

            return this.getSelectedTeamAndCalendars().then(function (data) {
                var selectedCalendarIds = data.selectedCalendarIds;

                var months = _this10.createMonths(timestamp);

                return _this10.$q.all([_this10.loadMonthlyBalances(selectedCalendarIds, months), _this10.refreshDailyBalances(timestamp)]).then(function () {
                    return data;
                }).catch(function (result) {
                    _this10.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to load your balances for this month. Please try again later.'));
                }).finally(function () {
                    return _this10.months = months;
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'selectSpecificMonth',
        value: function selectSpecificMonth(timestamp) {
            __WEBPACK_IMPORTED_MODULE_9_common_analytics__["c" /* default */].trackCalendarSpecificMonthSelect();

            return this.selectMonth(timestamp);
        }
    }, {
        key: 'selectPreviousMonth',
        value: function selectPreviousMonth() {
            __WEBPACK_IMPORTED_MODULE_9_common_analytics__["c" /* default */].trackCalendarPreviousMonthSelect();

            return this.selectMonth(__WEBPACK_IMPORTED_MODULE_8_moment___default()(this.timestamp).subtract(1, 'month').startOf('month'));
        }
    }, {
        key: 'selectNextMonth',
        value: function selectNextMonth() {
            __WEBPACK_IMPORTED_MODULE_9_common_analytics__["c" /* default */].trackCalendarNextMonthSelect();

            return this.selectMonth(__WEBPACK_IMPORTED_MODULE_8_moment___default()(this.timestamp).add(1, 'month').startOf('month'));
        }
    }, {
        key: 'selectToday',
        value: function selectToday() {
            __WEBPACK_IMPORTED_MODULE_9_common_analytics__["c" /* default */].trackCalendarTodaySelect();

            return this.selectMonth(__WEBPACK_IMPORTED_MODULE_8_moment___default()().startOf('month').valueOf());
        }
    }, {
        key: 'refreshCalendar',
        value: function refreshCalendar(calendarIds) {
            var _this11 = this;

            return this.$q.all([this.loadMonthlyBalances(calendarIds, this.months), this.loadDailyBalances(calendarIds, this.days)]).catch(function (result) {
                _this11.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to refresh your calendar. You might not have access to this calendar anymore or somebody else logged in in your browser. Please reload the page.'));
            });
        }
    }, {
        key: 'loadMonthlyBalances',
        value: function loadMonthlyBalances(calendarIds, months) {
            var _this12 = this;

            ++this.loadingMonthlyBalances;

            return this.balanceService.getMonthlyBalances(calendarIds, __WEBPACK_IMPORTED_MODULE_8_moment___default()(months[0].timestamp).valueOf(), __WEBPACK_IMPORTED_MODULE_8_moment___default()(months[months.length - 1].timestamp).endOf('month').valueOf()).then(function (monthlyBalances) {
                monthlyBalances.forEach(function (monthlyBalance) {
                    var month = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(months, function (month) {
                        return month.timestamp === monthlyBalance.timestamp;
                    });
                    if (month) {
                        month.change = monthlyBalance.revenue;
                        month.balance = monthlyBalance.balance;
                    }
                });
            }).finally(function () {
                return --_this12.loadingMonthlyBalances;
            });
        }
    }, {
        key: 'loadDailyBalances',
        value: function loadDailyBalances(calendarIds, days) {
            var _this13 = this;

            ++this.loadingDailyBalances;

            var from = days[0].timestamp;
            var to = __WEBPACK_IMPORTED_MODULE_8_moment___default()(days[days.length - 1].timestamp).endOf('day').valueOf();

            return this.balanceService.getDailyBalances(calendarIds, from, to).then(function (data) {
                var dailyBalances = data.dailyBalances || [];
                var events = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(data.transactions || [], function (event) {
                    return !event.autoForecasted;
                });

                var unmatchedBalances = [];
                var placed = [];
                var spans = _this13.buildDaySpans(days);
                var matchedByRange = 0;

                dailyBalances.forEach(function (dailyBalance) {
                    var day = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(days, function (day) {
                        return day.timestamp === dailyBalance.timestamp;
                    });

                    if (!day) {
                        var span = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(spans, function (span) {
                            return dailyBalance.timestamp >= span.start && dailyBalance.timestamp < span.end;
                        });

                        if (span) {
                            day = span.day;
                            ++matchedByRange;
                        }
                    }

                    if (day) {
                        day.change = dailyBalance.revenue;
                        day.balance = dailyBalance.balance;
                        day.events = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(events, function (event) {
                            return _this13.eventUtil.happenedOn(event, day.timestamp);
                        });
                        day.filteredTransactions = _this13.filterDailyTransactions(day.events);

                        __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(day.events, function (event) {
                            if (placed.indexOf(event) < 0) {
                                placed.push(event);
                            }
                        });
                    } else {
                        unmatchedBalances.push(dailyBalance.timestamp);
                    }
                });

                _this13.logDayPlacement(calendarIds, days, from, to, dailyBalances, events, placed, unmatchedBalances, matchedByRange);
            }).finally(function () {
                return --_this13.loadingDailyBalances;
            });
        }

        /**
         * The half open [start, end) instant range each day cell covers.
         *
         * The day cells and the buckets in the response are derived independently: we build cells from
         * the browser's idea of local midnight, the backend builds buckets from the timezone the
         * request declared. Matching the two on exact equality assumes those never disagree, and when
         * they do every cell past the disagreement silently renders empty rather than failing loudly.
         *
         * A machine whose timezone is stuck on one side of a daylight saving change is enough to cause
         * it: the cells walk in fixed offset steps while the buckets step to real local midnights, so
         * from the transition onwards the two are an hour apart and nothing matches. Placing a bucket
         * on the cell whose range contains it survives that, and is identical to exact matching when
         * the two agree, which is the case for a correctly configured browser.
         *
         * The last cell's end is derived by adding a day rather than read from the next cell, so the
         * trailing bucket the backend emits past the end of the grid still falls outside every span
         * and is ignored, exactly as before.
         */

    }, {
        key: 'buildDaySpans',
        value: function buildDaySpans(days) {
            return __WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(days, function (day, index) {
                return {
                    day: day,
                    start: day.timestamp,
                    end: index + 1 < days.length ? days[index + 1].timestamp : __WEBPACK_IMPORTED_MODULE_8_moment___default()(day.timestamp).add(1, 'day').valueOf()
                };
            });
        }

        /**
         * Records how much of the /calendars/days response actually landed on a day cell.
         *
         * A transaction the server returned but no day claimed is invisible to the user with nothing
         * logged anywhere, which is the state a blank calendar leaves us guessing about. Logging the
         * counts separates the two candidate causes: nothing returned means the series was not
         * generated server side, while something returned but not placed means the day grid and the
         * response disagree about which day an instant belongs to.
         *
         * Only ids and timestamps are recorded, never amounts, notes or categories, so this is safe to
         * leave on for every user.
         */

    }, {
        key: 'logDayPlacement',
        value: function logDayPlacement(calendarIds, days, from, to, dailyBalances, events, placed, unmatchedBalances, matchedByRange) {
            if (!this.diagnosticsService) {
                return;
            }

            var orphans = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(events, function (event) {
                return placed.indexOf(event) < 0;
            });

            this.diagnosticsService.info('calendar_days_loaded', {
                calendarIds: calendarIds,
                from: from,
                to: to,
                browserTimezone: this.getBrowserTimezone(),
                gridDays: days.length,
                gridFirst: days[0].timestamp,
                gridLast: days[days.length - 1].timestamp,
                // Non zero means this browser's day cells disagree with the backend's buckets and the
                // calendar only rendered because of the range fallback. Worth noticing rather than
                // silently relying on.
                balancesMatchedByRange: matchedByRange,
                balancesReturned: dailyBalances.length,
                balancesMatched: dailyBalances.length - unmatchedBalances.length,
                unmatchedBalanceSample: unmatchedBalances.slice(0, 5),
                eventsReturned: events.length,
                eventsPlaced: placed.length,
                orphanCount: orphans.length,
                orphanSample: __WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(orphans.slice(0, 5), function (event) {
                    return {
                        timestamp: event.timestamp,
                        transactionDate: event.transactionDate,
                        repeating: event.repeating,
                        templateId: event.templateId,
                        calendarId: event.calendarId
                    };
                })
            });
        }
    }, {
        key: 'getBrowserTimezone',
        value: function getBrowserTimezone() {
            try {
                return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
            } catch (error) {
                return null;
            }
        }
    }, {
        key: 'getDefaultCalendar',
        value: function getDefaultCalendar(team) {
            return team.calendars[0];
        }
    }, {
        key: 'getDefaultTeam',
        value: function getDefaultTeam() {
            return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.teams || [], function (team) {
                return team && team.calendars.length > 0;
            });
        }
    }, {
        key: 'getTeamById',
        value: function getTeamById(teamId) {
            return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.teams || [], function (team) {
                return team && team.id === teamId;
            });
        }
    }, {
        key: 'findCalendarById',
        value: function findCalendarById(calendarId) {
            var _this14 = this;

            return __WEBPACK_IMPORTED_MODULE_3_lodash_reduce___default()(this.teams || [], function (calendar, team) {
                return calendar || _this14.getCalendarById(team.calendars, calendarId);
            }, null);
        }
    }, {
        key: 'findTeamThatHasCalendarId',
        value: function findTeamThatHasCalendarId(calendarId) {
            return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.teams || [], function (team) {
                return __WEBPACK_IMPORTED_MODULE_5_lodash_some___default()(team.calendars || [], function (calendar) {
                    return calendar.id === calendarId;
                });
            });
        }
    }, {
        key: 'getCalendarById',
        value: function getCalendarById(calendars, calendarId) {
            return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(calendars || [], function (calendar) {
                return calendar.id === calendarId;
            });
        }
    }, {
        key: 'loadTeams',
        value: function loadTeams(promise) {
            var _this15 = this;

            ++this.loadingTeams;

            promise = promise || this.sessionService.reload();

            return promise.then(function (data) {
                if (_this15.user && data.user && _this15.user.id !== data.user.id) {
                    return _this15.$q.reject('We were not able to refresh your calendar. You might not have access to this calendar anymore or somebody else logged in in your browser. Please reload the page.');
                }

                _this15.user = data.user || {};
                _this15.plan = data.plan || {};
                _this15.plan.paid = !!_this15.plan.subscription && !!_this15.plan.subscription.type;

                _this15.teams = __WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(data.teams, _this15.decorateTeamWithPermissions.bind(_this15, _this15.user));

                if (_this15.selectedTeam) {
                    _this15.selectedTeam = _this15.findTeamById(_this15.selectedTeam.id);
                    if (!_this15.selectedTeam) {
                        return _this15.selectTeamIdAndCalendarIds().then(function () {
                            return _this15.teams;
                        }).catch(function () {
                            return _this15.teams;
                        });
                    }
                }

                _this15.updateCalendarHighlight();

                return _this15.teams;
            }).catch(function (result) {
                _this15.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were unable to load your teams and calendars. Please reload the page.'));

                return _this15.$q.reject(result);
            }).finally(function () {
                return --_this15.loadingTeams;
            });
        }
    }, {
        key: 'decorateTeamWithPermissions',
        value: function decorateTeamWithPermissions(user, team) {
            return __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge({}, team, {
                permissions: {
                    edit: Object(__WEBPACK_IMPORTED_MODULE_10_application_util__["k" /* hasPermission */])(team.permissions, __WEBPACK_IMPORTED_MODULE_10_application_util__["g" /* PERMISSION_TEAM_EDIT */]),
                    delete: Object(__WEBPACK_IMPORTED_MODULE_10_application_util__["k" /* hasPermission */])(team.permissions, __WEBPACK_IMPORTED_MODULE_10_application_util__["f" /* PERMISSION_TEAM_DELETE */]),
                    addCalendar: Object(__WEBPACK_IMPORTED_MODULE_10_application_util__["k" /* hasPermission */])(team.permissions, __WEBPACK_IMPORTED_MODULE_10_application_util__["d" /* PERMISSION_TEAM_ADD_CALENDAR */]),
                    addMember: Object(__WEBPACK_IMPORTED_MODULE_10_application_util__["k" /* hasPermission */])(team.permissions, __WEBPACK_IMPORTED_MODULE_10_application_util__["e" /* PERMISSION_TEAM_ADD_MEMBER */]),
                    manageEvents: Object(__WEBPACK_IMPORTED_MODULE_10_application_util__["k" /* hasPermission */])(team.permissions, __WEBPACK_IMPORTED_MODULE_10_application_util__["i" /* PERMISSION_TEAM_MANAGE_EVENTS */]),
                    manageCategories: Object(__WEBPACK_IMPORTED_MODULE_10_application_util__["k" /* hasPermission */])(team.permissions, __WEBPACK_IMPORTED_MODULE_10_application_util__["h" /* PERMISSION_TEAM_MANAGE_CATEGORIES */])
                },
                calendars: __WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(team.calendars, this.decorateCalendarWithPermissions.bind(this)),
                owner: {
                    isMe: !!team.owner && !!user && team.owner.id === user.id
                }
            });
        }
    }, {
        key: 'decorateCalendarWithPermissions',
        value: function decorateCalendarWithPermissions(calendar) {
            return __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge({}, calendar, {
                permissions: {
                    edit: Object(__WEBPACK_IMPORTED_MODULE_10_application_util__["k" /* hasPermission */])(calendar.permissions, __WEBPACK_IMPORTED_MODULE_10_application_util__["b" /* PERMISSION_CALENDAR_EDIT */]),
                    delete: Object(__WEBPACK_IMPORTED_MODULE_10_application_util__["k" /* hasPermission */])(calendar.permissions, __WEBPACK_IMPORTED_MODULE_10_application_util__["a" /* PERMISSION_CALENDAR_DELETE */]),
                    manageEvents: Object(__WEBPACK_IMPORTED_MODULE_10_application_util__["k" /* hasPermission */])(calendar.permissions, __WEBPACK_IMPORTED_MODULE_10_application_util__["c" /* PERMISSION_CALENDAR_MANAGE_EVENTS */])
                }
            });
        }
    }, {
        key: 'openCalendarList',
        value: function openCalendarList() {
            var _this16 = this;

            this.toggleNavigationBar(true);

            this.loadTeams().catch(function (result) {
                _this16.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to refresh your teams and calendars. Please try again later.'));
                return _this16.$q.reject(result);
            });
        }
    }, {
        key: 'toggleNavigationBar',
        value: function toggleNavigationBar(visible) {
            this.navigationBarVisible = !!visible;
        }
    }, {
        key: 'openCalendar',
        value: function openCalendar(team, calendar) {
            return this.modalService.open({
                component: 'dbACalendarEditModal',
                bindings: {
                    teamId: team.id,
                    calendar: __WEBPACK_IMPORTED_MODULE_7_angular___default.a.extend({}, calendar)
                }
            });
        }
    }, {
        key: 'editCalendar',
        value: function editCalendar(team, calendar) {
            var _this17 = this;

            return this.getSelectedTeamAndCalendars().then(function (data) {
                var selectedTeam = data.selectedTeam,
                    selectedCalendarIds = data.selectedCalendarIds;


                return _this17.openCalendar(team, calendar).then(function (updatedCalendar) {
                    if (updatedCalendar && updatedCalendar.id) {
                        _this17.applyCalendarUpdate(updatedCalendar);
                        _this17.updateCalendarHighlight();
                    }

                    return _this17.loadTeams().then(function () {
                        if (team && selectedTeam && selectedTeam.id === team.id) {
                            team = _this17.findTeamById(team.id);
                            return _this17.selectTeamIdAndCalendarIds(team ? team.id : null, selectedCalendarIds);
                        }

                        return data;
                    });
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'addCalendar',
        value: function addCalendar(team) {
            var _this18 = this;

            return this.openCalendar(team).then(function (calendar) {
                return _this18.loadTeams().then(function () {
                    return _this18.selectCalendar(team, calendar);
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'applyCalendarUpdate',
        value: function applyCalendarUpdate(updatedCalendar) {
            if (!updatedCalendar || !updatedCalendar.id) {
                return;
            }

            (this.teams || []).forEach(function (team) {
                if (!team || !team.calendars) {
                    return;
                }

                team.calendars = team.calendars.map(function (calendar) {
                    if (calendar && calendar.id === updatedCalendar.id) {
                        return __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge({}, calendar, updatedCalendar);
                    }

                    return calendar;
                });
            });

            if (this.selectedTeam && this.selectedTeam.calendars) {
                this.selectedTeam.calendars = this.selectedTeam.calendars.map(function (calendar) {
                    if (calendar && calendar.id === updatedCalendar.id) {
                        return __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge({}, calendar, updatedCalendar);
                    }

                    return calendar;
                });
            }
        }
    }, {
        key: 'deleteCalendar',
        value: function deleteCalendar(team, calendar) {
            var _this19 = this;

            return this.modalService.open({
                component: 'dbAConfirmModal',
                bindings: {
                    title: 'Delete calendar',
                    message: ['Deleting a calendar cannot be undone. All the events added to this calendar will be erased.', 'Are you still sure about it?']
                }
            }).then(function () {
                return _this19.calendarService.remove(calendar).catch(function (result) {
                    _this19.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to delete the calendar.'));
                    return _this19.$q.reject(result);
                }).then(function () {
                    return _this19.loadTeams().then(function () {
                        return _this19.selectCalendar(team, calendar);
                    });
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'openTeam',
        value: function openTeam(team) {
            // TODO move the can manage collaborators permission to the backend and use that instead

            return this.modalService.open({
                component: 'dbATeamEditModal',
                bindings: {
                    team: team,
                    canEdit: team ? team.permissions.edit : true,
                    canDelete: team ? team.permissions.delete : false,
                    canManageCategories: team ? team.permissions.manageCategories : false,
                    canManageCollaborators: team ? this.isTeamOwnedBy(team, this.user) && this.canManageCollaboratorsByPlan(this.plan) : this.canManageCollaboratorsByPlan(this.plan)
                }
            });
        }
    }, {
        key: 'isTeamOwnedBy',
        value: function isTeamOwnedBy(team, user) {
            return team.owner.id === user.id;
        }
    }, {
        key: 'canManageCollaboratorsByPlan',
        value: function canManageCollaboratorsByPlan(plan) {
            return Object(__WEBPACK_IMPORTED_MODULE_13_common_util_plan_util__["a" /* getMaxNumberOfCollaborators */])(plan) > 0;
        }
    }, {
        key: 'addTeam',
        value: function addTeam() {
            var _this20 = this;

            return this.openTeam().then(function (team) {
                return _this20.loadTeams().then(function () {
                    return _this20.selectCalendar(team, []);
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'editTeam',
        value: function editTeam(team) {
            var _this21 = this;

            return this.openTeam(team).then(function (team) {
                return _this21.loadTeams().then(function () {
                    var exists = !!_this21.findTeamById(team.id);
                    var selectedTeam = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(_this21.teams, function (item) {
                        return item.id !== team.id;
                    });

                    if (!exists) {
                        return _this21.selectCalendar(selectedTeam, []);
                    }
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'findTeamById',
        value: function findTeamById(id) {
            return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.teams, function (team) {
                return team.id === id;
            });
        }
    }, {
        key: 'getEditableCalendars',
        value: function getEditableCalendars(calendars) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(calendars, function (calendar) {
                return calendar.permissions.manageEvents;
            });
        }
    }, {
        key: 'listEvents',
        value: function listEvents(day) {
            var _this22 = this;

            return this.getSelectedTeamAndCalendars().then(function (_ref7) {
                var selectedCalendarIds = _ref7.selectedCalendarIds;

                return _this22.modalService.open({
                    component: 'dbAEventListModal',
                    bindings: {
                        timestamp: day.timestamp,
                        balance: function balance() {
                            return day.balance;
                        },
                        change: function change() {
                            return day.change;
                        },
                        events: function events() {
                            return day.events;
                        },
                        canAddEvent: _this22.canManageEvents,
                        onTransactionCreate: function onTransactionCreate(timestamp) {
                            var day = _this22.getDayByTimestamp(_this22.days, timestamp);
                            return _this22.addEvent(day, 'list');
                        },
                        onTransactionEdit: function onTransactionEdit(transaction) {
                            return _this22.editEvent(transaction, 'list');
                        },
                        onTransactionConfirmChange: function onTransactionConfirmChange(transaction) {
                            if (_this22.canEditTransaction(transaction)) {
                                var promise = transaction.templateId ? _this22.eventService.updateRepeating(transaction, transaction.repeat.occurrence) : _this22.eventService.update(transaction);

                                return promise.then(function (transaction) {
                                    __WEBPACK_IMPORTED_MODULE_9_common_analytics__["c" /* default */].trackTransactionConfirmChange(transaction.confirmed);

                                    return _this22.refreshCalendar(selectedCalendarIds, _this22.months, _this22.days);
                                }).catch(function (result) {
                                    _this22.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to ' + (transaction.confirmed ? '' : 'un') + 'confirm the transaction. Please try again later.'));
                                });
                            }

                            return _this22.$q.reject('We were unable to edit the transaction.');
                        }
                    }
                }).then(_this22.refreshCalendar.bind(_this22, selectedCalendarIds, _this22.months, _this22.days));
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'canEditTransaction',
        value: function canEditTransaction(transaction) {
            var calendar = this.findCalendarById(transaction.calendarId);
            return calendar && calendar.permissions.manageEvents;
        }
    }, {
        key: 'getDayByTimestamp',
        value: function getDayByTimestamp(days, timestamp) {
            var day = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(days, function (day) {
                return day.timestamp === timestamp;
            });
            return __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge({}, day || {});
        }
    }, {
        key: 'addEvent',
        value: function addEvent(day, from) {
            var _this23 = this;

            var now = __WEBPACK_IMPORTED_MODULE_8_moment___default()();
            var date = __WEBPACK_IMPORTED_MODULE_8_moment___default()(day.timestamp);

            date.hour(now.hour()).minute(now.minute()).second(now.second());

            return this.eventService.getInitial(date.valueOf()).then(function (event) {
                event.transactionDate = _this23.timeUtil.toTransactionDate(day.timestamp);
                return _this23.editEvent(event, from);
            });
        }
    }, {
        key: 'toggleMultiple',
        value: function toggleMultiple(multiple) {
            var _this24 = this;

            this.multiple = multiple;
            this.storageService.setUserItem('multiple-calendars', this.multiple);

            return this.getSelectedTeamAndCalendars().then(function (_ref8) {
                var selectedTeam = _ref8.selectedTeam,
                    selectedCalendarIds = _ref8.selectedCalendarIds;

                return _this24.selectTeamIdAndCalendarIds(selectedTeam.id, selectedCalendarIds);
            });
        }
    }, {
        key: 'editEvent',
        value: function editEvent(event, from) {
            var _this25 = this;

            return this.getSelectedTeamAndCalendars().then(function (_ref9) {
                var selectedTeam = _ref9.selectedTeam,
                    selectedCalendarIds = _ref9.selectedCalendarIds;

                var editableCalendars = _this25.getEditableCalendars(selectedTeam.calendars);
                var calendarIds = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(selectedCalendarIds, function (calendarId) {
                    return _this25.getCalendarById(editableCalendars, calendarId);
                });

                var calendar = event.calendarId ? _this25.findCalendarById(event.calendarId) : _this25.findCalendarById(calendarIds[0]);

                if (!calendar) {
                    return _this25.$q.reject('We couldn\'t find the calendar this event is added to.');
                }

                return _this25.modalService.open({
                    component: 'dbAEventEditModal',
                    bindings: {
                        teamId: selectedTeam.id,
                        calendarIds: calendarIds,
                        calendars: selectedTeam.calendars,
                        event: __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge({}, event),
                        startOfWeek: _this25.startOfWeek,
                        autoCategorization: _this25.autoCategorization,
                        from: from || 'calendar',
                        canEdit: calendar.permissions.manageEvents,
                        canDelete: calendar.permissions.manageEvents,
                        canManageCategories: selectedTeam.permissions.manageCategories
                    }
                }).then(function () {
                    return _this25.loadTeams().then(_this25.refreshCalendar.bind(_this25, selectedCalendarIds, _this25.months, _this25.days));
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'moveEvent',
        value: function moveEvent(day, event) {
            var _this26 = this;

            var target = __WEBPACK_IMPORTED_MODULE_8_moment___default()(day.timestamp);
            var source = __WEBPACK_IMPORTED_MODULE_8_moment___default()(event.timestamp);

            source.year(target.year());
            source.month(target.month());
            source.date(target.date());

            var changes = {
                timestamp: source.valueOf(),
                transactionDate: this.timeUtil.toTransactionDate(day.timestamp)
            };

            event = __WEBPACK_IMPORTED_MODULE_7_angular___default.a.merge(event, changes);

            var promise = event.templateId ? this.eventService.updateRepeating(event, event.repeat.occurrence) : this.eventService.update(event);

            return this.getSelectedTeamAndCalendars().then(function (_ref10) {
                var selectedCalendarIds = _ref10.selectedCalendarIds;

                return promise.finally(function () {
                    __WEBPACK_IMPORTED_MODULE_9_common_analytics__["c" /* default */].trackTransactionMove(event);
                    return _this26.refreshCalendar(selectedCalendarIds, _this26.months, _this26.days);
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'updateEventLimit',
        value: function updateEventLimit(limit) {
            this.limit = limit;
        }
    }, {
        key: 'initializeTransactionsByEmailNotification',
        value: function initializeTransactionsByEmailNotification() {
            var saved = this.storageService.getUserItem(TRANSACTIONS_BY_EMAIL_NOTIFICATION_KEY);
            this.showTransactionsByEmailNotification = saved == null ? true : !!saved;
        }
    }, {
        key: 'dismissTransactionsByEmailNotification',
        value: function dismissTransactionsByEmailNotification() {
            this.showTransactionsByEmailNotification = false;
            this.storageService.setUserItem(TRANSACTIONS_BY_EMAIL_NOTIFICATION_KEY, false);
        }
    }, {
        key: 'openTransactionsByEmailModal',
        value: function openTransactionsByEmailModal(team) {
            if (!team || !team.id) {
                return this.$q.resolve();
            }

            return this.modalService.open({
                component: 'dbAEmailIngestTokenModal',
                bindings: {
                    teamId: team.id,
                    teamName: team.name
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'openTransactionsByEmailFromShortcut',
        value: function openTransactionsByEmailFromShortcut() {
            this.dismissTransactionsByEmailNotification();
            return this.openTransactionsByEmailModal(this.selectedTeam);
        }
    }, {
        key: 'searchTransactionsByTerms',
        value: function searchTransactionsByTerms(terms) {
            var _this27 = this;

            this.searchTerms = terms;

            __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(this.days, function (day) {
                day.filteredTransactions = _this27.filterDailyTransactions(day.events);
            });

            if (!this.hasSearchedBefore) {
                this.hasSearchedBefore = true;

                __WEBPACK_IMPORTED_MODULE_9_common_analytics__["c" /* default */].trackTransactionSearch();
            }
        }
    }, {
        key: 'filterDailyTransactions',
        value: function filterDailyTransactions(transactions) {
            var _this28 = this;

            return this.searchTerms && this.searchTerms.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(transactions, function (transaction) {
                return Object(__WEBPACK_IMPORTED_MODULE_14_application_util_transaction_util__["g" /* transactionHasTerms */])(transaction, _this28.searchTerms);
            }) : transactions;
        }
    }, {
        key: 'reorderCalendars',
        value: function reorderCalendars(team, order) {
            var _this29 = this;

            return this.calendarService.reorder(team.id, __WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(order, function (calendar) {
                return calendar.id;
            })).catch(function (result) {
                _this29.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to reorder your calendars. Please try again later.'));
            }).finally(function () {
                return _this29.loadTeams().then(function () {
                    return _this29.getSelectedTeamAndCalendars().then(function (_ref11) {
                        var selectedTeam = _ref11.selectedTeam,
                            selectedCalendarIds = _ref11.selectedCalendarIds;

                        return _this29.selectTeamIdAndCalendarIds(selectedTeam.id, selectedCalendarIds);
                    });
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'reorderTeams',
        value: function reorderTeams(order) {
            var _this30 = this;

            return this.teamService.reorder(__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(order, function (team) {
                return team.id;
            })).catch(function (result) {
                _this30.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_11_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to reorder your teams. Please try again later.'));
            }).finally(function () {
                return _this30.loadTeams().then(function () {
                    return _this30.getSelectedTeamAndCalendars().then(function (_ref12) {
                        var selectedTeam = _ref12.selectedTeam,
                            selectedCalendarIds = _ref12.selectedCalendarIds;

                        return _this30.selectTeamIdAndCalendarIds(selectedTeam.id, selectedCalendarIds);
                    });
                });
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'canCaptureShortcuts',
        get: function get() {
            return this.selectedCalendarIds && this.selectedCalendarIds.length > 0 && !this.navigationBarVisible && this.modalService.modals.length === 0;
        }
    }, {
        key: 'shouldShowTransactionsByEmailShortcut',
        get: function get() {
            return !!this.showTransactionsByEmailNotification && !!this.selectedTeam;
        }
    }]);

    return CalendarController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendar',
    template: __WEBPACK_IMPORTED_MODULE_16__calendar_tpl_pug___default()(),
    controller: CalendarController,
    bindings: {
        teamId: '<',
        calendarIds: '<'
    }
});

/***/ }),

/***/ "fgEq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"event-repeat-change-modal":"event-repeat-change-modal","prompt-question":"prompt-question","prompt-answer":"prompt-answer","prompt-answer-description":"prompt-answer-description"};

/***/ }),

/***/ "fpgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("hJ5Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_navigation_cmpt__ = __webpack_require__("S4DG");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-navigation', [__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_2__calendar_navigation_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__calendar_navigation_cmpt__["a" /* default */]));

/***/ }),

/***/ "ft5x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search_cmpt__ = __webpack_require__("fGGw");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.search', []).component(__WEBPACK_IMPORTED_MODULE_1__search_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__search_cmpt__["a" /* default */]));

/***/ }),

/***/ "fwUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__category_color_chart_style_sass__ = __webpack_require__("8xVG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__category_color_chart_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__category_color_chart_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_color_chart_tpl_pug__ = __webpack_require__("aKzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_color_chart_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__category_color_chart_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CategoryColorChartController = function () {
    CategoryColorChartController.$inject = ['arrayUtil'];

    /* @ngInject */
    function CategoryColorChartController(arrayUtil) {
        _classCallCheck(this, CategoryColorChartController);

        this.arrayUtil = arrayUtil;
    }

    _createClass(CategoryColorChartController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.entries) {
                this.entries = this.fixPercentage(changeObject.entries.currentValue || []);
            }
        }
    }, {
        key: 'fixPercentage',
        value: function fixPercentage(entries) {
            var total = entries.reduce(function (total, entry) {
                return total + entry.percent;
            }, 0);
            var ratio = 100 / total;

            return entries.map(function (entry) {
                return {
                    label: entry.label,
                    color: entry.color,
                    percent: entry.percent * ratio
                };
            }).sort(function (current, next) {
                return next.percent - current.percent;
            });
        }
    }]);

    return CategoryColorChartController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategoryColorChart',
    template: __WEBPACK_IMPORTED_MODULE_1__category_color_chart_tpl_pug___default()(),
    controller: CategoryColorChartController,
    bindings: {
        entries: '<'
    }
});

/***/ }),

/***/ "g/wL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__confirm_modal_style_sass__ = __webpack_require__("axi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__confirm_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__confirm_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__confirm_modal_tpl_pug__ = __webpack_require__("e1lC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__confirm_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__confirm_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ConfirmDeleteController = function () {
    function ConfirmDeleteController() {
        _classCallCheck(this, ConfirmDeleteController);
    }

    _createClass(ConfirmDeleteController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.message) {
                this.paragraphs = typeof this.message === 'string' ? [this.message] : this.message;
            }

            if (changeObject.primaryButton) {
                if (typeof this.primaryButton === 'string') {
                    this.primaryButtonText = this.primaryButton;
                    this.primaryButtonLoadingText = this.primaryButtonText;
                } else if (this.primaryButton) {
                    this.primaryButtonText = this.primaryButton[0];
                    this.primaryButtonLoadingText = this.primaryButton[1] || this.primaryButtonText;
                } else {
                    this.primaryButtonText = 'Yes, delete';
                    this.primaryButtonLoadingText = 'Deleting...';
                }
            }

            if (changeObject.checkboxPrimaryButton) {
                if (typeof this.checkboxPrimaryButton === 'string') {
                    this.checkboxPrimaryButtonText = this.checkboxPrimaryButton;
                    this.checkboxPrimaryButtonLoadingText = this.checkboxPrimaryButtonText;
                } else if (this.checkboxPrimaryButton) {
                    this.checkboxPrimaryButtonText = this.checkboxPrimaryButton[0];
                    this.checkboxPrimaryButtonLoadingText = this.checkboxPrimaryButton[1] || this.checkboxPrimaryButtonText;
                } else {
                    this.checkboxPrimaryButtonText = null;
                    this.checkboxPrimaryButtonLoadingText = null;
                }
            }

            if (changeObject.secondaryButton) {
                this.secondaryButtonText = this.secondaryButton || 'Cancel';
            }

            if (changeObject.buttonStyle) {
                this.buttonStyleClass = this.buttonStyle || 'button-danger';
            }

            if (changeObject.checkboxDefault) {
                this.checkboxChecked = !!this.checkboxDefault;
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.buttonStyleClass = this.buttonStyle || 'button-danger';
            this.checkboxChecked = !!this.checkboxDefault;
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            return this.onDismiss();
        }
    }, {
        key: 'confirm',
        value: function confirm() {
            return this.onClose({
                data: this.checkboxChecked
            });
        }
    }, {
        key: 'getPrimaryButtonText',
        value: function getPrimaryButtonText() {
            if (this.checkboxChecked && this.checkboxPrimaryButtonText) {
                return this.checkboxPrimaryButtonText;
            }

            return this.primaryButtonText;
        }
    }, {
        key: 'getPrimaryButtonLoadingText',
        value: function getPrimaryButtonLoadingText() {
            if (this.checkboxChecked && this.checkboxPrimaryButtonLoadingText) {
                return this.checkboxPrimaryButtonLoadingText;
            }

            return this.primaryButtonLoadingText;
        }
    }]);

    return ConfirmDeleteController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAConfirmModal',
    template: __WEBPACK_IMPORTED_MODULE_1__confirm_modal_tpl_pug___default()(),
    controller: ConfirmDeleteController,
    bindings: {
        title: '<',
        message: '<',
        primaryButton: '<',
        checkboxPrimaryButton: '<',
        secondaryButton: '<',
        buttonStyle: '<',
        wide: '<',
        checkboxLabel: '<',
        checkboxDefault: '<',
        onDismiss: '&',
        onClose: '&'
    }
});

/***/ }),

/***/ "g2IO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__category_color_style_sass__ = __webpack_require__("F1Zx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__category_color_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__category_color_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_color_tpl_pug__ = __webpack_require__("7ck3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_color_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__category_color_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CategoryColorController = function () {
    function CategoryColorController() {
        _classCallCheck(this, CategoryColorController);
    }

    _createClass(CategoryColorController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.color || changeObject.fill) {
                this.borderColor = this.fill ? null : this.color;
                this.backgroundColor = this.fill ? this.color : null;
            }
        }
    }]);

    return CategoryColorController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategoryColor',
    template: __WEBPACK_IMPORTED_MODULE_1__category_color_tpl_pug___default()(),
    controller: CategoryColorController,
    bindings: {
        color: '<',
        fill: '<'
    }
});

/***/ }),

/***/ "g4UR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__time_tpl_pug__ = __webpack_require__("pWlP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__time_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__time_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var TimeController = function () {
    TimeController.$inject = ['$timeout'];

    /* @ngInject */
    function TimeController($timeout) {
        _classCallCheck(this, TimeController);

        this.$timeout = $timeout;

        this.units = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second'];
    }

    _createClass(TimeController, [{
        key: '$onDestory',
        value: function $onDestory() {
            this.clearTimer();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.timestamp) {
                this.updateDisplayedTime(changeObject.timestamp.currentValue);
            }
        }
    }, {
        key: 'updateDisplayedTime',
        value: function updateDisplayedTime(timestamp) {
            this.clearTimer();

            var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp);

            var unit = this.getDisplayedUnit(this.units, date, now);

            var difference = date.diff(now, unit, true);
            var past = difference < 0;

            if (past) {
                difference = Math.abs(difference);
                var _ref = [date, now];
                now = _ref[0];
                date = _ref[1];
            }

            var safeUnit = unit || this.units[this.units.length - 1];

            this.time = this.suffixify(this.format(__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(date.diff(now)).as(safeUnit), safeUnit));
            this.onChange();

            if (unit) {
                var timeoutDuration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(difference % 1, unit).asMilliseconds();
                this.timeoutId = this.$timeout(this.updateDisplayedTime.bind(this, timestamp), timeoutDuration);
            } else {
                this.onEnd();
            }
        }
    }, {
        key: 'getDisplayedUnit',
        value: function getDisplayedUnit(units, date, now) {
            // find the first unit which is displayable
            var unit = __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(this.units, function (unit) {
                return date.diff(now, unit) !== 0;
            });

            return unit && this.units.indexOf(unit) < this.units.indexOf(this.maxUnit) ? this.maxUnit : unit;
        }
    }, {
        key: 'clearTimer',
        value: function clearTimer() {
            if (this.timeoutId) {
                this.$timeout.cancel(this.timeoutId);
                this.timeoutId = null;
            }
        }
    }, {
        key: 'format',
        value: function format(quantity, unit) {
            quantity = Math.max(Math.ceil(quantity), 1);

            if (quantity === 1) {
                return 'a ' + unit;
            }

            return quantity + ' ' + unit + 's';
        }
    }, {
        key: 'suffixify',
        value: function suffixify(value, past) {
            return this.suffix ? past ? value + ' ago' : 'in ' + value : value;
        }
    }]);

    return TimeController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbATime',
    template: __WEBPACK_IMPORTED_MODULE_2__time_tpl_pug___default()(),
    controller: TimeController,
    bindings: {
        timestamp: '<',
        suffix: '<',
        maxUnit: '@',
        onChange: '&',
        onEnd: '&'
    }
});

/***/ }),

/***/ "g4i6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = AutofocusDirective;
AutofocusDirective.$inject = ['$parse', '$timeout'];
var selector = 'dbAAutofocus';

/* @ngInject */
function AutofocusDirective($parse, $timeout) {
    return {
        restrict: 'A',

        link: {
            post: function post(scope, element, attrs) {
                var model = $parse(attrs[selector]);

                var watcher = scope.$watch(model, function (shouldFocus) {
                    watcher();

                    if (shouldFocus) {
                        // TODO figure it out how to omit the magic number delay
                        $timeout(function () {
                            return element[0].focus();
                        }, 500);
                    }
                });

                scope.$on('$destroy', watcher);
            }
        }
    };
}

/***/ }),

/***/ "gACS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-manage-modal":"category-manage-modal","categories-container":"categories-container","category-search":"category-search","categories-message":"categories-message","category-select-item":"category-select-item","category-item":"category-item","category":"category","filled":"filled","unknown":"unknown","disabled":"disabled","category-name":"category-name","drag-handle":"drag-handle","sortable-drag":"sortable-drag","sortable-fallback":"sortable-fallback"};

/***/ }),

/***/ "gCP2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ "gDNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forgot_password_confirm_style_sass__ = __webpack_require__("SkZH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forgot_password_confirm_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__forgot_password_confirm_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_confirm_tpl_pug__ = __webpack_require__("fUuY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_confirm_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__forgot_password_confirm_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAForgotPasswordConfirm',
    template: __WEBPACK_IMPORTED_MODULE_1__forgot_password_confirm_tpl_pug___default()()
});

/***/ }),

/***/ "gGI1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryFitness-1de406878709f904.svg";

/***/ }),

/***/ "gZSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cookie-notification":"cookie-notification","visible":"visible","button-acknowledge-policy":"button-acknowledge-policy"};

/***/ }),

/***/ "ggwY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = NumberOnlyDirective;
NumberOnlyDirective.$inject = ['$parse', 'numberUtil'];
var selector = 'dbANumberOnly';

/* @ngInject */
function NumberOnlyDirective($parse, numberUtil) {
    return {
        restrict: 'A',
        require: 'ngModel',

        link: function link(scope, element, attrs, ctrl) {
            var getIntegerOnly = function getIntegerOnly() {
                return attrs.integerOnly != null;
            };
            var getAllowInvalid = function getAllowInvalid() {
                return attrs.allowInvalid != null;
            };
            var getMin = $parse(attrs.ngMin);
            var getMax = $parse(attrs.ngMax);

            ctrl.$parsers.push(parser);

            element.on('blur', blurHandler);
            scope.$on('$destroy', function () {
                return element.off('blur', blurHandler);
            });

            function parser(value) {
                var fixedValue = fixValue(value);

                if (numberUtil.isNumeric(value) && value !== fixedValue) {
                    render(fixedValue);
                }

                return fixedValue;
            }

            function blurHandler() {
                render(fixValue(ctrl.$viewValue));
            }

            function fixValue(value) {
                var min = getMin(scope);

                if (numberUtil.isNumeric(value)) {
                    var max = getMax(scope);

                    if (numberUtil.isNumeric(min) && value < min) {
                        value = min;
                    } else if (numberUtil.isNumeric(max) && value > max) {
                        value = max;
                    }

                    value = getIntegerOnly() ? parseInt(value) : value;
                } else if (!getAllowInvalid() || value != null && ('' + value).length > 0) {
                    value = fixValue(numberUtil.numberify(value || min));
                }

                return value;
            }

            function render(value) {
                ctrl.$setViewValue(value);
                ctrl.$render();
            }
        }
    };
}

/***/ }),

/***/ "ghsk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var helpers = __webpack_require__("iO9N");
var Interaction = __webpack_require__("KC8c");
var platform = __webpack_require__("2xI1");

module.exports = function(Chart) {
	var plugins = Chart.plugins;

	// Create a dictionary of chart types, to allow for extension of existing types
	Chart.types = {};

	// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	// Destroy method on the chart will remove the instance of the chart from this reference.
	Chart.instances = {};

	// Controllers available for dataset visualization eg. bar, line, slice, etc.
	Chart.controllers = {};

	/**
	 * Initializes the given config with global and chart default values.
	 */
	function initConfig(config) {
		config = config || {};

		// Do NOT use configMerge() for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = helpers.configMerge(
			defaults.global,
			defaults[config.type],
			config.options || {});

		return config;
	}

	/**
	 * Updates the config of the chart
	 * @param chart {Chart} chart to update the options for
	 */
	function updateConfig(chart) {
		var newOptions = chart.options;

		// Update Scale(s) with options
		if (newOptions.scale) {
			chart.scale.options = newOptions.scale;
		} else if (newOptions.scales) {
			newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
				chart.scales[scaleOptions.id].options = scaleOptions;
			});
		}

		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	helpers.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;

			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
		 * @private
		 */
		initialize: function() {
			var me = this;

			// Before init plugin notification
			plugins.notify(me, 'beforeInit');

			helpers.retinaScale(me, me.options.devicePixelRatio);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildScales();
			me.initToolTip();

			// After init plugin notification
			plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function() {
			helpers.canvas.clear(this);
			return this;
		},

		stop: function() {
			// Stops any current animation loop occurring
			Chart.animationService.cancelAnimation(this);
			return this;
		},

		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.

			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
			var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers.retinaScale(me, options.devicePixelRatio);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}

				me.stop();
				me.update(me.options.responsiveAnimationDuration);
			}
		},

		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});

			helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales = {};
			var items = [];

			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers.each(items, function(item) {
				var scaleOptions = item.options;
				var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);
				var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				var scale = new scaleClass({
					id: scaleOptions.id,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});

				scales[scale.id] = scale;
				scale.mergeTicksOptions();

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});

			Chart.scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function() {
			var me = this;
			var types = [];
			var newControllers = [];

			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				var type = dataset.type || me.config.type;

				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(datasetIndex);
					meta = me.getDatasetMeta(datasetIndex);
				}
				meta.type = type;

				types.push(meta.type);

				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
				} else {
					var ControllerClass = Chart.controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);

			return newControllers;
		},

		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			updateConfig(me);

			if (plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			helpers.each(newControllers, function(controller) {
				controller.reset();
			});

			me.updateDatasets();

			// Do this before render so that any plugins that need final scale updates can use it
			plugins.notify(me, 'afterUpdate');

			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},

		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;

			if (plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			Chart.layoutService.update(this, this.width, this.height);

			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			plugins.notify(me, 'afterScaleUpdate');
			plugins.notify(me, 'afterLayout');
		},

		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller.update();

			plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			var duration = config.duration;
			var lazy = config.lazy;

			if (plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var animationOptions = me.options.animation;
			var onComplete = function(animation) {
				plugins.notify(me, 'afterRender');
				helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
				var animation = new Chart.Animation({
					numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,

					render: function(chart, animationObject) {
						var easingFunction = helpers.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				Chart.animationService.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new Chart.Animation({numSteps: 0, chart: me}));
			}

			return me;
		},

		draw: function(easingValue) {
			var me = this;

			me.clear();

			if (helpers.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Draw all the scales
			helpers.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);

			if (me.scale) {
				me.scale.draw();
			}

			me.drawDatasets(easingValue);

			// Finally draw the tooltip
			me.tooltip.draw();

			plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;

			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			// Draw datasets reversed to support proper line stacking
			for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}

			plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		// Get the single element that was clicked on
		// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		getElementAtEvent: function(e) {
			return Interaction.modes.single(this, e);
		},

		getElementsAtEvent: function(e) {
			return Interaction.modes.label(this, e, {intersect: true});
		},

		getElementsAtXAxis: function(e) {
			return Interaction.modes['x-axis'](this, e, {intersect: true});
		},

		getElementsAtEventForMode: function(e, mode, options) {
			var method = Interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function(e) {
			return Interaction.modes.dataset(this, e, {intersect: true});
		},

		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function() {
			return this.options.legendCallback(this);
		},

		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];

			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},

		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}

			if (canvas) {
				me.unbindEvents();
				helpers.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function() {
			var me = this;
			me.tooltip = new Chart.Tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},

		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};

			helpers.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},

		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			changed |= tooltip && tooltip.handleEvent(e);

			plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render(me.options.hover.animationDuration, true);
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {Boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
};


/***/ }),

/***/ "go0+":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"collaborator-invite-modal\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.invite()\"\u003E\u003Cdiv class=\"modal-header modal-section modal-delimiter\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\"\u003EAdd collaborators\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-section\"\u003E\u003Cdiv class=\"form-description\"\u003EAdd collaborators to your account by inviting people.\u003C\u002Fdiv\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"email\" id=\"collaborator-email\" name=\"email\" placeholder=\"e.g. somebody@example.com\" ng-model=\"$ctrl.email\" db-a-autofocus=\"true\" db-a-blacklist=\"$ctrl.emails\" db-a-match=\"$ctrl.user\" ignore-case=\"true\" required\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"collaborator-email\"\u003EEmail address\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"collaborator-email\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in the email address.\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"email\"\u003EPlease provide a valid email address.\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"match\"\u003EYou can't add yourself as a collaborator.\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"blacklist\"\u003EIt's already a collaborator.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-invite-collaborator\" type=\"submit\" db-a-async ng-loading=\"form.$submitting\"\u003E\u003Cinitial\u003EAdd\u003C\u002Finitial\u003E\u003Cloading\u003EAdding...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "h3dC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-radio":"calendar-radio","selected":"selected","calendar-radio-state":"calendar-radio-state","calendar-radio-name":"calendar-radio-name"};

/***/ }),

/***/ "h6eA":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-select-modal modal-fixed-height\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\" ng-bind=\"$ctrl.title\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-body-scrollable\"\u003E\u003Cdiv class=\"calendar-items\"\u003E\u003Cdb-a-calendar-radio class=\"calendar-select-item modal-section\" ng-repeat=\"calendar in $ctrl.calendars track by $index\" name=\"calendar.name\" selected=\"$ctrl.selected === calendar\" ng-click=\"$ctrl.select(calendar)\"\u003E\u003C\u002Fdb-a-calendar-radio\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "hAmm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("iO9N");

module.exports = function(Chart) {

	function filterByPosition(array, position) {
		return helpers.where(array, function(v) {
			return v.position === position;
		});
	}

	function sortByWeight(array, reverse) {
		array.forEach(function(v, i) {
			v._tmpIndex_ = i;
			return v;
		});
		array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0._tmpIndex_ - v1._tmpIndex_ :
				v0.weight - v1.weight;
		});
		array.forEach(function(v) {
			delete v._tmpIndex_;
		});
	}

	/**
	 * @interface ILayoutItem
	 * @prop {String} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {Function} getPadding -  Returns an object with padding on the edges
	 * @prop {Number} width - Width of item. Must be valid after update()
	 * @prop {Number} height - Height of item. Must be valid after update()
	 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */

	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	Chart.layoutService = {
		defaults: {},

		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}

			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;

			chart.boxes.push(item);
		},

		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {Object} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},

		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {Object} item - the item to configure with the given options
		 * @param {Object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;

			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},

		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {Number} width - the width to fit into
		 * @param {Number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}

			var layoutOptions = chart.options.layout || {};
			var padding = helpers.options.toPadding(layoutOptions.padding);
			var leftPadding = padding.left;
			var rightPadding = padding.right;
			var topPadding = padding.top;
			var bottomPadding = padding.bottom;

			var leftBoxes = filterByPosition(chart.boxes, 'left');
			var rightBoxes = filterByPosition(chart.boxes, 'right');
			var topBoxes = filterByPosition(chart.boxes, 'top');
			var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
			var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

			// Sort boxes by weight. A higher weight is further away from the chart area
			sortByWeight(leftBoxes, true);
			sortByWeight(rightBoxes, false);
			sortByWeight(topBoxes, true);
			sortByWeight(bottomBoxes, false);

			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
			// What we do to find the best sizing, we do the following
			// 1. Determine the minimum size of the chart area.
			// 2. Split the remaining width equally between each vertical axis
			// 3. Split the remaining height equally between each horizontal axis
			// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
			// 5. Adjust the sizes of each axis based on it's minimum reported size.
			// 6. Refit each axis
			// 7. Position each axis in the final location
			// 8. Tell the chart the final location of the chart area
			// 9. Tell any axes that overlay the chart area the positions of the chart area

			// Step 1
			var chartWidth = width - leftPadding - rightPadding;
			var chartHeight = height - topPadding - bottomPadding;
			var chartAreaWidth = chartWidth / 2; // min 50%
			var chartAreaHeight = chartHeight / 2; // min 50%

			// Step 2
			var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

			// Step 3
			var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

			// Step 4
			var maxChartAreaWidth = chartWidth;
			var maxChartAreaHeight = chartHeight;
			var minBoxSizes = [];

			function getMinimumBoxSize(box) {
				var minSize;
				var isHorizontal = box.isHorizontal();

				if (isHorizontal) {
					minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
					maxChartAreaHeight -= minSize.height;
				} else {
					minSize = box.update(verticalBoxWidth, chartAreaHeight);
					maxChartAreaWidth -= minSize.width;
				}

				minBoxSizes.push({
					horizontal: isHorizontal,
					minSize: minSize,
					box: box,
				});
			}

			helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

			// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
			var maxHorizontalLeftPadding = 0;
			var maxHorizontalRightPadding = 0;
			var maxVerticalTopPadding = 0;
			var maxVerticalBottomPadding = 0;

			helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
				if (horizontalBox.getPadding) {
					var boxPadding = horizontalBox.getPadding();
					maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
					maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
				}
			});

			helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
				if (verticalBox.getPadding) {
					var boxPadding = verticalBox.getPadding();
					maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
					maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
				}
			});

			// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
			// be if the axes are drawn at their minimum sizes.
			// Steps 5 & 6
			var totalLeftBoxesWidth = leftPadding;
			var totalRightBoxesWidth = rightPadding;
			var totalTopBoxesHeight = topPadding;
			var totalBottomBoxesHeight = bottomPadding;

			// Function to fit a box
			function fitBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
					return minBox.box === box;
				});

				if (minBoxSize) {
					if (box.isHorizontal()) {
						var scaleMargin = {
							left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
							right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
							top: 0,
							bottom: 0
						};

						// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
						// on the margin. Sometimes they need to increase in size slightly
						box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
					} else {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight);
					}
				}
			}

			// Update, and calculate the left and right margins for the horizontal boxes
			helpers.each(leftBoxes.concat(rightBoxes), fitBox);

			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			// Set the Left and Right margins for the horizontal boxes
			helpers.each(topBoxes.concat(bottomBoxes), fitBox);

			// Figure out how much margin is on the top and bottom of the vertical boxes
			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});

			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			function finalFitVerticalBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
					return minSize.box === box;
				});

				var scaleMargin = {
					left: 0,
					right: 0,
					top: totalTopBoxesHeight,
					bottom: totalBottomBoxesHeight
				};

				if (minBoxSize) {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
				}
			}

			// Let the left layout know the final margin
			helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

			// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
			totalLeftBoxesWidth = leftPadding;
			totalRightBoxesWidth = rightPadding;
			totalTopBoxesHeight = topPadding;
			totalBottomBoxesHeight = bottomPadding;

			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});
			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			// We may be adding some padding to account for rotated x axis labels
			var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
			totalLeftBoxesWidth += leftPaddingAddition;
			totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

			var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
			totalTopBoxesHeight += topPaddingAddition;
			totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

			// Figure out if our chart area changed. This would occur if the dataset layout label rotation
			// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
			// without calling `fit` again
			var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
			var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

			if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
				helpers.each(leftBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers.each(rightBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers.each(topBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				helpers.each(bottomBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				maxChartAreaHeight = newMaxChartAreaHeight;
				maxChartAreaWidth = newMaxChartAreaWidth;
			}

			// Step 7 - Position the boxes
			var left = leftPadding + leftPaddingAddition;
			var top = topPadding + topPaddingAddition;

			function placeBox(box) {
				if (box.isHorizontal()) {
					box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
					box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
					box.top = top;
					box.bottom = top + box.height;

					// Move to next point
					top = box.bottom;

				} else {

					box.left = left;
					box.right = left + box.width;
					box.top = totalTopBoxesHeight;
					box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

					// Move to next point
					left = box.right;
				}
			}

			helpers.each(leftBoxes.concat(topBoxes), placeBox);

			// Account for chart width and height
			left += maxChartAreaWidth;
			top += maxChartAreaHeight;

			helpers.each(rightBoxes, placeBox);
			helpers.each(bottomBoxes, placeBox);

			// Step 8
			chart.chartArea = {
				left: totalLeftBoxesWidth,
				top: totalTopBoxesHeight,
				right: totalLeftBoxesWidth + maxChartAreaWidth,
				bottom: totalTopBoxesHeight + maxChartAreaHeight
			};

			// Step 9
			helpers.each(chartAreaBoxes, function(box) {
				box.left = chart.chartArea.left;
				box.top = chart.chartArea.top;
				box.right = chart.chartArea.right;
				box.bottom = chart.chartArea.bottom;

				box.update(maxChartAreaWidth, maxChartAreaHeight);
			});
		}
	};
};


/***/ }),

/***/ "hGsm":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"selected-date-range\"\u003E\u003Cdiv class=\"selected-date\" ng-bind=\"$ctrl.startDate\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"selected-date-delimiter\"\u003E\u003Ci class=\"icon-dollarbird-arrow-right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"selected-date\" ng-bind=\"$ctrl.endDate\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "hJ5Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_list__ = __webpack_require__("S19y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__team_list__ = __webpack_require__("RTFI");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-navigation.component', [__WEBPACK_IMPORTED_MODULE_1__calendar_list__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__team_list__["a" /* default */].name]));

/***/ }),

/***/ "hNRh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategorySubscription-426c982fa69e5e75.svg";

/***/ }),

/***/ "hTxh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"checkbox","selected":"selected","icon":"icon","input-checkbox":"input-checkbox"};

/***/ }),

/***/ "hqfj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"renew-subscription-notification":"renew-subscription-notification","subscription-description":"subscription-description","button-subscription":"button-subscription"};

/***/ }),

/***/ "hypg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-icon-image-aff2af5657ab6cfd.svg";

/***/ }),

/***/ "i6nN":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "iO9N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("3n1n");
module.exports.easing = __webpack_require__("d1/4");
module.exports.canvas = __webpack_require__("F4U8");
module.exports.options = __webpack_require__("u1o0");


/***/ }),

/***/ "iT3l":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"period-month-item\" ng-class=\"{ selected: $ctrl.selected }\"\u003E\u003Cdiv class=\"month-item-content\"\u003E\u003Cdiv class=\"month-name\" ng-bind=\"$ctrl.name\"\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"month-change\" value=\"$ctrl.change\" limit=\"100000\" pretty=\"true\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003Cdb-a-pretty-number class=\"month-balance\" value=\"$ctrl.balance\" limit=\"100000\" pretty=\"true\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "iWFD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"collaborator-manage-modal":"collaborator-manage-modal","modal-fixed-height":"modal-fixed-height","modal-body":"modal-body","empty":"empty","modal-footer":"modal-footer","collaborators":"collaborators","empty-state":"empty-state","invite-collaborator":"invite-collaborator","button":"button","invite-collaborator-text":"invite-collaborator-text","collaborator-item":"collaborator-item","button-delete-collaborator":"button-delete-collaborator","collaborator-info":"collaborator-info","collaborator-image":"collaborator-image","collaborator-name":"collaborator-name","collaborator-email":"collaborator-email","collaborators-full-message":"collaborators-full-message","empty-state-image":"empty-state-image"};

/***/ }),

/***/ "iZDt":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"date\" ng-class=\"{ disabled: $ctrl.disabled }\" ng-click=\"$ctrl.click()\"\u003E\u003Cdiv class=\"date-value\" ng-bind=\"$ctrl.value\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"date-icon\"\u003E\u003Ci class=\"icon-dollarbird-calendar\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "ia/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = CustomErrorDirective;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

CustomErrorDirective.$inject = ['$parse'];
var selector = 'dbACustomError';

/* @ngInject */
function CustomErrorDirective($parse) {
    return {
        require: ['?ngModel', '?form'],
        restrict: 'A',

        link: function link(scope, element, attrs, _ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                ngModel = _ref2[0],
                form = _ref2[1];

            var getError = $parse(attrs[selector]);

            scope.$watch(function () {
                return getError(scope);
            }, function (error) {
                setValidity(ngModel, !!error);
                setValidity(form, !!error);
            });

            function setValidity(ctrl, error) {
                if (ctrl) {
                    ctrl.$setValidity('error', !error);
                }
            }
        }
    };
}

/***/ }),

/***/ "iphP":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-side-bar\" ng-class=\"{ visible: $ctrl.visible }\"\u003E\u003Cdiv class=\"side-bar-overlay\" ng-click=\"$ctrl.close()\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"side-bar-content\" ng-transclude db-stop-propagation=\"click\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "it8l":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_23-b663568019c9fd72.svg";

/***/ }),

/***/ "j95d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directive__ = __webpack_require__("A8eB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_edit_modal_cmpt__ = __webpack_require__("Hpa7");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.event-edit-modal', [__WEBPACK_IMPORTED_MODULE_1__directive__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_2__event_edit_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__event_edit_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "jDkL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_group_style_sass__ = __webpack_require__("OmoP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_group_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__category_group_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_group_tpl_pug__ = __webpack_require__("UY3x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_group_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__category_group_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var CategoryGroupController = function () {
    CategoryGroupController.$inject = ['numberUtil', 'arrayUtil'];

    /* @ngInject */
    function CategoryGroupController(numberUtil, arrayUtil) {
        _classCallCheck(this, CategoryGroupController);

        this.numberUtil = numberUtil;
        this.arrayUtil = arrayUtil;

        this.expanded = false;
    }

    _createClass(CategoryGroupController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.average || changeObject.value) {
                if (changeObject.average) {
                    this.average = changeObject.average.currentValue;
                }
                if (changeObject.value) {
                    this.value = changeObject.value.currentValue;
                }

                this.calculateDifference(this.average, this.value);
            }
        }
    }, {
        key: 'calculateDifference',
        value: function calculateDifference(average, value) {
            if (average > 0) {
                this.exceeded = value > average;
                this.difference = Math.abs(average - value);
            } else {
                this.exceeded = false;
                this.difference = 0;
            }

            this.averagePercent = this.getPercentage(average, value);
            this.valuePercent = this.getPercentage(value, average);
        }
    }, {
        key: 'getPercentage',
        value: function getPercentage(value1, value2) {
            return this.numberUtil.convertToPercentage(value1 / value2 * 100) + '%';
        }
    }, {
        key: 'toggleGroupVisibility',
        value: function toggleGroupVisibility() {
            this.expanded = !this.expanded;

            __WEBPACK_IMPORTED_MODULE_0_common_analytics__["c" /* default */].trackDashboardToggleCategoryGroup();
        }
    }, {
        key: 'clickEventGroup',
        value: function clickEventGroup() {
            __WEBPACK_IMPORTED_MODULE_0_common_analytics__["c" /* default */].trackDashboardClickEventGroup();
        }
    }, {
        key: 'hasPastData',
        get: function get() {
            return !!this.average;
        }
    }]);

    return CategoryGroupController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategoryGroup',
    template: __WEBPACK_IMPORTED_MODULE_2__category_group_tpl_pug___default()(),
    controller: CategoryGroupController,
    bindings: {
        name: '<',
        color: '<',
        average: '<',
        value: '<',
        eventGroups: '<',
        exceededText: '<',
        savedText: '<'
    }
});

/***/ }),

/***/ "jGXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__team_radio_cmpt__ = __webpack_require__("aUVh");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.team-radio', []).component(__WEBPACK_IMPORTED_MODULE_1__team_radio_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__team_radio_cmpt__["a" /* default */]));

/***/ }),

/***/ "jJ84":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var helpers = __webpack_require__("iO9N");

module.exports = function(Chart) {

	Chart.scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				Chart.layoutService.addBox(chart, scale);
			});
		}
	};
};


/***/ }),

/***/ "jhJr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ "k1UB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_value_key_filter_directive__ = __webpack_require__("CYOx");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.event-add-modal.directive.event-value-key-filter', []).directive(__WEBPACK_IMPORTED_MODULE_1__event_value_key_filter_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__event_value_key_filter_directive__["a" /* default */]));

/***/ }),

/***/ "k5Qk":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"checkbox\" ng-class=\"{ selected: $ctrl.selected }\"\u003E\u003Ci class=\"icon icon-dollarbird-checkmark\"\u003E\u003C\u002Fi\u003E\u003Cinput class=\"input-checkbox\" type=\"checkbox\" ng-attr-checked=\"{{ $ctrl.selected }}\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "k7DW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("iO9N");

module.exports = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers.merge(this[scope] || (this[scope] = {}), values);
	}
};


/***/ }),

/***/ "kIam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_cmpt__ = __webpack_require__("2YoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scene__ = __webpack_require__("/hOf");
stateConfiguration.$inject = ['$stateProvider'];





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity', [__WEBPACK_IMPORTED_MODULE_2__scene__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_1__identity_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__identity_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity', {
        url: '?redirect',
        redirectTo: 'identity.sign-in',
        template: '<db-a-identity class="block-component"></db-a-identity>'
    });
}

/***/ }),

/***/ "kOIG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-dashboard":"calendar-dashboard","calendar-dashboard-content":"calendar-dashboard-content","calendar-dashboard-section":"calendar-dashboard-section","calendar-dashboard-section-fill":"calendar-dashboard-section-fill","calendar-dashboard-section-content":"calendar-dashboard-section-content","month-name":"month-name","dashboard-types":"dashboard-types","dashboard-type":"dashboard-type","active":"active","dashboard-type-name":"dashboard-type-name","dashboard-type-value":"dashboard-type-value","category-color-chart":"category-color-chart","category-groups":"category-groups","category-group-item":"category-group-item","empty-state-title":"empty-state-title"};

/***/ }),

/***/ "kX2h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_submit_directive__ = __webpack_require__("RIi+");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.form-submit', []).directive(__WEBPACK_IMPORTED_MODULE_1__form_submit_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__form_submit_directive__["a" /* default */]));

/***/ }),

/***/ "kmJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation_message_tpl_pug__ = __webpack_require__("V+kx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation_message_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__validation_message_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ValidationMessageController = function () {
    function ValidationMessageController() {
        _classCallCheck(this, ValidationMessageController);
    }

    _createClass(ValidationMessageController, [{
        key: 'invalid',
        get: function get() {
            var _this = this;

            var keys = String.prototype.split.call(this.key || '', / *, */);
            return keys.some(function (key) {
                return !!_this.$ctrl.$error[key];
            });
        }
    }]);

    return ValidationMessageController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAValidationMessage',
    template: __WEBPACK_IMPORTED_MODULE_0__validation_message_tpl_pug___default()(),
    controller: ValidationMessageController,
    transclude: true,
    require: {
        $ctrl: '^form'
    },
    bindings: {
        key: '@'
    }
});

/***/ }),

/***/ "ksva":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reset_password_service__ = __webpack_require__("uQVb");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.forgot-password.service', []).service('resetPasswordService', __WEBPACK_IMPORTED_MODULE_1__reset_password_service__["a" /* default */]));

/***/ }),

/***/ "kui2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_side_bar_cmpt__ = __webpack_require__("VVuF");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-side-bar', []).component(__WEBPACK_IMPORTED_MODULE_1__calendar_side_bar_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__calendar_side_bar_cmpt__["a" /* default */]));

/***/ }),

/***/ "kwBb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common__ = __webpack_require__("1lyH");
stateConfiguration.$inject = ['$stateProvider', '$transitionsProvider'];
/* eslint-disable no-console */




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.payment', ['application.service']).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('authorized.payment', {
        url: __WEBPACK_IMPORTED_MODULE_1_common__["a" /* URL_PAYMENT */],
        params: {
            plan: {
                dynamic: true
            },
            subscription: {
                dynamic: true
            }
        },
        data: {
            requires: {
                authentication: {
                    state: 'identity.sign-up',
                    keep: true
                }
            }
        }
    }).state('authorized.payment-confirm', {
        url: __WEBPACK_IMPORTED_MODULE_1_common__["a" /* URL_PAYMENT */] + '/confirm?ctrl&token',
        params: {
            plan: {
                dynamic: true
            },
            subscription: {
                dynamic: true
            }
        }
    });

    $transitionsProvider.onStart({
        to: 'authorized.payment'
    }, function (transition) {
        var _ref = transition.params() || {},
            subscription = _ref.subscription;

        var $state = transition.injector().get('$state');
        var $window = transition.injector().get('$window');
        var paymentService = transition.injector().get('paymentService');
        var notificationService = transition.injector().get('notificationService');

        return paymentService.getBuyUrl(subscription).then(function (url) {
            $window.location.replace(url);

            return true;
        }).catch(function () {
            notificationService.show({
                component: 'dbAAlreadySubscribedNotification',
                id: 'already-subscribed'
            }, false, 0);

            return $state.target('authorized');
        });
    });

    $transitionsProvider.onStart({
        to: 'authorized.payment-confirm'
    }, function (transition) {
        var _ref2 = transition.params() || {},
            ctrl = _ref2.ctrl,
            token = _ref2.token;

        var $state = transition.injector().get('$state');
        var configuration = transition.injector().get('configuration');
        var sessionService = transition.injector().get('sessionService');
        var paymentService = transition.injector().get('paymentService');
        var notificationService = transition.injector().get('notificationService');

        // Get analytics service safely
        var analyticsService = void 0;
        try {
            analyticsService = transition.injector().get('analyticsService');
        } catch (error) {
            console.warn('Analytics service not available:', error);
        }

        return paymentService.confirm(ctrl, token).then(function () {
            // Since we're getting a 204 No Content response, we need to use default values
            // Use the token from URL params as the transaction ID
            var transactionId = token;
            // Use default values for amount and currency
            var value = 1.0;
            var currency = 'RON';

            // Track conversion if analytics service is available
            if (analyticsService && typeof analyticsService.trackPurchaseConversion === 'function') {
                console.log('Tracking purchase conversion:', { transactionId: transactionId, value: value, currency: currency });
                analyticsService.trackPurchaseConversion(transactionId, value, currency);
            } else {
                console.warn('Analytics service not available for tracking purchase conversion');
            }

            notificationService.showInfo('Your payment went through and your account has been upgraded. Don\'t forget to add it as an expense. :)', 'Hooray!', false);
            return sessionService.reload().then(function () {
                return $state.target('authorized');
            });
        }).catch(function (error) {
            // Log error for debugging
            console.error('Payment confirmation error:', error);

            notificationService.showError('Something might have gone wrong. If you don\'t receive your plan upgrade in the next 10 minutes, please contact us at ' + configuration.supportEmail + '.', null, false, 0);
            return $state.target('authorized');
        });
    });
}

/***/ }),

/***/ "l/ov":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-edit-modal\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.save()\"\u003E\u003Cdiv class=\"modal-header modal-section modal-delimiter\"\u003E\u003Cdiv class=\"modal-title\"\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ECalendar Details\u003C\u002Fspan\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ENew Calendar\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body\"\u003E\u003Cdiv class=\"calendar-name modal-section\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"text\" id=\"calendar-name\" name=\"name\" placeholder=\"e.g. Europe trip\" ng-model=\"$ctrl.calendar.name\" ng-change=\"$ctrl.updateName()\" db-a-autofocus=\"!$ctrl.existing\" required\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"calendar-name\"\u003EName\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"calendar-name\"\u003E\u003Cdb-a-validation-message key=\"error\" ng-bind=\"$ctrl.error\"\u003E\u003C\u002Fdb-a-validation-message\u003E\u003Cdb-a-validation-message key=\"required\"\u003EPlease fill in the calendar name.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-color modal-section\"\u003E\u003Cdiv class=\"section-label\"\u003EColor\u003C\u002Fdiv\u003E\u003Cdiv class=\"control\"\u003E\u003Cdb-a-color-palette colors=\"$ctrl.colors\" ng-model=\"$ctrl.calendar.color\" rows=\"4\" columns=\"7\" required\u003E\u003C\u002Fdb-a-color-palette\u003E\u003Clabel class=\"control-validation\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003ESelect a color\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-note modal-section\"\u003E\u003Cdiv class=\"control\"\u003E\u003Ctextarea class=\"control-input\" id=\"calendar-note\" name=\"note\" placeholder=\"Add a note for this calendar\" ng-model=\"$ctrl.calendar.note\"\u003E\u003C\u002Ftextarea\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"calendar-note\"\u003ECalendar note\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-accounts modal-section\"\u003E\u003Cdiv class=\"control\"\u003E\u003Ctextarea class=\"control-input\" id=\"calendar-accounts\" name=\"accounts\" placeholder=\"Accounts (one per line)\" ng-model=\"$ctrl.accountsInput\"\u003E\u003C\u002Ftextarea\u003E\u003Clabel class=\"control-label control-label-permanent\" for=\"calendar-accounts\"\u003EAccounts\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-auto-forecast modal-section\"\u003E\u003Clabel class=\"control-switch\"\u003EAuto forecasting\u003Cdb-a-switch class=\"control-switch-content\" ng-model=\"$ctrl.calendar.useAutoForecasting\"\u003E\u003C\u002Fdb-a-switch\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-save-calendar\" type=\"submit\" db-a-async loading=\"form.$submitting\"\u003E\u003Cinitial\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ECreate\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ESave\u003C\u002Fspan\u003E\u003C\u002Finitial\u003E\u003Cloading\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ECreating...\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ESaving...\u003C\u002Fspan\u003E\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "l/u7":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"radio\" ng-class=\"{ selected: $ctrl.selected }\"\u003E\u003Cinput class=\"input-radio\" type=\"radio\" ng-attr-name=\"{{ $ctrl.name }}\" ng-attr-checked=\"{{ $ctrl.selected }}\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "l4hu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directive__ = __webpack_require__("sndW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component__ = __webpack_require__("BjW1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar_cmpt__ = __webpack_require__("feAF");

calendarIdResolver.$inject = ['$transition$'];
teamIdResolver.$inject = ['$transition$'];
stateConfiguration.$inject = ['$stateProvider', '$transitionsProvider'];







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular___default.a.module('application.scene.authorized.scene.calendar', [__WEBPACK_IMPORTED_MODULE_2__directive__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_4__calendar_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_4__calendar_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('authorized.calendar', {
        url: '/calendar/:teamId?cid',
        component: __WEBPACK_IMPORTED_MODULE_4__calendar_cmpt__["a" /* default */].selector,
        params: {
            teamId: {
                value: null,
                squash: true,
                dynamic: true
            },
            cid: {
                array: true,
                value: [],
                squash: true,
                dynamic: true
            }
        },
        resolve: {
            teamId: teamIdResolver,
            calendarIds: calendarIdResolver
        }
    });

    $transitionsProvider.onStart({
        to: 'authorized.calendar'
    }, function (transition) {
        var _ref = transition.params() || {},
            teamId = _ref.teamId;

        teamId = +teamId;

        var $state = transition.injector().get('$state');
        var sessionService = transition.injector().get('sessionService');

        if (sessionService.user) {
            sessionService.initialize().then(function (data) {
                var teams = data.teams;


                if (teamId && !__WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(teams, function (team) {
                    return team.id === teamId;
                })) {
                    $state.go('authorized.calendar');
                }
            }).catch(function () {
                $state.go('authorized');
            });

            return true;
        }

        return sessionService.initialize().then(function (data) {
            var teams = data.teams;


            if (teamId) {
                if (__WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(teams, function (team) {
                    return team.id === teamId;
                })) {
                    return true;
                }

                return $state.target('authorized.calendar');
            }

            return true;
        }).catch(function () {
            return $state.target('authorized');
        });
    });
}

/* @ngInject */
function teamIdResolver($transition$) {
    var _ref2 = $transition$.params() || {},
        teamId = _ref2.teamId;

    return teamId || null;
}

/* @ngInject */
function calendarIdResolver($transition$) {
    var _ref3 = $transition$.params() || {},
        cid = _ref3.cid;

    return cid || [];
}

/***/ }),

/***/ "l5SJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__team_edit_modal_cmpt__ = __webpack_require__("4jcD");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.team-edit-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__team_edit_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__team_edit_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "l9ut":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Wuestion-Mark-4258366eaa666e99.svg";

/***/ }),

/***/ "lAgd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_29-983f4151a36d1ff6.svg";

/***/ }),

/***/ "lG75":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */
/* global document: false */


var color = __webpack_require__("rWJA");
var defaults = __webpack_require__("k7DW");
var helpers = __webpack_require__("iO9N");

module.exports = function(Chart) {

	// -- Basic js utility methods

	helpers.extend = function(base) {
		var setFn = function(value, key) {
			base[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; i++) {
			helpers.each(arguments[i], setFn);
		}
		return base;
	};

	helpers.configMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];

				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = helpers.scaleMerge(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.scaleMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;

					if (!target[key]) {
						target[key] = [];
					}

					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');

						if (i >= target[key].length) {
							target[key].push({});
						}

						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers.merge(target[key][i], scale);
						}
					}
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.where = function(collection, filterCallback) {
		if (helpers.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.inherits = function(extensions) {
		// Basic javascript inheritance based on the model created in Backbone.js
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};
		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();

		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;

		return ChartElement;
	};
	// -- Math methods
	helpers.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers.log10 = Math.log10 ?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			return Math.log(x) / Math.LN10;
		};
	helpers.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};
	// Gets the angle from vertical upright to the point about a centre.
	helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};
	helpers.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};
	helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers.EPSILON = Number.EPSILON || 1e-14;
	helpers.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers.niceNum = function(range, round) {
		var exponent = Math.floor(helpers.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.currentTarget || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	// Private helper to get a constraint dimension
	// @param domNode : the node to check the constraint on
	// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
	// @param percentageProperty : property of parent to use when calculating width as a percentage
	// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = domNode.parentNode;
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	helpers.getMaximumWidth = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientWidth;
		}

		var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
		var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
		var w = container.clientWidth - paddingLeft - paddingRight;
		var cw = helpers.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers.getMaximumHeight = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientHeight;
		}

		var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
		var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
		var h = container.clientHeight - paddingTop - paddingBottom;
		var ch = helpers.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		canvas.style.height = height + 'px';
		canvas.style.width = width + 'px';
	};
	// -- Canvas methods
	helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
				longest = helpers.measureText(ctx, data, gc, longest, thing);
			} else if (helpers.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
						longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers.each(arrayOfThings, function(thing) {
			if (helpers.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers.color = !color ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = defaults.global.defaultColor;
			}

			return color(value);
		};

	helpers.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern) ?
			colorValue :
			helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};


/***/ }),

/***/ "lH5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NotificationService = function () {
    NotificationService.$inject = ['$q', '$timeout', 'arrayUtil', 'navigationService'];

    /* @ngInject */
    function NotificationService($q, $timeout, arrayUtil, navigationService) {
        _classCallCheck(this, NotificationService);

        this.$q = $q;
        this.$timeout = $timeout;
        this.arrayUtil = arrayUtil;

        this.notifications = [];

        navigationService.onSuccess(this.onStateChange.bind(this));
    }

    _createClass(NotificationService, [{
        key: 'show',
        value: function show(options, closeOnStateChange, closeTimeout) {
            options = options || {};

            closeOnStateChange = !!closeOnStateChange;
            closeTimeout = closeTimeout == null ? 5000 : closeTimeout;

            var notification = this.arrayUtil.find(this.notifications, function (notification) {
                return notification.id === options.id;
            });

            return notification ? this.update(notification, options, closeOnStateChange, closeTimeout) : this.create(options, closeOnStateChange, closeTimeout);
        }
    }, {
        key: 'showInfo',
        value: function showInfo(message, title) {
            for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = arguments[_key];
            }

            return this.show.apply(this, [{
                component: 'dbATextNotification',
                id: 'ui-info',
                bindings: {
                    title: title || 'All good!',
                    message: message
                }
            }].concat(args));
        }
    }, {
        key: 'showError',
        value: function showError(message, title) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
            }

            return this.show.apply(this, [{
                component: 'dbAErrorNotification',
                id: 'ui-error',
                bindings: {
                    title: title || 'Something Went Wrong',
                    message: message
                }
            }].concat(args));
        }
    }, {
        key: 'create',
        value: function create(notification, closeOnStateChange, closeTimeout) {
            var _this = this;

            notification = notification || {};
            notification.bindings = notification.bindings || {};
            notification.closeOnStateChange = !!closeOnStateChange;
            notification.closeTimeout = closeTimeout;

            notification.promise = this.$q(function (resolve, reject) {
                notification.close = reject;
                notification.bindings.onClose = notification.close;

                _this.scheduleClose(notification);
            }).finally(function () {
                var index = _this.notifications.indexOf(notification);
                if (index >= 0) {
                    _this.$timeout.cancel(notification.timeout);
                    _this.notifications.splice(index, 1);
                }
            }).catch(function () {
                return null;
            });

            this.notifications.unshift(notification);

            return notification.promise;
        }
    }, {
        key: 'update',
        value: function update(notification, options, closeOnStateChange, closeTimeout) {
            notification.closeOnStateChange = !!closeOnStateChange;
            notification.closeTimeout = closeTimeout;
            notification.bindings = options.bindings || {};

            this.scheduleClose(notification);

            return notification.promise;
        }
    }, {
        key: 'scheduleClose',
        value: function scheduleClose(notification) {
            if (notification.closeTimeout > 0) {
                this.$timeout.cancel(notification.timeout);
                notification.timeout = this.$timeout(function () {
                    return notification.close();
                }, notification.closeTimeout);
            }
        }
    }, {
        key: 'onStateChange',
        value: function onStateChange() {
            this.notifications.forEach(function (notification) {
                if (notification.closeOnStateChange) {
                    notification.close();
                }
            });
        }
    }, {
        key: 'disableClose',
        value: function disableClose() {
            var _this2 = this;

            this.notifications.forEach(function (notification) {
                return _this2.$timeout.cancel(notification.timeout);
            });
        }
    }, {
        key: 'enableClose',
        value: function enableClose() {
            this.notifications.forEach(this.scheduleClose.bind(this));
        }
    }]);

    return NotificationService;
}();

/* harmony default export */ __webpack_exports__["a"] = (NotificationService);

/***/ }),

/***/ "lRs/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var Element = __webpack_require__("wGD1");
var helpers = __webpack_require__("iO9N");

defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		lineHeight: 1.2,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

module.exports = function(Chart) {

	var layout = Chart.layoutService;
	var noop = helpers.noop;

	Chart.Title = Element.extend({
		initialize: function(config) {
			var me = this;
			helpers.extend(me, config);

			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},

		// These methods are ordered by lifecycle. Utilities then follow.

		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: noop,

		//

		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,

		//

		beforeBuildLabels: noop,
		buildLabels: noop,
		afterBuildLabels: noop,

		//

		beforeFit: noop,
		fit: function() {
			var me = this;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = me.options;
			var display = opts.display;
			var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
			var minSize = me.minSize;
			var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
			var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
			var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;

			if (me.isHorizontal()) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = textSize;
			} else {
				minSize.width = textSize;
				minSize.height = me.maxHeight; // fill all the height
			}

			me.width = minSize.width;
			me.height = minSize.height;

		},
		afterFit: noop,

		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},

		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = me.options;
			var globalDefaults = defaults.global;

			if (opts.display) {
				var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
				var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
				var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
				var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
				var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
				var offset = lineHeight / 2 + opts.padding;
				var rotation = 0;
				var top = me.top;
				var left = me.left;
				var bottom = me.bottom;
				var right = me.right;
				var maxWidth, titleX, titleY;

				ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
				ctx.font = titleFont;

				// Horizontal
				if (me.isHorizontal()) {
					titleX = left + ((right - left) / 2); // midpoint of the width
					titleY = top + offset;
					maxWidth = right - left;
				} else {
					titleX = opts.position === 'left' ? left + offset : right - offset;
					titleY = top + ((bottom - top) / 2);
					maxWidth = bottom - top;
					rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
				}

				ctx.save();
				ctx.translate(titleX, titleY);
				ctx.rotate(rotation);
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';

				var text = opts.text;
				if (helpers.isArray(text)) {
					var y = 0;
					for (var i = 0; i < text.length; ++i) {
						ctx.fillText(text[i], 0, y, maxWidth);
						y += lineHeight;
					}
				} else {
					ctx.fillText(text, 0, 0, maxWidth);
				}

				ctx.restore();
			}
		}
	});

	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Chart.Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});

		layout.configure(chart, title, titleOpts);
		layout.addBox(chart, title);
		chart.titleBlock = title;
	}

	return {
		id: 'title',

		beforeInit: function(chart) {
			var titleOpts = chart.options.title;

			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},

		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;

			if (titleOpts) {
				helpers.mergeIf(titleOpts, defaults.global.title);

				if (titleBlock) {
					layout.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				Chart.layoutService.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
};


/***/ }),

/***/ "lVVc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_select_modal_style_sass__ = __webpack_require__("p9qD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_select_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__calendar_select_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_select_modal_tpl_pug__ = __webpack_require__("h6eA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_select_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_select_modal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CalendarSelectModalController = function () {
    function CalendarSelectModalController() {
        _classCallCheck(this, CalendarSelectModalController);
    }

    _createClass(CalendarSelectModalController, [{
        key: 'select',
        value: function select(calendar) {
            this.onClose({
                data: calendar
            });
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            this.onDismiss();
        }
    }]);

    return CalendarSelectModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarSelectModal',
    template: __WEBPACK_IMPORTED_MODULE_1__calendar_select_modal_tpl_pug___default()(),
    controller: CalendarSelectModalController,
    bindings: {
        calendars: '<',
        selected: '<',
        title: '<',

        onClose: '&',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "lY5P":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category-edit-modal modal-fixed-height\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.save()\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\"\u003E\u003Cspan ng-show=\"$ctrl.canEdit\"\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003EAdd new category\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003EEdit category\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan ng-hide=\"$ctrl.canEdit\"\u003EView category\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter modal-section\"\u003E\u003Cdiv class=\"category-info\"\u003E\u003Cdb-a-category class=\"category-preview\" name=\"$ctrl.category.name\" color=\"$ctrl.category.color\" icon-name=\"$ctrl.category.iconName\" icon-index=\"$ctrl.category.iconIndex\" use-icons=\"true\" fallback-icon-name=\"null\"\u003E\u003C\u002Fdb-a-category\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-tabs\"\u003E\u003Cbutton class=\"button-tab\" type=\"button\" ng-class=\"{ active: $ctrl.activeTab === 'label' }\" ng-click=\"$ctrl.selectTab('label')\"\u003EName\u003C\u002Fbutton\u003E\u003Cbutton class=\"button-tab\" type=\"button\" ng-class=\"{ active: $ctrl.activeTab === 'color' }\" ng-click=\"$ctrl.selectTab('color')\"\u003EColors\u003C\u002Fbutton\u003E\u003Cbutton class=\"button-tab\" type=\"button\" ng-class=\"{ active: $ctrl.activeTab === 'icon' }\" ng-click=\"$ctrl.selectTab('icon')\"\u003EIcons\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-tab-content\"\u003E\u003Cdiv class=\"category-tab-item\" ng-show=\"$ctrl.activeTab === 'label'\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"text\" id=\"category-name-control\" name=\"name\" placeholder=\"e.g. Food\" ng-model=\"$ctrl.category.name\" db-a-autofocus=\"$ctrl.canEdit &amp;&amp; !$ctrl.existing\" ng-readonly=\"!$ctrl.canEdit\" required\u003E\u003Clabel class=\"control-validation\" for=\"category-name-control\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003EFill in the name\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-tab-item\" ng-show=\"$ctrl.activeTab === 'color'\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cdb-a-color-palette colors=\"$ctrl.colors\" ng-model=\"$ctrl.category.color\" ng-disabled=\"!$ctrl.canEdit\" rows=\"4\" columns=\"7\" required\u003E\u003C\u002Fdb-a-color-palette\u003E\u003Clabel class=\"control-validation\"\u003E\u003Cdb-a-validation-message key=\"required\"\u003ESelect a color\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"category-tab-item\" ng-show=\"$ctrl.activeTab === 'icon'\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cdb-a-icon-palette icons=\"$ctrl.icons\" ng-model=\"$ctrl.category.iconIndex\" icon-color=\"$ctrl.category.color\" ng-disabled=\"!$ctrl.canEdit\" rows=\"4\" columns=\"7\" on-change=\"$ctrl.selectIcon(icon)\"\u003E\u003C\u002Fdb-a-icon-palette\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-danger button-remove button-modal-left button-remove-category\" type=\"button\" ng-show=\"$ctrl.existing &amp;&amp; $ctrl.canDelete\" ng-click=\"$ctrl.remove()\"\u003E\u003Ci class=\"icon-delete icon-dollarbird-delete\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-link button-danger button-merge button-modal-left button-merge-category\" type=\"button\" ng-show=\"$ctrl.existing &amp;&amp; $ctrl.canDelete\" ng-click=\"$ctrl.merge()\"\u003E\u003Ci class=\"icon-merge\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-link button-modal-left button-close-modal\" type=\"button\" ng-show=\"!$ctrl.canEdit\" ng-click=\"$ctrl.dismiss()\"\u003EClose\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-save-category\" type=\"submit\" db-a-async ng-show=\"$ctrl.canEdit\" ng-disabled=\"form.$submitting\"\u003E\u003Cinitial\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ECreate\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ESave\u003C\u002Fspan\u003E\u003C\u002Finitial\u003E\u003Cloading\u003E\u003Cspan ng-hide=\"$ctrl.existing\"\u003ECreating...\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.existing\"\u003ESaving...\u003C\u002Fspan\u003E\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "lgK8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autofocus_directive__ = __webpack_require__("g4i6");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.autofocus', []).directive(__WEBPACK_IMPORTED_MODULE_1__autofocus_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__autofocus_directive__["a" /* default */]));

/***/ }),

/***/ "lhZF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Property-1-Shield-b4e13f132fbcf5a5.svg";

/***/ }),

/***/ "liEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("tJW2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_edit_modal_cmpt__ = __webpack_require__("uaBl");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.category-edit-modal', [__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_2__category_edit_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__category_edit_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "lnWs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_27-e22f016c960a6900.svg";

/***/ }),

/***/ "m/2A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cash-flow-chart":"cash-flow-chart","chart-container":"chart-container","chart-content":"chart-content","visible":"visible","chart-error":"chart-error","chart-selected-period":"chart-selected-period","chart-meta":"chart-meta","meta-heading":"meta-heading","meta-value":"meta-value"};

/***/ }),

/***/ "m4tL":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("M1c9"),
    toInteger = __webpack_require__("5Zxu");

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = take;


/***/ }),

/***/ "mC8W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");

defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	showLines: false,

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

module.exports = function(Chart) {

	// Scatter charts use line controllers
	Chart.controllers.scatter = Chart.controllers.line;

};


/***/ }),

/***/ "mE2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__custom_error_directive__ = __webpack_require__("ia/i");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.custom-error', []).directive(__WEBPACK_IMPORTED_MODULE_1__custom_error_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__custom_error_directive__["a" /* default */]));

/***/ }),

/***/ "mGzp":
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__("2X2u"),
    baseIteratee = __webpack_require__("JyYQ"),
    baseSome = __webpack_require__("LkuQ"),
    isArray = __webpack_require__("NGEn"),
    isIterateeCall = __webpack_require__("zBOP");

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ "mRXS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-day":"calendar-day","day-heading":"day-heading","day-date":"day-date","day-values":"day-values","day-change":"day-change","day-balance":"day-balance","button-add-container":"button-add-container","button-add-event":"button-add-event","disabled":"disabled","day-content":"day-content","day-event":"day-event","button-show-more-events":"button-show-more-events","icon-plus":"icon-plus","readonly":"readonly","another":"another","today":"today"};

/***/ }),

/***/ "mTmz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryGroceries-542450aef0d72da2.svg";

/***/ }),

/***/ "mUT3":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdb-a-notification\u003E\u003Cnotification-title\u003EHm...\u003C\u002Fnotification-title\u003E\u003Cnotification-content\u003E\u003Cspan\u003ELooks like you already have an active subscription. View your subscription details \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"authorized.calendar.settings.subscription\" ng-click=\"$ctrl.close()\"\u003Ehere\u003C\u002Fa\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fnotification-content\u003E\u003C\u002Fdb-a-notification\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "mVCC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-More-dots-d7e248c67ec8f497.svg";

/***/ }),

/***/ "mWUN":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("yZbI");
module.exports = 'ngAnimate';


/***/ }),

/***/ "mYgp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Percent-40d9114d8da361d0.svg";

/***/ }),

/***/ "mZnQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cash_flow_chart_cmpt__ = __webpack_require__("oUc+");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.dashboard.component.cash-flow-chart', []).component(__WEBPACK_IMPORTED_MODULE_1__cash_flow_chart_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__cash_flow_chart_cmpt__["a" /* default */]));

/***/ }),

/***/ "mg6x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ "mhet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = MatchDirective;
MatchDirective.$inject = ['$parse'];
var selector = 'dbAMatch';

/* @ngInject */
function MatchDirective($parse) {
    return {
        restrict: 'A',
        require: 'ngModel',

        link: function link(scope, element, attrs, ctrl) {
            var getValue = $parse(attrs[selector]);
            var getIgnoreCase = $parse(attrs.ignoreCase);
            var getInverse = $parse(attrs.inverse);

            ctrl.$parsers.unshift(function (value) {
                validate(value);
                return value;
            });

            ctrl.$formatters.unshift(function (value) {
                validate(value);
                return value;
            });

            function validate(value) {
                var valid = equals(getValue(scope), value, getIgnoreCase(scope), getInverse());

                ctrl.$setValidity('match', valid);

                return valid;
            }

            function equals(value1, value2, ignoreCase, inverse) {
                if (ignoreCase) {
                    value1 = String.prototype.toLowerCase.call(value1 || '');
                    value2 = String.prototype.toLowerCase.call(value2 || '');
                }

                return inverse ? value1 === value2 : value1 !== value2;
            }
        }
    };
}

/***/ }),

/***/ "mrfP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-checkbox":"calendar-checkbox","selected":"selected","calendar-checkbox-state":"calendar-checkbox-state","calendar-checkbox-name":"calendar-checkbox-name"};

/***/ }),

/***/ "msgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrollContainerDirective;
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var selector = 'dbAScrollContainer';

var ScrollContainerController = function () {
    ScrollContainerController.$inject = ['$element'];

    /* @ngInject */
    function ScrollContainerController($element) {
        _classCallCheck(this, ScrollContainerController);

        this.$element = $element;
    }

    _createClass(ScrollContainerController, [{
        key: 'scrollToElement',
        value: function scrollToElement(element) {
            this.$element[0].scrollTop = this.getScrollPositionCenter(element);
        }
    }, {
        key: 'getScrollPositionCenter',
        value: function getScrollPositionCenter(element) {
            return element.offsetTop + (element.clientHeight - this.$element[0].clientHeight) / 2;
        }
    }]);

    return ScrollContainerController;
}();

/* @ngInject */


function ScrollContainerDirective() {
    return {
        restrict: 'A',
        controller: ScrollContainerController
    };
}

/***/ }),

/***/ "n1Zt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_analytics__ = __webpack_require__("3pWh");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ModalService = function () {
    ModalService.$inject = ['$q', 'navigationService'];

    /* @ngInject */
    function ModalService($q, navigationService) {
        var _this = this;

        _classCallCheck(this, ModalService);

        this.$q = $q;

        navigationService.onSuccess(function () {
            _this.modals.forEach(function (modal) {
                return modal.dismiss();
            });
        });

        this.modals = [];
    }

    _createClass(ModalService, [{
        key: 'open',
        value: function open(modal) {
            var _this2 = this;

            modal = modal || {};
            modal.bindings = modal.bindings || {};
            modal.bindings.index = this.modals.length;

            modal.promise = this.$q(function (resolve, reject) {
                modal.close = _this2.safeCall(modal, resolve);
                modal.dismiss = _this2.safeCall(modal, reject);
                modal.bindings.onClose = _this2.addCallback(modal, modal.bindings.onClose, modal.close);
                modal.bindings.onDismiss = _this2.safeCall(modal, function () {
                    var _modal;

                    __WEBPACK_IMPORTED_MODULE_1_common_analytics__["c" /* default */].trackModalDismissByTrigger();
                    return (_modal = modal).dismiss.apply(_modal, arguments);
                });
            }).finally(function () {
                var index = _this2.modals.indexOf(modal);
                if (index >= 0) {
                    _this2.modals.splice(index, 1);
                }
            });

            this.modals.push(modal);

            return modal.promise;
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            var modal = this.modals[this.modals.length - 1];
            if (modal && !modal.static) {
                modal.dismiss();
            }
        }

        // make sure the modal can't be closed/dismissed while it's being closed/dismissed

    }, {
        key: 'safeCall',
        value: function safeCall(modal, callback) {
            return function () {
                return modal.closing || callback.apply(undefined, arguments);
            };
        }
    }, {
        key: 'addCallback',
        value: function addCallback(modal, pre, post) {
            var _this3 = this;

            pre = pre || __WEBPACK_IMPORTED_MODULE_0_angular___default.a.noop;

            return function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                modal.closing = _this3.$q.when(pre.apply(undefined, args)).finally(function () {
                    return delete modal.closing;
                });
                return modal.closing.then(function () {
                    return post.apply(undefined, args);
                }).catch(function () {
                    return null;
                });
            };
        }
    }]);

    return ModalService;
}();

/* harmony default export */ __webpack_exports__["a"] = (ModalService);

/***/ }),

/***/ "n2mO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__("ksva");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scene__ = __webpack_require__("rPNC");
stateConfiguration.$inject = ['$stateProvider'];





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.forgot-password', [__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__scene__["a" /* default */].name]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.forgot-password', {
        url: '/forgot-password',
        abstract: true,
        template: '<ui-view class="block-component"></ui-view>'
    });
}

/***/ }),

/***/ "n4aM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"account-settings-page":"account-settings-page","form-group":"form-group","account-expiration":"account-expiration","plan-note":"plan-note","button-pricing-get-started":"button-pricing-get-started","button-update-settings":"button-update-settings","button-send-confirmation-email":"button-send-confirmation-email","button-change-password":"button-change-password","button-generate-backup":"button-generate-backup","button-restore-data":"button-restore-data","button-export-data":"button-export-data","button-download-data":"button-download-data","button-delete-account":"button-delete-account"};

/***/ }),

/***/ "nJpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date_picker_style_sass__ = __webpack_require__("aLVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date_picker_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__date_picker_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__date_picker_tpl_pug__ = __webpack_require__("PZT5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__date_picker_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__date_picker_tpl_pug__);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var DatePickerController = function () {
    DatePickerController.$inject = ['timeUtil'];

    /* @ngInject */
    function DatePickerController(timeUtil) {
        _classCallCheck(this, DatePickerController);

        this.timeUtil = timeUtil;
    }

    _createClass(DatePickerController, [{
        key: '$onInit',
        value: function $onInit() {
            this.weekdays = this.timeUtil.getWeekdays(this.startOfWeek).map(function (day) {
                return {
                    name: __WEBPACK_IMPORTED_MODULE_3_moment___default()(day.timestamp).format('ddd'),
                    weekend: day.weekend
                };
            });
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.date) {
                this.selectedTimestamp = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date).startOf('day').valueOf();
            }

            if (changeObject.viewTimestamp || changeObject.date) {
                this.renderMonth(this.viewTimestamp || this.selectedTimestamp);
            }
        }
    }, {
        key: 'renderMonth',
        value: function renderMonth(viewTimestamp) {
            this.viewTimestamp = __WEBPACK_IMPORTED_MODULE_3_moment___default()(viewTimestamp).startOf('day').valueOf();
            this.monthName = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.viewTimestamp).format('MMMM YYYY');

            this.weeks = this.createWeeks(this.viewTimestamp);
        }
    }, {
        key: 'changeMonth',
        value: function changeMonth(viewTimestamp) {
            this.renderMonth(viewTimestamp);

            this.onViewChange({
                timestamp: this.viewTimestamp
            });
        }
    }, {
        key: 'createWeeks',
        value: function createWeeks(viewTimestamp) {
            var _this = this;

            var weeks = [];

            var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()();

            __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(this.timeUtil.getDaysForMonth(viewTimestamp, this.startOfWeek, 42), function (day, index) {
                index = Math.floor(index / 7);

                if (index >= weeks.length) {
                    weeks.push([]);
                }

                var item = {
                    timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()(day.timestamp).set({
                        hour: now.get('hour'),
                        minute: now.get('minute'),
                        second: now.get('second')
                    }).valueOf(),
                    date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(day.timestamp).date(),
                    style: {
                        active: _this.checkActive(_this.selectedTimestamp, day),
                        weekend: day.weekend,
                        another: day.previous || day.next,
                        today: day.today,
                        highlighted: _this.onDayCheckHighlighted({
                            timestamp: day.timestamp
                        }),
                        disabled: _this.onDayCheckDisabled({
                            timestamp: day.timestamp
                        })
                    }
                };

                item.style.hidden = _this.hideDaysFromOtherMonth && item.style.another;

                weeks[index].push(item);
            });

            __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(weeks, function (week) {
                __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(week, function (day, index) {
                    if (day.style.highlighted) {
                        day.style['first-highlighted'] = index === 0 || !week[index - 1].style.highlighted || week[index - 1].style.hidden;
                        day.style['last-highlighted'] = index === week.length - 1 || !week[index + 1].style.highlighted || week[index + 1].style.hidden;
                    }
                });
            });

            return this.filterHiddenWeeks(weeks);
        }
    }, {
        key: 'filterHiddenWeeks',
        value: function filterHiddenWeeks(weeks) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(weeks, function (week) {
                var hiddenDayCount = __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()(week, function (count, day) {
                    if (day.style.hidden) {
                        return count + 1;
                    }

                    return count;
                }, 0);

                return hiddenDayCount < week.length;
            });
        }
    }, {
        key: 'selectPreviousMonth',
        value: function selectPreviousMonth() {
            this.changeMonth(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.viewTimestamp).subtract(1, 'month').valueOf());
        }
    }, {
        key: 'selectNextMonth',
        value: function selectNextMonth() {
            this.changeMonth(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.viewTimestamp).add(1, 'month').valueOf());
        }
    }, {
        key: 'checkActive',
        value: function checkActive(timestamp, day) {
            var active = this.onDayCheckActive({
                timestamp: day.timestamp
            });

            return active == null ? timestamp === day.timestamp : active;
        }
    }, {
        key: 'selectDay',
        value: function selectDay(timestamp) {
            return this.onDaySelect({
                timestamp: timestamp
            });
        }
    }]);

    return DatePickerController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbADatePicker',
    template: __WEBPACK_IMPORTED_MODULE_5__date_picker_tpl_pug___default()(),
    controller: DatePickerController,
    bindings: {
        date: '<timestamp',
        startOfWeek: '<',
        viewTimestamp: '<',

        preventNavigationToPreviousMonth: '<',
        preventNavigationToNextMonth: '<',
        hideDaysFromOtherMonth: '<',

        onDaySelect: '&',
        onDayCheckActive: '&',
        onDayCheckDisabled: '&',
        onDayCheckHidden: '&',
        onDayCheckHighlighted: '&',
        onViewChange: '&'
    }
});

/***/ }),

/***/ "nMZG":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdb-a-notification\u003E\u003Cnotification-title\u003EPlease verify your email address!\u003C\u002Fnotification-title\u003E\u003Cnotification-content ng-if=\"!$ctrl.message\"\u003E\u003Cspan ng-if=\"$ctrl.expired\"\u003EYour account has expired. \u003C\u002Fspan\u003E\u003Cspan ng-if=\"!$ctrl.expired\"\u003E\u003Cspan\u003EYou still have \u003C\u002Fspan\u003E\u003Cdb-a-time timestamp=\"$ctrl.expire\" max-unit=\"day\" on-end=\"$ctrl.close()\"\u003E\u003C\u002Fdb-a-time\u003E\u003Cspan\u003E left to verify it. \u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan\u003EIn case of you lost the email we have sent, you can \u003Cbutton class=\"link\" type=\"button\" ng-click=\"$ctrl.resend()\"\u003Eresend it from here\u003C\u002Fbutton\u003E\u003Cspan\u003E or from the \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"authorized.calendar.settings.account\"\u003Esettings\u003C\u002Fa\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fnotification-content\u003E\u003Cnotification-content ng-if=\"$ctrl.message\" ng-bind=\"$ctrl.message\"\u003E\u003C\u002Fnotification-content\u003E\u003C\u002Fdb-a-notification\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "nYk1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"team-list":"team-list","sortable-drag":"sortable-drag","sortable-fallback":"sortable-fallback","team-items":"team-items","sorting":"sorting","team-item":"team-item","sortable-ghost":"sortable-ghost","button-add-team":"button-add-team","active":"active","drag-handle":"drag-handle","team-state":"team-state","team-content":"team-content","team-name":"team-name","team-owner":"team-owner","team-add-container":"team-add-container","link-add-team":"link-add-team"};

/***/ }),

/***/ "nl3g":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdb-a-dashboard-card class=\"card-with-period\" ng-attr-data-name=\"{{ ::$ctrl.name }}\"\u003E\u003Ccard-date\u003E\u003Cdiv class=\"chart-period\"\u003E\u003Cdiv class=\"chart-period-items\"\u003E\u003Cbutton class=\"button chart-period-item\" type=\"button\" ng-repeat=\"period in $ctrl.periods\" ng-class=\"{ 'button-fill button-primary': $ctrl.isActive(period), 'button-outline button-secondary': !$ctrl.isActive(period) }\" ng-click=\"$ctrl.select(period)\" ng-bind=\"period.name\"\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"chart-confirmed-filter\" ng-if=\"$ctrl.confirmedFilterOptions &amp;&amp; $ctrl.confirmedFilterOptions.length\"\u003E\u003Cbutton class=\"button chart-period-item\" type=\"button\" ng-repeat=\"option in $ctrl.confirmedFilterOptions track by option.id\" ng-class=\"{ 'button-fill button-primary': $ctrl.isConfirmedFilterActive(option), 'button-outline button-secondary': !$ctrl.isConfirmedFilterActive(option) }\" ng-click=\"$ctrl.selectConfirmedFilter(option)\" ng-bind=\"option.value\"\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"chart-custom-range-tooltip\" ng-if=\"$ctrl.isCustomVisible\" db-a-outside-click=\"$ctrl.hideDateRange()\"\u003E\u003Cdb-a-date-range-picker start=\"$ctrl.start\" end=\"$ctrl.end\" start-of-week=\"$ctrl.startOfWeek\" on-change=\"$ctrl.selectCustom(start, end)\"\u003E\u003C\u002Fdb-a-date-range-picker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fcard-date\u003E\u003Ccard-content ng-transclude\u003E\u003C\u002Fcard-content\u003E\u003C\u002Fdb-a-dashboard-card\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "nrl3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryPersonalCare-5616d6d8f13ba78f.svg";

/***/ }),

/***/ "nsAZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_group_cmpt__ = __webpack_require__("4aOx");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-dashboard.component.event-group', []).component(__WEBPACK_IMPORTED_MODULE_1__event_group_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__event_group_cmpt__["a" /* default */]));

/***/ }),

/***/ "nwX1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TeamService = function () {
    TeamService.$inject = ['apiService'];

    /* @ngInject */
    function TeamService(apiService) {
        _classCallCheck(this, TeamService);

        this.apiService = apiService;
    }

    _createClass(TeamService, [{
        key: 'create',
        value: function create(team) {
            return this.apiService.post('/teams', team).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'update',
        value: function update(team) {
            return this.apiService.put('/teams/' + team.id, {
                name: team.name
            }).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'remove',
        value: function remove(team) {
            return this.apiService.delete('/teams/' + team.id).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'leave',
        value: function leave(team) {
            return this.apiService.post('/teams/' + team.id + '/leave').then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'getNoteMapping',
        value: function getNoteMapping(teamId) {
            return this.apiService.get('/teams/' + teamId + '/note-category-map').then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'getMembers',
        value: function getMembers(teamId) {
            return this.apiService.get('/teams/' + teamId + '/members').then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'updateMembers',
        value: function updateMembers(teamId, addedMembers, removedMembers) {
            var operations = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(addedMembers, function (user) {
                return {
                    operation: 'create',
                    email: user.email
                };
            });

            operations = __WEBPACK_IMPORTED_MODULE_0_lodash_concat___default()(operations, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(removedMembers, function (user) {
                return {
                    operation: 'delete',
                    email: user.email
                };
            }));

            return this.apiService.patch('/teams/' + teamId + '/members', operations).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'reorder',
        value: function reorder(ids) {
            return this.apiService.post('/teams/order', ids).then(function (result) {
                return result.data;
            });
        }
    }]);

    return TeamService;
}();

/* harmony default export */ __webpack_exports__["a"] = (TeamService);

/***/ }),

/***/ "nyB0":
/***/ (function(module, exports) {

module.exports = [{"iconIndex":1,"pdfFilename":"iconCategoryCar.pdf","svgFilename":"iconCategoryCar.svg"},{"iconIndex":2,"pdfFilename":"iconCategoryEntertainment.pdf","svgFilename":"iconCategoryEntertainment.svg"},{"iconIndex":3,"pdfFilename":"iconCategoryHousehold.pdf","svgFilename":"iconCategoryHousehold.svg"},{"iconIndex":4,"pdfFilename":"iconCategoryHealth.pdf","svgFilename":"iconCategoryHealth.svg"},{"iconIndex":5,"pdfFilename":"iconCategoryEatingOut.pdf","svgFilename":"iconCategoryEatingOut.svg"},{"iconIndex":6,"pdfFilename":"iconCategoryGroceries.pdf","svgFilename":"iconCategoryGroceries.svg"},{"iconIndex":7,"pdfFilename":"iconCategoryClothes.pdf","svgFilename":"iconCategoryClothes.svg"},{"iconIndex":8,"pdfFilename":"iconCategoryFitness.pdf","svgFilename":"iconCategoryFitness.svg"},{"iconIndex":9,"pdfFilename":"iconCategoryPersonalCare.pdf","svgFilename":"iconCategoryPersonalCare.svg"},{"iconIndex":10,"pdfFilename":"iconCategorySubscription.pdf","svgFilename":"iconCategorySubscription.svg"},{"iconIndex":11,"pdfFilename":"iconCategoryIncome.pdf","svgFilename":"iconCategoryIncome.svg"},{"iconIndex":12,"pdfFilename":"iconCategoryUncategorized.pdf","svgFilename":"iconCategoryUncategorized.svg"},{"iconIndex":13,"pdfFilename":"iconCategoryBalanceUpdate.pdf","svgFilename":"iconCategoryBalanceUpdate.svg"},{"iconIndex":14,"pdfFilename":"iconCategoryTransfer.pdf","svgFilename":"iconCategoryTransfer.svg"},{"iconIndex":15,"pdfFilename":"ic_category_15.pdf","svgFilename":"ic_category_15.svg"},{"iconIndex":16,"pdfFilename":"ic_category_16.pdf","svgFilename":"ic_category_16.svg"},{"iconIndex":17,"pdfFilename":"ic_category_17.pdf","svgFilename":"ic_category_17.svg"},{"iconIndex":18,"pdfFilename":"ic_category_18.pdf","svgFilename":"ic_category_18.svg"},{"iconIndex":19,"pdfFilename":"ic_category_19.pdf","svgFilename":"ic_category_19.svg"},{"iconIndex":20,"pdfFilename":"ic_category_20.pdf","svgFilename":"ic_category_20.svg"},{"iconIndex":21,"pdfFilename":"ic_category_21.pdf","svgFilename":"ic_category_21.svg"},{"iconIndex":22,"pdfFilename":"ic_category_22.pdf","svgFilename":"ic_category_22.svg"},{"iconIndex":23,"pdfFilename":"ic_category_23.pdf","svgFilename":"ic_category_23.svg"},{"iconIndex":24,"pdfFilename":"ic_category_24.pdf","svgFilename":"ic_category_24.svg"},{"iconIndex":25,"pdfFilename":"ic_category_25.pdf","svgFilename":"ic_category_25.svg"},{"iconIndex":26,"pdfFilename":"ic_category_26.pdf","svgFilename":"ic_category_26.svg"},{"iconIndex":27,"pdfFilename":"ic_category_27.pdf","svgFilename":"ic_category_27.svg"},{"iconIndex":28,"pdfFilename":"ic_category_28.pdf","svgFilename":"ic_category_28.svg"},{"iconIndex":29,"pdfFilename":"ic_category_29.pdf","svgFilename":"ic_category_29.svg"},{"iconIndex":30,"pdfFilename":"ic_category_30.pdf","svgFilename":"ic_category_30.svg"},{"iconIndex":31,"pdfFilename":"ic_category_31.pdf","svgFilename":"ic_category_31.svg"},{"iconIndex":32,"pdfFilename":"ic_category_32.pdf","svgFilename":"ic_category_32.svg"},{"iconIndex":33,"pdfFilename":"ic_category_33.pdf","svgFilename":"ic_category_33.svg"},{"iconIndex":34,"pdfFilename":"ic_category_34.pdf","svgFilename":"ic_category_34.svg"},{"iconIndex":35,"pdfFilename":"ic_category_35.pdf","svgFilename":"ic_category_35.svg"},{"iconIndex":36,"pdfFilename":"Property 1=Coffee cup (1).pdf","svgFilename":"Property-1-Coffee-cup-1.svg"},{"iconIndex":37,"pdfFilename":"Property 1=Coffee cup 2.pdf","svgFilename":"Property-1-Coffee-cup-2.svg"},{"iconIndex":38,"pdfFilename":"Property 1=Receipt.pdf","svgFilename":"Property-1-Receipt.svg"},{"iconIndex":39,"pdfFilename":"Property 1=Piggy Bank.pdf","svgFilename":"Property-1-Piggy-Bank.svg"},{"iconIndex":40,"pdfFilename":"Property 1=Shield.pdf","svgFilename":"Property-1-Shield.svg"},{"iconIndex":41,"pdfFilename":"Paw.pdf","svgFilename":"Paw.svg"},{"iconIndex":42,"pdfFilename":"Recurring arrows.pdf","svgFilename":"Recurring-arrows.svg"},{"iconIndex":43,"pdfFilename":"Balance scale.pdf","svgFilename":"Balance-scale.svg"},{"iconIndex":44,"pdfFilename":"Charts.pdf","svgFilename":"Charts.svg"},{"iconIndex":45,"pdfFilename":"Banknote.pdf","svgFilename":"Banknote.svg"},{"iconIndex":46,"pdfFilename":"Percent.pdf","svgFilename":"Percent.svg"},{"iconIndex":47,"pdfFilename":"Calculator.pdf","svgFilename":"Calculator.svg"},{"iconIndex":48,"pdfFilename":"Wrench.pdf","svgFilename":"Wrench.svg"},{"iconIndex":49,"pdfFilename":"Key.pdf","svgFilename":"Key.svg"},{"iconIndex":50,"pdfFilename":"Bed.pdf","svgFilename":"Bed.svg"},{"iconIndex":51,"pdfFilename":"Broom.pdf","svgFilename":"Broom.svg"},{"iconIndex":52,"pdfFilename":"Scrissors.pdf","svgFilename":"Scrissors.svg"},{"iconIndex":53,"pdfFilename":"Pill.pdf","svgFilename":"Pill.svg"},{"iconIndex":54,"pdfFilename":"Bed-1.pdf","svgFilename":"Bed-1.svg"},{"iconIndex":55,"pdfFilename":"Books.pdf","svgFilename":"Books.svg"},{"iconIndex":56,"pdfFilename":"Heart Hands.pdf","svgFilename":"Heart-Hands.svg"},{"iconIndex":57,"pdfFilename":"Wifi.pdf","svgFilename":"Wifi.svg"},{"iconIndex":58,"pdfFilename":"Running.pdf","svgFilename":"Running.svg"},{"iconIndex":59,"pdfFilename":"Laptop.pdf","svgFilename":"Laptop.svg"},{"iconIndex":60,"pdfFilename":"More dots.pdf","svgFilename":"More-dots.svg"},{"iconIndex":61,"pdfFilename":"Wuestion Mark.pdf","svgFilename":"Wuestion-Mark.svg"},{"iconIndex":62,"pdfFilename":"Cross.pdf","svgFilename":"Cross.svg"},{"iconIndex":63,"pdfFilename":"Baby.pdf","svgFilename":"Baby.svg"}]

/***/ }),

/***/ "nyMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_list_modal_cmpt__ = __webpack_require__("BsFo");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.event-list-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__event_list_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__event_list_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "o7lu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"event-list-modal":"event-list-modal","day-date":"day-date","day-data":"day-data","heading-day-data":"heading-day-data","day-data-title":"day-data-title","day-data-value":"day-data-value","group":"group","group-heading":"group-heading","group-name":"group-name","group-value":"group-value","events":"events","event-item":"event-item","event-confirmation-state":"event-confirmation-state","event-balance-update-placeholder":"event-balance-update-placeholder","event-category-icon-left":"event-category-icon-left","event-confirmation-checkmark":"event-confirmation-checkmark","event-balance-update-icon":"event-balance-update-icon","icon":"icon","loader-container":"loader-container","event-note-container":"event-note-container","event-note":"event-note","event-note-text":"event-note-text","event-icons":"event-icons","event-category-icon":"event-category-icon","event-repeating":"event-repeating","event-receipt":"event-receipt","event-value":"event-value","confirmed":"confirmed","use-category-icons":"use-category-icons","async-loading":"async-loading","empty-state":"empty-state","empty":"empty","modal-footer":"modal-footer","footer-day-data":"footer-day-data","modal-fixed-height":"modal-fixed-height","modal-body":"modal-body"};

/***/ }),

/***/ "oLRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_color__ = __webpack_require__("BhGz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category__ = __webpack_require__("JiEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_edit_modal__ = __webpack_require__("j95d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_date_modal__ = __webpack_require__("v70l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_details_modal__ = __webpack_require__("q0gM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_receipt_modal__ = __webpack_require__("dDla");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event_repeat_change_modal__ = __webpack_require__("AL3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_repeat_delete_modal__ = __webpack_require__("LVGs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__event_list_modal__ = __webpack_require__("nyMU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__category_select_modal__ = __webpack_require__("5BGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__category_manage_modal__ = __webpack_require__("LTak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__category_edit_modal__ = __webpack_require__("liEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__category_merge_modal__ = __webpack_require__("OfXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__calendar_edit_modal__ = __webpack_require__("LcjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__calendar_select_default_modal__ = __webpack_require__("qC7n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__calendar_select_modal__ = __webpack_require__("xESi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__confirm_modal__ = __webpack_require__("aPo/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__team_edit_modal__ = __webpack_require__("l5SJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__email_ingest_token_modal__ = __webpack_require__("CusM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__collaborator_invite_modal__ = __webpack_require__("0O7t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__collaborator_manage_modal__ = __webpack_require__("NtIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__date_modal__ = __webpack_require__("xKDW");

























/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component', [__WEBPACK_IMPORTED_MODULE_1__category_color__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__category__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__event_edit_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__event_date_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__event_details_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__event_receipt_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__event_repeat_change_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__event_repeat_delete_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__event_list_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__category_select_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__category_manage_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__category_edit_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_13__category_merge_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__calendar_edit_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_15__calendar_select_default_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_16__calendar_select_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_17__confirm_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_18__team_edit_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_19__email_ingest_token_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_20__collaborator_invite_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_21__collaborator_manage_modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_22__date_modal__["a" /* default */].name]));

/***/ }),

/***/ "oQMP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("iO9N");

module.exports = function(Chart) {

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function(key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	Chart.DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers.extend(Chart.DatasetController.prototype, {

		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,

		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,

		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},

		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();

			if (meta.xAxisID === null) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},

		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},

		reset: function() {
			this.update(true);
		},

		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				listenArrayEvents(data, me);
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		update: helpers.noop,

		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},

		removeHoverStyle: function(element, elementOpts) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var model = element._model;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
		},

		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var getHoverColor = helpers.getHoverColor;
			var model = element._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
		 * @private
		 */
		onDataPush: function() {
			this.insertElements(this.getDataset().data.length - 1, arguments.length);
		},

		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},

		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},

		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});

	Chart.DatasetController.extend = helpers.inherits;
};


/***/ }),

/***/ "oUc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge__ = __webpack_require__("HN2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_slice__ = __webpack_require__("bpPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_application_util_number_util__ = __webpack_require__("Cybx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cash_flow_chart_style_sass__ = __webpack_require__("m/2A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cash_flow_chart_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__cash_flow_chart_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cash_flow_chart_tpl_pug__ = __webpack_require__("4ONb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cash_flow_chart_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__cash_flow_chart_tpl_pug__);






var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










var CashFlowChartController = function () {
    CashFlowChartController.$inject = ['dashboardService'];

    /* @ngInject */
    function CashFlowChartController(dashboardService) {
        _classCallCheck(this, CashFlowChartController);

        this.dashboardService = dashboardService;

        this.options = this.getChartOptions();
    }

    _createClass(CashFlowChartController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loading = true;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.calendarIds || changeObject.start || changeObject.end) {
                return this.load(this.calendarIds, __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.start).startOf('day').valueOf(), __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.end).endOf('day').valueOf());
            }
        }
    }, {
        key: 'getTooltipLabel',
        value: function getTooltipLabel(item, data) {
            var index = item['index'];
            var datasetIndex = item.datasetIndex;

            // skip the common point having 2 balances in the tooltip
            if (datasetIndex === 1 && data.datasets[0].data.length > index) {
                return null;
            }

            var balance = Object(__WEBPACK_IMPORTED_MODULE_6_application_util_number_util__["c" /* prettifyNumber */])(data.datasets[datasetIndex].data[index], {
                preventShrink: true,
                pretty: true
            });

            var change = Object(__WEBPACK_IMPORTED_MODULE_6_application_util_number_util__["c" /* prettifyNumber */])(data.datasets[datasetIndex].changes[index], {
                preventShrink: true,
                addPositiveSign: true,
                pretty: true
            });

            return [datasetIndex === 0 ? 'Balance' : 'Forecasted balance', balance, 'Change', change];
        }
    }, {
        key: 'getBalanceTick',
        value: function getBalanceTick(label) {
            return Object(__WEBPACK_IMPORTED_MODULE_6_application_util_number_util__["c" /* prettifyNumber */])(label);
        }
    }, {
        key: 'getUnitFromDataCount',
        value: function getUnitFromDataCount(count) {
            return count > 1000 ? 'year' : count > 70 ? 'month' : 'day';
        }
    }, {
        key: 'getChartOptions',
        value: function getChartOptions() {
            return {
                layout: {
                    padding: {
                        left: 5,
                        right: 15,
                        bottom: 40
                    }
                },
                tooltips: {
                    callbacks: {
                        label: this.getTooltipLabel.bind(this)
                    }
                },
                scales: {
                    yAxes: [{
                        gridLines: {
                            color: '#ebeced',
                            borderDash: [3, 5],
                            zeroLineColor: '#ebeced',
                            zeroLineBorderDash: [3, 5],
                            drawBorder: false,
                            drawTicks: false
                        },
                        ticks: {
                            padding: 30,
                            suggestedMin: 0,
                            suggestedMax: 0,
                            beginAtZero: true,
                            fontFamily: '\'Open Sans\', sans-serif',
                            callback: this.getBalanceTick.bind(this)
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        time: {
                            unit: 'day',
                            tooltipFormat: 'dddd, MMM D, YYYY'
                        },
                        gridLines: {
                            color: '#ebeced',
                            drawBorder: false,
                            drawTicks: false
                        },
                        ticks: {
                            maxTicksLimit: 12,
                            autoSkipPadding: 20,
                            padding: 15,
                            maxRotation: 0,
                            minRotation: 0,
                            fontFamily: '\'Open Sans\', sans-serif'
                        }
                    }]
                }
            };
        }
    }, {
        key: 'load',
        value: function load(calendarIds, start, end) {
            var _this = this;

            start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(start);
            end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(end);

            this.loading = true;

            var today = __WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('day').valueOf();
            var labels = [];
            var past = [];
            var future = [];
            var changes = [];

            var periodStart = start.isValid() ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(start).valueOf() : null;

            return this.dashboardService.getCashFlowData(calendarIds, periodStart, end.valueOf()).then(function (_ref) {
                var dataSet = _ref.dataSet,
                    meta = _ref.meta;

                __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(dataSet, function (day) {
                    labels.push(day.timestamp);
                    changes.push(day.change);

                    if (day.timestamp <= today) {
                        past.push(day.value);
                    } else {
                        future.push(day.value);
                    }
                });

                if (past.length > 0) {
                    var emptyPast = __WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_slice___default()(past, 0, past.length - 1), function () {
                        return null;
                    });
                    future = __WEBPACK_IMPORTED_MODULE_1_lodash_concat___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_concat___default()(emptyPast, [past[past.length - 1]]), future);
                }

                _this.updateMeta(meta.income, meta.expense, dataSet.length);

                _this.error = null;
            }).catch(function (result) {
                _this.updateMeta();

                _this.error = Object(__WEBPACK_IMPORTED_MODULE_7_application_util_error_util__["b" /* getErrorMessage */])(result, 'Unfortunately we couldn\'t load the chart data. Please try again later.');
            }).finally(function () {
                _this.updateScaleByDataCount(labels.length);

                _this.data = {
                    labels: labels,
                    datasets: [_this.getDataSet(past, changes, true), _this.getDataSet(future, changes)]
                };

                _this.loading = false;
            });
        }
    }, {
        key: 'updateScaleByDataCount',
        value: function updateScaleByDataCount(count) {
            var options = __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({}, this.options);

            options.scales.xAxes[0].time = __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({}, options.scales.xAxes[0].time, {
                unit: this.getUnitFromDataCount(count),
                displayFormats: {
                    month: count > 30 * 6 ? 'MMM' : 'MMMM',
                    day: 'D'
                }
            });

            this.options = options;

            return this.options;
        }
    }, {
        key: 'updateMeta',
        value: function updateMeta(income, expense, count) {
            this.income = income || 0;
            this.expense = expense || 0;

            this.change = this.income - this.expense;
            this.average = this.expense > 0 ? count > 0 ? this.expense / count : 0 : 0;
        }
    }, {
        key: 'getCssVar',
        value: function getCssVar(name, fallback) {
            var value = getComputedStyle(document.documentElement).getPropertyValue(name);

            return value && value.trim() ? value.trim() : fallback;
        }
    }, {
        key: 'getDataSet',
        value: function getDataSet(data, changes, isPast) {
            var pastFill = this.getCssVar('--color-chart-area-past', '#cfeafb');
            var futureFill = this.getCssVar('--color-chart-area-future', '#e7f4fd');

            return {
                data: data,
                changes: changes,
                backgroundColor: isPast ? pastFill : futureFill,
                borderDash: isPast ? null : [5, 5],
                borderDashOffset: 5,
                borderColor: isPast ? '#1196ea' : '#88caf4',
                borderWidth: 2,
                lineTension: 0,
                pointHitRadius: 15,
                pointRadius: 0,
                pointBorderWidth: 0,
                pointHoverBackgroundColor: isPast ? '#1196ea' : '#88caf4',
                pointHoverBorderColor: '#fff',
                pointHoverRadius: 5,
                pointHoverBorderWidth: 2
            };
        }
    }]);

    return CashFlowChartController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACashFlowChart',
    template: __WEBPACK_IMPORTED_MODULE_9__cash_flow_chart_tpl_pug___default()(),
    controller: CashFlowChartController,
    bindings: {
        calendarIds: '<',
        start: '<',
        end: '<'
    }
});

/***/ }),

/***/ "opx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_random__ = __webpack_require__("XPuf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_random__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_application_util_category_util__ = __webpack_require__("XzH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__category_manage_modal_style_sass__ = __webpack_require__("gACS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__category_manage_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__category_manage_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__category_manage_modal_tpl_pug__ = __webpack_require__("S+Kx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__category_manage_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__category_manage_modal_tpl_pug__);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










var CategoryManageModalController = function () {
    CategoryManageModalController.$inject = ['categoryService', 'modalService', 'notificationService', 'storageService'];

    /* @ngInject */
    function CategoryManageModalController(categoryService, modalService, notificationService, storageService) {
        _classCallCheck(this, CategoryManageModalController);

        this.categoryService = categoryService;
        this.modalService = modalService;
        this.notificationService = notificationService;
        this.storageService = storageService;
    }

    _createClass(CategoryManageModalController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.sortableOptions = {
                animation: 100,
                onEnd: this.endSort.bind(this)
            };

            this.categories = [];
            var categoryIconStyle = this.storageService.getUserItem('category-icon-style') || 'icons';
            this.useCategoryIcons = categoryIconStyle === 'icons';
            this.categoryService.onUpdate(this.handleCategoryUpdate.bind(this));

            this.reload().finally(function () {
                _this.searchPlaceholder = _this.categories && _this.categories.length > 0 ? 'search for e.g. ' + _this.categories[__WEBPACK_IMPORTED_MODULE_0_lodash_random___default()(0, _this.categories.length - 1)].name : null;
            });
        }
    }, {
        key: 'reload',
        value: function reload(force) {
            var _this2 = this;

            this.loading = true;

            return this.load(typeof force === 'undefined' ? true : force).finally(function () {
                return _this2.loading = false;
            });
        }
    }, {
        key: 'handleCategoryUpdate',
        value: function handleCategoryUpdate(updatedCategory) {
            if (!updatedCategory || !updatedCategory.id) {
                return this.reload(true);
            }

            var replaced = false;
            this.categories = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.categories || [], function (category) {
                if ('' + category.id === '' + updatedCategory.id) {
                    replaced = true;
                    return __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, category, updatedCategory);
                }

                return category;
            });

            if (!replaced) {
                return this.reload(true);
            }

            return this.search();
        }
    }, {
        key: 'load',
        value: function load(force) {
            var _this3 = this;

            return this.categoryService.getAll(this.teamId, force).then(function (categories) {
                _this3.categories = __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(categories, __WEBPACK_IMPORTED_MODULE_5_application_util_category_util__["c" /* isCategoryListable */]);
                _this3.search();
            }).catch(function (result) {
                _this3.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_4_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to load your categories. Please try again later.'));
            });
        }
    }, {
        key: 'create',
        value: function create() {
            return this.openCategory();
        }
    }, {
        key: 'select',
        value: function select(category) {
            return this.openCategory(category);
        }
    }, {
        key: 'openCategory',
        value: function openCategory(category) {
            return this.modalService.open({
                component: 'dbACategoryEditModal',
                bindings: {
                    teamId: this.teamId,
                    category: __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, category),
                    canEdit: !category || !category.other,
                    canDelete: !!category && !category.other,
                    from: 'team'
                }
            }).catch(function () {
                return null;
            }).finally(this.reload.bind(this));
        }
    }, {
        key: 'searchBySubmit',
        value: function searchBySubmit(terms) {
            var valid = this.search(terms);

            if (valid && this.filteredCategories.length > 0) {
                this.openCategory(this.filteredCategories[0]);
            }
        }
    }, {
        key: 'search',
        value: function search(terms) {
            var valid = terms && terms.length > 0;

            this.filteredCategories = valid ? __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.categories, function (category) {
                return Object(__WEBPACK_IMPORTED_MODULE_5_application_util_category_util__["a" /* categoryHasTerms */])(category, terms);
            }) : this.categories;

            this.sortableOptions.disabled = valid;

            return valid;
        }
    }, {
        key: 'endSort',
        value: function endSort() {
            var _this4 = this;

            return this.categoryService.reorder(this.teamId, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.categories, function (category) {
                return category.id;
            })).catch(function (result) {
                _this4.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_4_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to re-order your categories. Please try again later.'));
            }).finally(this.load.bind(this, true));
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            this.onDismiss();
        }
    }]);

    return CategoryManageModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategoryManageModal',
    template: __WEBPACK_IMPORTED_MODULE_7__category_manage_modal_tpl_pug___default()(),
    controller: CategoryManageModalController,
    bindings: {
        teamId: '<',
        onDismiss: '&'
    }
});

/***/ }),

/***/ "owzX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__period_month_item_style_sass__ = __webpack_require__("5BVa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__period_month_item_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__period_month_item_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__period_month_item_tpl_pug__ = __webpack_require__("iT3l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__period_month_item_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__period_month_item_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAPeriodMonthItem',
    template: __WEBPACK_IMPORTED_MODULE_1__period_month_item_tpl_pug___default()(),
    bindings: {
        name: '<',
        change: '<',
        balance: '<',
        selected: '<'
    }
});

/***/ }),

/***/ "p9qD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-select-modal":"calendar-select-modal","modal-fixed-height":"modal-fixed-height","modal-body":"modal-body","calendar-items":"calendar-items","calendar-select-item":"calendar-select-item"};

/***/ }),

/***/ "pDM8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-error-icon-de0162d6ac3a73bf.svg";

/***/ }),

/***/ "pWlP":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cspan ng-bind=\"$ctrl.time\"\u003E\u003C\u002Fspan\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "pdTe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryCar-4b0b7dd9ad22a98e.svg";

/***/ }),

/***/ "ph9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selected_date_range_cmpt__ = __webpack_require__("LPE0");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.dashboard.component.selected-date-range', []).component(__WEBPACK_IMPORTED_MODULE_1__selected_date_range_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__selected_date_range_cmpt__["a" /* default */]));

/***/ }),

/***/ "plvF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__("KBYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar_dashboard_style_sass__ = __webpack_require__("kOIG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar_dashboard_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__calendar_dashboard_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__calendar_dashboard_tpl_pug__ = __webpack_require__("aQK8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__calendar_dashboard_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__calendar_dashboard_tpl_pug__);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var CalendarDashboardController = function () {
    CalendarDashboardController.$inject = ['numberUtil'];

    /* @ngInject */
    function CalendarDashboardController(numberUtil) {
        _classCallCheck(this, CalendarDashboardController);

        this.numberUtil = numberUtil;

        this.selectExpenseType();
    }

    _createClass(CalendarDashboardController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (this.expenseSelected) {
                if (changeObject.expense || changeObject.expenseCategoryGroups) {
                    this.selectExpenseType();
                }
            } else if (changeObject.income || changeObject.incomeCategoryGroups) {
                this.selectIncomeType();
            }
        }
    }, {
        key: 'isValueValid',
        value: function isValueValid(value) {
            return this.numberUtil.isNumeric(value);
        }
    }, {
        key: 'selectIncome',
        value: function selectIncome() {
            __WEBPACK_IMPORTED_MODULE_3_common_analytics__["c" /* default */].trackDashboardSelectIncome();

            this.selectIncomeType();
        }
    }, {
        key: 'selectExpense',
        value: function selectExpense() {
            __WEBPACK_IMPORTED_MODULE_3_common_analytics__["c" /* default */].trackDashboardSelectExpense();

            this.selectExpenseType();
        }
    }, {
        key: 'selectIncomeType',
        value: function selectIncomeType() {
            this.selectType(false, this.income, this.incomeCategoryGroups || [], 'surplus', 'deficit');
        }
    }, {
        key: 'selectExpenseType',
        value: function selectExpenseType() {
            this.selectType(true, this.expense, this.expenseCategoryGroups || [], 'exceeded by', 'saved');
        }
    }, {
        key: 'selectType',
        value: function selectType(expenseSelected, total, groups, exceeded, saved) {
            this.expenseSelected = expenseSelected;
            this.groups = __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(groups, function (group) {
                return __WEBPACK_IMPORTED_MODULE_2_angular___default.a.merge(group, {
                    eventGroups: group.eventGroups.map(function (eventGroup) {
                        return __WEBPACK_IMPORTED_MODULE_2_angular___default.a.merge(eventGroup, {
                            note: eventGroup.note ? eventGroup.note : 'without label'
                        });
                    })
                });
            }), function (group) {
                return -group.totalCurrentValue;
            });
            this.colors = groups.map(function (group) {
                return {
                    label: group.name + ': ' + group.totalCurrentValue,
                    color: group.color,
                    percent: Math.abs(group.totalCurrentValue) / total * 100
                };
            });

            this.exceeded = exceeded;
            this.saved = saved;
        }
    }]);

    return CalendarDashboardController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACalendarDashboard',
    template: __WEBPACK_IMPORTED_MODULE_5__calendar_dashboard_tpl_pug___default()(),
    controller: CalendarDashboardController,
    bindings: {
        loading: '<',
        monthName: '<',
        income: '<',
        incomeCategoryGroups: '<',
        expense: '<',
        expenseCategoryGroups: '<'
    }
});

/***/ }),

/***/ "po3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_cmpt__ = __webpack_require__("dQ6+");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.settings.scene.general', []).component(__WEBPACK_IMPORTED_MODULE_1__general_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__general_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.general', {
        url: '/general',
        component: __WEBPACK_IMPORTED_MODULE_1__general_cmpt__["a" /* default */].selector
    });
}

/***/ }),

/***/ "pv2Y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-expired-72a7f3a2065ed35b.svg";

/***/ }),

/***/ "pxa1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-no-collaborators-7515ae14f2865789.svg";

/***/ }),

/***/ "pz8W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Broom-19eaf77b16bf78f0.svg";

/***/ }),

/***/ "q0gM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_details_modal_cmpt__ = __webpack_require__("TN7M");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.event-details-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__event_details_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__event_details_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "qC7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_select_default_modal_cmpt__ = __webpack_require__("6fjO");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.calendar-select-default-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__calendar_select_default_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__calendar_select_default_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "qe5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compile_component_directive__ = __webpack_require__("SyVF");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.compile-component', []).directive(__WEBPACK_IMPORTED_MODULE_1__compile_component_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__compile_component_directive__["a" /* default */]));

/***/ }),

/***/ "qk6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar__ = __webpack_require__("JpD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__("Q1n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__team__ = __webpack_require__("1BKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__payment__ = __webpack_require__("Hxm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard__ = __webpack_require__("P29P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__("7F/i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__email_ingest_token__ = __webpack_require__("/NDf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__session_service__ = __webpack_require__("NLQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notification_service__ = __webpack_require__("lH5j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_service__ = __webpack_require__("n1Zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__theme_service__ = __webpack_require__("Gvsf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_start_cache_service__ = __webpack_require__("KodT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_analytics__ = __webpack_require__("3pWh");

















/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.service', [__WEBPACK_IMPORTED_MODULE_1__calendar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__team__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__payment__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__dashboard__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__email_ingest_token__["a" /* default */].name]).service('sessionService', __WEBPACK_IMPORTED_MODULE_8__session_service__["a" /* default */]).service('notificationService', __WEBPACK_IMPORTED_MODULE_9__notification_service__["a" /* default */]).service('modalService', __WEBPACK_IMPORTED_MODULE_10__modal_service__["a" /* default */]).service('themeService', __WEBPACK_IMPORTED_MODULE_11__theme_service__["a" /* default */]).service('appStartCacheService', __WEBPACK_IMPORTED_MODULE_12__app_start_cache_service__["a" /* default */]).factory('analyticsService', function () {
    return __WEBPACK_IMPORTED_MODULE_13_common_analytics__["c" /* default */];
}));

/***/ }),

/***/ "qkz2":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"forgot-password-reset-page\"\u003E\u003Cdiv class=\"form-validation\" ng-bind=\"$ctrl.error\" ng-show=\"$ctrl.error\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-box\"\u003E\u003Cdiv class=\"identity-title\"\u003EChange password\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-form\"\u003E\u003Cform role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.resetPassword($ctrl.password)\"\u003E\u003Cdiv class=\"form-note\"\u003EFill in your new password containing at least 4 characters.\u003C\u002Fdiv\u003E\u003Cdiv class=\"control-group\"\u003E\u003Clabel class=\"control-icon\" for=\"password-control\"\u003E\u003Ci class=\"icon-dollarbird-password\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput class=\"control-input\" type=\"password\" id=\"password-control\" name=\"password\" placeholder=\"new password\" ng-model=\"$ctrl.password\" ng-minlength=\"6\" required\u003E\u003Clabel class=\"control-label\" for=\"password-control\"\u003EEmail\u003C\u002Flabel\u003E\u003Clabel class=\"control-validation\" for=\"password-control\"\u003E\u003Cdb-a-validation-message key=\"required,minlength\"\u003EShould be at least 6 characters long.\u003C\u002Fdb-a-validation-message\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cbutton class=\"button button-block button-fill button-primary button-password-reset\" type=\"submit\" db-a-async loading=\"form.$submitting\"\u003E\u003Cinitial\u003EChange password\u003C\u002Finitial\u003E\u003Cloading\u003EChanging...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"identity-comment\"\u003E\u003Cspan\u003EGo back to \u003C\u002Fspan\u003E\u003Ca class=\"link\" href=\"javascript:void(0);\" ui-sref=\"identity.sign-in\"\u003Elog in\u003C\u002Fa\u003E\u003Cspan\u003E.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "qnXT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-list":"calendar-list","sortable-drag":"sortable-drag","sortable-fallback":"sortable-fallback","calendar-items":"calendar-items","calendar-list-title":"calendar-list-title","calendar-list-title-text":"calendar-list-title-text","calendar-list-title-loader":"calendar-list-title-loader","calendar-multiple":"calendar-multiple","button-toggle-multiple":"button-toggle-multiple","button-clear-multiple":"button-clear-multiple","calendar-selected-count":"calendar-selected-count","calendar-list-items":"calendar-list-items","sorting":"sorting","calendar-list-item":"calendar-list-item","calendar-toolbar":"calendar-toolbar","sortable-ghost":"sortable-ghost","button-add-calendar":"button-add-calendar","active":"active","drag-handle":"drag-handle","calendar-state":"calendar-state","calendar-color-icon":"calendar-color-icon","readonly":"readonly","calendar-name":"calendar-name","calendar-name-wrapper":"calendar-name-wrapper","icon":"icon","calendar-balance":"calendar-balance","button-edit-calendar":"button-edit-calendar","button-delete-calendar":"button-delete-calendar","calendar-add-container":"calendar-add-container","link-add-calendar":"link-add-calendar","link-subscribe":"link-subscribe","team-details":"team-details","team-details-icon":"team-details-icon","team-details-content":"team-details-content","team-details-title":"team-details-title","team-details-description":"team-details-description","calendar-page":"calendar-page","pulse-indicator":"pulse-indicator"};

/***/ }),

/***/ "qrdl":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "r1UY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Banknote-4fe04f3aa16deff7.svg";

/***/ }),

/***/ "r5tb":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"category-select-modal modal-fixed-height\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cbutton class=\"button button-modal-back button-icon button-back\" type=\"button\" ng-click=\"$ctrl.dismiss()\"\u003E\u003Ci class=\"icon icon-dollarbird-arrow-left\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"modal-title\"\u003ESelect category\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-icon button-link button-manage-categories\" type=\"button\" ng-click=\"$ctrl.manage()\"\u003E\u003Ci class=\"icon icon-dollarbird-settings\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter\"\u003E\u003Cdb-a-search class=\"category-search modal-section\" data-id=\"category-search\" data-placeholder=\"$ctrl.searchPlaceholder\" can-capture=\"true\" on-focus-change=\"$ctrl.toggleSearch(focused)\" on-term-change=\"$ctrl.search(terms)\" on-submit=\"$ctrl.searchBySubmit(terms)\" ng-show=\"$ctrl.categories.length &gt; 0\"\u003E\u003C\u002Fdb-a-search\u003E\u003Cdiv class=\"categories-container\" ng-hide=\"$ctrl.loading\" db-a-scroll-container\u003E\u003Cdiv class=\"categories\" ng-show=\"$ctrl.categories.length &gt; 0\"\u003E\u003Cdb-a-category class=\"category-select-item modal-section\" ng-repeat=\"category in $ctrl.filteredCategories track by category.id\" ng-style=\"{ backgroundColor: category.selected ? category.color : null }\" name=\"category.name\" color=\"category.color\" fill=\"category.selected\" icon-name=\"category.iconName\" icon-index=\"category.iconIndex\" use-icons=\"$ctrl.useCategoryIcons\" fallback-icon-name=\"null\" ng-click=\"$ctrl.select(category)\" db-a-scroll-into-view=\"category.selected\"\u003E\u003C\u002Fdb-a-category\u003E\u003Cdiv class=\"categories-message modal-section\" ng-if=\"$ctrl.filteredCategories.length &lt; 1\"\u003E\u003Cspan\u003ENone of the \u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.categories.length\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E categories matched your search criteria.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"categories-message modal-section\" ng-show=\"$ctrl.categories.length &lt; 1\"\u003EIt looks like you have no categories created yet. You can add one by clicking the button below.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader visible=\"$ctrl.loading\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-modal-left button-close-modal\" ng-click=\"$ctrl.dismiss()\" ng-if=\"!$ctrl.canAdd\"\u003EClose\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-link button-modal-left button-add-category\" ng-click=\"$ctrl.create()\" ng-if=\"$ctrl.canAdd\"\u003EAdd new category\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "rPNC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forgot_password_request__ = __webpack_require__("b+8S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forgot_password_confirm__ = __webpack_require__("OHlg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forgot_password_reset__ = __webpack_require__("8BbD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forgot_password_token_expired__ = __webpack_require__("3yLT");







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.identity.scene.forgot-password.scene', [__WEBPACK_IMPORTED_MODULE_1__forgot_password_request__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__forgot_password_confirm__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__forgot_password_reset__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__forgot_password_token_expired__["a" /* default */].name]));

/***/ }),

/***/ "rWJA":
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var convert = __webpack_require__("zOqJ");
var string = __webpack_require__("ajDi");

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = convert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

module.exports = Color;


/***/ }),

/***/ "rqO+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__switch_style_sass__ = __webpack_require__("Nnmi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__switch_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__switch_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__switch_tpl_pug__ = __webpack_require__("Dvy5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__switch_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__switch_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var SwitchController = function () {
    function SwitchController() {
        _classCallCheck(this, SwitchController);
    }

    _createClass(SwitchController, [{
        key: 'change',
        value: function change() {
            this.$ctrl.$setViewValue(this.toggled);
            this.$ctrl.$render();
        }
    }]);

    return SwitchController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbASwitch',
    template: __WEBPACK_IMPORTED_MODULE_1__switch_tpl_pug___default()(),
    controller: SwitchController,
    transclude: true,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        toggled: '<ngModel',
        disabled: '<'
    }
});

/***/ }),

/***/ "rw/q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_style_sass__ = __webpack_require__("beF3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_tpl_pug__ = __webpack_require__("zlC8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var DataSettingsController = function () {
    DataSettingsController.$inject = ['$q', '$scope', '$state', 'profileService', 'notificationService', 'modalService', 'sessionService'];

    /* @ngInject */
    function DataSettingsController($q, $scope, $state, profileService, notificationService, modalService, sessionService) {
        _classCallCheck(this, DataSettingsController);

        this.$q = $q;
        this.$scope = $scope;
        this.$state = $state;
        this.profileService = profileService;
        this.notificationService = notificationService;
        this.modalService = modalService;
        this.sessionService = sessionService;
    }

    _createClass(DataSettingsController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.$state.params.action === 'restore') {
                this.restoreData();
            }
        }
    }, {
        key: 'generateBackup',
        value: function generateBackup() {
            var _this = this;

            return this.profileService.generateBackup().then(function (response) {
                _this.backupRequested = true;

                var message = response && response.message || 'Backup requested. You will receive an email shortly containing the backup file.';
                _this.notificationService.showInfo(message, null, true, 5000);
            }).catch(function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to generate your backup. Please try again later.'));
            });
        }
    }, {
        key: 'restoreData',
        value: function restoreData() {
            var _this2 = this;

            this.modalService.open({
                component: 'dbAConfirmModal',
                bindings: {
                    title: 'Restore from backup',
                    message: ['Restoring your data from a backup file will replace all the data in your account with the data from the selected backup file. If you have added transactions, calendars, etc. since the backup file has been generated, those will be overwritten.', 'Make sure you have the correct backup file before proceeding.'],
                    primaryButton: ['Select file', 'Select file'],
                    secondaryButton: 'Cancel',
                    buttonStyle: 'button-primary',
                    onClose: function onClose() {
                        return _this2.selectAndUploadBackupFile();
                    }
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'selectAndUploadBackupFile',
        value: function selectAndUploadBackupFile() {
            var _this3 = this;

            var input = document.createElement('input');
            input.type = 'file';
            input.onchange = function (event) {
                var file = event.target.files[0];
                if (!file) {
                    return _this3.$q.reject();
                }

                return _this3.$scope.$apply(function () {
                    return _this3.modalService.open({
                        component: 'dbAConfirmModal',
                        bindings: {
                            title: 'Confirm restore',
                            message: ['Selected file: ' + _this3.normalizeFileName(file.name), 'This action cannot be undone. Are you sure?'],
                            wide: true,
                            checkboxLabel: 'Just check backup file integrity, don\'t import.',
                            primaryButton: ['Restore from selected file', 'Restoring...'],
                            checkboxPrimaryButton: ['Check selected file', 'Checking...'],
                            secondaryButton: 'Cancel',
                            onClose: function onClose(dryRun) {
                                return _this3.profileService.importBackup(file, !!dryRun).then(function (response) {
                                    if (response.status === 'SUCCESS' || response.status === 'DRY_RUN_SUCCESS') {
                                        var successMessage = dryRun ? 'Backup file integrity check completed successfully. The backup can be imported.' : response.message || 'Your data has been restored successfully.';

                                        _this3.notificationService.showInfo(successMessage, null, true, 5000);
                                        if (!dryRun) {
                                            return _this3.sessionService.reload();
                                        }
                                        return _this3.$q.resolve();
                                    }
                                    if (response.status === 'DISABLED') {
                                        _this3.notificationService.showError(response.message || 'Backup restore is currently disabled.');
                                        return _this3.$q.reject();
                                    }
                                    _this3.notificationService.showError(response.message || 'Failed to restore backup.');
                                    return _this3.$q.reject();
                                }).catch(function (result) {
                                    _this3.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to restore your backup. Please try again later.'));
                                    return _this3.$q.reject(result);
                                });
                            }
                        }
                    }).catch(function () {
                        return null;
                    });
                });
            };

            input.click();
            return this.$q.resolve();
        }
    }, {
        key: 'normalizeFileName',
        value: function normalizeFileName(fileName) {
            var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;

            if (!fileName || fileName.length <= maxLength) {
                return fileName;
            }

            var ellipsis = '...';
            var remainingLength = maxLength - ellipsis.length;
            var startLength = Math.ceil(remainingLength / 2);
            var endLength = Math.floor(remainingLength / 2);

            return '' + fileName.slice(0, startLength) + ellipsis + fileName.slice(-endLength);
        }
    }, {
        key: 'sendExportEmail',
        value: function sendExportEmail() {
            var _this4 = this;

            return this.profileService.export().then(function () {
                _this4.exportEmailSent = true;

                _this4.notificationService.showInfo('The email has been sent to your inbox.', null, true, 3000);
            }).catch(function (result) {
                _this4.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to export your data and send it to your through email. Please try again later.'));
            });
        }
    }, {
        key: 'exportCsv',
        value: function exportCsv() {
            var _this5 = this;

            return this.profileService.exportCsv().then(function () {
                _this5.exportDownloaded = true;
            }).catch(function (result) {
                _this5.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to export your data and send it to your through email. Please try again later.'));
            });
        }
    }]);

    return DataSettingsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbADataSettings',
    template: __WEBPACK_IMPORTED_MODULE_2__data_tpl_pug___default()(),
    controller: DataSettingsController
});

/***/ }),

/***/ "s96k":
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "sFj2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var elements = __webpack_require__("L5rj");
var helpers = __webpack_require__("iO9N");

defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc && arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: Math.PI * -0.5,

	// The total circumference of the chart.
	circumference: Math.PI * 2.0,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

defaults._set('pie', helpers.clone(defaults.doughnut));
defaults._set('pie', {
	cutoutPercentage: 0
});

module.exports = function(Chart) {

	Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
			var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
			var minSize = Math.min(availableWidth, availableHeight);
			var offset = {x: 0, y: 0};
			var meta = me.getMeta();
			var cutoutPercentage = opts.cutoutPercentage;
			var circumference = opts.circumference;

			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}

			chart.borderWidth = me.getMaxBorderWidth(meta.data);
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;
			// Resets the visual styles
			this.removeHoverStyle(arc);

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
				total = NaN;
			}*/

			return total;
		},

		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (value / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var max = 0;
			var index = this.index;
			var length = arcs.length;
			var borderWidth;
			var hoverWidth;

			for (var i = 0; i < length; i++) {
				borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
				hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
			return max;
		}
	});
};


/***/ }),

/***/ "sFo6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("k7DW");
var helpers = __webpack_require__("iO9N");
var Ticks = __webpack_require__("IbXy");

module.exports = function(Chart) {

	var globalDefaults = defaults.global;

	var defaultConfig = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: Ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};

	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}

	function getPointLabelFontOptions(scale) {
		var pointLabelOptions = scale.options.pointLabels;
		var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
		var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
		var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
		var font = helpers.fontString(fontSize, fontStyle, fontFamily);

		return {
			size: fontSize,
			style: fontStyle,
			family: fontFamily,
			font: font
		};
	}

	function measureLabelSize(ctx, fontSize, label) {
		if (helpers.isArray(label)) {
			return {
				w: helpers.longestText(ctx, ctx.font, label),
				h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: fontSize
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size - 5,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size + 5
		};
	}

	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
		/*
		 * Right, this is really confusing and there is a lot of maths going on here
		 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		 *
		 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		 *
		 * Solution:
		 *
		 * We assume the radius of the polygon is half the size of the canvas at first
		 * at each index we check if the text overlaps.
		 *
		 * Where it does, we store that angle and that index.
		 *
		 * After finding the largest index and angle we calculate how much we need to remove
		 * from the shape radius to move the point inwards by that x.
		 *
		 * We average the left and right distances to get the maximum shape radius that can fit in the box
		 * along with labels.
		 *
		 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		 * on each side, removing that from the size, halving it and adding the left x protrusion width.
		 *
		 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		 * and position it in the most space efficient manner
		 *
		 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
		 */

		var plFont = getPointLabelFontOptions(scale);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		var furthestLimits = {
			r: scale.width,
			l: 0,
			t: scale.height,
			b: 0
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;

		scale.ctx.font = plFont.font;
		scale._pointLabelSizes = [];

		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, largestPossibleRadius);
			textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
	}

	/**
	 * Helper function to fit a radial linear scale with no point labels
	 */
	function fit(scale) {
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		scale.drawingArea = Math.round(largestPossibleRadius);
		scale.setCenterPoint(0, 0, 0, 0);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, fontSize) {
		if (helpers.isArray(text)) {
			var y = position.y;
			var spacing = 1.5 * fontSize;

			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += spacing;
			}
		} else {
			ctx.fillText(text, position.x, position.y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var pointLabelOpts = opts.pointLabels;

		ctx.lineWidth = angleLineOpts.lineWidth;
		ctx.strokeStyle = angleLineOpts.color;

		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

		// Point Label Font
		var plFont = getPointLabelFontOptions(scale);

		ctx.textBaseline = 'top';

		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
				ctx.closePath();
			}

			if (pointLabelOpts.display) {
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = valueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;

				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
		ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

		if (scale.options.gridLines.circular) {
			// Draw circular arcs between the points
			ctx.beginPath();
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.stroke();
		} else {
			// Draw straight lines connecting each index
			var valueCount = getValueCount(scale);

			if (valueCount === 0) {
				return;
			}

			ctx.beginPath();
			var pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}

			ctx.closePath();
			ctx.stroke();
		}
	}

	function numberOrZero(param) {
		return helpers.isNumber(param) ? param : 0;
	}

	var LinearRadialScale = Chart.LinearScaleBase.extend({
		setDimensions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.xCenter = Math.round(me.width / 2);
			me.yCenter = Math.round(me.height / 2);

			var minSize = helpers.min([me.height, me.width]);
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
		},
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var tickOpts = this.options.ticks;
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
		},
		convertTicksToLabels: function() {
			var me = this;

			Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		fit: function() {
			if (this.options.pointLabels.display) {
				fitWithPointLabels(this);
			} else {
				fit(this);
			}
		},
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(
				Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = me.height - bottomMovement - me.drawingArea;

			me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
		},

		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;

			var startAngleRadians = startAngle * Math.PI * 2 / 360;

			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},
		getDistanceFromCenterForValue: function(value) {
			var me = this;

			if (value === null) {
				return 0; // null always in center
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
				y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
			};
		},
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},

		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;

			if (opts.display) {
				var ctx = me.ctx;

				// Tick Font
				var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);

				helpers.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || tickOpts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						var yHeight = me.yCenter - yCenterOffset;

						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}

						if (tickOpts.display) {
							var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = tickLabelFont;

							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									me.xCenter - labelWidth / 2 - tickOpts.backdropPaddingX,
									yHeight - tickFontSize / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFontSize + tickOpts.backdropPaddingY * 2
								);
							}

							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, me.xCenter, yHeight);
						}
					}
				});

				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}
			}
		}
	});
	Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);

};


/***/ }),

/***/ "sICz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);

stateConfiguration.$inject = ['$stateProvider', '$transitionsProvider'];



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular___default.a.module('application.scene.authorized.scene.team-share', []).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('authorized.team-share', {
        url: '/team-share/:teamId',
        params: {
            teamId: null
        }
    });

    $transitionsProvider.onStart({
        to: 'authorized.team-share'
    }, function (transition) {
        var _ref = transition.params() || {},
            teamId = _ref.teamId;

        var $state = transition.injector().get('$state');
        var sessionService = transition.injector().get('sessionService');

        return sessionService.initialize().then(function (data) {
            if (__WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(data.teams || [], function (team) {
                return team.id === +teamId;
            })) {
                return $state.target('authorized.calendar', {
                    teamId: teamId
                });
            }

            return $state.target('authorized');
        }).catch(function () {
            return $state.target('authorized');
        });
    });
}

/***/ }),

/***/ "sMAA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sO6y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"event-limit-notification":"event-limit-notification","subscription-description":"subscription-description","button-subscription":"button-subscription"};

/***/ }),

/***/ "sUV3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"search":"search","search-control":"search-control","search-control-input":"search-control-input","button-clear-search":"button-clear-search"};

/***/ }),

/***/ "sV5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribe_style_sass__ = __webpack_require__("siip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribe_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__subscribe_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subscribe_tpl_pug__ = __webpack_require__("+t/z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subscribe_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__subscribe_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var SubscribeController = function () {
    SubscribeController.$inject = ['$state', '$window', 'planService', 'configuration', 'notificationService'];

    /* @ngInject */
    function SubscribeController($state, $window, planService, configuration, notificationService) {
        _classCallCheck(this, SubscribeController);

        this.$state = $state;
        this.$window = $window;
        this.planService = planService;
        this.configuration = configuration;
        this.notificationService = notificationService;
    }

    _createClass(SubscribeController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;

            this.planService.getAllUpgrade().then(function (plans) {
                _this.plans = plans;
            }, function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'It looks like we were unable to retrieve the pricing plans. Please check back later.'), null, true);
            }).finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'select',
        value: function select(plan, subscription) {
            if (subscription) {
                return this.$state.go('authorized.payment', {
                    plan: plan ? plan.id : null,
                    subscription: subscription ? subscription.id : null
                });
            }

            return this.$window.open('mailto:' + this.configuration.salesEmail, '_self');
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            this.$state.go('authorized.calendar');
        }
    }]);

    return SubscribeController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbASubscribe',
    template: __WEBPACK_IMPORTED_MODULE_2__subscribe_tpl_pug___default()(),
    controller: SubscribeController
});

/***/ }),

/***/ "siip":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"subscribe-page":"subscribe-page","subscribe-header":"subscribe-header","button-close-page":"button-close-page","page-title":"page-title","subscribe-content":"subscribe-content","subscribe-title":"subscribe-title","subscribe-description":"subscribe-description"};

/***/ }),

/***/ "sndW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__check_event_count__ = __webpack_require__("At72");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.directive', [__WEBPACK_IMPORTED_MODULE_1__check_event_count__["a" /* default */].name]));

/***/ }),

/***/ "ssmE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkmark_cmpt__ = __webpack_require__("zhrX");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.checkmark', []).component(__WEBPACK_IMPORTED_MODULE_1__checkmark_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__checkmark_cmpt__["a" /* default */]));

/***/ }),

/***/ "t145":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("/iHN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_dashboard_cmpt__ = __webpack_require__("plvF");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-dashboard', [__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_2__calendar_dashboard_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__calendar_dashboard_cmpt__["a" /* default */]));

/***/ }),

/***/ "tJW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_palette__ = __webpack_require__("313L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_palette__ = __webpack_require__("RrLh");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.category-edit-modal.component', [__WEBPACK_IMPORTED_MODULE_1__color_palette__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__icon_palette__["a" /* default */].name]));

/***/ }),

/***/ "tOBf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_into_view_directive__ = __webpack_require__("+skt");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.directive.scroll-into-view', []).directive(__WEBPACK_IMPORTED_MODULE_1__scroll_into_view_directive__["b" /* selector */], __WEBPACK_IMPORTED_MODULE_1__scroll_into_view_directive__["a" /* default */]));

/***/ }),

/***/ "ty5p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_join__ = __webpack_require__("ZZNS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_join__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardService = function () {
    DashboardService.$inject = ['$q', 'apiService'];

    /* @ngInject */
    function DashboardService($q, apiService) {
        _classCallCheck(this, DashboardService);

        this.$q = $q;
        this.apiService = apiService;
    }

    _createClass(DashboardService, [{
        key: 'getCashFlowData',
        value: function getCashFlowData(calendarIds, from, to) {
            return this.apiService.get('/dashboard/cashflow', {
                params: {
                    from: from,
                    to: to,
                    calendars: __WEBPACK_IMPORTED_MODULE_0_lodash_join___default()(calendarIds, ',')
                }
            }).then(function (result) {
                return result.data || [];
            });
        }
    }, {
        key: 'getIncomeExpenseData',
        value: function getIncomeExpenseData(calendarIds, from, to) {
            return this.apiService.get('/dashboard/income-expense', {
                params: {
                    from: from,
                    to: to,
                    calendars: __WEBPACK_IMPORTED_MODULE_0_lodash_join___default()(calendarIds, ',')
                }
            }).then(function (result) {
                return result.data || [];
            });
        }
    }, {
        key: 'getCategoryData',
        value: function getCategoryData(calendarIds, from, to, expense, confirmed) {
            var params = {
                from: from,
                to: to,
                calendars: __WEBPACK_IMPORTED_MODULE_0_lodash_join___default()(calendarIds, ','),
                expense: expense
            };

            if (typeof confirmed !== 'undefined') {
                params.confirmed = confirmed;
            }

            return this.apiService.get('/dashboard/categories', {
                params: params
            }).then(function (result) {
                return result.data || [];
            });
        }
    }, {
        key: 'getExpenseCategoryData',
        value: function getExpenseCategoryData(calendarIds, from, to, confirmed) {
            return this.getCategoryData(calendarIds, from, to, true, confirmed);
        }
    }]);

    return DashboardService;
}();

/* harmony default export */ __webpack_exports__["a"] = (DashboardService);

/***/ }),

/***/ "u1o0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__("3n1n");

/**
 * @namespace Chart.helpers.options
 */
module.exports = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		default:
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {Number|Object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {Object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	}
};


/***/ }),

/***/ "u2yG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscription_cmpt__ = __webpack_require__("KilB");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.settings.scene.subscription', []).component(__WEBPACK_IMPORTED_MODULE_1__subscription_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__subscription_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.subscription', {
        url: '/subscription',
        component: __WEBPACK_IMPORTED_MODULE_1__subscription_cmpt__["a" /* default */].selector
    });
}

/***/ }),

/***/ "u60v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"income-expense-chart":"income-expense-chart","chart-container":"chart-container","chart-content":"chart-content","visible":"visible","chart-error":"chart-error"};

/***/ }),

/***/ "uJqd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Property-1-Receipt-2d9347944dbf0d3e.svg";

/***/ }),

/***/ "uQVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResetPasswordService = function () {
    ResetPasswordService.$inject = ["apiService"];

    /* @ngInject */
    function ResetPasswordService(apiService) {
        _classCallCheck(this, ResetPasswordService);

        this.apiService = apiService;
    }

    _createClass(ResetPasswordService, [{
        key: "send",
        value: function send(email) {
            return this.apiService.post("/password/send-reset-email", {
                email: email
            }, {
                anonymous: true
            });
        }
    }, {
        key: "validate",
        value: function validate(token) {
            return this.apiService.post("/password/validate-reset-token", {
                token: token
            }, {
                anonymous: true
            });
        }
    }, {
        key: "reset",
        value: function reset(token, password) {
            return this.apiService.post("/password/reset", {
                token: token,
                password: password
            }, {
                anonymous: true
            });
        }
    }]);

    return ResetPasswordService;
}();

/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordService);

/***/ }),

/***/ "uaBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_application_component_category_icon_category_icon_map_json__ = __webpack_require__("nyB0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_application_component_category_icon_category_icon_map_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_application_component_category_icon_category_icon_map_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__category_edit_modal_style_sass__ = __webpack_require__("udzI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__category_edit_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__category_edit_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__category_edit_modal_tpl_pug__ = __webpack_require__("lY5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__category_edit_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__category_edit_modal_tpl_pug__);




var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var CategoryEditModalController = function () {
    CategoryEditModalController.$inject = ['$q', 'categoryService', 'modalService', 'notificationService'];

    /* @ngInject */
    function CategoryEditModalController($q, categoryService, modalService, notificationService) {
        _classCallCheck(this, CategoryEditModalController);

        this.$q = $q;
        this.categoryService = categoryService;
        this.modalService = modalService;
        this.notificationService = notificationService;
    }

    _createClass(CategoryEditModalController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.existing = !!this.category && !!this.category.id;
            this.loading = true;
            this.activeTab = 'label';

            return this.$q.all([this.categoryService.getAll(this.teamId), this.categoryService.getPalette()]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    categories = _ref2[0],
                    colors = _ref2[1];

                _this.colors = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(colors, function (color) {
                    return {
                        used: __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(categories, function (category) {
                            return category.color === color;
                        }),
                        hex: color
                    };
                });

                _this.icons = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_5_application_component_category_icon_category_icon_map_json___default.a || [], function (icon) {
                    return {
                        iconIndex: icon.iconIndex,
                        iconName: _this.normalizeIconName(icon.svgFilename)
                    };
                });

                _this.syncCategoryIcon();
            }).catch(function (result) {
                _this.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_3_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to load the color palette. Please try again later.'));
            }).finally(function () {
                return _this.loading = false;
            });
        }
    }, {
        key: 'normalizeIconName',
        value: function normalizeIconName(iconName) {
            if (!iconName) {
                return null;
            }

            return ('' + iconName).replace(/\.svg$/i, '');
        }
    }, {
        key: 'syncCategoryIcon',
        value: function syncCategoryIcon() {
            var _this2 = this;

            if (!this.category) {
                return;
            }

            var normalizedIconName = this.normalizeIconName(this.category.iconName);

            if (!this.category.iconIndex && normalizedIconName) {
                var matchedByName = __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(this.icons, function (icon) {
                    return icon.iconName === normalizedIconName;
                });
                this.category.iconIndex = matchedByName ? matchedByName.iconIndex : null;
            }

            if (!this.category.iconName && this.category.iconIndex) {
                var matchedByIndex = __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(this.icons, function (icon) {
                    return icon.iconIndex === _this2.category.iconIndex;
                });
                this.category.iconName = matchedByIndex ? matchedByIndex.iconName : null;
                return;
            }

            this.category.iconName = normalizedIconName;
        }
    }, {
        key: 'selectTab',
        value: function selectTab(tab) {
            this.activeTab = tab;
        }
    }, {
        key: 'selectIcon',
        value: function selectIcon(icon) {
            if (!this.category || !icon) {
                return;
            }

            this.category.iconIndex = icon.iconIndex;
            this.category.iconName = icon.iconName;
        }
    }, {
        key: 'updateColor',
        value: function updateColor(color) {
            this.color = color;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this3 = this;

            var promise = this.existing ? this.categoryService.update(this.teamId, this.category) : this.categoryService.create(this.teamId, this.category);

            return promise.then(function (category) {
                if (_this3.existing) {
                    __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackCategoryUpdate(_this3.category);
                } else {
                    __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackCategoryCreate(_this3.category, _this3.from);
                }

                return _this3.onClose({
                    data: category
                });
            }).catch(function (result) {
                _this3.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_3_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to save the category. Please try again later.'));
            });
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this4 = this;

            return this.modalService.open({
                component: 'dbAConfirmModal',
                bindings: {
                    title: 'Delete category',
                    message: ['Deleting a category cannot be undone. All the transactions which belong to this category will be uncategorized.', 'Are you still sure about it?'],
                    onClose: function onClose() {
                        return _this4.categoryService.remove(_this4.teamId, _this4.category).then(function () {
                            __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackCategoryDelete(_this4.category);
                            return _this4.onClose();
                        }).catch(function (result) {
                            _this4.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_3_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to delete the ' + _this4.category.name + ' category. Please try again later.'));
                            return _this4.$q.reject(result);
                        });
                    }
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'merge',
        value: function merge() {
            var _this5 = this;

            return this.modalService.open({
                component: 'dbACategoryMergeModal',
                bindings: {
                    teamId: this.teamId,
                    category: this.category,
                    onClose: function onClose(fallbackCategory) {
                        if (!fallbackCategory || !fallbackCategory.id) {
                            return _this5.$q.reject();
                        }

                        return _this5.categoryService.remove(_this5.teamId, _this5.category, fallbackCategory.id).then(function () {
                            __WEBPACK_IMPORTED_MODULE_4_common_analytics__["c" /* default */].trackCategoryDelete(_this5.category);
                            return _this5.onClose();
                        }).catch(function (result) {
                            _this5.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_3_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to merge the ' + _this5.category.name + ' category. Please try again later.'));
                            return _this5.$q.reject(result);
                        });
                    }
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'dismiss',
        value: function dismiss() {
            this.onDismiss();
        }
    }]);

    return CategoryEditModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategoryEditModal',
    template: __WEBPACK_IMPORTED_MODULE_7__category_edit_modal_tpl_pug___default()(),
    controller: CategoryEditModalController,
    bindings: {
        teamId: '<',
        category: '<',
        from: '<',
        canEdit: '<',
        canDelete: '<',
        onDismiss: '&',
        onClose: '&'
    }
});

/***/ }),

/***/ "udzI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-edit-modal":"category-edit-modal","modal-body":"modal-body","category-tabs":"category-tabs","button-tab":"button-tab","active":"active","category-tab-content":"category-tab-content","category-tab-item":"category-tab-item","category-info":"category-info","category-preview":"category-preview","button-merge":"button-merge","icon-merge":"icon-merge"};

/***/ }),

/***/ "uqIT":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"event-repeat-delete-modal modal-fixed-height\"\u003E\u003Cform class=\"form\" role=\"form\" name=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.confirm()\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cdiv class=\"modal-title\"\u003EChange transaction\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-delimiter modal-section\"\u003E\u003Cdiv class=\"prompt-question\"\u003EWould you like to change this particular transaction or all the following transactions too?\u003C\u002Fdiv\u003E\u003Cdiv class=\"prompt-answers\"\u003E\u003Clabel class=\"prompt-answer\" ng-click=\"$ctrl.selectOnlyThis()\"\u003E\u003Cdb-a-radio class=\"prompt-answer-state\" selected=\"$ctrl.isOnlyThisSelected\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"prompt-answer-title\"\u003EOnly this transaction\u003C\u002Fdiv\u003E\u003Cdiv class=\"prompt-answer-description\"\u003EThis particular transaction will be changed. The other transactions in the series won't be affected.\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003Clabel class=\"prompt-answer\" ng-click=\"$ctrl.selectThisAndAllFollowing()\"\u003E\u003Cdb-a-radio class=\"prompt-answer-state\" selected=\"!$ctrl.isOnlyThisSelected\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"promot-answer-title\"\u003EThis and all following transactions\u003C\u002Fdiv\u003E\u003Cdiv class=\"prompt-answer-description\"\u003EThis and all the following transactions in the series will be changed.\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-outline button-secondary button-modal-left button-modal-done button-cancel\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-class=\"{ disabled: form.$submitting }\"\u003ECancel\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-primary button-modal-right button-modal-done button-confirm\" type=\"submit\" db-a-async loading=\"form.$submitting\"\u003E\u003Cinitial\u003EChange\u003C\u002Finitial\u003E\u003Cloading\u003EChanging...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "ur4S":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"search\" role=\"form\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.submit($ctrl.term)\"\u003E\u003Cdiv class=\"control search-control\"\u003E\u003Cinput class=\"control-input search-control-input\" type=\"text\" ng-attr-id=\"{{ $ctrl.id }}\" ng-attr-placeholder=\"{{ $ctrl.placeholder }}\" ng-model=\"$ctrl.term\" ng-change=\"$ctrl.search($ctrl.term)\" ng-focus=\"$ctrl.open()\" ng-blur=\"$ctrl.close($ctrl.term)\" db-a-capture-keys=\"$ctrl.canCapture\" db-a-process-key=\"$ctrl.handleClear(code)\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-icon button-clear-search\" type=\"button\" ng-if=\"$ctrl.term.length &gt; 0\" ng-click=\"$ctrl.clear()\" db-prevent-default=\"mousedown\"\u003E\u003Ci class=\"icon icon-dollarbird-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "v70l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_date_modal_cmpt__ = __webpack_require__("0CCe");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.event-date-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__event_date_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__event_date_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "v9a+":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["IdleJs"] = factory();
	else
		root["IdleJs"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var bulkAddEventListener = function bulkAddEventListener(object, events, callback) {
	  events.forEach(function (event) {
	    object.addEventListener(event, function (event) {
	      callback(event);
	    });
	  });
	};
	
	var bulkRemoveEventListener = function bulkRemoveEventListener(object, events) {
	  events.forEach(function (event) {
	    object.removeEventListener(event);
	  });
	};
	
	var IdleJs = function () {
	  function IdleJs(options) {
	    _classCallCheck(this, IdleJs);
	
	    this.defaults = {
	      idle: 10000, // idle time in ms
	      events: ['mousemove', 'keydown', 'mousedown', 'touchstart'], // events that will trigger the idle resetter
	      onIdle: function onIdle() {}, // callback function to be executed after idle time
	      onActive: function onActive() {}, // callback function to be executed after back form idleness
	      onHide: function onHide() {}, // callback function to be executed when window become hidden
	      onShow: function onShow() {}, // callback function to be executed when window become visible
	      keepTracking: true, // set it to false of you want to track only once
	      startAtIdle: false, // set it to true if you want to start in the idle state
	      recurIdleCall: false
	    };
	    this.settings = _extends({}, this.defaults, options);
	    this.idle = this.settings.startAtIdle;
	    this.visible = !this.settings.startAtIdle;
	    this.visibilityEvents = ['visibilitychange', 'webkitvisibilitychange', 'mozvisibilitychange', 'msvisibilitychange'];
	    this.lastId = null;
	  }
	
	  _createClass(IdleJs, [{
	    key: 'resetTimeout',
	    value: function resetTimeout(id, settings) {
	      if (this.idle) {
	        settings.onActive.call();
	        this.idle = false;
	      }
	      clearTimeout(id);
	      if (this.settings.keepTracking) {
	        return this.timeout(this.settings);
	      }
	    }
	  }, {
	    key: 'timeout',
	    value: function timeout(settings) {
	      var timer = this.settings.recurIdleCall ? setInterval : setTimeout;
	      var id;
	      id = timer(function () {
	        this.idle = true;
	        this.settings.onIdle.call();
	      }.bind(this), this.settings.idle);
	      return id;
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      window.addEventListener('idle:stop', function (event) {
	        bulkRemoveEventListener(window, this.settings.events);
	        this.settings.keepTracking = false;
	        this.resetTimeout(this.lastId, this.settings);
	      });
	      this.lastId = this.timeout(this.settings);
	      bulkAddEventListener(window, this.settings.events, function (event) {
	        this.lastId = this.resetTimeout(this.lastId, this.settings);
	      }.bind(this));
	      if (this.settings.onShow || this.settings.onHide) {
	        bulkAddEventListener(document, this.visibilityEvents, function (event) {
	          if (document.hidden || document.webkitHidden || document.mozHidden || document.msHidden) {
	            if (this.visible) {
	              this.visible = false;
	              this.settings.onHide.call();
	            }
	          } else {
	            if (!this.visible) {
	              this.visible = true;
	              this.settings.onShow.call();
	            }
	          }
	        }.bind(this));
	      }
	    }
	  }]);
	
	  return IdleJs;
	}();
	
	module.exports = IdleJs;

/***/ }
/******/ ])
});
;
//# sourceMappingURL=idle.js.map

/***/ }),

/***/ "vGwf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"event-details-modal":"event-details-modal","modal-body":"modal-body","event-details":"event-details"};

/***/ }),

/***/ "vImi":
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__("Y/tY");

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),

/***/ "vOuy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_limit_notification_style_sass__ = __webpack_require__("sO6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_limit_notification_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__event_limit_notification_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_limit_notification_tpl_pug__ = __webpack_require__("E61u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_limit_notification_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__event_limit_notification_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var EventLimitNotificationController = function () {
    function EventLimitNotificationController() {
        _classCallCheck(this, EventLimitNotificationController);
    }

    _createClass(EventLimitNotificationController, [{
        key: 'renew',
        value: function renew() {
            __WEBPACK_IMPORTED_MODULE_0_common_analytics__["c" /* default */].trackRenewNotificationRenew();

            return this.onClose();
        }
    }]);

    return EventLimitNotificationController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEventLimitNotification',
    template: __WEBPACK_IMPORTED_MODULE_2__event_limit_notification_tpl_pug___default()(),
    controller: EventLimitNotificationController,
    bindings: {
        plan: '<',
        onClose: '&'
    }
});

/***/ }),

/***/ "vQ4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = routerConfiguration;
/* unused harmony export defaultRouteHandler */
/* harmony export (immutable) */ __webpack_exports__["a"] = bootstrapApplication;
bootstrapApplication.$inject = ['$urlRouter', 'sessionService', 'preferenceService', 'themeService'];
defaultRouteHandler.$inject = ['$injector'];
routerConfiguration.$inject = ['$locationProvider', '$urlRouterProvider'];
/* @ngInject */
function routerConfiguration($locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise(defaultRouteHandler).deferIntercept();
}

/* @ngInject */
function defaultRouteHandler($injector) {
    var $state = $injector.get('$state');
    return $state.go('identity.sign-in');
}

/* @ngInject */
function bootstrapApplication($urlRouter, sessionService, preferenceService, themeService) {
    return sessionService.initialize().finally(function () {
        var storedTheme = themeService.getStoredTheme();

        if (!sessionService.user) {
            themeService.applyTheme(storedTheme || 'system');
            $urlRouter.sync();
            $urlRouter.listen();
            return;
        }

        preferenceService.get().then(function (preferences) {
            var theme = preferences && preferences.theme ? preferences.theme : storedTheme || 'system';
            themeService.applyTheme(theme);

            if ((!preferences || !preferences.theme) && !storedTheme) {
                var nextPreferences = preferences || {};
                nextPreferences.theme = 'system';
                preferenceService.save(nextPreferences).catch(function () {
                    return null;
                });
            }
        }).catch(function () {
            themeService.applyTheme(themeService.getStoredTheme() || 'system');
        });

        $urlRouter.sync();
        $urlRouter.listen();
    }).catch(function () {
        return null;
    });
}

/***/ }),

/***/ "vksQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_style_sass__ = __webpack_require__("Q+vZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__settings_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings_tpl_pug__ = __webpack_require__("5pZ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__settings_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var SettingsController = function () {
    SettingsController.$inject = ['$state', 'sessionService', 'navigationService', 'notificationService'];

    /* @ngInject */
    function SettingsController($state, sessionService, navigationService, notificationService) {
        _classCallCheck(this, SettingsController);

        this.$state = $state;
        this.sessionService = sessionService;
        this.navigationService = navigationService;
        this.notificationService = notificationService;
    }

    _createClass(SettingsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.closeNavigation();
            this.plan = this.plan || {};
            this.loadPlan();
        }
    }, {
        key: 'loadPlan',
        value: function loadPlan() {
            var _this = this;

            return this.sessionService.initialize().then(function (data) {
                _this.plan = data.plan || _this.plan;
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'openNavigation',
        value: function openNavigation() {
            this.isNavigationVisible = true;
        }
    }, {
        key: 'closeNavigation',
        value: function closeNavigation() {
            this.isNavigationVisible = false;
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            var _this2 = this;

            if (this.signingOut) {
                return null;
            }

            this.signingOut = true;

            return this.sessionService.signOut().then(function () {
                _this2.$state.go('identity.sign-in');

                __WEBPACK_IMPORTED_MODULE_0_common_analytics__["c" /* default */].trackSessionEnd('User', true);
            }).catch(function (result) {
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_1_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to log you out. Please try again later.'));
                return null;
            }).finally(function () {
                _this2.signingOut = false;
            });
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            this.$state.go('authorized.calendar');
        }
    }]);

    return SettingsController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbASettings',
    template: __WEBPACK_IMPORTED_MODULE_3__settings_tpl_pug___default()(),
    controller: SettingsController,
    bindings: {
        plan: '<'
    }
});

/***/ }),

/***/ "vu3g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRANSACTION_TYPE_INCOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRANSACTION_TYPE_EXPENSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSACTION_KIND_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRANSACTION_KIND_TRANSFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRANSACTION_KIND_BALANCE_UPDATE; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getTransactionNote;
/* unused harmony export getTransactionValue */
/* harmony export (immutable) */ __webpack_exports__["g"] = transactionHasTerms;
/* unused harmony export transactionPriceHasTerm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_util__ = __webpack_require__("XzH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_util_js__ = __webpack_require__("Vihm");






var TRANSACTION_TYPE_INCOME = 'income';
var TRANSACTION_TYPE_EXPENSE = 'expense';

var TRANSACTION_KIND_EVENT = 'event';
var TRANSACTION_KIND_TRANSFER = 'transfer';
var TRANSACTION_KIND_BALANCE_UPDATE = 'balance-update';

function getTransactionNote(note, type, category) {
    if (note) {
        return note;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1__category_util__["e" /* isCategoryTransfer */])(category)) {
        return category && category.name ? category.name : 'Transfer';
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1__category_util__["b" /* isCategoryBalanceUpdate */])(category)) {
        return category && category.name ? category.name : 'Balance update';
    }

    return category && category.name ? category.name : type === TRANSACTION_TYPE_INCOME ? 'income' : 'expense';
}

function getTransactionValue(type, value) {
    return type === TRANSACTION_TYPE_INCOME ? value : -value;
}

function transactionHasTerms(transaction, terms) {
    var note = getTransactionNote(transaction.note, transaction.type, transaction.category);
    var value = getTransactionValue(transaction.type, transaction.value);

    terms = __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(terms, function (term) {
        return !Object(__WEBPACK_IMPORTED_MODULE_2__search_util_js__["b" /* valueContainsTerm */])(note, term) && !transactionPriceHasTerm(value, term) && !Object(__WEBPACK_IMPORTED_MODULE_2__search_util_js__["b" /* valueContainsTerm */])(transaction.details, term);
    });

    return terms.length === 0 || Object(__WEBPACK_IMPORTED_MODULE_1__category_util__["a" /* categoryHasTerms */])(transaction.category, terms);
}

function transactionPriceHasTerm(price, term) {
    return price > 0 ? Object(__WEBPACK_IMPORTED_MODULE_2__search_util_js__["b" /* valueContainsTerm */])('+' + price, term) : Object(__WEBPACK_IMPORTED_MODULE_2__search_util_js__["b" /* valueContainsTerm */])('' + price, term);
}

/***/ }),

/***/ "vvdA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ "vx4v":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-no-data-07c7e899bc84604a.svg";

/***/ }),

/***/ "vymh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification":"notification","notification-image":"notification-image","notification-title":"notification-title","notification-content":"notification-content","has-image":"has-image"};

/***/ }),

/***/ "w47J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Key-b2b7db6a2280ae19.svg";

/***/ }),

/***/ "w7kL":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-navigation\" ng-switch=\"$ctrl.isSelectingCalendar\"\u003E\u003Cdiv class=\"calendar-list-content\"\u003E\u003Cdiv class=\"calendar-list-section\"\u003E\u003Cdiv class=\"calendar-list-section-content calendar-list-heading\"\u003E\u003Cdiv class=\"calendar-list-heading-actions\"\u003E\u003Ca class=\"button button-subscribe\" href=\"javascript:void(0);\" ui-sref=\"authorized.subscribe\" ng-if=\"$ctrl.plan.expired || $ctrl.plan.free\" ng-click=\"$ctrl.subscribe($ctrl.plan.expired)\"\u003E\u003Ci class=\"icon icon-dollarbird-premium\"\u003E\u003C\u002Fi\u003E\u003Cspan ng-show=\"$ctrl.plan.expired\"\u003ERenew subscription\u003C\u002Fspan\u003E\u003Cspan ng-show=\"$ctrl.plan.free\"\u003EGo premium\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"plan-name\" ng-bind=\"$ctrl.plan.name\" ng-hide=\"$ctrl.plan.expired || $ctrl.plan.free\" ng-style=\"$ctrl.planBadgeStyle || { backgroundColor: '#394852', color: '#fff' }\"\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"button button-icon button-open-settings\" href=\"javascript:void(0);\" ui-sref=\"authorized.calendar.settings\" ng-click=\"$ctrl.onSettingsOpen()\"\u003E\u003Ci class=\"icon icon-dollarbird-settings\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-user-profile\"\u003E\u003Cdb-a-user-image class=\"current-user-image\" name=\"$ctrl.user.name\" email=\"$ctrl.user.email\" url=\"$ctrl.user.profileImage.url\" color=\"$ctrl.user.profileImage.color\"\u003E\u003C\u002Fdb-a-user-image\u003E\u003Cdiv class=\"user-info\"\u003E\u003Cdiv class=\"user-name\" ng-bind=\"$ctrl.user.name\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"user-email\" ng-bind=\"$ctrl.user.email\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-list-section\"\u003E\u003Cdiv class=\"calendar-list-section-content\"\u003E\u003Cdiv class=\"calendar-navigation-heading\" ng-click=\"$ctrl.toggleView()\"\u003E\u003Cdiv class=\"team-selection\" ng-switch-when=\"true\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-down\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"team-selection-main\"\u003E\u003Cdiv class=\"team-name\" ng-bind=\"$ctrl.selectedTeam.name\"\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"team-balance\" value=\"$ctrl.balance\" limit=\"100000\" pretty=\"true\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team-shared\" ng-if=\"$ctrl.sharedWithLabel\"\u003E\u003Ci class=\"icon-dollarbird-users\"\u003E\u003C\u002Fi\u003E\u003Cspan ng-bind=\"$ctrl.sharedWithLabel\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-switch-default ng-show=\"$ctrl.selectedTeam\"\u003E\u003Ci class=\"icon icon-dollarbird-chevron-up\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EChange calendar group\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-switch-default ng-hide=\"$ctrl.selectedTeam\"\u003ECreate calendar group\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-list-section calendar-list-section-fill\"\u003E\u003Cdiv class=\"calendar-list-section-content calendar-navigation\"\u003E\u003Cdb-a-calendar-list class=\"calendar-navigation-content\" ng-switch-when=\"true\" loading=\"$ctrl.loading\" selected-calendar-ids=\"$ctrl.selectedCalendarIds\" calendars=\"$ctrl.selectedTeam.calendars\" owner=\"$ctrl.selectedTeam.owner.isMe\" plan=\"$ctrl.plan\" multiple=\"$ctrl.multiple\" can-select-multiple=\"$ctrl.canSelectMultiple\" balance-warning-threshold=\"$ctrl.balanceWarningThreshold\" can-add=\"$ctrl.selectedTeam.permissions.addCalendar\" on-calendar-select=\"$ctrl.selectCalendar($ctrl.selectedTeam, calendar)\" on-calendar-edit=\"$ctrl.editCalendar($ctrl.selectedTeam, calendar, name)\" on-calendar-delete=\"$ctrl.deleteCalendar($ctrl.selectedTeam, calendar)\" on-calendar-add=\"$ctrl.addCalendar($ctrl.selectedTeam)\" on-calendar-reorder=\"$ctrl.reorderCalendars($ctrl.selectedTeam, order)\" on-team-edit=\"$ctrl.editTeam($ctrl.selectedTeam)\" on-team-add=\"$ctrl.addTeam()\" on-multiple-change=\"$ctrl.toggleMultiple(multiple)\"\u003E\u003C\u002Fdb-a-calendar-list\u003E\u003Cdb-a-team-list class=\"calendar-navigation-content\" ng-switch-default selected=\"$ctrl.selectedTeam\" teams=\"$ctrl.teams\" on-select=\"$ctrl.selectTeam(team)\" on-add=\"$ctrl.addTeam()\" on-reorder=\"$ctrl.reorderTeams(order)\"\u003E\u003C\u002Fdb-a-team-list\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "wC4o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Bed-5c1e84f7ff39b0d6.svg";

/***/ }),

/***/ "wER3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar__ = __webpack_require__("l4hu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings__ = __webpack_require__("KH+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subscribe__ = __webpack_require__("EWC9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__payment__ = __webpack_require__("kwBb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__team_share__ = __webpack_require__("sICz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dashboard__ = __webpack_require__("VIWf");









/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene', [__WEBPACK_IMPORTED_MODULE_1__calendar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__settings__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__subscribe__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__payment__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__team_share__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__dashboard__["a" /* default */].name]));

/***/ }),

/***/ "wGD1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var color = __webpack_require__("rWJA");
var helpers = __webpack_require__("iO9N");

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = color(origin);
				if (c0.valid) {
					c1 = color(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers.extend(Element.prototype, {

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers.clone(me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = model;
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
	}
});

Element.extend = helpers.inherits;

module.exports = Element;


/***/ }),

/***/ "wNkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EmailVerificationService = function () {
    EmailVerificationService.$inject = ["apiService"];

    /* @ngInject */
    function EmailVerificationService(apiService) {
        _classCallCheck(this, EmailVerificationService);

        this.apiService = apiService;
    }

    _createClass(EmailVerificationService, [{
        key: "send",
        value: function send(email) {
            return this.apiService.post("/resend-verification-token", {
                email: email
            });
        }
    }, {
        key: "verify",
        value: function verify(token) {
            return this.apiService.post("/verify-user", {
                token: token
            });
        }
    }]);

    return EmailVerificationService;
}();

/* harmony default export */ __webpack_exports__["a"] = (EmailVerificationService);

/***/ }),

/***/ "wPWQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};


/***/ }),

/***/ "wZ8A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_image_style_sass__ = __webpack_require__("WnJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_image_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__user_image_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_image_tpl_pug__ = __webpack_require__("U7WT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_image_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__user_image_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var UserImageController = function () {
    function UserImageController() {
        _classCallCheck(this, UserImageController);
    }

    _createClass(UserImageController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.url) {
                this.url = changeObject.url.currentValue;
            }
            if (changeObject.color) {
                this.color = changeObject.color.currentValue;
            }
            if (changeObject.name || changeObject.email) {
                if (changeObject.name) {
                    this.name = changeObject.name.currentValue;
                }
                if (changeObject.email) {
                    this.email = changeObject.email.currentValue;
                }

                this.initials = this.getInitialsFromName(this.name) || this.getInitialsFromEmail(this.email) || null;
            }
        }
    }, {
        key: 'update',
        value: function update(url) {
            this.missing = !!url;
        }
    }, {
        key: 'getInitialsFromName',
        value: function getInitialsFromName(name) {
            if (name && name.length > 0) {
                return name.split(' ').filter(function (name) {
                    return name.length > 0 && /^[a-zA-Z]/g.test(name);
                }).map(function (name) {
                    return name[0].toUpperCase();
                }).join('').substr(0, 2);
            }

            return null;
        }
    }, {
        key: 'getInitialsFromEmail',
        value: function getInitialsFromEmail(email) {
            if (email && email.length > 0) {
                var name = email.replace(/@.+$/, '').replace(/[^a-zA-Z0-9]/, ' ');
                if (email !== name) {
                    return this.getInitialsFromName(name);
                }
            }

            return null;
        }
    }]);

    return UserImageController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAUserImage',
    template: __WEBPACK_IMPORTED_MODULE_1__user_image_tpl_pug___default()(),
    controller: UserImageController,
    bindings: {
        url: '<',
        color: '<',
        name: '<',
        email: '<'
    }
});

/***/ }),

/***/ "waoX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_28-ba74c956489e927c.svg";

/***/ }),

/***/ "whya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sign_up_style_sass__ = __webpack_require__("EC5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sign_up_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sign_up_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sign_up_tpl_pug__ = __webpack_require__("S46d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sign_up_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sign_up_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var SignUpController = function () {
    SignUpController.$inject = ['$state', '$stateParams', 'sessionService', 'navigationService'];

    /* @ngInject */
    function SignUpController($state, $stateParams, sessionService, navigationService) {
        _classCallCheck(this, SignUpController);

        this.$state = $state;
        this.sessionService = sessionService;
        this.navigationService = navigationService;

        this.redirect = $stateParams.redirect || null;
    }

    _createClass(SignUpController, [{
        key: 'signUp',
        value: function signUp(name, email, password) {
            var _this = this;

            return this.sessionService.signUp(name, email, password).then(function () {
                __WEBPACK_IMPORTED_MODULE_0_common_analytics__["c" /* default */].trackSignUp();

                var _ref = _this.navigationService.getStateFromRedirectUrl(_this.redirect) || {},
                    state = _ref.state,
                    params = _ref.params;

                _this.$state.go(state || 'authorized.calendar', params || {});
            }, function (result) {
                _this.error = Object(__WEBPACK_IMPORTED_MODULE_1_application_util_error_util__["b" /* getErrorMessage */])(result, 'Sorry but we were not able to sign you up. Please try again later.');
            });
        }
    }]);

    return SignUpController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbASignUp',
    template: __WEBPACK_IMPORTED_MODULE_3__sign_up_tpl_pug___default()(),
    controller: SignUpController
});

/***/ }),

/***/ "x/nr":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"event-list-modal modal-fixed-height\" ng-class=\"{ empty: $ctrl.groups.length &lt; 1 }\"\u003E\u003Cdiv class=\"modal-header modal-delimiter modal-section\"\u003E\u003Cdiv class=\"day-date\" ng-bind=\"$ctrl.date\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"day-data heading-day-data\"\u003E\u003Cdiv class=\"day-data-title\"\u003EOverall balance\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"day-data-value\" value=\"$ctrl.balance\" pretty=\"true\" limit=\"99999999999\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body modal-body-scrollable modal-delimiter\"\u003E\u003Cdiv class=\"group\" ng-repeat=\"group in $ctrl.groups track by $index\"\u003E\u003Cdiv class=\"group-heading modal-section\"\u003E\u003Cdiv class=\"group-name\" ng-bind=\"group.name\"\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"group-value\" value=\"group.value\" pretty=\"true\" limit=\"99999999999\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"group-content modal-section\"\u003E\u003Cdiv class=\"event-items\"\u003E\u003Cdiv class=\"event-item\" ng-repeat=\"event in group.events track by $index\" ng-class=\"{ confirmed: event.confirmed, 'use-category-icons': $ctrl.useCategoryIcons }\" ng-click=\"$ctrl.openEvent(event)\" ng-switch=\"$ctrl.isBalanceUpdate(event)\"\u003E\u003Cdiv class=\"event-action-content\" ng-switch-when=\"true\"\u003E\u003Cdiv class=\"event-balance-update-placeholder\"\u003E\u003Cdiv class=\"event-balance-update-icon\" ng-style=\"{ backgroundColor: event.category.color }\"\u003E\u003Ci class=\"icon icon-dollarbird-balance-update\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-action-content\" ng-switch-default\u003E\u003Cdiv class=\"event-confirmation-state\" db-a-async on-click=\"$ctrl.toggleConfirmation(event)\" db-stop-propagation=\"click\"\u003E\u003Cinitial\u003E\u003Cdb-a-checkmark class=\"event-confirmation-checkmark\" ng-model=\"event.confirmed\" color=\"event.category.color\"\u003E\u003C\u002Fdb-a-checkmark\u003E\u003C\u002Finitial\u003E\u003Cloading\u003E\u003Cdb-loader visible=\"true\"\u003E\u003Cdb-spinner-indicator color=\"event.category.color\"\u003E\u003C\u002Fdb-spinner-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Floading\u003E\u003C\u002Fdiv\u003E\u003Cdb-a-category-icon class=\"event-category-icon-left\" ng-if=\"$ctrl.useCategoryIcons &amp;&amp; event.category\" icon-name=\"event.category.iconName\" icon-index=\"event.category.iconIndex\" color=\"event.category.color\" size=\"14\"\u003E\u003C\u002Fdb-a-category-icon\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-note-container\"\u003E\u003Cdiv class=\"event-note\"\u003E\u003Cspan class=\"event-note-text\" ng-bind=\"event.actualNote\"\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"event-icons\" ng-if=\"event.repeat || event.receiptUrl\"\u003E\u003Cdiv class=\"event-repeating\"\u003E\u003Ci class=\"icon-dollarbird-repeat\" ng-if=\"event.repeat\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-receipt\" ng-if=\"event.receiptUrl\" ng-style=\"{ '-webkit-mask-image': $ctrl.receiptIconUrl, 'mask-image': $ctrl.receiptIconUrl }\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-value\"\u003E\u003Cdb-a-pretty-number value=\"event.actualValue\" pretty=\"true\" limit=\"99999999999\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state\"\u003E\u003Cdiv class=\"empty-state-content\"\u003E\u003Cimg" + (" class=\"empty-state-image\""+pug.attr("src", __webpack_require__("HGZV"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003Cdiv class=\"empty-state-title\"\u003ENo transaction added, yet.\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state-message\"\u003EThe transactions added on this day will appear here.\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-fill button-primary button-add-event\" ng-click=\"$ctrl.addEvent()\" ng-if=\"$ctrl.canAddEvent\"\u003ECreate a new transaction\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer modal-section\"\u003E\u003Cbutton class=\"button button-link button-modal-left button-add-event\" ng-click=\"$ctrl.addEvent()\" ng-if=\"$ctrl.canAddEvent\"\u003EAdd new transaction\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-link button-modal-left button-close-modal\" ng-click=\"$ctrl.dismiss()\" ng-if=\"!$ctrl.canAddEvent\"\u003EClose\u003C\u002Fbutton\u003E\u003Cdiv class=\"day-data footer-day-data\"\u003E\u003Cdiv class=\"day-data-title\"\u003EDaily change\u003C\u002Fdiv\u003E\u003Cdb-a-pretty-number class=\"day-data-value\" value=\"$ctrl.change\" pretty=\"true\" limit=\"99999999999\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "x28t":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cui-view class=\"block-component\"\u003E\u003C\u002Fui-view\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "x3r6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryEatingOut-06677b86789e77b9.svg";

/***/ }),

/***/ "xARd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"event-repeat-delete-modal":"event-repeat-delete-modal","prompt-question":"prompt-question","prompt-answer":"prompt-answer","prompt-answer-state":"prompt-answer-state","prompt-answer-description":"prompt-answer-description"};

/***/ }),

/***/ "xBRd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calendar-select-default-modal":"calendar-select-default-modal","select-default-description":"select-default-description","team-items":"team-items","team-name":"team-name","calendar-items":"calendar-items","calendar-select-item":"calendar-select-item"};

/***/ }),

/***/ "xESi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_select_modal_cmpt__ = __webpack_require__("lVVc");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.calendar-select-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__calendar_select_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__calendar_select_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "xFT5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__category_style_sass__ = __webpack_require__("2CaH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__category_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__category_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_tpl_pug__ = __webpack_require__("N141");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__category_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CategoryController = function () {
    /* @ngInject */
    function CategoryController() {
        _classCallCheck(this, CategoryController);
    }

    _createClass(CategoryController, [{
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.name) {
                var name = changeObject.name.currentValue;
                this.name = name || 'Unknown';
                this.unknown = !name;
            }

            if (changeObject.color || changeObject.fill) {
                this.borderColor = this.fill ? null : this.color;
                this.backgroundColor = this.fill ? this.color : null;
                this.iconColor = this.fill ? '#fff' : this.color;
            }

            if (changeObject.useIcons || changeObject.iconName || changeObject.iconIndex || changeObject.fallbackIconName) {
                this.iconNameResolved = this.iconName || this.fallbackIconName || null;
                this.showIcon = !!(this.useIcons && (this.iconNameResolved || this.iconIndex));
            }
        }
    }]);

    return CategoryController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACategory',
    template: __WEBPACK_IMPORTED_MODULE_1__category_tpl_pug___default()(),
    controller: CategoryController,
    bindings: {
        name: '<',
        color: '<',
        fill: '<',
        disabled: '<',
        iconName: '<',
        iconIndex: '<',
        useIcons: '<',
        fallbackIconName: '<'
    }
});

/***/ }),

/***/ "xKDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_modal_cmpt__ = __webpack_require__("CBsE");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.component.modals.component.date-modal', []).component(__WEBPACK_IMPORTED_MODULE_1__date_modal_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__date_modal_cmpt__["a" /* default */]));

/***/ }),

/***/ "xQkc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MESSAGE_SESSION_END; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getRepeatEndFieldError;
/* harmony export (immutable) */ __webpack_exports__["b"] = getErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["d"] = trackError;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateErrorMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_monitoring_sentry__ = __webpack_require__("e49Y");



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var MESSAGE_SESSION_END = 'Your session has expired or it has been invalidated. Please sign in again!';

function getRepeatEndFieldError(result) {
    var errors = result && result.data && result.data.errors;

    if (!errors) {
        return null;
    }

    var field = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(Object.keys(errors), function (key) {
        var normalizedKey = key.toLowerCase();
        var isEndingField = normalizedKey.indexOf('end') !== -1 || normalizedKey.indexOf('occurrence') !== -1;
        return isEndingField && (normalizedKey.indexOf('repeat') !== -1 || normalizedKey.indexOf('date') !== -1 || normalizedKey.indexOf('occurrence') !== -1);
    });

    if (!field) {
        return null;
    }

    var message = errors[field];
    if (message === null || typeof message === 'undefined') {
        return null;
    }

    return Array.isArray(message) ? message.join(', ') : String(message);
}

function getErrorMessage(result, fallbackMessage) {
    // catched exception
    if (result instanceof Error) {
        return result.message || fallbackMessage;
    }

    if (typeof result === 'string') {
        return result || fallbackMessage;
    }

    result = result || {};

    switch (result.status) {
        case 0:
            return 'We are having maintenance at the moment or you might have network connectivity issues. Anyway, grab a cup of coffee and try again a bit later.';
        case 500:
            return 'We are sorry but something failed in the deep. Grab a cup of coffee and try again later.';
        case 502:
        case 503:
            return 'No worries, we are having a break at the moment for maintenance. Grab a cup of coffee and try again later.';
    }

    var data = result.data || {};

    switch (data.error) {
        case 'BAD_REQUEST':
            {
                var errors = data.errors || {};
                var keys = Object.keys(errors);

                if (keys.length > 0) {
                    var message = keys.map(function (field) {
                        var name = field.replace(/([A-Z])/g, function (letter) {
                            return ' ' + letter.toLowerCase();
                        });
                        return name + ' ' + errors[field];
                    }).join(', ');

                    return 'Validation errros occured. The ' + message + '.';
                }

                return data.message;
            }
        case 'ACCOUNT_EXPIRED':
            return 'Your account expired because you forgot to verify your email address.';
        case 'INVALID_GRANT':
            return MESSAGE_SESSION_END;
        case 'USERNAME_IN_USE':
            return 'It looks like this email address is already in use.';
        case 'UPDATE_REQUIRED':
            return 'There is an updated version available. Please reload the page in your browser.';
    }

    return fallbackMessage;
}

function trackError(result) {
    var _ref = result || {},
        status = _ref.status,
        data = _ref.data,
        config = _ref.config;

    var _ref2 = data || {},
        error = _ref2.error;

    var _ref3 = config || {},
        method = _ref3.method,
        url = _ref3.url;

    var shouldRedactBackendMessage = status === 0 || status >= 500;

    var message = shouldRedactBackendMessage ? 'Server error' : data && data.message ? data.message : '';

    switch (status) {
        case 401:
            {
                return __WEBPACK_IMPORTED_MODULE_2_common_analytics__["c" /* default */].trackSessionEnd('Session');
            }
    }

    switch (error) {
        case 'ACCOUNT_EXPIRED':
            {
                return __WEBPACK_IMPORTED_MODULE_2_common_analytics__["c" /* default */].trackSessionEnd('Unverified account');
            }

        case 'BAD_REQUEST':
            {
                var errors = data.errors || {};
                var errorFields = Object.keys(errors);

                if (errorFields.length > 0) {
                    var fieldErrorMessage = __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(errorFields, function (key) {
                        return key + ': ' + errors[key];
                    }).join(', ');
                    message += ' [' + fieldErrorMessage + ']';
                }

                break;
            }
    }

    Object(__WEBPACK_IMPORTED_MODULE_3_common_monitoring_sentry__["a" /* captureApiError */])(result);

    return __WEBPACK_IMPORTED_MODULE_2_common_analytics__["c" /* default */].trackApiError(status, error, message, method, url);
}

function updateErrorMessage(result, message) {
    // catched exception
    if (result instanceof Error) {
        return new Error(message);
    }

    // raised application error
    if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
        result.message = message;
        return result;
    }

    // something else
    return message;
}

/***/ }),

/***/ "xb/H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Bed-1-4482756185974a50.svg";

/***/ }),

/***/ "xhhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_period__ = __webpack_require__("bB1I");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.calendar.component.calendar-header.component', [__WEBPACK_IMPORTED_MODULE_1__calendar_period__["a" /* default */].name]));

/***/ }),

/***/ "xnPS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authorized_style_sass__ = __webpack_require__("X5OD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authorized_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__authorized_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authorized_tpl_pug__ = __webpack_require__("x28t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authorized_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__authorized_tpl_pug__);



/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAAuthorized',
    template: __WEBPACK_IMPORTED_MODULE_1__authorized_tpl_pug___default()()
});

/***/ }),

/***/ "xnjY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_verification_request_tpl_pug__ = __webpack_require__("bB9A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_verification_request_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__email_verification_request_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var EmailVerificationRequestController = function () {
    EmailVerificationRequestController.$inject = ['$state', 'emailVerificationService'];

    /* @ngInject */
    function EmailVerificationRequestController($state, emailVerificationService) {
        _classCallCheck(this, EmailVerificationRequestController);

        this.$state = $state;
        this.emailVerificationService = emailVerificationService;
    }

    _createClass(EmailVerificationRequestController, [{
        key: 'send',
        value: function send(email) {
            var _this = this;

            return this.emailVerificationService.send(email).then(function () {
                _this.$state.go('identity.email-verification.confirm');
            }, function (result) {
                _this.error = Object(__WEBPACK_IMPORTED_MODULE_0_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to verify your email address.');
            });
        }
    }]);

    return EmailVerificationRequestController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbAEmailVerificationRequest',
    template: __WEBPACK_IMPORTED_MODULE_1__email_verification_request_tpl_pug___default()(),
    controller: EmailVerificationRequestController,
    bindings: {
        email: '<',
        error: '<'
    }
});

/***/ }),

/***/ "y7YE":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-list\"\u003E\u003Cdiv class=\"calendar-items\"\u003E\u003Cdiv class=\"calendar-list-title\"\u003E\u003Cspan class=\"calendar-list-title-text\"\u003ECalendars\u003C\u002Fspan\u003E\u003Cdiv class=\"calendar-list-title-loader\" ng-if=\"$ctrl.loading\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-multiple\" ng-if=\"$ctrl.canSelectMultiple\"\u003E\u003Cbutton class=\"button button-icon button-toggle-multiple\" type=\"button\" ng-click=\"$ctrl.toggleMultiple(!$ctrl.multiple)\" ng-if=\"!$ctrl.multiple\"\u003E\u003Ci class=\"icon icon-dollarbird-multiple\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv class=\"calendar-multiple-selection\" ng-if=\"$ctrl.multiple\"\u003E\u003Cspan class=\"calendar-selected-count\"\u003E\u003Cspan ng-bind=\"$ctrl.selectedCount\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E selected\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cbutton class=\"button button-icon button-clear-multiple\" type=\"button\" ng-click=\"$ctrl.toggleMultiple(!$ctrl.multiple)\"\u003E\u003Ci class=\"icon icon-dollarbird-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-list-items\" ng-sortable=\"$ctrl.sortableOptions\" ng-class=\"{ sorting: $ctrl.sorting }\"\u003E\u003Cdiv class=\"calendar-list-item\" ng-repeat=\"calendar in $ctrl.calendars track by calendar.id\" ng-class=\"{ active: $ctrl.isActive(calendar), readonly: !calendar.permissions.edit }\" ng-click=\"$ctrl.select(calendar)\"\u003E\u003Ci class=\"drag-handle icon-dollarbird-grip\" ng-if=\"$ctrl.calendars.length &gt; 1\"\u003E\u003C\u002Fi\u003E\u003Cdb-a-radio class=\"calendar-state\" ng-if=\"!$ctrl.multiple\" selected=\"$ctrl.isActive(calendar)\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdb-a-checkbox class=\"calendar-state\" ng-if=\"$ctrl.multiple\" selected=\"$ctrl.isActive(calendar)\"\u003E\u003C\u002Fdb-a-checkbox\u003E\u003Ci class=\"icon icon-dollarbird-calendar calendar-color-icon\" ng-style=\"{ color: calendar.color || '#b0b6ba' }\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"calendar-name\"\u003E\u003Cdiv class=\"calendar-name-wrapper\"\u003E\u003Cspan ng-bind=\"calendar.name\"\u003E\u003C\u002Fspan\u003E\u003Ci class=\"icon icon-dollarbird-readonly\" title=\"The calendar is read-only.\nSubscribe to continue editing this calendar.\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-toolbar\"\u003E\u003Cdb-a-pretty-number class=\"calendar-balance\" value=\"calendar.balance\" limit=\"100000\" pretty=\"true\" ng-style=\"{ color: $ctrl.getBalanceOverrideColor(calendar.balance) }\"\u003E\u003C\u002Fdb-a-pretty-number\u003E\u003Cbutton class=\"button button-icon button-link button-edit-calendar\" ng-click=\"$ctrl.edit(calendar)\" db-stop-propagation=\"click\" ng-disabled=\"!calendar.permissions.edit\"\u003E\u003Ci class=\"icon icon-dollarbird-edit\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-icon button-link button-danger button-delete-calendar\" ng-click=\"$ctrl.delete(calendar)\" db-stop-propagation=\"click\" ng-disabled=\"!calendar.permissions.delete\"\u003E\u003Ci class=\"icon icon-dollarbird-delete\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-add-container\"\u003E\u003Cbutton class=\"link link-add-calendar\" ng-click=\"$ctrl.add()\" ng-if=\"$ctrl.canAdd\"\u003EAdd calendar\u003C\u002Fbutton\u003E\u003Ca class=\"link link-subscribe\" href=\"javascript:void(0);\" ui-sref=\"authorized.subscribe\" ng-if=\"!$ctrl.canAdd &amp;&amp; $ctrl.owner\"\u003E\u003Cspan ng-if=\"!$ctrl.plan.paid\"\u003EGo Premium\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.plan.paid\"\u003EUpgrade your account\u003C\u002Fspan\u003E\u003Cspan\u003E to add more calendars\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"team-details\" ng-click=\"$ctrl.editTeam()\"\u003E\u003Cdiv class=\"team-details-icon\"\u003E\u003Ci class=\"icon-dollarbird-users\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team-details-content\"\u003E\u003Cdiv class=\"team-details-title\"\u003ECalendar group details and sharing\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "yHpE":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"block-component\" id=\"calendar-page\"\u003E\u003Cui-view class=\"calendar-modal-host\"\u003E\u003C\u002Fui-view\u003E\u003Cdb-a-calendar-side-bar visible=\"$ctrl.navigationBarVisible\" on-close=\"$ctrl.toggleNavigationBar(false)\"\u003E\u003Cdb-a-calendar-navigation loading=\"$ctrl.loadingTeams\" plan=\"$ctrl.plan\" user=\"$ctrl.user\" selected-calendar-ids=\"$ctrl.selectedCalendarIds\" selected-team=\"$ctrl.selectedTeam\" teams=\"$ctrl.teams\" multiple=\"$ctrl.multiple\" can-select-multiple=\"$ctrl.selectedTeam.calendars.length &gt; 1\" balance-warning-threshold=\"$ctrl.balanceWarningThreshold\" on-calendar-edit=\"$ctrl.editCalendar(team, calendar)\" on-calendar-add=\"$ctrl.addCalendar(team)\" on-calendar-delete=\"$ctrl.deleteCalendar(team, calendar)\" on-calendar-select=\"$ctrl.selectCalendar(team, calendar)\" on-calendar-reorder=\"$ctrl.reorderCalendars(team, order)\" on-team-select=\"$ctrl.selectTeam(team)\" on-team-edit=\"$ctrl.editTeam(team)\" on-team-add=\"$ctrl.addTeam()\" on-team-reorder=\"$ctrl.reorderTeams(order)\" on-multiple-change=\"$ctrl.toggleMultiple(multiple)\" on-settings-open=\"$ctrl.toggleNavigationBar(false)\"\u003E\u003C\u002Fdb-a-calendar-navigation\u003E\u003C\u002Fdb-a-calendar-side-bar\u003E\u003Cdb-a-calendar-header loading=\"$ctrl.loadingMonthlyBalances\" team=\"$ctrl.selectedTeam\" calendar-ids=\"$ctrl.selectedCalendarIds\" timestamp=\"$ctrl.timestamp\" months=\"$ctrl.months\" can-capture-search=\"$ctrl.canCaptureShortcuts\" balance-warning-threshold=\"$ctrl.balanceWarningThreshold\" on-team-management-click=\"$ctrl.openCalendarList()\" on-previous-month-click=\"$ctrl.selectPreviousMonth()\" on-next-month-click=\"$ctrl.selectNextMonth()\" on-today-click=\"$ctrl.selectToday()\" on-month-click=\"$ctrl.selectSpecificMonth(timestamp)\" on-search-terms-changed=\"$ctrl.searchTransactionsByTerms(terms)\"\u003E\u003C\u002Fdb-a-calendar-header\u003E\u003Cdiv class=\"calendar-content\"\u003E\u003Cdiv class=\"calendar-weekday-list\" ng-if=\"$ctrl.selectedCalendarIds.length &gt; 0\"\u003E\u003Cdiv class=\"calendar-piece-container calendar-weekday-item-container\" ng-repeat=\"weekday in $ctrl.weekdays track by $index\"\u003E\u003Cdiv class=\"calendar-piece\" ng-class=\"{ weekend: weekday.weekend }\" ng-bind=\"weekday.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-day-list\" ng-if=\"$ctrl.selectedCalendarIds.length &gt; 0\" db-a-scroll-container\u003E\u003Cdiv class=\"calendar-piece-container calendar-day-item-container\" ng-repeat=\"day in $ctrl.days track by $index\" ng-class=\"{ empty: $ctrl.searchTerms.length &gt; 0 &amp;&amp; day.filteredTransactions.length === 0 }\"\u003E\u003Cdb-a-calendar-day class=\"calendar-piece\" date=\"day.date\" change=\"day.change\" balance=\"day.balance\" events=\"day.filteredTransactions || day.events\" today=\"day.today\" another=\"day.another\" loading-balances=\"$ctrl.loadingDailyBalances\" balance-warning-threshold=\"$ctrl.balanceWarningThreshold\" limit=\"$ctrl.limit\" use-category-icons=\"$ctrl.useCategoryIcons\" can-manage-events=\"$ctrl.canManageEvents\" on-list-click=\"$ctrl.listEvents(day)\" on-add-click=\"$ctrl.addEvent(day)\" on-event-click=\"$ctrl.editEvent(event)\" on-event-drop=\"$ctrl.moveEvent(day, event)\" db-a-check-event-count=\"$index === 0\" on-limit-change=\"$ctrl.updateEventLimit\" db-a-scroll-into-view=\"day.today\"\u003E\u003C\u002Fdb-a-calendar-day\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state\" ng-hide=\"$ctrl.selectedCalendarIds.length &gt; 0 || $ctrl.loading\"\u003E\u003Cdiv class=\"empty-state-content\" ng-if=\"$ctrl.selectedTeam\"\u003E\u003Cimg" + (" class=\"empty-state-image\""+pug.attr("src", __webpack_require__("CNHz"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003Cdiv ng-if=\"$ctrl.selectedTeam.owner.id === $ctrl.user.id\"\u003E\u003Cdiv ng-if=\"$ctrl.selectedTeam.permissions.addCalendar\"\u003E\u003Cdiv class=\"empty-state-title\"\u003EHow about adding a calendar?\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state-message\"\u003EOnce you’ve added a new calendar, it will appear here.\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-fill button-primary button-add-calendar\" ng-click=\"$ctrl.addCalendar($ctrl.selectedTeam)\"\u003EAdd calendar\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!$ctrl.selectedTeam.permissions.addCalendar\"\u003E\u003Cdiv class=\"empty-state-title\"\u003E\u003Cspan ng-if=\"!$ctrl.plan.paid\"\u003EGo Premium\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.plan.paid\"\u003EUpgrade your account\u003C\u002Fspan\u003E\u003Cspan\u003E to add more calendars.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state-message\"\u003EHave more control over your finances with multiple calendars\u003C\u002Fdiv\u003E\u003Ca class=\"button button-fill button-primary button-contact-us\" href=\"javascript:void(0);\" ui-sref=\"authorized.subscribe\"\u003E\u003Cspan ng-if=\"!$ctrl.plan.paid\"\u003EGo Premium\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.plan.paid\"\u003EUpgrade account\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"$ctrl.selectedTeam.owner.id !== $ctrl.user.id\"\u003E\u003Cdiv class=\"empty-state-title\"\u003ENo more calendars can be added to this team.\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state-message\"\u003E\u003Cspan\u003EContact \u003C\u002Fspan\u003E\u003Cspan ng-bind=\"$ctrl.selectedTeam.owner.name\"\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E to add more calendars.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state-content\" ng-if=\"!$ctrl.selectedTeam\"\u003E\u003Cimg" + (" class=\"empty-state-image\""+pug.attr("src", __webpack_require__("3Mt+"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003Cdiv class=\"empty-state-title\"\u003EGet started with a team\u003C\u002Fdiv\u003E\u003Cdiv class=\"empty-state-message\"\u003ETeams contain your calendars, collaborators and category settings.\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-fill button-primary button-add-team\" ng-click=\"$ctrl.addTeam()\"\u003ECreate team\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"transactions-by-email-shortcut\" ng-if=\"$ctrl.shouldShowTransactionsByEmailShortcut\"\u003E\u003Cbutton class=\"button button-icon button-dismiss-transactions-by-email\" type=\"button\" ng-click=\"$ctrl.dismissTransactionsByEmailNotification()\"\u003E\u003Ci class=\"icon icon-dollarbird-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-fill button-primary button-open-transactions-by-email\" type=\"button\" ng-click=\"$ctrl.openTransactionsByEmailFromShortcut()\"\u003E\u003Cdiv class=\"transactions-by-email-shortcut-title\"\u003EAdding transactions by email is now available\u003C\u002Fdiv\u003E\u003Cdiv class=\"transactions-by-email-shortcut-subtitle\"\u003ETap here to set it up\u003C\u002Fdiv\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdb-loader class=\"calendar-loader\" visible=\"$ctrl.loadingDailyBalances || $ctrl.loading\" fit=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "ySb5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__("MVjj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cash_flow_chart__ = __webpack_require__("mZnQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__income_expense_chart__ = __webpack_require__("PdLe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category_chart__ = __webpack_require__("RS2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__card__ = __webpack_require__("Y4Fx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card_with_period__ = __webpack_require__("XeE5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card_with_year_picker__ = __webpack_require__("T1eG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selected_date_range__ = __webpack_require__("ph9T");











/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.scene.authorized.scene.dashboard.component', [__WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__cash_flow_chart__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__income_expense_chart__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__category_chart__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__card__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__card_with_period__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__card_with_year_picker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__selected_date_range__["a" /* default */].name]));

/***/ }),

/***/ "yVny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_application_util_error_util__ = __webpack_require__("xQkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_util_plan_util__ = __webpack_require__("vOfg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__collaborator_manage_modal_style_sass__ = __webpack_require__("iWFD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__collaborator_manage_modal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__collaborator_manage_modal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__collaborator_manage_modal_tpl_pug__ = __webpack_require__("O9jO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__collaborator_manage_modal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__collaborator_manage_modal_tpl_pug__);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










var CollaboratorManageModalController = function () {
    CollaboratorManageModalController.$inject = ['$q', 'modalService', 'sessionService', 'collaboratorService', 'notificationService'];

    /* @ngInject */
    function CollaboratorManageModalController($q, modalService, sessionService, collaboratorService, notificationService) {
        _classCallCheck(this, CollaboratorManageModalController);

        this.$q = $q;
        this.modalService = modalService;
        this.sessionService = sessionService;
        this.collaboratorService = collaboratorService;
        this.notificationService = notificationService;
    }

    _createClass(CollaboratorManageModalController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;

            this.load().finally(function () {
                _this.initialCollaborators = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(_this.collaborators, function (collaborator) {
                    return __WEBPACK_IMPORTED_MODULE_3_angular___default.a.merge({}, collaborator);
                });
                _this.loading = false;
            });
        }
    }, {
        key: 'load',
        value: function load() {
            var _this2 = this;

            return this.$q.all([this.loadUser(), this.loadCollaborators()]).catch(function (result) {
                _this2.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_4_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to load your data. Please try again later.'));
            });
        }
    }, {
        key: 'loadUser',
        value: function loadUser() {
            var _this3 = this;

            return this.sessionService.initialize().then(function (data) {
                _this3.maxCollaboratorCount = Object(__WEBPACK_IMPORTED_MODULE_5_common_util_plan_util__["a" /* getMaxNumberOfCollaborators */])(data ? data.plan : null);
                _this3.user = data.user;
            }).catch(function (result) {
                _this3.maxCollaboratorCount = 0;
                _this3.user = {};

                return _this3.$q.reject(result || 'We were not able to load your user data. Please try again later.');
            });
        }
    }, {
        key: 'loadCollaborators',
        value: function loadCollaborators() {
            var _this4 = this;

            return this.collaboratorService.getAll().then(function (collaborators) {
                _this4.collaborators = collaborators;
            }).catch(function (result) {
                _this4.collaborators = [];

                return _this4.$q.reject(result || 'We were not able to retrieve the collaborators. Please try again later.');
            });
        }
    }, {
        key: 'openInviteMembersModal',
        value: function openInviteMembersModal() {
            var _this5 = this;

            this.loading = true;

            return this.modalService.open({
                component: 'dbACollaboratorInviteModal',
                bindings: {
                    emails: __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.collaborators, function (collaborator) {
                        return collaborator.email;
                    }),
                    user: this.user.email
                }
            }).then(function (email) {
                return _this5.add({
                    email: email
                });
            }).catch(function () {
                return null;
            }).finally(function () {
                return _this5.loading = false;
            });
        }
    }, {
        key: 'add',
        value: function add(collaborator) {
            var _this6 = this;

            return this.collaboratorService.create(collaborator).then(function () {
                return _this6.load();
            }).catch(function (result) {
                _this6.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_4_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to add ' + collaborator.name + ' to the collaborators. Please try again later.'));
                return _this6.$q.reject(result);
            });
        }
    }, {
        key: 'promptToDelete',
        value: function promptToDelete(collaborator) {
            var _this7 = this;

            this.loading = true;

            return this.modalService.open({
                component: 'dbAConfirmModal',
                bindings: {
                    title: 'Delete collaborator',
                    message: ['This collaborator will be removed from all the teams he has been assigned to. Altough you can re-invite him back anytime.', 'Are you still sure about it?'],
                    onClose: this.delete.bind(this, collaborator)
                }
            }).catch(function () {
                return null;
            }).finally(function () {
                return _this7.loading = false;
            });
        }
    }, {
        key: 'delete',
        value: function _delete(collaborator) {
            var _this8 = this;

            return this.collaboratorService.delete(collaborator).then(function () {
                return _this8.load();
            }).catch(function (result) {
                _this8.notificationService.showError(Object(__WEBPACK_IMPORTED_MODULE_4_application_util_error_util__["b" /* getErrorMessage */])(result, 'We were not able to remove ' + collaborator.name + ' from the collaborators. Please try again later.'));
                return _this8.$q.reject(result);
            });
        }
    }, {
        key: 'getAddedCollaborators',
        value: function getAddedCollaborators() {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(this.collaborators, function (collaborator) {
                return !__WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(_this9.initialCollaborators, function (initial) {
                    return collaborator.email === initial.email;
                });
            });
        }
    }, {
        key: 'close',
        value: function close() {
            return this.onClose({
                data: __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.getAddedCollaborators(), function (collaborator) {
                    return collaborator.email;
                })
            });
        }
    }, {
        key: 'isEmpty',
        get: function get() {
            return this.collaborators && this.initialCollaborators && this.collaborators.length < 1 && this.initialCollaborators.length < 1;
        }
    }, {
        key: 'canInvite',
        get: function get() {
            return this.collaborators && this.maxCollaboratorCount > 0 && this.collaborators.length < this.maxCollaboratorCount;
        }
    }, {
        key: 'isAtMaxCollaborators',
        get: function get() {
            return !this.loading && this.maxCollaboratorCount > 0 && this.collaborators && this.collaborators.length >= this.maxCollaboratorCount;
        }
    }]);

    return CollaboratorManageModalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACollaboratorManageModal',
    template: __WEBPACK_IMPORTED_MODULE_7__collaborator_manage_modal_tpl_pug___default()(),
    controller: CollaboratorManageModalController,
    bindings: {
        onDismiss: '&',
        onClose: '&'
    }
});

/***/ }),

/***/ "yXCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = BlacklistDirective;
BlacklistDirective.$inject = ['$parse'];
var selector = 'dbABlacklist';

/* @ngInject */
function BlacklistDirective($parse) {
    return {
        restrict: 'A',
        require: 'ngModel',

        link: function link(scope, element, attrs, ctrl) {
            var getBlacklist = $parse(attrs[selector]);

            ctrl.$parsers.unshift(function (value) {
                validate(value);
                return value;
            });

            ctrl.$formatters.unshift(function (value) {
                validate(value);
                return value;
            });

            function validate(value) {
                var valid = !exists(value);

                ctrl.$setValidity('blacklist', valid);

                return valid;
            }

            function exists(value) {
                var list = getBlacklist(scope) || [];
                return list.indexOf(value) >= 0;
            }
        }
    };
}

/***/ }),

/***/ "yZbI":
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var ADD_CLASS_SUFFIX = '-add';
var REMOVE_CLASS_SUFFIX = '-remove';
var EVENT_CLASS_PREFIX = 'ng-';
var ACTIVE_CLASS_SUFFIX = '-active';
var PREPARE_CLASS_SUFFIX = '-prepare';

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var ngMinErr = angular.$$minErr('ng');
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return element;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  };
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationDetails(element, oldAnimation, newAnimation) {
  var target = oldAnimation.options || {};
  var newOptions = newAnimation.options || {};

  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  if (newOptions.preparationClasses) {
    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
    delete newOptions.preparationClasses;
  }

  // noop is basically when there is no callback; otherwise something has been set
  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;

  extend(target, newOptions);

  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
  if (realDomOperation) {
    target.domOperation = realDomOperation;
  }

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  oldAnimation.addClass = target.addClass;
  oldAnimation.removeClass = target.removeClass;

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof jqLite) ? element[0] : element;
}

function applyGeneratedPreparationClasses($$jqLite, element, event, options) {
  var classes = '';
  if (event) {
    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
  }
  if (options.addClass) {
    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
  }
  if (options.removeClass) {
    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
  }
  if (classes.length) {
    options.preparationClasses = classes;
    element.addClass(classes);
  }
}

function clearGeneratedClasses(element, options) {
  if (options.preparationClasses) {
    element.removeClass(options.preparationClasses);
    options.preparationClasses = null;
  }
  if (options.activeClasses) {
    element.removeClass(options.activeClasses);
    options.activeClasses = null;
  }
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function concatWithSpace(a,b) {
  if (!a) return b;
  if (!b) return a;
  return a + ' ' + b;
}

var helpers = {
  blockTransitions: function(node, duration) {
    // we use a negative delay value since it performs blocking
    // yet it doesn't kill any existing transitions running on the
    // same element which makes this safe for class-based animations
    var value = duration ? '-' + duration + 's' : '';
    applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
    return [TRANSITION_DELAY_PROP, value];
  }
};

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var queue, cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    queue = queue.concat(tasks);
    nextTick();
  }

  queue = scheduler.queue = [];

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!queue.length) return;

    var items = queue.shift();
    for (var i = 0; i < items.length; i++) {
      items[i]();
    }

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }
}];

/**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */
var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
  return {
    link: function(scope, element, attrs) {
      var val = attrs.ngAnimateChildren;
      if (isString(val) && val.length === 0) { //empty attribute
        element.data(NG_ANIMATE_CHILDREN_DATA, true);
      } else {
        // Interpolate and set the value, so that it is available to
        // animations that run right after compilation
        setData($interpolate(val)(scope));
        attrs.$observe('ngAnimateChildren', setData);
      }

      function setData(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      }
    }
  };
}];

/* exported $AnimateCssProvider */

var ANIMATE_TIMER_KEY = '$$animateCss';

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## General Use
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */
var ONE_SECOND = 1000;

var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for negative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) === 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

// we do not reassign an already present style value since
// if we detect the style property value again we may be
// detecting styles that were added via the `from` styles.
// We make use of `isDefined` here since an empty string
// or null value (which is what getPropertyValue will return
// for a non-existing style) will still be marked as a valid
// value for the style (a falsy value implies that the style
// is to be removed at the end of the animation). If we had a simple
// "OR" statement then it would not be enough to catch that.
function registerRestorableStyles(backup, node, properties) {
  forEach(properties, function(prop) {
    backup[prop] = isDefined(backup[prop])
        ? backup[prop]
        : node.style.getPropertyValue(prop);
  });
}

var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout', '$$animateCache',
               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,   $$animateCache,
                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function computeCachedCssStyles(node, className, cacheKey, allowNoDuration, properties) {
      var timings = $$animateCache.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // if a css animation has no duration we
      // should mark that so that repeated addClass/removeClass calls are skipped
      var hasDuration = allowNoDuration || (timings.transitionDuration > 0 || timings.animationDuration > 0);

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an internal tally of how many duplicate animations are detected.
      $$animateCache.put(cacheKey, timings, hasDuration);

      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;
      var staggerCacheKey = 'stagger-' + cacheKey;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if ($$animateCache.count(cacheKey) > 0) {
        stagger = $$animateCache.get(staggerCacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          $$animateCache.put(staggerCacheKey, stagger, true);
        }
      }

      return stagger || {};
    }

    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        $$animateCache.flush();

        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
        var pageWidth = $$forceReflow();

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](pageWidth);
        }
        rafWaitQueue.length = 0;
      });
    }

    function computeTimings(node, className, cacheKey, allowNoDuration) {
      var timings = computeCachedCssStyles(node, className, cacheKey, allowNoDuration, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    return function init(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = prepareAnimationOptions(copy(options));
      }

      var restoreStyles = {};
      var node = getDomNode(element);
      if (!node
          || !node.parentNode
          || !$$animateQueue.enabled()) {
        return closeAndReturnNoopAnimator();
      }

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;
      var startTime;
      var events = [];

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
      }

      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + preparationClasses;
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

      // there is no way we can trigger an animation if no styles and
      // no classes are being applied which would then trigger a transition,
      // unless there a is raw keyframe value that is applied to the element.
      if (!containsKeyframeAnimation
           && !hasToStyles
           && !preparationClasses) {
        return closeAndReturnNoopAnimator();
      }

      var stagger, cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
      if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
        preparationClasses = null;
        return closeAndReturnNoopAnimator();
      }

      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      if (!options.$$skipPreparationClasses) {
        $$jqLite.addClass(element, preparationClasses);
      }

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : $$animateCache.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst && !options.skipBlocking) {
        helpers.blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey, !isStructural);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);

      if (options.delay != null) {
        var delayStyle;
        if (typeof options.delay !== 'boolean') {
          delayStyle = parseFloat(options.delay);
          // number in options.delay means we have to recalculate the delay for the closing timeout
          maxDelay = Math.max(delayStyle, 0);
        }

        if (flags.applyTransitionDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle));
        }

        if (flags.applyAnimationDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
        }
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      if (options.from) {
        if (options.cleanupStyles) {
          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
        }
        applyAnimationFromStyles(element, options);
      }

      if (flags.blockTransition || flags.blockKeyframeAnimation) {
        applyBlocking(maxDuration);
      } else if (!options.skipBlocking) {
        helpers.blockTransitions(node, false);
      }

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) {
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        if (preparationClasses && !options.$$skipPreparationClasses) {
          $$jqLite.removeClass(element, preparationClasses);
        }

        if (activeClasses) {
          $$jqLite.removeClass(element, activeClasses);
        }

        blockKeyframeAnimations(node, false);
        helpers.blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        if (Object.keys(restoreStyles).length) {
          forEach(restoreStyles, function(value, prop) {
            if (value) {
              node.style.setProperty(prop, value);
            } else {
              node.style.removeProperty(prop);
            }
          });
        }

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        if (events && events.length) {
          // Remove the transitionend / animationend listener(s)
          element.off(events.join(' '), onAnimationProgress);
        }

        //Cancel the fallback closing timeout and remove the timer data
        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
        if (animationTimerData) {
          $timeout.cancel(animationTimerData[0].timer);
          element.removeData(ANIMATE_TIMER_KEY);
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          helpers.blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        // should flush the cache animation
        waitUntilQuiet(noop);
        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function onAnimationProgress(event) {
        event.stopPropagation();
        var ev = event.originalEvent || event;

        if (ev.target !== node) {
          // Since TransitionEvent / AnimationEvent bubble up,
          // we have to ignore events by finished child animations
          return;
        }

        // we now always use `Date.now()` due to the recent changes with
        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
        var timeStamp = ev.$manualTimeStamp || Date.now();

        /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */
        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

        /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */
        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
          // we set this flag to ensure that if the transition is paused then, when resumed,
          // the animation will automatically close itself since transitions cannot be paused.
          animationCompleted = true;
          close();
        }
      }

      function start() {
        if (animationClosed) return;
        if (!node.parentNode) {
          close();
          return;
        }

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              if (animationPaused) {
                temporaryStyles.push(value);
              } else {
                removeFromArray(temporaryStyles, value);
              }
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intentional stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
            cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);

            timings = computeTimings(node, fullClassName, cacheKey, false);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);
            timings.animationDelay = relativeDelay;
            delayStyle = getCssDelayStyle(relativeDelay, true);
            temporaryStyles.push(delayStyle);
            node.style[delayStyle[0]] = delayStyle[1];
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
          var endTime = startTime + timerTime;

          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
          var setupFallbackTimer = true;
          if (animationsData.length) {
            var currentTimerData = animationsData[0];
            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
            if (setupFallbackTimer) {
              $timeout.cancel(currentTimerData.timer);
            } else {
              animationsData.push(close);
            }
          }

          if (setupFallbackTimer) {
            var timer = $timeout(onAnimationExpired, timerTime, false);
            animationsData[0] = {
              timer: timer,
              expectedEndTime: endTime
            };
            animationsData.push(close);
            element.data(ANIMATE_TIMER_KEY, animationsData);
          }

          if (events.length) {
            element.on(events.join(' '), onAnimationProgress);
          }

          if (options.to) {
            if (options.cleanupStyles) {
              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
            }
            applyAnimationToStyles(element, options);
          }
        }

        function onAnimationExpired() {
          var animationsData = element.data(ANIMATE_TIMER_KEY);

          // this will be false in the event that the element was
          // removed from the DOM (via a leave animation or something
          // similar)
          if (animationsData) {
            for (var i = 1; i < animationsData.length; i++) {
              animationsData[i]();
            }
            element.removeData(ANIMATE_TIMER_KEY);
          }
        }
      }
    };
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  function isDocumentFragment(node) {
    return node.parentNode && node.parentNode.nodeType === 11;
  }

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = $document[0].body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
    );

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coords object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from, noop);
      var toAnimation = prepareRegularAnimation(to, noop);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        options.event = animationDetails.event;
        options.structural = true;
        options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        if (animationDetails.event === 'leave') {
          options.onDone = options.domOperation;
        }
      }

      // We assign the preparationClasses as the actual animation event since
      // the internals of $animateCss will just suffix the event token values
      // with `-active` to trigger the animation.
      if (options.preparationClasses) {
        options.event = concatWithSpace(options.event, options.preparationClasses);
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      var animationClosed = false;

      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event === 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      function close() {
        animationClosed = true;
        applyOptions();
        applyAnimationStyles(element, options);
      }

      var runner;

      return {
        $$willAnimate: true,
        end: function() {
          if (runner) {
            runner.end();
          } else {
            close();
            runner = new $$AnimateRunner();
            runner.complete(true);
          }
          return runner;
        },
        start: function() {
          if (runner) {
            return runner;
          }

          runner = new $$AnimateRunner();
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          runner.setHost({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            close(success);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a, b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          if (runners.length) {
            $$AnimateRunner.all(runners, callback);
          }  else {
            callback();
          }

          return function endFn(reject) {
            forEach(runners, function(runner) {
              if (reject) {
                runner.cancel();
              } else {
                runner.end();
              }
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i = 0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;
  var ONE_SPACE = ' ';

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function getEventData(options) {
    return {
      addClass: options.addClass,
      removeClass: options.removeClass,
      from: options.from,
      to: options.to
    };
  }

  function makeTruthyCssClassMap(classString) {
    if (!classString) {
      return null;
    }

    var keys = classString.split(ONE_SPACE);
    var map = Object.create(null);

    forEach(keys, function(key) {
      map[key] = true;
    });
    return map;
  }

  function hasMatchingClasses(newClassString, currentClassString) {
    if (newClassString && currentClassString) {
      var currentClassMap = makeTruthyCssClassMap(currentClassString);
      return newClassString.split(ONE_SPACE).some(function(className) {
        return currentClassMap[className];
      });
    }
  }

  function isAllowed(ruleType, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(animation, and) {
    var a = (animation.addClass || '').length > 0;
    var b = (animation.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event === 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // if there is an ongoing current animation then don't even bother running the class-based animation
    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // cancel the animation if classes added / removed in both animation cancel each other out,
    // but only if the current animation isn't structural

    if (currentAnimation.structural) return false;

    var nA = newAnimation.addClass;
    var nR = newAnimation.removeClass;
    var cA = currentAnimation.addClass;
    var cR = currentAnimation.removeClass;

    // early detection to save the global CPU shortage :)
    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
      return false;
    }

    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
               '$$isDocumentHidden',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
                $$isDocumentHidden) {

    var activeAnimationsLookup = new $$Map();
    var disabledElementsLookup = new $$Map();
    var animationsEnabled = null;

    function removeFromDisabledElementsLookup(evt) {
      disabledElementsLookup.delete(evt.target);
    }

    function postDigestTaskFactory() {
      var postDigestCalled = false;
      return function(fn) {
        // we only issue a call to postDigest before
        // it has first passed. This prevents any callbacks
        // from not firing once the animation has completed
        // since it will be out of the digest cycle.
        if (postDigestCalled) {
          fn();
        } else {
          $rootScope.$$postDigest(function() {
            postDigestCalled = true;
            fn();
          });
        }
      };
    }

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var callbackRegistry = Object.create(null);

    // remember that the `customFilter`/`classNameFilter` are set during the
    // provider/config stage therefore we can optimize here and setup helper functions
    var customFilter = $animateProvider.customFilter();
    var classNameFilter = $animateProvider.classNameFilter();
    var returnTrue = function() { return true; };

    var isAnimatableByFilter = customFilter || returnTrue;
    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
      return classNameFilter.test(className);
    };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationDetails(element, animation) {
      return mergeAnimationDetails(element, animation, {});
    }

    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
      // eslint-disable-next-line no-bitwise
      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
    };

    function findCallbacks(targetParentNode, targetNode, event) {
      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (contains.call(entry.node, targetNode)) {
            matches.push(entry.callback);
          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function filterFromRegistry(list, matchContainer, matchCallback) {
      var containerNode = extractElementNode(matchContainer);
      return list.filter(function(entry) {
        var isMatch = entry.node === containerNode &&
                        (!matchCallback || entry.callback === matchCallback);
        return !isMatch;
      });
    }

    function cleanupEventListeners(phase, node) {
      if (phase === 'close' && !node.parentNode) {
        // If the element is not attached to a parentNode, it has been removed by
        // the domOperation, and we can safely remove the event callbacks
        $animate.off(node);
      }
    }

    var $animate = {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });

        // Remove the callback when the element is removed from the DOM
        jqLite(container).on('$destroy', function() {
          var animationDetails = activeAnimationsLookup.get(node);

          if (!animationDetails) {
            // If there's an animation ongoing, the callback calling code will remove
            // the event listeners. If we'd remove here, the callbacks would be removed
            // before the animation ends
            $animate.off(event, container, callback);
          }
        });
      },

      off: function(event, container, callback) {
        if (arguments.length === 1 && !isString(arguments[0])) {
          container = arguments[0];
          for (var eventType in callbackRegistry) {
            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
          }

          return;
        }

        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !disabledElementsLookup.get(node);
            } else {
              // (element, bool) - Element setter
              if (!disabledElementsLookup.has(node)) {
                // The element is added to the map for the first time.
                // Create a listener to remove it on `$destroy` (to avoid memory leak).
                jqLite(element).on('$destroy', removeFromDisabledElementsLookup);
              }
              disabledElementsLookup.set(node, !bool);
            }
          }
        }

        return bool;
      }
    };

    return $animate;

    function queueAnimation(originalElement, event, initialOptions) {
      // we always make a copy of the options since
      // there should never be any side effects on
      // the input data when running `$animateCss`.
      var options = copy(initialOptions);

      var element = stripCommentsFromElement(originalElement);
      var node = getDomNode(element);
      var parentNode = node && node.parentNode;

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // this is used to trigger callbacks in postDigest mode
      var runInNextPostDigestOrNow = postDigestTaskFactory();

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (options.addClass && !isString(options.addClass)) {
        options.addClass = null;
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.removeClass && !isString(options.removeClass)) {
        options.removeClass = null;
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      // If animations are hard-disabled for the whole application there is no need to continue.
      // There are also situations where a directive issues an animation for a jqLite wrapper that
      // contains only comment nodes. In this case, there is no way we can perform an animation.
      if (!animationsEnabled ||
          !node ||
          !isAnimatableByFilter(node, event, initialOptions) ||
          !isAnimatableClassName(node, options)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      var documentHidden = $$isDocumentHidden();

      // This is a hard disable of all animations the element itself, therefore  there is no need to
      // continue further past this point if not enabled
      // Animations are also disabled if the document is currently hidden (page is not visible
      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
      var skipAnimations = documentHidden || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
      }

      if (skipAnimations) {
        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
        if (documentHidden) notifyProgress(runner, event, 'start', getEventData(options));
        close();
        if (documentHidden) notifyProgress(runner, event, 'close', getEventData(options));
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(node);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        addClass: options.addClass,
        removeClass: options.removeClass,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationDetails(element, existingAnimation, newAnimation);
            return existingAnimation.runner;
          }
        }
        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the new animation options into existing animation options
            mergeAnimationDetails(element, existingAnimation, newAnimation);

            return existingAnimation.runner;
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationDetails(element, newAnimation);
            } else {
              applyGeneratedPreparationClasses($$jqLite, element, isStructural ? event : null, options);

              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationDetails(element, existingAnimation, newAnimation);

              //we return the same runner since only the option values of this animation will
              //be fed into the `existingAnimation`.
              return existingAnimation.runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationDetails(element, newAnimation);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(node);
        return runner;
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
        // happen if the animated element is a transcluded clone and also has a `templateUrl`
        // directive on it. Therefore, we must recreate `element` in order to interact with the
        // actual DOM nodes.
        // Note: We still need to use the old `node` for certain things, such as looking up in
        //       HashMaps where it was used as the key.

        element = stripCommentsFromElement(originalElement);

        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(node);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
            ? 'setClass'
            : animationDetails.event;

        markElementAnimationState(node, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', getEventData(options));

        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(node);
          }
          notifyProgress(runner, event, 'close', getEventData(options));
        });
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        runInNextPostDigestOrNow(function() {
          var callbacks = findCallbacks(parentNode, node, event);
          if (callbacks.length) {
            // do not optimize this call here to RAF because
            // we don't know how heavy the callback code here will
            // be and if this code is buffered then this can
            // lead to a performance regression.
            $$rAF(function() {
              forEach(callbacks, function(callback) {
                callback(element, phase, data);
              });
              cleanupEventListeners(phase, node);
            });
          } else {
            cleanupEventListeners(phase, node);
          }
        });
        runner.progress(event, phase, data);
      }

      function close(reject) {
        clearGeneratedClasses(element, options);
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(node) {
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
        var animationDetails = activeAnimationsLookup.get(child);
        if (animationDetails) {
          switch (state) {
            case RUNNING_STATE:
              animationDetails.runner.end();
              /* falls through */
            case PRE_DIGEST_STATE:
              activeAnimationsLookup.delete(child);
              break;
          }
        }
      });
    }

    function clearElementAnimationState(node) {
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.delete(node);
    }

    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */
    function areAnimationsAllowed(node, parentNode, event) {
      var bodyNode = $document[0].body;
      var rootNode = getDomNode($rootElement);

      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
      var rootNodeDetected = (node === rootNode);
      var parentAnimationDetected = false;
      var elementDisabled = disabledElementsLookup.get(node);
      var animateChildren;

      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentNode = getDomNode(parentHost);
      }

      while (parentNode) {
        if (!rootNodeDetected) {
          // AngularJS doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootNodeDetected = (parentNode === rootNode);
        }

        if (parentNode.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentNode) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          var parentNodeDisabled = disabledElementsLookup.get(parentNode);

          if (parentNodeDisabled === true && elementDisabled !== false) {
            // disable animations if the user hasn't explicitly enabled animations on the
            // current element
            elementDisabled = true;
            // element is disabled via parent element, no need to check anything else
            break;
          } else if (parentNodeDisabled === false) {
            elementDisabled = false;
          }
          parentAnimationDetected = details.structural;
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!bodyNodeDetected) {
          // we also need to ensure that the element is or will be a part of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyNodeDetected = (parentNode === bodyNode);
        }

        if (bodyNodeDetected && rootNodeDetected) {
          // If both body and root have been found, any other checks are pointless,
          // as no animation data should live outside the application
          break;
        }

        if (!rootNodeDetected) {
          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
          if (parentHost) {
            // The pin target element becomes the next parent element
            parentNode = getDomNode(parentHost);
            continue;
          }
        }

        parentNode = parentNode.parentNode;
      }

      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
      return allowAnimation && rootNodeDetected && bodyNodeDetected;
    }

    function markElementAnimationState(node, state, details) {
      details = details || {};
      details.state = state;

      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.set(node, newValue);
    }
  }];
}];

/** @this */
var $$AnimateCacheProvider = function() {

  var KEY = '$$ngAnimateParentKey';
  var parentCounter = 0;
  var cache = Object.create(null);

  this.$get = [function() {
    return {
      cacheKey: function(node, method, addClass, removeClass) {
        var parentNode = node.parentNode;
        var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
        var parts = [parentID, method, node.getAttribute('class')];
        if (addClass) {
          parts.push(addClass);
        }
        if (removeClass) {
          parts.push(removeClass);
        }
        return parts.join(' ');
      },

      containsCachedAnimationWithoutDuration: function(key) {
        var entry = cache[key];

        // nothing cached, so go ahead and animate
        // otherwise it should be a valid animation
        return (entry && !entry.isValid) || false;
      },

      flush: function() {
        cache = Object.create(null);
      },

      count: function(key) {
        var entry = cache[key];
        return entry ? entry.total : 0;
      },

      get: function(key) {
        var entry = cache[key];
        return entry && entry.value;
      },

      put: function(key, value, isValid) {
        if (!cache[key]) {
          cache[key] = { total: 1, value: value, isValid: isValid };
        } else {
          cache[key].total++;
          cache[key].value = value;
        }
      }
    };
  }];
};

/* exported $$AnimationProvider */

var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';
  var PREPARE_CLASSES_KEY = '$$animatePrepareClasses';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler', '$$animateCache',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler, $$animateCache) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function sortAnimations(animations) {
      var tree = { children: [] };
      var i, lookup = new $$Map();

      // this is done first beforehand so that the map
      // is filled with a list of the elements that will be animated
      for (i = 0; i < animations.length; i++) {
        var animation = animations[i];
        lookup.set(animation.domNode, animations[i] = {
          domNode: animation.domNode,
          element: animation.element,
          fn: animation.fn,
          children: []
        });
      }

      for (i = 0; i < animations.length; i++) {
        processNode(animations[i]);
      }

      return flatten(tree);

      function processNode(entry) {
        if (entry.processed) return entry;
        entry.processed = true;

        var elementNode = entry.domNode;
        var parentNode = elementNode.parentNode;
        lookup.set(elementNode, entry);

        var parentEntry;
        while (parentNode) {
          parentEntry = lookup.get(parentNode);
          if (parentEntry) {
            if (!parentEntry.processed) {
              parentEntry = processNode(parentEntry);
            }
            break;
          }
          parentNode = parentNode.parentNode;
        }

        (parentEntry || tree).children.push(entry);
        return entry;
      }

      function flatten(tree) {
        var result = [];
        var queue = [];
        var i;

        for (i = 0; i < tree.children.length; i++) {
          queue.push(tree.children[i]);
        }

        var remainingLevelEntries = queue.length;
        var nextLevelEntries = 0;
        var row = [];

        for (i = 0; i < queue.length; i++) {
          var entry = queue[i];
          if (remainingLevelEntries <= 0) {
            remainingLevelEntries = nextLevelEntries;
            nextLevelEntries = 0;
            result.push(row);
            row = [];
          }
          row.push(entry);
          entry.children.forEach(function(childEntry) {
            nextLevelEntries++;
            queue.push(childEntry);
          });
          remainingLevelEntries--;
        }

        if (row.length) {
          result.push(row);
        }

        return result;
      }
    }

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      if (isStructural) {
        element.data(PREPARE_CLASSES_KEY, 'ng-' + event + PREPARE_CLASS_SUFFIX);
      }

      setRunner(element, runner);

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          } else {
            entry.close();
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        var groupedAnimations = groupAnimations(animations);
        var toBeSortedAnimations = [];

        forEach(groupedAnimations, function(animationEntry) {
          var element = animationEntry.from ? animationEntry.from.element : animationEntry.element;
          var extraClasses = options.addClass;

          extraClasses = (extraClasses ? (extraClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
          var cacheKey = $$animateCache.cacheKey(element[0], animationEntry.event, extraClasses, options.removeClass);

          toBeSortedAnimations.push({
            element: element,
            domNode: getDomNode(element),
            fn: function triggerAnimationStart() {
              var startAnimationFn, closeFn = animationEntry.close;

              // in the event that we've cached the animation status for this element
              // and it's in fact an invalid animation (something that has duration = 0)
              // then we should skip all the heavy work from here on
              if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
                closeFn();
                return;
              }

              // it's important that we apply the `ng-animate` CSS class and the
              // temporary classes before we do any driver invoking since these
              // CSS classes may be required for proper CSS detection.
              animationEntry.beforeStart();

              // in the event that the element was removed before the digest runs or
              // during the RAF sequencing then we should not trigger the animation.
              var targetElement = animationEntry.anchors
                  ? (animationEntry.from.element || animationEntry.to.element)
                  : animationEntry.element;

              if (getRunner(targetElement)) {
                var operation = invokeFirstDriver(animationEntry);
                if (operation) {
                  startAnimationFn = operation.start;
                }
              }

              if (!startAnimationFn) {
                closeFn();
              } else {
                var animationRunner = startAnimationFn();
                animationRunner.done(function(status) {
                  closeFn(!status);
                });
                updateAnimationRunners(animationEntry, animationRunner);
              }
            }
          });
        });

        // we need to sort each of the animations in order of parent to child
        // relationships. This ensures that the child classes are applied at the
        // right time.
        var finalAnimations = sortAnimations(toBeSortedAnimations);
        for (var i = 0; i < finalAnimations.length; i++) {
          var innerArray = finalAnimations[i];
          for (var j = 0; j < innerArray.length; j++) {
            var entry = innerArray[j];
            var element = entry.element;

            // the RAFScheduler code only uses functions
            finalAnimations[i][j] = entry.fn;

            // the first row of elements shouldn't have a prepare-class added to them
            // since the elements are at the top of the animation hierarchy and they
            // will be applied without a RAF having to pass...
            if (i === 0) {
              element.removeData(PREPARE_CLASSES_KEY);
              continue;
            }

            var prepareClassName = element.data(PREPARE_CLASSES_KEY);
            if (prepareClassName) {
              $$jqLite.addClass(element, prepareClassName);
            }
          }
        }

        $$rAFScheduler(finalAnimations);
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effectively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        tempClasses = (tempClasses ? (tempClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
        $$jqLite.addClass(element, tempClasses);

        var prepareClassName = element.data(PREPARE_CLASSES_KEY);
        if (prepareClassName) {
          $$jqLite.removeClass(element, prepareClassName);
          prepareClassName = null;
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          var runner = getRunner(element);
          if (runner) runner.setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) {
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        runner.complete(!rejected);
      }
    };
  }];
}];

/**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */
var ngAnimateSwapDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 550, // We use 550 here to ensure that the directive is caught before others,
                   // but after `ngIf` (at priority 600).
    link: function(scope, $element, attrs, ctrl, $transclude) {
      var previousElement, previousScope;
      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
        if (previousElement) {
          $animate.leave(previousElement);
        }
        if (previousScope) {
          previousScope.$destroy();
          previousScope = null;
        }
        if (value || value === 0) {
          $transclude(function(clone, childScope) {
            previousElement = clone;
            previousScope = childScope;
            $animate.enter(clone, null, $element);
          });
        }
      });
    }
  };
}];

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
 *
 * ## Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                     | Supported Animations                                                      |
 * |-------------------------------------------------------------------------------|---------------------------------------------------------------------------|
 * | {@link ng.directive:form#animations form / ngForm}                            | add and remove ({@link ng.directive:form#css-classes various classes})    |
 * | {@link ngAnimate.directive:ngAnimateSwap#animations ngAnimateSwap}            | enter and leave                                                           |
 * | {@link ng.directive:ngClass#animations ngClass / {{class&#125;&#8203;&#125;}  | add and remove                                                            |
 * | {@link ng.directive:ngClassEven#animations ngClassEven}                       | add and remove                                                            |
 * | {@link ng.directive:ngClassOdd#animations ngClassOdd}                         | add and remove                                                            |
 * | {@link ng.directive:ngHide#animations ngHide}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngIf#animations ngIf}                                     | enter and leave                                                           |
 * | {@link ng.directive:ngInclude#animations ngInclude}                           | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessage / ngMessageExp}                 | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessages}                               | add and remove (the `ng-active`/`ng-inactive` classes)                    |
 * | {@link ng.directive:ngModel#animations ngModel}                               | add and remove ({@link ng.directive:ngModel#css-classes various classes}) |
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                             | enter, leave, and move                                                    |
 * | {@link ng.directive:ngShow#animations ngShow}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                             | enter and leave                                                           |
 * | {@link ngRoute.directive:ngView#animations ngView}                            | enter and leave                                                           |
 *
 * (More information can be found by visiting the documentation associated with each directive.)
 *
 * For a full breakdown of the steps involved during each animation event, refer to the
 * {@link ng.$animate `$animate` API docs}.
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 *
 *   /&#42; if you are using animations instead of transitions you should configure as follows:
 *     animation-delay: 0.1s;
 *     animation-duration: 0s; &#42;/
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 * ```
 *
 * ### Animating between value changes
 *
 * Sometimes you need to animate between different expression states, whose values
 * don't necessary need to be known or referenced in CSS styles.
 * Unless possible with another {@link ngAnimate#directive-support "animation aware" directive},
 * that specific use case can always be covered with {@link ngAnimate.directive:ngAnimateSwap} as
 * can be seen in {@link ngAnimate.directive:ngAnimateSwap#examples this example}.
 *
 * Note that {@link ngAnimate.directive:ngAnimateSwap} is a *structural directive*, which means it
 * creates a new instance of the element (including any other/child directives it may have) and
 * links it to a new scope every time *swap* happens. In some cases this might not be desirable
 * (e.g. for performance reasons, or when you wish to retain internal state on the original
 * element instance).
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that AngularJS
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#!/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#!/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
 */

var copy;
var extend;
var forEach;
var isArray;
var isDefined;
var isElement;
var isFunction;
var isObject;
var isString;
var isUndefined;
var jqLite;
var noop;

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [], function initAngularHelpers() {
  // Access helpers from AngularJS core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  noop        = angular.noop;
  copy        = angular.copy;
  extend      = angular.extend;
  jqLite      = angular.element;
  forEach     = angular.forEach;
  isArray     = angular.isArray;
  isString    = angular.isString;
  isObject    = angular.isObject;
  isUndefined = angular.isUndefined;
  isDefined   = angular.isDefined;
  isFunction  = angular.isFunction;
  isElement   = angular.isElement;
})
  .info({ angularVersion: '1.8.3' })
  .directive('ngAnimateSwap', ngAnimateSwapDirective)

  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animateCache', $$AnimateCacheProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);


/***/ }),

/***/ "ybOs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-mailbox-7f9c957df6d7e0e4.svg";

/***/ }),

/***/ "ykAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array_util__ = __webpack_require__("zMFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__time_util__ = __webpack_require__("S2sh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__number_util__ = __webpack_require__("Cybx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_util__ = __webpack_require__("GMmw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__permission_util__ = __webpack_require__("H9+b");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__permission_util__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_util__ = __webpack_require__("xQkc");
/* unused harmony namespace reexport */










/* harmony default export */ __webpack_exports__["j"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('application.util', []).service('arrayUtil', __WEBPACK_IMPORTED_MODULE_1__array_util__["a" /* default */]).service('timeUtil', __WEBPACK_IMPORTED_MODULE_2__time_util__["a" /* default */]).service('numberUtil', __WEBPACK_IMPORTED_MODULE_3__number_util__["a" /* default */]).service('eventUtil', __WEBPACK_IMPORTED_MODULE_4__event_util__["a" /* default */]));

/***/ }),

/***/ "yn4m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-iconCategoryClothes-e1e3a010e8643592.svg";

/***/ }),

/***/ "ysNX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Pill-268dc5bbcaa032d8.svg";

/***/ }),

/***/ "zMFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArrayUtil = function () {
    function ArrayUtil() {
        _classCallCheck(this, ArrayUtil);
    }

    _createClass(ArrayUtil, [{
        key: "find",
        value: function find(array, callback, initial, convert) {
            convert = convert || function (current) {
                return current;
            };

            for (var index = 0; index < array.length; ++index) {
                if (callback(array[index], index)) {
                    return convert(array[index], index);
                }
            }

            return initial === null ? null : initial;
        }
    }, {
        key: "remove",
        value: function remove(array, callback) {
            for (var index = 0; index < array.length; ++index) {
                if (callback(array[index], index)) {
                    array = array.slice();
                    array.splice(index, 1);
                    break;
                }
            }

            return array;
        }
    }, {
        key: "groupBy",
        value: function groupBy(array, callback) {
            var groups = {};

            array.forEach(function (current) {
                var key = callback(current);
                groups[key] = groups[key] || {
                    key: key,
                    values: []
                };
                groups[key].values.push(current);
            });

            return Object.keys(groups).map(function (key) {
                return groups[key];
            });
        }
    }, {
        key: "skip",
        value: function skip(array, count) {
            return array.slice(count);
        }
    }, {
        key: "take",
        value: function take(array, count) {
            return array.slice(0, count);
        }
    }, {
        key: "unique",
        value: function unique(array, callback) {
            var set = {};
            var result = [];

            for (var index = 0; index < array.length; ++index) {
                var key = JSON.stringify(callback(array[index]));
                if (!set[key]) {
                    set[key] = true;
                    result.push(array[index]);
                }
            }

            return result;
        }
    }, {
        key: "flatten",
        value: function flatten(array) {
            return Array.prototype.concat.apply([], array);
        }
    }]);

    return ArrayUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (ArrayUtil);

/***/ }),

/***/ "zOqJ":
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__("Y/tY");
var route = __webpack_require__("vImi");

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),

/***/ "zhrX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkmark_style_sass__ = __webpack_require__("ZpKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkmark_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__checkmark_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkmark_tpl_pug__ = __webpack_require__("a6EW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkmark_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__checkmark_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CheckmarkController = function () {
    function CheckmarkController() {
        _classCallCheck(this, CheckmarkController);
    }

    _createClass(CheckmarkController, [{
        key: 'toggle',
        value: function toggle() {
            this.$ctrl.$setViewValue(!this.selected);
            this.$ctrl.$render();
        }
    }]);

    return CheckmarkController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbACheckmark',
    template: __WEBPACK_IMPORTED_MODULE_1__checkmark_tpl_pug___default()(),
    controller: CheckmarkController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        selected: '<ngModel',
        color: '<',
        loading: '<'
    }
});

/***/ }),

/***/ "zlC8":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"data-settings-page\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EDollarbird Backups\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv\u003EGenerate backups of your Dollarbird data that you can use to restore your account in case of accidental calendar deletions, etc.\u003C\u002Fdiv\u003E\u003Cform role=\"form\" name=\"backup\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.generateBackup()\"\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cdiv class=\"data-action-button\"\u003E\u003Cbutton class=\"button button-fill button-primary button-generate-backup\" type=\"submit\" db-a-async loading=\"backup.$submitting\" ng-disabled=\"$ctrl.backupRequested\"\u003E\u003Cinitial ng-hide=\"$ctrl.backupRequested\"\u003EGenerate backup\u003C\u002Finitial\u003E\u003Cinitial ng-show=\"$ctrl.backupRequested\"\u003EBackup requested\u003C\u002Finitial\u003E\u003Cloading\u003EProcessing...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003ERestore your account from a backup file:\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cdiv class=\"data-action-button\"\u003E\u003Cbutton class=\"button button-outline button-secondary button-restore-data\" type=\"button\" ng-click=\"$ctrl.restoreData()\"\u003ERestore data\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"form-group-name\"\u003EExport your data\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group-content\"\u003E\u003Cdiv\u003EExport the transactions and photos\u002Freceipts of all of your calendars in an easy-to-process CSV format. This export is not for restoring data (please use the Dollarbird Backups for that) but for crunching the numbers in your favorite spreadsheet tool.\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003EExport my data, and:\u003C\u002Fdiv\u003E\u003Cform role=\"form\" name=\"export\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.sendExportEmail()\"\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cdiv class=\"data-action-button\"\u003E\u003Cbutton class=\"button button-fill button-primary button-export-data\" type=\"submit\" db-a-async loading=\"export.$submitting\" ng-disabled=\"$ctrl.exportEmailSent\"\u003E\u003Cinitial ng-hide=\"$ctrl.exportEmailSent\"\u003ESend it to me in email\u003C\u002Finitial\u003E\u003Cinitial ng-show=\"$ctrl.exportEmailSent\"\u003EData export requested\u003C\u002Finitial\u003E\u003Cloading\u003EProcessing...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cform role=\"form\" name=\"exportCsv\" autocomplete=\"off\" spellcheck=\"false\" novalidate db-a-form-submit=\"$ctrl.exportCsv()\"\u003E\u003Cdiv class=\"form-submit\"\u003E\u003Cdiv class=\"data-download-label\"\u003EOr download a zip file to this device:\u003C\u002Fdiv\u003E\u003Cdiv class=\"data-action-button\"\u003E\u003Cbutton class=\"button button-outline button-secondary button-download-data\" type=\"submit\" db-a-async loading=\"exportCsv.$submitting\" ng-disabled=\"$ctrl.exportDownloaded\"\u003E\u003Cinitial ng-hide=\"$ctrl.exportDownloaded\"\u003EDownload\u003C\u002Finitial\u003E\u003Cinitial ng-show=\"$ctrl.exportDownloaded\"\u003EDownloaded\u003C\u002Finitial\u003E\u003Cloading\u003EProcessing...\u003C\u002Floading\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "zsci":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-ic_category_33-dc6acb33c72d3087.svg";

/***/ }),

/***/ "zvwG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-Charts-340df7b648e56827.svg";

/***/ })

},[3]);


// WEBPACK FOOTER //
// asset/script-application-6a3c49b53cdca347ead5.bundle.js